import { useState, useEffect, useRef, useCallback, useMemo, useContext, createContext, Fragment } from "react";
import "./LoginScreen.css";
import BrandLogo from "./BrandLogo";
import { watchVisiblePolling } from "./visiblePolling.mjs";
import DashboardOriginCards from "./newUi/DashboardOriginCards";
import { readConversationHistory } from "./conversationHistoryRead.mjs";
import HistoryPagination from "./HistoryPagination";
import LazyChatImage from "./LazyChatImage";
import RecoveryGapNote from "./RecoveryGapNote";
import DocumentAttachment from "./DocumentAttachment";
import { isDocumentMessage } from "./documentAttachment.mjs";
import { CHAT_MEDIA_LIMITS, mediaLimitMessage } from "./chatMediaLimits.mjs";
import {publishHistoryState,setHistoryPageLoader,clearHistoryPages} from "./conversationPaging.mjs";
import { watchScopedDataPolling } from "./scopedDataPolling.mjs";
import { fetchScopedData } from "./scopedDataClient.mjs";
import { observedAdFields } from "./observedAdFields.mjs";
import { createOwnActionSnapshots } from "./ownActionSnapshots.mjs";
import ScopedDataLoadNotice, { ScopedDataLoadProvider, INITIAL_SCOPED_LOADING,
  useScopedDataLoadState, ScopedLeadsUnavailable, ScopedLeadEmptyLabel } from "./ScopedDataLoadNotice";
import AdminStoreEntry from "./AdminStoreEntry";
import { isGeneralAdminView, requestedReadStores } from "./adminReadScope.mjs";
import InboundSafetyNotice from "./InboundSafetyNotice";
import ProspDailySettings from "./newUi/ProspDailySettings";
import { isNewUiEnabled, NEW_THEMES, NEW_UI_FONT, NewUiStyles, NewSidebar } from "./newUi/newUi";
import Entregas from "./newUi/Entregas";
import { alertaSemResposta, passou15h } from "./newUi/alertaSemResposta.mjs";
import PainelProdutosConversa, { EVENTO_PARECIDOS, pedirParecidos } from "./newUi/PainelProdutosConversa";
import PontosCard from "./newUi/PontosCard";
import GlobalContactSearch from "./newUi/GlobalContactSearch";
import RotinaGerente from "./newUi/RotinaGerente";
import AvaliacaoAtendimento from "./newUi/AvaliacaoAtendimento";
import Produtos from "./newUi/Produtos";
import Biblioteca from "./newUi/Biblioteca";
import MarketingNova from "./newUi/MarketingNova";
import CatalogoAdmin from "./newUi/CatalogoAdmin";
import MobileNav from "./newUi/MobileNav";
import DashboardMeta from "./newUi/DashboardMeta";
import MeuDia from "./newUi/MeuDia";
import DepositoApp from "./newUi/DepositoApp";
import DepositoAvisos from "./newUi/DepositoAvisos";
import { LiftCrmClientContext } from "./LiftCrmClientActions";
import ClientOriginLabels from "./ClientOriginLabels";
import { isLiftRegisteredClientCard, liftCrmSourceRoute } from "./liftCrmSourceNavigation.mjs";
import useLiftClientRegistration from "./useLiftClientRegistration";
import { orderWaitingReplies } from "./newUi/meuDiaPriority.mjs";
import { filaOperatorContext, ProspFilaDemoBoundary, useProspFila as useProspFilaMeuDia, useProspDiaPreparado } from "./newUi/ProspFila";
import { conversaDaOrigem } from "./newUi/abaDaConversa.mjs";
import Vendas from "./newUi/Vendas";
import SaleDetailsPanel from "./newUi/SaleDetailsPanel";
import LiftCloseSaleAction from "./LiftCloseSaleAction";
import LiftSaleStageSelect from "./LiftSaleStageSelect";
import { buildVendasFollowUps, buildVendasMonthRows, buildVendasOriginTotals, resolveVendasConversation, saleConversationRoute, vendasBreakdownForUser, vendasMonthLabels, vendasMonthRange } from "./newUi/vendasModel.mjs";
import PresencialList from "./newUi/PresencialList";
import ClientActionsBar from "./newUi/ClientActionsBar";
import ProspKanban from "./newUi/ProspKanban";
import { useProspFila, useProspPlacar, JustificativaTombamento, PlacarTombamento } from "./newUi/ProspFila";
import { notifyProspRefresh } from "./newUi/prospRefresh";
import { maskReadPushEvents, prospectUnreadCount } from "./prospectBoardState.mjs";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, get as firebaseGet, update, remove, runTransaction as firebaseRunTransaction, forceLongPolling } from "firebase/database";
import { observeLeadGet, observeLeadTransaction } from "./leadsReadDiagnostics.mjs";
import { onValue } from "./nightFirebase.mjs";
import { mayAutoRefresh } from "./nightActivity.mjs";
import { getStorage, ref as storageRef, uploadBytes as firebaseUploadBytes, getDownloadURL as firebaseGetDownloadURL } from "firebase/storage";
import { developmentFirebaseConfig } from "./developmentFirebase.mjs";
import { canonicalPhone, clientIdentityKey, sameClientIdentity, normalizeClientSnapshot, runIdempotentWrite, saveClientOnce } from "./clientIdempotency.mjs";
import { computeCanonicalDashboardSales, computeSalesLedger, getClosingDate, isHistoricalLiftPostSaleCard, wasSold } from "./salesLedger.mjs";
import { buildFinancialSaleSheet, findFinancialSaleSheet, isClosedSaleSource as isCompletedSaleSource, mergeFinancialSaleSheet } from "./financialSaleSheets.mjs";
import { resolveSaleSource } from "./saleSourceResolution.mjs";
import { mediaKindForFile, uploadMimeType, documentExtension, documentMimeType } from "./mediaFileType.mjs";
import { mergeMessageSourceSnapshots, replaceMessageSourcePhones, replaceMessageSourceSnapshot } from "./whatsappSourceReconciler.mjs";
import { VoiceDictationButton } from "./VoiceDictation";
import ClientRegistrationModal from "./ClientRegistrationModal";
import ReportsView from "./ReportsView";
import LiftPendingSales, { liftSaleIsLate } from "./LiftPendingSales";
import LiftPostSale from "./LiftPostSale";
import { GOOGLE_REVIEW_TITLE, GOOGLE_REVIEW_SHORTCUT, GOOGLE_REVIEW_STORES, formatGoogleReviewMessage } from "./reviewMessage";
import IndicacoesView, { RegistrarIndicacao } from "./IndicacoesView";
import { canonicalLeadEntryDate } from "./canonicalReporting.mjs";
import { enablePush, getPushEvents, getPushStatus, pushSupported, sendPushTelemetry, setPushPresence } from "./pushNotifications";
import { useActiveConversationPresence, useConversationPresence, usePushPresenceHeartbeat } from "./conversationPresence";
import { adminSwitcherUsers, canViewAsDeposito, consultantUsers, DEPOSITO_USER, operationalUsers } from "./roleViewPolicy.mjs";
import { resolveConversationNavigation } from "./conversationNavigation.mjs";
import { conversationConsultantsInScope, conversationRecordIsInUserStore } from "./centralConversationScope.mjs";
import { auroraHandoffAwaitsConsultant, conversationActionTimestamp, conversationReplyState, currentDateKeySaoPaulo, leadConversationReplyState, postSaleReplyState } from "./awaitingReply.mjs";
import { conversationKey, conversationMessagePath, conversationTarget, mergeConversationMessages, mergeIndividualConversationPayload, messagesForConversation, normalizedConversationPhone, preserveLatestConversationEvidence, replyMessagesForConversation, replyMessagesForLeadCard, recordMatchesConversationTarget, relocateConversationMessage, scopedConversationCache } from "./conversationIdentity.mjs";
import { confirmedReminderTarget, hasCurrentProspectReply, hasReplyToConfirmedProspectOutbound } from "./prospectCycleEvidence.mjs";
import { postQueuedText } from "./sendQueueTransport.mjs";
import { isConfirmedTextSend, isQueueTextAcceptance, sendConfirmedTextBatch, textSendFailureMessage } from "./textSendConfirmation.mjs";
import TextSendStatus, { TextAttemptStatus, useTextSendAttempts, useTextSendMessages } from "./TextSendStatus";
import { bindTextSendAttemptSender, getTextSendAttempts, prioritizeTextSendFailures, prioritizeTextSendGroups, setTextSendAttemptOwner, startTextSendAttempt, textSendAttemptScope } from "./textSendAttempts.mjs";
import { findProspectSelection, resolveDailyQueueProspect } from "./prospectSelection.mjs";
import { postScopedReminder } from "./reminderTransport.mjs";
import { resolveReminderCard } from "./reminderCardResolution.mjs";
import { matchesCrmPhoneSearch } from "./crmPhoneSearch.mjs";
import { messageSenderLabel } from "./messageSenderLabel.mjs";
import ProspectPhoneSearchResults from "./ProspectPhoneSearchResults";
import { prospectsForViewer, prospectBoardItems, prospectReturnsDue, mergeProspectReturns } from "./prospectBoardVisibility.mjs";
import { persistReminderCompletion, reconcileReminderCompletions } from "./reminderCompletion.mjs";
import { confirmHumanCardUpdate, saveConversationTreatment } from "./humanCardActions.mjs";
import { confirmedBindingForCard, confirmedFinancialLeadBinding, projectConfirmedLiftCard, projectConfirmedFinancialLead, protectLeadBindingPatch } from "./liftCardBinding.mjs";
import {MonthlyGoalsProvider,useMonthlyGoalStores,useMonthlyGoals} from "./MonthlyGoalsContext";
import MonthlyGoalsEditor from "./MonthlyGoalsEditor";
import MonthlyGoalSummary from "./MonthlyGoalSummary";
import {monthlyGoalRange} from "./monthlyGoalsModel.mjs";
import useReminderCardNavigation from "./useReminderCardNavigation";
import ReminderCompletionButton from "./ReminderCompletionButton";
import { operationFailureMessage, contextualizeProspectWriteError } from "./operationFailure.mjs";
import MessageTextLinks from "./MessageTextLinks";
import { leadHasHumanOwnership, leadIsAuroraActive, leadResponsibleMode } from "./leadHumanOwnership.mjs";
import { formatTransferClock, leadMatchesTransferFilters, latestTransferEvent, transferEventMatches, transferEventsForLead, transferEventText, transferResponseCycles } from "./transferEvents.mjs";
import { projectLeadReengagementFields } from "./leadReengagementView.mjs";
import { useScreenPeriodFilters } from "./screenPeriodFilters.mjs";
import { dedupeLeadsForDisplay } from "./leadDisplayDedup.mjs";
import { activeConversationExitGuard, FUTURE_FOLLOW_UP_REQUIRED_MESSAGE, hasValidFutureNextContactDate, persistedRecordIsReferral } from "./futureFollowUpGuard.mjs";
import { nextContactSaveChanges, confirmedNextContactAfterSave, nextContactPersistenceFields } from "./nextContactSave.mjs";
import { leadTransferDestinations, transferBusinessPatch, transferScheduleChanges } from "./leadTransferPolicy.mjs";
import { createNextContactTiming } from "./nextContactTiming.mjs";
import { noteConversationSelection, loadConversationDiagnostic, conversationMark, conversationPhase, conversationHeaders, prepareConversationMerges, observeConversationMerge, observeConversationFrame, finishConversationDiagnostic } from "./conversationDiagnostics.mjs";
import useConversationDiagnosticView from "./useConversationDiagnosticView";
import { createSaveDiagnostic, diagnosticMark, associateReminderDiagnostic, reminderDiagnostic, observeDiagnosticClose, closingDiagnostic, observeListFrame } from "./saveDiagnostics.mjs";
import useFutureFollowUpExit from "./useFutureFollowUpExit";
import { saveNextContactOnExit } from "./nextContactExitSave.mjs";
import { persistLeadAutomaticExit, remindersWithAccounting } from "./leadAutomaticExit.mjs";
import NextContactExitDialog from "./NextContactExitDialog";
import NextContactDiagnostics from "./NextContactDiagnostics";
import { CENTRAL_RECORD_NOT_FOUND_MESSAGE } from "./centralConversationExit.mjs";
import useCentralConversationSelection from "./useCentralConversationSelection";
import { canonicalSaleChannelStore, createSaleTarget, mergeVirtualCommercialReminders, normalizeCommercialTrackingSnapshot, reconcileCommercialTrackingSnapshot, projectClients, projectLeads, projectProspects, resolveProjectedRecord, sanitizeProjectedRecord, sanitizeProjectedRecords } from "./commercialTracking.mjs";
import {
  MANUAL_SALE_CUTOFF_NOTICE,
  canManuallyRegisterSale,
  manualSaleWriteDenied,
} from "./manualSaleCutoff.mjs";
import {
  createProspectId,
  fenceProspectHttpResponse,
  firstConfirmedProspectWrite,
  mergeConfirmedProspectItem,
  planProspectItemOperations,
  prospectOperationIsCurrent,
  prospectWriteWasStale,
  runProspectSideEffectIfCurrent,
  prospectWriteScope,
} from "./prospectItemWrites.mjs";

export const LiftPendingContext = createContext({ sales:[], error:"", onSaved:() => {}, onRefresh:async () => {},
  postSales:[], postError:"", onPostSaved:() => {}, onLinksUpdated:() => {},
  commercialSales:[], commercialError:"", commercialLoaded:false });

// The transfer endpoint owns identity and ownership fields, while this form owns
// the submitted business fields.  Its response can intentionally omit fields it
// did not change, so never use it alone as the save confirmation.
export function confirmedTransferredLead(existingLead, transferLead, businessPatch, leadKey) {
  return {
    ...existingLead,
    ...transferLead,
    ...businessPatch,
    _rawPhone:leadKey || transferLead?._rawPhone || existingLead?._rawPhone,
  };
}

export function confirmedLeadForExit(submittedLead, persistedLead) {
  if (!persistedLead || typeof persistedLead !== "object") return submittedLead;
  const submittedBusiness = { ...submittedLead };
  [
    'consultantId','assignedConsultantId','consultorAtual','responsavel','storeId',
    'lojaAtual','lojaOrigem','whatsappStoreId','historicoTransferencias',
    '_prev_store_ids','id','_source','_rawPhone','_prevStoreIds',
  ].forEach(field => delete submittedBusiness[field]);
  return { ...submittedLead, ...persistedLead, ...submittedBusiness };
}

// ── FIREBASE ────────────────────────────────────────────────────
const isLocalDevelopment = process.env.NODE_ENV !== "production";
const firebaseConfig = isLocalDevelopment ? developmentFirebaseConfig(window.location.origin) : {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL:       process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};
// Same-origin HTTPS long-polling is proxied exclusively to the local emulator.
// No production database config or websocket host is used in development.
if (isLocalDevelopment) forceLongPolling();
const firebaseApp = initializeApp(firebaseConfig);
const db = getDatabase(firebaseApp);
const get = (...args) => observeLeadGet(firebaseGet, args);
const runTransaction = (...args) => observeLeadTransaction(firebaseRunTransaction, args);
const storage = getStorage(firebaseApp);
const uploadBytes = (...args) => isLocalDevelopment
  ? Promise.reject(Error("Uploads Firebase Storage desativados no desenvolvimento isolado."))
  : firebaseUploadBytes(...args);
const getDownloadURL = (...args) => isLocalDevelopment
  ? Promise.reject(Error("Firebase Storage de produção indisponível no desenvolvimento."))
  : firebaseGetDownloadURL(...args);

// ── Demo mode — namespace isolation ──────────────────────────────────────────
// _demoMode: variável de módulo mutável, true durante sessão demo.
// demoPath(): prefixa nodes Firebase com 'demo_' quando ativo.
// dbRef(): substituto OBRIGATÓRIO para ref(db,path) em todo o App.js.
// Garante isolamento automático — nenhuma chamada toca dados reais no modo demo.
let _demoMode = false;
const DEMO_FB_NODES = new Set([
  'arflow_clients','arflow_whatsapp','leads','arflow_prospeccao',
  'arflow_historico','arflow_data','arflow_lead_messages',
  'arflow_lead_events','arflow_client_events','arflow_prosp_messages',
  'arflow_prosp_n8n','arflow_zaapid_index','arflow_commercial_tracking',
  'arflow_commercial_events','whatsapp','historico','prospeccao',
]);
function demoPath(path) {
  if (!_demoMode) return path;
  const segs = path.split('/');
  if (DEMO_FB_NODES.has(segs[0])) segs[0] = 'demo_' + segs[0];
  return segs.join('/');
}
function dbRef(path) { return ref(db, demoPath(path)); }
// Helpers para views: retornam lojas/usuários ativos no contexto atual (demo ou real).
// Usados em vez de STORES/USERS diretamente nas funções de render de cada view,
// porque essas funções são closures de módulo e não recebem isDemoMode como prop.
function getActiveStores() { return _demoMode ? DEMO_STORES : STORES; }
function getActiveUsers()  { return operationalUsers(_demoMode ? DEMO_USERS : USERS); }
const fbSet = (key, val) => set(dbRef(key), val).catch(() => {});

// ── Separador de data estilo WhatsApp (Hoje / Ontem / dd de mês de aaaa) ──
function formatDayLabel(timestamp) {
  if (!timestamp) return "";
  const d = new Date(timestamp);
  if (isNaN(d.getTime())) return "";
  const today = new Date();
  const yesterday = new Date(); yesterday.setDate(today.getDate() - 1);
  const sameDay = (a,b) => a.getFullYear()===b.getFullYear() && a.getMonth()===b.getMonth() && a.getDate()===b.getDate();
  if (sameDay(d, today)) return "Hoje";
  if (sameDay(d, yesterday)) return "Ontem";
  return d.toLocaleDateString("pt-BR", { day:"2-digit", month:"long", year:"numeric" });
}
function dayKey(timestamp) {
  if (!timestamp) return "";
  const d = new Date(timestamp);
  if (isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

// ── TEMAS POR LOJA ─────────────────────────────────────────────
const THEMES = {
  1: {
    navy:"#3D2800", navyMid:"#5C3D00", navyLight:"#7A5010",
    accent:"#A07830", accentLight:"#C49A50",
    sand:"#FBF6EE", sandDark:"#EDE0C8",
    positive:"#6B8F3E", gold:"#C49A50",
    text:"#2A1A00", muted:"#8C7A5A", white:"#FFFFFF",
    headerGrad:"linear-gradient(135deg,#3D2800,#5C3D00)",
    tabActive:"#A07830", icon:"👑", label:"Rei dos Estofados",
  },
  2: {
    navy:"#0A2A6E", navyMid:"#1040A0", navyLight:"#1A5CC8",
    accent:"#1565C0", accentLight:"#42A5F5",
    sand:"#F0F4FF", sandDark:"#D0DCFF",
    positive:"#1E8C3A", gold:"#42A5F5",
    text:"#0A1A3E", muted:"#5A6A8C", white:"#FFFFFF",
    headerGrad:"linear-gradient(135deg,#0A2A6E,#1565C0)",
    tabActive:"#42A5F5", icon:"👑", label:"Rei dos Colchões",
  },
  3: {
    navy:"#1A1A1A", navyMid:"#2D2D2D", navyLight:"#444444",
    accent:"#B8960C", accentLight:"#D4AF37",
    sand:"#F8F8F8", sandDark:"#E8E8E8",
    positive:"#2D8A4E", gold:"#D4AF37",
    text:"#1A1A1A", muted:"#666666", white:"#FFFFFF",
    headerGrad:"linear-gradient(135deg,#1A1A1A,#333333)",
    tabActive:"#D4AF37", icon:"⭐", label:"Mezzo Ponta Grossa",
    storeButtonBg:"#000000", storeButtonText:"#FFFFFF",
  },
  4: {
    navy:"#FAFAF5", navyMid:"#F0EAD0", navyLight:"#C9A227",
    accent:"#C9A227", accentLight:"#E8C84A",
    sand:"#FFFDF8", sandDark:"#F5EDD0",
    positive:"#2D8A4E", gold:"#B8860B",
    text:"#1A1200", muted:"#7A6A3A", white:"#FFFFFF",
    headerGrad:"linear-gradient(135deg,#FFFDF5,#F5EDD0)",
    tabActive:"#B8860B", icon:"✨", label:"Mezzo Curitiba",
    storeButtonBg:"#FFFFFF", storeButtonText:"#1A1200",
    headerSubColor:"#7A6233",
    headerBtnBg:"rgba(0,0,0,0.07)",
    headerBtnColor:"#1A1200",
    headerTabInactive:"rgba(90,70,20,0.55)",
    headerShadow:"0 2px 16px rgba(180,140,0,0.13)",
  },
};
let T = THEMES[1];

// ── TEMA DEMO — estilo ArtFlow Connect (branco/dourado premium) ─
const T_DEMO = {
  navy:"#1C1917", navyMid:"#292524", navyLight:"#44403C",
  accent:"#B8960C", accentLight:"#D4AF37",
  sand:"#FAF9F6", sandDark:"#F0EDE6",
  positive:"#2D8A4E", gold:"#B8960C",
  text:"#1C1917", muted:"#78716C", white:"#FFFFFF",
  headerGrad:"linear-gradient(135deg,#1C1917,#292524)",
  tabActive:"#B8960C", icon:"🏠", label:"Grupo Móvel & Arte",
};

// ── DADOS ──────────────────────────────────────────────────────
const STORES = [
  { id:1, name:"Rei dos Estofados",   goal:400000, superGoal:480000, consultantGoal:100000, consultantSuperGoal:120000 },
  { id:2, name:"Rei dos Colchões",    goal:400000, superGoal:480000, consultantGoal:100000, consultantSuperGoal:120000 },
  { id:3, name:"Mezzo Ponta Grossa", goal:150000, superGoal:180000, consultantGoal:100000, consultantSuperGoal:120000 },
  { id:4, name:"Mezzo Curitiba",     goal:120000, superGoal:145000, consultantGoal:100000, consultantSuperGoal:120000 },
];

const USERS = [
  { id:40, name:"Ana Paula Ribeiro", role:"superadmin", storeId:null, authKind:"crm" },
  DEPOSITO_USER,
  { id:0,  name:"Carol", role:"admin", storeId:null },
  { id:1,  name:"Gerente Estofados", role:"manager",    storeId:1 },
  { id:2,  name:"Ana Paula",         role:"consultant", storeId:1 },
  { id:3,  name:"Lucas",             role:"consultant", storeId:1 },
  { id:4,  name:"Jaine",             role:"consultant", storeId:1 },
  { id:5,  name:"Carol",             role:"consultant", storeId:1 },
  { id:6,  name:"Jhenyfer",          role:"consultant", storeId:1 },
  { id:10, name:"Gerente Colchões",  role:"manager",    storeId:2 },
  { id:11, name:"Elaine",            role:"consultant", storeId:2 },
  { id:12, name:"Guilherme",         role:"consultant", storeId:2 },
  { id:13, name:"Priscila",          role:"consultant", storeId:2 },
  { id:23, name:"Gerente Mezzo PG",  role:"manager",    storeId:3 },
  { id:20, name:"Amile",             role:"consultant", storeId:3 },
  { id:21, name:"Rodrigo",           role:"consultant", storeId:3 },
  { id:22, name:"Vinicius",          role:"consultant", storeId:3 },
  { id:34, name:"Gerente Mezzo CWB", role:"manager",    storeId:4 },
  { id:30, name:"Rosana",            role:"consultant", storeId:4 },
  { id:31, name:"Cris",              role:"consultant", storeId:4 },
  { id:32, name:"Adriana",           role:"consultant", storeId:4 },
  { id:33, name:"Diogo",             role:"consultant", storeId:4 },
  { id:35, name:"Ana",               role:"consultant", storeId:4 },
];

// ── Usuários e lojas fictícias para o modo DEMO ───────────────────────────────
// storeId 101-103 são exclusivos do ambiente demo. Nunca entram em colisão
// com lojas reais (1-4). isDemo:true ativa _demoMode no login.
const DEMO_STORES = [
  { id:101, name:"Móvel & Arte Curitiba",  goal:120000, superGoal:150000, consultantGoal:30000, consultantSuperGoal:40000 },
  { id:102, name:"Móvel & Arte Londrina",  goal:80000,  superGoal:100000, consultantGoal:25000, consultantSuperGoal:32000 },
  { id:103, name:"Móvel & Arte Maringá",   goal:60000,  superGoal:75000,  consultantGoal:20000, consultantSuperGoal:26000 },
];
const DEMO_USERS = [
  { id:101, name:"Carlos Mendes (Admin)",  role:"admin",      storeId:null, isDemo:true },
  { id:102, name:"Beatriz Alves",          role:"manager",    storeId:101,  isDemo:true },
  { id:103, name:"Felipe Costa",           role:"consultant", storeId:101,  isDemo:true },
  { id:104, name:"Mariana Lima",           role:"consultant", storeId:101,  isDemo:true },
  { id:105, name:"Rafael Santos",          role:"consultant", storeId:102,  isDemo:true },
  { id:106, name:"Ana Paula Moreira",      role:"consultant", storeId:102,  isDemo:true },
  { id:107, name:"Gerente Londrina",       role:"manager",    storeId:102,  isDemo:true },
  { id:108, name:"Gerente Maringá",        role:"manager",    storeId:103,  isDemo:true },
  { id:109, name:"Letícia Rocha",          role:"consultant", storeId:103,  isDemo:true },
  { id:110, name:"Diego Martins",          role:"consultant", storeId:103,  isDemo:true },
];
// isDemoStore: use DEMO_STORE_IDS.has(id) server-side; client-side: storeId >= 101 && storeId <= 199

const PRODUCTS_BY_STORE = {
  1: ["Sofá","Mesa","Cadeira","Conj. Mesa + Cadeiras","Poltrona","Tapete","Aparador","Itens de Decoração","Outros"],
  3: ["Sofá","Mesa","Cadeira","Conj. Mesa + Cadeiras","Poltrona","Tapete","Rack","Painel TV","Buffet","Aparador","Cama","Criado-mudo","Outros"],
  4: ["Sofá","Mesa","Cadeira","Conj. Mesa + Cadeiras","Poltrona","Tapete","Rack","Painel TV","Buffet","Aparador","Cama","Criado-mudo","Outros"],
  2: [
    "Colchão Solteiro","Colchão Solteirão","Colchão Casal","Colchão Queen","Colchão King",
    "Box Solteiro","Box Solteirão","Box Casal","Box Queen","Box King",
    "Box Baú Solteiro","Box Baú Solteirão","Box Baú Casal","Box Baú Queen","Box Baú King",
    "Conjunto Box Casal","Conjunto Box Queen","Conjunto Box King",
    "Conjunto Box Baú Casal","Conjunto Box Baú Queen","Conjunto Box Baú King",
    "Cama Solteiro","Cama Casal","Cama Queen","Cama King",
    "Travesseiro","Protetor de Colchão","Conjunto Cama",
  ],
};

const STAGES = [
  { id:"future",   label:"Prospecção Futura 🏗️", color:"#64748B" },
  { id:"waiting",  label:"Em acompanhamento",     color:"#8B5CF6" },
  { id:"msg_sent", label:"Mensagem Enviada 💬",   color:"#0EA5E9" },
  { id:"final",    label:"Em Negociação 🔔",      color:"#A07830" },
  { id:"closed",   label:"Fechado ✅",            color:"#6B8F3E" },
  { id:"posVenda", label:"Pós-venda ⭐",          color:"#7C3AED" },
  { id:"nextSale", label:"Próxima Venda 🔄",      color:"#2563EB" },
  { id:"semInteresse", label:"Sem Interesse 🚫",    color:"#8C7A5A" },
];

const ORIGINS = ["Porta","Lead","Prospecção","Indicação","WhatsApp"];

const LEAD_STAGES = [
  { id:"chegou",              label:"Chegou",               color:"#8B6F47" },
  { id:"qualificacao",        label:"Em conversa",            color:"#C8A04D" },
  { id:"followup_programado", label:"Follow-up Programado",  color:"#B8763E" },
  { id:"prospeccao_futura",   label:"Prosp. Futura",         color:"#6B7280" },
  { id:"qualificado",         label:"Qualificado",           color:"#4A7A5C" },
  { id:"vai_na_loja",         label:"Vai na Loja 🏪",        color:"#7C3AED" },
  { id:"fechou_venda",        label:"Fechou Venda 🎉",       color:"#2563EB" },
  { id:"desqualificado",      label:"Desqualificado",        color:"#C0392B" },
];
const KNOWN_LEAD_STAGE_IDS = new Set(LEAD_STAGES.map(s => s.id));
export function isDisqualifiedLead(lead) {
  const stages = [
    lead?.estagio, lead?._crm_estagio, lead?.status, lead?.stage,
  ].map(value => String(value || "").toLowerCase());
  return lead?.desqualificado === true
    || stages.some(stage => ["desqualificado", "sem_interesse", "seminteresse"].includes(stage));
}
// ── Tour de apresentação comercial (visível apenas no modo demo) ──────────
const GUIDED_STEPS = [
  { id:'dashboard',   tab:'dashboard',    icon:'📊', label:'Dashboard',    desc:'Visão geral do mês: metas, conversões e performance de cada equipe em tempo real' },
  { id:'leads',       tab:'leads',        icon:'📋', label:'Leads',        desc:'Leads chegando pelo WhatsApp e redes sociais — Aurora atende e qualifica automaticamente' },
  { id:'conversa',    tab:'central',      icon:'💬', label:'Conversa',     desc:'Histórico completo da conversa: da Aurora até o atendimento humano' },
  { id:'atendimento', tab:'kanban',       icon:'🗂', label:'Atendimento',  desc:'Funil de vendas presencial — negociação, venda fechada, entrega e pós-venda' },
  { id:'tarefas',     tab:'lembretes',    icon:'📅', label:'Tarefas',      desc:'Follow-ups e lembretes gerados automaticamente pelo sistema para cada consultor' },
  { id:'indicadores', tab:'historico',    icon:'📈', label:'Indicadores',  desc:'Conversão por origem, etapas do funil e histórico comparativo de resultados' },
  { id:'resultado',   tab:'recebimentos', icon:'💰', label:'Resultado',    desc:'Vendas e recebimentos do mês — detalhado por consultor e por loja' },
];

const DESQUALIFICACAO_REASONS = [
  { id:"preco",              label:"💰 Queria preço" },
  { id:"teste",              label:"🧪 Teste / curiosidade" },
  { id:"comprou_outro_lugar",label:"🛍️ Já comprou em outro lugar" },
  { id:"sem_interesse",      label:"🚫 Sem interesse" },
  { id:"sem_retorno",        label:"🔕 Sem retorno" },
  { id:"representante",      label:"🤝 Representante" },
  { id:"outro",              label:"❓ Outro" },
];

// Leads desqualificados antes desta funcionalidade só têm o texto livre
// (motivo_desqualificacao), sem a categoria nova (motivo_desqualificacao_tipo).
// Esta função tenta advinhar a categoria a partir do texto para que esses
// registros antigos não fiquem escondidos em "Sem motivo informado".
const guessMotivoTipo = (texto) => {
  const t = (texto||"").toLowerCase();
  if (!t.trim()) return "";
  if (/pre[cç]o|caro|valor/.test(t)) return "preco";
  if (/teste|curiosidade|brincadeira/.test(t)) return "teste";
  if (/comprou|outro lugar|concorrente|outra loja/.test(t)) return "comprou_outro_lugar";
  if (/sem interesse|desistiu|não quer mais|nao quer mais|sumiu|não responde|nao responde/.test(t)) return "sem_interesse";
  return "outro";
};

// ── Notificação sonora (Web Audio API — sem arquivo externo) ──────────────
const playNotificationSound = (type = "message") => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = "sine";
    if (type === "transfer") {
      // Três tons ascendentes: lead transferido
      osc.frequency.setValueAtTime(660, ctx.currentTime);
      osc.frequency.setValueAtTime(880, ctx.currentTime + 0.15);
      osc.frequency.setValueAtTime(1100, ctx.currentTime + 0.30);
      gain.gain.setValueAtTime(0.25, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.55);
      osc.start();
      osc.stop(ctx.currentTime + 0.55);
    } else {
      // Ping simples: nova mensagem
      osc.frequency.setValueAtTime(1000, ctx.currentTime);
      gain.gain.setValueAtTime(0.2, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);
      osc.start();
      osc.stop(ctx.currentTime + 0.3);
    }
  } catch { /* navegador sem AudioContext — silencioso */ }
};

// Dados iniciais zerados — tudo começa do zero
const REAL_SALES = { 2:0, 3:0, 4:0, 5:0, 6:0, 11:0, 12:0, 13:0, 20:0, 21:0, 22:0, 30:0, 31:0, 32:0, 33:0, 34:0 };

const fmt = (v) => (v||0).toLocaleString("pt-BR", { style:"currency", currency:"BRL", maximumFractionDigits:0 });
const fmtDate = (d) => { if (!d) return ""; const [y,m,dd] = d.split("-"); return `${dd}/${m}/${y}`; };
const fmtDateTime = (v) => {
  if (!v) return "";
  if (typeof v === "string" && v.includes("T")) {
    const dt = new Date(v);
    if (!isNaN(dt.getTime())) return `${fmtDate(v.split("T")[0])} às ${dt.toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"})}`;
  }
  return fmtDate(v);
};

// ── FILTROS DE PERÍODO / DATA (compartilhado entre Leads, Atendimento, Prospecção, Dashboard, Admin) ──
const PERIOD_PRESETS = [
  { id:"hoje",       label:"Hoje" },
  { id:"ontem",      label:"Ontem" },
  { id:"7dias",      label:"Últimos 7 dias" },
  { id:"este_mes",   label:"Este mês" },
  { id:"mes_passado",label:"Mês anterior" },
  { id:"tudo",       label:"Tudo" },
  { id:"custom",     label:"Personalizado" },
];
const SORT_OPTIONS = [
  { id:"recentes",       label:"Mais recentes" },
  { id:"antigos",        label:"Mais antigos" },
  { id:"interacao",      label:"Última interação" },
  { id:"followup",       label:"Próximo follow-up" },
  { id:"valor",          label:"Maior valor" },
  { id:"parado",         label:"Mais tempo parado" },
];
// Extrai um objeto Date "seguro" a partir de string ISO, "YYYY-MM-DD" ou timestamp
const toDateSafe = (v) => {
  if (!v) return null;
  // Datas "YYYY-MM-DD" puras (sem horário) devem ser tratadas como dia LOCAL,
  // não UTC — senão `new Date("2026-07-04")` vira 2026-07-03 21:00 no horário
  // de Brasília e o registro "some" do filtro "Hoje".
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const [y, m, d] = v.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
};
// Calcula o intervalo [from,to] (Date) para um preset de período
function getPeriodRange(preset, customFrom, customTo) {
  const now = new Date();
  const startOfDay = (d) => { const x=new Date(d); x.setHours(0,0,0,0); return x; };
  const endOfDay   = (d) => { const x=new Date(d); x.setHours(23,59,59,999); return x; };
  switch (preset) {
    case "hoje":        return { from:startOfDay(now), to:endOfDay(now) };
    case "ontem": {      const y=new Date(now); y.setDate(y.getDate()-1); return { from:startOfDay(y), to:endOfDay(y) }; }
    case "7dias": {      const s=new Date(now); s.setDate(s.getDate()-6); return { from:startOfDay(s), to:endOfDay(now) }; }
    case "este_mes":     return { from:new Date(now.getFullYear(), now.getMonth(), 1), to:endOfDay(now) };
    case "mes_passado": { const s=new Date(now.getFullYear(), now.getMonth()-1, 1); const e=new Date(now.getFullYear(), now.getMonth(), 0); return { from:startOfDay(s), to:endOfDay(e) }; }
    case "custom":       return { from: customFrom?startOfDay(new Date(customFrom)):null, to: customTo?endOfDay(new Date(customTo)):null };
    case "tudo":
    default:             return { from:null, to:null };
  }
}
// Verifica se uma data (string/timestamp) cai dentro do intervalo {from,to}
function inPeriod(value, range) {
  if (!range || (!range.from && !range.to)) return true;
  const d = toDateSafe(value);
  if (!d) return false;
  if (range.from && d < range.from) return false;
  if (range.to && d > range.to) return false;
  return true;
}
// Retorna texto relativo tipo "há 2h", "há 3 dias"
function timeAgo(value) {
  const d = toDateSafe(value);
  if (!d) return "";
  const diffMs = Date.now() - d.getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "agora";
  if (mins < 60) return `há ${mins}min`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `há ${hrs}h`;
  const days = Math.floor(hrs / 24);
  return `há ${days} dia${days>1?"s":""}`;
}
// Quantos dias o card está parado (baseado na última interação/atualização)
function daysStalled(value) {
  const d = toDateSafe(value);
  if (!d) return 0;
  return Math.floor((Date.now() - d.getTime()) / 86400000);
}
// Rótulo de agrupamento por dia (Hoje, Ontem, dia da semana, ou DD/MM/YYYY)
function dayGroupLabel(value) {
  const d = toDateSafe(value);
  if (!d) return "Sem data";
  const startOfDay = (x) => { const y=new Date(x); y.setHours(0,0,0,0); return y; };
  const today = startOfDay(new Date());
  const day = startOfDay(d);
  const diffDays = Math.round((today - day) / 86400000);
  const dd = String(d.getDate()).padStart(2,"0");
  const mm = String(d.getMonth()+1).padStart(2,"0");
  if (diffDays === 0) return `Hoje — ${dd}/${mm}`;
  if (diffDays === 1) return `Ontem — ${dd}/${mm}`;
  if (diffDays > 1 && diffDays < 7) {
    const WEEKDAYS = ["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"];
    return `${WEEKDAYS[d.getDay()]} — ${dd}/${mm}`;
  }
  return `${dd}/${mm}/${d.getFullYear()}`;
}
// Agrupa uma lista de itens por dia (usa dateGetter(item) para extrair a data), retorna [{label, key, items}] ordenado desc
function groupByDay(items, dateGetter) {
  const groups = {};
  items.forEach(item => {
    const raw = dateGetter(item);
    const d = toDateSafe(raw);
    const key = d ? d.toISOString().split("T")[0] : "sem-data";
    if (!groups[key]) groups[key] = { key, sortKey: d ? d.getTime() : -1, items: [] };
    groups[key].items.push(item);
  });
  return Object.values(groups)
    .sort((a,b) => b.sortKey - a.sortKey)
    .map(g => ({ ...g, label: g.key==="sem-data" ? "Sem data" : dayGroupLabel(g.key) }));
}
// Agrupa itens (leads) pela data de ENTRADA/CRIAÇÃO em baldes fixos: Hoje, Ontem, 2-5 dias atrás, Mais antigos.
// A etapa/status do item nunca afeta este agrupamento — só a data de chegada, para que o lead nunca "suma"
// ao mudar de etapa. Dentro de cada balde, ordena do mais recente para o mais antigo.
function groupLeadsByArrivalDay(items, dateGetter) {
  const buckets = { hoje: [], ontem: [], d2: [], d3: [], d4: [], d5: [], antigos: [] };
  const startOfDay = (x) => { const y = new Date(x); y.setHours(0,0,0,0); return y; };
  const today = startOfDay(new Date());
  items.forEach(item => {
    const d = toDateSafe(dateGetter(item));
    if (!d) { buckets.antigos.push(item); return; }
    const diffDays = Math.round((today - startOfDay(d)) / 86400000);
    if (diffDays <= 0)      buckets.hoje.push(item);
    else if (diffDays === 1) buckets.ontem.push(item);
    else if (diffDays === 2) buckets.d2.push(item);
    else if (diffDays === 3) buckets.d3.push(item);
    else if (diffDays === 4) buckets.d4.push(item);
    else if (diffDays === 5) buckets.d5.push(item);
    else                      buckets.antigos.push(item);
  });
  const sortDesc = (arr) => [...arr].sort((a,b) => (toDateSafe(dateGetter(b))?.getTime()||0) - (toDateSafe(dateGetter(a))?.getTime()||0));
  return [
    ["hoje","Hoje"], ["ontem","Ontem"], ["d2","2 dias atrás"], ["d3","3 dias atrás"],
    ["d4","4 dias atrás"], ["d5","5 dias atrás"], ["antigos","Mais antigos"],
  ]
    .map(([key,label]) => ({ key, label, items: sortDesc(buckets[key]) }))
    .filter(g => g.items.length > 0);
}
// Ordena uma lista de itens de acordo com um critério (SORT_OPTIONS)
function sortItems(items, sortBy, getters) {
  const g = { createdAt:()=>null, interacao:()=>null, followup:()=>null, valor:()=>0, ...getters };
  const arr = [...items];
  switch (sortBy) {
    case "antigos":   return arr.sort((a,b) => (toDateSafe(g.createdAt(a))||0) - (toDateSafe(g.createdAt(b))||0));
    case "interacao": return arr.sort((a,b) => (toDateSafe(g.interacao(b))?.getTime()||0) - (toDateSafe(g.interacao(a))?.getTime()||0));
    case "followup":  return arr.sort((a,b) => { const fa=toDateSafe(g.followup(a)), fb=toDateSafe(g.followup(b)); if(!fa&&!fb)return 0; if(!fa)return 1; if(!fb)return -1; return fa-fb; });
    case "valor":     return arr.sort((a,b) => (g.valor(b)||0) - (g.valor(a)||0));
    case "parado":    return arr.sort((a,b) => daysStalled(g.interacao(b)) - daysStalled(g.interacao(a)) ? daysStalled(g.interacao(a))<daysStalled(g.interacao(b))?1:-1 : 0);
    case "recentes":
    default:          return arr.sort((a,b) => (toDateSafe(g.createdAt(b))||0) - (toDateSafe(g.createdAt(a))||0));
  }
}

// Barra de filtros reutilizável: período, tipo de data, ordenação, consultor, status
function FilterBar({ filters, setFilters, dateFieldOptions, statusOptions, consultants, showConsultant=true, showStatus=true, hidePeriod=false, showSearch=false, searchValue="", onSearchChange, showStore=false, storeValue="todas", onStoreChange }) {
  const f = filters;
  const set = (patch) => setFilters(prev => ({ ...prev, ...patch }));
  const inputSm = { padding:"7px 10px", borderRadius:8, border:`1.5px solid ${T.sandDark}`, fontSize:12, fontWeight:600, color:T.text, background:"#fff", cursor:"pointer", outline:"none" };
  return (
    <div style={{ display:"flex", flexWrap:"wrap", gap:10, alignItems:"flex-end", background:"#fff", borderRadius:12, padding:"12px 14px", marginBottom:16, boxShadow:"0 2px 10px rgba(15,31,61,0.06)", border:`1px solid ${T.sandDark}` }}>
      {!hidePeriod && (
        <div>
          <div style={{ fontSize:10, fontWeight:700, color:T.muted, marginBottom:4 }}>Período</div>
          <select aria-label="Período" value={f.period} onChange={e=>set({ period:e.target.value })} style={inputSm}>
            {PERIOD_PRESETS.map(p => <option key={p.id} value={p.id}>{p.label}</option>)}
          </select>
        </div>
      )}
      {!hidePeriod && f.period === "custom" && (
        <>
          <div>
            <div style={{ fontSize:10, fontWeight:700, color:T.muted, marginBottom:4 }}>De</div>
            <input type="date" value={f.customFrom||""} onChange={e=>set({ customFrom:e.target.value })} style={inputSm} />
          </div>
          <div>
            <div style={{ fontSize:10, fontWeight:700, color:T.muted, marginBottom:4 }}>Até</div>
            <input type="date" value={f.customTo||""} onChange={e=>set({ customTo:e.target.value })} style={inputSm} />
          </div>
        </>
      )}
      {dateFieldOptions && (
        <div>
          <div style={{ fontSize:10, fontWeight:700, color:T.muted, marginBottom:4 }}>Filtrar por</div>
          <select value={f.dateField} onChange={e=>set({ dateField:e.target.value })} style={inputSm}>
            {dateFieldOptions.map(o => <option key={o.id} value={o.id}>{o.label}</option>)}
          </select>
        </div>
      )}
      {showSearch && (
        <div style={{ flex:"1 1 200px", minWidth:160 }}>
          <div style={{ fontSize:10, fontWeight:700, color:T.muted, marginBottom:4 }}>Buscar</div>
          <input
            type="text"
            value={searchValue||""}
            onChange={e=>onSearchChange && onSearchChange(e.target.value)}
            placeholder="🔎 Nome ou telefone..."
            style={{ ...inputSm, width:"100%", cursor:"text" }}
          />
        </div>
      )}
      <div>
        <div style={{ fontSize:10, fontWeight:700, color:T.muted, marginBottom:4 }}>Ordenar por</div>
        <select value={f.sortBy} onChange={e=>set({ sortBy:e.target.value })} style={inputSm}>
          {SORT_OPTIONS.map(o => <option key={o.id} value={o.id}>{o.label}</option>)}
        </select>
      </div>
      {showConsultant && consultants && (
        <div>
          <div style={{ fontSize:10, fontWeight:700, color:T.muted, marginBottom:4 }}>Responsável pelo Atendimento</div>
          <select aria-label="Responsável pelo Atendimento" value={f.consultantId||"todos"} onChange={e=>set({ consultantId:e.target.value })} style={inputSm}>
            <option value="todos">Todos</option>
            <option value="aurora">🤖 Aurora</option>
            {consultants.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
          </select>
        </div>
      )}
      {showStatus && statusOptions && (
        <div>
          <div style={{ fontSize:10, fontWeight:700, color:T.muted, marginBottom:4 }}>Status</div>
          <select value={f.status||"todos"} onChange={e=>set({ status:e.target.value })} style={inputSm}>
            <option value="todos">Todos</option>
            {statusOptions.map(o => <option key={o.id} value={o.id}>{o.label}</option>)}
          </select>
        </div>
      )}
      {showStore && (
        <div>
          <div style={{ fontSize:10, fontWeight:700, color:T.muted, marginBottom:4 }}>Loja</div>
          <select value={storeValue||"todas"} onChange={e=>onStoreChange && onStoreChange(e.target.value)} style={inputSm}>
            <option value="todas">Todas as Lojas</option>
            {STORES.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </div>
      )}
      <button onClick={()=>set({ period:"tudo", customFrom:"", customTo:"", sortBy:"recentes", consultantId:"todos", status:"todos" })}
        style={{ ...inputSm, background:T.sandDark, border:"none", cursor:"pointer" }}>
        Limpar filtros
      </button>
    </div>
  );
}
const DEFAULT_FILTERS = { period:"tudo", customFrom:"", customTo:"", dateField:"createdAt", sortBy:"recentes", consultantId:"todos", status:"todos" };
// Compara um item (lead/cliente/prospecção) contra o filtro de responsável do FilterBar.
// "aurora" só existe de fato nos leads (campo responsavel); para clientes/prospecção,
// que já foram atribuídos a um consultor humano no momento em que são criados, um
// consultantId ainda não definido é tratado como "com a Aurora" por equivalência.
function matchesResponsavelFiltro(item, filterVal) {
  if (!filterVal || filterVal === "todos") return true;
  if (filterVal === "aurora") {
    if (item && Object.prototype.hasOwnProperty.call(item, "responsavel")) return leadIsAuroraActive(item);
    return item.consultantId == null;
  }
  return Number(item.consultantId) === Number(filterVal);
}

// Resolve uma atribuição humana de lead mesmo em registros antigos nos quais
// `responsavel` foi atualizado pelo webhook, mas algum id ficou desatualizado.
// O nome explícito do responsável tem prioridade, porque representa o último
// atendente informado pela automação; campos de id são os fallbacks.
function resolveLeadConsultant(lead) {
  if (!lead) return null;
  const storeId = Number(lead.storeId ?? lead.lojaAtual ?? lead.lojaOrigem);
  const consultants = USERS.filter(u => u.role === "consultant" && (!storeId || u.storeId === storeId));
  const normalizeName = value => String(value || "").trim().toLocaleLowerCase("pt-BR");
  const compactName = value => normalizeName(value).replace(/\s+/g, "");
  const ignoredNames = new Set(["", "aurora", "consultor", "cliente"]);
  const findByName = rawName => {
    const name = normalizeName(rawName);
    if (ignoredNames.has(name)) return null;
    return consultants.find(u => normalizeName(u.name) === name)
      || consultants.find(u => compactName(u.name) === compactName(name))
      || consultants.find(u => normalizeName(u.name.split(" ")[0]) === name)
      || null;
  };

  // Em uma transferência feita pelo CRM, `consultantId` é a escolha explícita.
  // IDs auditáveis sempre prevalecem sobre nomes antigos ou de mensagens.
  for (const id of [lead.consultantId, lead.consultorAtual, lead.assignedConsultantId]) {
    const consultant = USERS.find(u => u.id === Number(id));
    if (consultant) return consultant;
  }
  for (const name of [lead.responsavelNome, lead.consultorNome, lead.responsavel]) {
    const consultant = findByName(name);
    if (consultant) return consultant;
  }
  return null;
}

const resolveLeadConsultantId = lead => resolveLeadConsultant(lead)?.id ?? null;

// Verifica se um lead pertence a um consultor, sempre pela atribuição canônica.
// Usado para manter Kanban de Leads e Resumo por Consultor com a MESMA contagem.
function leadOwnedByConsultant(l, consultant) {
  return !!consultant && resolveLeadConsultantId(l) === consultant.id;
}

// Parseia valor em formato BR ("40.410,00" → 40410) ou número puro
const parseValorBR = (v) => {
  if (!v && v !== 0) return 0;
  const s = String(v).trim().replace(/R\$\s*/g, "");
  if (/^\d+(\.\d{1,2})?$/.test(s)) return parseFloat(s) || 0; // já é número puro
  return parseFloat(s.replace(/\./g, "").replace(",", ".")) || 0; // "40.410,00" → 40410
};
// Normaliza telefone para 11 dígitos (DDD + número, sem DDI 55)
// Aurora/Z-API gravam com DDI: 5511999999999 → normalizamos para 11999999999
// Também corrige números de celular salvos sem o 9º dígito (DDD + 8 dígitos → DDD + 9 + 8 dígitos),
// erro comum vindo da Aurora/cadastro manual que fazia a msg "sumir" (chave diferente no Firebase).
const normalizePhone = (p) => {
  let d = (p||"").replace(/\D/g,"");
  if ((d.length === 13 || d.length === 12) && d.startsWith("55")) d = d.slice(2);
  if (d.length === 10) d = d.slice(0,2) + "9" + d.slice(2); // DDD+8 dígitos → DDD+9+8 dígitos
  return d;
};

// Verifica se dois números batem considerando variação do 9º dígito brasileiro
const phonesMatchGlobal = (a, b) => {
  if (!a || !b) return false;
  if (a === b) return true;
  const strip9 = (p) => p.length === 11 ? p.slice(0, 2) + p.slice(3) : p;
  return strip9(a) === strip9(b);
};

// Busca de telefone deve aceitar o mesmo contato com ou sem o 9º dígito,
// além de pontuação e DDI. Sem isso, uma conversa existente parece inexistente
// quando o usuário pesquisa o número no formato curto recebido pelo cliente.
const matchesPhoneSearch = (phone, query) => {
  const rawQuery = String(query || "").replace(/\D/g, "");
  if (!rawQuery) return false;
  const rawPhone = String(phone || "").replace(/\D/g, "");
  const normalizedPhone = normalizePhone(rawPhone);
  const normalizedQuery = normalizePhone(rawQuery);
  return rawPhone.includes(rawQuery)
    || matchesCrmPhoneSearch(rawPhone, rawQuery)
    || normalizedPhone.includes(normalizedQuery)
    || phonesMatchGlobal(normalizedPhone, normalizedQuery);
};

// Mensagens de encerramento do cliente (obrigada/ok/blz/só emoji) não devem disparar o
// selo vermelho "aguardando resposta" — o consultor já resolveu o assunto, não é um pedido
// novo. Só classifica por TEXTO (áudio/imagem sem texto não dá pra saber o conteúdo, então
// continua contando como pendente, mais seguro nunca perder um cliente real).
const CLOSING_MSG_KEYWORDS = [
  "obrigad", "valeu", "vlw", "obg", "de nada", "tranquilo", "blz", "beleza",
  "perfeito", "show", "certo", "combinado", "entendi", "👍", "🙏", "❤️", "😊", "🙌", "✅",
];
const isClosingMessage = (text) => {
  const t = (text || "").trim().toLowerCase();
  if (!t) return false;
  if (t.length > 60) return false;
  if (/^ok(ay|k+)?[.!]*$/i.test(t)) return true;
  return CLOSING_MSG_KEYWORDS.some(k => t.includes(k));
};

// Conversation cache keys are storeId:normalizedPhone. Never fuzzy-match a
// cache lookup: equal phones in separate stores are separate conversations.
const getWaMsgsForPhone = (waMap, phone, storeId = null) => {
  if (!phone || !waMap || Array.isArray(storeId)) return {};
  return messagesForConversation(waMap, storeId, phone);
};

// The authenticated /api/crm/conversations snapshot is the card's current
// evidence. Full-history cache is for the open chat, never for card status:
// merging historical messages across polls can preserve an obsolete "red".
const getReplyMsgsForPhone = (waMap, phone, storeId = null) =>
  replyMessagesForConversation(waMap, storeId, phone);

// A transfer retains its outbound channel separately; it never joins prior
// store history into the destination conversation.
const leadStoreIds = (lead) => {
  return lead?.whatsappStoreId ?? lead?.lojaOrigem ?? lead?.storeId ?? null;
};

// A loja responsável autoriza o usuário; o canal de origem define qual número
// do WhatsApp envia a mensagem. A loja do consultor atual tem precedência para
// também cobrir transferências legadas que mudaram o responsável, mas deixaram
// storeId/lojaAtual apontando para a origem.
const leadResponsibleStoreId = (lead) => {
  const consultantIds = [
    lead?.consultorAtual,
    lead?.consultantId,
    lead?.assignedConsultantId,
  ];
  for (const value of consultantIds) {
    const consultantId = Number(value);
    if (!Number.isFinite(consultantId)) continue;
    const consultantStoreId = Number(USERS.find(u => u.id === consultantId)?.storeId);
    if (consultantStoreId) return consultantStoreId;
  }
  return Number(lead?.lojaAtual ?? lead?.storeId) || null;
};

const leadOutboundStoreContext = (lead) => ({
  responsibleStoreId: leadResponsibleStoreId(lead),
  channelStoreId: Number(lead?.whatsappStoreId ?? lead?.lojaOrigem ?? lead?.storeId) || null,
});

const normalizeOutboundStoreContext = (value, fallbackStoreId) => {
  if (value && typeof value === "object") {
    const responsibleStoreId = Number(value.responsibleStoreId ?? fallbackStoreId) || null;
    const channelStoreId = Number(value.channelStoreId ?? responsibleStoreId) || null;
    return { responsibleStoreId, channelStoreId };
  }
  const storeId = Number(value ?? fallbackStoreId) || null;
  return { responsibleStoreId:storeId, channelStoreId:storeId };
};

// Verifica se um lead pertence a uma loja, considerando:
// 1) o storeId gravado no lead (campo direto)
// 2) a loja do consultor responsável (fallback para leads transferidos sem storeId atualizado)
// Retorna true se storeId for null/0 (sem restrição).
const leadBelongsToStore = (l, storeId) => {
  if (!storeId) return true;
  const sid = Number(storeId);
  if (l.storeId && Number(l.storeId) === sid) return true;
  // Fallback: loja do consultor responsável (lead transferido sem storeId atualizado)
  const cons = resolveLeadConsultant(l);
  return cons?.storeId === sid;
};

// Converte URL do Z-API para passar pelo proxy local (que adiciona o Client-Token).
// Cópias permanentes sempre vencem URLs temporárias do provedor.
const resolveMediaSrc = (rawSrc, storagePath=null) => {
  if (storagePath) return `/api/media-storage?path=${encodeURIComponent(storagePath)}`;
  if (!rawSrc) return null;
  if (rawSrc.startsWith("data:")) return rawSrc;
  if (rawSrc.includes("firebasestorage.googleapis.com")) return rawSrc;
  // Z-API e outros CDNs que exigem auth → proxy
  if (rawSrc.includes("z-api.io") || rawSrc.includes("cdn.z-api.io")) {
    return `/api/media?url=${encodeURIComponent(rawSrc)}`;
  }
  return rawSrc;
};

// Abre mídia de forma confiável:
// 1) base64Data → cria blob URL temporário (funciona sempre)
// 2) URL do Firebase Storage → renova token antes de abrir
// 3) URL Z-API → abre via proxy (que adiciona o Client-Token)
// 4) Qualquer outra URL → abre direto
const openMediaSrc = async (m) => {
  const src = resolveMediaSrc(
    m.storageUrl || m.base64Data || m.url || m.image || m.audio || m.video || null,
    m.storagePath,
  );
  if (!src) return;
  // 1. base64 → blob URL
  if (src.startsWith("data:")) {
    try {
      const res = await fetch(src);
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      const win = window.open(blobUrl, "_blank");
      if (win) setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
      return;
    } catch {}
  }
  // 2. Firebase Storage → renova token
  if (src.includes("firebasestorage.googleapis.com")) {
    try {
      const urlObj = new URL(src);
      const pathMatch = urlObj.pathname.match(/\/o\/(.+)$/);
      if (pathMatch) {
        const { getDownloadURL: gdURL, ref: sRef } = await import("firebase/storage");
        const { getStorage: gSt } = await import("firebase/storage");
        const freshUrl = await gdURL(sRef(gSt(), decodeURIComponent(pathMatch[1])));
        window.open(freshUrl, "_blank");
        return;
      }
    } catch {}
  }
  // 3. Z-API → abre via proxy
  if (src.includes("z-api.io") || src.includes("cdn.z-api.io")) {
    window.open(`/api/media?url=${encodeURIComponent(src)}`, "_blank");
    return;
  }
  // 4. Fallback direto
  window.open(src, "_blank");
};
// ── Fotos de produto referenciadas pela Aurora via fotoIds ────────
// Aurora envia { fotoIds: ["sofa-pulse"] } em vez de imagem direta.
// As fotos reais ficam em produto-fotos/{id} (array de URLs) e o nome em produtos/{id}.nome
const _produtoFotosCache = {};
const fetchProdutoFotos = async (id) => {
  if (_produtoFotosCache[id]) return _produtoFotosCache[id];
  try {
    const [fotosSnap, prodSnap] = await Promise.all([
      get(dbRef(`produto-fotos/${id}`)),
      get(dbRef(`produtos/${id}`)),
    ]);
    const fotosVal = fotosSnap.exists() ? fotosSnap.val() : [];
    const fotos = Array.isArray(fotosVal) ? fotosVal.filter(Boolean) : Object.values(fotosVal||{}).filter(Boolean);
    const nome = prodSnap.exists() ? (prodSnap.val().nome || id) : id;
    const result = { id, fotos, nome };
    _produtoFotosCache[id] = result;
    return result;
  } catch {
    return { id, fotos: [], nome: id };
  }
};
function WaAckTicks({ ack }) {
  // Provider acceptance is not delivery. Keep every provider callback state
  // visibly distinct instead of collapsing RECEIVED/DELIVERED or READ/PLAYED.
  const a = (ack || "").toUpperCase();
  if (a === "PLAYED") return <span title="Reproduzida" style={{ color:"#53BDEB", fontSize:9 }}>✓✓ Reproduzida</span>;
  if (a === "READ") return <span title="Lida" style={{ color:"#53BDEB", fontSize:9 }}>✓✓ Lida</span>;
  if (a === "DELIVERED") return <span title="Entregue" style={{ color:"#94A3B8", fontSize:9 }}>✓✓ Entregue</span>;
  if (a === "RECEIVED") return <span title="Recebida" style={{ color:"#94A3B8", fontSize:9 }}>✓✓ Recebida</span>;
  if (a === "SENT") return <span title="Aceita pelo provedor; ainda não entregue" style={{ color:"#94A3B8", fontSize:9 }}>✓ Aceita pelo provedor</span>;
  return null;
}
// Espelha na interface do consultor o status real de envio vindo da fila do
// backend (server.js): pending (na fila) → sending (tentando agora) → sent
// (entregue à Z-API, usa WaAckTicks pra confirmação de leitura) ou, em caso de
// falha, retry (tentando de novo) / failed (desistiu após as tentativas — aqui
// o consultor pode reenviar manualmente).
function waMsgIsFailed(m) { return m?.status === "failed"; }
const CRM_SESSION_EXPIRED_MOTIVO = "NÃO enviada — sua sessão de login expirou. Entre novamente e use Reenviar.";
const WA_SEND_UNCONFIRMED_MOTIVO = "Envio não confirmado — verifique a conexão e tente Reenviar. O mesmo pedido não será enviado duas vezes.";
function isCrmSessionExpired(response, data) {
  return response?.status === 401 || /faça login novamente/i.test(String(data?.error || ""));
}
// Mensagens de mídia (imagem/áudio/vídeo) não guardam o arquivo original após o
// envio, então não dá pra reenviar automaticamente reenviando texto vazio —
// só habilitamos o botão de reenvio pra mensagens de texto puro.
function waMsgIsMedia(m) {
  return !!(m?.tipo || m?.type || m?.base64Data || m?.url || m?.image || m?.audio || m?.video);
}
// Se uma mensagem fica pending/sending/retry por tempo demais sem o backend
// atualizar o status (ex.: servidor reiniciou no meio do processamento da
// fila e ninguém retomou aquele item), consideramos "travada" e avisamos o
// consultor, liberando o reenvio manual mesmo sem um "failed" explícito.
const WA_SEND_STALL_MS = 3 * 60 * 1000; // 3 minutos
// Mensagens de mídia enviadas antes do reenvio automático existir (ou cujo
// upload original falhou) não têm base64/URL salvos — não há como reanexar
// o arquivo a essa bolha antiga, então "reenviar" nesse caso só repetiria a
// mesma falha. Avisamos que é preciso mandar o arquivo de novo pelo 📎.
const MEDIA_UNAVAILABLE_MOTIVO = "Não foi possível reenviar — arquivo original não está mais disponível. Anexe o arquivo de novo pelo 📎 para enviar como nova mensagem.";
function WaSendStatus({ status, ack, motivo, onRetry, timestamp, attempt }) {
  const inFlight = status === "pending" || status === "sending" || status === "retry";
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!inFlight) return;
    const id = setInterval(() => setNow(Date.now()), 15000);
    return () => clearInterval(id);
  }, [inFlight]);
  if (attempt && attempt.phase !== "accepted") return <TextAttemptStatus attempt={attempt} />;
  const stalled = inFlight && timestamp && (now - new Date(timestamp).getTime() > WA_SEND_STALL_MS);
  if (stalled) return (
    <>
      <span title="Sem atualização há vários minutos — pode ter travado (ex.: servidor reiniciou). Tente reenviar." style={{ fontSize:9, color:"#EF4444", fontWeight:700 }}>⚠ Travou</span>
      {onRetry && (
        <button onClick={onRetry} title="Reenviar mensagem" style={{ background:"#EF4444", color:"#fff", border:"none", borderRadius:5, padding:"1px 7px", fontSize:9, fontWeight:700, cursor:"pointer", marginLeft:2 }}>
          ↺ Reenviar
        </button>
      )}
    </>
  );
  if (status === "pending") return <span title={motivo || "Na fila de envio…"} style={{ fontSize:9, opacity:.75 }}>⏳ Na fila{motivo ? ` — ${motivo}` : ""}</span>;
  if (status === "sending") return <span title={motivo || "Enviando…"} style={{ fontSize:9, opacity:.75 }}>⏳ Enviando…{motivo ? ` — ${motivo}` : ""}</span>;
  if (status === "retry") return <span title={motivo || "Reenviando após falha…"} style={{ fontSize:9, color:"#F59E0B", fontWeight:700 }}>↻ Reenviando…{motivo ? ` — ${motivo}` : ""}</span>;
  if (status === "blocked") return (
    <>
      <span title={motivo || "Envio não confirmado; bloqueado para evitar duplicidade"} style={{ fontSize:9, color:"#B45309", fontWeight:800 }}>
        ⚠ Envio não confirmado{motivo ? ` — ${motivo}` : ""}
      </span>
      {motivo === WA_SEND_UNCONFIRMED_MOTIVO && onRetry && (
        <button onClick={onRetry} title="Verificar e reenviar com o mesmo identificador" style={{ background:"#B45309", color:"#fff", border:"none", borderRadius:5, padding:"1px 7px", fontSize:9, fontWeight:700, cursor:"pointer", marginLeft:2 }}>
          ↺ Reenviar
        </button>
      )}
    </>
  );
  if (status === "failed" && motivo === MEDIA_UNAVAILABLE_MOTIVO) return (
    <span title={motivo} style={{ fontSize:9, color:"#EF4444", fontWeight:700 }}>
      ✗ Arquivo antigo indisponível — anexe de novo pelo 📎
    </span>
  );
  if (status === "failed" && motivo === CRM_SESSION_EXPIRED_MOTIVO) return (
    <span title={motivo} style={{ fontSize:9, color:"#EF4444", fontWeight:800 }}>
      🔒 Não enviada — login expirou
    </span>
  );
  if (status === "failed") return (
    <>
      <span title={motivo || "Falhou ao enviar"} style={{ fontSize:9, color:"#EF4444", fontWeight:700 }}>✗ Falhou{motivo ? ` — ${motivo}` : ""}</span>
      {onRetry && (
        <button onClick={onRetry} title="Reenviar mensagem" style={{ background:"#EF4444", color:"#fff", border:"none", borderRadius:5, padding:"1px 7px", fontSize:9, fontWeight:700, cursor:"pointer", marginLeft:2 }}>
          ↺ Reenviar
        </button>
      )}
    </>
  );
  if (status === "sent" && !ack) return <span title="Aceita pelo provedor; ainda não entregue" style={{ color:"#94A3B8", fontSize:9 }}>✓ Aceita pelo provedor</span>;
  return <WaAckTicks ack={ack} />;
}
function FotoIdsGallery({ fotoIds, dark }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(fotoIds || []);
  useEffect(() => {
    let alive = true;
    if (!fotoIds || !fotoIds.length) { setLoading(false); setItems([]); return; }
    setLoading(true);
    Promise.all(fotoIds.map(fetchProdutoFotos)).then(res => {
      if (alive) { setItems(res); setLoading(false); }
    });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  if (!fotoIds || !fotoIds.length) return null;
  if (loading) return <div style={{ fontSize:11, opacity:0.75, marginTop:6 }}>🖼 Carregando fotos…</div>;
  const withFotos = items.filter(it => it.fotos.length);
  if (!withFotos.length) return null;
  return (
    <div style={{ marginTop:8, display:"flex", flexDirection:"column", gap:8 }}>
      {withFotos.map(it => (
        <div key={it.id}>
          <div style={{ fontSize:11, fontWeight:800, marginBottom:4, opacity:0.9 }}>🛋 {it.nome}</div>
          <div style={{ display:"flex", gap:5, overflowX:"auto", paddingBottom:2 }}>
            {it.fotos.slice(0,8).map((url,i)=>(
              <img key={i} src={url} alt={it.nome} onClick={()=>window.open(url,"_blank")}
                style={{ width:68, height:68, objectFit:"cover", borderRadius:8, cursor:"pointer", flexShrink:0, border: dark?"1px solid rgba(255,255,255,0.25)":"1px solid #E2E8F0" }}
                onError={e=>{ e.target.style.display="none"; }} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
const isThisMonthOrEarlier = (dateStr) => {
  if (!dateStr) return true;
  const today = new Date();
  const d = new Date(dateStr + "T12:00:00");
  return d.getFullYear() < today.getFullYear() ||
    (d.getFullYear() === today.getFullYear() && d.getMonth() <= today.getMonth());
};
const pct = (a, b) => b===0 ? 0 : Math.min(100, Math.round((a/b)*100));


// ── AR Flow Studio — Acesso exclusivo AR Flow ───────────────────────────────
const SUPERADMIN_USER = { id:-1, name:"Superadmin AR Flow", role:"superadmin", storeId:null, authKind:"studio", capabilities:["marketing_intelligence"] };

const STUDIO_MODULES = [
  { id:"arquitetura",    icon:"🏗️", title:"Arquitetura Oficial",  desc:"Estrutura técnica e decisões de arquitetura da plataforma." },
  { id:"auroras",        icon:"🤖", title:"Auroras",              desc:"Todos os agentes de IA da AR Flow — gestão centralizada.", special:"auroras" },
  { id:"base-skills",    icon:"⚡", title:"Base de Skills",       desc:"Biblioteca global de skills reutilizáveis por qualquer Aurora." },
  { id:"aurora-helper",  icon:"🧭", title:"Aurora Helper",        desc:"Camada de dados para as Skills: anúncios, estoque e campanhas." },
  { id:"fluxo",          icon:"🔄", title:"Fluxo Comercial",      desc:"Jornada do lead ao fechamento — regras e etapas do processo." },
  { id:"regras",         icon:"📋", title:"Regras Operacionais",  desc:"Normas de funcionamento da plataforma e dos times." },
  { id:"playbooks",      icon:"📖", title:"Playbooks",            desc:"Roteiros de atendimento, objeções e situações específicas." },
  { id:"roadmap",        icon:"🗺️", title:"Roadmap",              desc:"Evolução planejada da plataforma — o que vem a seguir." },
  { id:"testes",         icon:"🧪", title:"Testes",               desc:"Cenários de validação e testes de comportamento." },
  { id:"docs",           icon:"📄", title:"Documentação",         desc:"Referências técnicas, APIs, integrações e guias." },
];

const AURORA_STATUS = {
  producao:      { label:"Produção",        color:"#22C55E", bg:"rgba(34,197,94,0.12)"   },
  testes:        { label:"Em testes",       color:"#F59E0B", bg:"rgba(245,158,11,0.12)"  },
  desenvolvimento:{ label:"Em desenvolvimento", color:"#818CF8", bg:"rgba(129,140,248,0.12)" },
  planejamento:  { label:"Planejamento",    color:"#64748B", bg:"rgba(100,116,139,0.12)" },
  pausada:       { label:"Pausada",         color:"#F87171", bg:"rgba(248,113,113,0.12)" },
  arquivada:     { label:"Arquivada",       color:"#475569", bg:"rgba(71,85,105,0.12)"   },
};

const AURORA_SECTIONS = [
  { id:"identidade",       icon:"🪪", title:"Identidade",       desc:"Propósito, personalidade e tom de voz." },
  { id:"skills",           icon:"⚡", title:"Skills",           desc:"Skills da Base utilizadas + skills exclusivas." },
  { id:"fluxo",            icon:"🔄", title:"Fluxo",            desc:"Jornada específica deste agente." },
  { id:"integracoes",      icon:"🔌", title:"Integrações",      desc:"Sistemas conectados: Z-API, Firebase, n8n..." },
  { id:"testes",           icon:"🧪", title:"Testes",           desc:"Casos de teste e validações de comportamento." },
  { id:"evolucao",         icon:"📈", title:"Evolução",         desc:"Changelog, versão em produção e histórico." },
  { id:"docs",             icon:"📄", title:"Documentação",     desc:"Referência técnica completa do agente." },
];

const INITIAL_AURORAS = [
  { id:"aurora-v2-comercial", name:"Aurora V2 Comercial", icon:"💼", status:"producao",       desc:"Agente de atendimento e qualificação de leads no funil de vendas." },
  { id:"aurora-followup",     name:"Aurora Follow-up",    icon:"📞", status:"desenvolvimento", desc:"Agente de acompanhamento pós-contato e retomada de negociações." },
  { id:"aurora-posvenda",     name:"Aurora Pós-venda",    icon:"🤝", status:"desenvolvimento", desc:"Agente de satisfação, fidelização e relacionamento pós-compra." },
  { id:"aurora-marketing",    name:"Aurora Marketing",    icon:"📣", status:"planejamento",    desc:"Agente de comunicação, campanhas e nutrição de leads." },
];

const studioDataUrl = (path) => `/api/studio/data?path=${encodeURIComponent(String(path||"").replace(/^\/+|\/+$/g,""))}`;
const studioFetch = (path, options={}) => fetch(studioDataUrl(path), { ...options, credentials:'include' });

function SuperAdminLoginModal({ onClose, onSuccess }) {
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!pin.trim() || loading) return;
    setLoading(true); setError("");
    try {
      const resp = await fetch('/api/studio/session', {
        method:'POST', credentials:'include', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ pin }),
      });
      const data = await resp.json();
      if (!resp.ok || !data.ok) { setError(data.error==="studio_session_not_configured" ? "Acesso não configurado." : "PIN incorreto."); setLoading(false); return; }
      onSuccess(data);
    } catch { setError("Erro de rede. Tente novamente."); }
    setLoading(false);
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.85)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center" }} onClick={onClose}>
      <div style={{ background:"#0F172A", borderRadius:16, padding:36, width:"100%", maxWidth:360, boxShadow:"0 20px 60px rgba(0,0,0,0.7)", border:"1px solid rgba(99,102,241,0.35)" }} onClick={e=>e.stopPropagation()}>
        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div style={{ fontSize:36, marginBottom:8 }}>🔮</div>
          <div style={{ color:"#E2E8F0", fontWeight:800, fontSize:18, fontFamily:"Georgia,serif" }}>AR Flow Studio</div>
          <div style={{ color:"#475569", fontSize:11, marginTop:4, letterSpacing:1 }}>ACESSO EXCLUSIVO AR FLOW</div>
        </div>
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize:11, fontWeight:700, color:"#64748B", display:"block", marginBottom:6, letterSpacing:1 }}>PIN DE ACESSO</label>
          <input
            type="password" value={pin} onChange={e=>{setPin(e.target.value);setError("");}}
            placeholder="••••••••••••" autoFocus
            style={{ width:"100%", padding:"12px 14px", borderRadius:8, border:`1.5px solid ${error?"#F87171":"rgba(99,102,241,0.4)"}`, fontSize:18, boxSizing:"border-box", background:"#1E293B", color:"#E2E8F0", letterSpacing:6, textAlign:"center", outline:"none" }}
          />
          {error && <div style={{ color:"#F87171", fontSize:13, marginTop:8, textAlign:"center" }}>{error}</div>}
          <button type="submit" disabled={loading} style={{ marginTop:20, width:"100%", background:"linear-gradient(135deg,#4F46E5,#7C3AED)", color:"#fff", border:"none", borderRadius:8, padding:"13px", fontWeight:700, fontSize:14, cursor:loading?"default":"pointer", opacity:loading?0.7:1 }}>
            {loading ? "Verificando…" : "Acessar Studio"}
          </button>
        </form>
      </div>
    </div>
  );
}

// ── STUDIO: editor markdown genérico com persistência Firebase ──────────────
function StudioMarkdownEditor({ fbPath, label, placeholder, minH }) {
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [lastUpd, setLastUpd] = useState(null);

  useEffect(() => {
    setLoading(true); setSaved(false);
    studioFetch(fbPath)
      .then(r=>r.json())
      .then(d => { setText(d?.content||''); setLastUpd(d?.updated_at||null); setLoading(false); })
      .catch(()=>setLoading(false));
  }, [fbPath]);

  const handleSave = () => {
    setSaving(true);
    const payload = { content: text, updated_at: new Date().toISOString() };
    studioFetch(fbPath, {
      method:'PUT', headers:{'Content-Type':'application/json'},
      body: JSON.stringify(payload),
    }).then(()=>{ setSaving(false); setSaved(true); setLastUpd(payload.updated_at); setTimeout(()=>setSaved(false),2500); })
      .catch(()=>setSaving(false));
  };

  const inp = { background:'#0D1421', border:'1px solid rgba(99,102,241,0.25)', borderRadius:10, padding:14, color:'#CBD5E1', fontSize:13, fontFamily:'monospace', lineHeight:1.65, resize:'vertical', width:'100%', boxSizing:'border-box', outline:'none', minHeight: minH||220 };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
      {label && <div style={{ color:'#64748B', fontSize:11, fontWeight:700, letterSpacing:1 }}>{label}</div>}
      {loading
        ? <div style={{ color:'#475569', fontSize:13, padding:20 }}>Carregando…</div>
        : <textarea value={text} onChange={e=>setText(e.target.value)} placeholder={placeholder||'Digite o conteúdo…'} style={inp} />
      }
      <div style={{ display:'flex', alignItems:'center', gap:12 }}>
        <button onClick={handleSave} disabled={saving||loading} style={{ background: saved?'rgba(34,197,94,0.15)':'rgba(99,102,241,0.15)', border:`1px solid ${saved?'rgba(34,197,94,0.4)':'rgba(99,102,241,0.4)'}`, borderRadius:7, padding:'6px 16px', color:saved?'#22C55E':'#818CF8', cursor:'pointer', fontSize:12, fontWeight:700 }}>
          {saving?'Salvando…':saved?'✓ Salvo':'Salvar'}
        </button>
        {lastUpd && <span style={{ color:'#334155', fontSize:11 }}>Última edição: {new Date(lastUpd).toLocaleString('pt-BR')}</span>}
      </div>
    </div>
  );
}

// ── STUDIO: editor de Identidade de uma Aurora ─────────────────────────────
function AuroraIdentidadeEditor({ aurora }) {
  const fbPath = `arflow_studio/auroras/${aurora.id}/identidade`;
  const blank = { proposito:'', personalidade:'', tom_voz:'', restricoes:'', versao:'1.0' };
  const [form, setForm] = useState(blank);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setLoading(true);
    studioFetch(fbPath).then(r=>r.json())
      .then(d=>{ setForm({ ...blank, ...(d||{}) }); setLoading(false); })
      .catch(()=>setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aurora.id]);

  const set = (k,v) => setForm(f=>({ ...f, [k]:v }));

  const handleSave = () => {
    setSaving(true);
    const payload = { ...form, updated_at: new Date().toISOString() };
    studioFetch(fbPath, {
      method:'PUT', headers:{'Content-Type':'application/json'},
      body: JSON.stringify(payload),
    }).then(()=>{ setSaving(false); setSaved(true); setTimeout(()=>setSaved(false),2500); })
      .catch(()=>setSaving(false));
  };

  const field = (label, key, multiline, ph) => {
    const base = { background:'#0D1421', border:'1px solid rgba(99,102,241,0.2)', borderRadius:8, padding:'10px 12px', color:'#CBD5E1', fontSize:13, width:'100%', boxSizing:'border-box', outline:'none', fontFamily: multiline?'monospace':'inherit', lineHeight:1.55, resize:multiline?'vertical':'none' };
    return (
      <div key={key} style={{ display:'flex', flexDirection:'column', gap:5 }}>
        <label style={{ color:'#64748B', fontSize:11, fontWeight:700, letterSpacing:0.8 }}>{label}</label>
        {multiline
          ? <textarea value={form[key]} onChange={e=>set(key,e.target.value)} placeholder={ph} style={{ ...base, minHeight:90 }} />
          : <input type="text" value={form[key]} onChange={e=>set(key,e.target.value)} placeholder={ph} style={base} />
        }
      </div>
    );
  };

  if (loading) return <div style={{ color:'#475569', padding:20 }}>Carregando…</div>;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
        {field('PROPÓSITO', 'proposito', true, 'Para que esse agente existe? Qual problema resolve?')}
        {field('PERSONALIDADE', 'personalidade', true, 'Como o agente se comporta? Quais traços de caráter?')}
        {field('TOM DE VOZ', 'tom_voz', true, 'Como se comunica? Formal, próximo, direto…')}
        {field('RESTRIÇÕES', 'restricoes', true, 'O que o agente NUNCA deve fazer ou dizer?')}
      </div>
      {field('VERSÃO EM PRODUÇÃO', 'versao', false, 'ex: 1.0, 2.3')}
      <div style={{ display:'flex', alignItems:'center', gap:12, marginTop:4 }}>
        <button onClick={handleSave} disabled={saving} style={{ background:saved?'rgba(34,197,94,0.15)':'rgba(99,102,241,0.15)', border:`1px solid ${saved?'rgba(34,197,94,0.4)':'rgba(99,102,241,0.4)'}`, borderRadius:7, padding:'7px 18px', color:saved?'#22C55E':'#818CF8', cursor:'pointer', fontSize:12, fontWeight:700 }}>
          {saving?'Salvando…':saved?'✓ Salvo':'Salvar Identidade'}
        </button>
      </div>
    </div>
  );
}

// ── STUDIO: gestão de skills de uma Aurora ─────────────────────────────────
function AuroraSkillsEditor({ aurora }) {
  const fbPath = `arflow_studio/auroras/${aurora.id}/skills`;
  const [skillsList, setSkillsList] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [saving, setSaving]     = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [editSkill, setEditSkill] = useState(null);
  const [showAdd, setShowAdd]   = useState(false);
  const [delConfirm, setDelConfirm] = useState(null);
  const blankNew = { numero:'', name:'', versao:'1.0', status_skill:'Em Revisão', autor:'', aprovacao:'Pendente', desc:'', content:'' };
  const [newForm, setNewForm]   = useState(blankNew);

  const STATUS_SKILL_COLORS = {
    'Em Revisão':  { c:'#F59E0B', bg:'rgba(245,158,11,0.12)' },
    'Aprovada':    { c:'#22C55E', bg:'rgba(34,197,94,0.12)'  },
    'Em produção': { c:'#818CF8', bg:'rgba(129,140,248,0.12)'},
    'Pendente':    { c:'#64748B', bg:'rgba(100,116,139,0.12)'},
    'Arquivada':   { c:'#475569', bg:'rgba(71,85,105,0.12)'  },
  };

  const APROVALS = ['Pendente','Aprovada','Reprovada'];
  const STATUS_OPTS = Object.keys(STATUS_SKILL_COLORS);

  const objToList = (obj) => {
    if (!obj || Array.isArray(obj)) return [];
    return Object.values(obj).sort((a,b) => {
      const n1 = parseInt(a.numero||'99'), n2 = parseInt(b.numero||'99');
      return n1 - n2;
    });
  };

  const reload = () => {
    setLoading(true);
    studioFetch(fbPath).then(r=>r.json())
      .then(d => { setSkillsList(objToList(d?.skills_proprias)); setLoading(false); })
      .catch(()=>setLoading(false));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(reload, [aurora.id]);

  const saveList = (list) => {
    setSaving(true);
    // Store as object keyed by id (avoids Firebase array coercion)
    const obj = {};
    for (const s of list) { obj[s.id] = s; }
    const payload = { skills_proprias: obj, skills_refs: [], updated_at: new Date().toISOString() };
    studioFetch(fbPath, {
      method:'PUT', headers:{'Content-Type':'application/json'},
      body: JSON.stringify(payload),
    }).then(()=>{ setSaving(false); setSkillsList(list); })
      .catch(()=>setSaving(false));
  };

  const addSkill = () => {
    if (!newForm.name.trim()) return;
    const skill = { ...newForm, id:`v2-skill-${Date.now()}`, created_at:new Date().toISOString(), updated_at:new Date().toISOString() };
    const updated = [...skillsList, skill].sort((a,b)=>parseInt(a.numero||99)-parseInt(b.numero||99));
    saveList(updated);
    setNewForm(blankNew);
    setShowAdd(false);
  };

  const saveEdit = () => {
    const updated = skillsList.map(s => s.id===editSkill.id ? { ...editSkill, updated_at:new Date().toISOString() } : s);
    saveList(updated);
    setEditSkill(null);
  };

  const deleteSkill = (id) => {
    saveList(skillsList.filter(s=>s.id!==id));
    setDelConfirm(null);
    if (expanded===id) setExpanded(null);
  };

  const inp = { background:'#070D1A', border:'1px solid rgba(99,102,241,0.2)', borderRadius:7, padding:'8px 12px', color:'#E2E8F0', fontSize:13, outline:'none', width:'100%', boxSizing:'border-box' };
  const sel = { ...inp, cursor:'pointer' };

  const StatusBadge = ({v}) => {
    const s = STATUS_SKILL_COLORS[v]||STATUS_SKILL_COLORS['Pendente'];
    return <span style={{ background:s.bg, color:s.c, border:`1px solid ${s.c}44`, borderRadius:20, padding:'1px 9px', fontSize:10, fontWeight:700 }}>{v}</span>;
  };

  if (loading) return <div style={{ color:'#475569', padding:20 }}>Carregando skills…</div>;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:20 }}>
      {/* Header */}
      <div style={{ display:'flex', alignItems:'center', gap:12 }}>
        <div style={{ flex:1 }}>
          <div style={{ color:'#64748B', fontSize:11, fontWeight:700, letterSpacing:1 }}>SKILLS DESTA AURORA {saving&&<span style={{ fontWeight:400 }}>— salvando…</span>}</div>
          <div style={{ color:'#334155', fontSize:11, marginTop:3 }}>{skillsList.length} skill{skillsList.length!==1?'s':''} registrada{skillsList.length!==1?'s':''}</div>
        </div>
        <button onClick={()=>{setShowAdd(v=>!v);setEditSkill(null);}}
          style={{ background:'rgba(99,102,241,0.12)', border:'1px solid rgba(99,102,241,0.35)', borderRadius:7, padding:'6px 14px', color:'#818CF8', cursor:'pointer', fontSize:12, fontWeight:700 }}>
          {showAdd?'✕ Cancelar':'+ Nova Skill'}
        </button>
      </div>

      {/* Formulário nova skill */}
      {showAdd && (
        <div style={{ background:'#0A1020', border:'1px solid rgba(99,102,241,0.25)', borderRadius:12, padding:20, display:'flex', flexDirection:'column', gap:12 }}>
          <div style={{ color:'#818CF8', fontWeight:700, fontSize:13, marginBottom:2 }}>Nova Skill</div>
          <div style={{ display:'grid', gridTemplateColumns:'80px 1fr 80px', gap:10 }}>
            <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
              <label style={{ color:'#64748B', fontSize:10, fontWeight:700, letterSpacing:0.8 }}>Nº</label>
              <input value={newForm.numero} onChange={e=>setNewForm(f=>({...f,numero:e.target.value}))} placeholder="04" style={inp} />
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
              <label style={{ color:'#64748B', fontSize:10, fontWeight:700, letterSpacing:0.8 }}>NOME</label>
              <input value={newForm.name} onChange={e=>setNewForm(f=>({...f,name:e.target.value}))} placeholder="Nome da Skill" style={inp} />
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
              <label style={{ color:'#64748B', fontSize:10, fontWeight:700, letterSpacing:0.8 }}>VERSÃO</label>
              <input value={newForm.versao} onChange={e=>setNewForm(f=>({...f,versao:e.target.value}))} placeholder="1.0" style={inp} />
            </div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10 }}>
            <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
              <label style={{ color:'#64748B', fontSize:10, fontWeight:700, letterSpacing:0.8 }}>STATUS</label>
              <select value={newForm.status_skill} onChange={e=>setNewForm(f=>({...f,status_skill:e.target.value}))} style={sel}>
                {STATUS_OPTS.map(o=><option key={o}>{o}</option>)}
              </select>
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
              <label style={{ color:'#64748B', fontSize:10, fontWeight:700, letterSpacing:0.8 }}>AUTOR</label>
              <input value={newForm.autor} onChange={e=>setNewForm(f=>({...f,autor:e.target.value}))} placeholder="Nome" style={inp} />
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
              <label style={{ color:'#64748B', fontSize:10, fontWeight:700, letterSpacing:0.8 }}>APROVAÇÃO</label>
              <select value={newForm.aprovacao} onChange={e=>setNewForm(f=>({...f,aprovacao:e.target.value}))} style={sel}>
                {APROVALS.map(o=><option key={o}>{o}</option>)}
              </select>
            </div>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
            <label style={{ color:'#64748B', fontSize:10, fontWeight:700, letterSpacing:0.8 }}>DESCRIÇÃO RÁPIDA</label>
            <input value={newForm.desc} onChange={e=>setNewForm(f=>({...f,desc:e.target.value}))} placeholder="Para que serve esta skill? (1–2 linhas)" style={inp} />
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
            <label style={{ color:'#64748B', fontSize:10, fontWeight:700, letterSpacing:0.8 }}>CONTEÚDO COMPLETO</label>
            <textarea value={newForm.content} onChange={e=>setNewForm(f=>({...f,content:e.target.value}))}
              placeholder="Cole aqui o conteúdo completo da skill…"
              style={{ ...inp, fontFamily:'monospace', lineHeight:1.6, resize:'vertical', minHeight:120 }} />
          </div>
          <div style={{ display:'flex', gap:8 }}>
            <button onClick={addSkill} disabled={!newForm.name.trim()}
              style={{ background:'rgba(99,102,241,0.15)', border:'1px solid rgba(99,102,241,0.4)', borderRadius:7, padding:'7px 18px', color:'#818CF8', cursor:'pointer', fontWeight:700, fontSize:12, opacity:!newForm.name.trim()?0.5:1 }}>
              Salvar Skill
            </button>
            <button onClick={()=>{setShowAdd(false);setNewForm(blankNew);}}
              style={{ background:'none', border:'1px solid rgba(255,255,255,0.1)', borderRadius:7, padding:'7px 14px', color:'#475569', cursor:'pointer', fontSize:12 }}>
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* Lista de skills */}
      {skillsList.length===0
        ? <div style={{ color:'#334155', fontSize:13, padding:'16px 0' }}>Nenhuma skill cadastrada ainda. Clique em "+ Nova Skill" para adicionar.</div>
        : <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {skillsList.map(s => {
              const isExp = expanded===s.id;
              const isEdit = editSkill?.id===s.id;
              return (
                <div key={s.id} style={{ background:'#0D1421', border:`1px solid ${isExp?'rgba(99,102,241,0.4)':'rgba(99,102,241,0.12)'}`, borderRadius:11, overflow:'hidden', transition:'border-color 0.15s' }}>
                  {/* Cabeçalho do card */}
                  <div style={{ padding:'12px 16px', display:'flex', alignItems:'center', gap:12, cursor:'pointer' }}
                    onClick={()=>setExpanded(isExp?null:s.id)}>
                    <div style={{ background:'rgba(99,102,241,0.15)', border:'1px solid rgba(99,102,241,0.3)', borderRadius:8, width:36, height:36, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                      <span style={{ color:'#818CF8', fontWeight:800, fontSize:13 }}>{String(s.numero||'?').padStart(2,'0')}</span>
                    </div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                        <span style={{ color:'#E2E8F0', fontWeight:700, fontSize:14 }}>{s.name}</span>
                        <StatusBadge v={s.status_skill||'Pendente'} />
                        {s.versao && <span style={{ color:'#334155', fontSize:10 }}>v{s.versao}</span>}
                      </div>
                      <div style={{ display:'flex', gap:12, marginTop:3 }}>
                        {s.autor && <span style={{ color:'#475569', fontSize:11 }}>Autor: {s.autor}</span>}
                        {s.aprovacao && <span style={{ color:'#334155', fontSize:11 }}>Aprovação: {s.aprovacao}</span>}
                        {s.ultima_atualizacao && <span style={{ color:'#334155', fontSize:11 }}>Atualizado: {s.ultima_atualizacao}</span>}
                      </div>
                    </div>
                    <span style={{ color:'#475569', fontSize:14, flexShrink:0 }}>{isExp?'▲':'▼'}</span>
                  </div>

                  {/* Conteúdo expandido */}
                  {isExp && !isEdit && (
                    <div style={{ borderTop:'1px solid rgba(99,102,241,0.12)', padding:'16px 18px', display:'flex', flexDirection:'column', gap:14 }}>
                      {s.desc && <div style={{ color:'#64748B', fontSize:13, lineHeight:1.55 }}>{s.desc}</div>}
                      {s.content && (
                        <pre style={{ background:'#070D1A', border:'1px solid rgba(99,102,241,0.12)', borderRadius:8, padding:14, color:'#94A3B8', fontSize:12, lineHeight:1.65, whiteSpace:'pre-wrap', wordBreak:'break-word', margin:0, fontFamily:'monospace', maxHeight:400, overflowY:'auto' }}>
                          {s.content}
                        </pre>
                      )}
                      <div style={{ display:'flex', gap:8 }}>
                        <button onClick={()=>{setEditSkill({...s});setExpanded(s.id);}}
                          style={{ background:'rgba(99,102,241,0.1)', border:'1px solid rgba(99,102,241,0.3)', borderRadius:6, padding:'5px 12px', color:'#818CF8', cursor:'pointer', fontSize:11, fontWeight:700 }}>✏️ Editar</button>
                        <button onClick={()=>setDelConfirm(s.id)}
                          style={{ background:'rgba(239,68,68,0.08)', border:'1px solid rgba(239,68,68,0.2)', borderRadius:6, padding:'5px 12px', color:'#F87171', cursor:'pointer', fontSize:11 }}>Excluir</button>
                      </div>
                    </div>
                  )}

                  {/* Formulário de edição */}
                  {isEdit && (
                    <div style={{ borderTop:'1px solid rgba(99,102,241,0.2)', padding:'16px 18px', display:'flex', flexDirection:'column', gap:12 }}>
                      <div style={{ display:'grid', gridTemplateColumns:'80px 1fr 80px', gap:10 }}>
                        <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                          <label style={{ color:'#64748B', fontSize:10, fontWeight:700 }}>Nº</label>
                          <input value={editSkill.numero||''} onChange={e=>setEditSkill(v=>({...v,numero:e.target.value}))} style={inp} />
                        </div>
                        <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                          <label style={{ color:'#64748B', fontSize:10, fontWeight:700 }}>NOME</label>
                          <input value={editSkill.name||''} onChange={e=>setEditSkill(v=>({...v,name:e.target.value}))} style={inp} />
                        </div>
                        <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                          <label style={{ color:'#64748B', fontSize:10, fontWeight:700 }}>VERSÃO</label>
                          <input value={editSkill.versao||''} onChange={e=>setEditSkill(v=>({...v,versao:e.target.value}))} style={inp} />
                        </div>
                      </div>
                      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10 }}>
                        <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                          <label style={{ color:'#64748B', fontSize:10, fontWeight:700 }}>STATUS</label>
                          <select value={editSkill.status_skill||'Pendente'} onChange={e=>setEditSkill(v=>({...v,status_skill:e.target.value}))} style={sel}>
                            {STATUS_OPTS.map(o=><option key={o}>{o}</option>)}
                          </select>
                        </div>
                        <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                          <label style={{ color:'#64748B', fontSize:10, fontWeight:700 }}>AUTOR</label>
                          <input value={editSkill.autor||''} onChange={e=>setEditSkill(v=>({...v,autor:e.target.value}))} style={inp} />
                        </div>
                        <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                          <label style={{ color:'#64748B', fontSize:10, fontWeight:700 }}>APROVAÇÃO</label>
                          <select value={editSkill.aprovacao||'Pendente'} onChange={e=>setEditSkill(v=>({...v,aprovacao:e.target.value}))} style={sel}>
                            {APROVALS.map(o=><option key={o}>{o}</option>)}
                          </select>
                        </div>
                      </div>
                      <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                        <label style={{ color:'#64748B', fontSize:10, fontWeight:700 }}>DESCRIÇÃO</label>
                        <input value={editSkill.desc||''} onChange={e=>setEditSkill(v=>({...v,desc:e.target.value}))} style={inp} />
                      </div>
                      <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                        <label style={{ color:'#64748B', fontSize:10, fontWeight:700 }}>CONTEÚDO</label>
                        <textarea value={editSkill.content||''} onChange={e=>setEditSkill(v=>({...v,content:e.target.value}))}
                          style={{ ...inp, fontFamily:'monospace', lineHeight:1.6, resize:'vertical', minHeight:160 }} />
                      </div>
                      <div style={{ display:'flex', gap:8 }}>
                        <button onClick={saveEdit}
                          style={{ background:'rgba(99,102,241,0.15)', border:'1px solid rgba(99,102,241,0.4)', borderRadius:7, padding:'7px 18px', color:'#818CF8', cursor:'pointer', fontWeight:700, fontSize:12 }}>
                          {saving?'Salvando…':'Salvar alterações'}
                        </button>
                        <button onClick={()=>setEditSkill(null)}
                          style={{ background:'none', border:'1px solid rgba(255,255,255,0.1)', borderRadius:7, padding:'7px 14px', color:'#475569', cursor:'pointer', fontSize:12 }}>
                          Cancelar
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
      }

      {/* Nota sobre Base de Skills */}
      <div style={{ background:'rgba(99,102,241,0.04)', border:'1px dashed rgba(99,102,241,0.15)', borderRadius:10, padding:'12px 16px', display:'flex', gap:10, alignItems:'flex-start' }}>
        <span style={{ fontSize:16, flexShrink:0 }}>📋</span>
        <div>
          <div style={{ color:'#475569', fontSize:12, fontWeight:700, marginBottom:3 }}>Plano de Evolução — Base de Skills</div>
          <div style={{ color:'#334155', fontSize:11, lineHeight:1.5 }}>
            A Base de Skills global será criada na <strong style={{ color:'#475569' }}>Fase 3</strong> — após a conclusão da Aurora V2 e Aurora Follow-up.
            Primeiro executamos. Depois abstraímos.
          </div>
        </div>
      </div>

      {/* Confirm delete */}
      {delConfirm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', zIndex:300, display:'flex', alignItems:'center', justifyContent:'center' }} onClick={()=>setDelConfirm(null)}>
          <div style={{ background:'#0F172A', border:'1px solid rgba(239,68,68,0.35)', borderRadius:14, padding:28, maxWidth:340, textAlign:'center' }} onClick={e=>e.stopPropagation()}>
            <div style={{ fontSize:28, marginBottom:10 }}>⚠️</div>
            <div style={{ color:'#E2E8F0', fontWeight:700, marginBottom:6 }}>Excluir esta skill?</div>
            <div style={{ color:'#64748B', fontSize:13, marginBottom:20 }}>Ação permanente. O conteúdo será removido do Firebase.</div>
            <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
              <button onClick={()=>deleteSkill(delConfirm)} style={{ background:'rgba(239,68,68,0.15)', border:'1px solid rgba(239,68,68,0.4)', borderRadius:7, padding:'8px 18px', color:'#F87171', cursor:'pointer', fontWeight:700 }}>Excluir</button>
              <button onClick={()=>setDelConfirm(null)} style={{ background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:7, padding:'8px 14px', color:'#64748B', cursor:'pointer' }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── STUDIO: módulo Base de Skills (CRUD global) ────────────────────────────
function BaseSkillsModule() {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(null); // null | { mode:'add'|'edit', data }
  const [delConfirm, setDelConfirm] = useState(null);

  const reload = () => {
    setLoading(true);
    studioFetch('arflow_studio/base_skills').then(r=>r.json())
      .then(d => {
        if (!d) { setSkills([]); setLoading(false); return; }
        const list = Object.entries(d).map(([id,v])=>({ id, ...v })).sort((a,b)=>(a.name||'').localeCompare(b.name||''));
        setSkills(list); setLoading(false);
      }).catch(()=>setLoading(false));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(reload, []);

  const CATEGORIES = ['Qualificação','Objeção','Follow-up','Pós-venda','Apresentação','Fechamento','Geral'];

  const saveSkill = (formData, id) => {
    const isEdit = !!id;
    const path = isEdit
      ? `arflow_studio/base_skills/${id}`
      : 'arflow_studio/base_skills';
    const method = isEdit ? 'PATCH' : 'POST';
    const payload = { ...formData, updated_at: new Date().toISOString(), ...(isEdit?{}:{ created_at: new Date().toISOString() }) };
    return studioFetch(path, { method, headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload) })
      .then(()=>{ setModal(null); reload(); });
  };

  const deleteSkill = (id) => {
    studioFetch(`arflow_studio/base_skills/${id}`, { method:'DELETE' })
      .then(()=>{ setDelConfirm(null); reload(); });
  };

  const filtered = skills.filter(s => !search || s.name?.toLowerCase().includes(search.toLowerCase()) || s.category?.toLowerCase().includes(search.toLowerCase()));
  const catColor = { 'Qualificação':'#6366F1','Objeção':'#F59E0B','Follow-up':'#22C55E','Pós-venda':'#818CF8','Apresentação':'#38BDF8','Fechamento':'#F472B6','Geral':'#64748B' };

  return (
    <div>
      {/* Header */}
      <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:20 }}>
        <div style={{ flex:1 }}>
          <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:20, marginBottom:3 }}>⚡ Base de Skills</div>
          <div style={{ color:'#475569', fontSize:13 }}>Biblioteca global de skills reutilizáveis por qualquer Aurora. {skills.length} skill{skills.length!==1?'s':''} cadastrada{skills.length!==1?'s':''}.</div>
        </div>
        <button onClick={()=>setModal({ mode:'add', data:{ name:'', category:'Geral', desc:'', content:'' } })}
          style={{ background:'rgba(99,102,241,0.15)', border:'1px solid rgba(99,102,241,0.4)', borderRadius:8, padding:'8px 16px', color:'#818CF8', cursor:'pointer', fontSize:13, fontWeight:700 }}>
          + Nova Skill
        </button>
      </div>

      {/* Busca */}
      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Buscar por nome ou categoria…"
        style={{ background:'#0D1421', border:'1px solid rgba(99,102,241,0.2)', borderRadius:8, padding:'9px 14px', color:'#E2E8F0', fontSize:13, width:'100%', boxSizing:'border-box', outline:'none', marginBottom:16 }} />

      {/* Lista */}
      {loading ? <div style={{ color:'#475569', padding:20 }}>Carregando…</div> : (
        filtered.length===0
          ? <div style={{ color:'#334155', fontSize:13, padding:20, textAlign:'center' }}>{search?'Nenhuma skill encontrada.':'Ainda sem skills. Adicione a primeira!'}</div>
          : <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
              {filtered.map(s => {
                const cc = catColor[s.category]||'#64748B';
                return (
                  <div key={s.id} style={{ background:'#111827', border:'1px solid rgba(99,102,241,0.15)', borderRadius:10, padding:'14px 18px', display:'flex', gap:14, alignItems:'flex-start' }}>
                    <div style={{ flex:1 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:5 }}>
                        <span style={{ color:'#E2E8F0', fontWeight:700, fontSize:14 }}>{s.name}</span>
                        <span style={{ background:`${cc}1A`, color:cc, border:`1px solid ${cc}44`, borderRadius:20, padding:'1px 9px', fontSize:10, fontWeight:700 }}>{s.category}</span>
                      </div>
                      {s.desc && <div style={{ color:'#64748B', fontSize:12, marginBottom:s.content?6:0 }}>{s.desc}</div>}
                      {s.content && <div style={{ color:'#334155', fontSize:11, fontFamily:'monospace', whiteSpace:'pre-wrap', lineHeight:1.5 }}>{s.content.slice(0,200)}{s.content.length>200?'…':''}</div>}
                    </div>
                    <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                      <button onClick={()=>setModal({ mode:'edit', data:s })}
                        style={{ background:'rgba(99,102,241,0.08)', border:'1px solid rgba(99,102,241,0.2)', borderRadius:6, padding:'4px 10px', color:'#818CF8', cursor:'pointer', fontSize:11, fontWeight:700 }}>Editar</button>
                      <button onClick={()=>setDelConfirm(s.id)}
                        style={{ background:'rgba(239,68,68,0.08)', border:'1px solid rgba(239,68,68,0.2)', borderRadius:6, padding:'4px 10px', color:'#F87171', cursor:'pointer', fontSize:11 }}>Excluir</button>
                    </div>
                  </div>
                );
              })}
            </div>
      )}

      {/* Modal skill */}
      {modal && <SkillFormModal mode={modal.mode} data={modal.data} categories={CATEGORIES}
        onClose={()=>setModal(null)} onSave={saveSkill} />}

      {/* Confirm delete */}
      {delConfirm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center' }} onClick={()=>setDelConfirm(null)}>
          <div style={{ background:'#0F172A', border:'1px solid rgba(239,68,68,0.4)', borderRadius:14, padding:28, maxWidth:340, textAlign:'center' }} onClick={e=>e.stopPropagation()}>
            <div style={{ fontSize:28, marginBottom:10 }}>⚠️</div>
            <div style={{ color:'#E2E8F0', fontWeight:700, marginBottom:6 }}>Excluir esta skill?</div>
            <div style={{ color:'#64748B', fontSize:13, marginBottom:20 }}>Esta ação não pode ser desfeita. Auroras que referenciam esta skill perderão o vínculo.</div>
            <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
              <button onClick={()=>deleteSkill(delConfirm)} style={{ background:'rgba(239,68,68,0.15)', border:'1px solid rgba(239,68,68,0.4)', borderRadius:7, padding:'8px 20px', color:'#F87171', cursor:'pointer', fontWeight:700 }}>Confirmar exclusão</button>
              <button onClick={()=>setDelConfirm(null)} style={{ background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:7, padding:'8px 16px', color:'#64748B', cursor:'pointer' }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── STUDIO: modal add/edit skill ────────────────────────────────────────────
function SkillFormModal({ mode, data, categories, onClose, onSave }) {
  const [form, setForm] = useState(data);
  const [saving, setSaving] = useState(false);
  const set = (k,v) => setForm(f=>({ ...f, [k]:v }));
  const inp = { background:'#0D1421', border:'1px solid rgba(99,102,241,0.25)', borderRadius:8, padding:'9px 12px', color:'#E2E8F0', fontSize:13, outline:'none', width:'100%', boxSizing:'border-box' };
  const handleSave = () => {
    if (!form.name?.trim()) return;
    setSaving(true);
    onSave({ name:form.name, category:form.category||'Geral', desc:form.desc||'', content:form.content||'' }, mode==='edit'?form.id:null)
      .catch(()=>setSaving(false));
  };
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center' }} onClick={onClose}>
      <div style={{ background:'#0F172A', border:'1px solid rgba(99,102,241,0.3)', borderRadius:16, padding:28, width:'100%', maxWidth:500, display:'flex', flexDirection:'column', gap:14 }} onClick={e=>e.stopPropagation()}>
        <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:17 }}>{mode==='add'?'Nova Skill':'Editar Skill'}</div>
        <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
          <label style={{ color:'#64748B', fontSize:11, fontWeight:700, letterSpacing:0.8 }}>NOME</label>
          <input value={form.name} onChange={e=>set('name',e.target.value)} placeholder="Nome da skill" style={inp} />
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
          <label style={{ color:'#64748B', fontSize:11, fontWeight:700, letterSpacing:0.8 }}>CATEGORIA</label>
          <select value={form.category} onChange={e=>set('category',e.target.value)} style={{ ...inp, cursor:'pointer' }}>
            {categories.map(c=><option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
          <label style={{ color:'#64748B', fontSize:11, fontWeight:700, letterSpacing:0.8 }}>DESCRIÇÃO</label>
          <input value={form.desc} onChange={e=>set('desc',e.target.value)} placeholder="Descrição rápida (1 linha)" style={inp} />
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
          <label style={{ color:'#64748B', fontSize:11, fontWeight:700, letterSpacing:0.8 }}>CONTEÚDO / PROMPT</label>
          <textarea value={form.content} onChange={e=>set('content',e.target.value)} placeholder="Cole aqui o prompt completo da skill…" style={{ ...inp, fontFamily:'monospace', lineHeight:1.55, resize:'vertical', minHeight:100 }} />
        </div>
        <div style={{ display:'flex', gap:10, marginTop:4 }}>
          <button onClick={handleSave} disabled={saving||!form.name?.trim()}
            style={{ background:'rgba(99,102,241,0.15)', border:'1px solid rgba(99,102,241,0.4)', borderRadius:7, padding:'9px 20px', color:'#818CF8', cursor:'pointer', fontWeight:700, fontSize:13, opacity:!form.name?.trim()?0.5:1 }}>
            {saving?'Salvando…':'Salvar'}
          </button>
          <button onClick={onClose} style={{ background:'none', border:'1px solid rgba(255,255,255,0.1)', borderRadius:7, padding:'9px 16px', color:'#475569', cursor:'pointer', fontSize:13 }}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

// ── STUDIO: modal add/edit Aurora ───────────────────────────────────────────
function AuroraFormModal({ mode, data, onClose, onSave }) {
  const ICONS = ['🤖','💼','📞','🤝','📣','🧠','⚡','🎯','🔥','💡','🌟','🛡️','📊','🔮','✨'];
  const [form, setForm] = useState(data || { name:'', icon:'🤖', status:'planejamento', desc:'' });
  const [saving, setSaving] = useState(false);
  const set = (k,v) => setForm(f=>({ ...f, [k]:v }));
  const inp = { background:'#0D1421', border:'1px solid rgba(99,102,241,0.25)', borderRadius:8, padding:'9px 12px', color:'#E2E8F0', fontSize:13, outline:'none', width:'100%', boxSizing:'border-box' };
  const handleSave = () => {
    if (!form.name?.trim()) return;
    setSaving(true);
    onSave(form, mode==='edit'?form.id:null).catch(()=>setSaving(false));
  };
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center' }} onClick={onClose}>
      <div style={{ background:'#0F172A', border:'1px solid rgba(99,102,241,0.3)', borderRadius:16, padding:28, width:'100%', maxWidth:460, display:'flex', flexDirection:'column', gap:14 }} onClick={e=>e.stopPropagation()}>
        <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:17 }}>{mode==='add'?'Nova Aurora':'Editar Aurora'}</div>
        <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
          <label style={{ color:'#64748B', fontSize:11, fontWeight:700, letterSpacing:0.8 }}>NOME</label>
          <input value={form.name} onChange={e=>set('name',e.target.value)} placeholder="Ex: Aurora V2 Comercial" style={inp} />
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          <label style={{ color:'#64748B', fontSize:11, fontWeight:700, letterSpacing:0.8 }}>ÍCONE</label>
          <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
            {ICONS.map(ic=>(
              <button key={ic} onClick={()=>set('icon',ic)}
                style={{ background:form.icon===ic?'rgba(99,102,241,0.25)':'rgba(255,255,255,0.04)', border:`1px solid ${form.icon===ic?'rgba(99,102,241,0.6)':'rgba(255,255,255,0.1)'}`, borderRadius:8, width:38, height:38, fontSize:18, cursor:'pointer' }}>
                {ic}
              </button>
            ))}
          </div>
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
          <label style={{ color:'#64748B', fontSize:11, fontWeight:700, letterSpacing:0.8 }}>STATUS</label>
          <select value={form.status} onChange={e=>set('status',e.target.value)} style={{ ...inp, cursor:'pointer' }}>
            {Object.entries(AURORA_STATUS).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}
          </select>
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
          <label style={{ color:'#64748B', fontSize:11, fontWeight:700, letterSpacing:0.8 }}>DESCRIÇÃO</label>
          <textarea value={form.desc} onChange={e=>set('desc',e.target.value)} placeholder="Para que serve esta Aurora?" style={{ ...inp, resize:'vertical', minHeight:60 }} />
        </div>
        <div style={{ display:'flex', gap:10, marginTop:4 }}>
          <button onClick={handleSave} disabled={saving||!form.name?.trim()}
            style={{ background:'rgba(99,102,241,0.15)', border:'1px solid rgba(99,102,241,0.4)', borderRadius:7, padding:'9px 20px', color:'#818CF8', cursor:'pointer', fontWeight:700, fontSize:13, opacity:!form.name?.trim()?0.5:1 }}>
            {saving?'Salvando…':'Salvar'}
          </button>
          <button onClick={onClose} style={{ background:'none', border:'1px solid rgba(255,255,255,0.1)', borderRadius:7, padding:'9px 16px', color:'#475569', cursor:'pointer', fontSize:13 }}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}


// ── AURORA HELPER MODULE ─────────────────────────────────────────────────────
const AH_FB          = 'arflow_studio/aurora_helper';
const AH_CAMPANHAS_FB = 'catalogo/campanhas';

const AH_BLANK_ANUNCIO = {
  identificador_interno: '', meta_source_id: '', utm_content: '',
  campanha: '', categoria: 'sofa', produto_interno: '',
  configuracao_anunciada: '', medida_anunciada: '', formato_anunciado: '',
  preco_anunciado: '', preco_original: '', preco_promocional: '',
  politica_preco: 'livre', oferta: '', condicao_descricao: '',
  caracteristicas_comerciais: '', observacao_comercial: '',
  fotos: '', videos: '',
  medidas_disponiveis: '', medidas_pronta_entrega: '',
  cores_disponiveis: '', tecidos_disponiveis: '',
  quantidade_disponivel: '', personalizacao: false,
  medidas_encomenda: '', prazo_estimado: '',
  disponibilidade: 'pronta_entrega', observacoes: '',
};

const AH_BLANK_CAMPANHA = {
  nome: '', descricao: '', vigente: true,
  data_inicio: '', data_fim: '',
  categorias_afetadas: '', condicoes: '',
  oferta_geral_sofa: '', oferta_geral_mesa: '',
};

const AH_CATEGORIAS = ['sofa','poltrona','mesa','cadeira','decoracao','tapete','colchao'];
const AH_DISPONIB   = ['pronta_entrega','encomenda','indisponivel'];
const AH_PILOT_STORES = [
  { id:1, label:'Rei dos Estofados' },
  { id:2, label:'Rei dos Colchões' },
];

function AuroraHelperModule() { // eslint-disable-line no-unused-vars
  const [tab, setTab] = useState('anuncios');
  const [anuncios, setAnuncios] = useState([]);
  const [adStoreId, setAdStoreId] = useState(1);
  const [adSearch, setAdSearch] = useState('');
  const [adStatus, setAdStatus] = useState('todos');
  const [adError, setAdError] = useState('');
  const [campanhas, setCampanhas] = useState([]);
  const [config, setConfig] = useState({ sheets_url_anuncios:'', sheets_url_estoque:'', obs_config:'' });
  const [editAnuncio, setEditAnuncio] = useState(null);   // null | 'new' | {id, ...}
  const [editCampanha, setEditCampanha] = useState(null); // null | 'new' | {id, ...}
  const [formA, setFormA] = useState(AH_BLANK_ANUNCIO);
  const [formC, setFormC] = useState(AH_BLANK_CAMPANHA);
  const [saving, setSaving] = useState(false);
  const [testId, setTestId] = useState('');
  const [testType, setTestType] = useState('anuncio_id');
  const [testResult, setTestResult] = useState(null);
  const [testLoading, setTestLoading] = useState(false);
  const [mattressMatrix, setMattressMatrix] = useState({});
  const [mattressError, setMattressError] = useState('');

  const reload = () => {
    fetch(`/api/qualification/ads_catalog?storeId=${adStoreId}&companyId=arflow&include_inactive=true`).then(r=>r.json()).then(d=>{
      if (!d.ok) throw new Error(d.error || 'Não foi possível carregar o catálogo');
      setAnuncios((d.ads||[]).map(a=>({
        ...a, id:a.ad_id, identificador_interno:a.ad_id, produto_interno:a.produto_nome_comercial,
        campanha:a.campaign_id || '', observacoes:a.descricao_curta || '',
        disponibilidade:a.ativo===false?'indisponivel':'pronta_entrega',
      })).sort((a,b)=>(a.ad_id||'').localeCompare(b.ad_id||'')));
      setAdError('');
    }).catch(e=>{ setAnuncios([]); setAdError(e.message || 'Erro ao carregar catálogo.'); });
    studioFetch(AH_CAMPANHAS_FB).then(r=>r.json()).then(d=>{
      if (!d) { setCampanhas([]); return; }
      setCampanhas(Object.entries(d).map(([id,v])=>({id,...v})));
    }).catch(()=>{});
    studioFetch(`${AH_FB}/config`).then(r=>r.json()).then(d=>{ if(d) setConfig(c=>({...c,...d})); }).catch(()=>{});
    fetch('/api/qualification/config/2', { credentials:'same-origin', cache:'no-store' })
      .then(r=>r.json()).then(d=>{
        if (!d.ok) throw new Error(d.error || 'Não foi possível carregar a matriz.');
        setMattressMatrix(d.config?.fluxos_comerciais?.colchoes?.matriz_comercial || {});
        setMattressError('');
      }).catch(e=>setMattressError(e.message || 'Não foi possível carregar a matriz.'));
  };

  useEffect(()=>{ reload(); }, [adStoreId]); // eslint-disable-line react-hooks/exhaustive-deps

  const saveAnuncio = async () => {
    if (!formA.identificador_interno.trim() || !formA.produto_interno.trim()) {
      setAdError('Informe o identificador e o nome comercial do produto.');
      return;
    }
    setSaving(true);
    const payload = {
      storeId: adStoreId, companyId:'arflow',
      ad_id:formA.identificador_interno.trim(), produto_nome_comercial:formA.produto_interno.trim(),
      categoria:formA.categoria, descricao_curta:formA.observacoes,
      configuracao_anunciada:formA.configuracao_anunciada,
      medida_anunciada:formA.medida_anunciada, formato_anunciado:formA.formato_anunciado,
      preco_anunciado:formA.preco_anunciado, preco_original:formA.preco_original,
      preco_promocional:formA.preco_promocional, politica_preco:formA.politica_preco,
      oferta:formA.oferta, condicao_descricao:formA.condicao_descricao,
      caracteristicas_comerciais:formA.caracteristicas_comerciais,
      observacao_comercial:formA.observacao_comercial,
      campaign_id:formA.campanha, meta_source_id:formA.meta_source_id, utm_content:formA.utm_content,
      foto_url:(formA.fotos||'').split('\n').map(v=>v.trim()).find(Boolean)||null,
      ativo:formA.disponibilidade!=='indisponivel',
    };
    try {
      const url = editAnuncio === 'new'
        ? '/api/qualification/ads_catalog'
        : `/api/qualification/ads_catalog/${encodeURIComponent(editAnuncio.ad_id || editAnuncio.id)}?storeId=${adStoreId}&companyId=arflow`;
      const response = await fetch(url, { method:editAnuncio==='new'?'POST':'PATCH', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload) });
      const data = await response.json();
      if (!response.ok || !data.ok) throw new Error(data.error || 'Não foi possível salvar o anúncio.');
      setEditAnuncio(null); setAdError(''); reload();
    } catch (e) { setAdError(e.message || 'Não foi possível salvar o anúncio.'); }
    setSaving(false);
  };

  const deleteAnuncio = async (id) => {
    if (!window.confirm('Remover este anúncio? Esta ação não pode ser desfeita.')) return;
    try {
      const r = await fetch(`/api/qualification/ads_catalog/${encodeURIComponent(id)}?storeId=${adStoreId}&companyId=arflow`, { method:'DELETE' });
      const data = await r.json();
      if (!r.ok || !data.ok) throw new Error(data.error || 'Não foi possível remover o anúncio.');
      reload();
    } catch (e) { setAdError(e.message || 'Não foi possível remover o anúncio.'); }
  };

  const saveMattressMatrix = async () => {
    setSaving(true); setMattressError('');
    try {
      const response = await fetch('/api/qualification/config/2', {
        method:'PATCH', credentials:'same-origin',
        headers:{ 'Content-Type':'application/json', Accept:'application/json' },
        body:JSON.stringify({ fluxos_comerciais:{ colchoes:{ matriz_comercial:mattressMatrix } } }),
      });
      const data = await response.json();
      if (!response.ok || !data.ok) throw new Error(data.error || 'Não foi possível salvar a matriz.');
      setMattressMatrix(data.config?.fluxos_comerciais?.colchoes?.matriz_comercial || mattressMatrix);
    } catch (error) {
      setMattressError(error.message || 'Não foi possível salvar a matriz.');
    } finally {
      setSaving(false);
    }
  };

  const renderMattressMatrix = () => {
    const sizes = ['Solteiro','Solteirao','Casal','Queen','King'];
    const columns = [
      ['so_colchao','Só colchão'], ['colchao_box','Colchão + box'],
      ['box_bau','Box baú'], ['colchao_bau','Colchão + baú'],
    ];
    return (
      <div style={{ background:'#111827', border:'1px solid rgba(99,102,241,.2)', borderRadius:14, padding:20 }}>
        <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:18, marginBottom:5 }}>Matriz comercial — Colchões</div>
        <div style={{ color:'#64748B', fontSize:12, marginBottom:18 }}>Valores usados pela Aurora da loja 2. Salvar aqui não altera Estofados nem o Motor de Follow-up.</div>
        {mattressError && <div style={{ color:'#FCA5A5', fontSize:12, marginBottom:12 }}>{mattressError}</div>}
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse', minWidth:760 }}>
            <thead><tr>{['Tamanho','Medida',...columns.map(([,label])=>label)].map(label=><th key={label} style={{ color:'#94A3B8', textAlign:'left', padding:'8px 6px', fontSize:11 }}>{label}</th>)}</tr></thead>
            <tbody>{sizes.map(size=>{
              const row = mattressMatrix[size] || {};
              return <tr key={size} style={{ borderTop:'1px solid rgba(148,163,184,.12)' }}>
                <td style={{ color:'#E2E8F0', padding:'8px 6px', fontWeight:700 }}>{size==='Solteirao'?'Solteirão':size}</td>
                <td style={{ padding:'8px 6px' }}><input value={row.medida||''} onChange={e=>setMattressMatrix(m=>({...m,[size]:{...(m[size]||{}),medida:e.target.value}}))} style={{ width:105, padding:7, borderRadius:6, border:'1px solid #334155', background:'#0F172A', color:'#E2E8F0' }} /></td>
                {columns.map(([field])=><td key={field} style={{ padding:'8px 6px' }}><input type="number" min="0.01" step="0.01" value={row[field]??''} onChange={e=>setMattressMatrix(m=>({...m,[size]:{...(m[size]||{}),[field]:Number(e.target.value)}}))} style={{ width:105, padding:7, borderRadius:6, border:'1px solid #334155', background:'#0F172A', color:'#E2E8F0' }} /></td>)}
              </tr>;
            })}</tbody>
          </table>
        </div>
        <button onClick={saveMattressMatrix} disabled={saving} style={{ marginTop:16, background:'#4F46E5', color:'#fff', border:0, borderRadius:8, padding:'9px 16px', fontWeight:800, cursor:'pointer', opacity:saving ? .6 : 1 }}>{saving?'Salvando…':'Salvar matriz'}</button>
      </div>
    );
  };

  const saveCampanha = async () => {
    if (!formC.nome.trim()) return;
    setSaving(true);
    const payload = {
      ...formC,
      ofertas_gerais_por_categoria:{
        ...(formC.ofertas_gerais_por_categoria || {}),
        sofa:formC.oferta_geral_sofa || null,
        mesa:formC.oferta_geral_mesa || null,
      },
      updated_at: new Date().toISOString(),
    };
    if (editCampanha === 'new') {
      payload.created_at = new Date().toISOString();
      await studioFetch(AH_CAMPANHAS_FB, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload) });
    } else {
      await studioFetch(`${AH_CAMPANHAS_FB}/${editCampanha.id}`, { method:'PATCH', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload) });
    }
    setSaving(false); setEditCampanha(null); reload();
  };

  const deleteCampanha = async (id) => {
    if (!window.confirm('Remover esta campanha?')) return;
    await studioFetch(`${AH_CAMPANHAS_FB}/${id}`, { method:'DELETE' });
    reload();
  };

  const saveConfig = async () => {
    setSaving(true);
    await studioFetch(`${AH_FB}/config`, { method:'PATCH', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ ...config, updated_at: new Date().toISOString() }) });
    setSaving(false);
    alert('Configuração salva.');
  };

  // Testador chama o backend (/api/ah-test) — cascata real executada server-side,
  // token nunca exposto ao browser.
  const runTest = async () => {
    setTestLoading(true); setTestResult(null);
    try {
      const r = await fetch('/api/ah-test', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: testId.trim(), type: testType }),
      });
      const data = await r.json();
      setTestResult(data);
    } catch (e) {
      setTestResult({ ok: false, error: e.message });
    }
    setTestLoading(false);
  };

  const st = { background:'#0B1222', minHeight:'100%' };
  const card = { background:'#111827', border:'1px solid rgba(99,102,241,0.2)', borderRadius:12, padding:20, marginBottom:14 };
  const inp = { width:'100%', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(99,102,241,0.2)', borderRadius:7, padding:'8px 12px', color:'#E2E8F0', fontSize:13, outline:'none', boxSizing:'border-box' };
  const lbl = { color:'#94A3B8', fontSize:11, fontWeight:600, marginBottom:4, display:'block', letterSpacing:0.5 };
  const btn = (v='primary') => {
    const s = { primary:{bg:'rgba(99,102,241,0.2)',bd:'rgba(99,102,241,0.5)',c:'#818CF8'}, danger:{bg:'rgba(239,68,68,0.1)',bd:'rgba(239,68,68,0.3)',c:'#F87171'}, success:{bg:'rgba(34,197,94,0.1)',bd:'rgba(34,197,94,0.3)',c:'#4ADE80'} };
    const x = s[v]||s.primary;
    return { background:x.bg, border:`1px solid ${x.bd}`, borderRadius:7, padding:'6px 16px', color:x.c, cursor:'pointer', fontSize:12, fontWeight:700 };
  };

  const renderAnuncioForm = () => (
    <div style={{ ...card, borderColor:'rgba(99,102,241,0.4)' }}>
      <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:15, marginBottom:18 }}>
        {editAnuncio === 'new' ? '➕ Novo Anúncio' : '✏️ Editar Anúncio'}
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
        {[
          ['identificador_interno','Identificador Interno *','text','Ex: anuncio_001'],
          ['meta_source_id','Meta Source ID','text','ID real do Meta Ads (produção)'],
          ['utm_content','UTM Content','text','utm_content da campanha'],
          ['campanha','Nome da Campanha','text','Ex: Black Friday Sofás'],
          ['produto_interno','Produto Interno','text','Ex: Sofá Retrátil Zeus'],
          ['configuracao_anunciada','Configuração do Anúncio','text','Ex: retrátil, 4 lugares, com chaise'],
          ['medida_anunciada','Medida Anunciada','text','Ex: 2,40m'],
          ['formato_anunciado','Tipo / Formato','text','Ex: reto, L, redondo'],
          ['preco_anunciado','Preço dessa Configuração','text','Ex: R$ 2.890,00'],
          ['preco_original','Preço Original (opcional)','text','Ex: R$ 3.490,00'],
          ['preco_promocional','Preço Promocional (opcional)','text','Ex: R$ 2.890,00'],
          ['quantidade_disponivel','Quantidade Disponível','text','Ex: 3'],
          ['prazo_estimado','Prazo de Entrega / Encomenda','text','Ex: 45 dias úteis'],
        ].map(([k,label,type,ph])=>(
          <div key={k}>
            <label style={lbl}>{label}</label>
            <input type={type} value={formA[k]||''} onChange={e=>setFormA(f=>({...f,[k]:e.target.value}))} placeholder={ph} style={inp} />
          </div>
        ))}
        <div>
          <label style={lbl}>Categoria</label>
          <select value={formA.categoria} onChange={e=>setFormA(f=>({...f,categoria:e.target.value}))} style={inp}>
            {AH_CATEGORIAS.map(c=><option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label style={lbl}>Política de Preço</label>
          <select value={formA.politica_preco||'livre'} onChange={e=>setFormA(f=>({...f,politica_preco:e.target.value}))} style={inp}>
            <option value="livre">Pode informar o preço da ficha</option>
            <option value="informar_somente_apos_confirmacao_medida_ou_insistencia">Confirmar medida antes do preço</option>
          </select>
        </div>
        <div>
          <label style={lbl}>Disponibilidade</label>
          <select value={formA.disponibilidade} onChange={e=>setFormA(f=>({...f,disponibilidade:e.target.value}))} style={inp}>
            {AH_DISPONIB.map(d=><option key={d} value={d}>{d.replace('_',' ')}</option>)}
          </select>
        </div>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginTop:12 }}>
        {[
          ['medidas_disponiveis','Medidas Disponíveis (separar por vírgula)','Ex: 2,00m, 2,40m, 3,00m'],
          ['medidas_pronta_entrega','Medidas Pronta Entrega (vírgula)','Ex: 2,40m'],
          ['cores_disponiveis','Cores Disponíveis (vírgula)','Ex: Cinza, Bege, Azul'],
          ['tecidos_disponiveis','Tecidos Disponíveis (vírgula)','Ex: Linho, Veludo, Couro'],
          ['medidas_encomenda','Medidas Sob Encomenda (vírgula)','Ex: 2,80m, 3,20m'],
        ].map(([k,label,ph])=>(
          <div key={k}>
            <label style={lbl}>{label}</label>
            <input value={formA[k]||''} onChange={e=>setFormA(f=>({...f,[k]:e.target.value}))} placeholder={ph} style={inp} />
          </div>
        ))}
        <div style={{ display:'flex', alignItems:'center', gap:10, paddingTop:20 }}>
          <input type="checkbox" id="ah-pers" checked={!!formA.personalizacao} onChange={e=>setFormA(f=>({...f,personalizacao:e.target.checked}))} />
          <label htmlFor="ah-pers" style={{ color:'#94A3B8', fontSize:13 }}>Aceita personalização</label>
        </div>
      </div>
      <div style={{ marginTop:12 }}>
        <label style={lbl}>Fotos (uma URL por linha)</label>
        <textarea value={formA.fotos||''} onChange={e=>setFormA(f=>({...f,fotos:e.target.value}))} rows={3} placeholder="https://..." style={{ ...inp, resize:'vertical' }} />
      </div>
      <div style={{ marginTop:12 }}>
        <label style={lbl}>Vídeos (uma URL por linha)</label>
        <textarea value={formA.videos||''} onChange={e=>setFormA(f=>({...f,videos:e.target.value}))} rows={2} placeholder="https://..." style={{ ...inp, resize:'vertical' }} />
      </div>
      <div style={{ marginTop:12 }}>
        <label style={lbl}>Características Comerciais Necessárias</label>
        <textarea value={formA.caracteristicas_comerciais||''} onChange={e=>setFormA(f=>({...f,caracteristicas_comerciais:e.target.value}))} rows={2} placeholder="Ex: tecido linho, assento retrátil, inclui 6 cadeiras" style={{ ...inp, resize:'vertical' }} />
      </div>
      <div style={{ marginTop:12 }}>
        <label style={lbl}>Condição Comercial da Configuração</label>
        <textarea value={formA.condicao_descricao||''} onChange={e=>setFormA(f=>({...f,condicao_descricao:e.target.value}))} rows={2} placeholder="Ex: valor à vista; frete e montagem consultados separadamente" style={{ ...inp, resize:'vertical' }} />
      </div>
      <div style={{ marginTop:12 }}>
        <label style={lbl}>Observação Comercial para a Aurora</label>
        <textarea value={formA.observacao_comercial||''} onChange={e=>setFormA(f=>({...f,observacao_comercial:e.target.value}))} rows={2} placeholder="Orientação opcional específica deste anúncio" style={{ ...inp, resize:'vertical' }} />
      </div>
      <div style={{ marginTop:12 }}>
        <label style={lbl}>Observações Internas</label>
        <textarea value={formA.observacoes||''} onChange={e=>setFormA(f=>({...f,observacoes:e.target.value}))} rows={2} placeholder="Notas internas sobre este anúncio..." style={{ ...inp, resize:'vertical' }} />
      </div>
      <div style={{ display:'flex', gap:10, marginTop:18 }}>
        <button onClick={saveAnuncio} disabled={saving} style={btn('success')}>{saving?'Salvando…':'💾 Salvar Anúncio'}</button>
        <button onClick={()=>setEditAnuncio(null)} style={btn('danger')}>Cancelar</button>
      </div>
    </div>
  );

  const renderAnuncios = () => (
    <div style={st}>
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:20 }}>
        <div style={{ flex:1 }}>
          <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:18 }}>📢 Anúncios</div>
          <div style={{ color:'#475569', fontSize:12 }}>Catálogo do piloto por loja, salvo pelo Aurora Helper. O vínculo automático com um lead permanece bloqueado até a validação de payload real da Z-API.</div>
        </div>
        {!editAnuncio && <button onClick={()=>{ setFormA({...AH_BLANK_ANUNCIO}); setEditAnuncio('new'); }} style={btn()}>+ Novo Anúncio</button>}
      </div>
      <div style={{ ...card, display:'flex', gap:10, flexWrap:'wrap', alignItems:'end', padding:14 }}>
        <div style={{ minWidth:190 }}>
          <label style={lbl}>Loja do piloto</label>
          <select value={adStoreId} onChange={e=>setAdStoreId(Number(e.target.value))} style={inp}>
            {AH_PILOT_STORES.map(s=><option key={s.id} value={s.id}>{s.label}</option>)}
          </select>
        </div>
        <div style={{ flex:'1 1 180px' }}>
          <label style={lbl}>Buscar anúncio</label>
          <input value={adSearch} onChange={e=>setAdSearch(e.target.value)} placeholder="ID, produto ou campanha…" style={inp} />
        </div>
        <div style={{ minWidth:130 }}>
          <label style={lbl}>Status</label>
          <select value={adStatus} onChange={e=>setAdStatus(e.target.value)} style={inp}>
            <option value="todos">Todos</option><option value="ativos">Ativos</option><option value="inativos">Inativos</option>
          </select>
        </div>
        <span style={{ color:'#FBBF24', fontSize:11, fontWeight:700, paddingBottom:9 }}>● Piloto preparado, sem automação</span>
      </div>
      {adError && <div style={{ color:'#FCA5A5', background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.25)', borderRadius:8, padding:'8px 12px', fontSize:12, marginBottom:12 }}>{adError}</div>}
      {editAnuncio && renderAnuncioForm()}
      {!editAnuncio && anuncios.filter(a => {
        const q=adSearch.trim().toLowerCase();
        const matchesSearch=!q || [a.ad_id,a.produto_nome_comercial,a.campaign_id,a.meta_source_id].some(v=>(v||'').toLowerCase().includes(q));
        const matchesStatus=adStatus==='todos' || (adStatus==='ativos' ? a.ativo!==false : a.ativo===false);
        return matchesSearch && matchesStatus;
      }).map(a => (
        <div key={a.id} style={card}>
          <div style={{ display:'flex', alignItems:'flex-start', gap:12 }}>
            <div style={{ flex:1 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:6 }}>
                <span style={{ color:'#818CF8', fontWeight:800, fontSize:14 }}>{a.identificador_interno || '—'}</span>
                <span style={{ background:'rgba(99,102,241,0.1)', color:'#6366F1', border:'1px solid rgba(99,102,241,0.2)', borderRadius:20, padding:'1px 9px', fontSize:10, fontWeight:700 }}>{a.categoria}</span>
                 <span style={{ background: a.ativo!==false?'rgba(34,197,94,0.1)':'rgba(239,68,68,0.1)', color: a.ativo!==false?'#4ADE80':'#F87171', border:'1px solid transparent', borderRadius:20, padding:'1px 9px', fontSize:10, fontWeight:700 }}>{a.ativo!==false?'Ativo':'Inativo'}</span>
              </div>
               <div style={{ color:'#CBD5E1', fontSize:13, fontWeight:600 }}>{a.produto_nome_comercial || a.produto_interno || '—'}</div>
              <div style={{ display:'flex', gap:16, marginTop:5, flexWrap:'wrap' }}>
                {a.medida_anunciada && <span style={{ color:'#64748B', fontSize:12 }}>📐 {a.medida_anunciada}</span>}
                {a.preco_anunciado && <span style={{ color:'#64748B', fontSize:12 }}>💰 {a.preco_anunciado}</span>}
                 {a.configuracao_anunciada && <span style={{ color:'#64748B', fontSize:12 }}>⚙ {a.configuracao_anunciada}</span>}
                {a.meta_source_id && <span style={{ color:'#64748B', fontSize:12 }}>🎯 meta: {a.meta_source_id}</span>}
                {a.utm_content && <span style={{ color:'#64748B', fontSize:12 }}>📌 utm: {a.utm_content}</span>}
              </div>
              {(a.descricao_curta || a.oferta) && <div style={{ color:'#94A3B8', fontSize:12, lineHeight:1.45, marginTop:7 }}>
                {a.descricao_curta}{a.descricao_curta && a.oferta ? ' • ' : ''}{a.oferta}
              </div>}
            </div>
            <div style={{ display:'flex', gap:6 }}>
               <button onClick={()=>{ setFormA({...AH_BLANK_ANUNCIO,...a,identificador_interno:a.ad_id||a.id,produto_interno:a.produto_nome_comercial||a.produto_interno,campanha:a.campaign_id||a.campanha||'',fotos:a.foto_url||'',disponibilidade:a.ativo===false?'indisponivel':'pronta_entrega'}); setEditAnuncio(a); }} style={btn()}>✏️</button>
               <button onClick={()=>deleteAnuncio(a.ad_id||a.id)} style={btn('danger')}>🗑️</button>
            </div>
          </div>
        </div>
      ))}
      {!editAnuncio && anuncios.length === 0 && (
        <div style={{ ...card, textAlign:'center', color:'#475569', padding:40 }}>
          Nenhum anúncio cadastrado ainda.<br/>Clique em "+ Novo Anúncio" para começar.
        </div>
      )}
    </div>
  );

  const renderCampanhas = () => (
    <div style={st}>
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:20 }}>
        <div style={{ flex:1 }}>
          <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:18 }}>🎯 Campanhas Ativas</div>
          <div style={{ color:'#475569', fontSize:12 }}>Promoções vigentes retornadas pela Helper junto ao contexto de cada anúncio.</div>
        </div>
        {!editCampanha && <button onClick={()=>{ setFormC({...AH_BLANK_CAMPANHA}); setEditCampanha('new'); }} style={btn()}>+ Nova Campanha</button>}
      </div>
      {editCampanha && (
        <div style={{ ...card, borderColor:'rgba(99,102,241,0.4)' }}>
          <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:15, marginBottom:18 }}>{editCampanha==='new'?'➕ Nova Campanha':'✏️ Editar Campanha'}</div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            {[['nome','Nome da Campanha *','Ex: Black Friday'],['data_inicio','Data Início','2025-01-01'],['data_fim','Data Fim','2025-01-31'],['categorias_afetadas','Categorias (vírgula, vazio = todas)','Ex: sofa, poltrona'],['oferta_geral_sofa','Oferta Geral — Sofás','Ex: Outras opções de sofás a partir de R$ 4.490'],['oferta_geral_mesa','Oferta Geral — Mesas','Ex: Outras opções de mesas a partir de R$ 3.990']].map(([k,label,ph])=>(
              <div key={k}>
                <label style={lbl}>{label}</label>
                <input value={formC[k]||''} onChange={e=>setFormC(f=>({...f,[k]:e.target.value}))} placeholder={ph} style={inp} />
              </div>
            ))}
          </div>
          <div style={{ marginTop:12 }}>
            <label style={lbl}>Descrição</label>
            <input value={formC.descricao||''} onChange={e=>setFormC(f=>({...f,descricao:e.target.value}))} placeholder="Ex: Até 30% de desconto em sofás selecionados" style={inp} />
          </div>
          <div style={{ marginTop:12 }}>
            <label style={lbl}>Condições / Regras</label>
            <textarea value={formC.condicoes||''} onChange={e=>setFormC(f=>({...f,condicoes:e.target.value}))} rows={3} placeholder="Ex: Válido para pagamento à vista ou em até 12x. Não acumulável com outras promoções." style={{ ...inp, resize:'vertical' }} />
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:10, marginTop:12 }}>
            <input type="checkbox" id="ah-vig" checked={!!formC.vigente} onChange={e=>setFormC(f=>({...f,vigente:e.target.checked}))} />
            <label htmlFor="ah-vig" style={{ color:'#94A3B8', fontSize:13 }}>Campanha vigente (ativa agora)</label>
          </div>
          <div style={{ display:'flex', gap:10, marginTop:18 }}>
            <button onClick={saveCampanha} disabled={saving} style={btn('success')}>{saving?'Salvando…':'💾 Salvar'}</button>
            <button onClick={()=>setEditCampanha(null)} style={btn('danger')}>Cancelar</button>
          </div>
        </div>
      )}
      {!editCampanha && campanhas.map(c => (
        <div key={c.id} style={card}>
          <div style={{ display:'flex', alignItems:'flex-start', gap:12 }}>
            <div style={{ flex:1 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:5 }}>
                <span style={{ color:'#E2E8F0', fontWeight:700, fontSize:14 }}>{c.nome}</span>
                <span style={{ background:c.vigente?'rgba(34,197,94,0.12)':'rgba(71,85,105,0.12)', color:c.vigente?'#4ADE80':'#64748B', border:'1px solid transparent', borderRadius:20, padding:'1px 9px', fontSize:10, fontWeight:700 }}>{c.vigente?'✅ Vigente':'⏸ Inativa'}</span>
              </div>
              <div style={{ color:'#94A3B8', fontSize:12 }}>{c.descricao}</div>
              {c.condicoes && <div style={{ color:'#64748B', fontSize:11, marginTop:3 }}>📋 {c.condicoes}</div>}
              {(c.data_inicio || c.data_fim) && <div style={{ color:'#64748B', fontSize:11 }}>📅 {c.data_inicio||'?'} → {c.data_fim||'?'}</div>}
            </div>
            <div style={{ display:'flex', gap:6 }}>
              <button onClick={()=>{ setFormC({...AH_BLANK_CAMPANHA,...c,oferta_geral_sofa:c.ofertas_gerais_por_categoria?.sofa||c.oferta_geral_sofa||'',oferta_geral_mesa:c.ofertas_gerais_por_categoria?.mesa||c.oferta_geral_mesa||''}); setEditCampanha(c); }} style={btn()}>✏️</button>
              <button onClick={()=>deleteCampanha(c.id)} style={btn('danger')}>🗑️</button>
            </div>
          </div>
        </div>
      ))}
      {!editCampanha && campanhas.length === 0 && <div style={{ ...card, textAlign:'center', color:'#475569', padding:40 }}>Nenhuma campanha cadastrada ainda.</div>}
    </div>
  );

  const renderConfig = () => (
    <div style={st}>
      <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:18, marginBottom:6 }}>⚙️ Configuração</div>
      <div style={{ color:'#475569', fontSize:12, marginBottom:20 }}>URLs das fontes de dados externas. As Skills acessam apenas a Aurora Helper — nunca as fontes diretamente.</div>
      <div style={card}>
        <div style={{ color:'#818CF8', fontWeight:700, fontSize:13, marginBottom:14 }}>📊 Google Sheets</div>
        <div style={{ marginBottom:12 }}>
          <label style={lbl}>URL da planilha de Anúncios / Produtos</label>
          <input value={config.sheets_url_anuncios||''} onChange={e=>setConfig(c=>({...c,sheets_url_anuncios:e.target.value}))} placeholder="https://docs.google.com/spreadsheets/d/..." style={inp} />
        </div>
        <div style={{ marginBottom:12 }}>
          <label style={lbl}>URL da planilha de Estoque</label>
          <input value={config.sheets_url_estoque||''} onChange={e=>setConfig(c=>({...c,sheets_url_estoque:e.target.value}))} placeholder="https://docs.google.com/spreadsheets/d/..." style={inp} />
        </div>
      </div>
      <div style={card}>
        <div style={{ color:'#818CF8', fontWeight:700, fontSize:13, marginBottom:14 }}>🔌 Fontes Futuras</div>
        <div style={{ color:'#475569', fontSize:12, lineHeight:1.7 }}>
          Outras fontes de dados (Firebase por segmento, APIs de estoque, ERPs) poderão ser adicionadas aqui sem alterar as Skills da Aurora.
        </div>
      </div>
      <div style={card}>
        <div style={{ color:'#818CF8', fontWeight:700, fontSize:13, marginBottom:14 }}>📝 Observações Internas</div>
        <textarea value={config.obs_config||''} onChange={e=>setConfig(c=>({...c,obs_config:e.target.value}))} rows={4} placeholder="Notas sobre configuração, pendências, responsáveis..." style={{ ...inp, resize:'vertical' }} />
      </div>
      <button onClick={saveConfig} disabled={saving} style={btn('success')}>{saving?'Salvando…':'💾 Salvar Configuração'}</button>
    </div>
  );

  const renderTestar = () => {
    const found = testResult && testResult.ok && testResult.anuncio_id;
    return (
      <div style={st}>
        <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:18, marginBottom:6 }}>🧪 Testar Aurora Helper</div>
        <div style={{ color:'#475569', fontSize:12, marginBottom:20 }}>
          Executa a cascata real no backend (meta_source_id → utm_content → anuncio_id → sem contexto).
          O token de segurança nunca é exposto ao navegador.
        </div>
        <div style={card}>
          <div style={{ display:'grid', gridTemplateColumns:'160px 1fr auto', gap:10, alignItems:'flex-end' }}>
            <div>
              <label style={lbl}>Tipo de identificador</label>
              <select value={testType} onChange={e=>setTestType(e.target.value)} style={inp}>
                <option value="anuncio_id">anuncio_id (interno)</option>
                <option value="meta_source_id">meta_source_id</option>
                <option value="utm_content">utm_content</option>
              </select>
            </div>
            <div>
              <label style={lbl}>Valor do identificador</label>
              <input value={testId} onChange={e=>setTestId(e.target.value)}
                onKeyDown={e=>e.key==='Enter'&&runTest()}
                placeholder="Ex: anuncio_001" style={inp} />
            </div>
            <button onClick={runTest} disabled={testLoading} style={{ ...btn('success'), padding:'9px 20px', fontSize:13, whiteSpace:'nowrap' }}>
              {testLoading ? '⏳' : '▶ Resolver'}
            </button>
          </div>
          <div style={{ color:'#475569', fontSize:11, marginTop:8 }}>
            Deixe o identificador vazio para ver apenas campanhas ativas sem contexto de anúncio.
          </div>
        </div>
        {testResult && (
          <div style={card}>
            <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:14 }}>
              <span style={{ fontSize:18 }}>{testResult.ok ? (found ? '✅' : '⚠️') : '❌'}</span>
              <div>
                <div style={{ color: testResult.ok ? (found ? '#4ADE80' : '#FBBF24') : '#F87171', fontWeight:700, fontSize:14 }}>
                  {!testResult.ok ? `Erro: ${testResult.error || 'falha no backend'}` :
                   found ? `Anúncio resolvido: ${testResult.anuncio_id}` : 'Sem anúncio — retornando campanhas gerais'}
                </div>
                {testResult.resolution_level && (
                  <div style={{ color:'#64748B', fontSize:11, marginTop:2 }}>
                    Nível de resolução: <span style={{ color:'#818CF8' }}>{testResult.resolution_level}</span>
                    {testResult.campanha && <span style={{ marginLeft:12 }}>🎯 Campanha aplicada: <span style={{ color:'#FBBF24' }}>{testResult.campanha.nome}</span></span>}
                  </div>
                )}
              </div>
            </div>
            <div style={{ color:'#475569', fontSize:11, marginBottom:8 }}>JSON exato entregue para a Skill:</div>
            <pre style={{ background:'#070D1A', border:'1px solid rgba(99,102,241,0.15)', borderRadius:8, padding:16, color:'#A5B4FC', fontSize:11, overflow:'auto', margin:0, lineHeight:1.6, maxHeight:400 }}>
              {JSON.stringify(testResult, null, 2)}
            </pre>
          </div>
        )}
        <div style={card}>
          <div style={{ color:'#818CF8', fontWeight:700, fontSize:13, marginBottom:10 }}>📌 Mapa de identificadores cadastrados</div>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            {anuncios.length === 0 && <div style={{ color:'#475569', fontSize:12 }}>Nenhum anúncio cadastrado ainda.</div>}
            {anuncios.map(a=>(
              <div key={a.id} style={{ background:'#070D1A', borderRadius:7, padding:'8px 14px', display:'flex', gap:20, flexWrap:'wrap', alignItems:'center' }}>
                <span style={{ color:'#818CF8', fontWeight:700, fontSize:12, minWidth:120 }}>{a.identificador_interno}</span>
                {a.meta_source_id && <span style={{ color:'#64748B', fontSize:11 }}>meta_source_id: <span style={{ color:'#94A3B8' }}>{a.meta_source_id}</span></span>}
                {a.utm_content && <span style={{ color:'#64748B', fontSize:11 }}>utm_content: <span style={{ color:'#94A3B8' }}>{a.utm_content}</span></span>}
                <span style={{ color:'#64748B', fontSize:11, marginLeft:'auto' }}>{a.produto_interno}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const AH_SHEETS_MODELO = [
    {
      tab: 'anuncios', icon: '📢',
      desc: 'Um anúncio por linha. Relaciona o identificador do Meta com o produto interno.',
      cols: [
        ['anuncio_id','string','ID interno único. Ex: sofa-berlin-190-jul26'],
        ['meta_source_id','string','ID do anúncio no Meta — deixar em branco durante testes'],
        ['utm_content','string','Valor de utm_content — deixar em branco durante testes'],
        ['categoria','string','sofas / mesas / cadeiras / poltronas'],
        ['produto_codigo','string','Código interno do produto. Ex: BERLIN-190'],
        ['medida_anunciada_cm','int','Medida do anúncio em centímetros. Ex: 190'],
        ['formato_anunciado','string','reta / L / retratil'],
        ['preco_anunciado','decimal','Preço exibido no anúncio. Ex: 2590.00'],
        ['campanha_id','string','ID da campanha vinculada (opcional)'],
        ['foto_url','string','URL pública da foto do anúncio'],
        ['video_url','string','URL pública do vídeo (opcional)'],
        ['ativo','boolean','true / false'],
        ['ultima_atualizacao','date','Data da última revisão. Ex: 2026-07-10'],
      ],
    },
    {
      tab: 'produtos', icon: '🛋️',
      desc: 'Catálogo completo de produtos. Cada linha é uma variação de medida/formato.',
      cols: [
        ['produto_codigo','string','Chave única. Ex: BERLIN-190'],
        ['modelo','string','Nome comercial. Ex: Berlin'],
        ['categoria','string','sofas / mesas / cadeiras / poltronas'],
        ['medida_cm','int','Medida em centímetros. Ex: 190'],
        ['formato','string','reta / L / retratil'],
        ['preco_base','decimal','Preço sem campanha. Ex: 2590.00'],
        ['tipo_disponibilidade','string','pronta_entrega / encomenda / ambos'],
        ['prazo_producao_dias','int','0 para pronta entrega puro. Ex: 30'],
        ['personalizacao_permitida','boolean','Permite escolher tecido e cor?'],
        ['ativo','boolean','true / false'],
      ],
    },
    {
      tab: 'estoque', icon: '📦',
      desc: 'Itens disponíveis para pronta entrega com cor, tecido e quantidade.',
      cols: [
        ['produto_codigo','string','Referência ao produto. Ex: BERLIN-190'],
        ['cor','string','Ex: Cinza Chumbo'],
        ['tecido','string','Ex: Suede / Linho'],
        ['quantidade','int','Unidades disponíveis. Ex: 2'],
        ['tipo','string','sempre: pronta_entrega'],
      ],
    },
    {
      tab: 'encomendas', icon: '🔖',
      desc: 'Combinações de cor/tecido disponíveis para encomenda.',
      cols: [
        ['produto_codigo','string','Referência ao produto. Ex: BERLIN-190'],
        ['cor','string','Cor disponível para encomenda. Ex: Grafite'],
        ['tecido','string','Tecido disponível. Ex: Suede'],
        ['disponivel','boolean','true / false — se está ativo para pedido'],
      ],
    },
  ];

  const renderModelo = () => (
    <div style={st}>
      <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:18, marginBottom:6 }}>📋 Modelo de Planilha</div>
      <div style={{ color:'#475569', fontSize:12, marginBottom:8, lineHeight:1.7 }}>
        Estrutura exata que a planilha Google Sheets deve ter — 4 abas separadas conforme abaixo.
        Durante o desenvolvimento, os dados das abas <strong style={{ color:'#94A3B8' }}>anuncios</strong> e <strong style={{ color:'#94A3B8' }}>estoque</strong> podem ser cadastrados direto pelo Studio na aba Anúncios.
        Quando vincular a planilha real, configure as URLs na aba Configuração.
      </div>
      <div style={{ ...card, background:'rgba(34,197,94,0.05)', borderColor:'rgba(34,197,94,0.2)', marginBottom:20 }}>
        <div style={{ color:'#4ADE80', fontWeight:700, fontSize:12, marginBottom:4 }}>💡 Como criar a planilha</div>
        <div style={{ color:'#64748B', fontSize:12, lineHeight:1.7 }}>
          1. Crie uma nova planilha no Google Sheets.<br/>
          2. Renomeie a primeira aba para <strong style={{ color:'#94A3B8' }}>anuncios</strong> e crie as abas <strong style={{ color:'#94A3B8' }}>produtos</strong>, <strong style={{ color:'#94A3B8' }}>estoque</strong> e <strong style={{ color:'#94A3B8' }}>encomendas</strong>.<br/>
          3. Copie os cabeçalhos de cada aba abaixo para a primeira linha da aba correspondente.<br/>
          4. Publique a planilha como CSV público (Arquivo → Compartilhar → Publicar na web → CSV).<br/>
          5. Cole as URLs geradas na aba Configuração do Studio.
        </div>
      </div>
      {AH_SHEETS_MODELO.map(s => (
        <div key={s.tab} style={card}>
          <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12 }}>
            <span style={{ fontSize:20 }}>{s.icon}</span>
            <div>
              <span style={{ color:'#818CF8', fontWeight:800, fontSize:14 }}>Aba: {s.tab}</span>
              <div style={{ color:'#64748B', fontSize:12 }}>{s.desc}</div>
            </div>
          </div>
          <div style={{ background:'#070D1A', borderRadius:7, padding:'10px 14px', marginBottom:10, overflowX:'auto' }}>
            <div style={{ color:'#475569', fontSize:10, marginBottom:6, letterSpacing:0.5 }}>CABEÇALHOS (copiar para linha 1):</div>
            <code style={{ color:'#A5B4FC', fontSize:11, whiteSpace:'nowrap' }}>{s.cols.map(c=>c[0]).join(',')}</code>
          </div>
          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:11 }}>
            <thead>
              <tr style={{ borderBottom:'1px solid rgba(99,102,241,0.15)' }}>
                {['Campo','Tipo','Descrição'].map(h=><th key={h} style={{ textAlign:'left', color:'#475569', padding:'4px 8px', fontWeight:600 }}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {s.cols.map(([campo,tipo,desc])=>(
                <tr key={campo} style={{ borderBottom:'1px solid rgba(99,102,241,0.07)' }}>
                  <td style={{ padding:'5px 8px', color:'#818CF8', fontWeight:600, whiteSpace:'nowrap' }}>{campo}</td>
                  <td style={{ padding:'5px 8px', color:'#64748B', whiteSpace:'nowrap' }}>{tipo}</td>
                  <td style={{ padding:'5px 8px', color:'#94A3B8' }}>{desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );

  const TABS = [
    { id:'anuncios',   label:'📢 Anúncios',   count: anuncios.length },
    { id:'campanhas',  label:'🎯 Campanhas',   count: campanhas.filter(c=>c.vigente || c.ativo).length },
    { id:'colchoes',   label:'🛏️ Colchões',    count: null },
    { id:'config',     label:'⚙️ Configuração', count: null },
    { id:'testar',     label:'🧪 Testar',       count: null },
    { id:'modelo',     label:'📋 Modelo de Planilha', count: null },
  ];

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <div style={{ color:'#E2E8F0', fontWeight:900, fontSize:20, marginBottom:4 }}>🧭 Aurora Helper</div>
        <div style={{ color:'#475569', fontSize:13, lineHeight:1.6 }}>
          Camada de serviço de dados da Aurora V2. Centraliza o acesso a anúncios, estoque e campanhas — as Skills consultam apenas a Helper, nunca as fontes diretamente.
        </div>
      </div>
      <div style={{ display:'flex', gap:6, marginBottom:24, borderBottom:'1px solid rgba(99,102,241,0.15)', paddingBottom:0 }}>
        {TABS.map(t => (
          <button key={t.id} onClick={()=>setTab(t.id)} style={{ background:'none', border:'none', borderBottom: tab===t.id ? '2px solid #818CF8' : '2px solid transparent', padding:'8px 18px', color: tab===t.id ? '#818CF8' : '#64748B', cursor:'pointer', fontSize:13, fontWeight: tab===t.id ? 700 : 500, transition:'color .15s' }}>
            {t.label}{t.count != null ? <span style={{ marginLeft:6, background:'rgba(99,102,241,0.15)', borderRadius:20, padding:'1px 7px', fontSize:10, color:'#6366F1' }}>{t.count}</span> : null}
          </button>
        ))}
      </div>
      {tab==='anuncios'  && renderAnuncios()}
      {tab==='campanhas' && renderCampanhas()}
      {tab==='colchoes'  && renderMattressMatrix()}
      {tab==='config'    && renderConfig()}
      {tab==='testar'    && renderTestar()}
      {tab==='modelo'    && renderModelo()}
    </div>
  );
}

// ── FIM AURORA HELPER ─────────────────────────────────────────────────────────

export function AccountPasswordModal({ user, required=false, onClose, onChanged, onLogout }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const isStudioAccount = user?.authKind === 'studio';
  const submit = async (event) => {
    event.preventDefault();
    if (saving || loggingOut) return;
    setSaving(true); setError('');
    try {
      const response = await fetch(isStudioAccount ? '/api/studio/change-password' : '/api/crm/change-password', {
        method:'POST', credentials:'include', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ currentPassword, newPassword, confirmation }),
      });
      const data = await response.json().catch(()=>({}));
      if (!response.ok || !data.ok) setError(data.error || 'Não foi possível alterar a senha.');
      else onChanged?.();
    } catch {
      setError('Erro de rede. Tente novamente.');
    }
    setSaving(false);
  };
  const logout = async () => {
    if (saving || loggingOut || !onLogout) return;
    setLoggingOut(true); setError('');
    try {
      const loggedOut = await onLogout();
      if (loggedOut !== true) throw new Error('Não foi possível encerrar a sessão. Tente novamente.');
    } catch (logoutError) {
      setError(logoutError?.message || 'Não foi possível encerrar a sessão. Tente novamente.');
      setLoggingOut(false);
    }
  };
  const fieldStyle = { width:'100%', boxSizing:'border-box', padding:'10px 12px', borderRadius:8, border:'1px solid #CBD5E1', fontSize:14 };
  return (
    <div style={{ position:'fixed', inset:0, zIndex:10000, background:'rgba(15,23,42,.72)', display:'flex', alignItems:'center', justifyContent:'center', padding:20 }} onClick={()=>!required&&onClose?.()}>
      <form onSubmit={submit} onClick={e=>e.stopPropagation()} style={{ width:'100%', maxWidth:420, background:'#fff', color:'#0F172A', borderRadius:16, padding:28, boxShadow:'0 24px 70px rgba(0,0,0,.35)' }}>
        <div style={{ fontSize:20, fontWeight:800 }}>Minha conta</div>
        <div style={{ fontSize:13, color:'#64748B', margin:'4px 0 20px' }}>
          {required ? 'Troque a senha provisória para continuar.' : 'Altere sua senha sem mudar o usuário de acesso.'}
        </div>
        {[['Senha atual',currentPassword,setCurrentPassword,'current-password'],['Nova senha',newPassword,setNewPassword,'new-password'],['Confirmar nova senha',confirmation,setConfirmation,'new-password']].map(([label,value,setValue,autoComplete])=>(
          <label key={label} style={{ display:'block', fontSize:12, fontWeight:700, marginBottom:12 }}>
            <span style={{ display:'block', marginBottom:5 }}>{label}</span>
            <input type="password" value={value} onChange={e=>{setValue(e.target.value);setError('');}} autoComplete={autoComplete} required style={fieldStyle} />
          </label>
        ))}
        <div style={{ fontSize:11, color:'#64748B', lineHeight:1.5 }}>Mínimo de 10 caracteres, com letra maiúscula, minúscula e número.</div>
        {error && <div role="alert" style={{ color:'#B91C1C', fontSize:13, marginTop:12 }}>{error}</div>}
        <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:20 }}>
          {required && onLogout && <button type="button" aria-label="Sair do depósito" onClick={logout} disabled={saving || loggingOut} style={{ marginRight:'auto', padding:'9px 14px', borderRadius:8, border:'1px solid #CBD5E1', background:'#fff', color:'#0F172A', cursor:saving||loggingOut?'wait':'pointer', opacity:saving||loggingOut?.55:1 }}>{loggingOut?'Saindo…':'Sair'}</button>}
          {!required && <button type="button" onClick={onClose} style={{ padding:'9px 14px', borderRadius:8, border:'1px solid #CBD5E1', background:'#fff', cursor:'pointer' }}>Cancelar</button>}
          <button type="submit" disabled={saving || loggingOut} style={{ padding:'9px 16px', borderRadius:8, border:'none', background:'#4F46E5', color:'#fff', fontWeight:700, cursor:saving||loggingOut?'wait':'pointer', opacity:saving||loggingOut?.7:1 }}>{saving?'Salvando…':'Alterar senha'}</button>
        </div>
      </form>
    </div>
  );
}

function CrmPasswordResetPanel({ onClose, apiBase='/api/studio', exactConfirmation=false }) {
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [temporaryPassword, setTemporaryPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);
  const usersEndpoint = apiBase==='/api/crm/admin' ? '/api/crm/admin/users' : '/api/studio/crm-users';
  const resetEndpoint = `${usersEndpoint}/reset-password`;
  useEffect(() => {
    fetch(usersEndpoint, { credentials:'include' })
      .then(async response => ({ response, data:await response.json().catch(()=>({})) }))
      .then(({ response, data }) => {
        if (!response.ok || !data.ok) throw new Error(data.error || 'Não foi possível carregar os usuários.');
        setUsers(Array.isArray(data.users) ? data.users : []);
      })
      .catch(err=>setError(err.message || 'Erro de rede ao carregar usuários.'))
      .finally(()=>setLoading(false));
  }, [usersEndpoint]);
  const reset = async event => {
    event.preventDefault();
    if (!selected || (exactConfirmation ? confirmation!==selected : confirmation.trim().toLowerCase()!==selected) || saving) return;
    setSaving(true); setError(''); setTemporaryPassword(''); setCopied(false);
    try {
      const response = await fetch(resetEndpoint, {
        method:'POST', credentials:'include', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ username:selected, confirmation }),
      });
      const data = await response.json().catch(()=>({}));
      if (!response.ok || !data.ok) throw new Error(data.error || 'Não foi possível redefinir a senha.');
      setTemporaryPassword(data.temporaryPassword);
      setConfirmation('');
    } catch (err) { setError(err.message || 'Erro de rede ao redefinir a senha.'); }
    setSaving(false);
  };
  const copyTemporaryPassword = async () => {
    try { await navigator.clipboard.writeText(temporaryPassword); setCopied(true); }
    catch { setError('Não foi possível copiar. Copie a senha manualmente.'); }
  };
  const selectedUser = users.find(user=>user.username===selected);
  const inputStyle = { width:'100%', boxSizing:'border-box', padding:'10px 12px', borderRadius:8, border:'1px solid #334155', background:'#0F172A', color:'#E2E8F0', fontSize:14 };
  return (
    <div style={{ background:'#111827', border:'1px solid rgba(248,113,113,.35)', borderRadius:14, padding:'clamp(16px,4vw,24px)', maxWidth:560 }}>
      <div style={{ display:'flex', alignItems:'flex-start', gap:12, marginBottom:16 }}>
        <span style={{ fontSize:24 }}>🔐</span>
        <div style={{ flex:1 }}>
          <div style={{ color:'#F8FAFC', fontWeight:800, fontSize:18 }}>Redefinir senha do CRM</div>
          <div style={{ color:'#94A3B8', fontSize:12, lineHeight:1.5, marginTop:3 }}>As senhas existentes permanecem inalteradas até você selecionar e confirmar uma única conta abaixo.</div>
        </div>
        <button onClick={onClose} style={{ background:'none', border:'none', color:'#94A3B8', cursor:'pointer', fontSize:18 }} aria-label="Fechar">×</button>
      </div>
      {temporaryPassword ? (
        <div style={{ background:'rgba(34,197,94,.1)', border:'1px solid rgba(34,197,94,.35)', borderRadius:10, padding:15 }}>
          <div style={{ color:'#86EFAC', fontWeight:800, fontSize:13 }}>Senha provisória — exibida somente agora</div>
          <div style={{ color:'#F8FAFC', fontFamily:'monospace', fontSize:16, wordBreak:'break-all', margin:'10px 0' }}>{temporaryPassword}</div>
          <button onClick={copyTemporaryPassword} style={{ background:'#166534', border:'none', borderRadius:7, padding:'8px 12px', color:'#fff', cursor:'pointer', fontWeight:700, fontSize:12 }}>{copied ? 'Copiada' : 'Copiar senha'}</button>
          <div style={{ color:'#BBF7D0', fontSize:11, lineHeight:1.45, marginTop:10 }}>Envie-a com segurança. A conta deverá trocar esta senha no próximo acesso; apenas as sessões desta conta foram encerradas.</div>
        </div>
      ) : (
        <form onSubmit={reset}>
          <label style={{ display:'block', color:'#CBD5E1', fontSize:12, fontWeight:700, marginBottom:12 }}>Conta CRM
            <select value={selected} onChange={e=>{setSelected(e.target.value);setConfirmation('');setError('');}} disabled={loading} style={{ ...inputStyle, marginTop:5 }}>
              <option value="">{loading ? 'Carregando…' : 'Selecione uma conta'}</option>
              {users.map(user=><option key={user.username} value={user.username}>{user.username} · {user.role}{user.storeId ? ` · Loja ${user.storeId}` : Array.isArray(user.storeIds) && user.storeIds.length ? ` · Lojas ${user.storeIds.join(", ")}` : ''}</option>)}
            </select>
          </label>
          {selectedUser && <label style={{ display:'block', color:'#CBD5E1', fontSize:12, fontWeight:700, marginBottom:12 }}>Para confirmar, digite <strong>{selectedUser.username}</strong>
            <input value={confirmation} onChange={e=>{setConfirmation(e.target.value);setError('');}} autoComplete="off" style={{ ...inputStyle, marginTop:5 }} />
          </label>}
          {error && <div style={{ color:'#FCA5A5', fontSize:12, marginBottom:10 }}>{error}</div>}
          <button type="submit" disabled={!selected || (exactConfirmation ? confirmation!==selected : confirmation.trim().toLowerCase()!==selected) || saving} style={{ width:'100%', padding:'10px 12px', border:0, borderRadius:8, background:'#B91C1C', color:'#fff', cursor:'pointer', fontWeight:800, opacity:(!selected || (exactConfirmation ? confirmation!==selected : confirmation.trim().toLowerCase()!==selected) || saving)?.55:1 }}>
            {saving ? 'Redefinindo…' : 'Confirmar redefinição'}
          </button>
        </form>
      )}
    </div>
  );
}

function ArFlowStudioView({ onLogout, mustChangePassword=false }) {
  const [accountOpen, setAccountOpen] = useState(mustChangePassword);
  const [activeModule, setActiveModule] = useState(null);
  const [activeAurora, setActiveAurora] = useState(null);
  const [activeSection, setActiveSection] = useState(null);
  const [showAudit, setShowAudit] = useState(false);
  const [showCrmPasswordReset, setShowCrmPasswordReset] = useState(false);
  const [auroras, setAuroras] = useState([]);
  const [baseSkills, setBaseSkills] = useState([]);
  const [auditLog, setAuditLog] = useState([]);
  const [auroraModal, setAuroraModal] = useState(null);

  const reloadAuroras = () => {
    studioFetch('arflow_studio/auroras').then(r=>r.json())
      .then(d => {
        if (!d) { setAuroras(INITIAL_AURORAS); return; }
        const list = Object.entries(d).map(([id,v])=>({ id, ...v }));
        list.sort((a,b)=>(a.order||99)-(b.order||99));
        setAuroras(list);
      }).catch(()=>setAuroras(INITIAL_AURORAS));
  };

  const reloadBaseSkills = () => {
    studioFetch('arflow_studio/base_skills').then(r=>r.json())
      .then(d => {
        if (!d) { setBaseSkills([]); return; }
        const list = Object.entries(d).map(([id,v])=>({ id, ...v })).sort((a,b)=>(a.name||'').localeCompare(b.name||''));
        setBaseSkills(list);
      }).catch(()=>{});
  };

  useEffect(() => {
    reloadAuroras();
    reloadBaseSkills();
    studioFetch('arflow_studio/audit').then(r=>r.json())
      .then(d => {
        if (!d) return;
        setAuditLog(Object.values(d).sort((a,b)=>b.at.localeCompare(a.at)).slice(0,50));
      }).catch(()=>{});
  }, []);

  const logAccess = (action) => {
    studioFetch('arflow_studio/audit', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ action, at:new Date().toISOString() }),
    }).catch(()=>{});
  };

  const handleBack = () => {
    if (activeSection) { setActiveSection(null); return; }
    if (activeAurora)  { setActiveAurora(null);  return; }
    if (activeModule)  { setActiveModule(null); setShowAudit(false); return; }
  };

  const breadcrumb = [
    showAudit && 'Auditoria',
    activeModule && activeModule.title,
    activeAurora && activeAurora.name,
    activeSection && activeSection.title,
  ].filter(Boolean);

  const saveAurora = (formData, id) => {
    const isEdit = !!id;
    const path = isEdit
      ? `arflow_studio/auroras/${id}`
      : 'arflow_studio/auroras';
    const method = isEdit ? 'PATCH' : 'POST';
    const payload = { ...formData, updated_at: new Date().toISOString(), ...(isEdit?{}:{ created_at:new Date().toISOString(), order: auroras.length+1 }) };
    return studioFetch(path, { method, headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload) })
      .then(()=>{ setAuroraModal(null); reloadAuroras(); });
  };

  const changeAuroraStatus = (aurora, newStatus) => {
    studioFetch(`arflow_studio/auroras/${aurora.id}`, {
      method:'PATCH', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ status:newStatus, updated_at:new Date().toISOString() }),
    }).then(reloadAuroras).catch(()=>{});
  };

  const hBtn = (variant) => {
    const v = { default:{bg:'rgba(99,102,241,0.1)',bd:'rgba(99,102,241,0.3)',c:'#818CF8'}, danger:{bg:'rgba(239,68,68,0.1)',bd:'rgba(239,68,68,0.3)',c:'#F87171'} };
    const s = v[variant]||v.default;
    return { background:s.bg, border:`1px solid ${s.bd}`, borderRadius:7, padding:'5px 14px', color:s.c, cursor:'pointer', fontSize:12, fontWeight:600 };
  };
  const cardBase = { background:'#111827', border:'1px solid rgba(99,102,241,0.2)', borderRadius:14, padding:22, cursor:'pointer', display:'flex', flexDirection:'column', gap:8 };
  const sectionBox = { background:'#111827', border:'1px solid rgba(99,102,241,0.18)', borderRadius:14, padding:28 };

  const renderSection = () => {
    const sec = activeSection;
    const aurora = activeAurora;
    const sectionContent = () => {
      if (sec.id === 'identidade') return <AuroraIdentidadeEditor aurora={aurora} />;
      if (sec.id === 'skills')     return <AuroraSkillsEditor aurora={aurora} baseSkills={baseSkills} />;
      const PLACEHOLDERS = {
        fluxo:       'Descreva o fluxo de conversação desta Aurora: etapas, gatilhos e transições…',
        integracoes: 'Liste as integrações ativas: Z-API, Firebase, n8n, webhooks…\n\nFormato sugerido:\n- Z-API: [URL e config]\n- Firebase: [nó utilizado]\n- n8n: [endpoint e fluxo]',
        testes:      'Cenários de teste:\n\n1. Gatilho: [descrição]\n   Esperado: [resultado]\n   Status: ✅/❌',
        evolucao:    'Changelog:\n\nv1.0 (DD/MM/AAAA)\n- Primeira versão em produção\n\nv1.1 (DD/MM/AAAA)\n- …',
        docs:        'Documentação técnica completa desta Aurora:\n\n## Visão Geral\n…\n\n## Como usar\n…',
      };
      return <StudioMarkdownEditor fbPath={`arflow_studio/auroras/${aurora.id}/${sec.id}/data`} placeholder={PLACEHOLDERS[sec.id]||'Digite o conteúdo…'} minH={280} />;
    };
    return (
      <div style={sectionBox}>
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:22 }}>
          <span style={{ fontSize:24 }}>{sec.icon}</span>
          <div>
            <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:17 }}>{sec.title}</div>
            <div style={{ color:'#475569', fontSize:12 }}>{sec.desc}</div>
          </div>
        </div>
        {sectionContent()}
      </div>
    );
  };

  const renderAurora = () => {
    const st = AURORA_STATUS[activeAurora.status] || AURORA_STATUS.planejamento;
    return (
      <div>
        <div style={{ background:'#111827', border:'1px solid rgba(99,102,241,0.2)', borderRadius:14, padding:24, marginBottom:22, display:'flex', gap:18, alignItems:'center' }}>
          <div style={{ fontSize:44 }}>{activeAurora.icon}</div>
          <div style={{ flex:1 }}>
            <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:20, marginBottom:5 }}>{activeAurora.name}</div>
            <div style={{ color:'#64748B', fontSize:13, lineHeight:1.5, marginBottom:10 }}>{activeAurora.desc}</div>
            <div style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap' }}>
              <span style={{ background:st.bg, color:st.color, border:`1px solid ${st.color}44`, borderRadius:20, padding:'3px 12px', fontSize:12, fontWeight:700 }}>{st.label}</span>
              <select value={activeAurora.status} onChange={e=>{ changeAuroraStatus(activeAurora, e.target.value); setActiveAurora(a=>({...a, status:e.target.value})); }}
                style={{ background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.12)', borderRadius:6, padding:'4px 10px', color:'#64748B', cursor:'pointer', fontSize:11, outline:'none' }}>
                {Object.entries(AURORA_STATUS).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}
              </select>
              <button onClick={()=>setAuroraModal({ mode:'edit', data:activeAurora })}
                style={{ background:'rgba(99,102,241,0.08)', border:'1px solid rgba(99,102,241,0.2)', borderRadius:6, padding:'4px 12px', color:'#818CF8', cursor:'pointer', fontSize:11, fontWeight:700 }}>✏️ Editar</button>
            </div>
          </div>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))', gap:12 }}>
          {AURORA_SECTIONS.map(sec => (
            <div key={sec.id} style={{ ...cardBase, padding:20 }}
              onClick={()=>{ setActiveSection(sec); logAccess(`${activeAurora.id}_${sec.id}`); }}
              onMouseEnter={e=>{e.currentTarget.style.borderColor='rgba(99,102,241,0.5)';e.currentTarget.style.background='#141f35';}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor='rgba(99,102,241,0.2)';e.currentTarget.style.background='#111827';}}>
              <div style={{ fontSize:24 }}>{sec.icon}</div>
              <div style={{ color:'#E2E8F0', fontWeight:700, fontSize:14 }}>{sec.title}</div>
              <div style={{ color:'#64748B', fontSize:12, lineHeight:1.4 }}>{sec.desc}</div>
              <span style={{ alignSelf:'flex-start', background:'rgba(99,102,241,0.08)', color:'#6366F1', border:'1px solid rgba(99,102,241,0.18)', borderRadius:20, padding:'1px 9px', fontSize:10 }}>→ Abrir</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderAurorasList = () => (
    <div>
      <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:20 }}>
        <div style={{ flex:1 }}>
          <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:20, marginBottom:3 }}>🤖 Auroras</div>
          <div style={{ color:'#475569', fontSize:13 }}>Todos os agentes de IA da AR Flow. {auroras.length} agente{auroras.length!==1?'s':''} cadastrado{auroras.length!==1?'s':''}.</div>
        </div>
        <button onClick={()=>setAuroraModal({ mode:'add', data:null })}
          style={{ background:'rgba(99,102,241,0.15)', border:'1px solid rgba(99,102,241,0.4)', borderRadius:8, padding:'8px 16px', color:'#818CF8', cursor:'pointer', fontSize:13, fontWeight:700 }}>
          + Nova Aurora
        </button>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))', gap:16 }}>
        {auroras.map(aurora => {
          const st = AURORA_STATUS[aurora.status] || AURORA_STATUS.planejamento;
          return (
            <div key={aurora.id} style={{ ...cardBase, padding:24, gap:12 }}
              onClick={()=>{ setActiveAurora(aurora); logAccess(aurora.id); }}
              onMouseEnter={e=>{e.currentTarget.style.borderColor='rgba(99,102,241,0.55)';e.currentTarget.style.background='#141f35';}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor='rgba(99,102,241,0.2)';e.currentTarget.style.background='#111827';}}>
              <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                <div style={{ fontSize:34 }}>{aurora.icon}</div>
                <div style={{ flex:1 }}>
                  <div style={{ color:'#E2E8F0', fontWeight:700, fontSize:15, marginBottom:4 }}>{aurora.name}</div>
                  <span style={{ background:st.bg, color:st.color, border:`1px solid ${st.color}44`, borderRadius:20, padding:'2px 10px', fontSize:11, fontWeight:700 }}>{st.label}</span>
                </div>
              </div>
              <div style={{ color:'#64748B', fontSize:12, lineHeight:1.5 }}>{aurora.desc}</div>
              <div style={{ display:'flex', gap:5, flexWrap:'wrap' }}>
                {AURORA_SECTIONS.map(s => (
                  <span key={s.id} style={{ background:'rgba(255,255,255,0.04)', color:'#475569', border:'1px solid rgba(255,255,255,0.08)', borderRadius:6, padding:'1px 7px', fontSize:10 }}>{s.icon} {s.title}</span>
                ))}
              </div>
            </div>
          );
        })}
        <div style={{ ...cardBase, padding:24, gap:10, border:'1px dashed rgba(99,102,241,0.2)', opacity:0.6 }}
          onClick={()=>setAuroraModal({ mode:'add', data:null })}>
          <div style={{ fontSize:32 }}>➕</div>
          <div style={{ color:'#475569', fontWeight:700, fontSize:14 }}>Nova Aurora</div>
          <div style={{ color:'#334155', fontSize:12 }}>Adicionar um novo agente de IA ao Studio.</div>
        </div>
      </div>
    </div>
  );

  const renderGenericModule = (mod) => (
    <div style={sectionBox}>
      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:22 }}>
        <span style={{ fontSize:28 }}>{mod.icon}</span>
        <div>
          <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:18 }}>{mod.title}</div>
          <div style={{ color:'#475569', fontSize:13 }}>{mod.desc}</div>
        </div>
      </div>
      <StudioMarkdownEditor
        fbPath={`arflow_studio/modules/${mod.id}/data`}
        placeholder={`Conteúdo do módulo ${mod.title}. Suporte a texto livre, markdown, listas e prompts.`}
        minH={320}
      />
    </div>
  );

  const renderModule = () => {
    const mod = activeModule;
    if (mod.id === 'auroras') {
      if (activeAurora) return activeSection ? renderSection() : renderAurora();
      return renderAurorasList();
    }
    if (mod.id === 'base-skills')   return <BaseSkillsModule key="base-skills" />;
    if (mod.id === 'aurora-helper') return <AuroraHelperModule key="aurora-helper" />;
    return renderGenericModule(mod);
  };

  const renderAudit = () => (
    <div>
      <div style={{ color:'#818CF8', fontWeight:700, fontSize:16, marginBottom:16 }}>
        🔍 Log de Auditoria <span style={{ color:'#475569', fontSize:12, fontWeight:400 }}>— últimas 50 entradas</span>
      </div>
      {auditLog.length===0
        ? <div style={{ color:'#475569', fontSize:13 }}>Nenhum registro encontrado.</div>
        : <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
            {auditLog.map((e,i) => (
              <div key={i} style={{ background:'#111827', border:'1px solid rgba(99,102,241,0.1)', borderRadius:8, padding:'9px 16px', display:'flex', gap:20, alignItems:'center' }}>
                <span style={{ color:'#6366F1', fontSize:13, fontWeight:700, minWidth:220 }}>{e.action}</span>
                <span style={{ color:'#64748B', fontSize:12 }}>{e.at ? new Date(e.at).toLocaleString('pt-BR') : '—'}</span>
              </div>
            ))}
          </div>
      }
    </div>
  );

  return (
    <div style={{ minHeight:'100vh', background:'#070D1A', fontFamily:"'Inter',system-ui,sans-serif", color:'#E2E8F0' }}>
      <div style={{ background:'linear-gradient(135deg,#0F172A,#1A1040)', padding:'8px clamp(12px,4vw,24px)', borderBottom:'1px solid rgba(99,102,241,0.2)', display:'flex', flexWrap:'wrap', alignItems:'center', minHeight:60, gap:10, position:'sticky', top:0, zIndex:50 }}>
        <div style={{ flex:'1 1 220px', minWidth:0, display:'flex', alignItems:'center', gap:12 }}>
          <span style={{ fontSize:22 }}>🔮</span>
          <div style={{ minWidth:0 }}>
            <div style={{ color:'#818CF8', fontWeight:900, fontSize:14, letterSpacing:3, fontFamily:"Georgia,serif" }}>AR FLOW STUDIO</div>
            {breadcrumb.length>0
              ? <div style={{ color:'#475569', fontSize:10, letterSpacing:0.5 }}>{breadcrumb.join(' › ')}</div>
              : <div style={{ color:'#334155', fontSize:10, letterSpacing:1 }}>AMBIENTE INTERNO — ACESSO EXCLUSIVO AR FLOW</div>
            }
          </div>
        </div>
        <div style={{ display:'flex', flex:'0 1 auto', flexWrap:'wrap', justifyContent:'flex-end', gap:8 }}>
          <button onClick={()=>setAccountOpen(true)} style={hBtn('default')}>Minha conta</button>
          <button onClick={()=>setShowCrmPasswordReset(s=>!s)} title="Redefinir senhas do CRM" style={hBtn('default')}>🔐 CRM</button>
          <button onClick={()=>{setShowAudit(s=>!s);setActiveModule(null);setActiveAurora(null);setActiveSection(null);}} style={hBtn('default')}>🔍 Auditoria</button>
          <button onClick={onLogout} style={hBtn('danger')}>Sair</button>
        </div>
      </div>
      {accountOpen && <AccountPasswordModal user={SUPERADMIN_USER} required={mustChangePassword} onClose={()=>setAccountOpen(false)} onChanged={()=>setAccountOpen(false)} />}

      <div style={{ maxWidth:1140, margin:'0 auto', padding:'28px 20px' }}>
        {(activeModule || showAudit) && (
          <button onClick={handleBack} style={{ background:'none', border:'none', color:'#818CF8', cursor:'pointer', fontSize:13, fontWeight:600, marginBottom:20, padding:0, display:'flex', alignItems:'center', gap:6 }}>
            ← Voltar
          </button>
        )}

        {showAudit && renderAudit()}
        {!showAudit && showCrmPasswordReset && <div style={{ marginBottom:24 }}><CrmPasswordResetPanel onClose={()=>setShowCrmPasswordReset(false)} /></div>}
        {!showAudit && activeModule && renderModule()}

        {!showAudit && !activeModule && (
          <>
            <div style={{ marginBottom:28 }}>
              <div style={{ color:'#E2E8F0', fontWeight:800, fontSize:22, marginBottom:4 }}>Bem-vinda ao Studio 🔮</div>
              <div style={{ color:'#475569', fontSize:14 }}>Ambiente interno exclusivo da AR Flow. Todo o conteúdo é salvo no Firebase.</div>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(240px,1fr))', gap:16 }}>
              {STUDIO_MODULES.map(mod => {
                const isAuroras = mod.id==='auroras';
                const isSkills  = mod.id==='base-skills';
                return (
                  <div key={mod.id} style={cardBase}
                    onClick={()=>{ setActiveModule(mod); setActiveAurora(null); setActiveSection(null); logAccess(mod.id); }}
                    onMouseEnter={e=>{e.currentTarget.style.borderColor='rgba(99,102,241,0.55)';e.currentTarget.style.background='#141f35';}}
                    onMouseLeave={e=>{e.currentTarget.style.borderColor='rgba(99,102,241,0.2)';e.currentTarget.style.background='#111827';}}>
                    <div style={{ fontSize:30 }}>{mod.icon}</div>
                    <div style={{ color:'#E2E8F0', fontWeight:700, fontSize:15 }}>{mod.title}</div>
                    <div style={{ color:'#64748B', fontSize:12, lineHeight:1.5 }}>{mod.desc}</div>
                    {isAuroras && (
                      <div style={{ display:'flex', gap:5, flexWrap:'wrap', marginTop:2 }}>
                        {auroras.slice(0,4).map(a => {
                          const st = AURORA_STATUS[a.status]||AURORA_STATUS.planejamento;
                          return <span key={a.id} style={{ background:st.bg, color:st.color, border:`1px solid ${st.color}44`, borderRadius:20, padding:'1px 8px', fontSize:10, fontWeight:700 }}>{a.icon} {(a.name||'').replace('Aurora ','')}</span>;
                        })}
                      </div>
                    )}
                    {isSkills && (
                      <span style={{ alignSelf:'flex-start', background:'rgba(245,158,11,0.1)', color:'#F59E0B', border:'1px solid rgba(245,158,11,0.3)', borderRadius:20, padding:'2px 10px', fontSize:11, fontWeight:700 }}>
                        {baseSkills.length} skill{baseSkills.length!==1?'s':''} cadastrada{baseSkills.length!==1?'s':''}
                      </span>
                    )}
                    {!isAuroras && !isSkills && (
                      <span style={{ alignSelf:'flex-start', background:'rgba(99,102,241,0.08)', color:'#6366F1', border:'1px solid rgba(99,102,241,0.18)', borderRadius:20, padding:'2px 10px', fontSize:11, fontWeight:600 }}>→ Abrir</span>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>

      {auroraModal && (
        <AuroraFormModal
          mode={auroraModal.mode}
          data={auroraModal.data}
          onClose={()=>setAuroraModal(null)}
          onSave={saveAurora}
        />
      )}
    </div>
  );
}

function MarketingIntelligenceView({ user, onLogout, onOpenConversation, onOpenSafetyAlerts }) {
  const today = new Date().toLocaleDateString('en-CA', { timeZone:'America/Sao_Paulo' });
  const [filters,setFilters] = useState({ start:today, end:today, storeId:'', consultantId:'', campaign:'', origin:'', ad:'', category:'' });
  const [report,setReport] = useState(null), [loading,setLoading] = useState(true), [error,setError] = useState('');
  const [view,setView] = useState('Geral'), [question,setQuestion] = useState(''), [answer,setAnswer] = useState(''), [asking,setAsking] = useState(false), [detail,setDetail] = useState(null);
  const [passwordResetOpen, setPasswordResetOpen] = useState(false);
  const canResetPasswords = user?.capabilities?.includes('crm_user_password_reset');
  const money = value => value === null || value === undefined || value === '' ? 'Indisponível' : Number(value).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
  const count = value => value === null || value === undefined ? '—' : Number(value).toLocaleString('pt-BR');
  const load = useCallback(async () => {
    setLoading(true); setError('');
    try { const query = new URLSearchParams(Object.entries(filters).filter(([,v])=>v)); const response = await fetch(`/api/crm/marketing-intelligence?${query}`,{credentials:'include'}); const data=await response.json().catch(()=>({}));
      if(!response.ok) throw new Error(data.error || 'Não foi possível carregar o relatório.'); setReport(data);
    } catch(err) { setError(err.message || 'Não foi possível carregar o relatório.'); } finally { setLoading(false); }
  },[filters]);
  useEffect(()=>{load();},[load]);
  useEffect(()=>watchVisiblePolling(load,60000,{initial:false,pauseWhenIdle:true}),[load]);
  const applyPreset = preset => { const end=today, d=new Date(`${today}T12:00:00`); if(preset==='today') setFilters(f=>({...f,start:end,end})); else if(preset==='yesterday'){d.setDate(d.getDate()-1);const day=d.toLocaleDateString('en-CA');setFilters(f=>({...f,start:day,end:day}));} else if(preset==='7d'){d.setDate(d.getDate()-6);setFilters(f=>({...f,start:d.toLocaleDateString('en-CA'),end}));} else if(preset==='month') setFilters(f=>({...f,start:`${today.slice(0,7)}-01`,end})); };
  const records=useMemo(()=>report?.records||{},[report]), summary={...(report?.summary||{}),auroraConversion:report?.summary?.leadEntries?report.summary.salesCount/report.summary.leadEntries*100:null}, contactKey=r=>`${r.storeId||''}:${normalizePhone(r.phone)||r.id}`;
  const stages=[['Leads',records.leadEntries||[]],['Atendidos',[...(records.firstResponses||[]),...(records.effectiveHumanServices||[])]],['Qualificados',records.qualified||[]],['Visitas reais',records.visits||[]],['Vendas',records.sales||[]]];
  const all = Object.values(records).flatMap(v=>Array.isArray(v)?v:[]);
  const options=key=>[...new Set(all.map(r=>r?.[key]).filter(v=>v && !String(v).startsWith('Não inform')))].sort();
  const grouped=useMemo(()=>{const map=new Map(); const add=(kind,r)=>{const key=`${r.campaign||'Não informada'}|||${r.ad||r.adId||'Não informado'}`;const g=map.get(key)||{campaign:r.campaign||'Não informada',ad:r.ad||r.adId||'Não informado',leads:new Map(),attended:new Map(),qualified:new Map(),visits:new Map(),sales:new Map(),revenue:0,quality:r.attributionQuality};g[kind].set(contactKey(r),r);if(kind==='sales')g.revenue+=Number(r.value||0);map.set(key,g);};(records.leadEntries||[]).forEach(r=>add('leads',r));[...(records.firstResponses||[]),...(records.effectiveHumanServices||[])].forEach(r=>add('attended',r));(records.qualified||[]).forEach(r=>add('qualified',r));(records.visits||[]).forEach(r=>add('visits',r));(records.sales||[]).forEach(r=>add('sales',r));return [...map.values()].map(g=>({...g,leads:g.leads.size,attended:g.attended.size,qualified:g.qualified.size,visits:g.visits.size,sales:g.sales.size,ticket:g.sales.size?g.revenue/g.sales.size:null,conversion:g.leads?g.sales.size/g.leads*100:null,records:[...g.sales.values()]})).sort((a,b)=>b.revenue-a.revenue);},[records]);
  const stageFor = record => {
    const key=contactKey(record);
    if((records.sales||[]).some(r=>contactKey(r)===key)) return 'Venda';
    if((records.visits||[]).some(r=>contactKey(r)===key)) return 'Visita real';
    if((records.qualified||[]).some(r=>contactKey(r)===key)) return 'Qualificado';
    if((records.effectiveHumanServices||[]).some(r=>contactKey(r)===key)||(records.firstResponses||[]).some(r=>contactKey(r)===key)) return 'Atendido';
    return 'Lead';
  };
  const journeyFor = record => (records.journeys||[]).find(item=>item.storeId===record.storeId&&normalizePhone(item.phone)===normalizePhone(record.phone));
  const campaignRows = useMemo(()=>{const map=new Map();grouped.forEach(row=>{const g=map.get(row.campaign)||{name:row.campaign,leads:0,attended:0,qualified:0,visits:0,sales:0,revenue:0,records:[]};['leads','attended','qualified','visits','sales'].forEach(k=>g[k]+=row[k]);g.revenue+=row.revenue;g.records.push(...row.records);map.set(row.campaign,g);});return [...map.values()].map(g=>({...g,conversion:g.leads?g.sales/g.leads*100:null,ticket:g.sales?g.revenue/g.sales:null}));},[grouped]);
  const storeRows = report?.comparisons?.stores||[];
  const leadRows = records.leadEntries||[];
  const salesRows = records.sales||[];
  const viewRows = view==='Campanha'?campaignRows:view==='Anuncio'?grouped:view==='Loja'?storeRows:view==='Venda'?salesRows:leadRows;
  const styles={page:{minHeight:'100vh',background:'#eef2f3',color:'#152331',fontFamily:"'DM Sans',system-ui,sans-serif"},card:{background:'#fbfcfa',border:'1px solid #d6dfdc',borderRadius:12,padding:18,boxShadow:'0 5px 18px rgba(22,43,48,.05)'},field:{padding:'9px 10px',borderRadius:7,border:'1px solid #c8d4d1',background:'#fff',color:'#152331',fontSize:12,minWidth:126}};
  const badge=(quality)=>{const map={confirmed:['Confirmada','#d7f0e3','#17613e'],reported:['Reportada','#fff0c9','#8a5a00'],legacy:['Legado','#e9edf0','#53636b'],legacy_or_not_captured:['Não capturada','#e9edf0','#53636b'],ambiguous:['Ambígua','#ffe0d1','#9a432c'],unidentified:['Não identificada','#ffe0d1','#9a432c']};const [label,bg,color]=map[quality]||map.unidentified;return <span style={{background:bg,color,borderRadius:20,padding:'3px 8px',fontSize:10,fontWeight:800}}>{label}</span>;};
  const askAI=async()=>{if(!question.trim())return;setAsking(true);setAnswer('');try{const response=await fetch('/api/crm/marketing-intelligence/ai',{method:'POST',credentials:'include',headers:{'Content-Type':'application/json'},body:JSON.stringify({start:filters.start,end:filters.end,storeId:filters.storeId,consultantId:filters.consultantId,origin:filters.origin,campaign:filters.campaign,ad:filters.ad,category:filters.category,question})});const data=await response.json();if(!response.ok)throw new Error(data.error||'Não foi possível consultar a IA.');setAnswer(data.answer||data.response||'Sem resposta disponível.');}catch(err){setAnswer(err.message);}finally{setAsking(false);}};
  const metric=(label,value,detail)=> <div style={styles.card}><div style={{fontSize:11,fontWeight:800,color:'#63747a',textTransform:'uppercase',letterSpacing:.5}}>{label}</div><div style={{fontSize:23,fontWeight:900,marginTop:7,color:'#153c3d'}}>{value}</div>{detail&&<div style={{fontSize:10,color:'#718086',marginTop:5}}>{detail}</div>}</div>;
  return <div style={styles.page}><header style={{background:'#153c3d',color:'#f6f2e8',padding:'20px clamp(15px,4vw,42px)',display:'flex',justifyContent:'space-between',alignItems:'center',gap:15,flexWrap:'wrap'}}><div><div style={{fontSize:10,letterSpacing:2,fontWeight:900,color:'#b5d9c7'}}>AR FLOW / SUPERADMIN</div><h1 style={{fontSize:25,margin:'5px 0 3px',letterSpacing:-.7}}>Marketing Intelligence</h1><div style={{fontSize:12,color:'#c6dbd5'}}>Evidência real do primeiro contato ao valor vendido.</div></div><div style={{display:'flex',alignItems:'center',gap:12,fontSize:12}}><span>{user?.name}</span>
      {onOpenSafetyAlerts && <button type="button" onClick={onOpenSafetyAlerts}
        style={{border:'1px solid #79a89b',background:'transparent',color:'#f6f2e8',borderRadius:7,padding:'8px 12px',cursor:'pointer'}}>
        Alertas do WhatsApp
      </button>}
      {canResetPasswords&&<button onClick={()=>setPasswordResetOpen(true)} style={{border:'1px solid #79a89b',background:'transparent',color:'#f6f2e8',borderRadius:7,padding:'8px 12px',cursor:'pointer'}}>🔐 Usuários CRM</button>}<button onClick={onLogout} style={{border:'1px solid #79a89b',background:'transparent',color:'#f6f2e8',borderRadius:7,padding:'8px 12px',cursor:'pointer'}}>Sair</button></div></header>
    <main style={{maxWidth:1380,margin:'0 auto',padding:'18px clamp(12px,3vw,30px) 45px'}}><section style={{...styles.card,marginBottom:14}}><div style={{display:'flex',gap:7,flexWrap:'wrap',marginBottom:14}}>{[['today','Hoje'],['yesterday','Ontem'],['7d','7 dias'],['month','Mês atual']].map(([key,label])=><button key={key} onClick={()=>applyPreset(key)} style={{border:'1px solid #b8ccc6',background:'#e5f0eb',color:'#20564d',borderRadius:20,padding:'7px 12px',fontSize:11,fontWeight:800,cursor:'pointer'}}>{label}</button>)}</div><div style={{display:'flex',flexWrap:'wrap',gap:9,alignItems:'flex-end'}}>{[['start','Início'],['end','Fim']].map(([key,label])=><label key={key} style={{fontSize:11,fontWeight:800}}>{label}<input type="date" value={filters[key]} onChange={e=>setFilters({...filters,[key]:e.target.value})} style={{...styles.field,display:'block',marginTop:4}}/></label>)}{[['storeId','Loja',STORES],['consultantId','Consultor',USERS.filter(u=>u.role==='consultant'&&(!filters.storeId||Number(filters.storeId)===u.storeId))],['campaign','Campanha',options('campaign')],['origin','Origem',options('source')],['ad','Anúncio',options('ad')],['category','Categoria',options('category')]].map(([key,label,list])=><label key={key} style={{fontSize:11,fontWeight:800}}>{label}<select value={filters[key]} onChange={e=>setFilters({...filters,[key]:e.target.value,...key==='storeId'?{consultantId:''}:{}})} style={{...styles.field,display:'block',marginTop:4}}><option value="">Todos</option>{list.map(item=><option key={item.id||item} value={item.id||item}>{item.name||item}</option>)}</select></label>)}<button onClick={load} style={{border:0,borderRadius:7,padding:'10px 15px',background:'#d97952',color:'#fff',fontWeight:900,cursor:'pointer'}}>Atualizar</button></div></section>
      {error&&<div role="alert" style={{background:'#fff0ec',border:'1px solid #e6a18b',color:'#8f3827',padding:13,borderRadius:9,marginBottom:14}}>{error} <button onClick={load} style={{marginLeft:8}}>Tentar novamente</button></div>}
      <nav style={{display:'flex',gap:3,overflowX:'auto',borderBottom:'1px solid #cbd8d4',marginBottom:16}}>{['Geral','Loja','Campanha','Anuncio','Lead','Venda'].map(item=><button key={item} onClick={()=>setView(item)} style={{border:0,borderBottom:view===item?'3px solid #d97952':'3px solid transparent',background:'transparent',padding:'11px 15px',color:view===item?'#153c3d':'#697a7c',fontWeight:900,cursor:'pointer',whiteSpace:'nowrap'}}>{item}</button>)}</nav>
      {loading?<div style={{...styles.card,padding:50,textAlign:'center',color:'#63747a'}}>Carregando evidências do período…</div>:<><section style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(145px,1fr))',gap:10,marginBottom:14}}>{metric('Leads',count(summary.leadEntries),'recebidos no período')}{metric('Atendidos',count(summary.answeredConversations??summary.effectiveHumanServices),'resposta ou atendimento humano')}{metric('Qualificados',count(summary.qualified))}{metric('Visitas reais',count(summary.visits),'não inclui intenção')}{metric('Vendas',count(summary.salesCount))}{metric('Valor vendido',money(summary.revenue))}{metric('Ticket médio',money(summary.ticketMedio))}{metric('Conversão',summary.auroraConversion===null||summary.auroraConversion===undefined?'—':`${Number(summary.auroraConversion).toFixed(1)}%`,'indicador reportado')}</section>
        <section style={{...styles.card,marginBottom:14}}><div style={{display:'flex',justifyContent:'space-between',gap:10,flexWrap:'wrap'}}><div><h2 style={{fontSize:16,margin:'0 0 4px'}}>Jornada comercial</h2><div style={{fontSize:11,color:'#718086'}}>Contagens deduplicadas por contato e estágio observado.</div></div><span style={{fontSize:10,color:'#718086',alignSelf:'center'}}>Atualizado {report?.generatedAt?new Date(report.generatedAt).toLocaleString('pt-BR'):'agora'}</span></div><div style={{display:'grid',gridTemplateColumns:'repeat(5,minmax(125px,1fr))',gap:8,overflowX:'auto',marginTop:15}}>{stages.map(([label,list],i)=>{const n=new Set(list.map(contactKey)).size;const previous=i?new Set(stages[i-1][1].map(contactKey)).size:null;return <div key={label} style={{background:i===4?'#e5f0eb':'#f3f6f4',borderLeft:`4px solid ${i===4?'#d97952':'#78a99a'}`,borderRadius:8,padding:13,minWidth:125}}><div style={{fontSize:11,fontWeight:900,color:'#376b62'}}>{label}</div><div style={{fontSize:25,fontWeight:900,margin:'5px 0'}}>{n}</div><div style={{fontSize:10,color:'#718086'}}>{previous===null?'base do período':previous?`${(n/previous*100).toFixed(1)}% da etapa anterior`:'sem etapa anterior'}</div></div>})}</div></section>
        <section style={{...styles.card,overflowX:'auto',marginBottom:14}}><h2 style={{fontSize:16,margin:'0 0 4px'}}>{view==='Geral'?'Desempenho de origem e anúncio':`Visão ${view}`}</h2><div style={{fontSize:11,color:'#718086',marginBottom:13}}>Métricas de mídia paga não disponíveis no CRM permanecem indisponíveis, nunca convertidas em zero.</div><table style={{width:'100%',borderCollapse:'collapse',minWidth:900,fontSize:12}}><thead><tr>{['Campanha','Anúncio','Leads','Atendidos','Qualificados','Visitas','Vendas','Conversão','Faturamento','Ticket','Evidência'].map(c=><th key={c} style={{textAlign:'left',padding:'9px 7px',borderBottom:'2px solid #dbe3df',color:'#617276'}}>{c}</th>)}</tr></thead><tbody>{grouped.map((r,i)=><tr key={`${r.campaign}${r.ad}`} style={{background:i%2?'#f7f9f7':'transparent'}}><td style={{padding:'10px 7px',fontWeight:800}}>{r.campaign}</td><td style={{padding:'10px 7px'}}>{r.ad}</td>{[r.leads,r.attended,r.qualified,r.visits,r.sales].map((v,j)=><td key={j} style={{padding:'10px 7px'}}>{count(v)}</td>)}<td style={{padding:'10px 7px'}}>{r.conversion===null?'—':`${r.conversion.toFixed(1)}%`}</td><td style={{padding:'10px 7px',fontWeight:800}}>{money(r.revenue)}</td><td style={{padding:'10px 7px'}}>{money(r.ticket)}</td><td style={{padding:'10px 7px'}}>{badge(r.records[0]?.attributionQuality||'legacy_or_not_captured')}</td></tr>)}</tbody></table>{!grouped.length&&<div style={{padding:28,textAlign:'center',color:'#718086'}}>Nenhum registro observado neste recorte.</div>}</section>
        <section style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(280px,1fr))',gap:14}}><div style={styles.card}><h2 style={{fontSize:15,margin:'0 0 12px'}}>Desempenho por consultor</h2>{(report?.marketing?.consultantPerformance||report?.comparisons?.consultants||[]).map(row=><div key={row.consultantId} style={{borderTop:'1px solid #e1e8e4',padding:'10px 0',display:'flex',justifyContent:'space-between',gap:10}}><div><strong>{row.name}</strong><div style={{fontSize:10,color:'#718086'}}>{count(row.leadEntries)} leads · {count(row.visits)} visitas</div></div><strong>{money(row.revenue)}</strong></div>)}{!(report?.marketing?.consultantPerformance||report?.comparisons?.consultants||[]).length&&<div style={{color:'#718086',fontSize:12}}>Sem desempenho observado.</div>}</div><div style={styles.card}><h2 style={{fontSize:15,margin:'0 0 5px'}}>Pergunte à inteligência</h2><div style={{fontSize:11,color:'#718086',marginBottom:10}}>Respostas restritas ao período e ao escopo selecionados.</div><textarea value={question} onChange={e=>setQuestion(e.target.value)} placeholder="Ex.: qual origem trouxe mais visitas reais?" rows={3} style={{width:'100%',boxSizing:'border-box',border:'1px solid #c8d4d1',borderRadius:7,padding:10,fontFamily:'inherit',resize:'vertical'}}/><button onClick={askAI} disabled={asking||!question.trim()} style={{marginTop:8,border:0,borderRadius:7,padding:'9px 13px',background:'#153c3d',color:'#fff',fontWeight:900,cursor:'pointer',opacity:(asking||!question.trim())?.5:1}}>{asking?'Analisando…':'Perguntar'}</button>{answer&&<div style={{marginTop:12,background:'#f1f6f3',borderRadius:8,padding:12,fontSize:12,lineHeight:1.55,whiteSpace:'pre-wrap'}}>{answer}</div>}</div></section>
        {view !== 'Geral' && <section style={{...styles.card,marginBottom:14,overflowX:'auto'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:10,marginBottom:12}}>
            <div><h2 style={{fontSize:16,margin:0}}>{view==='Loja'?'Lojas':view==='Campanha'?'Campanhas':view==='Anuncio'?'Anúncios':view==='Lead'?'Leads':'Vendas'}</h2><div style={{fontSize:11,color:'#718086'}}>Navegue pelo registro observado para aprofundar a evidência.</div></div>
            <span style={{fontSize:11,color:'#718086'}}>{count(viewRows.length)} registros</span>
          </div>
          {view==='Lead' ? <table style={{width:'100%',borderCollapse:'collapse',minWidth:980,fontSize:12}}><thead><tr>{['Chegada','Cliente / identidade','Origem · anúncio','Loja','Consultor','Etapa','Qualificação','Visita','Venda','Atribuição','Ações'].map(c=><th key={c} style={{textAlign:'left',padding:'8px',borderBottom:'2px solid #dbe3df',color:'#617276'}}>{c}</th>)}</tr></thead><tbody>{leadRows.map((r,i)=>{const sale=(records.sales||[]).find(s=>contactKey(s)===contactKey(r));const visit=(records.visits||[]).find(s=>contactKey(s)===contactKey(r));return <tr key={r.id||i} style={{background:i%2?'#f7f9f7':'transparent'}}><td style={{padding:8,whiteSpace:'nowrap'}}>{r.createdAt||r.occurredAt||r.created_at||'—'}</td><td style={{padding:8,fontWeight:800}}>{r.name||'Cliente sem nome'}<div style={{fontSize:10,color:'#718086'}}>{r.phone||'Identidade não informada'}</div></td><td style={{padding:8}}>{r.source||r.origin||'Não identificada'}<div style={{fontSize:10,color:'#718086'}}>{r.ad||r.adId||'Anúncio não identificado'}</div></td><td style={{padding:8}}>{r.storeName||r.storeId||'—'}</td><td style={{padding:8}}>{r.consultantName||'Não informado'}</td><td style={{padding:8}}>{stageFor(r)}</td><td style={{padding:8}}>{r.qualified||r.qualificationStatus?'Observada':'—'}</td><td style={{padding:8}}>{visit?'Sim':'—'}</td><td style={{padding:8}}>{sale?money(sale.value):'—'}</td><td style={{padding:8}}>{badge(r.attributionQuality||'legacy_or_not_captured')}</td><td style={{padding:8}}><button onClick={()=>setDetail(r)} style={{border:0,borderRadius:6,padding:'6px 8px',background:'#e5f0eb',color:'#20564d',fontWeight:800,cursor:'pointer'}}>Ver jornada</button></td></tr>})}</tbody></table> :
          view==='Venda' ? <table style={{width:'100%',borderCollapse:'collapse',minWidth:760,fontSize:12}}><thead><tr>{['Data','Cliente','Valor','Loja','Consultor','Origem · anúncio','Atribuição','Ações'].map(c=><th key={c} style={{textAlign:'left',padding:8,borderBottom:'2px solid #dbe3df'}}>{c}</th>)}</tr></thead><tbody>{salesRows.map((r,i)=><tr key={r.id||i}><td style={{padding:8}}>{r.date||r.occurredAt||r.createdAt||'—'}</td><td style={{padding:8,fontWeight:800}}>{r.name||'Cliente sem nome'}</td><td style={{padding:8,fontWeight:800}}>{money(r.value)}</td><td style={{padding:8}}>{r.storeName||r.storeId||'—'}</td><td style={{padding:8}}>{r.consultantName||'Não informado'}</td><td style={{padding:8}}>{r.source||r.origin||'Não identificada'} · {r.ad||r.adId||'Anúncio não identificado'}</td><td style={{padding:8}}>{badge(r.attributionQuality||'legacy_or_not_captured')}</td><td style={{padding:8}}><button onClick={()=>setDetail(r)} style={{border:0,borderRadius:6,padding:'6px 8px',background:'#e5f0eb',color:'#20564d',fontWeight:800,cursor:'pointer'}}>Detalhes</button></td></tr>)}</tbody></table> :
          <table style={{width:'100%',borderCollapse:'collapse',minWidth:720,fontSize:12}}><thead><tr>{['Nome','Leads','Atendidos','Qualificados','Visitas','Vendas','Conversão','Ticket','Atribuição','Ação'].map(c=><th key={c} style={{textAlign:'left',padding:8,borderBottom:'2px solid #dbe3df'}}>{c}</th>)}</tr></thead><tbody>{viewRows.map((r,i)=><tr key={r.storeId||r.name||i}><td style={{padding:8,fontWeight:800}}>{r.name||r.ad||'Não identificado'}</td><td style={{padding:8}}>{count(r.leads??r.leadEntries)}</td><td style={{padding:8}}>{count(r.attended??r.effectiveHumanServices)}</td><td style={{padding:8}}>{count(r.qualified)}</td><td style={{padding:8}}>{count(r.visits)}</td><td style={{padding:8}}>{count(r.sales??r.salesCount)}</td><td style={{padding:8}}>{r.conversion===null||r.conversion===undefined?'—':`${Number(r.conversion).toFixed(1)}%`}</td><td style={{padding:8}}>{money(r.ticket??(r.salesCount?r.revenue/r.salesCount:null))}</td><td style={{padding:8}}>{badge(r.quality||r.attributionQuality||'legacy_or_not_captured')}</td><td style={{padding:8}}><button onClick={()=>{if(view==='Campanha')setFilters(f=>({...f,campaign:r.name}));if(view==='Anuncio')setFilters(f=>({...f,ad:r.ad}));setView(view==='Campanha'?'Anuncio':view==='Anuncio'?'Lead':view)}} style={{border:0,borderRadius:6,padding:'6px 8px',background:'#e5f0eb',color:'#20564d',fontWeight:800,cursor:'pointer'}}>{view==='Loja'?'Ver leads':'Abrir nível'}</button></td></tr>)}</tbody></table>}
        </section>}
        {detail && <div onClick={()=>setDetail(null)} style={{position:'fixed',inset:0,zIndex:20,background:'rgba(21,60,61,.55)',display:'flex',alignItems:'center',justifyContent:'center',padding:16}}><div onClick={e=>e.stopPropagation()} style={{...styles.card,width:'100%',maxWidth:680,maxHeight:'80vh',overflow:'auto'}}><div style={{display:'flex',justifyContent:'space-between',gap:12}}><div><h2 style={{fontSize:18,margin:0}}>{detail.name||'Cliente sem nome'}</h2><div style={{fontSize:11,color:'#718086'}}>{detail.phone||'Identidade não informada'} · {detail.storeName||`Loja ${detail.storeId||'não informada'}`}</div></div><button onClick={()=>setDetail(null)} style={{border:0,background:'transparent',fontSize:20,cursor:'pointer'}}>Fechar</button></div><div style={{marginTop:14,display:'flex',flexWrap:'wrap',gap:6}}>{badge(detail.attributionQuality||'legacy_or_not_captured')}<span style={{background:'#f3f6f4',borderRadius:20,padding:'3px 8px',fontSize:10,fontWeight:800}}>{stageFor(detail)}</span></div><div style={{marginTop:15,borderTop:'1px solid #dbe3df',paddingTop:12}}><strong>Jornada observada</strong>{(journeyFor(detail)?.events||[]).length?<div style={{display:'grid',gap:7,marginTop:9}}>{journeyFor(detail).events.map((event,i)=><div key={event.id||i} style={{fontSize:12,padding:'8px 10px',background:'#f3f6f4',borderRadius:7}}>{event.event_type||event.type||'Evento'} <span style={{color:'#718086'}}>{event.occurred_at||''}</span></div>)}</div>:<div style={{fontSize:12,color:'#718086',marginTop:8}}>Não há eventos de jornada disponíveis para este contato.</div>}</div><div style={{marginTop:15,fontSize:12,color:'#53636b'}}>Origem: {detail.source||detail.origin||'Não identificada'} · anúncio: {detail.ad||detail.adId||'Não identificado'} · consultor: {detail.consultantName||'Não informado'}</div>{onOpenConversation&&detail.phone?<button onClick={()=>onOpenConversation({phone:detail.phone,storeId:detail.storeId,leadId:detail.id})} style={{marginTop:14,border:0,borderRadius:7,padding:'9px 12px',background:'#153c3d',color:'#fff',fontWeight:900,cursor:'pointer'}}>Abrir conversa canônica</button>:<div style={{marginTop:14,fontSize:11,color:'#718086'}}>Ação de conversa indisponível neste contexto; nenhum chat foi criado. A identidade canônica acima permanece disponível para conferência.</div>}</div></div>}
      </>}</main>{passwordResetOpen&&<div style={{position:'fixed',inset:0,zIndex:30,background:'rgba(15,23,42,.62)',display:'grid',placeItems:'center',padding:16}}><CrmPasswordResetPanel apiBase="/api/crm/admin" exactConfirmation onClose={()=>setPasswordResetOpen(false)} /></div>}</div>;
}


// ── LOGIN ──────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showStudioLogin, setShowStudioLogin] = useState(false);
  const studioClickRef = useRef(0);
  const studioTimerRef = useRef(null);

  const handleTriggerClick = () => {
    studioClickRef.current += 1;
    if (studioTimerRef.current) clearTimeout(studioTimerRef.current);
    if (studioClickRef.current >= 5) {
      studioClickRef.current = 0;
      setShowStudioLogin(true);
    } else {
      studioTimerRef.current = setTimeout(() => { studioClickRef.current = 0; }, 3000);
    }
  };

  // Trigger via teclado (F2) ou URL hash
  useEffect(() => {
    if (window.location.hash === '#studio') {
      window.location.hash = '';
      setShowStudioLogin(true);
    }
    const onKey = (e) => {
      if (e.key === 'F2') { e.preventDefault(); setShowStudioLogin(true); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  // Auto-login demo via cookie arflow_demo=1
  // O cookie é garantido pelo module-level code que roda antes do React montar,
  // cobrindo os cenários: path /apresentacao (dev), hash #_demo (proxy dev) e cookie direto (prod).
  // Não usa fetch — o módulo já validou a origem; uma chamada de rede extra só cria riscos de falha silenciosa.
  useEffect(() => {
    const hasDemoCookie = document.cookie.split(';').some(c => c.trim() === 'arflow_demo=1');
    if (!hasDemoCookie) return;
    // Consome o cookie para não persistir entre abas
    document.cookie = 'arflow_demo=1; max-age=0; path=/';
    // Login direto — sem roundtrip ao servidor
    onLogin(DEMO_USERS[0]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const uname = username.trim().toLowerCase();
    if (uname === "studio") { setShowStudioLogin(true); return; }
    // Demo login — valida senha no servidor (não exposta no frontend)
    if (uname === "demo") {
      try {
        const r = await fetch('/api/demo/login', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ password }) });
        const d = await r.json().catch(() => ({}));
        if (d.ok) {
          onLogin(DEMO_USERS[0]); // Admin demo: Carlos Mendes
        } else {
          setError(d.error || "Senha de demonstração incorreta.");
        }
      } catch { setError("Erro ao verificar credenciais de demonstração."); }
      return;
    }
    try {
      const r = await fetch('/api/crm/login', {
        method:'POST',
        headers:{ 'Content-Type':'application/json' },
        body:JSON.stringify({ username:uname, password }),
      });
      const d = await r.json().catch(() => ({}));
      const user = d.ok ? USERS.find(u => u.id === d.userId) : null;
      if (user) onLogin({ ...user, capabilities:d.capabilities||[], mustChangePassword:d.mustChangePassword===true });
      else setError(d.error || "Usuário ou senha incorretos.");
    } catch {
      setError("Não foi possível verificar suas credenciais. Tente novamente.");
    }
  };

  return (
    <>
      {showStudioLogin && (
        <SuperAdminLoginModal
          onClose={()=>setShowStudioLogin(false)}
          onSuccess={(session)=>{ setShowStudioLogin(false); onLogin({ ...SUPERADMIN_USER, ...session, id:-1, storeId:null }); }}
        />
      )}
      <div className="arflow-login">
        <div className="arflow-login__card">
          <div className="arflow-login__brand">
            <BrandLogo variant="full" size={204} style={{ margin:"0 auto 8px", cursor:"default", userSelect:"none" }} onClick={handleTriggerClick} />
            <div className="arflow-login__subtitle">AR Flow OS — Grupo Mezzo & Reis</div>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="arflow-login__field">
              <label className="arflow-login__label">Usuário</label>
              <input className="arflow-login__input" type="text" value={username} onChange={e => { setUsername(e.target.value); setError(""); }} placeholder="Digite seu usuário" autoComplete="username" />
            </div>
            <div className="arflow-login__field arflow-login__field--password">
              <label className="arflow-login__label">Senha</label>
              <input className="arflow-login__input" type="password" value={password} onChange={e => { setPassword(e.target.value); setError(""); }} placeholder="Digite sua senha" autoComplete="current-password" />
            </div>
            {error && <div className="arflow-login__error">{error}</div>}
            <button type="submit" className="arflow-login__submit">
              Entrar
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

// ── DEMO LOGIN SCREEN — estilo ArtFlow Connect ─────────────────
// eslint-disable-next-line no-unused-vars
function DemoLoginScreen({ onLogin }) {
  const C = { gold:'#B8960C', dark:'#1C1917', muted:'#78716C', border:'#E8E2DA' };
  const DEMO_PROFILES = [
    { icon:'👑', label:'Admin Demo',    desc:'Visão completa de todas as lojas', user: DEMO_USERS[0] },
    { icon:'📊', label:'Gerente Demo',  desc:'Loja Curitiba — Grupo Móvel & Arte', user: DEMO_USERS.find(u=>u.role==='manager'&&u.storeId===101)||DEMO_USERS[1] },
    { icon:'💼', label:'Consultor Demo',desc:'Felipe Costa — Vendas e atendimento', user: DEMO_USERS.find(u=>u.name==='Felipe Costa')||DEMO_USERS[2] },
  ];
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [autoLogging, setAutoLogging] = useState(_demoPendingLogin);

  useEffect(() => {
    if (!_demoPendingLogin) return;
    // Limpa o parâmetro ?demo da URL
    window.history.replaceState({}, '', window.location.pathname);
    setAutoLogging(true);
    fetch('/api/demo/login', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ password:'arflow2025' }) })
      .then(r => r.json())
      .then(d => { if (d.ok) { onLogin(DEMO_USERS[0]); } else { setAutoLogging(false); } })
      .catch(() => setAutoLogging(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const doLogin = async (user) => {
    setSelected(user?.id);
    setLoading(true);
    try {
      const r = await fetch('/api/demo/login', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ password:'arflow2025' }) });
      const d = await r.json().catch(() => ({}));
      if (d.ok) { onLogin(user); }
      else setLoading(false);
    } catch { setLoading(false); }
  };

  if (autoLogging || loading) {
    return (
      <div style={{ minHeight:'100vh', background:'#FAF9F6', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:16 }}>
        <div style={{ width:48, height:48, border:'3px solid #E8E2DA', borderTopColor:'#B8960C', borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
        <div style={{ color:'#78716C', fontSize:14 }}>Carregando demonstração...</div>
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      </div>
    );
  }

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'#FAF9F6' }}>
      {/* ── Left hero ── */}
      <div className="demo-hero" style={{ flex:1, position:'relative', backgroundImage:'url(https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1200&q=80)', backgroundSize:'cover', backgroundPosition:'center', display:'flex', flexDirection:'column', justifyContent:'flex-end', padding:48, minHeight:400 }}>
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(135deg, rgba(28,25,23,0.88) 0%, rgba(184,150,12,0.25) 100%)' }} />
        <div style={{ position:'relative', zIndex:1 }}>
          <div style={{ color:C.gold, fontSize:13, fontWeight:700, letterSpacing:3, textTransform:'uppercase', marginBottom:12 }}>AR Flow</div>
          <h1 style={{ fontFamily:'Georgia,serif', fontSize:52, fontWeight:700, color:'#fff', lineHeight:1.1, margin:'0 0 20px' }}>OS</h1>
          <p style={{ color:'rgba(255,255,255,0.75)', fontSize:18, maxWidth:360, lineHeight:1.6, margin:'0 0 28px' }}>
            Plataforma de gestão para lojas de alto padrão
          </p>
          <div style={{ borderTop:'1px solid rgba(255,255,255,0.15)', paddingTop:24 }}>
            <div style={{ color:'rgba(255,255,255,0.45)', fontSize:11, fontWeight:700, letterSpacing:2, textTransform:'uppercase', marginBottom:8 }}>Ambiente de demonstração</div>
            <div style={{ color:C.gold, fontSize:16, fontWeight:700, fontFamily:'Georgia,serif' }}>Grupo Móvel &amp; Arte</div>
            <div style={{ color:'rgba(255,255,255,0.5)', fontSize:12, marginTop:4 }}>3 lojas · Curitiba, Londrina e Maringá</div>
          </div>
        </div>
      </div>

      {/* ── Right form panel ── */}
      <div className="demo-form" style={{ width:480, background:'#fff', display:'flex', flexDirection:'column', justifyContent:'center', padding:'48px', boxShadow:'-4px 0 40px rgba(0,0,0,0.08)' }}>
        <div style={{ marginBottom:36 }}>
          <div style={{ color:C.gold, fontSize:12, fontWeight:700, letterSpacing:2, textTransform:'uppercase' }}>AR Flow OS</div>
          <h2 style={{ fontFamily:'Georgia,serif', fontSize:28, color:C.dark, margin:'8px 0 4px', fontWeight:600 }}>Bem-vindo à demonstração</h2>
          <p style={{ color:C.muted, fontSize:14, margin:0 }}>Escolha o perfil para começar a explorar</p>
        </div>

        <div style={{ display:'flex', flexDirection:'column', gap:12, marginBottom:32 }}>
          {DEMO_PROFILES.map(p => (
            <button key={p.label} onClick={() => doLogin(p.user)}
              style={{ display:'flex', alignItems:'center', gap:16, padding:'16px 20px', border:`1.5px solid ${selected===p.user?.id?C.gold:C.border}`, borderRadius:12, background:selected===p.user?.id?'#FFFBEB':'#FAFAF8', cursor:'pointer', textAlign:'left', transition:'all 0.15s', width:'100%' }}>
              <div style={{ width:48, height:48, background:C.gold+'22', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:24, flexShrink:0 }}>{p.icon}</div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:14, fontWeight:700, color:C.dark }}>{p.label}</div>
                <div style={{ fontSize:12, color:C.muted, marginTop:3 }}>{p.desc}</div>
              </div>
              <div style={{ color:C.gold, fontSize:20, opacity:selected===p.user?.id?1:0.25 }}>→</div>
            </button>
          ))}
        </div>

        <div style={{ textAlign:'center', color:C.muted, fontSize:11, lineHeight:1.6 }}>
          Dados fictícios · Nenhuma mensagem real é enviada · Nenhum dado real é exibido
        </div>
      </div>

      <style>{`
        @media(max-width:768px){
          .demo-hero{display:none!important;}
          .demo-form{width:100%!important;padding:32px 24px!important;}
        }
      `}</style>
    </div>
  );
}

// ── COMPONENTS ────────────────────────────────────────────────

function Badge({ children, color }) {
  return <span style={{ background:color+"22", color, border:`1px solid ${color}44`, borderRadius:20, padding:"2px 10px", fontSize:11, fontWeight:700, whiteSpace:"nowrap" }}>{children}</span>;
}

// Detecta dispositivo touch (celular/tablet) para decidir o comportamento do Enter no chat.
function isTouchDevice() {
  return typeof window !== "undefined" && (('ontouchstart' in window) || (navigator.maxTouchPoints||0) > 0);
}

// Campo de mensagem reutilizável para todos os chats (Leads, Atendimento Presencial, Prospecção, Inbox):
// textarea multi-linha que cresce automaticamente. No desktop, Enter envia e Shift+Enter quebra linha;
// em dispositivos touch, Enter só quebra linha — o envio só acontece pelo botão "Enviar".
function ChatMessageInput({ value, onChange, onSend, onPaste, placeholder="Digite sua mensagem…", disabled=false, autoFocus=false, maxHeight=110, style={} }) {
  const taRef = useRef(null);
  useEffect(() => {
    const el = taRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, maxHeight) + "px";
  }, [value, maxHeight]);
  return (
    <textarea
      ref={taRef}
      value={value}
      onChange={e=>onChange(e.target.value)}
      onPaste={onPaste}
      onKeyDown={e=>{
        if (e.key === "Enter" && !e.shiftKey && !isTouchDevice()) {
          e.preventDefault();
          onSend();
        }
      }}
      placeholder={placeholder}
      disabled={disabled}
      autoFocus={autoFocus}
      spellCheck={true}
      lang="pt-BR"
      autoCorrect="off"
      rows={1}
      style={{ flex:1, padding:"9px 12px", borderRadius:10, border:"1.5px solid #E2E8F0", fontSize:12, resize:"none", overflowY:"auto", maxHeight, minHeight:36, lineHeight:1.4, fontFamily:"inherit", boxSizing:"border-box", ...style }}
    />
  );
}

// ── Lista de mensagens compartilhada (Atendimento Presencial + Central de Conversas) ──
// Mesmo componente de renderização de bolhas para os dois lugares: separador de dia,
// notas internas, mídia (imagem/áudio/vídeo) e status de envio. `buildRetry(m, msgTexto, isMine)`
// deixa cada tela decidir como reenviar (com seu próprio onSend/onSendZapi e telefone).
function QuotedPreview({ quotedMsg, isMine }) {
  if (!quotedMsg) return null;
  const { texto, tipo, url, storagePath, fromMe } = quotedMsg;
  const imageSrc = resolveMediaSrc(url, storagePath);
  return (
    <div style={{ borderLeft:`3px solid ${isMine?"rgba(255,255,255,0.45)":"#94A3B8"}`, background:isMine?"rgba(0,0,0,0.12)":"rgba(0,0,0,0.06)", borderRadius:"4px 8px 8px 4px", padding:"4px 8px", marginBottom:6, maxWidth:"100%", overflow:"hidden" }}>
      <div style={{ fontSize:9, fontWeight:800, marginBottom:2, opacity:0.8 }}>{fromMe?"👤 Consultor":"👥 Cliente"}</div>
      {tipo==="imagem"&&(
        imageSrc
          ? <img src={imageSrc} alt="Foto citada" style={{ height:36, borderRadius:3, display:"block", marginBottom:2, objectFit:"cover" }} onError={e=>e.target.style.display="none"} />
          : <div style={{ fontSize:10, opacity:0.75 }}>📷 Foto citada</div>
      )}
      {tipo==="audio"&&<div style={{ fontSize:10, opacity:0.75 }}>🎵 Áudio</div>}
      {tipo==="video"&&<div style={{ fontSize:10, opacity:0.75 }}>🎥 Vídeo</div>}
      {tipo==="documento"&&<div style={{ fontSize:10, opacity:0.75 }}>📄 Documento</div>}
      {texto?<div style={{ fontSize:10, opacity:0.85, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", maxWidth:220 }}>{texto}</div>:(!imageSrc&&<div style={{ fontSize:10, opacity:0.6, fontStyle:"italic" }}>📎 Mídia</div>)}
    </div>
  );
}

function ChatMessageActions({ message, onDelete, onEdit }) {
  const [open, setOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [notice, setNotice] = useState("");
  const canDelete = !!(message.providerMessageId || message.waMessageId);
  const canEdit = message.tipo === "text" && !!(message.providerMessageId || message.waMessageId) && !!onEdit;
  if (message.remetente !== "consultor" || message.deletedForEveryone || !onDelete) return null;
  const handleDelete = async () => {
    if (!canDelete) {
      setNotice("Esta mensagem não tem um identificador do WhatsApp e não pode ser apagada para todos.");
      return;
    }
    if (!window.confirm("Apagar esta mensagem para todos no WhatsApp? Essa ação não pode ser desfeita.")) return;
    setDeleting(true);
    setNotice("");
    try {
      await onDelete(message);
      setOpen(false);
    } catch (error) {
      setNotice(error?.message || "Não foi possível apagar a mensagem. Ela continua visível.");
    } finally {
      setDeleting(false);
    }
  };
  const handleEdit = async () => {
    if (!canEdit) return setNotice("Esta mensagem ainda não foi confirmada pelo WhatsApp e não pode ser editada.");
    const text = window.prompt("Editar mensagem no WhatsApp:", message.texto || "");
    if (text == null || !text.trim() || text === message.texto) return;
    setDeleting(true); setNotice("");
    try { await onEdit(message, text.trim()); setOpen(false); }
    catch (error) { setNotice(error?.message || "A edição foi recusada; o texto local não foi alterado."); }
    finally { setDeleting(false); }
  };
  return (
    <div style={{ position:"relative", alignSelf:"center", display:"flex", flexDirection:"column", alignItems:"flex-end" }}>
      <button
        onClick={()=>setOpen(v=>!v)}
        title="Editar ou apagar mensagem"
        aria-label="Editar ou apagar mensagem"
        style={{ background:open?"#F1F5F9":"#F8FAFC", border:"1px solid #E2E8F0", cursor:"pointer", fontSize:10, color:"#64748B", padding:"4px 7px", borderRadius:6, lineHeight:1.2, whiteSpace:"nowrap", fontWeight:700 }}
      >⋮ Ações</button>
      {open && (
        <div style={{ position:"absolute", zIndex:20, right:0, bottom:"calc(100% + 4px)", width:260, background:"#fff", border:"1px solid #E2E8F0", borderRadius:9, boxShadow:"0 8px 22px rgba(15,23,42,.18)", padding:5 }}>
          <button onClick={handleEdit} disabled={deleting || !canEdit} style={{ width:"100%", textAlign:"left", background:"none", border:"none", color:canEdit?"#334155":"#94A3B8", padding:"8px", borderRadius:6, cursor:"pointer", fontSize:11, lineHeight:1.35 }}>✏️ Editar mensagem {!canEdit&&<span>(ID ainda não confirmado)</span>}</button>
          <button onClick={handleDelete} disabled={deleting} style={{ width:"100%", textAlign:"left", background:"none", border:"none", color:canDelete?"#DC2626":"#94A3B8", padding:"8px", borderRadius:6, cursor:deleting?"wait":"pointer", fontSize:11, fontWeight:700, lineHeight:1.35 }}>{deleting?"Apagando no WhatsApp…":canDelete?"🗑 Apagar para todos":"🗑 Apagar para todos (ID ainda não confirmado)"}</button>
          {notice && <div style={{ fontSize:10, color:"#B45309", background:"#FFFBEB", borderRadius:6, padding:"6px 8px", marginTop:3, lineHeight:1.35 }}>{notice}</div>}
        </div>
      )}
    </div>
  );
}

export function ChatMessageList({ messages:sourceMessages, storeId, phone, buildRetry, onReply, onDelete, onEdit }) {
  const messages = useTextSendMessages(sourceMessages, storeId, phone);
  return (
    <>
      {messages.length===0 && <div style={{ textAlign:"center", color:"#94A3B8", fontSize:12, padding:"20px 0" }}>Nenhuma mensagem ainda</div>}
      {messages.map((m,i)=>{
        if(m.messageSource==="firebase_outage_gap_note")return <RecoveryGapNote key={m.id||i} message={m}/>;
        const isMine = m.remetente==="consultor";
        const isAurora = m.remetente==="aurora";
        const isNote = m.remetente==="nota_interna";
        const failed = (isMine || isAurora) && waMsgIsFailed(m);
        const msgTexto = m.texto||(typeof m.content==="string"?m.content:"")||(typeof m.body==="string"?m.body:"")||(typeof m.text==="string"?m.text:m.text?.message||"")||m.caption||m.mensagem||m.message||"";
        const showLabel = isMine||i===0||messages[i-1]?.remetente!==m.remetente
          || messageSenderLabel(messages[i-1], USERS)!==messageSenderLabel(m, USERS);
        const showDaySep = i===0||dayKey(messages[i-1]?.timestamp)!==dayKey(m.timestamp);
        const onRetry = buildRetry ? buildRetry(m, msgTexto, isMine) : null;
        if (isNote) return (
          <div key={i} style={{ display:"flex", flexDirection:"column" }}>
            {showDaySep&&m.timestamp&&(
              <div style={{ display:"flex", justifyContent:"center", margin:"10px 0 6px" }}>
                <span style={{ background:"#E2E8F0", color:"#64748B", fontSize:10, fontWeight:700, borderRadius:99, padding:"3px 12px" }}>{formatDayLabel(m.timestamp)}</span>
              </div>
            )}
            <div style={{ background:"#FEF9C3", border:"1px solid #FDE68A", borderRadius:10, padding:"8px 12px", margin:"2px 0" }}>
              <div style={{ fontSize:10, fontWeight:800, color:"#92400E", marginBottom:2 }}>📝 Nota interna (só a equipe vê){m.autor?` — ${m.autor}`:""}</div>
              <div style={{ fontSize:12, color:"#78350F", lineHeight:1.5, whiteSpace:"pre-wrap" }}><MessageTextLinks text={m.texto} /></div>
              <div style={{ fontSize:9, color:"#B45309", marginTop:4 }}>{m.timestamp?new Date(m.timestamp).toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"}):""}</div>
            </div>
          </div>
        );
        return (
          <div key={i} style={{ display:"flex", flexDirection:"column" }}>
            {showDaySep&&m.timestamp&&(
              <div style={{ display:"flex", justifyContent:"center", margin:"10px 0 6px" }}>
                <span style={{ background:"#E2E8F0", color:"#64748B", fontSize:10, fontWeight:700, borderRadius:99, padding:"3px 12px" }}>{formatDayLabel(m.timestamp)}</span>
              </div>
            )}
            <div style={{ display:"flex", flexDirection:"column", alignItems:(isMine||isAurora)?"flex-end":"flex-start" }}>
            {showLabel&&<div style={{ fontSize:9, color:"#94A3B8", marginBottom:2 }}>{messageSenderLabel(m, USERS)}</div>}
            <div style={{ display:"flex", alignItems:"flex-end", gap:4, flexDirection:(isMine||isAurora)?"row-reverse":"row" }}>
            {onReply&&<button onClick={()=>onReply(m)} title="Responder" style={{ background:"none", border:"none", cursor:"pointer", fontSize:14, color:"#94A3B8", padding:"2px 5px", flexShrink:0, borderRadius:6, lineHeight:1, alignSelf:"center", opacity:0.55 }}>↩</button>}
            <ChatMessageActions message={m} onDelete={onDelete} onEdit={onEdit} />
            <div style={{ background:failed?"#FEE2E2":isMine?T.accent:isAurora?"#6366F1":"#E8EDF8", color:failed?"#991B1B":(isMine||isAurora)?"#fff":"#1E293B", borderRadius:(isMine||isAurora)?"14px 14px 4px 14px":"14px 14px 14px 4px", padding:"8px 12px", maxWidth:"88%", fontSize:12, lineHeight:1.5, boxShadow:"0 1px 4px rgba(0,0,0,0.10)", border:failed?"1px solid #FECACA":(isMine||isAurora)?"none":"1px solid #DDE4F0" }}>
              {m.deletedForEveryone ? (
                <span style={{ fontStyle:"italic", opacity:0.8 }}>🚫 Esta mensagem foi apagada para todos.</span>
              ) : (
                <>
                {m.quotedMsg&&<QuotedPreview quotedMsg={m.quotedMsg} isMine={isMine||isAurora} />}
                {(()=>{
                // Suporta formato flat (m.url) e formato aninhado do Z-API (m.image.url / m.audio.url / m.video.url)
                const rawUrl = m.storageUrl || m.base64Data || m.url || m.image?.url || m.audio?.url || m.video?.url || m.document?.url || null;
                const mediaSrc = resolveMediaSrc(rawUrl, m.storagePath);
                const _tipoRaw = (m.tipo || m.type || (m.image?.url ? "imagem" : m.audio?.url ? "audio" : m.video?.url ? "video" : m.document?.url ? "documento" : "") || "").toLowerCase();
                const _tipoFromMime = rawUrl?.startsWith("data:image/") ? "imagem" : rawUrl?.startsWith("data:audio/") ? "audio" : rawUrl?.startsWith("data:video/") ? "video" : "";
                const tipo = _tipoFromMime || (_tipoRaw.includes("imag")||_tipoRaw==="foto"||_tipoRaw==="photo"||_tipoRaw==="picture" ? "imagem" : _tipoRaw.includes("audio")||_tipoRaw==="voz" ? "audio" : _tipoRaw.includes("video")||_tipoRaw==="vídeo" ? "video" : _tipoRaw) || null;
                const txt = m.texto||(typeof m.content==="string"?m.content:"")||(typeof m.body==="string"?m.body:"")||(typeof m.text==="string"?m.text:m.text?.message||"")||m.caption||m.mensagem||"";
                if ((tipo==="imagem"||tipo==="image")) return (
                  <div>
                    {mediaSrc
                      ? <LazyChatImage src={mediaSrc} alt="imagem" style={{maxWidth:"100%",borderRadius:6,display:"block",cursor:"pointer"}}
                          onClick={()=>openMediaSrc({...m, url: rawUrl})}
                          onError={async e=>{
                            const img = e.target;
                            if (img.dataset.retried) {
                              img.style.display="none";
                              if (img.nextSibling) {
                                img.nextSibling.style.display="flex";
                                img.nextSibling.textContent = "⚠ Imagem histórica indisponível";
                              }
                              return;
                            }
                            img.dataset.retried = "1";
                            if (rawUrl && rawUrl.includes("firebasestorage")) {
                              try {
                                const { getDownloadURL: gd, ref: sr } = await import("firebase/storage");
                                const { getStorage: gs } = await import("firebase/storage");
                                const pm = new URL(rawUrl).pathname.match(/\/o\/(.+)$/);
                                if (pm) { img.src = await gd(sr(gs(), decodeURIComponent(pm[1]))); return; }
                              } catch {}
                            }
                            if (rawUrl && !rawUrl.startsWith("data:") && !rawUrl.includes("firebasestorage")) {
                              img.src = `/api/media?url=${encodeURIComponent(rawUrl)}`;
                              return;
                            }
                            img.style.display="none"; if(img.nextSibling) img.nextSibling.style.display="flex";
                          }}/>
                      : null}
                    <button onClick={()=>openMediaSrc({...m, url: rawUrl})} style={{display:mediaSrc?"none":"flex",alignItems:"center",gap:6,background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.4)",borderRadius:8,padding:"6px 12px",cursor:"pointer",color:"inherit",fontSize:11,fontWeight:700}}>{m.mediaRetentionPending?"⚠ Imagem sem cópia permanente — tentar abrir":"🖼 Abrir imagem ↗"}</button>
                    {txt?<div style={{marginTop:4,fontSize:11}}><MessageTextLinks text={txt} /></div>:null}
                    {mediaSrc && m.remetente==="cliente" && isNewUiEnabled() && (
                      <button type="button" onClick={()=>pedirParecidos(mediaSrc)} title="Buscar produtos parecidos com esta foto" style={{ marginTop:4, background:"rgba(255,255,255,0.18)", border:"1px solid rgba(0,0,0,0.12)", borderRadius:8, padding:"3px 9px", cursor:"pointer", color:"inherit", fontSize:11, fontWeight:700 }}>🔎 Parecidos</button>
                    )}
                  </div>
                );
                if ((tipo==="audio")) return (
                  <div>
                    {mediaSrc
                      ? <audio preload="none" controls src={mediaSrc} style={{maxWidth:"100%",display:"block"}}
                          onError={e=>{e.target.style.display="none"; if(e.target.nextSibling) e.target.nextSibling.style.display="flex";}}/>
                      : null}
                    <button onClick={()=>openMediaSrc({...m, url: rawUrl})} style={{display:mediaSrc?"none":"flex",alignItems:"center",gap:6,background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.4)",borderRadius:8,padding:"6px 12px",cursor:"pointer",color:"inherit",fontSize:11,fontWeight:700}}>🎵 Baixar áudio ↗</button>
                  </div>
                );
                if ((tipo==="video")) return (
                  <div>
                    {mediaSrc
                      ? <video preload="none" src={mediaSrc} controls style={{maxWidth:"100%",borderRadius:6,display:"block"}}
                          onError={e=>{e.target.style.display="none"; if(e.target.nextSibling) e.target.nextSibling.style.display="flex";}}/>
                      : null}
                    <button onClick={()=>openMediaSrc({...m, url: rawUrl})} style={{display:mediaSrc?"none":"flex",alignItems:"center",gap:6,background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.4)",borderRadius:8,padding:"6px 12px",cursor:"pointer",color:"inherit",fontSize:11,fontWeight:700}}>🎥 Abrir vídeo ↗</button>
                  </div>
                );
                if (isDocumentMessage(m)) return (
                  <DocumentAttachment message={m} src={mediaSrc || rawUrl} resolveSrc={resolveMediaSrc} />
                );
                // Placeholder do n8n sem URL real: "[Imagem enviada]", "[Audio recebido]", "chegou imagem"…
                const _N8N_RE = /^\[(imagem|foto|audio|áudio|vídeo|video|arquivo)[^\]]*\]$/i;
                const _isPlaceholder = _N8N_RE.test((txt||"").trim()) || /^chegou (imagem|áudio|audio|vídeo|video)/i.test((txt||"").trim());
                if (_isPlaceholder) {
                  const _pAud = /audio|áudio/i.test(txt); const _pVid = /video|vídeo/i.test(txt);
                  return <span style={{opacity:0.65,fontStyle:"italic"}}>{_pAud?"🎵":_pVid?"🎥":"📷"} {_pAud?"Áudio":_pVid?"Vídeo":"Imagem"} (ver no WhatsApp)</span>;
                }
                return <span><MessageTextLinks text={txt||"📎 Mídia"} /><FotoIdsGallery fotoIds={m.fotoIds} dark={isMine||isAurora} /></span>;
                })()}
                </>
              )}
            </div>
            </div>
            <div style={{ fontSize:9, color:"#94A3B8", marginTop:2, display:"flex", alignItems:"center", gap:3 }}>
              {m.timestamp?new Date(m.timestamp).toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"}):""}
              {m.deletedForEveryone ? <span style={{ color:"#64748B", fontWeight:700 }}>Apagada</span> : (isMine || isAurora) && <WaSendStatus attempt={m._textAttempt} status={m.status} ack={m.waAck} motivo={m.motivo} timestamp={m.timestamp} onRetry={isMine ? onRetry : null} />}
            </div>
            {failed && m.motivo && (
              <div style={{ fontSize:9, color:"#EF4444", fontWeight:600, marginTop:1 }}>⚠️ Não enviada: {m.motivo}</div>
            )}
            </div>
          </div>
        );
      })}
    </>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// RESPOSTAS RÁPIDAS — hook + popup de seleção + modal de gerenciamento pessoal
// ══════════════════════════════════════════════════════════════════════════════

// Carrega em tempo real as respostas rápidas do consultor (storeId + userId).
// Cada consultor tem sua própria biblioteca — sem cruzamento entre lojas ou usuários.
function useQuickReplies(storeId, userId) {
  const [replies, setReplies] = useState([]);
  useEffect(() => {
    if (!storeId || !userId) return;
    const unsub = onValue(dbRef(`arflow_respostas_rapidas/${storeId}/${userId}`), snap => {
      if (!snap.exists()) { setReplies([]); return; }
      const list = Object.entries(snap.val() || {})
        .map(([k, v]) => ({ _key: k, ...v }))
        .sort((a, b) => (a.atalho || "").localeCompare(b.atalho || ""));
      setReplies(list);
    });
    return () => unsub();
  }, [storeId, userId]); // eslint-disable-line react-hooks/exhaustive-deps
  return replies;
}

// Dropdown de seleção — aparece acima do compositor quando o consultor digita /
function QuickRepliesPopup({ query, replies, onSelect }) {
  const q = typeof query === "string" ? query.slice(1).toLowerCase() : "";
  const filtered = replies
    .filter(r => !q || (r.atalho||"").toLowerCase().includes(q) || (r.titulo||"").toLowerCase().includes(q))
    .slice(0, 7);
  if (!filtered.length) return null;
  return (
    <div style={{ background:"#fff", borderRadius:10, boxShadow:"0 4px 20px rgba(0,0,0,0.14)", border:"1px solid #E2E8F0", marginBottom:6, overflow:"hidden" }}>
      <div style={{ fontSize:9, fontWeight:800, color:"#9C8F7E", padding:"5px 12px 3px", letterSpacing:0.5, borderBottom:"1px solid #F1F5F9" }}>⚡ RESPOSTAS RÁPIDAS</div>
      {filtered.map(r => (
        <button key={r._key} onClick={() => onSelect(r)}
          style={{ width:"100%", display:"flex", alignItems:"center", gap:10, background:"none", border:"none", borderBottom:"1px solid #F8FAFC", padding:"8px 12px", cursor:"pointer", textAlign:"left" }}
          onMouseEnter={e=>e.currentTarget.style.background="#F8FAFC"}
          onMouseLeave={e=>e.currentTarget.style.background="none"}>
          <span style={{ fontWeight:800, fontSize:12, color:"#8B6F47", flexShrink:0 }}>/{r.atalho}</span>
          <span style={{ fontSize:12, color:"#2B1B12", flex:1, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{r.titulo}</span>
          {r.midias?.length > 0 && (
            <span style={{ fontSize:11, color:"#9C8F7E", flexShrink:0 }}>
              {r.midias.map((m,i) => <span key={i}>{m.tipo==="video"?"🎥":"📷"}</span>)}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}

// Modal de gerenciamento — consultor cadastra, edita e exclui as próprias respostas rápidas
function MyQuickRepliesModal({ storeId, userId, onClose, onSelectShared }) {
  const replies = useQuickReplies(storeId, userId);
  const [view, setView] = useState("list");
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({ atalho:"", titulo:"", texto:"" });
  const [pendingMidias, setPendingMidias] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const fileRef = useRef(null);

  const openNew  = () => { setEditItem(null); setForm({atalho:"",titulo:"",texto:""}); setPendingMidias([]); setError(""); setView("form"); };
  const openEdit = (r) => { setEditItem(r); setForm({atalho:r.atalho||"",titulo:r.titulo||"",texto:r.texto||""}); setPendingMidias(r.midias||[]); setError(""); setView("form"); };

  const handleFileUpload = async (e) => {
    const files = Array.from(e.target.files||[]);
    if (fileRef.current) fileRef.current.value="";
    if (!files.length) return;
    setUploading(true); setError("");
    for (const file of files) {
      const isImg = file.type.startsWith("image/");
      const isVid = file.type.startsWith("video/");
      if (!isImg && !isVid) { setError("Apenas imagens e vídeos."); continue; }
      if (file.size > (isVid?64:10)*1024*1024) { setError(`Máx ${isVid?"64":"10"} MB.`); continue; }
      try {
        const safe = file.name.replace(/[^a-zA-Z0-9._-]/g,"_");
        const sRef = storageRef(storage, `arflow_quick_replies_media/${storeId}/${userId}/${Date.now()}_${safe}`);
        await uploadBytes(sRef, file);
        const url = await getDownloadURL(sRef);
        setPendingMidias(prev => [...prev, { tipo: isVid?"video":"imagem", url, nome:file.name }]);
      } catch(err) { setError("Erro no upload: "+err.message); }
    }
    setUploading(false);
  };

  const removeMidia = (idx) => setPendingMidias(prev => prev.filter((_,i)=>i!==idx));

  const handleSave = async () => {
    const atalho = form.atalho.trim().toLowerCase().replace(/\s+/g,"_").replace(/[^a-z0-9_]/g,"");
    if (!atalho) { setError("Atalho obrigatório (ex: endereco, prazo)"); return; }
    if (!form.titulo.trim()) { setError("Título obrigatório"); return; }
    if (!form.texto.trim() && pendingMidias.length===0) { setError("Informe um texto ou adicione ao menos uma mídia"); return; }
    setSaving(true); setError("");
    try {
      const data = {
        atalho, titulo:form.titulo.trim(), texto:form.texto.trim(), midias:pendingMidias,
        storeId:Number(storeId), userId,
        criadoEm: editItem?.criadoEm||new Date().toISOString(),
        atualizadoEm: new Date().toISOString(),
      };
      await set(dbRef(`arflow_respostas_rapidas/${storeId}/${userId}/${editItem?._key||Date.now()}`), data);
      setView("list");
    } catch(err) { setError("Erro ao salvar: "+err.message); }
    setSaving(false);
  };

  const handleDelete = async (r) => {
    if (!window.confirm(`Excluir "/${r.atalho} — ${r.titulo}"?`)) return;
    remove(dbRef(`arflow_respostas_rapidas/${storeId}/${userId}/${r._key}`)).catch(()=>{});
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:1100, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
      onClick={onClose}>
      <div style={{ background:"#fff", borderRadius:16, maxWidth:520, width:"100%", maxHeight:"88vh", overflowY:"auto", boxShadow:"0 8px 48px rgba(0,0,0,0.22)" }}
        onClick={e=>e.stopPropagation()}>
        {/* Header */}
        <div style={{ padding:"14px 20px", borderBottom:"1px solid #F1F5F9", display:"flex", alignItems:"center", gap:8, position:"sticky", top:0, background:"#fff", zIndex:1 }}>
          {view==="form"&&<button onClick={()=>setView("list")} style={{ background:"none", border:"none", cursor:"pointer", fontSize:20, color:"#8B6F47", padding:0 }}>←</button>}
          <div style={{ flex:1 }}>
            <div style={{ fontWeight:800, fontSize:15, color:"#2B1B12" }}>
              {view==="list"?"⚡ Minhas Respostas Rápidas":editItem?"Editar resposta":"Nova resposta rápida"}
            </div>
            <div style={{ fontSize:11, color:"#9C8F7E" }}>
              {view==="list"?"Digite / no chat para acessar":"Preencha o atalho e o conteúdo"}
            </div>
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", fontSize:18, color:"#9C8F7E", padding:0 }}>✕</button>
        </div>

        {/* Lista */}
        {view==="list"&&(
          <div style={{ padding:"12px 20px" }}>
            <div style={{ background:"#FFFBEB", borderRadius:10, padding:"10px 14px", border:"1px solid #FDE68A", marginBottom:12, display:"flex", alignItems:"center", gap:10 }}>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:12, fontWeight:800, color:"#92400E" }}>{GOOGLE_REVIEW_TITLE} · da loja</div>
                <div style={{ fontSize:11, color:"#78350F" }}>/{GOOGLE_REVIEW_SHORTCUT} · preenche o rascunho, não envia</div>
              </div>
              <button type="button" onClick={onSelectShared} style={{ background:"#92400E", color:"#fff", border:0, borderRadius:7, padding:"6px 10px", cursor:"pointer", fontWeight:700 }}>Usar no chat</button>
            </div>
            {replies.length===0
              ? <div style={{ textAlign:"center", padding:"32px 0", color:"#9C8F7E", fontSize:13 }}>
                  <div style={{ fontSize:28, marginBottom:8 }}>⚡</div>
                  Nenhuma resposta rápida ainda.<br/>Crie a primeira abaixo.
                </div>
              : <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:12 }}>
                  {replies.map(r=>(
                    <div key={r._key} style={{ background:"#F8FAFC", borderRadius:10, padding:"10px 14px", border:"1px solid #E2E8F0", display:"flex", alignItems:"flex-start", gap:10 }}>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:2 }}>
                          <span style={{ fontWeight:800, fontSize:13, color:"#8B6F47" }}>/{r.atalho}</span>
                          {r.midias?.length>0&&<span style={{ fontSize:10, color:"#9C8F7E" }}>{r.midias.map((m,i)=><span key={i}>{m.tipo==="video"?"🎥":"📷"}</span>)} {r.midias.length} mídia{r.midias.length>1?"s":""}</span>}
                        </div>
                        <div style={{ fontSize:12, fontWeight:600, color:"#2B1B12" }}>{r.titulo}</div>
                        {r.texto&&<div style={{ fontSize:11, color:"#64748B", overflow:"hidden", maxHeight:36 }}>{r.texto}</div>}
                      </div>
                      <div style={{ display:"flex", gap:6, flexShrink:0 }}>
                        <button onClick={()=>openEdit(r)} style={{ background:"#EDE9FE", color:"#7C3AED", border:"none", borderRadius:7, padding:"5px 10px", fontSize:11, fontWeight:700, cursor:"pointer" }}>Editar</button>
                        <button onClick={()=>handleDelete(r)} style={{ background:"#FEF2F2", color:"#DC2626", border:"none", borderRadius:7, padding:"5px 10px", fontSize:11, fontWeight:700, cursor:"pointer" }}>Excluir</button>
                      </div>
                    </div>
                  ))}
                </div>
            }
            <button onClick={openNew} style={{ width:"100%", padding:"11px", background:"#8B6F47", color:"#fff", border:"none", borderRadius:10, fontWeight:700, fontSize:13, cursor:"pointer" }}>+ Adicionar resposta rápida</button>
          </div>
        )}

        {/* Formulário */}
        {view==="form"&&(
          <div style={{ padding:"14px 20px" }}>
            {error&&<div style={{ color:"#DC2626", fontSize:12, background:"#FEF2F2", borderRadius:8, padding:"8px 12px", marginBottom:12 }}>⚠️ {error}</div>}
            <div style={{ marginBottom:12 }}>
              <div style={{ fontSize:11, fontWeight:700, color:"#64748B", marginBottom:4 }}>ATALHO <span style={{ fontWeight:400, color:"#9C8F7E" }}>(sem espaços, ex: endereco)</span></div>
              <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                <span style={{ fontWeight:800, fontSize:18, color:"#8B6F47" }}>/</span>
                <input value={form.atalho} onChange={e=>setForm(f=>({...f,atalho:e.target.value.toLowerCase().replace(/\s/g,"_")}))}
                  placeholder="ex: endereco" style={{ flex:1, padding:"8px 12px", borderRadius:8, border:"1.5px solid #E2E8F0", fontSize:13, color:"#2B1B12" }} />
              </div>
            </div>
            <div style={{ marginBottom:12 }}>
              <div style={{ fontSize:11, fontWeight:700, color:"#64748B", marginBottom:4 }}>TÍTULO <span style={{ fontWeight:400, color:"#9C8F7E" }}>(aparece no dropdown)</span></div>
              <input value={form.titulo} onChange={e=>setForm(f=>({...f,titulo:e.target.value}))}
                placeholder="ex: Endereço da loja" style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:"1.5px solid #E2E8F0", fontSize:13, color:"#2B1B12", boxSizing:"border-box" }} />
            </div>
            <div style={{ marginBottom:12 }}>
              <div style={{ fontSize:11, fontWeight:700, color:"#64748B", marginBottom:4 }}>TEXTO <span style={{ fontWeight:400, color:"#9C8F7E" }}>(opcional se tiver mídia)</span></div>
              <textarea value={form.texto} onChange={e=>setForm(f=>({...f,texto:e.target.value}))}
                placeholder="Ex: Estamos na Rua X, 123 — Curitiba. Seg–Sáb 9h–18h 📍"
                rows={3} style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:"1.5px solid #E2E8F0", fontSize:13, color:"#2B1B12", resize:"vertical", boxSizing:"border-box" }} />
            </div>
            <div style={{ marginBottom:16 }}>
              <div style={{ fontSize:11, fontWeight:700, color:"#64748B", marginBottom:6 }}>MÍDIAS <span style={{ fontWeight:400, color:"#9C8F7E" }}>(opcional — fotos e/ou vídeo)</span></div>
              {pendingMidias.length>0&&(
                <div style={{ display:"flex", flexWrap:"wrap", gap:8, marginBottom:8 }}>
                  {pendingMidias.map((m,i)=>(
                    <div key={i} style={{ position:"relative", borderRadius:8, overflow:"hidden", border:"1px solid #E2E8F0" }}>
                      {m.tipo==="imagem"
                        ? <img src={m.url} alt={m.nome} style={{ width:68, height:68, objectFit:"cover", display:"block" }} />
                        : <div style={{ width:68, height:68, background:"#F1F5F9", display:"flex", alignItems:"center", justifyContent:"center", fontSize:22 }}>🎥</div>}
                      <button onClick={()=>removeMidia(i)} style={{ position:"absolute", top:2, right:2, background:"rgba(0,0,0,0.6)", color:"#fff", border:"none", borderRadius:"50%", width:16, height:16, fontSize:9, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", padding:0, lineHeight:1 }}>✕</button>
                    </div>
                  ))}
                </div>
              )}
              <input ref={fileRef} type="file" accept="image/*,video/*" multiple style={{ display:"none" }} onChange={handleFileUpload} />
              <button onClick={()=>fileRef.current?.click()} disabled={uploading}
                style={{ background:"#F3EDE2", color:"#8B6F47", border:"1.5px dashed #D4C5A9", borderRadius:8, padding:"8px 14px", fontSize:12, fontWeight:700, cursor:uploading?"wait":"pointer", opacity:uploading?0.7:1 }}>
                {uploading?"⏳ Enviando…":"📎 Adicionar foto / vídeo"}
              </button>
            </div>
            <button onClick={handleSave} disabled={saving||uploading}
              style={{ width:"100%", padding:"12px", background:"#8B6F47", color:"#fff", border:"none", borderRadius:10, fontWeight:700, fontSize:13, cursor:saving?"wait":"pointer", opacity:(saving||uploading)?0.7:1 }}>
              {saving?"Salvando…":editItem?"Salvar alterações":"Criar resposta rápida"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Aurora Helper: chamada à API de roteiro ──────────────────────────────────
async function callAhRoteiro({ phone, storeId, name, produto, estagio, mode, setRoteiroModal }) {
  setRoteiroModal({ loading: true, mode });
  try {
    const r = await fetch('/api/ah-roteiro', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone, storeId, nome: name || "", produto: produto || "", estagio: estagio || "chegou", mode })
    });
    const d = await r.json();
    if (d.error) { setRoteiroModal({ error: d.error }); return; }
    setRoteiroModal({ mode, roteiro: d.roteiro || {} });
  } catch(e) { setRoteiroModal({ error: "Erro de rede: " + e.message }); }
}

// ── ✨ Modal de Ajuda da IA — componente universal, usado em todos os módulos ─
function AiHelpModal({ roteiroModal, setRoteiroModal, clientName = "", phone, storeId, produto = "", estagio = "chegou" }) {
  if (!roteiroModal) return null;
  const handleMode = (mode) => callAhRoteiro({ phone, storeId, name: clientName, produto, estagio, mode, setRoteiroModal });
  const rot = roteiroModal.roteiro || {};
  const isObjecao = roteiroModal.mode === "objecao";
  const accent = isObjecao ? "#8B6F47" : "#1D4ED8";
  const bg     = isObjecao ? "#FEF9F0" : "#EFF6FF";
  const border = isObjecao ? "#E8E1D3" : "#BFDBFE";
  const btnBg  = isObjecao ? "#F3EDE2" : "#DBEAFE";
  const abordagens = rot.abordagens || rot.proximos_passos || [];
  const mensagens  = rot.mensagens  || [];
  const temConteudo = rot.insight || rot.contexto_parada || rot.observacao ||
    abordagens.length > 0 || mensagens.length > 0 || rot.evitar;

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
      onClick={()=>setRoteiroModal(null)}>
      <div style={{ background:"#fff", borderRadius:16, padding:24, maxWidth:580, width:"100%", maxHeight:"88vh", overflowY:"auto", boxShadow:"0 8px 48px rgba(0,0,0,0.22)" }}
        onClick={e=>e.stopPropagation()}>
        <div style={{ fontWeight:800, fontSize:16, color:"#2B1B12", marginBottom:4 }}>✨ Ajuda da IA{clientName ? ` — ${clientName}` : ""}</div>
        <div style={{ fontSize:11, color:"#9C8F7E", marginBottom:16 }}>A IA analisa a conversa real deste contato e sugere o que você pode enviar</div>

        {/* Seletor de modo */}
        {roteiroModal.chooser && (
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            <button onClick={()=>handleMode("objecao")}
              style={{ display:"flex", alignItems:"center", gap:12, background:"#FEF9F0", border:"2px solid #D4C5A9", borderRadius:12, padding:"14px 18px", cursor:"pointer", textAlign:"left", width:"100%" }}>
              <span style={{ fontSize:28 }}>🛡️</span>
              <div>
                <div style={{ fontWeight:800, fontSize:14, color:"#2B1B12" }}>Quebrar objeção</div>
                <div style={{ fontSize:12, color:"#8B6F47", marginTop:2 }}>Cliente está em silêncio, com dúvida ou resistência</div>
              </div>
            </button>
            <button onClick={()=>handleMode("reengajamento")}
              style={{ display:"flex", alignItems:"center", gap:12, background:"#EFF6FF", border:"2px solid #BFDBFE", borderRadius:12, padding:"14px 18px", cursor:"pointer", textAlign:"left", width:"100%" }}>
              <span style={{ fontSize:28 }}>🔄</span>
              <div>
                <div style={{ fontWeight:800, fontSize:14, color:"#2B1B12" }}>Reengajar cliente</div>
                <div style={{ fontSize:12, color:"#1D4ED8", marginTop:2 }}>Lead sumiu, conversa esfriou ou faz tempo que não responde</div>
              </div>
            </button>
            <button onClick={()=>setRoteiroModal(null)} style={{ background:"none", border:"none", color:"#9C8F7E", fontSize:12, cursor:"pointer", marginTop:4, alignSelf:"flex-end" }}>Cancelar</button>
          </div>
        )}

        {/* Loading */}
        {roteiroModal.loading && (
          <div style={{ textAlign:"center", padding:"40px 0", color:"#9C8F7E", fontSize:13 }}>
            <div style={{ fontSize:28, marginBottom:10 }}>{isObjecao?"🛡️":"🔄"}</div>
            ⏳ Analisando conversa e gerando sugestões…
          </div>
        )}

        {/* Resultado rico */}
        {roteiroModal.roteiro && (
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:14 }}>
              <span style={{ fontSize:18 }}>{isObjecao?"🛡️":"🔄"}</span>
              <span style={{ fontWeight:800, fontSize:13, color:accent, textTransform:"uppercase", letterSpacing:0.4 }}>
                {isObjecao?"Quebra de Objeção":"Reengajamento de Lead"}
              </span>
              <button onClick={()=>setRoteiroModal({ chooser:true })}
                style={{ marginLeft:"auto", background:"#F3EDE2", border:"none", borderRadius:8, padding:"4px 10px", fontSize:11, fontWeight:700, color:"#8B6F47", cursor:"pointer" }}>← Voltar</button>
            </div>

            {!temConteudo && (
              <div style={{ background:"#FFFBEB", border:"1px solid #FDE68A", borderRadius:10, padding:"14px", marginBottom:14, textAlign:"center" }}>
                <div style={{ fontSize:22, marginBottom:6 }}>🤔</div>
                <div style={{ fontSize:13, color:"#92400E", fontWeight:700, marginBottom:4 }}>Histórico insuficiente</div>
                <div style={{ fontSize:12, color:"#92400E", lineHeight:1.5 }}>
                  A IA não encontrou conversa suficiente para gerar sugestões contextualizadas.<br/>
                  Tente após o contato ter trocado ao menos algumas mensagens.
                </div>
              </div>
            )}

            {/* ── MODO OBJEÇÃO ── */}
            {isObjecao && <>
              {rot.insight && (
                <div style={{ background:"#F0FDF4", border:"1px solid #BBF7D0", borderRadius:10, padding:"10px 14px", marginBottom:10 }}>
                  <div style={{ fontSize:10, fontWeight:800, color:"#166534", marginBottom:4 }}>💡 INSIGHT</div>
                  {rot.tipo_objecao && <div style={{ fontSize:10, color:"#166534", fontWeight:700, marginBottom:4, opacity:0.75 }}>Tipo: {rot.tipo_objecao}</div>}
                  <div style={{ fontSize:12, color:"#166534", lineHeight:1.5 }}>{rot.insight}</div>
                </div>
              )}
              {rot.observacao && (
                <div style={{ background:"#FFFBEB", border:"1px solid #FDE68A", borderRadius:10, padding:"10px 14px", marginBottom:10 }}>
                  <div style={{ fontSize:10, fontWeight:800, color:"#92400E", marginBottom:4 }}>⚠️ COMO CONDUZIR</div>
                  <div style={{ fontSize:12, color:"#92400E", lineHeight:1.5 }}>{rot.observacao}</div>
                </div>
              )}
              {abordagens.length > 0 && (
                <div style={{ marginBottom:10 }}>
                  <div style={{ fontSize:10, fontWeight:800, color:accent, letterSpacing:0.4, marginBottom:8 }}>📝 RESPOSTAS PRONTAS PARA ENVIAR</div>
                  <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                    {abordagens.map((p, i) => {
                      const titulo = p.titulo || p.acao || `Opção ${i+1}`;
                      const frase  = p.frase  || p.texto || "";
                      return (
                        <div key={i} style={{ background:bg, border:`1px solid ${border}`, borderRadius:10, padding:"10px 14px" }}>
                          <div style={{ fontSize:10, fontWeight:800, color:accent, marginBottom:5 }}>{i+1}. {titulo}</div>
                          <div style={{ fontSize:13, color:"#2B1B12", lineHeight:1.65, whiteSpace:"pre-wrap" }}>{frase}</div>
                          <button onClick={()=>navigator.clipboard?.writeText(frase)}
                            style={{ marginTop:7, background:btnBg, color:accent, border:"none", borderRadius:7, padding:"5px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>📋 Copiar</button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {rot.evitar && (
                <div style={{ background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:10, padding:"10px 14px", marginBottom:10 }}>
                  <div style={{ fontSize:10, fontWeight:800, color:"#991B1B", marginBottom:4 }}>🚫 EVITAR</div>
                  <div style={{ fontSize:12, color:"#991B1B", lineHeight:1.5 }}>{rot.evitar}</div>
                </div>
              )}
            </>}

            {/* ── MODO REENGAJAMENTO ── */}
            {!isObjecao && <>
              {rot.contexto_parada && (
                <div style={{ background:"#F0FDF4", border:"1px solid #BBF7D0", borderRadius:10, padding:"10px 14px", marginBottom:10 }}>
                  <div style={{ fontSize:10, fontWeight:800, color:"#166534", marginBottom:4 }}>📍 ONDE A CONVERSA PAROU</div>
                  <div style={{ fontSize:12, color:"#166534", lineHeight:1.5 }}>{rot.contexto_parada}</div>
                </div>
              )}
              {rot.hipotese_motivo && (
                <div style={{ background:"#FFFBEB", border:"1px solid #FDE68A", borderRadius:10, padding:"10px 14px", marginBottom:10 }}>
                  <div style={{ fontSize:10, fontWeight:800, color:"#92400E", marginBottom:4 }}>💡 MELHOR ESTRATÉGIA PARA RETOMAR</div>
                  <div style={{ fontSize:12, color:"#92400E", lineHeight:1.5 }}>{rot.hipotese_motivo}</div>
                </div>
              )}
              {rot.melhor_horario && (
                <div style={{ background:bg, border:`1px solid ${border}`, borderRadius:10, padding:"8px 14px", marginBottom:10 }}>
                  <div style={{ fontSize:10, fontWeight:800, color:accent, marginBottom:3 }}>⏰ MELHOR HORÁRIO</div>
                  <div style={{ fontSize:12, color:accent, lineHeight:1.5 }}>{rot.melhor_horario}</div>
                </div>
              )}
              {mensagens.length > 0 && (
                <div style={{ marginBottom:10 }}>
                  <div style={{ fontSize:10, fontWeight:800, color:accent, letterSpacing:0.4, marginBottom:8 }}>📝 MENSAGENS PRONTAS DE REENGAJAMENTO</div>
                  <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                    {mensagens.map((m, i) => {
                      const texto = m.texto || m.frase || "";
                      const tom   = m.tom   || m.acao  || `Opção ${i+1}`;
                      return (
                        <div key={i} style={{ background:bg, border:`1px solid ${border}`, borderRadius:10, padding:"10px 14px" }}>
                          <div style={{ fontSize:10, fontWeight:800, color:accent, marginBottom:5 }}>{i+1}. Tom: {tom}</div>
                          <div style={{ fontSize:13, color:"#2B1B12", lineHeight:1.65, whiteSpace:"pre-wrap" }}>{texto}</div>
                          <button onClick={()=>navigator.clipboard?.writeText(texto)}
                            style={{ marginTop:7, background:btnBg, color:accent, border:"none", borderRadius:7, padding:"5px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>📋 Copiar</button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {/* fallback legado */}
              {mensagens.length === 0 && abordagens.length > 0 && (
                <div style={{ marginBottom:10 }}>
                  <div style={{ fontSize:10, fontWeight:800, color:accent, letterSpacing:0.4, marginBottom:8 }}>📝 SUGESTÕES DE RETOMADA</div>
                  <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                    {abordagens.map((p, i) => {
                      const titulo = p.titulo || p.acao || `Opção ${i+1}`;
                      const frase  = p.frase  || p.texto || "";
                      return (
                        <div key={i} style={{ background:bg, border:`1px solid ${border}`, borderRadius:10, padding:"10px 14px" }}>
                          <div style={{ fontSize:10, fontWeight:800, color:accent, marginBottom:5 }}>{i+1}. {titulo}</div>
                          <div style={{ fontSize:13, color:"#2B1B12", lineHeight:1.65, whiteSpace:"pre-wrap" }}>{frase}</div>
                          <button onClick={()=>navigator.clipboard?.writeText(frase)}
                            style={{ marginTop:7, background:btnBg, color:accent, border:"none", borderRadius:7, padding:"5px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>📋 Copiar</button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {rot.evitar && (
                <div style={{ background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:10, padding:"10px 14px", marginBottom:10 }}>
                  <div style={{ fontSize:10, fontWeight:800, color:"#991B1B", marginBottom:4 }}>🚫 EVITAR</div>
                  <div style={{ fontSize:12, color:"#991B1B", lineHeight:1.5 }}>{rot.evitar}</div>
                </div>
              )}
            </>}

            <div style={{ display:"flex", justifyContent:"flex-end", marginTop:4 }}>
              <button onClick={()=>setRoteiroModal(null)}
                style={{ background:"#8B6F47", color:"#fff", border:"none", borderRadius:8, padding:"8px 18px", fontSize:12, fontWeight:700, cursor:"pointer" }}>Fechar</button>
            </div>
          </div>
        )}

        {/* Erro */}
        {roteiroModal.error && (
          <div>
            <div style={{ color:"#DC2626", fontSize:13, padding:"12px", background:"#FEF2F2", borderRadius:8, marginBottom:12 }}>⚠️ {roteiroModal.error}</div>
            <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
              <button onClick={()=>setRoteiroModal({ chooser:true })} style={{ background:"#F3EDE2", color:"#8B6F47", border:"none", borderRadius:8, padding:"8px 14px", fontSize:12, fontWeight:700, cursor:"pointer" }}>← Tentar novamente</button>
              <button onClick={()=>setRoteiroModal(null)} style={{ background:"#8B6F47", color:"#fff", border:"none", borderRadius:8, padding:"8px 18px", fontSize:12, fontWeight:700, cursor:"pointer" }}>Fechar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Composer compartilhado (Atendimento Presencial + Central de Conversas) ──
// Mantém os limites em um único lugar: todas as telas que usam o compositor
// enviam pelo mesmo armazenamento permanente e pela mesma fila do servidor.
// Some browsers expose pasted screenshots only through `files`, while others
// advertise image MIME on the ClipboardItem but return a File with no MIME.
// Normalize only that latter case so the regular media pipeline can recognize it.
function normalizedPastedImageFile(file, advertisedType) {
  const mimeType = String(advertisedType || '').toLowerCase();
  if (!file || String(file.type || '').trim() || !mimeType.startsWith('image/')) return file;

  const name = file.name || `imagem-colada.${mimeType.slice('image/'.length) || 'png'}`;
  const options = { type:mimeType };
  if (Number.isFinite(file.lastModified)) options.lastModified = file.lastModified;
  if (typeof File !== 'undefined') return new File([file], name, options);
  return new Blob([file], options);
}

function pastedImageFile(clipboardData) {
  for (const item of Array.from(clipboardData?.items || [])) {
    const advertisedType = String(item?.type || '').toLowerCase();
    if (item?.kind !== 'file' || !advertisedType.startsWith('image/')) continue;
    const file = item.getAsFile?.();
    const normalizedFile = normalizedPastedImageFile(file, advertisedType);
    if (normalizedFile && mediaKindForFile(normalizedFile) === 'imagem') return normalizedFile;
  }
  return Array.from(clipboardData?.files || [])
    .find(file => mediaKindForFile(file) === 'imagem') || null;
}

// Microfone, anexos (foto/vídeo/áudio), nota interna (opcional) e envio de texto —
// tudo num único componente para que as duas telas tenham exatamente os mesmos recursos.
const COACH_DEMO_USUARIOS = [2];
export function ChatComposerBar({ onSendText, onSendMedia, allowNote=false, onSaveNote, noteTarget=null, placeholder="Digite sua mensagem…", disabled=false, replyTo=null, onClearReply, currentUser=null, storeId=null, reviewContext=null, onSendQRMedia=null, onGerarRoteiro=null, onToggleAguardandoRetorno=null, aguardandoRetorno=false, coachAlvo=null }) {
  const [savingTreatment,setSavingTreatment]=useState(false);
  const [treatmentError,setTreatmentError]=useState("");
  const treatmentIntentRef=useRef(null);
  const [text, setText] = useState("");
  const fallbackAttemptScope = useRef(`composer_${Date.now()}_${Math.random()}`);
  const attemptStore = storeId || coachAlvo?.storeId;
  const attemptPhone = reviewContext?.phone || coachAlvo?.phone;
  const attemptScope = textSendAttemptScope(attemptStore, attemptPhone) || fallbackAttemptScope.current;
  const textDraftRef = useRef(text);
  textDraftRef.current = text;
  const [sendingText, setSendingText] = useState(false);
  const [textSendError, setTextSendError] = useState("");
  const textSendLock = useRef(false);
  const [uploading, setUploading] = useState(false);
  const [mediaError, setMediaError] = useState("");
  const [retryableMedia, setRetryableMedia] = useState(null);
  const [stagedPastedImage, setStagedPastedImage] = useState(null);
  const pastedImageUrlRef = useRef(null);
  const [reviewingText, setReviewingText] = useState(false);
  const [reviewResult, setReviewResult] = useState(null); // eslint-disable-line no-unused-vars
  const [reviewError, setReviewError] = useState(""); // eslint-disable-line no-unused-vars
  const [editingReview, setEditingReview] = useState(false); // eslint-disable-line no-unused-vars
  const [editedReviewText, setEditedReviewText] = useState(""); // eslint-disable-line no-unused-vars
  const reviewRequestRef = useRef(0);
  const [showMediaMenu, setShowMediaMenu] = useState(false);
  const [showNoteBox, setShowNoteBox] = useState(false);
  const [noteText, setNoteText] = useState("");
  const [recording, setRecording] = useState(false);
  const [recSecs, setRecSecs] = useState(0);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef  = useRef([]);
  const recTimerRef     = useRef(null);
  const fileImgRef = useRef(null);
  const fileVidRef = useRef(null);
  const fileAudRef = useRef(null);
  const fileDocRef = useRef(null);
  const [stagedQR, setStagedQR] = useState(null);      // resposta rápida com mídia staged
  const [showQRModal, setShowQRModal] = useState(false);
  // Nova interface: produtos e fotos da loja dentro da conversa (só prepara a
  // foto como prévia; o envio continua sendo o botão Enviar de sempre).
  const nuProdutosAtivo = isNewUiEnabled() && !!onSendMedia;
  const [nuProdutos, setNuProdutos] = useState(null);
  // A avaliação no Google continua independente da demonstração da coach.
  const nuAvaliacaoAtiva = isNewUiEnabled() && Boolean(coachAlvo?.phone && coachAlvo?.storeId);
  const nuCoachAtivo = nuAvaliacaoAtiva && (
    ["admin", "superadmin"].includes(currentUser?.role)
    || (currentUser?.role === "consultant" && COACH_DEMO_USUARIOS.includes(Number(currentUser.id)))
  );
  const [nuCoach, setNuCoach] = useState(false);
  const nuUsarTexto = novo => setText(atual => (atual && atual.trim() ? `${atual.trim()}\n\n${novo}` : novo));
  const nuInserirAvaliacao = async () => {
    try {
      const r = await fetch(`/api/avaliacao/link?storeId=${encodeURIComponent(coachAlvo.storeId)}`, { credentials:"include" });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.mensagem) throw new Error(d.error || "Link de avaliação indisponível.");
      setMediaError("");
      nuUsarTexto(d.mensagem);
    } catch (err) { setMediaError(err.message); }
  };
  useEffect(() => {
    if (!nuProdutosAtivo) return undefined;
    const abrir = e => setNuProdutos({ fotoUrl: e.detail?.fotoUrl || null });
    window.addEventListener(EVENTO_PARECIDOS, abrir);
    return () => window.removeEventListener(EVENTO_PARECIDOS, abrir);
  }, [nuProdutosAtivo]);
  const personalReplies = useQuickReplies(storeId, currentUser?.id);
  const qrReplies = storeId && currentUser
    ? [{ _key:"shared-google-review", atalho:GOOGLE_REVIEW_SHORTCUT, titulo:GOOGLE_REVIEW_TITLE, shared:true }, ...personalReplies]
    : personalReplies;
  const [quickReplyError, setQuickReplyError] = useState("");
  const templateRequestRef = useRef(0);
  const templateIdentity = `${storeId || ""}:${reviewContext?.phone || ""}:${reviewContext?.nome || ""}:${reviewContext?.produto || ""}`;
  const templateIdentityRef = useRef(templateIdentity);
  templateIdentityRef.current = templateIdentity;
  const [reviewDraftIdentity, setReviewDraftIdentity] = useState(null);
  useEffect(() => {
    if (reviewDraftIdentity && reviewDraftIdentity !== templateIdentity) {
      setText("");
      setReviewDraftIdentity(null);
    }
  }, [reviewDraftIdentity, templateIdentity]);
  useEffect(() => () => { templateRequestRef.current += 1; }, []);
  // A miniatura local permite responder antes de a confirmação chegar, mas a
  // Z-API só entende o ID canônico do WhatsApp. Nunca envie id/zaapId local,
  // pois ela rejeita a mensagem inteira em vez de mandar sem citação.
  // providerMessageId is the only ID accepted by Z-API for a quote.  The
  // older waMessageId is a read-only migration alias; local id/zaapId never
  // leave the browser as a quote.
  const quotedMessageId = replyTo?.providerMessageId || replyTo?.waMessageId || null;
  useEffect(() => {
    bindTextSendAttemptSender(attemptScope, (options, r) =>
      onSendText?.(r.draft.trim(), r.quotedId, r.quote, options));
  }, [attemptScope, onSendText]);
  const waitingForQuotedMessageId = !!replyTo && !quotedMessageId;

  const clearStagedPastedImage = useCallback(() => {
    if (pastedImageUrlRef.current) URL.revokeObjectURL(pastedImageUrlRef.current);
    pastedImageUrlRef.current = null;
    setStagedPastedImage(null);
  }, []);
  useEffect(() => () => {
    if (pastedImageUrlRef.current) URL.revokeObjectURL(pastedImageUrlRef.current);
  }, []);

  const handlePaste = event => {
    const file = pastedImageFile(event.clipboardData);
    if (!file) return; // Text and every non-image clipboard item retain native paste behavior.
    event.preventDefault();
    if (file.size > CHAT_MEDIA_LIMITS.imagem) {
      setMediaError(mediaLimitMessage("imagem"));
      return;
    }
    if (!onSendMedia) {
      setMediaError("O envio de imagens não está disponível nesta conversa.");
      return;
    }
    setMediaError("");
    setRetryableMedia(null);
    clearStagedPastedImage();
    const previewUrl = URL.createObjectURL(file);
    pastedImageUrlRef.current = previewUrl;
    setStagedPastedImage({ file, previewUrl });
  };

  const handleTextChange = nextText => { // eslint-disable-line no-unused-vars
    textDraftRef.current = nextText;
    templateRequestRef.current += 1;
    reviewRequestRef.current += 1;
    setText(nextText);
    setReviewResult(null);
    setReviewError("");
    setEditingReview(false);
  };

  const selectQuickReply = async reply => {
    if (!reply.shared) {
      handleTextChange(reply.texto || "");
      setReviewDraftIdentity(null);
      setStagedQR(reply.midias?.length ? reply : null);
      setQuickReplyError("");
      return;
    }
    const requestId = ++templateRequestRef.current;
    const identity = templateIdentity;
    setQuickReplyError("");
    try {
      if (disabled) throw new Error("O envio desta conversa não está disponível.");
      if (!storeId || !reviewContext?.phone) throw new Error("Abra a conversa do cliente para usar a avaliação.");
      const response = await fetch(`/api/lift/review-links/${encodeURIComponent(storeId)}`, { credentials:"same-origin", cache:"no-store" });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.error || "Não foi possível consultar o link de avaliação.");
      if (Number(body.storeId) !== Number(storeId) || !body.url) throw new Error("Link de avaliação da loja não configurado.");
      const loja = GOOGLE_REVIEW_STORES[storeId];
      const draft = formatGoogleReviewMessage({
        nome:reviewContext.nome, consultor:currentUser?.name, loja,
        produto:reviewContext.produto, link:body.url,
      });
      if (requestId !== templateRequestRef.current || identity !== templateIdentityRef.current) return;
      handleTextChange(draft);
      setReviewDraftIdentity(identity);
      setStagedQR(null);
    } catch (error) {
      if (requestId === templateRequestRef.current && identity === templateIdentityRef.current) {
        setQuickReplyError(error.message || "Não foi possível preparar a avaliação.");
      }
    }
  };

  const reviewText = async () => { // eslint-disable-line no-unused-vars
    const requestedText = text.trim();
    if (disabled || !requestedText || reviewingText) return;
    const requestId = reviewRequestRef.current + 1;
    reviewRequestRef.current = requestId;
    setReviewingText(true);
    setReviewResult(null);
    setReviewError("");
    setEditingReview(false);
    try {
      const response = await fetch('/api/review-text', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: requestedText }),
      });
      const result = await response.json().catch(() => ({}));
      if (requestId !== reviewRequestRef.current) return;
      if (!response.ok || result.error) {
        throw new Error(result.error || 'Não foi possível concluir a revisão ortográfica');
      }
      const correctedText = typeof result.correctedText === 'string'
        ? result.correctedText.trim()
        : '';
      if (!correctedText) throw new Error('A revisão não retornou uma sugestão');
      setReviewResult({
        original: requestedText,
        corrected: correctedText,
        changes: Array.isArray(result.changes) ? result.changes : [],
      });
    } catch (error) {
      if (requestId === reviewRequestRef.current) {
        setReviewError(error.message || 'Não foi possível concluir a revisão ortográfica');
      }
    } finally {
      if (requestId === reviewRequestRef.current) setReviewingText(false);
    }
  };

  const applyReviewedText = nextText => { // eslint-disable-line no-unused-vars
    reviewRequestRef.current += 1;
    setText(nextText);
    setReviewResult(null);
    setReviewError("");
    setEditingReview(false);
  };

  const handleSend = async () => {
    if (disabled || uploading || textSendLock.current) return;
    if (!textDraftRef.current.trim() && !stagedQR?.midias?.length && !stagedPastedImage) return;
    // Text-only transport can continue independently of the editor. The media
    // pipeline below is intentionally unchanged and retains its upload guards.
    if (text.trim() && !stagedQR?.midias?.length && !stagedPastedImage) {
      const submittedDraft = textDraftRef.current;
      const submittedScope = attemptScope;
      setTextSendError("");
      templateRequestRef.current += 1;
      reviewRequestRef.current += 1;
      startTextSendAttempt({
        storeId:attemptStore, phone:attemptPhone, scope:submittedScope,
        draft:submittedDraft, quotedId:quotedMessageId, quote:replyTo,
        send:options => onSendText?.(submittedDraft.trim(), quotedMessageId, replyTo, options),
      });
      // Fence duplicate click/Enter before React renders. Later confirmations
      // never touch the editor, a newer draft, or its quotation.
      textDraftRef.current = "";
      setText("");
      setReviewDraftIdentity(null);
      setReviewResult(null);
      onClearReply?.();
      return;
    }
    textSendLock.current = true;
    const submittedDraft = text;
    const submittedIdentity = templateIdentityRef.current;
    let textAccepted = false;
    setTextSendError("");
    setSendingText(Boolean(text.trim()));
    try {
    templateRequestRef.current += 1;
    // Não deixa uma resposta de revisão que chegou atrasada preencher novamente
    // um rascunho que o consultor já enviou.
    reviewRequestRef.current += 1;
    if (text.trim()) {
      const result = await onSendText?.(text.trim(), quotedMessageId, replyTo);
      if (submittedIdentity !== templateIdentityRef.current) return;
      if (!isConfirmedTextSend(result)) {
        setTextSendError(textSendFailureMessage(result));
        return;
      }
      textAccepted = true;
      setText(current => current === submittedDraft ? "" : current);
      setReviewDraftIdentity(null);
      if (onClearReply) onClearReply();
    }
    if (stagedQR?.midias?.length && onSendQRMedia) {
      stagedQR.midias.forEach(m => onSendQRMedia(m, quotedMessageId, replyTo));
    }
    if (stagedPastedImage && onSendMedia) {
      setUploading(true);
      setMediaError("");
      try {
        await onSendMedia(stagedPastedImage.file, "imagem", quotedMessageId, replyTo);
        clearStagedPastedImage();
        if (replyTo && onClearReply) onClearReply();
      } catch (error) {
        setMediaError(error.message || "Não foi possível enviar a mídia. Tente novamente.");
        setRetryableMedia({ file:stagedPastedImage.file, tipo:"imagem", quotedMessageId, quotedMsg:replyTo, pasted:true });
      } finally {
        setUploading(false);
      }
    }
    setStagedQR(null);
    setReviewResult(null);
    setReviewError("");
    setEditingReview(false);
    } catch (error) {
      if (submittedIdentity === templateIdentityRef.current) {
        if (!textAccepted) setTextSendError(textSendFailureMessage(null));
        else setMediaError("A mensagem de texto foi aceita, mas não foi possível enviar o anexo. Tente enviar somente o anexo novamente.");
      }
    } finally {
      textSendLock.current = false;
      setSendingText(false);
    }
  };

  const saveInternalNote = async (waive=false) => {
    if ((!waive&&!noteText.trim())||savingTreatment) return;
    setSavingTreatment(true);setTreatmentError("");
    try{
      if(noteTarget){
        const key=JSON.stringify([noteTarget,waive?null:noteText.trim()]);
        if(treatmentIntentRef.current?.key!==key)treatmentIntentRef.current={key,id:`treat_${Date.now()}_${Math.random().toString(36).slice(2)}`};
        await saveConversationTreatment({...noteTarget,intentId:treatmentIntentRef.current.id},waive?null:noteText.trim());
        treatmentIntentRef.current=null;
      }
      else if(!waive)await onSaveNote(noteText.trim());
      setNoteText("");setShowNoteBox(false);notifyProspRefresh();
    }catch(error){setTreatmentError(error.message);}
    finally{setSavingTreatment(false);}
  };

  const retryMediaUpload = async () => {
    if (!retryableMedia || !onSendMedia || uploading) return;
    setUploading(true);
    setMediaError("");
    try {
      await onSendMedia(retryableMedia.file, retryableMedia.tipo, retryableMedia.quotedMessageId, retryableMedia.quotedMsg);
      if (retryableMedia.pasted) clearStagedPastedImage();
      setRetryableMedia(null);
      if (retryableMedia.quotedMsg && onClearReply) onClearReply();
    } catch (error) {
      setMediaError(error.message || 'Não foi possível enviar a mídia. Tente novamente.');
    } finally {
      setUploading(false);
    }
  };

  const handleFile = async (e) => {
    const files = Array.from(e.target.files || []);
    [fileImgRef, fileVidRef, fileAudRef, fileDocRef].forEach(r => { if (r.current) r.current.value = ""; });
    if (!files.length || !onSendMedia) return;
    setMediaError("");
    setRetryableMedia(null);
    const firstFile = files[0];
    const firstType = mediaKindForFile(firstFile) || (documentMimeType(firstFile) ? 'documento' : null);
    if (!firstType) { setMediaError("Formato não suportado. Envie imagem, vídeo, áudio ou documento seguro."); return; }
    // Para imagens permite envio de múltiplos arquivos de uma vez; vídeo/áudio só o primeiro
    const filesToSend = firstType === 'imagem' ? files : [firstFile];
    setUploading(true);
    for (const file of filesToSend) {
      const tipo = mediaKindForFile(file) || (documentMimeType(file) ? 'documento' : null);
      if (!tipo) { setMediaError("Formato não suportado. Envie imagem, vídeo, áudio ou documento seguro."); continue; }
      if (file.size > CHAT_MEDIA_LIMITS[tipo]) { setMediaError(mediaLimitMessage(tipo)); continue; }
      try {
        await onSendMedia(file, tipo, quotedMessageId, replyTo);
      } catch (error) {
        setMediaError(error.message || "Não foi possível enviar a mídia. Tente novamente.");
        setRetryableMedia({ file, tipo, quotedMessageId, quotedMsg: replyTo });
        break;
      }
    }
    setUploading(false);
    if (replyTo && onClearReply) onClearReply();
  };

  const startRecording = async () => {
    setMediaError("");
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setMediaError("Este navegador não permite gravar áudio. Tente usar o Chrome/Safari atualizado.");
      return;
    }
    let stream;
    try {
      stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    } catch {
      setMediaError("Microfone bloqueado. Permita o acesso ao microfone nas configurações do navegador/celular e tente novamente.");
      return;
    }
    try {
      // iPhone/Safari não suporta webm nem ogg — precisa de mp4/aac. Testa em ordem
      // de preferência e, se nada bater, deixa o navegador escolher o formato padrão.
      const candidates = ["audio/webm;codecs=opus", "audio/ogg;codecs=opus", "audio/mp4", "audio/aac"];
      const supported = candidates.find(t => window.MediaRecorder && MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(t));
      const mr = supported ? new MediaRecorder(stream, { mimeType: supported }) : new MediaRecorder(stream);
      audioChunksRef.current = [];
      mr.ondataavailable = e => { if (e.data.size > 0) audioChunksRef.current.push(e.data); };
      mr.start(200);
      mediaRecorderRef.current = mr;
      setRecording(true);
      setRecSecs(0);
      recTimerRef.current = setInterval(() => setRecSecs(s => s + 1), 1000);
    } catch (e) {
      stream.getTracks().forEach(t => t.stop());
      setMediaError("Não foi possível iniciar a gravação de áudio neste aparelho.");
    }
  };

  const stopAndSend = async (cancel = false) => {
    clearInterval(recTimerRef.current);
    setRecording(false);
    setRecSecs(0);
    const mr = mediaRecorderRef.current;
    if (!mr) return;
    mr.stream.getTracks().forEach(t => t.stop());
    if (cancel) { mr.stop(); return; }
    await new Promise(res => { mr.onstop = res; mr.stop(); });
    if (!audioChunksRef.current.length || !onSendMedia) return;
    const mime = mr.mimeType || "audio/webm";
    const blob = new Blob(audioChunksRef.current, { type: mime });
    const ext = mime.includes("ogg") ? "ogg" : mime.includes("mp4") ? "mp4" : mime.includes("aac") ? "aac" : "webm";
    const file = new File([blob], `audio_${Date.now()}.${ext}`, { type: mime });
    setUploading(true);
    try {
      await onSendMedia(file, "audio", quotedMessageId, replyTo);
      if (replyTo && onClearReply) onClearReply();
    }
    catch (e) { setMediaError(e.message || "Erro ao enviar áudio."); }
    setUploading(false);
  };

  return (
    <div>
      {nuCoach && nuCoachAtivo && (
        <AvaliacaoAtendimento theme={T} alvo={coachAlvo} onFechar={() => setNuCoach(false)} onUsar={nuUsarTexto} />
      )}
      {nuProdutos && nuProdutosAtivo && (
        <PainelProdutosConversa theme={T} fotoInicial={nuProdutos.fotoUrl} onFechar={() => setNuProdutos(null)}
          onUsarImagem={(file, legenda) => {
            if (file.size > CHAT_MEDIA_LIMITS.imagem) { setMediaError(mediaLimitMessage("imagem")); return false; }
            setMediaError(""); setRetryableMedia(null); clearStagedPastedImage();
            const previewUrl = URL.createObjectURL(file);
            pastedImageUrlRef.current = previewUrl;
            setStagedPastedImage({ file, previewUrl });
            if (legenda && !text.trim()) setText(legenda);
            return true;
          }} />
      )}
      {mediaError&&<div style={{ fontSize:11, color:"#EF4444", marginBottom:6 }}>⚠️ {mediaError} {retryableMedia&&<button onClick={retryMediaUpload} disabled={uploading} style={{ marginLeft:6, background:"transparent", color:"#B91C1C", border:"1px solid #FCA5A5", borderRadius:6, padding:"2px 6px", fontSize:10, fontWeight:800, cursor:uploading?"not-allowed":"pointer" }}>Tentar novamente</button>}</div>}
      {quickReplyError&&<div role="alert" style={{ fontSize:11, color:"#B91C1C", marginBottom:6 }}>⚠️ {quickReplyError}</div>}
      {reviewError&&<div role="alert" style={{ fontSize:11, color:"#B45309", background:"#FFFBEB", border:"1px solid #FDE68A", borderRadius:8, padding:"6px 9px", marginBottom:6 }}>⚠️ {reviewError}. Você pode enviar o texto original normalmente.</div>}
      {text.startsWith("/") && qrReplies.length > 0 && !showNoteBox && !recording && (
        <QuickRepliesPopup
          query={text}
          replies={qrReplies}
          onSelect={selectQuickReply}
        />
      )}
      {replyTo&&(
        <div style={{ display:"flex", alignItems:"flex-start", gap:8, background:"#EFF6FF", borderRadius:8, padding:"6px 10px", marginBottom:6, border:"1px solid #BFDBFE" }}>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontSize:9, fontWeight:800, color:"#1D4ED8", marginBottom:2 }}>↩ Respondendo {(replyTo.remetente==="consultor"||replyTo.remetente==="aurora")?"Consultor":"Cliente"}</div>
            {(replyTo.tipo==="imagem"||replyTo.tipo==="image")&&(
              resolveMediaSrc(replyTo.base64Data||replyTo.url, replyTo.storagePath)
                ? <img src={resolveMediaSrc(replyTo.base64Data||replyTo.url, replyTo.storagePath)} alt="Foto respondida" style={{ height:28, borderRadius:3, display:"block", marginBottom:2 }} onError={e=>e.target.style.display="none"} />
                : <div style={{ fontSize:10, color:"#1E40AF" }}>📷 Foto citada</div>
            )}
            {replyTo.tipo==="audio"&&<div style={{ fontSize:10, color:"#1E40AF" }}>🎵 Áudio</div>}
            {replyTo.tipo==="video"&&<div style={{ fontSize:10, color:"#1E40AF" }}>🎥 Vídeo</div>}
            <div style={{ fontSize:10, color:"#1E40AF", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{replyTo.texto||replyTo.caption||"(mídia)"}</div>
            {waitingForQuotedMessageId && <div style={{ fontSize:9, color:"#92400E", marginTop:2 }}>⚠️ Resposta ainda não confirmada pelo WhatsApp. A mensagem será enviada sem citação.</div>}
          </div>
          <button onClick={onClearReply} style={{ background:"none", border:"none", cursor:"pointer", color:"#94A3B8", fontSize:14, flexShrink:0, padding:0, lineHeight:1 }}>✕</button>
        </div>
      )}
      {reviewResult&&(
        <div role="status" aria-live="polite" style={{ background:"#F8FAFC", border:"1px solid #CBD5E1", borderRadius:10, padding:"9px 10px", marginBottom:7 }}>
          <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:5 }}>
            <span style={{ fontSize:13 }}>Aa</span>
            <strong style={{ fontSize:11, color:"#334155" }}>Revisão ortográfica</strong>
            <span style={{ fontSize:10, color:"#64748B", marginLeft:"auto" }}>Nada é enviado automaticamente</span>
          </div>
          {reviewResult.corrected===reviewResult.original ? (
            <div style={{ fontSize:11, color:"#475569", marginBottom:7 }}>Nenhuma correção encontrada. Você pode enviar o texto original.</div>
          ) : editingReview ? (
            <textarea
              autoFocus
              value={editedReviewText}
              onChange={e=>setEditedReviewText(e.target.value)}
              aria-label="Editar sugestão de revisão"
              rows={3}
              style={{ width:"100%", boxSizing:"border-box", padding:"7px 8px", borderRadius:7, border:"1px solid #94A3B8", fontSize:12, resize:"vertical", fontFamily:"inherit", lineHeight:1.4, marginBottom:7 }}
            />
          ) : (
            <>
              <div style={{ whiteSpace:"pre-wrap", fontSize:12, color:"#0F172A", background:"#fff", borderRadius:7, padding:"7px 8px", border:"1px solid #E2E8F0", marginBottom:5 }}>{reviewResult.corrected}</div>
              {reviewResult.changes.length > 0 && (
                <div style={{ fontSize:10, color:"#64748B", marginBottom:7 }}>
                  {reviewResult.changes.slice(0, 4).map((change, index) => <div key={`${change}-${index}`}>• {change}</div>)}
                </div>
              )}
            </>
          )}
          <div style={{ display:"flex", flexWrap:"wrap", gap:5 }}>
            {reviewResult.corrected===reviewResult.original ? (
              <button onClick={()=>setReviewResult(null)} style={{ background:"#E2E8F0", color:"#334155", border:"none", borderRadius:7, padding:"6px 10px", fontSize:11, cursor:"pointer", fontWeight:600 }}>Fechar</button>
            ) : editingReview ? (
              <>
                <button onClick={()=>applyReviewedText(editedReviewText.trim())} disabled={!editedReviewText.trim()} style={{ background:"#2563EB", color:"#fff", border:"none", borderRadius:7, padding:"6px 10px", fontSize:11, cursor:editedReviewText.trim()?"pointer":"not-allowed", fontWeight:700, opacity:editedReviewText.trim()?1:0.55 }}>Usar versão editada</button>
                <button onClick={()=>setEditingReview(false)} style={{ background:"#E2E8F0", color:"#334155", border:"none", borderRadius:7, padding:"6px 10px", fontSize:11, cursor:"pointer", fontWeight:600 }}>Cancelar edição</button>
              </>
            ) : (
              <>
                <button onClick={()=>applyReviewedText(reviewResult.corrected)} style={{ background:"#2563EB", color:"#fff", border:"none", borderRadius:7, padding:"6px 10px", fontSize:11, cursor:"pointer", fontWeight:700 }}>Aplicar correção</button>
                <button onClick={()=>{ setEditedReviewText(reviewResult.corrected); setEditingReview(true); }} style={{ background:"#E2E8F0", color:"#334155", border:"none", borderRadius:7, padding:"6px 10px", fontSize:11, cursor:"pointer", fontWeight:600 }}>Editar sugestão</button>
                <button onClick={()=>setReviewResult(null)} style={{ background:"transparent", color:"#64748B", border:"1px solid #CBD5E1", borderRadius:7, padding:"6px 10px", fontSize:11, cursor:"pointer", fontWeight:600 }}>Dispensar</button>
              </>
            )}
          </div>
        </div>
      )}
      {/* Barra de gravação de áudio — substitui a barra normal enquanto grava */}
      {noteTarget&&<button type="button" disabled={savingTreatment} onClick={()=>saveInternalNote(true)}
        style={{fontSize:11,margin:"0 0 8px",padding:"5px 9px",border:"1px solid #ddd",borderRadius:7,background:"#fff"}}>
        {savingTreatment?"Salvando…":"✅ Não precisa responder"}
      </button>}
      {treatmentError&&<div role="alert" style={{color:"#b91c1c",fontSize:12,marginBottom:8}}>{treatmentError}</div>}
      {recording ? (
        <div style={{ display:"flex", alignItems:"center", gap:10, background:"#FEF2F2", borderRadius:10, padding:"8px 14px", border:"1.5px solid #FECACA" }}>
          <span style={{ fontSize:18, animation:"pulse 1s infinite" }}>🔴</span>
          <span style={{ fontWeight:700, fontSize:13, color:"#DC2626", flex:1 }}>
            Gravando… {String(Math.floor(recSecs/60)).padStart(2,"0")}:{String(recSecs%60).padStart(2,"0")}
          </span>
          <button onClick={()=>stopAndSend(true)} title="Cancelar" style={{ background:"#F1F5F9", border:"none", borderRadius:8, padding:"6px 12px", fontSize:12, cursor:"pointer", color:"#64748B", fontWeight:600 }}>✕ Cancelar</button>
          <button onClick={()=>stopAndSend(false)} title="Parar e enviar" style={{ background:"#10B981", color:"#fff", border:"none", borderRadius:8, padding:"6px 14px", fontSize:12, cursor:"pointer", fontWeight:700 }}>⬆ Enviar</button>
        </div>
      ) : showNoteBox ? (
        <div style={{ display:"flex", alignItems:"center", gap:8, background:"#FFFBEB", borderRadius:10, padding:"8px 12px", border:"1.5px solid #FDE68A" }}>
          <span style={{ fontSize:16, flexShrink:0 }}>📝</span>
          <input autoFocus value={noteText} onChange={e=>setNoteText(e.target.value)} onKeyDown={e=>{ if(e.key==="Enter"){e.preventDefault();saveInternalNote();} if(e.key==="Escape"){setShowNoteBox(false);setNoteText("");} }} placeholder="Nota interna (só a equipe vê, não vai pro cliente)…" style={{ flex:1, padding:"8px 10px", borderRadius:8, border:"1px solid #FDE68A", fontSize:12, background:"#fff" }} />
          <button onClick={()=>{ setShowNoteBox(false); setNoteText(""); }} title="Cancelar" style={{ background:"#F1F5F9", border:"none", borderRadius:8, padding:"6px 12px", fontSize:12, cursor:"pointer", color:"#64748B", fontWeight:600, flexShrink:0 }}>✕</button>
          <button onClick={()=>saveInternalNote()} disabled={savingTreatment} title="Salvar nota" style={{ background:"#F59E0B", color:"#fff", border:"none", borderRadius:8, padding:"6px 14px", fontSize:12, cursor:"pointer", fontWeight:700, flexShrink:0 }}>Salvar</button>
        </div>
      ) : (
        <>
        {stagedQR?.midias?.length > 0 && (
          <div style={{ display:"flex", alignItems:"center", gap:8, background:"#EFF6FF", borderRadius:8, padding:"5px 10px", marginBottom:6, border:"1px solid #BFDBFE" }}>
            <div style={{ display:"flex", flexWrap:"wrap", gap:6, flex:1 }}>
              {stagedQR.midias.map((m,i) => (
                <span key={i} style={{ fontSize:11, color:"#1D4ED8", display:"flex", alignItems:"center", gap:3 }}>
                  {m.tipo==="video"?"🎥":"📷"} <span style={{ maxWidth:100, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{m.nome}</span>
                </span>
              ))}
            </div>
            <button onClick={()=>setStagedQR(null)} style={{ background:"none", border:"none", cursor:"pointer", color:"#94A3B8", fontSize:14, padding:"2px 4px" }}>✕</button>
          </div>
        )}
        {stagedPastedImage && (
          <div style={{ display:"flex", alignItems:"center", gap:8, background:"#EFF6FF", borderRadius:8, padding:"6px 10px", marginBottom:6, border:"1px solid #BFDBFE" }}>
            <img src={stagedPastedImage.previewUrl} alt="Prévia da imagem colada" style={{ width:44, height:44, objectFit:"cover", borderRadius:5, display:"block" }} />
            <div style={{ minWidth:0, flex:1, fontSize:11, color:"#1D4ED8" }}>
              <div style={{ fontWeight:700, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{stagedPastedImage.file.name || "imagem colada"}</div>
              <div>{(stagedPastedImage.file.size / 1024).toLocaleString("pt-BR", { maximumFractionDigits:1 })} KB</div>
            </div>
            <button onClick={clearStagedPastedImage} aria-label="Remover imagem colada" title="Remover imagem" style={{ background:"none", border:"none", cursor:"pointer", color:"#94A3B8", fontSize:16, padding:"2px 4px" }}>✕</button>
          </div>
        )}
        <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap" }}>
          <input ref={fileImgRef} type="file" accept="image/*" multiple style={{ display:"none" }} onChange={handleFile} />
          <input ref={fileVidRef} type="file" accept="video/*" style={{ display:"none" }} onChange={handleFile} />
          <input ref={fileAudRef} type="file" accept="audio/*" style={{ display:"none" }} onChange={handleFile} />
          <input ref={fileDocRef} type="file" accept=".pdf,.txt,.csv,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.odt,.ods,.odp,.rtf,.zip" style={{ display:"none" }} onChange={handleFile} />
          {allowNote && (
            <button onClick={()=>{ setShowMediaMenu(false); setShowNoteBox(true); }} title="Adicionar nota interna (só a equipe vê)" style={{ background:"#FEF3C7", border:"none", borderRadius:10, width:38, height:38, cursor:"pointer", fontSize:16, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>📝</button>
          )}
          {currentUser && storeId && !uploading && !recording && (
            <button onClick={()=>setShowQRModal(true)} title="⚡ Minhas respostas rápidas" style={{ background:"#FEF9F0", border:"none", borderRadius:10, width:38, height:38, cursor:"pointer", fontSize:16, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>⚡</button>
          )}
          {nuCoachAtivo && !uploading && !recording && (
            <button type="button" onClick={()=>setNuCoach(true)} title="Coach: o que responder agora" aria-label="Coach da conversa" style={{ display:"flex", alignItems:"center", justifyContent:"center", width:38, height:38, background:"#F5F3FF", border:"none", borderRadius:10, cursor:"pointer", fontSize:16, flexShrink:0 }}>🧠</button>
          )}
          {nuAvaliacaoAtiva && !uploading && !recording && (
            <button type="button" onClick={nuInserirAvaliacao} title="Pedir avaliação no Google (coloca a mensagem com o link na caixa)" aria-label="Pedir avaliação no Google" style={{ display:"flex", alignItems:"center", justifyContent:"center", width:38, height:38, background:"#FFFBEB", border:"none", borderRadius:10, cursor:"pointer", fontSize:16, flexShrink:0 }}>⭐</button>
          )}
          {nuProdutosAtivo && !uploading && !recording && (
            <button type="button" onClick={()=>setNuProdutos({ fotoUrl:null })} title="Produtos e fotos da loja" aria-label="Produtos e fotos da loja" style={{ display:"flex", alignItems:"center", justifyContent:"center", width:38, height:38, background:"#F4EBDD", border:"none", borderRadius:10, cursor:"pointer", fontSize:16, flexShrink:0 }}>🛋️</button>
          )}
          {onGerarRoteiro && !uploading && !recording && (
            <button onClick={onGerarRoteiro} title="✨ Ajuda da IA — sugestões de abordagem" style={{ display:"flex", alignItems:"center", justifyContent:"center", width:38, height:38, background:"#EDE9FE", border:"none", borderRadius:10, cursor:"pointer", fontSize:16, flexShrink:0 }}>✨</button>
          )}
          {onToggleAguardandoRetorno && !uploading && !recording && (
            <button onClick={onToggleAguardandoRetorno} title={aguardandoRetorno?"Desmarcar: aguardando retorno":"Marcar: aguardando retorno do cliente"} style={{ display:"flex", alignItems:"center", justifyContent:"center", width:38, height:38, background:aguardandoRetorno?"#DBEAFE":"#F3EDE2", border:"none", borderRadius:10, cursor:"pointer", fontSize:16, flexShrink:0 }}>🔵</button>
          )}
          {!uploading && !recording && (
            <button onClick={reviewText} disabled={!text.trim()||reviewingText||disabled} title="Revisar ortografia antes de enviar" aria-label="Revisar ortografia antes de enviar" style={{ display:"flex", alignItems:"center", justifyContent:"center", width:38, height:38, background:reviewingText?"#E0E7FF":"#EEF2FF", border:"none", borderRadius:10, cursor:(!text.trim()||reviewingText||disabled)?"not-allowed":"pointer", fontSize:15, flexShrink:0, opacity:(!text.trim()||disabled)?0.5:1 }}>
              {reviewingText?"⏳":"Aa"}
            </button>
          )}
          {onSendMedia&&(
            <div style={{ position:"relative", flexShrink:0 }}>
              <button onClick={()=>{ setMediaError(""); setShowMediaMenu(m=>!m); }} disabled={uploading} title="Enviar mídia" style={{ background:"#F1F5F9", border:"none", borderRadius:10, width:38, height:38, cursor:uploading?"not-allowed":"pointer", fontSize:17, display:"flex", alignItems:"center", justifyContent:"center", opacity:uploading?0.6:1 }}>
                {uploading?"⏳":"📎"}
              </button>
              {showMediaMenu&&!uploading&&(
                <div style={{ position:"absolute", bottom:"110%", left:0, background:"#fff", borderRadius:12, boxShadow:"0 4px 24px rgba(0,0,0,0.15)", border:"1px solid #E2E8F0", padding:"6px", zIndex:200, display:"flex", flexDirection:"column", gap:4, minWidth:160 }}>
                  {[["📷","Foto / Imagem",fileImgRef],["🎥","Vídeo",fileVidRef]].map(([icon,label,fref])=>(
                    <button key={label} onClick={()=>{ setShowMediaMenu(false); fref.current?.click(); }} style={{ background:"none", border:"none", borderRadius:8, padding:"8px 12px", fontSize:13, cursor:"pointer", textAlign:"left", display:"flex", alignItems:"center", gap:8, color:"#1E293B", fontWeight:600 }} onMouseEnter={e=>e.currentTarget.style.background="#F8FAFC"} onMouseLeave={e=>e.currentTarget.style.background="none"}>
                      <span style={{ fontSize:18 }}>{icon}</span>{label}
                    </button>
                  ))}
                  <button onClick={()=>{ setShowMediaMenu(false); fileDocRef.current?.click(); }} style={{ background:"none", border:"none", borderRadius:8, padding:"8px 12px", fontSize:13, cursor:"pointer", textAlign:"left", display:"flex", alignItems:"center", gap:8, color:"#1E293B", fontWeight:600 }}>
                    <span style={{ fontSize:18 }}>📎</span>Arquivo / Documento
                  </button>
                  {/* Gravar áudio direto no browser — sem depender de arquivo */}
                  <button onClick={()=>{ setShowMediaMenu(false); startRecording(); }} style={{ background:"none", border:"none", borderRadius:8, padding:"8px 12px", fontSize:13, cursor:"pointer", textAlign:"left", display:"flex", alignItems:"center", gap:8, color:"#DC2626", fontWeight:600 }} onMouseEnter={e=>e.currentTarget.style.background="#FEF2F2"} onMouseLeave={e=>e.currentTarget.style.background="none"}>
                    <span style={{ fontSize:18 }}>🎙️</span>Gravar áudio
                  </button>
                  {/* Arquivo de áudio existente — opção secundária */}
                  <button onClick={()=>{ setShowMediaMenu(false); fileAudRef.current?.click(); }} style={{ background:"none", border:"none", borderRadius:8, padding:"8px 12px", fontSize:13, cursor:"pointer", textAlign:"left", display:"flex", alignItems:"center", gap:8, color:"#64748B", fontWeight:500 }} onMouseEnter={e=>e.currentTarget.style.background="#F8FAFC"} onMouseLeave={e=>e.currentTarget.style.background="none"}>
                    <span style={{ fontSize:18 }}>🎵</span>Arquivo de áudio
                  </button>
                </div>
              )}
            </div>
          )}
          <ChatMessageInput value={text} onChange={handleTextChange} onSend={handleSend} onPaste={handlePaste} disabled={sendingText||uploading||disabled} placeholder={placeholder} maxHeight={160} style={{ borderRadius:10, order:2, flex:"1 1 calc(100% - 82px)", minWidth:0, minHeight:46, fontSize:14 }} />
          <button onClick={handleSend} disabled={sendingText||uploading||disabled} aria-busy={sendingText} style={{ background:`linear-gradient(135deg,${T.accent},${T.accentLight})`, color:"#fff", border:"none", borderRadius:10, padding:"0 14px", minHeight:46, fontWeight:700, fontSize:12, cursor:sendingText?"not-allowed":"pointer", flexShrink:0, alignSelf:"stretch", order:2 }}>{sendingText ? "Enviando…" : "Enviar ↑"}</button>
        </div>
        {textSendError && <div role="alert" style={{ color:"#B91C1C", background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:8, padding:"8px 10px", marginTop:7, fontSize:12 }}>{textSendError}</div>}
        </>
      )}
      {showQRModal && currentUser && storeId && <MyQuickRepliesModal storeId={storeId} userId={currentUser.id}
        onSelectShared={()=>{ setShowQRModal(false); selectQuickReply({ shared:true }); }}
        onClose={()=>setShowQRModal(false)} />}
    </div>
  );
}

function MetricCard({ label, value, sub, accent, icon, onClick }) {
  return (
    <div onClick={onClick} style={{ background:"#fff", borderRadius:14, padding:"18px 20px", boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderLeft:`4px solid ${accent}`, minWidth:0, cursor:onClick?"pointer":"default" }}>
      <div style={{ fontSize:22, marginBottom:2 }}>{icon}</div>
      <div style={{ fontSize:22, fontWeight:800, color:T.text, letterSpacing:-1 }}>{value}</div>
      <div style={{ fontSize:12, color:T.muted, marginTop:2 }}>{label}</div>
      {sub && <div style={{ fontSize:11, color:accent, fontWeight:700, marginTop:4 }}>{sub}</div>}
    </div>
  );
}

function ProgressBar({ value, max, color, label, motivational }) {
  const p = Math.min(pct(value, max), 100);
  return (
    <div style={{ marginBottom:16 }}>
      <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
        <span style={{ fontSize:12, color:T.muted }}>{label}</span>
        <span style={{ fontSize:12, fontWeight:700, color }}>{p}%</span>
      </div>
      <div style={{ background:T.sandDark, borderRadius:99, height:10, overflow:"hidden" }}>
        <div style={{ width:`${p}%`, height:"100%", background:`linear-gradient(90deg,${color},${color}cc)`, borderRadius:99, transition:"width 0.6s ease" }} />
      </div>
      {motivational && <div style={{ fontSize:11, color, fontWeight:600, marginTop:4 }}>{motivational}</div>}
    </div>
  );
}

function KanbanCard({ client, onClick, readonly, waMsgs }) {
  const isUrgent = client.stage === "final";
  const today = new Date().toISOString().split("T")[0];
  const phoneClean = normalizePhone(client.phone);
  const msgs = Object.values(waMsgs||{}).sort((a,b)=>a.timestamp>b.timestamp?1:-1);
  const lastMsg = msgs[msgs.length-1];
  const conversationState = getClientConversationState(client, msgs);
  const needsTeamReply = conversationState === "needs_team_reply";
  const hasWa = msgs.length > 0 && !!phoneClean;
  const followUpOverdue = client.followUp && client.followUp < today;
  const followUpToday = client.followUp && client.followUp === today;

  const timeAgo = (ts) => {
    if (!ts) return "";
    const mins = Math.floor((Date.now() - new Date(ts)) / 60000);
    if (mins < 2) return "agora";
    if (mins < 60) return `há ${mins}m`;
    const hrs = Math.floor(mins/60);
    if (hrs < 24) return `há ${hrs}h`;
    return `há ${Math.floor(hrs/24)}d`;
  };

  const hasAfazer = followUpToday || followUpOverdue
    || (client.posVendaDate && client.posVendaDate <= today)
    || (client.nextSaleDate && client.nextSaleDate <= today)
    || (client.deliveryDate && client.deliveryStatus !== "entregue" && client.deliveryDate <= today);
  return (
    <div onClick={() => !readonly && onClick(client)} style={{
      background: readonly ? T.sand : hasAfazer ? "#FFF7ED" : "#fff",
      borderRadius:10, padding:"12px 14px", marginBottom:8,
      cursor: readonly ? "default" : "pointer",
      opacity: readonly ? 0.72 : 1,
       border: needsTeamReply ? "2px solid #EF4444" : isUrgent ? `2px solid ${T.accent}` : hasAfazer ? `1.5px solid #D97706` : `1px solid ${T.sandDark}`,
       boxShadow: needsTeamReply ? "0 0 0 3px #FEE2E2" : isUrgent ? `0 0 0 3px ${T.accent}22` : hasAfazer ? "0 0 0 2px #D9770622" : "0 1px 4px rgba(0,0,0,0.06)",
      transition:"transform 0.15s",
      position:"relative",
    }}
      onMouseEnter={e => { if(!readonly) e.currentTarget.style.transform="translateY(-2px)"; }}
      onMouseLeave={e => e.currentTarget.style.transform="translateY(0)"}
    >
      {/* Header row: name + WA indicator */}
      <TextSendStatus storeId={client.storeId} phone={client.phone} readOnly={readonly} />
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:2 }}>
        <div>
          {isUrgent && <div style={{ fontSize:10, color:T.accent, fontWeight:700, marginBottom:2 }}>⚠️ Em Negociação — Mês fechando!</div>}
          <div style={{ fontWeight:700, fontSize:14, color:T.text }}>{client.name}</div>
        </div>
        {hasWa && (
          <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:2, flexShrink:0, marginLeft:6 }}>
            <div style={{ display:"flex", alignItems:"center", gap:4 }}>
              <span style={{ width:8, height:8, borderRadius:"50%", background:"#25D366", display:"inline-block", flexShrink:0 }} />
              <span style={{ fontSize:9, color:"#25D366", fontWeight:700 }}>WhatsApp</span>
            </div>
          </div>
        )}
      </div>

      {client.phone && <div style={{ fontSize:11, color:T.muted, marginTop:2 }}>📱 {client.phone}</div>}

      {/* Last WA message preview */}
      {hasWa && lastMsg && (() => {
        const texto = lastMsg.texto||lastMsg.content||lastMsg.body||lastMsg.text||lastMsg.message||"";
        const preview = texto.length > 40 ? texto.slice(0,40)+"…" : (texto||"📎 Mídia");
        const isFrom = messageSenderLabel(lastMsg, USERS);
        return (
          <div style={{ fontSize:10, color:"#64748B", marginTop:5, background:"#F0FFF4", borderRadius:6, padding:"4px 8px", borderLeft:"3px solid #25D366" }}>
            <span style={{ fontWeight:700 }}>{isFrom}: </span>{preview}
            {lastMsg.timestamp && <span style={{ color:"#94A3B8", marginLeft:4 }}>{timeAgo(lastMsg.timestamp)}</span>}
          </div>
        );
      })()}
      {needsTeamReply && (
        <div style={{ fontSize:10, color:"#B91C1C", background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:6, padding:"3px 8px", marginTop:5, fontWeight:800 }}>
          🔴 Responder cliente
        </div>
      )}
      {conversationState === "awaiting_customer" && (
        <div style={{ fontSize:10, color:"#166534", background:"#F0FDF4", border:"1px solid #BBF7D0", borderRadius:6, padding:"3px 8px", marginTop:5, fontWeight:700 }}>
          ✓ Respondido — aguardando cliente
        </div>
      )}
      {conversationState === "closing_message" && (
        <div style={{ fontSize:10, color:"#475569", background:"#F8FAFC", border:"1px solid #E2E8F0", borderRadius:6, padding:"3px 8px", marginTop:5, fontWeight:700 }}>
          ✓ Conversa encerrada
        </div>
      )}

      {(() => {
        const atendDate = client.createdAt;
        const stageDate = (client.stageDates||{})[client.stage] || client.createdAt;
        const diasNaEtapa = stageDate ? Math.floor((new Date(today) - new Date(stageDate)) / 86400000) : null;
        const diasTotal   = atendDate  ? Math.floor((new Date(today) - new Date(atendDate))  / 86400000) : null;
        return (
          <div style={{ display:"flex", gap:6, marginTop:5, flexWrap:"wrap" }}>
            {atendDate && <span style={{ fontSize:10, color:T.muted, background:T.sand, borderRadius:6, padding:"2px 6px" }}>📋 {fmtDate(atendDate)}</span>}
            {diasNaEtapa !== null && <span style={{ fontSize:10, color: diasNaEtapa > 7 ? "#D97706" : T.muted, background:T.sand, borderRadius:6, padding:"2px 6px", fontWeight: diasNaEtapa > 7 ? 700 : 400 }}>⏱ {diasNaEtapa === 0 ? "hoje" : `${diasNaEtapa}d nesta etapa`}</span>}
            {diasTotal !== null && diasTotal !== diasNaEtapa && <span style={{ fontSize:10, color:T.muted, background:T.sand, borderRadius:6, padding:"2px 6px" }}>🗓 {diasTotal}d total</span>}
          </div>
        );
      })()}

      <div style={{ display:"flex", gap:6, marginTop:6, flexWrap:"wrap" }}>
        <Badge color={T.gold}>{fmt(client.value)}</Badge>
        <ClientOriginLabels client={client} />
        {client.product && <Badge color="#8B5CF6">{client.product.length>18?client.product.slice(0,17)+"…":client.product}</Badge>}
      </div>

      {client.note && <div style={{ fontSize:11, color:T.muted, marginTop:6, fontStyle:"italic" }}>💬 {client.note.length>55?client.note.slice(0,54)+"…":client.note}</div>}

      {/* Follow-up badge */}
      {client.followUp && (
        <div style={{ fontSize:10, marginTop:5, fontWeight:700, padding:"3px 8px", borderRadius:6, display:"inline-block",
          background: followUpOverdue ? "#FEE2E2" : followUpToday ? "#FFF3CD" : "#F0FFF4",
          color: followUpOverdue ? "#EF4444" : followUpToday ? "#D97706" : T.positive,
          border: followUpOverdue ? "1px solid #EF4444" : followUpToday ? "1px solid #D97706" : "1px solid #6B8F3E",
        }}>
          {followUpOverdue ? `⚠️ Follow-up ATRASADO — ${fmtDate(client.followUp)}` : followUpToday ? `🔔 Follow-up HOJE — ${fmtDate(client.followUp)}` : `📅 Follow-up: ${fmtDate(client.followUp)}`}
        </div>
      )}

      {client.deliveryDate && client.deliveryStatus !== "entregue" && (() => {
        const diff = Math.ceil((new Date(client.deliveryDate) - new Date(today)) / 86400000);
        if (diff <= 3 && diff >= 0) return <div style={{ fontSize:10, color:"#D97706", marginTop:4, fontWeight:700 }}>⚠️ Entrega em {diff === 0 ? "HOJE" : `${diff} dia${diff>1?"s":""}`}!</div>;
        if (diff < 0) return <div style={{ fontSize:10, color:"#EF4444", marginTop:4, fontWeight:700 }}>🚨 Entrega ATRASADA!</div>;
        return <div style={{ fontSize:10, color:T.muted, marginTop:4 }}>📦 Entrega: {fmtDate(client.deliveryDate)} · {client.deliveryStatus==="confirmada"?"✅ Confirmada":"⏳ Aguardando"}</div>;
      })()}
    </div>
  );
}

// ── Registrar Venda a partir de qualquer conversa (Leads, Prospecção, Atendimento Presencial, Central de Conversas) ──
const FORMAS_PAGAMENTO = ["Pix", "Cartão de Crédito", "Cartão de Débito", "Dinheiro", "Boleto", "Outro"];

function ManualSaleAction({ currentUser, onClick, children, style, noticeStyle, disabled = false }) {
  if (!canManuallyRegisterSale(currentUser)) {
    return (
      <div role="status" style={{ fontSize:12, fontWeight:700, color:"#92400E", lineHeight:1.5, ...noticeStyle }}>
        {MANUAL_SALE_CUTOFF_NOTICE}
      </div>
    );
  }
  return (
    <button type="button" onClick={onClick} disabled={disabled} style={style}>
      {children || "Registrar Venda"}
    </button>
  );
}

export function RegistrarVendaModal({ contactName, phone, moduleId, currentUser, defaultConsultantId, defaultStoreId, onClose, onSave }) {
  const today = new Date().toISOString().split("T")[0];
  const isConsultant = currentUser?.role === "consultant";
  const isProspectSale = moduleId === "prospeccao";
  const [valor, setValor] = useState("");
  const [produtos, setProdutos] = useState("");
  const [storeId, setStoreId] = useState(defaultStoreId || currentUser?.storeId || STORES[0]?.id);
  const [consultantId, setConsultantId] = useState(isConsultant ? currentUser.id : (defaultConsultantId || ""));
  const [dataVenda, setDataVenda] = useState(today);
  const [formaPagamento, setFormaPagamento] = useState("");
  const [observacoes, setObservacoes] = useState("");
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [followUp, setFollowUp] = useState("");
  const [posVendaDate, setPosVendaDate] = useState("");
  const [nextSaleDate, setNextSaleDate] = useState("");
  const [nextSaleNote, setNextSaleNote] = useState("");

  const storeConsultants = USERS.filter(u => u.role === "consultant" && (!storeId || u.storeId === Number(storeId)));
  const moduleLabel = { leads:"Lead", prospeccao:"Prospecção", kanban:"Atendimento Presencial", inbox:"Central de Conversas" }[moduleId] || "";

  const inp = { width:"100%", padding:"9px 12px", borderRadius:8, border:"1.5px solid #D4C5A9", fontSize:14, boxSizing:"border-box", fontFamily:"inherit" };
  const lbl = { fontSize:12, fontWeight:700, color:"#2B1B12", display:"block", marginBottom:5 };
  const valorNum = parseValorBR(valor);

  const handleSave = async () => {
    if (valorNum <= 0 || saving) return;
    if (!canManuallyRegisterSale(currentUser)) throw new Error(MANUAL_SALE_CUTOFF_NOTICE);
    setSaving(true);
    setSaveError("");
    try {
      await onSave({
        valor: valorNum,
        produtos: produtos.trim(),
        storeId: storeId ? Number(storeId) : null,
        consultantId: consultantId ? Number(consultantId) : null,
        data: dataVenda,
        formaPagamento,
        observacoes: observacoes.trim(),
        deliveryDate: deliveryDate || null,
        followUp: followUp || null,
        posVendaDate: posVendaDate || null,
        nextSaleDate: nextSaleDate || null,
        nextSaleNote: nextSaleNote.trim(),
      });
    } catch (e) {
      console.error('[RegistrarVenda] erro ao salvar:', e);
      setSaveError(e?.message || "Não foi possível salvar a venda. Tente novamente.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:2000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }} onClick={onClose}>
      <div style={{ background:"#fff", borderRadius:18, padding:26, width:"100%", maxWidth:460, maxHeight:"90vh", overflowY:"auto", boxShadow:"0 20px 60px rgba(0,0,0,0.3)" }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
          <div style={{ fontWeight:800, fontSize:18, color:"#2B1B12" }}>🟢 Registrar Venda</div>
          <button onClick={onClose} style={{ background:"none", border:"none", fontSize:20, cursor:"pointer", color:"#8B6F47" }}>✕</button>
        </div>
        <div style={{ fontSize:12, color:"#8B6F47", marginBottom:18 }}>
          {contactName || "Cliente"} {phone ? `· 📱 ${phone}` : ""} {moduleLabel ? `· ${moduleLabel}` : ""}
        </div>
        <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
            <div>
              <label style={lbl}>Valor da venda (R$) *</label>
              <input style={{ ...inp, fontWeight:700, color:"#2563EB" }} type="text" value={valor} onChange={e=>setValor(e.target.value)} placeholder="Ex: 3.500,00" autoFocus />
            </div>
            <div>
              <label style={lbl}>Data da venda</label>
              <input style={inp} type="date" value={dataVenda} onChange={e=>setDataVenda(e.target.value)} />
            </div>
          </div>
          <div>
            <label style={lbl}>Produto(s) vendido(s)</label>
            <input style={inp} value={produtos} onChange={e=>setProdutos(e.target.value)} placeholder="Ex: Sofá 3 lugares + puff" />
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
            <div>
              <label style={lbl}>Loja</label>
              <select style={{ ...inp, background:"#fff" }} value={storeId||""} onChange={e=>setStoreId(e.target.value)} disabled={isConsultant}>
                {STORES.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>Consultor responsável</label>
              <select style={{ ...inp, background:"#fff" }} value={consultantId||""} onChange={e=>setConsultantId(e.target.value)} disabled={isConsultant}>
                <option value="">Selecione…</option>
                {storeConsultants.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
              </select>
            </div>
          </div>
          {isProspectSale && (
            <div role="status" style={{ fontSize:11, color:"#64748B", marginTop:-8 }}>
              O cartão mantém seus responsáveis atuais. A venda financeira continua vinculada a esta ficha e usa a loja e o consultor selecionados.
            </div>
          )}
          <div>
            <label style={lbl}>Forma de pagamento (opcional)</label>
            <select style={{ ...inp, background:"#fff" }} value={formaPagamento} onChange={e=>setFormaPagamento(e.target.value)}>
              <option value="">Não informado</option>
              {FORMAS_PAGAMENTO.map(f => <option key={f} value={f}>{f}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>Observações</label>
            <textarea style={{ ...inp, resize:"vertical" }} rows={3} value={observacoes} onChange={e=>setObservacoes(e.target.value)} placeholder="Detalhes adicionais da venda…" />
          </div>

          <div style={{ borderTop:"1px solid #F0E9DB", paddingTop:12, marginTop:2 }}>
            <div style={{ fontSize:12.5, fontWeight:800, color:"#2B1B12", marginBottom:10 }}>📅 Programações automáticas (opcional)</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div>
                <label style={lbl}>📦 Data de entrega</label>
                <input style={inp} type="date" value={deliveryDate} onChange={e=>setDeliveryDate(e.target.value)} />
              </div>
              <div>
                <label style={lbl}>📅 Follow-up</label>
                <input style={inp} type="date" value={followUp} onChange={e=>setFollowUp(e.target.value)} />
              </div>
              <div>
                <label style={lbl}>⭐ Pós-venda</label>
                <input style={inp} type="date" value={posVendaDate} onChange={e=>setPosVendaDate(e.target.value)} />
              </div>
              <div>
                <label style={lbl}>🔄 Próxima venda (reengajamento)</label>
                <input style={inp} type="date" value={nextSaleDate} onChange={e=>setNextSaleDate(e.target.value)} />
              </div>
              {nextSaleDate && (
                <div>
                  <label style={lbl}>O que ofertar na próxima venda?</label>
                  <input style={inp} value={nextSaleNote} onChange={e=>setNextSaleNote(e.target.value)} placeholder="Ex: Oferecer conjunto de puffs" />
                </div>
              )}
            </div>
          </div>

          <div style={{ fontSize:11, color:"#8B6F47", background:"#FEF9F0", border:"1px solid #D4C5A9", borderRadius:8, padding:"8px 12px" }}>
            Ao salvar, o cliente é movido para a etapa de venda concluída, o histórico da conversa é mantido, os indicadores são atualizados automaticamente e os lembretes preenchidos acima aparecem na Central de Tarefas.
          </div>
          {saveError && (
            <div role="alert" style={{ fontSize:12, fontWeight:700, color:"#B91C1C", background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:8, padding:"9px 12px" }}>
              ⚠️ {saveError}
            </div>
          )}
          <div style={{ display:"flex", gap:10, justifyContent:"flex-end", marginTop:4 }}>
            <button onClick={onClose} style={{ background:"#F3EDE2", color:"#2B1B12", border:"none", borderRadius:10, padding:"10px 20px", fontSize:14, fontWeight:700, cursor:"pointer" }}>Cancelar</button>
            <button onClick={handleSave} disabled={valorNum<=0||saving} style={{ background:(valorNum>0&&!saving)?"#10B981":"#ccc", color:"#fff", border:"none", borderRadius:10, padding:"10px 22px", fontSize:14, fontWeight:700, cursor:(valorNum>0&&!saving)?"pointer":"default" }}>
              {saving ? "Salvando…" : "🎉 Registrar Venda"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ClientModal({ client, onClose, onUpdate, onDelete, onAddReminder, storeId, onSendZapi, onSendZapiMedia, onDeleteWhatsAppMessage, onEditWhatsAppMessage, whatsappMsgs, onReturnToAurora, currentUser, onMarkRead, onRegistrarVenda, onConversationActive, layout = "modal" }) {
  const inline = layout === "inline";
  const exitGuard = useFutureFollowUpExit(client, `client:${client.storeId}:${normalizePhone(client.phone)}:${client.id}`, onClose, {
    getDate:() => followUp,
    onSave:(date, context) => saveNextContactOnExit(client, date, {
      kind:"client", update:onUpdate, addReminder:onAddReminder, ...context,
    }),
    screen:"central",
  });
  const [stage, setStage] = useState(client.stage);
  const [note, setNote]   = useState(client.note || "");
  const [followUp, setFollowUp] = useState(client.followUp || "");
  const [value, setValue] = useState(client.value || 0);
  const [nextSaleValue, setNextSaleValue] = useState(client.nextSaleValue || 0);
  const [name, setName]   = useState(client.name || "");
  const [phone, setPhone] = useState(client.phone || "");
  const [product, setProduct] = useState(client.product || "");
  const [origin, setOrigin]   = useState(client.origin || ORIGINS[0]);
  const [birthday, setBirthday] = useState(client.birthday || "");
  const [nextSaleDate, setNextSaleDate] = useState(client.nextSaleDate || "");
  const [nextSaleNote, setNextSaleNote] = useState(client.nextSaleNote || "");
  const [paidValue, setPaidValue] = useState(
    client.paidValue !== undefined ? client.paidValue
      : client.stage === "closed" ? (client.value || 0) : 0
  );
  const [deliveryDate,   setDeliveryDate]   = useState(client.deliveryDate   || "");
  const [deliveryStatus, setDeliveryStatus] = useState(client.deliveryStatus || "aguardando");
  const [posVendaDate,   setPosVendaDate]   = useState(client.posVendaDate   || "");
  const [showChat, setShowChat] = useState(inline);
  const [inlineBusy, setInlineBusy] = useState(false);
  const inlineBusyRef = useRef(false);
  const [inlineError, setInlineError] = useState("");
  const isStaffInline = currentUser?.role === "admin" || currentUser?.role === "manager";
  const inlineConsultants = inline && isStaffInline ? conversationConsultantsInScope(currentUser, USERS) : null;
  const runInlineUpdate = (changes) => {
    if (inlineBusyRef.current) return;
    if (changes.consultantId !== undefined && !activeConversationExitGuard.canExit()) {
      alert(FUTURE_FOLLOW_UP_REQUIRED_MESSAGE);
      return;
    }
    inlineBusyRef.current = true;
    setInlineError("");
    setInlineBusy(true);
    const updated = { ...client, ...changes };
    Promise.resolve().then(() => onUpdate(updated))
      .then(() => { exitGuard.saved(updated); exitGuard.dismiss(); })
      .catch(error => {
        console.error("[ClientModal] Falha ao salvar ação rápida:", error);
        const message = "Não foi possível salvar a alteração. Tente novamente.";
        setInlineError(message);
        // O usuário pode navegar enquanto a gravação está pendente; o aviso
        // também precisa chegar quando o painel já foi desmontado.
        alert(message);
      })
      .finally(() => { inlineBusyRef.current = false; setInlineBusy(false); });
  };
  const [replyTo2, setReplyTo2] = useState(null);
  const [roteiroModalClient, setRoteiroModalClient] = useState(null);
  const chatRef2 = useRef(null);
  useConversationDiagnosticView(client.storeId || storeId, normalizePhone(client.phone || client.telefone), chatRef2);
  const phoneClean = normalizePhone(phone);
  const attendanceConversationPhone = canonicalPhone(client.phone);
  const clientWaMsgs = whatsappMsgs ? getWaMsgsForPhone(whatsappMsgs, attendanceConversationPhone, client.storeId) : {};
  const sortedWaMsgs = Object.entries(clientWaMsgs).map(([id,m])=>({...m,id})).sort((a,b)=>a.timestamp>b.timestamp?1:-1);
  const pendingValue = Math.max(0, (value || 0) - (paidValue || 0));
  const wasAlreadyClosed = client.stage === "closed";
  const wasAlreadyPostSale = client.stage === "posVenda" || client.stage === "nextSale";
  useConversationPresence({
    phone:normalizePhone(client.phone || client.telefone),
    storeId:client.storeId || storeId, module:"kanban", onConversationActive,
  });
  useEffect(()=>{if(showChat&&chatRef2.current)chatRef2.current.scrollTop=chatRef2.current.scrollHeight;},[sortedWaMsgs.length,showChat]); // eslint-disable-line
  useEffect(()=>{ if(onMarkRead && attendanceConversationPhone) onMarkRead(conversationKey(client.storeId, attendanceConversationPhone)); },[sortedWaMsgs.length]); // eslint-disable-line

  return (
    <div className={inline ? "nu-client-panel" : undefined} style={inline ? {} : { position:"fixed", inset:0, background:"rgba(15,31,61,0.6)", zIndex:100, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={inline ? { background:"#fff", borderRadius:6, padding:20, display:"flex", flexDirection:"column", maxHeight:"calc(100vh - 120px)", overflowY:"auto", border:`1px solid ${T.nuLine || T.sandDark}` } : { background:"#fff", borderRadius:18, padding:28, width:"100%", maxWidth:480, maxHeight:"90vh", overflowY:"auto", boxShadow:"0 20px 60px rgba(0,0,0,0.25)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20, order:inline ? -3 : undefined }}>
          <div style={{ fontWeight:800, fontSize:20, color:T.text }}>{inline ? (name || "Cliente") : "Editar Cliente"}</div>
          <button onClick={exitGuard.dismiss} disabled={inline && inlineBusy} aria-label="Fechar card do cliente" style={{ background:T.sandDark, border:"none", borderRadius:99, width:32, height:32, cursor:"pointer", fontSize:16 }}>✕</button>
        </div>
        {inline && !["closed","posVenda","nextSale","semInteresse"].includes(client.stage) && (
          <ClientActionsBar theme={T} busy={inlineBusy}
            reasons={DESQUALIFICACAO_REASONS}
            consultants={inlineConsultants}
            canTransfer={isStaffInline && Array.isArray(inlineConsultants) && inlineConsultants.length > 0}
            currentConsultantId={client.consultantId}
            onDisqualify={(tipo, texto) => runInlineUpdate({ stage:"semInteresse", motivo_desqualificacao_tipo:tipo, motivo_desqualificacao:texto || (DESQUALIFICACAO_REASONS.find(r => r.id === tipo)?.label || "") })}
            onTransfer={consultantId => runInlineUpdate({ consultantId })} />
        )}
        {inline && inlineError && <div role="alert" style={{ color:"#B42318", marginBottom:12 }}>{inlineError}</div>}

        <div style={{ marginBottom:12 }}>
          <label style={{ fontSize:12, fontWeight:700, color:T.text, display:"block", marginBottom:4 }}>Nome</label>
          <input value={name} onChange={e=>setName(e.target.value)} style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:14, boxSizing:"border-box" }} />
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:12 }}>
          <div>
            <label style={{ fontSize:12, fontWeight:700, color:T.text, display:"block", marginBottom:4 }}>Telefone</label>
            <input value={phone} onChange={e=>setPhone(e.target.value)} style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:14, boxSizing:"border-box" }} />
          </div>
          <div>
            <label style={{ fontSize:12, fontWeight:700, color:T.text, display:"block", marginBottom:4 }}>Origem</label>
            <select value={origin} onChange={e=>setOrigin(e.target.value)} style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:14, background:"#fff" }}>
              {ORIGINS.map(o=><option key={o}>{o}</option>)}
            </select>
          </div>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:12 }}>
          <div>
            <label style={{ fontSize:12, fontWeight:700, color:T.text, display:"block", marginBottom:4 }}>Produto(s) de interesse</label>
            <input value={product} onChange={e=>setProduct(e.target.value)} placeholder="Ex: sofá e mesa" style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:14, boxSizing:"border-box" }} />
          </div>
          <div>
            <label style={{ fontSize:12, fontWeight:700, color:T.text, display:"block", marginBottom:4 }}>🎂 Aniversário</label>
            <input type="date" value={birthday} onChange={e=>setBirthday(e.target.value)} style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:14, boxSizing:"border-box" }} />
          </div>
        </div>

        <div style={{ marginBottom:14 }}>
          {(stage === "posVenda" || stage === "nextSale") ? (
            <>
              <label style={{ fontSize:12, fontWeight:700, color:T.muted, display:"block", marginBottom:6 }}>🔒 Valor da Venda Fechada (R$) — histórico</label>
              <div style={{ padding:"10px 12px", borderRadius:8, border:`2px solid ${T.sandDark}`, background:T.sand, fontSize:18, fontWeight:700, color:T.muted, display:"flex", alignItems:"center", gap:8 }}>
                {fmt(value)}
                <span style={{ fontSize:10, fontWeight:600, color:T.muted, background:"#E2E8F0", borderRadius:99, padding:"2px 8px" }}>Bloqueado</span>
              </div>
              <div style={{ fontSize:10, color:T.muted, marginTop:4 }}>Este valor é histórico e não pode ser alterado. Use o campo abaixo para o valor esperado da próxima venda.</div>
              <label style={{ fontSize:12, fontWeight:700, color:"#7C3AED", display:"block", marginBottom:6, marginTop:12 }}>💰 Valor Esperado — Próxima Venda (R$)</label>
              <input type="number" value={nextSaleValue} onChange={e => setNextSaleValue(parseFloat(e.target.value)||0)} style={{ width:"100%", padding:"10px 12px", borderRadius:8, border:"2px solid #7C3AED", fontSize:18, fontWeight:700, color:"#7C3AED", boxSizing:"border-box" }} />
            </>
          ) : (
            <>
              <label style={{ fontSize:12, fontWeight:700, color:T.text, display:"block", marginBottom:6 }}>💰 Valor Total da Venda (R$)</label>
              <input type="number" value={value} onChange={e => setValue(parseFloat(e.target.value)||0)} style={{ width:"100%", padding:"10px 12px", borderRadius:8, border:`2px solid ${T.gold}`, fontSize:18, fontWeight:700, color:T.accent, boxSizing:"border-box" }} />
            </>
          )}
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:14 }}>
          <div>
            <label style={{ fontSize:12, fontWeight:700, color:T.positive, display:"block", marginBottom:6 }}>💵 Valor Recebido (R$)</label>
            <input type="number" value={paidValue} onChange={e => setPaidValue(Math.min(parseFloat(e.target.value)||0, value||0))} style={{ width:"100%", padding:"10px 12px", borderRadius:8, border:`2px solid ${T.positive}`, fontSize:16, fontWeight:700, color:T.positive, boxSizing:"border-box" }} />
          </div>
          <div>
            <label style={{ fontSize:12, fontWeight:700, color: pendingValue>0 ? "#D97706" : T.muted, display:"block", marginBottom:6 }}>⏳ A Receber</label>
            <div style={{ padding:"10px 12px", borderRadius:8, border:`2px solid ${pendingValue>0?"#D97706":T.sandDark}`, background: pendingValue>0?"#FFF8E6":T.sand, fontSize:16, fontWeight:700, color: pendingValue>0?"#D97706":T.muted }}>
              {fmt(pendingValue)}
            </div>
          </div>
        </div>
        <div style={{ marginBottom:14 }}>
          <label style={{ fontSize:12, fontWeight:700, color:T.text, display:"block", marginBottom:6 }}>Etapa no Atendimento</label>
          <LiftSaleStageSelect moduleId="kanban" record={client} value={stage} saleStage="closed"
            onChange={setStage} disabled={inlineBusy}
            options={STAGES.filter(s=>canManuallyRegisterSale(currentUser)||!["posVenda","nextSale"].includes(s.id)
              ||s.id===stage||(s.id==="nextSale"&&["closed","posVenda"].includes(client.stage)))}
            onBegin={()=>{if(inlineBusyRef.current)return false;inlineBusyRef.current=true;setInlineBusy(true);return true;}}
            onSettled={()=>{inlineBusyRef.current=false;setInlineBusy(false);}}
            onLinked={card=>{setStage(card.stage);setFollowUp("");setValue(card.value||0);exitGuard.saved(card);}}
            style={{padding:"8px 12px",borderRadius:8,border:`1px solid ${T.sandDark}`,fontSize:14,background:"#fff"}}/>
        </div>
        {stage !== "closed" && (
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:12, fontWeight:700, color: followUp && followUp < new Date().toISOString().split("T")[0] ? "#EF4444" : T.text, display:"block", marginBottom:6 }}>
              {followUp && followUp < new Date().toISOString().split("T")[0] ? "⚠️ Follow-up agendado (atrasado)" : "📅 Follow-up agendado"}
            </label>
            <div style={{ display:"flex", gap:8, alignItems:"center" }}>
              <input type="date" value={followUp} onChange={e => setFollowUp(e.target.value)} style={{ flex:1, padding:"8px 12px", borderRadius:8, border:`1.5px solid ${followUp && followUp < new Date().toISOString().split("T")[0] ? "#EF4444" : T.sandDark}`, fontSize:14, boxSizing:"border-box" }} />
              {followUp && (
                <button onClick={() => setFollowUp("")}
                  title="Marcar como feito — limpa a data"
                  style={{ background:"#22C55E", color:"#fff", border:"none", borderRadius:8, padding:"8px 14px", fontWeight:700, fontSize:12, cursor:"pointer", whiteSpace:"nowrap", flexShrink:0 }}>
                  ✓ Feito
                </button>
              )}
            </div>
            {followUp && <div style={{ fontSize:10, color:T.muted, marginTop:3 }}>Clique em "✓ Feito" para marcar como concluído e limpar a data.</div>}
          </div>
        )}

        {stage === "posVenda" && (
          <div style={{ background:"#F5F0FF", borderRadius:12, padding:"14px 16px", marginBottom:14, border:"2px solid #7C3AED" }}>
            <div style={{ fontWeight:800, fontSize:13, color:"#7C3AED", marginBottom:10 }}>⭐ Pós-venda — Acompanhamento</div>
            <label style={{ fontSize:11, fontWeight:700, color:T.text, display:"block", marginBottom:4 }}>📅 Data de contato / acompanhamento</label>
            <input type="date" value={nextSaleDate} onChange={e=>setNextSaleDate(e.target.value)} style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:"1.5px solid #7C3AED", fontSize:13, boxSizing:"border-box" }} />
            {nextSaleDate && <div style={{ fontSize:10, color:"#7C3AED", fontWeight:600, marginTop:5 }}>✅ Lembrete gerado ao salvar.</div>}
          </div>
        )}

        {stage === "nextSale" && (
          <div style={{ background:"#EFF6FF", borderRadius:12, padding:"14px 16px", marginBottom:14, border:"2px solid #2563EB" }}>
            <div style={{ fontWeight:800, fontSize:13, color:"#2563EB", marginBottom:10 }}>🔄 Próxima Venda — Recompra</div>
            <label style={{ fontSize:11, fontWeight:700, color:T.text, display:"block", marginBottom:4 }}>📅 Data para reengajar o cliente</label>
            <input type="date" value={nextSaleDate} onChange={e=>setNextSaleDate(e.target.value)} style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:"1.5px solid #2563EB", fontSize:13, boxSizing:"border-box" }} />
            {nextSaleDate && <div style={{ fontSize:10, color:"#2563EB", fontWeight:600, marginTop:5 }}>✅ Alerta agendado para a data. Aurora poderá disparar mensagem automática no futuro.</div>}
            <label style={{ fontSize:11, fontWeight:700, color:T.text, display:"block", marginBottom:4, marginTop:12 }}>📝 O que ofertar</label>
            <textarea value={nextSaleNote} onChange={e=>setNextSaleNote(e.target.value)} rows={2} placeholder="Ex: oferecer o conjunto de cadeiras que combina com o sofá..." style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:"1.5px solid #2563EB", fontSize:13, resize:"vertical", boxSizing:"border-box", fontFamily:"inherit" }} />
          </div>
        )}

        {stage === "closed" && (
          <>
            {/* Agendamentos automáticos */}
            <div style={{ background:`linear-gradient(135deg,${T.accent}11,${T.gold}11)`, borderRadius:12, padding:"16px 18px", marginBottom:14, border:`2px solid ${T.gold}66` }}>
              <div style={{ fontWeight:800, fontSize:14, color:T.accent, marginBottom:12 }}>🎉 Venda Fechada — Agende agora!</div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:10 }}>
                <div>
                  <label style={{ fontSize:11, fontWeight:700, color:T.text, display:"block", marginBottom:4 }}>📅 Follow-up</label>
                  <input type="date" value={followUp} onChange={e => setFollowUp(e.target.value)} style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1.5px solid ${T.accent}`, fontSize:13, boxSizing:"border-box" }} />
                  <div style={{ fontSize:10, color:T.muted, marginTop:3 }}>Retornar com o cliente</div>
                </div>
                <div>
                  <label style={{ fontSize:11, fontWeight:700, color:T.positive, display:"block", marginBottom:4 }}>⭐ Pós-venda</label>
                  <input type="date" value={posVendaDate} onChange={e => setPosVendaDate(e.target.value)} style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1.5px solid ${T.positive}`, fontSize:13, boxSizing:"border-box" }} />
                  <div style={{ fontSize:10, color:T.muted, marginTop:3 }}>Satisfação / indicação</div>
                </div>
                <div>
                  <label style={{ fontSize:11, fontWeight:700, color:"#2563EB", display:"block", marginBottom:4 }}>🔄 Próxima Venda</label>
                  <input type="date" value={nextSaleDate} onChange={e => setNextSaleDate(e.target.value)} style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:"1.5px solid #2563EB", fontSize:13, boxSizing:"border-box" }} />
                  <div style={{ fontSize:10, color:T.muted, marginTop:3 }}>Data para ofertar de novo</div>
                </div>
              </div>
              {nextSaleDate && (
                <div style={{ marginBottom:6 }}>
                  <label style={{ fontSize:11, fontWeight:700, color:"#2563EB", display:"block", marginBottom:4 }}>📝 O que ofertar na próxima venda</label>
                  <textarea value={nextSaleNote} onChange={e => setNextSaleNote(e.target.value)} rows={2} placeholder="Ex: oferecer o conjunto de cadeiras que combina com o sofá..." style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:"1.5px solid #2563EB", fontSize:13, resize:"vertical", boxSizing:"border-box", fontFamily:"inherit" }} />
                </div>
              )}
              {(followUp || posVendaDate || nextSaleDate) && (
                <div style={{ fontSize:11, color:T.accent, fontWeight:600, marginTop:6 }}>
                  ✅ Lembretes criados automaticamente ao salvar.
                </div>
              )}
            </div>

            {/* Entrega */}
            <div style={{ background:"#F0FFF4", borderRadius:10, padding:"14px 16px", marginBottom:14, border:"2px solid #6B8F3E" }}>
              <div style={{ fontWeight:700, fontSize:13, color:"#6B8F3E", marginBottom:10 }}>📦 Entrega</div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
                <div>
                  <label style={{ fontSize:11, fontWeight:700, color:T.text, display:"block", marginBottom:4 }}>Previsão de Entrega</label>
                  <input type="date" value={deliveryDate} onChange={e => setDeliveryDate(e.target.value)} style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid #6B8F3E`, fontSize:13, boxSizing:"border-box" }} />
                </div>
                <div>
                  <label style={{ fontSize:11, fontWeight:700, color:T.text, display:"block", marginBottom:4 }}>Status da Entrega</label>
                  <select value={deliveryStatus} onChange={e => setDeliveryStatus(e.target.value)} style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid #6B8F3E`, fontSize:13, background:"#fff" }}>
                    <option value="aguardando">⏳ Aguardando</option>
                    <option value="confirmada">✅ Confirmada</option>
                    <option value="atrasada">⚠️ Atrasada</option>
                    <option value="entregue">🎉 Entregue</option>
                  </select>
                </div>
              </div>
              {deliveryDate && deliveryStatus !== "entregue" && (
                <div style={{ fontSize:11, color:"#6B8F3E", fontWeight:600 }}>
                  📅 Lembrete será gerado automaticamente para o dia da entrega.
                </div>
              )}
              {deliveryStatus === "entregue" && (
                <div style={{ background:"#E8F5E9", borderRadius:8, padding:"8px 12px", fontSize:12, color:"#6B8F3E", fontWeight:600 }}>
                  ✅ Entregue! Lembrete de pós-venda gerado para 5 dias após a entrega.
                </div>
              )}
            </div>
          </>
        )}

        <div style={{ marginBottom:20 }}>
          <label style={{ fontSize:12, fontWeight:700, color:T.text, display:"block", marginBottom:6 }}>Observações</label>
          <textarea value={note} onChange={e => setNote(e.target.value)} rows={3} style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:14, resize:"vertical", boxSizing:"border-box" }} />
          <VoiceDictationButton value={note} onChange={setNote} />
        </div>

        {onRegistrarVenda && stage !== "closed" && (
          <div style={{ marginBottom:20 }}>
            <ManualSaleAction currentUser={currentUser} onClick={onRegistrarVenda}
              disabled={inline && inlineBusy}
              style={{ background:"#10B981", color:"#fff", border:"none", borderRadius:10, padding:"10px 14px", fontSize:13, fontWeight:800, cursor:"pointer", width:"100%" }}
              noticeStyle={{ background:"#FEF9F0", border:"1px solid #D4C5A9", borderRadius:8, padding:"10px 12px" }} />
          </div>
        )}

        {(stage === "closed" || stage === "posVenda" || stage === "nextSale") && (
          <div style={{ marginBottom:16 }}>
            <RegistrarIndicacao
              sourceSale={{ type:"client", storeId:Number(client.storeId || storeId), id:client.id }}
              defaultIndicadoPor={client.name || name}
              showToggle
            />
          </div>
        )}

        {/* ── Chat WhatsApp ── */}
        {phoneClean && (
          <div style={{ marginBottom:20, order:inline ? -1 : undefined }}>
            <button onClick={()=>setShowChat(v=>!v)} style={{ background:showChat?"#128C7E":T.sandDark, color:showChat?"#fff":T.text, border:"none", borderRadius:"8px 8px"+(showChat?" 0 0":" 8px 8px"), padding:"8px 14px", fontSize:12, fontWeight:700, cursor:"pointer", width:"100%", textAlign:"left", display:"flex", alignItems:"center", gap:8 }}>
              <span>💬 Chat WhatsApp</span>
              {sortedWaMsgs.length>0&&<span style={{ background:"rgba(255,255,255,0.25)", borderRadius:99, padding:"1px 8px", fontSize:10, fontWeight:800 }}>{sortedWaMsgs.length}</span>}
              <span style={{ marginLeft:"auto" }}>{showChat?"▲":"▼"}</span>
            </button>
            {showChat && (
              <div style={{ background:"#F0F2F5", borderRadius:"0 0 10px 10px", border:"1px solid #E2E8F0", borderTop:"none", padding:"10px 12px" }}>
                <div ref={chatRef2} style={{ minHeight:inline ? 120 : 100, maxHeight:inline ? "min(32vh, 260px)" : 220, overflowY:"auto", display:"flex", flexDirection:"column", gap:6, marginBottom:8 }}>
                  <HistoryPagination storeId={client.storeId} phone={client.phone} />
                  <ChatMessageList
                    storeId={client.storeId || storeId} phone={phoneClean}
                    messages={sortedWaMsgs}
                    buildRetry={(m, msgTexto, isMine) => isMine ? (waMsgIsMedia(m)?(onSendZapiMedia?()=>onSendZapiMedia(phoneClean,m,m.tipo):null):(onSendZapi && msgTexto.trim())?()=>onSendZapi(phoneClean,msgTexto,{id:client.consultantId,name},null,client.storeId || storeId,null,m):null) : null}
                    onReply={msg=>setReplyTo2(msg)}
                    onDelete={onDeleteWhatsAppMessage ? (msg)=>onDeleteWhatsAppMessage(phoneClean, msg, msg.storeId || storeId || client.storeId) : null}
                    onEdit={onEditWhatsAppMessage ? (msg,text)=>onEditWhatsAppMessage(phoneClean, msg, text, msg.storeId || storeId || client.storeId) : null}
                  />
                </div>
                <div style={inline ? { position:"sticky", bottom:0, zIndex:2, background:"#F0F2F5", paddingTop:6 } : undefined}>
                <LiftCloseSaleAction moduleId="kanban" record={client}
                  onBegin={()=>{if(inlineBusyRef.current)return false;inlineBusyRef.current=true;setInlineBusy(true);return true;}}
                  onSettled={()=>{inlineBusyRef.current=false;setInlineBusy(false);}}
                  onLinked={card=>{setStage(card.stage);setFollowUp("");setValue(card.value||0);exitGuard.saved(card);}}/>
                <ChatComposerBar
                  allowNote
                  noteTarget={{moduleId:"kanban",recordId:client.id}}
                  onSendText={(t,qId,quote,options)=>onSendZapi && onSendZapi(phoneClean, t, {id:client.consultantId,name}, qId, client.storeId || storeId, quote, null, options)}
                  coachAlvo={phoneClean ? { phone:phoneClean, storeId:client.storeId || storeId } : null}
                  onSendMedia={onSendZapiMedia ? (file,tipo,qId,quote)=>onSendZapiMedia(phoneClean, file, tipo, client.storeId || storeId, qId, quote) : null}
                  placeholder="Mensagem…"
                  disabled={!phoneClean}
                  replyTo={replyTo2}
                  onClearReply={()=>setReplyTo2(null)}
                  currentUser={currentUser}
                  storeId={client.storeId || storeId}
                  reviewContext={{ phone:phoneClean, nome:name, produto:product }}
                  onSendQRMedia={onSendZapiMedia ? (m,qId,quote)=>onSendZapiMedia(phoneClean,{_isQRMedia:true,url:m.url,tipo:m.tipo},m.tipo,client.storeId || storeId,qId,quote) : null}
                  onGerarRoteiro={() => setRoteiroModalClient({ chooser: true })}
                />
                </div>
              </div>
            )}
          </div>
        )}
        <AiHelpModal
          roteiroModal={roteiroModalClient}
          setRoteiroModal={setRoteiroModalClient}
          clientName={name}
          phone={phoneClean}
          storeId={storeId}
          produto={product}
        />

        <button disabled={inline && inlineBusy} onClick={() => {
          if (inline && inlineBusyRef.current) return;
          if (manualSaleWriteDenied({
            user:currentUser, previousStage:client.stage, nextStage:stage,
            saleStages:["closed", "posVenda", "nextSale"],
          })) {
            alert(MANUAL_SALE_CUTOFF_NOTICE);
            return;
          }
          const stageChangedAt = new Date().toISOString();
          const today = stageChangedAt.split("T")[0];
          const newStageDates = stage !== client.stage
            ? { ...(client.stageDates||{}), [stage]: today }
            : (client.stageDates || { [client.stage]: client.createdAt || today });
          const TERMINAL_STAGES_C = ["closed","posVenda","nextSale","semInteresse"];
          const isNewTerminal = TERMINAL_STAGES_C.includes(stage) && !TERMINAL_STAGES_C.includes(client.stage);
          const updated = {
            ...client, name, phone, product, origin, stage, note, followUp, value, paidValue,
            deliveryDate, deliveryStatus, posVendaDate, birthday, nextSaleDate, nextSaleValue, nextSaleNote,
            stageDates: newStageDates,
            ...(stage === "future" && stage !== client.stage ? { futureStageEnteredAt: stageChangedAt } : {}),
            ...(isNewTerminal && !client.data_fechamento ? { data_fechamento: today } : {}),
          };
          const closingNow = stage === "closed" && !wasAlreadyClosed;
          const movingToPostSale = (stage === "posVenda" || stage === "nextSale") && !wasAlreadyPostSale;

          // ── Follow-up: cria lembrete se fechando agora com data definida, ou se data mudou
          if (stage === "closed" && followUp && onAddReminder && (closingNow || followUp !== client.followUp)) {
            onAddReminder({
              id: Date.now(),
              clientId:String(client.id),
              consultantId: client.consultantId,
              storeId: client.storeId,
              text: `📅 Follow-up — ${name} · ${product}`,
              clientName: name,
              dueDate: followUp,
              status: "pending",
              createdAt: today,
              doneAt: null,
              type: "followup"
            });
          }

          // ── Pós-venda manual: cria lembrete se data definida
          if (stage === "closed" && posVendaDate && onAddReminder && (closingNow || posVendaDate !== client.posVendaDate)) {
            onAddReminder({
              id: Date.now() + 1,
              clientId:String(client.id),
              consultantId: client.consultantId,
              storeId: client.storeId,
              text: `⭐ Pós-venda — ligar para ${name} · ${product}`,
              clientName: name,
              dueDate: posVendaDate,
              status: "pending",
              createdAt: today,
              doneAt: null,
              type: "posvenda"
            });
          }

          // ── Lembrete automático para o dia da entrega (se data nova ou alterada)
          if (deliveryDate && deliveryDate !== client.deliveryDate && deliveryStatus !== "entregue" && onAddReminder) {
            onAddReminder({
              id: Date.now() + 2,
              clientId:String(client.id),
              consultantId: client.consultantId,
              storeId: client.storeId,
              text: `📦 Entrega hoje — ${name} · ${product}`,
              clientName: name,
              dueDate: deliveryDate,
              status: "pending",
              createdAt: today,
              doneAt: null,
              type: "entrega"
            });
          }

          // ── Pós-venda automático 5 dias após entrega (se marcado entregue)
          if (deliveryStatus === "entregue" && deliveryDate && !client.posVendaCreated && onAddReminder) {
            const d = new Date(deliveryDate);
            d.setDate(d.getDate() + 5);
            updated.posVendaCreated = true;
            onAddReminder({
              id: Date.now() + 3,
              clientId:String(client.id),
              consultantId: client.consultantId,
              storeId: client.storeId,
              text: `📞 Pós-venda (entrega) — ligar para ${name}`,
              clientName: name,
              dueDate: d.toISOString().split("T")[0],
              status: "pending",
              createdAt: today,
              doneAt: null,
              type: "posvenda"
            });
          }

          // ── Pós-venda: lembrete de acompanhamento
          if (stage === "posVenda" && nextSaleDate && onAddReminder && (movingToPostSale || nextSaleDate !== client.nextSaleDate)) {
            onAddReminder({ id: Date.now()+4, clientId:String(client.id), consultantId: client.consultantId, storeId: client.storeId, text: `⭐ Pós-venda — contatar ${name} · ${product}`, clientName: name, dueDate: nextSaleDate, status:"pending", createdAt: today, doneAt:null, type:"posvenda" });
          }

          // ── Próxima Venda: lembrete de recompra
          if (stage === "nextSale" && nextSaleDate && onAddReminder && (movingToPostSale || nextSaleDate !== client.nextSaleDate)) {
            onAddReminder({ id: Date.now()+5, clientId:String(client.id), consultantId: client.consultantId, storeId: client.storeId, text: `🔄 Próxima Venda — reengajar ${name} · ${product}`, clientName: name, dueDate: nextSaleDate, status:"pending", createdAt: today, doneAt:null, type:"nextSale" });
          }

          // ── Próxima Venda (agendada no fechamento): lembrete para ofertar de novo
          if (stage === "closed" && nextSaleDate && onAddReminder && (closingNow || nextSaleDate !== client.nextSaleDate)) {
            onAddReminder({ id: Date.now()+8, clientId:String(client.id), consultantId: client.consultantId, storeId: client.storeId, text: `🔄 Próxima Venda — ofertar para ${name}${nextSaleNote ? " · " + nextSaleNote : ""}`, clientName: name, dueDate: nextSaleDate, status:"pending", createdAt: today, doneAt:null, type:"nextSale" });
          }

          // ── Follow-up genérico: lembrete sempre que data for preenchida/alterada (qualquer stage)
          if (followUp && followUp !== client.followUp && onAddReminder && stage !== "closed") {
            onAddReminder({ id: Date.now()+6, clientId:String(client.id), consultantId: client.consultantId, storeId: client.storeId, text: `📅 Follow-up — ${name} · ${product}`, clientName: name, dueDate: followUp, status:"pending", createdAt: today, doneAt:null, type:"followup" });
          }

          // ── Aniversário: lembrete para próximo aniversário quando campo for preenchido/alterado
          if (birthday && birthday !== client.birthday && onAddReminder) {
            const parts = birthday.split("-");
            if (parts.length === 3) {
              const thisYear = new Date().getFullYear();
              const thisYearBd = `${thisYear}-${parts[1]}-${parts[2]}`;
              const targetDate = thisYearBd >= today ? thisYearBd : `${thisYear+1}-${parts[1]}-${parts[2]}`;
              onAddReminder({ id: Date.now()+7, clientId:String(client.id), consultantId: client.consultantId, storeId: client.storeId, text: `🎂 Aniversário de ${name} — mandar mensagem!`, clientName: name, dueDate: targetDate, status:"pending", createdAt: today, doneAt:null, type:"birthday" });
            }
          }

          // The date is only eligible after the existing write reports
          // success.  A failed write leaves this modal and its draft open.
          Promise.resolve(onUpdate(updated))
            .then(() => { exitGuard.saved(updated); exitGuard.dismiss(); })
            .catch(() => {});
        }} style={{ width:"100%", background:`linear-gradient(135deg,${T.accent},${T.accentLight})`, color:"#fff", border:"none", borderRadius:10, padding:"12px", fontWeight:700, fontSize:15, cursor:"pointer" }}>
          Salvar Alterações
        </button>
        <button disabled={inline && inlineBusy} onClick={() => { if(window.confirm(`Excluir ${name}? Esta ação não pode ser desfeita.`)) { exitGuard.dismiss(); onDelete(client.id); } }} style={{ width:"100%", background:"#fff", color:"#C0392B", border:"2px solid #C0392B", borderRadius:10, padding:"10px", fontWeight:700, fontSize:14, cursor:"pointer", marginTop:8 }}>
          🗑 Excluir Cliente
        </button>
        {!!client.consultantId && onReturnToAurora && (
          <button disabled={inline && inlineBusy} onClick={() => {
            if (!window.confirm("Este cliente voltará para a fila da Aurora. O histórico será mantido.")) return;
            const motivo = window.prompt("Motivo da devolução (opcional):", "") || "";
            exitGuard.close(() => onReturnToAurora(client.id, motivo));
          }} style={{ width:"100%", background:"#fff", color:"#0F1F3D", border:"2px solid #0F1F3D", borderRadius:10, padding:"10px", fontWeight:700, fontSize:14, cursor:"pointer", marginTop:8 }}>
            ↩️ Devolver para Aurora
          </button>
        )}
      </div>
    </div>
  );
}

function AddClientModal({ onClose, onAdd, consultantId, storeId, currentUser, storeConsultants, initialValues, liftOrderMode }) {
  return <ClientRegistrationModal
    onClose={onClose}
    onAdd={onAdd}
    consultantId={consultantId}
    storeId={storeId}
    currentUser={currentUser}
    storeConsultants={storeConsultants}
    initialValues={initialValues}
    liftOrderMode={liftOrderMode}
    theme={T}
    stages={STAGES}
    origins={ORIGINS}
    canManuallyRegisterSale={canManuallyRegisterSale}
  />;
}

// ── LEMBRETES ──────────────────────────────────────────────────
function isOverdue(r) {
  if (!r.dueDate || r.status === "done") return false;
  return r.dueDate < new Date().toISOString().split("T")[0];
}

// Lembretes → Feitos: mostra só o que foi concluído hoje (horário de São Paulo).
// Os feitos antigos continuam gravados (pontos e histórico); só não aparecem na lista.
const DIA_SP = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Sao_Paulo" });
function feitoHojeSP(doneAt) {
  if (!doneAt) return false;
  const d = new Date(doneAt);
  return !Number.isNaN(d.getTime()) && DIA_SP.format(d) === DIA_SP.format(new Date());
}

export function ReminderItem({ reminder, onToggle, compact, onOpenClient, showConsultant, allowIdLink = false }) {
  const done = reminder.status === "done";
  const overdue = isOverdue(reminder);
  const clickable = !!(onOpenClient && (reminder.clientName || (allowIdLink && (reminder.leadId || reminder.prospId || reminder.clientId != null))));
  const consultantName = showConsultant && reminder.consultantId
    ? (USERS.find(u => u.id === reminder.consultantId)?.name || null)
    : null;
  return (
    <div onClick={clickable ? () => onOpenClient(reminder) : undefined} style={{ display:"flex", alignItems:"flex-start", gap:10, background:!done && overdue?"#FFF7ED":"#fff", borderRadius:10, padding:compact?"8px 12px":"12px 14px", marginBottom:8, border:!done && overdue?`1.5px solid #D97706`:`1px solid ${T.sandDark}`, opacity:done?0.6:1, cursor:clickable?"pointer":"default" }}>
      <ReminderCompletionButton reminder={reminder} onComplete={onToggle}
        style={{ width:24, height:24, minWidth:24, borderRadius:7, border:done?`2px solid ${T.positive}`:`2px solid ${T.muted}`, background:done?T.positive:"#fff", color:"#fff", cursor:"pointer", fontSize:14, fontWeight:800, lineHeight:"20px", padding:0, marginTop:2 }} />
      <div style={{ flex:1, minWidth:0 }}>
        <div style={{ fontSize:13, fontWeight:600, color:T.text, textDecoration:done?"line-through":"none" }}>{reminder.text}</div>
        <div style={{ fontSize:11, color:T.muted, marginTop:2, display:"flex", gap:8, flexWrap:"wrap" }}>
          {reminder.clientName && <span>👤 {reminder.clientName}{clickable?" · abrir card →":""}</span>}
          {consultantName && <span style={{ color:"#6366F1", fontWeight:600 }}>🧑‍💼 {consultantName}</span>}
          {reminder.dueDate && !done && <span style={{ color:overdue?T.accent:T.positive, fontWeight:overdue?700:600 }}>{overdue?"⚠️ Atrasado — ":"📅 "}{fmtDate(reminder.dueDate)}</span>}
          {done && reminder.doneAt && <span style={{ color:T.positive }}>✅ Feito em {fmtDateTime(reminder.doneAt)}</span>}
        </div>
      </div>
    </div>
  );
}

function PendingRemindersBox({ reminders, onToggle, onGoToReminders, onOpenClient }) {
  const in7days = (() => { const d = new Date(); d.setDate(d.getDate()+7); return d.toISOString().split("T")[0]; })();
  const now = reminders.filter(r => !r.dueDate || r.dueDate <= in7days);
  if (!now.length) return null;
  const overdueCount = now.filter(isOverdue).length;
  const futureCount  = reminders.length - now.length;
  return (
    <div style={{ background:`linear-gradient(135deg,${T.gold}15,${T.accent}15)`, border:`2px solid ${T.gold}66`, borderRadius:14, padding:"14px 18px", marginBottom:20 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10, flexWrap:"wrap", gap:8 }}>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <span style={{ fontSize:22 }}>📌</span>
          <div>
            <div style={{ fontWeight:800, fontSize:14, color:T.text }}>Você tem {now.length} lembrete{now.length>1?"s":""} pra este mês</div>
            {overdueCount>0 && <div style={{ fontSize:11, color:T.accent, fontWeight:700 }}>⚠️ {overdueCount} atrasado{overdueCount>1?"s":""} — resolve hoje!</div>}
            {futureCount>0 && <div style={{ fontSize:11, color:T.muted }}>+ {futureCount} agendado{futureCount>1?"s":""} para próximos meses</div>}
          </div>
        </div>
        <button onClick={onGoToReminders} style={{ background:T.accent, color:"#fff", border:"none", borderRadius:8, padding:"6px 14px", fontSize:12, fontWeight:700, cursor:"pointer" }}>Ver todos →</button>
      </div>
      {now.slice(0,3).map(r => <ReminderItem key={r.id} reminder={r} onToggle={onToggle} onOpenClient={onOpenClient} compact />)}
      {now.length>3 && <div style={{ fontSize:11, color:T.muted, fontWeight:600 }}>+ {now.length-3} na aba Lembretes</div>}
    </div>
  );
}

function periodLabelText(filters, filterDate) {
  if (filterDate) return `Dia ${fmtDate(filterDate)}`;
  if (!filters) return "Todo o período";
  switch (filters.period) {
    case "hoje": return "Hoje";
    case "ontem": return "Ontem";
    case "7dias": return "Últimos 7 dias";
    case "este_mes": return "Este mês";
    case "mes_passado": return "Mês passado";
    case "custom": return `${filters.customFrom?fmtDate(filters.customFrom):"?"} a ${filters.customTo?fmtDate(filters.customTo):"?"}`;
    case "tudo":
    default: return "Todo o período";
  }
}

// ── DRILL-DOWN: modal reutilizável de cards clicáveis ──────────
function DrillDownModal({ title, period, items, onClose, emptyMessage, groupByDay }) {
  const [query, setQuery] = useState("");
  const attemptRows = useTextSendAttempts();
  const q = query.trim().toLowerCase();
  const filtered = prioritizeTextSendFailures(q ? items.filter(it => (it.name||"").toLowerCase().includes(q) || matchesPhoneSearch(it.phone, q)) : items, attemptRows);
  // Mesmo agrupamento fixo por data de ENTRADA usado no Kanban/Consultores de Leads (Hoje, Ontem,
  // 2-5 dias atrás, Mais antigos) — só ativado quando o chamador marca groupByDay (listas de leads).
  const dayGroups = groupByDay ? prioritizeTextSendGroups(groupLeadsByArrivalDay(filtered, it => it.createdAt), attemptRows) : null;

  const renderItem = (it) => (
    <div key={it.id} style={{ background:T.sand, borderRadius:12, padding:"14px 16px", marginBottom:10 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10, flexWrap:"wrap" }}>
        <div style={{ minWidth:0 }}>
          <div style={{ fontWeight:700, fontSize:14, color:T.text }}>{it.name || "Sem nome"}</div>
          <TextSendStatus storeId={it.storeId} phone={it.phone} onOpen={it.onAction} readOnly={!it.onAction} />
          <div style={{ fontSize:11.5, color:T.muted, marginTop:2, display:"flex", gap:8, flexWrap:"wrap" }}>
            {it.phone && <span>📱 {it.phone}</span>}
            {it.consultant && <span>👤 {it.consultant}</span>}
            {it.store && <span>🏬 {it.store}</span>}
            {it.origin && <span>📍 {it.origin}</span>}
          </div>
        </div>
        {it.status && <span style={{ background:"#fff", border:`1px solid ${T.sandDark}`, borderRadius:99, padding:"3px 10px", fontSize:11, fontWeight:700, color:it.statusColor||T.accent, whiteSpace:"nowrap" }}>{it.status}</span>}
      </div>
      <div style={{ display:"flex", gap:10, flexWrap:"wrap", marginTop:8, fontSize:11, color:T.muted }}>
          {it.saleDate && <span>🛒 Venda: {fmtDate(String(it.saleDate).slice(0,10))}</span>}
        {it.createdAt && <span>🗓 Entrada: {fmtDate(it.createdAt)}</span>}
        {it.lastInteraction && <span>💬 Última interação: {fmtDate(it.lastInteraction)}</span>}
        {it.daysStopped!=null && <span style={{ color: it.daysStopped>7 ? "#D97706" : T.muted, fontWeight: it.daysStopped>7?700:400 }}>⏱ {it.daysStopped}d parado</span>}
        {it.value>0 && <span style={{ color:T.gold, fontWeight:700 }}>💰 {fmt(it.value)}</span>}
        {it.followUp && <span style={{ color:T.accent, fontWeight:700 }}>📅 Follow-up: {fmtDate(it.followUp)}</span>}
      </div>
      {(it.onAction || it.onDelete) && (
        <div style={{ marginTop:10, display:"flex", gap:8, flexWrap:"wrap" }}>
          {it.onAction && (
            <button onClick={it.onAction} style={{ background:T.accent, color:"#fff", border:"none", borderRadius:8, padding:"7px 14px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
              {it.actionLabel || "Ver card"}
            </button>
          )}
          {it.onDelete && (
            <button onClick={it.onDelete} style={{ background:"#FEF2F2", color:"#DC2626", border:"1px solid #FECACA", borderRadius:8, padding:"7px 14px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
              🗑️ Excluir lead
            </button>
          )}
        </div>
      )}
    </div>
  );

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(15,31,61,0.6)", zIndex:120, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={onClose}>
      <div style={{ background:"#fff", borderRadius:18, padding:0, width:"100%", maxWidth:640, maxHeight:"88vh", display:"flex", flexDirection:"column", boxShadow:"0 20px 60px rgba(0,0,0,0.3)" }} onClick={e=>e.stopPropagation()}>
        <div style={{ padding:"22px 26px 16px", borderBottom:`1px solid ${T.sandDark}` }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10 }}>
            <div>
              <div style={{ fontWeight:800, fontSize:18, color:T.text }}>{title}</div>
              <div style={{ fontSize:12, color:T.muted, marginTop:2 }}>Período: {period}</div>
              <div style={{ fontSize:12, color:T.accent, fontWeight:700, marginTop:4 }}>Total: {items.length} {items.length===1?"registro":"registros"}</div>
            </div>
            <button onClick={onClose} style={{ background:T.sandDark, border:"none", borderRadius:99, width:32, height:32, cursor:"pointer", fontSize:16, flexShrink:0 }}>✕</button>
          </div>
          <input value={query} onChange={e=>setQuery(e.target.value)} placeholder="🔎 Buscar por nome ou telefone..." style={{ width:"100%", padding:"9px 12px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box", marginTop:14 }} />
        </div>
        <div style={{ overflowY:"auto", padding:"14px 20px", flex:1 }}>
          {filtered.length===0 && <div style={{ textAlign:"center", color:T.muted, fontSize:13, padding:"30px 0" }}>{emptyMessage||"Nenhum registro encontrado."}</div>}
          {dayGroups
            ? dayGroups.map(g => (
                <div key={g.key}>
                  <div style={{ display:"flex", alignItems:"center", gap:5, margin:"6px 0 8px", padding:"0 2px" }}>
                    <span style={{ fontSize:10.5, fontWeight:800, color:"#8B6F47", letterSpacing:0.4, whiteSpace:"nowrap", textTransform:"uppercase" }}>{g.label}</span>
                    <span style={{ background:"#F3EDE2", color:"#9C8F7E", borderRadius:99, padding:"0 6px", fontSize:10.5, fontWeight:700, fontFamily:"monospace" }}>{g.items.length}</span>
                    <div style={{ flex:1, height:1, background:"#E8E1D3" }} />
                  </div>
                  {g.items.map(renderItem)}
                </div>
              ))
            : filtered.map(renderItem)
          }
        </div>
      </div>
    </div>
  );
}

// Modal de drill-down da Carteira Comercial ("Em Orçamentos") — 3 seções + ordenação
function PortfolioDrillModal({ periodLabel, groups, onClose, thresholds, onSaveThresholds, canEditThresholds }) {
  const [query, setQuery] = useState("");
  const [sortBy, setSortBy] = useState("valor");

  const sortList = (arr) => {
    const a = [...arr];
    switch (sortBy) {
      case "valor":     return a.sort((x,y) => (y.value||0) - (x.value||0));
      case "dias":      return a.sort((x,y) => (y.dias||0) - (x.dias||0));
      case "consultor": return a.sort((x,y) => (x.consultant||"").localeCompare(y.consultant||""));
      case "interacao": {
        const t = (it) => { const d = toDateSafe(it.lastInteraction); return d ? d.getTime() : 0; };
        return a.sort((x,y) => t(y) - t(x));
      }
      default: return a;
    }
  };
  const q = query.trim().toLowerCase();
  const filterQ = (arr) => q ? arr.filter(it => (it.name||"").toLowerCase().includes(q)) : arr;
  const totalValue = (arr) => arr.reduce((s,it) => s + (it.value||0), 0);

  const sections = [
    { key:"novo",         label:"🟢 Novos",       color:T.positive, items: sortList(filterQ(groups.novo||[])) },
    { key:"recuperacao",  label:"🟡 Recuperação", color:"#D97706",  items: sortList(filterQ(groups.recuperacao||[])) },
    { key:"risco",        label:"🔴 Em Risco",    color:"#DC2626",  items: sortList(filterQ(groups.risco||[])) },
  ];

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(15,31,61,0.6)", zIndex:130, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={onClose}>
      <div style={{ background:"#fff", borderRadius:18, padding:0, width:"100%", maxWidth:720, maxHeight:"90vh", display:"flex", flexDirection:"column", boxShadow:"0 20px 60px rgba(0,0,0,0.3)" }} onClick={e=>e.stopPropagation()}>
        <div style={{ padding:"22px 26px 14px", borderBottom:`1px solid ${T.sandDark}` }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10 }}>
            <div>
              <div style={{ fontWeight:800, fontSize:18, color:T.text }}>Carteira Comercial — Em Orçamentos</div>
              <div style={{ fontSize:12, color:T.muted, marginTop:2 }}>Período: {periodLabel}</div>
            </div>
            <button onClick={onClose} style={{ background:T.sandDark, border:"none", borderRadius:99, width:32, height:32, cursor:"pointer", fontSize:16, flexShrink:0 }}>✕</button>
          </div>
          <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginTop:14 }}>
            <input value={query} onChange={e=>setQuery(e.target.value)} placeholder="🔎 Buscar por nome..." style={{ flex:"1 1 180px", padding:"9px 12px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box" }} />
            <select value={sortBy} onChange={e=>setSortBy(e.target.value)} style={{ padding:"9px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:12, fontWeight:600, background:"#fff" }}>
              <option value="valor">Ordenar: Maior valor</option>
              <option value="dias">Ordenar: Mais dias em negociação</option>
              <option value="consultor">Ordenar: Consultor</option>
              <option value="interacao">Ordenar: Última interação</option>
            </select>
          </div>
          {canEditThresholds && (
            <div style={{ marginTop:12, display:"flex", alignItems:"center", gap:8 }}>
              <span style={{ fontSize:11, color:T.muted }}>⚙️ Marcar como "Em Risco" após</span>
              <input type="number" min={1} defaultValue={thresholds.riskDays}
                onBlur={e => { const v = Math.max(1, Number(e.target.value)||DEFAULT_PORTFOLIO_THRESHOLDS.riskDays); if (v !== thresholds.riskDays) onSaveThresholds({ ...thresholds, riskDays: v }); }}
                style={{ width:56, padding:"4px 6px", borderRadius:6, border:`1px solid ${T.sandDark}`, fontSize:12 }} />
              <span style={{ fontSize:11, color:T.muted }}>dias sem fechar</span>
            </div>
          )}
        </div>
        <div style={{ overflowY:"auto", padding:"14px 20px", flex:1 }}>
          {sections.map(sec => (
            <div key={sec.key} style={{ marginBottom:20 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
                <div style={{ fontWeight:800, fontSize:14, color:sec.color }}>{sec.label} ({sec.items.length})</div>
                <div style={{ fontWeight:800, fontSize:14, color:sec.color }}>{fmt(totalValue(sec.items))}</div>
              </div>
              {sec.items.length===0 ? (
                <div style={{ fontSize:12, color:T.muted, padding:"8px 0" }}>Nenhum cliente nesta categoria.</div>
              ) : sec.items.map(it => (
                <div key={it.id} style={{ background:T.sand, borderRadius:12, padding:"12px 14px", marginBottom:8, border: sec.key==="risco" ? "1.5px solid #DC262655" : "none" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10, flexWrap:"wrap" }}>
                    <div style={{ minWidth:0 }}>
                      <div style={{ fontWeight:700, fontSize:13, color:T.text }}>{it.name || "Sem nome"}</div>
                      <div style={{ fontSize:11, color:T.muted, marginTop:2 }}>👤 {it.consultant || "—"}</div>
                    </div>
                    <div style={{ textAlign:"right" }}>
                      <div style={{ fontWeight:800, fontSize:14, color:T.gold }}>{fmt(it.value||0)}</div>
                      <div style={{ fontSize:11, color: sec.key==="risco" ? "#DC2626" : T.muted, fontWeight: sec.key==="risco" ? 700 : 400 }}>{it.dias}d em negociação</div>
                    </div>
                  </div>
                  <div style={{ display:"flex", gap:10, flexWrap:"wrap", marginTop:6, fontSize:11, color:T.muted }}>
                    {it.createdAt && <span>🗓 Entrada: {fmtDate(it.createdAt)}</span>}
                    {it.lastInteraction && <span>💬 Última interação: {fmtDate(it.lastInteraction)}</span>}
                    {sec.key==="risco" && it.followUp && <span style={{ color:T.accent, fontWeight:700 }}>📅 Próximo follow-up: {fmtDate(it.followUp)}</span>}
                  </div>
                  {it.onAction && (
                    <div style={{ marginTop:8 }}>
                      <button onClick={it.onAction} style={{ background:T.accent, color:"#fff", border:"none", borderRadius:8, padding:"6px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>
                        {it.actionLabel || "Ver card"}
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── VIEWS ──────────────────────────────────────────────────────

const CLIENT_DATE_FIELDS = [
  { id:"createdAt",  label:"Data de entrada" },
  { id:"etapa",      label:"Data desta etapa" },
  { id:"fechamento", label:"Data de fechamento" },
  { id:"followup",   label:"Data de follow-up" },
];
export function KanbanView({ clients, leads, prospeccao, currentUser, onUpdate, onAdd, onDelete, onAddReminder, reminders, onToggleReminder, onGoToReminders, whatsappMsgs, onSendZapi, onSendZapiMedia, onDeleteWhatsAppMessage, onEditWhatsAppMessage, waReadAt, onMarkRead, onReturnToAurora, autoOpenTarget, onAutoOpenConsumed, onRegistrarVenda, onConversationActive, onOpenProspect }) {
  useTextSendAttempts();
  const { commercialSales:liftSales, commercialError, commercialLoaded } = useContext(LiftPendingContext);
  const renderClientCard = (c) => {
    return <div key={c.id} style={{ position:"relative", borderRadius:10 }}>
      <KanbanCard client={c} onClick={handleSelectClient} readonly={currentUser.role==="consultant" && c.consultantId!==currentUser.id} waMsgs={getWaMsgsForPhone(whatsappMsgs||{}, canonicalPhone(c.phone), c.storeId)} />
    </div>;
  };
  const [selected, setSelectedRaw] = useState(null);
  const selectedProjected = resolveProjectedRecord(clients, selected);
  const setSelected = useCallback((next) => {
    if (next && selected && next.id !== selected.id) {
      return activeConversationExitGuard.requestAction(() => setSelectedRaw(next));
    }
    setSelectedRaw(next);
  }, [selected]);
  const handleSelectClient = (client) => {
    if (client.phone) noteConversationSelection(client.storeId || currentUser?.storeId, normalizePhone(client.phone));
    setSelected(client);
    if (onMarkRead && client.phone) onMarkRead(conversationKey(client.storeId, canonicalPhone(client.phone)));
    if (client.phone) {
      onConversationActive?.({ phone:normalizePhone(client.phone), module:"kanban", storeId:client.storeId });
    }
  };
  const [adding, setAdding] = useState(false);
  const [filters, setFilters] = useScreenPeriodFilters("atendimento", DEFAULT_FILTERS);
  const [drillDown, setDrillDown] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const handleAddClient = (client) => {
    return Promise.resolve(onAdd(client)).then(savedClient => {
      setAdding(false);
      if (savedClient) handleSelectClient(savedClient);
      return savedClient;
    });
  };

  useEffect(() => {
    if (!autoOpenTarget) return;
    const match = clients.find(c => autoOpenTarget.recordId != null
      ? String(c.id) === String(autoOpenTarget.recordId) && Number(c.storeId) === Number(autoOpenTarget.storeId)
      : recordMatchesConversationTarget(c, autoOpenTarget, ["phone","telefone"]));
    if (!match) return;
    handleSelectClient(match);
    if (onAutoOpenConsumed) onAutoOpenConsumed();
  }, [autoOpenTarget, clients]); // eslint-disable-line react-hooks/exhaustive-deps

  const effPeriod = filters.period;
  const effCustomFrom = filters.customFrom;
  const effCustomTo = filters.customTo;

  const baseClients = currentUser.role==="admin" ? clients
    : currentUser.role==="manager" ? clients.filter(c => Number(c.storeId)===Number(currentUser.storeId))
    : clients.filter(c => Number(c.consultantId)===Number(currentUser.id));

  const isManagerOrAdmin = currentUser.role !== "consultant";
  const storeConsultantsKV = USERS.filter(u => u.role === "consultant" && (currentUser.role === "admin" || currentUser.role === "manager" ? true : u.storeId === currentUser.storeId));
  const effFilters = { period:effPeriod, customFrom:effCustomFrom, customTo:effCustomTo };
  const periodRangeKV = getPeriodRange(effPeriod, effCustomFrom, effCustomTo);
  const clientDateValue = (c) => {
    if (filters.dateField === "etapa")      return (c.stageDates||{})[c.stage] || c.createdAt;
    if (filters.dateField === "fechamento") return getClosingDate(c);
    if (filters.dateField === "followup")   return c.followUp;
    return c.createdAt;
  };
  const hasClientSearch = Boolean(searchQuery.trim());
  // A direct phone lookup crosses module and period, not store/owner boundaries.
  const prospectSearchResults = searchQuery.replace(/\D/g, "").length >= 8
    ? (prospeccao || []).filter(record => {
      if (!matchesCrmPhoneSearch(record.phone || record.telefone, searchQuery)) return false;
      if (currentUser.role !== "admin" && !conversationRecordIsInUserStore(record, currentUser, USERS)) return false;
      if (!matchesResponsavelFiltro(record, filters.consultantId)) return false;
      return Boolean(resolveReminderCard({ prospId:record.id, storeId:record.storeId }, {
        prospeccao:[record], currentUser,
        consultantStoreId:id => USERS.find(user => Number(user.id) === Number(id))?.storeId,
      }));
    }) : [];
  const openProspectSearchResult = record => {
    const linked = resolveReminderCard({ prospId:record.id, storeId:record.storeId }, {
      prospeccao:[record], currentUser,
      consultantStoreId:id => USERS.find(user => Number(user.id) === Number(id))?.storeId,
    });
    if (linked && onOpenProspect) onOpenProspect(linked.target);
  };
  const visibleClients = baseClients.filter(c => {
    if (!matchesResponsavelFiltro(c, filters.consultantId)) return false;
    // A busca direta precisa localizar o cadastro mesmo quando ele entrou em
    // outro período. A data de entrada não muda quando o cliente responde hoje.
    if (!hasClientSearch && effPeriod !== "tudo" && !inPeriod(clientDateValue(c), periodRangeKV)) return false;
    if (hasClientSearch) {
      const q = searchQuery.trim().toLowerCase();
      const nameMatch  = (c.name||"").toLowerCase().includes(q);
      const phoneMatch = matchesPhoneSearch(c.phone, q);
      if (!nameMatch && !phoneMatch) return false;
    }
    return true;
  });

  const myPendingReminders = (reminders||[]).filter(r => {
    if (r.status !== "pending" || !isThisMonthOrEarlier(r.dueDate)) return false;
    if (currentUser.role === "consultant") return r.consultantId === currentUser.id;
    const sid = r.storeId || USERS.find(u => u.id === r.consultantId)?.storeId || 1;
    return sid === currentUser.storeId;
  });
  const newUi = isNewUiEnabled();
  const SPECIAL_STAGES = ["closed","posVenda","nextSale","semInteresse"];
  const activeStages = STAGES.filter(s => !SPECIAL_STAGES.includes(s.id));
  const sortClients = (arr) => prioritizeTextSendFailures(filters.sortBy === "recentes" ? arr : sortItems(arr, filters.sortBy, {
    createdAt: (c)=> c.createdAt,
    interacao: (c)=> (c.stageDates||{})[c.stage] || c.createdAt,
    followup:  (c)=> c.followUp,
    valor:     (c)=> c.value || 0,
  }), getTextSendAttempts());

  const consultantNameKV = id => USERS.find(u=>u.id===id)?.name.split(" ")[0]||"";
  const storeNameKV = id => STORES.find(s=>s.id===id)?.name||"";
  const clientToItemKV = (c) => ({
    id:c.id, name:c.name, phone:c.phone, storeId:c.storeId, consultant:consultantNameKV(c.consultantId),
    store:storeNameKV(c.storeId||currentUser.storeId), origin:c.origin, status:STAGES.find(s=>s.id===c.stage)?.label||c.stage,
    createdAt:c.createdAt, lastInteraction:(c.stageDates||{})[c.stage]||c.createdAt, value:c.value, followUp:c.followUp,
    actionLabel:"Ver card", onAction:()=>{ setDrillDown(null); setSelected(c); },
  });

  const totalAtendidos    = visibleClients.length;
  const totalOrcamentos   = visibleClients.filter(c=>c.stage==="msg_sent").length;
  const totalNegociacao   = visibleClients.filter(c=>c.stage==="final").length;
  const totalFollowup     = visibleClients.filter(c=>c.followUp && !SPECIAL_STAGES.includes(c.stage)).length;
  const closedFinancialClients = visibleClients.filter(c => wasSold(c) && !isHistoricalLiftPostSaleCard(c));
  const totalFechados     = closedFinancialClients.length;
  const totalPerdidos     = visibleClients.filter(c=>c.stage==="semInteresse").length;
  // Uma única seleção local de período alimenta cards e métricas desta tela.
  const metricsRange      = getPeriodRange(filters.period, filters.customFrom, filters.customTo);
  const commercialAtendimento = computeDashboardRevenueBreakdown({
    clients:baseClients,
    periodRange:metricsRange,
    storeId:currentUser.role==="consultant" ? null : (currentUser.role==="admin" ? null : currentUser.storeId),
    consultantId:currentUser.role==="consultant" ? currentUser.id : null,
    consultantAcrossStores:currentUser.role==="consultant",
    liftSales,
  });
  const soldInPeriod      = baseClients.filter(c => wasSold(c) && !isHistoricalLiftPostSaleCard(c) && inPeriod(getClosingDate(c), metricsRange));
  const totalValorVendido = soldInPeriod.reduce((s,c)=>s+(c.value||0),0);
  const conversaoGeral    = totalAtendidos>0 ? Math.round(totalFechados/totalAtendidos*100) : 0;

  const kvMetrics = [
    { label:"Atendidos",          value:totalAtendidos,  color:"#6366F1", icon:"👥", list:visibleClients },
    { label:"Orçamentos enviados",value:totalOrcamentos, color:"#0EA5E9", icon:"📄", list:visibleClients.filter(c=>c.stage==="msg_sent") },
    { label:"Em Negociação",      value:totalNegociacao, color:"#A07830", icon:"🔔", list:visibleClients.filter(c=>c.stage==="final") },
    { label:"Follow-up",          value:totalFollowup,   color:"#F59E0B", icon:"📅", list:visibleClients.filter(c=>c.followUp && !SPECIAL_STAGES.includes(c.stage)) },
    { label:"Fechados",           value:totalFechados,   color:"#22C55E", icon:"✅", list:closedFinancialClients },
    { label:"Perdidos",           value:totalPerdidos,   color:"#EF4444", icon:"🚫", list:visibleClients.filter(c=>c.stage==="semInteresse") },
    { label:"Conversão",          value:`${conversaoGeral}%`, color:"#14B8A6", icon:"📊", list:closedFinancialClients },
    { label:"Valor vendido",      value:fmt(totalValorVendido), color:"#D97706", icon:"💰", list:soldInPeriod },
  ];

  const consultantRanking = storeConsultantsKV.map(u => {
    const attended = visibleClients.filter(c=>c.consultantId===u.id);
    // Usa computeOriginBreakdown para incluir leads + prospecção no valor total,
    // igual ao dashboard da loja (evita divergência entre "Resumo por Consultor" e "Vendido").
    const bd = redactConsultantCrossStoreSales(computeDashboardRevenueBreakdown({
      clients:baseClients, periodRange:metricsRange, storeId:null, consultantId:u.id,
      consultantAcrossStores:true, liftSales,
    }), currentUser.storeId || 1);
    const sold = bd.sales;
    const conv = attended.length>0 ? Math.round(sold.length/attended.length*100) : 0;
    const valor = bd.totalValue;
    const unanswered = whatsappMsgs ? attended.filter(c => clientAwaitingReply(c, whatsappMsgs)) : [];
    return { user:u, attended, sold, conv, valor, unanswered };
  }).sort((a,b)=>b.unanswered.length-a.unanswered.length || b.sold.length-a.sold.length || b.attended.length-a.attended.length);

  return (
    <div>
      <PendingRemindersBox reminders={myPendingReminders} onToggle={onToggleReminder} onGoToReminders={onGoToReminders} onOpenClient={r => { const c = clients.find(cl => (cl.name||"").trim().toLowerCase() === (r.clientName||"").trim().toLowerCase()); if (c) setSelected(c); }} />
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
        <div>
          <div style={{ fontWeight:800, fontSize:20, color:T.text }}>Atendimento Presencial</div>
          <div style={{ fontSize:13, color:T.muted }}>{visibleClients.filter(c=>c.stage!=="closed"&&c.stage!=="semInteresse").length} clientes ativos</div>
        </div>
        <button onClick={() => setAdding(true)} style={{ background:`linear-gradient(135deg,${T.accent},${T.accentLight})`, color:"#fff", border:"none", borderRadius:10, padding:"10px 18px", fontWeight:700, cursor:"pointer", fontSize:14 }}>
          + Novo Cliente
        </button>
      </div>

      <FilterBar
        filters={filters}
        setFilters={setFilters}
        dateFieldOptions={CLIENT_DATE_FIELDS}
        consultants={isManagerOrAdmin ? storeConsultantsKV : null}
        showConsultant={isManagerOrAdmin}
        showStatus={false}
        showSearch
        searchValue={searchQuery}
        onSearchChange={setSearchQuery}
      />
      <ProspectPhoneSearchResults results={prospectSearchResults} onOpen={openProspectSearchResult} />
      <CommercialSalesNotice breakdown={commercialAtendimento} periodRange={metricsRange} error={commercialError} loaded={commercialLoaded}
        storeId={currentUser.role==="consultant" ? null : (currentUser.role==="admin" ? null : currentUser.storeId)}
        consultantId={currentUser.role==="consultant" ? currentUser.id : null} liftSales={liftSales} />

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))", gap:10, marginBottom:16 }}>
        {kvMetrics.map(m => (
          <div key={m.label} onClick={()=>setDrillDown({ title:m.label, items:m.list.map(clientToItemKV), period:periodLabelText({ period:effPeriod, customFrom:effCustomFrom, customTo:effCustomTo }) })}
            style={{ background:"#fff", borderRadius:14, padding:"14px 16px", boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderLeft:`4px solid ${m.color}`, cursor:"pointer" }}
          >
            <div style={{ fontSize:18, marginBottom:2 }}>{m.icon}</div>
            <div style={{ fontSize:20, fontWeight:800, color:m.color }}>{m.value}</div>
            <div style={{ fontSize:11, color:T.muted, marginTop:2 }}>{m.label}</div>
          </div>
        ))}
      </div>
      {drillDown && <DrillDownModal {...drillDown} onClose={()=>setDrillDown(null)} />}

      {isManagerOrAdmin && consultantRanking.length>0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:"16px 18px", marginBottom:16, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:10, flexWrap:"wrap" }}>
            <div style={{ fontWeight:800, fontSize:14, color:T.text }}>👤 Resumo por Consultor — {periodLabelText(effFilters)}</div>
            {consultantRanking.some(r=>r.unanswered.length>0) && (
              <span style={{ background:"#FEF2F2", color:"#EF4444", border:"1px solid #FECACA", borderRadius:99, padding:"2px 10px", fontSize:11, fontWeight:700 }}>
                🔴 {consultantRanking.reduce((s,r)=>s+r.unanswered.length,0)} sem resposta
              </span>
            )}
          </div>
          <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
            {consultantRanking.map(r => (
              <div key={r.user.id} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap", padding:"8px 10px", background:r.unanswered.length>0?"#FFF5F5":T.sand, borderRadius:10, border:r.unanswered.length>0?"1px solid #FECACA":"1px solid transparent" }}>
                <div style={{ fontWeight:700, fontSize:13, color:T.text, minWidth:110 }}>{r.user.name}</div>
                <div style={{ display:"flex", gap:12, flexWrap:"wrap", alignItems:"center" }}>
                  {r.unanswered.length>0 && (
                    <span onClick={()=>setDrillDown({ title:`🔴 ${r.user.name} — Sem resposta`, items:r.unanswered.map(clientToItemKV), period:"Agora" })}
                      style={{ background:"#EF4444", color:"#fff", borderRadius:99, padding:"2px 10px", fontSize:11, fontWeight:800, cursor:"pointer", whiteSpace:"nowrap" }}>
                      🔴 {r.unanswered.length} sem resposta
                    </span>
                  )}
                  <span onClick={()=>setDrillDown({ title:`${r.user.name} — Atendimentos`, items:r.attended.map(clientToItemKV), period:periodLabelText(effFilters) })} style={{ fontSize:12, color:T.muted, cursor:"pointer" }}>
                    <b style={{ color:T.accent }}>{r.attended.length}</b> atend.
                  </span>
                  <span onClick={()=>setDrillDown({ title:`${r.user.name} — Vendas`, items:r.sold.map(saleToDrillItem), period:periodLabelText(effFilters) })} style={{ fontSize:12, color:T.muted, cursor:"pointer" }}>
                    <b style={{ color:T.positive }}>{r.sold.length}</b> venda{r.sold.length!==1?"s":""}
                  </span>
                  <span style={{ fontSize:12, color:T.muted }}>
                    <b style={{ color:"#14B8A6" }}>{r.conv}%</b> conv.
                  </span>
                  {r.valor>0 && <span style={{ fontSize:12, color:T.muted }}><b style={{ color:"#D97706" }}>{fmt(r.valor)}</b></span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {newUi && (
        <div className={selectedProjected ? "nu-presencial nu-presencial--open" : "nu-presencial"}>
          <style>{`
.nu-presencial--open { display:grid; grid-template-columns:minmax(300px,400px) minmax(0,1fr); gap:20px; align-items:start; }
.nu-presencial--open .nu-client-panel { position:sticky; top:84px; }
@media (max-width: 899px) {
  .nu-presencial--open { display:block; }
  .nu-presencial--open .nu-client-panel { position:fixed; inset:0; z-index:100; background:#fff; overflow:auto; padding:12px; }
}`}</style>
          <PresencialList theme={T} clients={visibleClients} onOpen={handleSelectClient} selectedId={selectedProjected?.id}
            isAwaiting={c => (whatsappMsgs ? clientAwaitingReply(c, whatsappMsgs) : false)}
            consultantName={consultantNameKV} showConsultant={isManagerOrAdmin} />
          {selectedProjected && <ClientModal key={selectedProjected.id} layout="inline" client={selectedProjected} storeId={currentUser.storeId||selectedProjected.storeId} onClose={() => setSelected(null)} onUpdate={updated => onUpdate(updated)} onDelete={id => { onDelete(id); setSelected(null); }} onAddReminder={onAddReminder} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} onDeleteWhatsAppMessage={onDeleteWhatsAppMessage} onEditWhatsAppMessage={onEditWhatsAppMessage} whatsappMsgs={whatsappMsgs} onReturnToAurora={onReturnToAurora} currentUser={currentUser} onMarkRead={onMarkRead} onRegistrarVenda={onRegistrarVenda ? () => onRegistrarVenda(createSaleTarget("kanban", selectedProjected, currentUser?.storeId, currentUser?.id)) : null} onConversationActive={onConversationActive} />}
        </div>
      )}
      {!isManagerOrAdmin && !newUi && (
        <div style={{ display:"flex", gap:12, overflowX:"auto", overflowY:"hidden", WebkitOverflowScrolling:"touch", flexWrap:"nowrap", height:"calc(100vh - 270px)", minHeight:420, paddingBottom:8 }}>
          {activeStages.map(stage => {
            const cols = sortClients(visibleClients.filter(c => c.stage===stage.id));
            const total = cols.reduce((s,c) => s+c.value, 0);
            const dayGroups = groupByDay(cols, c=>c.createdAt);
            return (
              <div key={stage.id} style={{ minWidth:220, flex:"0 0 220px", display:"flex", flexDirection:"column", height:"100%" }}>
                <div style={{ background:stage.color, borderRadius:"10px 10px 0 0", padding:"10px 14px", display:"flex", justifyContent:"space-between", alignItems:"center", flexShrink:0 }}>
                  <span style={{ color:"#fff", fontWeight:700, fontSize:13 }}>{stage.label}</span>
                  <span style={{ background:"rgba(255,255,255,0.25)", color:"#fff", borderRadius:99, padding:"1px 8px", fontSize:12, fontWeight:700 }}>{cols.length}</span>
                </div>
                <div style={{ background:"#fff", borderRadius:"0 0 10px 10px", padding:"10px 10px 4px", overflowY:"auto", flex:1 }}>
                  {total>0 && <div style={{ fontSize:11, color:T.muted, marginBottom:8, fontWeight:600 }}>Total: {fmt(total)}</div>}
                  {dayGroups.map(g => (
                    <Fragment key={g.key}>
                      <div style={{ fontSize:10, fontWeight:800, color:T.muted, textTransform:"uppercase", letterSpacing:0.4, margin:"6px 0 4px" }}>{g.label}</div>
                      {g.items.map(renderClientCard)}
                    </Fragment>
                  ))}
                  {cols.length===0 && <div style={{ textAlign:"center", color:T.muted, fontSize:12, padding:"20px 0" }}>Nenhum cliente</div>}
                </div>
              </div>
            );
          })}
          {["closed","posVenda","nextSale","semInteresse"].map(sid => {
            const stage = STAGES.find(s => s.id===sid);
            const rawCols = visibleClients.filter(c => c.stage===sid);
            const cols = sortClients(rawCols);
            const total = cols.reduce((s,c) => s+(c.value||0), 0);
            const dayGroups = groupByDay(cols, c=>c.createdAt);
            return (
              <div key={sid} style={{ minWidth:220, flex:"0 0 220px", display:"flex", flexDirection:"column", height:"100%" }}>
                <div style={{ background:stage.color, borderRadius:"10px 10px 0 0", padding:"10px 14px", display:"flex", justifyContent:"space-between", alignItems:"center", flexShrink:0 }}>
                  <span style={{ color:"#fff", fontWeight:700, fontSize:13 }}>{stage.label}</span>
                  <span style={{ background:"rgba(255,255,255,0.25)", color:"#fff", borderRadius:99, padding:"1px 8px", fontSize:12, fontWeight:700 }}>{cols.length}</span>
                </div>
                <div style={{ background:"#fff", borderRadius:"0 0 10px 10px", padding:"10px 10px 4px", overflowY:"auto", flex:1 }}>
                  {total>0 && <div style={{ fontSize:11, color:T.muted, marginBottom:8, fontWeight:600 }}>Total: {fmt(total)}</div>}
                  {dayGroups.map(g => (
                    <Fragment key={g.key}>
                      <div style={{ fontSize:10, fontWeight:800, color:T.muted, textTransform:"uppercase", letterSpacing:0.4, margin:"6px 0 4px" }}>{g.label}</div>
                      {g.items.map(renderClientCard)}
                    </Fragment>
                  ))}
                  {cols.length===0 && <div style={{ textAlign:"center", color:T.muted, fontSize:12, padding:"20px 0" }}>Nenhum cliente</div>}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {selectedProjected && !newUi && <ClientModal client={selectedProjected} storeId={currentUser.storeId||selectedProjected.storeId} onClose={() => setSelected(null)} onUpdate={updated => onUpdate(updated)} onDelete={id => { onDelete(id); setSelected(null); }} onAddReminder={onAddReminder} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} onDeleteWhatsAppMessage={onDeleteWhatsAppMessage} onEditWhatsAppMessage={onEditWhatsAppMessage} whatsappMsgs={whatsappMsgs} onReturnToAurora={onReturnToAurora} currentUser={currentUser} onMarkRead={onMarkRead} onRegistrarVenda={onRegistrarVenda ? () => onRegistrarVenda(createSaleTarget("kanban", selectedProjected, currentUser?.storeId, currentUser?.id)) : null} onConversationActive={onConversationActive} />}
      {adding && <AddClientModal onClose={() => setAdding(false)} onAdd={handleAddClient} consultantId={currentUser.id} storeId={currentUser.storeId} currentUser={currentUser} storeConsultants={storeConsultantsKV} />}
    </div>
  );
}

function computeOriginBreakdown({ clients=[], leads=[], prospeccao=[], periodRange, storeId, consultantId, consultantAcrossStores=false, liftSales=[] }) {
  return computeSalesLedger({
    clients,
    leads,
    prospeccao,
    liftSales,
    periodRange,
    storeId,
    consultantId,
    consultantAcrossStores,
    inPeriod,
    normalizePhone,
    users: USERS,
  });
}

function computeDashboardRevenueBreakdown({ clients=[], leads=[], prospeccao=[], periodRange, storeId, consultantId, consultantAcrossStores=false, liftSales=[] }) {
  return computeCanonicalDashboardSales({
    clients,
    leads,
    prospeccao,
    periodRange,
    storeId,
    consultantId,
    consultantAcrossStores,
    liftSales,
    inPeriod,
    normalizePhone,
    users: USERS,
  });
}

function redactConsultantCrossStoreSales(breakdown, homeStoreId) {
  return {
    ...breakdown,
    sales:breakdown.sales.map(sale => Number(sale.storeId) === Number(homeStoreId) ? sale : ({
      id:sale.id,
      name:"Venda em outra loja",
      value:sale.value,
      storeId:sale.storeId,
      crossStore:true,
      recordType:"lift",
      source:"LIFT",
    })),
  };
}

const LIFT_COMMERCIAL_CUTOFF = "2026-10-01";

function periodIncludesLift(periodRange) {
  if (!periodRange) return true;
  if (!periodRange.to) return true;
  const end = periodRange.to instanceof Date ? periodRange.to : new Date(periodRange.to);
  if (Number.isNaN(end.getTime())) return false;
  const day = `${end.getFullYear()}-${String(end.getMonth()+1).padStart(2,"0")}-${String(end.getDate()).padStart(2,"0")}`;
  return day >= LIFT_COMMERCIAL_CUTOFF;
}

function CommercialSalesNotice({ breakdown, periodRange, error, loaded, storeId=null, consultantId=null }) {
  if (!periodIncludesLift(periodRange)) return null;
  const alerts = [];
  if (error) alerts.push(`Falha ao carregar os dados do CRM: ${error}. Os indicadores de vendas deste período podem estar incompletos ou desatualizados. Esta falha não confirma indisponibilidade do LIFT.`);
  else if (!loaded) alerts.push("Aguardando carregamento dos dados comerciais do CRM. Os indicadores de vendas serão atualizados quando o carregamento terminar.");
  else {
    alerts.push("Fonte das vendas comerciais: LIFT desde 01/10/2026.");
    const unknownCount = breakdown?.unknownOriginCount || 0;
    const manualCount = (breakdown?.manualWithoutLift || []).filter(sale => (
      (storeId == null || Number(sale.storeId) === Number(storeId))
      && (consultantId == null || Number(sale.consultantId) === Number(consultantId))
    )).length;
    if (unknownCount) alerts.push(`${unknownCount} venda(s) LIFT com origem não identificada.`);
    if (manualCount) alerts.push(`${manualCount} venda(s) registrada(s) no CRM sem correspondência no LIFT — confirme manualmente.`);
  }
  if (!alerts.length) return null;
  const failed = Boolean(error) || !loaded;
  return <div role="alert" style={{ background:failed?"#FEF2F2":"#FFF8E6", border:`1px solid ${failed?"#FCA5A5":"#FCD34D"}`, borderRadius:9, padding:"9px 12px", marginBottom:14, color:failed?"#991B1B":"#92400E", fontSize:12, lineHeight:1.45 }}>{alerts.map(alert=><div key={alert}>{alert}</div>)}</div>;
}

// ── Nova interface (Etapa 8a): vendas e acompanhamento ──────────────────────
export function VendasTela({
  clients, leads, prospeccao, currentUser, onAbrirConversa, onUpdateClient,
  onDeleteClient, onAddReminder, onSendZapi, onSendZapiMedia,
  onDeleteWhatsAppMessage, onEditWhatsAppMessage, whatsappMsgs,
  onReturnToAurora, onMarkRead, onRegistrarVenda, onConversationActive,
}) {
  const { commercialSales:liftSales, commercialError, commercialLoaded } = useContext(LiftPendingContext);
  const [monthIndex, setMonthIndex] = useState(0);
  const [selectedClient, setSelectedClient] = useState(null);
  const [detailsSale, setDetailsSale] = useState(null);
  const now = new Date();
  const periodRange = vendasMonthRange(now, monthIndex);
  const users = getActiveUsers();
  const stores = getActiveStores();
  const breakdown = vendasBreakdownForUser({
    clients,
    leads,
    prospeccao,
    currentUser,
    periodRange,
    liftSales,
    calculate:computeDashboardRevenueBreakdown,
    redact:redactConsultantCrossStoreSales,
  });
  const openConversation = route => {
    if (!route?.phone || route.fallback) return false;
    const resolved = resolveVendasConversation(route, {
      clients, leads, prospeccao, currentUser, resolveLeadConsultantId,
    });
    if (!resolved) return false;
    const sourceTab = ["leads", "prospeccao"].includes(resolved.route.moduleId);
    const phone = normalizedConversationPhone(resolved.route.phone);
    const storeId = Number(resolved.route.storeId);
    // A phone-only chat cache cannot distinguish two records sharing the same
    // store and phone. Without a unique source, open the exact client ficha.
    const matchingRecords = [
      ...clients.filter(client => Number(client.storeId) === storeId
        && normalizedConversationPhone(client.phone || client.telefone) === phone),
      ...leads.filter(lead => (
        [lead.lojaAtual, lead.whatsappStoreId, lead.storeId].some(id => Number(id) === storeId)
        && normalizedConversationPhone(lead.telefone || lead.phone) === phone
      )),
      ...prospeccao.filter(prospect => Number(prospect.storeId) === storeId
        && normalizedConversationPhone(prospect.phone || prospect.telefone) === phone),
    ];
    const hasChat = Object.keys(messagesForConversation(
      whatsappMsgs, resolved.route.storeId, resolved.route.phone,
    )).length > 0;
    return Boolean((sourceTab || (hasChat && matchingRecords.length === 1))
      && onAbrirConversa?.(route));
  };
  const authorizedClient = candidate => {
    if (candidate?.id == null) return null;
    return clients.find(client => (
      String(client.id) === String(candidate.id)
      && Number(client.storeId) === Number(candidate.storeId)
      && (currentUser.role !== "manager" || Number(client.storeId) === Number(currentUser.storeId))
      && (currentUser.role !== "consultant"
        || (Number(client.storeId) === Number(currentUser.storeId)
          && Number(client.consultantId) === Number(currentUser.id)))
    )) || null;
  };
  const openSale = sale => {
    if (!sale.crossStore) {
      const route = saleConversationRoute(sale, currentUser.storeId);
      if (openConversation(route)) return;
      const client = authorizedClient(sale.client || (sale.recordType === "client" ? sale.record : null));
      if (client) { setSelectedClient(client); return; }
    }
    setDetailsSale(sale);
  };
  const openFollowUp = client => {
    const currentClient = authorizedClient(client);
    if (currentClient) {
      const route = saleConversationRoute({
        client:currentClient, storeId:currentClient.storeId, phone:currentClient.phone,
      }, currentUser.storeId);
      if (openConversation(route)) return;
      setSelectedClient(currentClient);
      return;
    }
    setDetailsSale({
      recordType:"client", client:null, record:null,
      name:client.name, value:client.value, saleDate:getClosingDate(client),
      origin:client.origin, consultantId:client.consultantId, storeId:client.storeId,
    });
  };
  const sales = buildVendasMonthRows(breakdown.sales, {
    currentUser,
    users,
    stores,
    onOpenSale:openSale,
  });
  const followUps = buildVendasFollowUps(clients, {
    currentUser,
    users,
    wasSold,
    now,
    onOpenFollowUp:openFollowUp,
  });
  const activeClient = selectedClient && authorizedClient(selectedClient);
  return (
    <>
    <Vendas
      theme={T}
      meses={vendasMonthLabels(now)}
      mesIdx={monthIndex}
      onMes={setMonthIndex}
      aviso={<CommercialSalesNotice
        breakdown={breakdown}
        periodRange={periodRange}
        error={commercialError}
        loaded={commercialLoaded}
        storeId={currentUser.role === "consultant" || currentUser.role === "manager" ? currentUser.storeId : null}
        consultantId={currentUser.role === "consultant" ? currentUser.id : null}
        liftSales={liftSales}
      />}
      resumo={{
        total:breakdown.totalValue,
        qtd:breakdown.totalQtd,
        porOrigem:buildVendasOriginTotals(breakdown.sales),
      }}
      vendas={sales}
      acompanhamento={followUps}
      mostrarConsultor={currentUser.role !== "consultant"}
    />
    {activeClient && <ClientModal
      key={activeClient.id}
      client={activeClient}
      storeId={activeClient.storeId}
      currentUser={currentUser}
      onClose={() => setSelectedClient(null)}
      onUpdate={onUpdateClient}
      onDelete={id => { onDeleteClient(id); setSelectedClient(null); }}
      onAddReminder={onAddReminder}
      onSendZapi={onSendZapi}
      onSendZapiMedia={onSendZapiMedia}
      onDeleteWhatsAppMessage={onDeleteWhatsAppMessage}
      onEditWhatsAppMessage={onEditWhatsAppMessage}
      whatsappMsgs={whatsappMsgs}
      onReturnToAurora={onReturnToAurora}
      onMarkRead={onMarkRead}
      onRegistrarVenda={onRegistrarVenda
        ? () => onRegistrarVenda(createSaleTarget("kanban", activeClient, activeClient.storeId, currentUser.id))
        : null}
      onConversationActive={onConversationActive}
    />}
    {detailsSale && <SaleDetailsPanel
      sale={detailsSale}
      semVinculo={!detailsSale.crossStore}
      users={users}
      stores={stores}
      currentUser={currentUser}
      onClose={() => setDetailsSale(null)}
    />}
    </>
  );
}

function saleToDrillItem(sale, { onOpenClient, onOpenLead, onOpenProsp }={}) {
  const consultant = sale.crossStore ? undefined : USERS.find(u=>u.id===sale.consultantId)?.name;
  const store = STORES.find(s=>s.id===sale.storeId)?.name;
  const onAction = sale.client && onOpenClient
    ? () => onOpenClient(sale.client)
    : sale.recordType === "lead" && onOpenLead
      ? () => onOpenLead(sale.record)
      : sale.recordType === "prospeccao" && onOpenProsp
        ? () => onOpenProsp(sale.record)
        : undefined;
  const actionLabel = sale.client ? "Ver ficha" : sale.recordType === "lead" ? "Abrir lead" : sale.recordType === "prospeccao" ? "Abrir prospecção" : undefined;
  return {
    id:sale.id,
    name:sale.crossStore ? "Venda em outra loja" : sale.name,
    phone:sale.crossStore ? undefined : sale.phone,
    consultant,
    store,
    origin:sale.origin,
    status:sale.crossStore ? "Venda em outra loja" : sale.source,
    saleDate:sale.crossStore ? undefined : sale.saleDate,
    value:sale.value,
    actionLabel:onAction ? actionLabel : undefined,
    onAction,
  };
}

function LegacySalesNotice({ value }) {
  if (!(value > 0)) return null;
  return (
    <div style={{ background:"#FFF8E6", border:"1px solid #FCD34D", borderRadius:10, padding:"9px 12px", marginBottom:14, color:"#92400E", fontSize:11.5, lineHeight:1.45 }}>
      <strong>Registro manual legado: {fmt(value)}</strong> sem cliente, data e comprovante individual. Este valor não entra em “Vendido”, metas, ticket ou recebimentos até ser conciliado.
    </div>
  );
}

// Card de resumo de uma origem (valor vendido, quantidade e conversão)
export function OriginBreakdownCard({ icon, label, data, color, onClick }) {
  const cardMoney=value=>(value||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});
  const denomUnit = label === "Lead" ? ["lead","leads"]
    : label === "Prospecção" ? ["prospecção","prospecções"]
    : ["atendimento","atendimentos"];
  const denomLabel = data.arrived === 1 ? denomUnit[0] : denomUnit[1];
  return (
    <div onClick={onClick} style={{ background:"#fff", borderRadius:12, padding:"14px 16px", boxShadow:"0 2px 8px rgba(0,0,0,0.06)", borderLeft:`4px solid ${color}`, cursor:onClick?"pointer":"default" }}>
      <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:8 }}>
        <span style={{ fontSize:16 }}>{icon}</span>
        <span style={{ fontSize:13, fontWeight:700, color:"#1E293B" }}>{label}</span>
      </div>
      <div style={{ fontSize:19, fontWeight:800, color }}>{data.value>0?cardMoney(data.value):"—"}</div>
      <div style={{ fontSize:11, color:"#64748B", marginTop:4, display:"flex", justifyContent:"space-between" }}>
        <span>{data.qtd} venda{data.qtd!==1?"s":""} de {data.arrived} {denomLabel}</span>
        <span style={{ fontWeight:700, color:"#D97706" }}>{data.conv==null?"—":`${data.conv}%`} conv.</span>
      </div>
      {label==="Lead"&&data.probableCount>0&&<div style={{fontSize:11,color:"#64748B",marginTop:5}}
        title="Informativo: estes pedidos permanecem no cartão Prospecção ou Venda direta e não são somados duas vezes.">
        + {cardMoney(data.probableValue)} prováveis
      </div>}
    </div>
  );
}

// ── Inteligência da Carteira Comercial ("Em Orçamentos") ────────
// Configuração padrão de prazos (dias) — configurável via portfolioThresholds (Firebase)
const DEFAULT_PORTFOLIO_THRESHOLDS = { riskDays: 30 };
// Quantos dias corridos o cliente está em negociação, a partir da data de entrada (createdAt)
function diasEmNegociacao(c) {
  const d = toDateSafe(c.createdAt);
  if (!d) return 0;
  return Math.max(0, Math.floor((Date.now() - d.getTime()) / 86400000));
}
// Classificação única e reutilizável da carteira em orçamento, respeitando o filtro global de período.
// Prioridade: Risco (dias em negociação > riskDays) > Novo (entrou dentro do período) > Recuperação (entrou antes).
function classifyCarteira(c, periodRange, thresholds) {
  const th = thresholds || DEFAULT_PORTFOLIO_THRESHOLDS;
  const dias = diasEmNegociacao(c);
  if (dias > (th.riskDays || DEFAULT_PORTFOLIO_THRESHOLDS.riskDays)) return { category:"risco", dias };
  return { category: inPeriod(c.createdAt, periodRange) ? "novo" : "recuperacao", dias };
}
// Agrupa uma lista de clientes em orçamento nas 3 categorias da carteira
function groupCarteira(list, periodRange, thresholds) {
  const groups = { novo:[], recuperacao:[], risco:[] };
  list.forEach(c => {
    const { category, dias } = classifyCarteira(c, periodRange, thresholds);
    groups[category].push({ c, dias });
  });
  return groups;
}

function StoreDashboard({ store, clients, leads=[], prospeccao=[], liftSales=[], commercialError="", commercialLoaded=false, rs, periodRange, periodLabel, effPeriod, today, onUpdateClient, onDeleteClient, onAddReminder, onSendZapi, onSendZapiMedia, whatsappMsgs, portfolioThresholds, onSavePortfolioThresholds, onReturnToAurora, onOpenLead, onOpenProsp, onConversationActive }) {
  const th = THEMES[store.id] || T_DEMO;
  const [drillDown, setDrillDown] = useState(null);
  const [drillSelected, setDrillSelected] = useState(null);
  const [portfolioDrillOpen, setPortfolioDrillOpen] = useState(false);
  const consultants = USERS.filter(u=>u.storeId===store.id&&u.role==="consultant");
  const allClients  = clients.filter(c=>Number(c.storeId)===Number(store.id));
  // nextSale com venda realizada (tem data closed/posVenda) também conta; semInteresse não conta
  // "closed" (só clientes) é usado apenas para Recebido/A Receber, que só existe em registros de Cliente (paidValue)
  const closed  = allClients.filter(c => wasSold(c) && inPeriod(getClosingDate(c), periodRange));
  const open    = allClients.filter(c=>!["closed","posVenda","nextSale","semInteresse"].includes(c.stage));
  const urgent  = allClients.filter(c=>c.stage==="final");
  const arrivedInMonth = allClients.filter(c => inPeriod(c.createdAt, periodRange));
  const mine = arrivedInMonth;

  // ── Origem das vendas: Lead / Prospecção / Atendimento Presencial-Porta — fonte única de "vendas fechadas" ──
  const originBreakdownS = computeDashboardRevenueBreakdown({ clients, periodRange, storeId: store.id, consultantId: null, liftSales });
  const consultantOriginSummaryS = consultants.map(u => ({
    id:u.id, name:u.name,
    breakdown: redactConsultantCrossStoreSales(computeDashboardRevenueBreakdown({
      clients, periodRange, storeId:null, consultantId:u.id, consultantAcrossStores:true, liftSales,
    }), store.id),
  })).sort((a,b)=>b.breakdown.totalValue-a.breakdown.totalValue);

  // Atendimento Presencial usa as fichas de cliente fechadas, inclusive Lead/Prospecção
  // que já foram convertidos em atendimento. O quadro de origem continua separado em `porta`.
  const atendidosMes   = arrivedInMonth;
  const vendidosDeAtendidos = originBreakdownS.atendVendidosList;
  const valorAtendimento    = originBreakdownS.atendimento.value;
  const convAtendimento     = originBreakdownS.atendimento.conv;
  const rankingAtendimento = consultantOriginSummaryS.map(r => ({
    id:r.id, name:r.name,
    atendidos: r.breakdown.atendimento.arrived, atendidosList: atendidosMes.filter(c=>Number(c.consultantId)===Number(r.id)),
    vendidos: r.breakdown.totalQtd, vendidosList: r.breakdown.sales.map(saleToDrillItem),
    valor: r.breakdown.totalValue,
    conv: r.breakdown.atendimento.conv,
  })).sort((a,b)=>b.valor-a.valor);
  const legacyUnverified = consultants.reduce((s,u)=>s+(rs[u.id]||0),0);
  const totalClosed      = originBreakdownS.totalValue;
  const closedCountS     = originBreakdownS.totalQtd;
  const totalOpen    = open.reduce((s,c)=>s+(c.value||0),0);
  const pendingClientsS = closed.filter(c=>Math.max(0,(c.value||0)-(c.paidValue!==undefined?c.paidValue:(c.value||0)))>0);
  const totalPending = closed.reduce((s,c)=>s+Math.max(0,(c.value||0)-( c.paidValue!==undefined?c.paidValue:(c.value||0))),0);
  const ticketMedioS = originBreakdownS.ticketMedio;
  const activeConsultantsCount = rankingAtendimento.filter(r=>r.atendidos>0).length;
  const ticketAtendimento = vendidosDeAtendidos.length>0 ? Math.round(valorAtendimento/vendidosDeAtendidos.length) : 0;
  const isCurrentMonthS = effPeriod === "este_mes";
  const nowS = new Date();
  const daysLeftS    = isCurrentMonthS ? Math.max(1, new Date(nowS.getFullYear(),nowS.getMonth()+1,0).getDate() - nowS.getDate()) : 1;
  const dailyNeededS = isCurrentMonthS && store.goal-totalClosed>0 ? Math.ceil((store.goal-totalClosed)/daysLeftS) : 0;
  const p = pct(totalClosed, store.goal);
  const pS= pct(totalClosed, store.superGoal);
  const alertas = allClients.filter(c=>c.deliveryDate&&c.deliveryStatus!=="entregue"&&Math.ceil((new Date(c.deliveryDate)-new Date(today))/86400000)<=3);

  const clientToItem = (c) => ({
    id:c.id, name:c.name, phone:c.phone,
    consultant:USERS.find(u=>u.id===c.consultantId)?.name.split(" ")[0],
    origin:c.origin, value:c.value||0, createdAt:c.createdAt, lastInteraction:c.lastInteraction,
    status:c.stage, actionLabel:"Ver card", onAction:()=>setDrillSelected(c),
  });
  const openDrill = (title, list) => setDrillDown({ title, period:`${periodLabel} · ${store.name}`, items:list.map(clientToItem) });
  const openDrillItems = (title, items) => setDrillDown({ title, period:`${periodLabel} · ${store.name}`, items });

  const carteira = groupCarteira(open, periodRange, portfolioThresholds);
  const toPortfolioItem = ({ c, dias }) => ({ ...clientToItem(c), dias, followUp:c.followUp });
  const carteiraGroups = { novo:carteira.novo.map(toPortfolioItem), recuperacao:carteira.recuperacao.map(toPortfolioItem), risco:carteira.risco.map(toPortfolioItem) };
  const totalNovos       = carteiraGroups.novo.reduce((s,it)=>s+(it.value||0),0);
  const totalRecuperacao = carteiraGroups.recuperacao.reduce((s,it)=>s+(it.value||0),0);
  const totalRisco       = carteiraGroups.risco.reduce((s,it)=>s+(it.value||0),0);
  const saleToItemS = sale => saleToDrillItem(sale, {
    onOpenClient:setDrillSelected,
    onOpenLead:lead => { setDrillDown(null); onOpenLead?.(lead); },
    onOpenProsp:prospect => { setDrillDown(null); onOpenProsp?.(prospect); },
  });
  const combinedClosedItemsS = originBreakdownS.sales.map(saleToItemS);

  return (
    <div style={{ background:"#fff", borderRadius:16, padding:24, marginBottom:20, boxShadow:"0 2px 16px rgba(0,0,0,0.08)", borderTop:`4px solid ${th.accent}` }}>
      {/* Cabeçalho da loja */}
      <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:16, paddingBottom:14, borderBottom:`2px solid ${th.sand}` }}>
        <div style={{ width:44, height:44, borderRadius:"50%", background:th.headerGrad, display:"flex", alignItems:"center", justifyContent:"center", fontSize:22 }}>👑</div>
        <div style={{ flex:1 }}>
          <div style={{ fontWeight:800, fontSize:17, color:th.text }}>{store.name}</div>
          <div style={{ fontSize:12, color:th.muted }}>{consultants.length} consultores · Meta: {fmt(store.goal)}</div>
        </div>
        <div style={{ textAlign:"right" }}>
          <div style={{ fontSize:22, fontWeight:800, color:th.positive }}>{fmt(totalClosed)}</div>
          <div style={{ fontSize:11, color:th.muted }}>{p}% da meta</div>
        </div>
      </div>

      {/* Alertas urgentes */}
      {urgent.length>0 && (
        <div style={{ background:`${th.accent}11`, border:`1.5px solid ${th.accent}`, borderRadius:10, padding:"10px 14px", marginBottom:14, display:"flex", gap:10, alignItems:"center" }}>
          <span style={{ fontSize:18 }}>⚠️</span>
          <div style={{ fontSize:13, fontWeight:700, color:th.accent }}>{urgent.length} cliente{urgent.length>1?"s":""} com proposta final — {urgent.map(c=>c.name).join(", ")}</div>
        </div>
      )}
      {alertas.length>0 && (
        <div style={{ background:"#FFF8E6", border:"1.5px solid #D97706", borderRadius:10, padding:"10px 14px", marginBottom:14 }}>
          <div style={{ fontSize:12, fontWeight:700, color:"#D97706", marginBottom:4 }}>📦 Entrega{alertas.length>1?"s":""} com atenção:</div>
          {alertas.map(c => {
            const diff = Math.ceil((new Date(c.deliveryDate)-new Date(today))/86400000);
            return <div key={c.id} style={{ fontSize:12, color:"#92400E" }}>{diff<0?"🚨 Atrasada":diff===0?"⚠️ Hoje":`⚠️ Em ${diff}d`} — {c.name}</div>;
          })}
        </div>
      )}
      {drillDown && <DrillDownModal {...drillDown} onClose={()=>setDrillDown(null)} />}
      {drillSelected && <ClientModal client={drillSelected} storeId={drillSelected.storeId} onClose={()=>setDrillSelected(null)}
        onUpdate={onUpdateClient ? (u=>onUpdateClient(u)) : undefined}
        onDelete={onDeleteClient ? (id=>{ onDeleteClient(id); setDrillSelected(null); }) : undefined}
        onAddReminder={onAddReminder} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} whatsappMsgs={whatsappMsgs} onReturnToAurora={onReturnToAurora} onConversationActive={onConversationActive} />}

      {/* Métricas */}
      <CommercialSalesNotice breakdown={originBreakdownS} periodRange={periodRange} error={commercialError} loaded={commercialLoaded} storeId={store.id} liftSales={liftSales} />
      <LegacySalesNotice value={legacyUnverified} />
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(100px,1fr))", gap:10, marginBottom:16 }}>
        {[
          { icon:"💵", label:"Vendido",     value:fmt(totalClosed),                              color:th.positive, onClick:()=>openDrillItems("Vendido", combinedClosedItemsS),
            sub:`🛒 ${closedCountS} venda${closedCountS!==1?"s":""}` },
          { icon:"⏳", label:"A receber",   value:fmt(totalPending),                             color:totalPending>0?"#D97706":th.muted, onClick:()=>openDrill("A receber", pendingClientsS),
            sub: totalPending>0 ? `📦 ${pendingClientsS.length} cliente${pendingClientsS.length!==1?"s":""} aguardando pagamento` : "👏 tudo recebido" },
          { icon:"🎯", label:"Em aberto",   value:fmt(totalOpen),                                color:th.gold, onClick:()=>setPortfolioDrillOpen(true),
            custom: (
              <>
                <div style={{ fontSize:16 }}>🎯</div>
                <div style={{ fontSize:15, fontWeight:800, color:th.gold }}>{fmt(totalOpen)}</div>
                <div style={{ fontSize:10, color:th.muted }}>📋 {open.length} orçamento{open.length!==1?"s":""} ativo{open.length!==1?"s":""}</div>
                <div style={{ fontSize:9, color:th.muted, marginTop:4, lineHeight:1.6, textAlign:"left" }}>
                  <div>📅 Mês Atual: {fmt(totalNovos)} · {carteiraGroups.novo.length}</div>
                  <div>🔄 Carteira Anterior: {fmt(totalRecuperacao)} · {carteiraGroups.recuperacao.length}</div>
                  <div>⚠️ Em Risco: {fmt(totalRisco)} · {carteiraGroups.risco.length}</div>
                </div>
              </>
            ) },
          { icon:"📊", label:"Conversão",   value:`${pct(closedCountS,mine.length||1)}%`,       color:th.accent, onClick:()=>openDrillItems("Conversão — vendas fechadas do mês", combinedClosedItemsS),
            sub:`🎯 ${closedCountS} de ${mine.length||0} oportunidades` },
          { icon:"🎫", label:"Ticket Médio",value:ticketMedioS>0?fmt(ticketMedioS):"—",          color:th.navyLight, onClick:()=>openDrillItems("Ticket Médio — vendas do mês", combinedClosedItemsS),
            sub: closedCountS>0 ? `🎫 ${closedCountS} venda${closedCountS!==1?"s":""}` : "sem vendas ainda" },
          { icon:"📆", label:"Meta/Dia",    value:dailyNeededS>0?fmt(dailyNeededS):"✅ Meta!",    color:dailyNeededS>0?"#D97706":th.positive,
            sub: isCurrentMonthS ? `📆 ${daysLeftS} dia${daysLeftS!==1?"s":""} restante${daysLeftS!==1?"s":""}` : "" },
        ].map(m => (
          <div key={m.label} onClick={m.onClick} style={{ background:"#fff", borderRadius:10, padding:"10px 12px", textAlign:"center", border:"1px solid #E2E8F0", cursor:m.onClick?"pointer":"default" }}>
            {m.custom ? m.custom : (
              <>
                <div style={{ fontSize:16 }}>{m.icon}</div>
                <div style={{ fontSize:15, fontWeight:800, color:m.color }}>{m.value}</div>
                <div style={{ fontSize:10, color:th.muted }}>{m.label}</div>
                {m.sub && <div style={{ fontSize:9, color:m.color, fontWeight:700, marginTop:3 }}>{m.sub}</div>}
              </>
            )}
          </div>
        ))}
      </div>
      {portfolioDrillOpen && (
        <PortfolioDrillModal periodLabel={`${periodLabel} · ${store.name}`} groups={carteiraGroups}
          onClose={()=>setPortfolioDrillOpen(false)}
          thresholds={portfolioThresholds||DEFAULT_PORTFOLIO_THRESHOLDS} onSaveThresholds={onSavePortfolioThresholds} canEditThresholds={!!onSavePortfolioThresholds} />
      )}

      {/* Barra de meta */}
      <div style={{ marginBottom:12 }}>
        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
          <span style={{ fontSize:12, color:th.muted }}>Meta: {fmt(totalClosed)} / {fmt(store.goal)}</span>
          <span style={{ fontSize:12, fontWeight:700, color:p>=75?th.positive:th.accent }}>{p}%</span>
        </div>
        <div style={{ background:th.sandDark, borderRadius:99, height:10, overflow:"hidden", marginBottom:6 }}>
          <div style={{ width:`${Math.min(p,100)}%`, height:"100%", background:`linear-gradient(90deg,${p>=75?th.positive:th.accent},${th.accentLight})`, borderRadius:99, transition:"width 0.6s" }} />
        </div>
        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:3 }}>
          <span style={{ fontSize:11, color:th.gold }}>🚀 Super Meta: {fmt(store.superGoal)}</span>
          <span style={{ fontSize:11, fontWeight:700, color:th.gold }}>{pS}%</span>
        </div>
        <div style={{ background:th.sandDark, borderRadius:99, height:6, overflow:"hidden" }}>
          <div style={{ width:`${Math.min(pS,100)}%`, height:"100%", background:`linear-gradient(90deg,${th.gold},${th.accentLight})`, borderRadius:99, transition:"width 0.6s" }} />
        </div>
      </div>

      {/* Ranking de consultores */}
      <div style={{ fontSize:12, fontWeight:700, color:th.muted, marginBottom:8 }}>🏆 Ranking</div>
      <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
        {consultants
          .map(c => {
            const bd = consultantOriginSummaryS.find(s => s.id === c.id);
            return { ...c, sold: bd?.breakdown.totalValue || 0 };
          })
          .sort((a,b)=>b.sold-a.sold)
          .map((c,i) => {
            const medal = i===0?"🥇":i===1?"🥈":i===2?"🥉":"👤";
            const cp = pct(c.sold, store.consultantGoal);
            return (
              <div key={c.id} style={{ background:"#fff", borderRadius:10, padding:"10px 14px", minWidth:150, flex:"1 1 150px", border:"1px solid #E2E8F0" }}>
                <div style={{ fontWeight:700, fontSize:13, color:th.text }}>{medal} {c.name.split(" ")[0]}</div>
                <div style={{ fontSize:16, fontWeight:800, color:th.accent, marginTop:2 }}>{fmt(c.sold)}</div>
                <div style={{ fontSize:10, color:th.muted }}>meta: {cp}%</div>
                <div style={{ background:"#E2E8F0", borderRadius:99, height:5, marginTop:4, overflow:"hidden" }}>
                  <div style={{ width:`${Math.min(cp,100)}%`, height:"100%", background:cp>=75?th.positive:th.accent, borderRadius:99 }} />
                </div>
              </div>
            );
          })}
      </div>

      {/* Atendimento Presencial: números fechados — atendimentos, vendas e conversão sempre do mesmo conjunto */}
      <div style={{ marginTop:18, paddingTop:14, borderTop:`2px solid ${th.sand}` }}>
        <div style={{ fontSize:12, fontWeight:700, color:th.muted, marginBottom:8 }}>🚪 Atendimento Presencial — {periodLabel}</div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(110px,1fr))", gap:10, marginBottom:12 }}>
          {[
            { icon:"👥", label:"Atendimentos", value:atendidosMes.length,                    onClick:()=>openDrill("Atendimentos presenciais", atendidosMes),
              sub:`👤 ${activeConsultantsCount} consultor${activeConsultantsCount!==1?"es":""} atender${activeConsultantsCount!==1?"am":"am"}` },
            { icon:"✅", label:"Vendas",        value:vendidosDeAtendidos.length,             onClick:()=>openDrill("Vendas originadas de atendimento", vendidosDeAtendidos),
              sub:`💰 ${fmt(valorAtendimento)} vendidos` },
            { icon:"📊", label:"Conversão",     value:`${convAtendimento}%`,                  onClick:()=>openDrill("Conversão de atendimento presencial", vendidosDeAtendidos),
              sub:`🎯 ${vendidosDeAtendidos.length} de ${atendidosMes.length} atendimentos` },
            { icon:"💰", label:"Valor vendido", value:fmt(valorAtendimento),                  onClick:()=>openDrill("Valor vendido — atendimento presencial", vendidosDeAtendidos),
              sub: ticketAtendimento>0 ? `🎫 ticket médio: ${fmt(ticketAtendimento)}` : "sem vendas ainda" },
          ].map(m => (
            <div key={m.label} onClick={m.onClick} style={{ background:"#fff", borderRadius:10, padding:"10px 12px", textAlign:"center", border:"1px solid #E2E8F0", cursor:m.onClick?"pointer":"default" }}>
              <div style={{ fontSize:16 }}>{m.icon}</div>
              <div style={{ fontSize:15, fontWeight:800, color:th.accent }}>{m.value}</div>
              <div style={{ fontSize:10, color:th.muted }}>{m.label}</div>
              {m.sub && <div style={{ fontSize:9, color:th.accent, fontWeight:700, marginTop:3 }}>{m.sub}</div>}
            </div>
          ))}
        </div>
        <div style={{ fontSize:11, fontWeight:700, color:th.muted, marginBottom:6 }}>Resumo por consultor</div>
        <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
          {rankingAtendimento.map(r => (
            <div key={r.id} style={{ display:"flex", alignItems:"center", gap:10, background:"#fff", border:"1px solid #E2E8F0", borderRadius:10, padding:"8px 12px", flexWrap:"wrap" }}>
              <div style={{ flex:"1 1 120px", fontWeight:700, fontSize:12.5, color:th.text }}>{r.name.split(" ")[0]}</div>
              <div onClick={()=>openDrill(`Atendimentos — ${r.name.split(" ")[0]}`, r.atendidosList)} style={{ cursor:"pointer", fontSize:12, color:th.navyLight }}>👥 {r.atendidos} atend.</div>
              <div onClick={()=>r.vendidos>0 && openDrill(`Vendas — ${r.name.split(" ")[0]}`, r.vendidosList)} style={{ cursor:r.vendidos>0?"pointer":"default", fontSize:12, color:th.positive }}>✅ {r.vendidos} venda{r.vendidos!==1?"s":""}</div>
              <div style={{ fontSize:12, color:th.accent }}>📊 {r.conv}%</div>
              <div style={{ fontSize:12, fontWeight:700, color:th.text }}>{fmt(r.valor)}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Origem das Vendas: Lead / Prospecção / Atendimento Presencial-Porta */}
      <div style={{ marginTop:18, paddingTop:14, borderTop:`2px solid ${th.sand}` }}>
        <div style={{ fontSize:12, fontWeight:700, color:th.muted, marginBottom:8 }}>Vínculos operacionais das vendas — {periodLabel}</div>
        <DashboardOriginCards Card={OriginBreakdownCard} storeId={store.id} periodRange={periodRange}
          legacyBreakdown={originBreakdownS} sales={originBreakdownS.sales}
          onOpen={(label,rows)=>openDrillItems(`Vendas de ${label} — ${periodLabel}`,rows.map(saleToItemS))}/>
        <div style={{ fontSize:11, fontWeight:700, color:th.muted, marginBottom:6 }}>Resumo por consultor</div>
        <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
          {consultantOriginSummaryS.map(r => (
            <div key={r.id} style={{ background:"#fff", border:"1px solid #E2E8F0", borderRadius:10, padding:"10px 12px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:6, marginBottom:6 }}>
                <div style={{ fontWeight:700, fontSize:12.5, color:th.text }}>{r.name.split(" ")[0]}</div>
                <div style={{ fontSize:13, fontWeight:800, color:th.positive }}>{fmt(r.breakdown.totalValue)} · {r.breakdown.totalQtd} venda{r.breakdown.totalQtd!==1?"s":""} · 🎫 {r.breakdown.ticketMedio>0?fmt(r.breakdown.ticketMedio):"—"}</div>
              </div>
              <div style={{ display:"flex", gap:14, flexWrap:"wrap", fontSize:11.5, color:th.muted }}>
                <span>📥 Lead: <strong>{fmt(r.breakdown.lead.value)}</strong> ({r.breakdown.lead.qtd} de {r.breakdown.lead.arrived}, {r.breakdown.lead.conv}%)</span>
                <span>🔎 Prospecção: <strong>{fmt(r.breakdown.prospeccao.value)}</strong> ({r.breakdown.prospeccao.qtd} de {r.breakdown.prospeccao.arrived}, {r.breakdown.prospeccao.conv}%)</span>
                <span>🏪 Atendimento: <strong>{fmt(r.breakdown.porta.value)}</strong> ({r.breakdown.porta.qtd} de {r.breakdown.porta.arrived}, {r.breakdown.porta.conv}%)</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function DashboardView({ clients, leads=[], prospeccao=[], currentUser, realSales, selectedMonth, onSelectMonth, onUpdateClient, onDeleteClient, onAddReminder, onSendZapi, onSendZapiMedia, whatsappMsgs, portfolioThresholds, onSavePortfolioThresholds, onReturnToAurora, onOpenLead, onOpenProsp, onConversationActive }) {
  const goalStores=useMonthlyGoalStores(getActiveStores(),selectedMonth||currentDateKeySaoPaulo().slice(0,7));
  const { commercialSales:liftSales, commercialError, commercialLoaded } = useContext(LiftPendingContext);
  const goalMonth=selectedMonth||currentDateKeySaoPaulo().slice(0,7);
  const monthlyGoalStore=goalStores.find(store=>Number(store.id)===Number(currentUser.storeId));
  const monthlyGoalLedger=monthlyGoalStore?computeDashboardRevenueBreakdown({
    clients,periodRange:monthlyGoalRange(goalMonth),
    storeId:currentUser.role==="consultant"?null:currentUser.storeId,
    consultantId:currentUser.role==="consultant"?currentUser.id:null,
    consultantAcrossStores:currentUser.role==="consultant",liftSales,
  }):null;
  const rs = realSales || REAL_SALES;
  const today = new Date().toISOString().split("T")[0];
  const [drillDown, setDrillDown] = useState(null);
  const [drillSelected, setDrillSelected] = useState(null);
  const [portfolioDrillOpen, setPortfolioDrillOpen] = useState(false);
  const [localFilters, setLocalFilters] = useScreenPeriodFilters("dashboard", DEFAULT_FILTERS);
  const effFiltersDash = localFilters;
  const effPeriodD = localFilters.period || "este_mes";
  const periodRangeD = getPeriodRange(effPeriodD, effFiltersDash.customFrom, effFiltersDash.customTo);
  const periodLabelD = periodLabelText(effFiltersDash, "");
  const isCurrentMonthD = effPeriodD === "este_mes";
  const filterHeader = (
    <div style={{ marginBottom:16 }}>
      {monthlyGoalStore&&<MonthlyGoalSummary month={goalMonth}
        goal={currentUser.role==="consultant"?monthlyGoalStore.consultantGoal:monthlyGoalStore.goal}
        sold={monthlyGoalLedger.totalValue} loaded={commercialLoaded} error={commercialError}
        isConsultant={currentUser.role==="consultant"}/>}
      <FilterBar filters={localFilters} setFilters={setLocalFilters} showConsultant={false} showStatus={false} />
    </div>
  );

  // ── ADMIN: geral (todas as lojas combinado) + por loja + por consultor ──
  if (currentUser.role === "admin") {
    const originBreakdownGeral = computeDashboardRevenueBreakdown({ clients, periodRange: periodRangeD, storeId: null, consultantId: null, liftSales });
    const openDrillGeral = (title, items) => setDrillDown({ title, period:periodLabelD, items });
    const saleToItemGeral = sale => saleToDrillItem(sale, {
      onOpenClient:setDrillSelected,
      onOpenLead:lead => { setDrillDown(null); onOpenLead?.(lead); },
      onOpenProsp:prospect => { setDrillDown(null); onOpenProsp?.(prospect); },
    });
    return (
      <div>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12, marginBottom:16 }}>
          <div>
            <div style={{ fontWeight:800, fontSize:20, color:T.text }}>Visão Geral — Todas as Lojas</div>
            <div style={{ fontSize:13, color:T.muted }}>Atualizado agora · {today}</div>
          </div>
        </div>
        {filterHeader}
        <CommercialSalesNotice breakdown={originBreakdownGeral} periodRange={periodRangeD} error={commercialError} loaded={commercialLoaded} liftSales={liftSales} />
        <div style={{ background:"#fff", borderRadius:16, padding:24, marginBottom:20, boxShadow:"0 2px 16px rgba(0,0,0,0.08)" }}>
          <DashboardOriginCards Card={OriginBreakdownCard} periodRange={periodRangeD}
            heading={`Vínculos operacionais — Geral (todas as lojas) — ${periodLabelD}`} stores={goalStores}
            legacyBreakdown={originBreakdownGeral} sales={originBreakdownGeral.sales}
            onOpen={(label,rows)=>openDrillGeral(`Vendas de ${label} — ${periodLabelD}`,rows.map(saleToItemGeral))}/>
        </div>

        {goalStores.map(store => (
          <StoreDashboard key={store.id} store={store} clients={clients} leads={leads} prospeccao={prospeccao} liftSales={liftSales} commercialError={commercialError} commercialLoaded={commercialLoaded} rs={rs} periodRange={periodRangeD} periodLabel={periodLabelD} effPeriod={effPeriodD} today={today} onUpdateClient={onUpdateClient} onDeleteClient={onDeleteClient} onAddReminder={onAddReminder} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} whatsappMsgs={whatsappMsgs} portfolioThresholds={portfolioThresholds} onSavePortfolioThresholds={onSavePortfolioThresholds} onReturnToAurora={onReturnToAurora} onOpenLead={onOpenLead} onOpenProsp={onOpenProsp} onConversationActive={onConversationActive} />
        ))}

        {drillDown && <DrillDownModal {...drillDown} onClose={()=>setDrillDown(null)} />}
        {drillSelected && <ClientModal client={drillSelected} storeId={drillSelected.storeId} onClose={()=>setDrillSelected(null)}
          onUpdate={updated => onUpdateClient(updated)} onDelete={id => { onDeleteClient(id); setDrillSelected(null); }}
          onAddReminder={onAddReminder} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} whatsappMsgs={whatsappMsgs} onReturnToAurora={onReturnToAurora} currentUser={currentUser} onConversationActive={onConversationActive} />}
      </div>
    );
  }

  // ── GERENTE / CONSULTOR ──────────────────────────────────────
  const nuDash = isNewUiEnabled() && ["consultant", "manager"].includes(currentUser.role);
  const store = goalStores.find(s => s.id===currentUser.storeId) || goalStores[0];
  const isConsultant = currentUser.role==="consultant";

  const activeGoal = isConsultant ? store.consultantGoal      : store.goal;
  const superGoal  = isConsultant ? store.consultantSuperGoal : store.superGoal;
  const goalLabel  = isConsultant ? "Meta Individual — " : "Meta da Loja — ";

  const allMine = currentUser.role==="manager"
    ? clients.filter(c => Number(c.storeId)===Number(currentUser.storeId))
    : clients.filter(c => Number(c.consultantId)===Number(currentUser.id));

  // nextSale com venda realizada (tem data closed/posVenda) também conta; semInteresse não conta
  // Vendas fechadas (só clientes) — usado apenas para Recebido/A Receber, que só existe em registros de Cliente (paidValue)
  const closed = allMine.filter(c => wasSold(c) && inPeriod(getClosingDate(c), periodRangeD));
  // Cards em aberto: sempre visíveis independente do mês
  const open   = allMine.filter(c => !["closed","posVenda","nextSale","semInteresse"].includes(c.stage));
  const lost   = allMine.filter(c => c.stage==="semInteresse");
  const urgent = allMine.filter(c => c.stage==="final");
  // Cards que chegaram no período selecionado (para conversão e breakdowns)
  const mine = allMine.filter(c => inPeriod(c.createdAt, periodRangeD));

  // ── Vendido x A Receber são indicadores separados: vendido nunca é reduzido pelo a receber ──
  // Fonte única de "vendas fechadas": computeOriginBreakdown (inclui vendas de Lead/Prospecção mesmo quando não viram registro de Cliente), evitando divergência entre blocos do dashboard.
  const originBreakdownD = isConsultant
    ? redactConsultantCrossStoreSales(computeDashboardRevenueBreakdown({
        clients, periodRange:periodRangeD, storeId:null, consultantId:currentUser.id, consultantAcrossStores:true, liftSales,
      }), currentUser.storeId)
    : computeDashboardRevenueBreakdown({ clients, periodRange:periodRangeD, storeId:currentUser.storeId, consultantId:null, liftSales });

  const totalClosed    = originBreakdownD.totalValue;
  const closedCount    = originBreakdownD.totalQtd;
  const totalReceived  = closed.reduce((s,c)=>s+(c.paidValue !== undefined ? c.paidValue : (c.value||0)),0);
  const totalPending   = closed.reduce((s,c)=>s+Math.max(0,(c.value||0)-(c.paidValue !== undefined ? c.paidValue : (c.value||0))),0);
  const totalOpen   = open.reduce((s,c)=>s+(c.value||0),0);
  const convRate    = pct(closedCount, mine.length||1);
  const pctGoal     = pct(totalClosed, activeGoal);
  const pctSuper    = pct(totalClosed, superGoal);
  const remaining   = activeGoal - totalClosed;
  const ticketMedio = originBreakdownD.ticketMedio;
  const nowD = new Date();
  const daysInMonth = new Date(nowD.getFullYear(), nowD.getMonth()+1, 0).getDate();
  const daysLeft    = isCurrentMonthD ? Math.max(1, daysInMonth - nowD.getDate()) : 1;
  const dailyNeeded = (isCurrentMonthD && remaining > 0) ? Math.ceil(remaining / daysLeft) : 0;

  const motivational = totalClosed>=superGoal ? "🚀🚀 SUPER META BATIDA! Você é incrível!!"
    : totalClosed>=activeGoal ? `🏆 Meta batida! Faltam ${fmt(superGoal-totalClosed)} pra Super Meta 🚀`
    : pctGoal>=75 ? `🔥 Quase lá! Faltam apenas ${fmt(remaining)} pra bater a meta!`
    : pctGoal>=50 ? "💪 Metade do caminho! Vai buscar!"
    : `🚀 ${fmt(remaining)} ainda pra bater a meta — bora!`;
  const consultantOriginSummary = !isConsultant
    ? USERS.filter(u=>u.role==="consultant" && u.storeId===currentUser.storeId).map(u => ({
        id:u.id, name:u.name,
        breakdown: redactConsultantCrossStoreSales(computeDashboardRevenueBreakdown({
          clients, periodRange:periodRangeD, storeId:null, consultantId:u.id, consultantAcrossStores:true, liftSales,
        }), currentUser.storeId),
      })).sort((a,b)=>b.breakdown.totalValue-a.breakdown.totalValue)
    : [];
  const legacyUnverifiedD = (isConsultant
    ? [currentUser]
    : USERS.filter(u=>u.role==="consultant" && u.storeId===currentUser.storeId)
  ).reduce((sum,u)=>sum+(rs[u.id]||0),0);

  const storeProducts = PRODUCTS_BY_STORE[currentUser.storeId||1]||PRODUCTS_BY_STORE[1];
  const byProduct = storeProducts.map(p => ({
    product:p,
    count:mine.filter(c=>c.product===p).length,
    value:mine.filter(c=>c.product===p).reduce((s,c)=>s+c.value,0),
  })).filter(p=>p.count>0).sort((a,b)=>b.value-a.value).slice(0,8);

  const clientToItem = (c) => ({
    id:c.id, name:c.name, phone:c.phone,
    consultant:USERS.find(u=>u.id===c.consultantId)?.name.split(" ")[0],
    origin:c.origin, value:c.value||0, createdAt:c.createdAt, lastInteraction:c.lastInteraction,
    status:c.stage, actionLabel:"Ver card", onAction:()=>setDrillSelected(c),
  });
  const openDrill = (title, list) => setDrillDown({ title, period:periodLabelD, items:list.map(clientToItem) });
  const openDrillItems = (title, items) => setDrillDown({ title, period:periodLabelD, items });
  const saleToItemD = sale => saleToDrillItem(sale, {
    onOpenClient:setDrillSelected,
    onOpenLead:lead => { setDrillDown(null); onOpenLead?.(lead); },
    onOpenProsp:prospect => { setDrillDown(null); onOpenProsp?.(prospect); },
  });
  const combinedClosedItems = originBreakdownD.sales.map(saleToItemD);
  const totalPendingCount = closed.filter(c=>Math.max(0,(c.value||0)-(c.paidValue!==undefined?c.paidValue:(c.value||0)))>0);

  const carteiraD = groupCarteira(open, periodRangeD, portfolioThresholds);
  const toPortfolioItemD = ({ c, dias }) => ({ ...clientToItem(c), dias, followUp:c.followUp });
  const carteiraGroupsD = { novo:carteiraD.novo.map(toPortfolioItemD), recuperacao:carteiraD.recuperacao.map(toPortfolioItemD), risco:carteiraD.risco.map(toPortfolioItemD) };
  const totalNovosD       = carteiraGroupsD.novo.reduce((s,it)=>s+(it.value||0),0);
  const totalRecuperacaoD = carteiraGroupsD.recuperacao.reduce((s,it)=>s+(it.value||0),0);
  const totalRiscoD       = carteiraGroupsD.risco.reduce((s,it)=>s+(it.value||0),0);

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12, marginBottom:16 }}>
        <div>
          <div style={{ fontWeight:800, fontSize:20, color:T.text }}>Visão Geral</div>
          <div style={{ fontSize:13, color:T.muted }}>Atualizado agora · {today}</div>
        </div>
      </div>
      {filterHeader}
      <CommercialSalesNotice breakdown={originBreakdownD} periodRange={periodRangeD} error={commercialError} loaded={commercialLoaded}
        storeId={isConsultant ? null : currentUser.storeId} consultantId={isConsultant ? currentUser.id : null} liftSales={liftSales} />
      <LegacySalesNotice value={legacyUnverifiedD} />

      {urgent.length>0 && (
        <div style={{ background:`linear-gradient(135deg,${T.accent}11,${T.accent}22)`, border:`2px solid ${T.accent}`, borderRadius:12, padding:"14px 18px", marginBottom:20, display:"flex", gap:12, alignItems:"center" }}>
          <div style={{ fontSize:24 }}>⚠️</div>
          <div>
            <div style={{ fontWeight:700, color:T.accent, fontSize:15 }}>{urgent.length} cliente{urgent.length>1?"s":""} precisam de proposta final!</div>
            <div style={{ fontSize:12, color:T.muted }}>Mês fechando — {urgent.map(c=>c.name).join(", ")}</div>
          </div>
        </div>
      )}

      {(() => {
        const alertas = allMine.filter(c => c.deliveryDate && c.deliveryStatus !== "entregue" && Math.ceil((new Date(c.deliveryDate) - new Date(today)) / 86400000) <= 3);
        if (!alertas.length) return null;
        return (
          <div style={{ background:"#FFF8E6", border:"2px solid #D97706", borderRadius:12, padding:"14px 18px", marginBottom:20 }}>
            <div style={{ fontWeight:700, color:"#D97706", fontSize:15, marginBottom:8 }}>📦 {alertas.length} entrega{alertas.length>1?"s":""} precisam de atenção!</div>
            {alertas.map(c => {
              const diff = Math.ceil((new Date(c.deliveryDate) - new Date(today)) / 86400000);
              return (
                <div key={c.id} style={{ fontSize:13, color:"#92400E", marginBottom:4 }}>
                  {diff < 0 ? "🚨 ATRASADA" : diff === 0 ? "⚠️ HOJE" : `⚠️ Em ${diff} dia${diff>1?"s":""}`} — <strong>{c.name}</strong> · {c.product}
                </div>
              );
            })}
          </div>
        );
      })()}

      {nuDash && (
        <DashboardMeta theme={T} titulo={`${goalLabel}${fmt(activeGoal)}`} periodo={periodLabelD}
          meta={activeGoal} superMeta={superGoal} vendido={totalClosed} vendas={closedCount} ticketMedio={ticketMedio}
          falta={remaining} metaDia={dailyNeeded} diasRestantes={daysLeft} mesAtual={isCurrentMonthD}
          emOrcamentos={totalOpen} recebido={totalReceived} aReceber={totalPending}
          motivacional={motivational} mostrarPotencial={isConsultant}
          onVendido={() => openDrillItems("Total Vendido no período", combinedClosedItems)}
          onRecebido={() => openDrill("Recebido no mês", closed)}
          onAReceber={() => openDrill("A Receber", totalPendingCount)} />
      )}
      {!nuDash && <div style={{ background:`linear-gradient(135deg,${T.positive}18,${T.positive}08)`, border:`2px solid ${T.positive}55`, borderRadius:14, padding:"16px 20px", marginBottom:14, display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:10 }}>
        <div onClick={()=>openDrillItems("Total Vendido no período", combinedClosedItems)} style={{ cursor:"pointer" }}>
          <div style={{ fontSize:11, fontWeight:700, color:T.muted, textTransform:"uppercase", letterSpacing:0.5 }}>💰 Total Vendido (comercial)</div>
          <div style={{ fontSize:30, fontWeight:900, color:T.positive, lineHeight:1.15 }}>{fmt(totalClosed)}</div>
          <div style={{ fontSize:12, color:T.muted, marginTop:2 }}>{closedCount} venda{closedCount!==1?"s":""} fechada{closedCount!==1?"s":""} · valor cheio, independente de pagamento</div>
        </div>
        <div style={{ display:"flex", gap:20 }}>
          <div onClick={()=>openDrill("Recebido no mês", closed)} style={{ cursor:"pointer", textAlign:"right" }}>
            <div style={{ fontSize:11, color:T.muted, fontWeight:600 }}>💵 Recebido (financeiro)</div>
            <div style={{ fontSize:17, fontWeight:800, color:T.text }}>{fmt(totalReceived)}</div>
          </div>
          <div onClick={()=>openDrill("A Receber", totalPendingCount)} style={{ cursor:"pointer", textAlign:"right" }}>
            <div style={{ fontSize:11, color:T.muted, fontWeight:600 }}>⏳ A Receber (financeiro)</div>
            <div style={{ fontSize:17, fontWeight:800, color:totalPending>0?"#D97706":T.muted }}>{fmt(totalPending)}</div>
          </div>
        </div>
      </div>}

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))", gap:12, marginBottom:24 }}>
        <MetricCard icon="🎯" label="Em orçamentos"      value={fmt(totalOpen)}     accent={T.gold}     sub={<>🟢 Mês Atual {fmt(totalNovosD)} · 🟡 Carteira Anterior {fmt(totalRecuperacaoD)} · 🔴 Em Risco {fmt(totalRiscoD)}</>} onClick={()=>setPortfolioDrillOpen(true)} />
        <MetricCard icon="📊" label="Conversão"          value={`${convRate}%`}     accent={T.accent}   sub={`${closedCount} de ${mine.length||0} · ${lost.length} perdido${lost.length!==1?"s":""}`} onClick={()=>openDrillItems("Conversão — vendas fechadas do mês", combinedClosedItems)} />
        <MetricCard icon="🎫" label="Ticket Médio"       value={ticketMedio>0?fmt(ticketMedio):"—"}  accent={T.navyLight} sub={ticketMedio>0?"por venda fechada":"sem vendas ainda"} onClick={()=>openDrillItems("Ticket Médio — vendas do mês", combinedClosedItems)} />
        <MetricCard icon="📆" label="Meta/Dia"           value={dailyNeeded>0?fmt(dailyNeeded):"✅ Meta!"}  accent={dailyNeeded>0?"#D97706":T.positive} sub={`${daysLeft} dia${daysLeft!==1?"s":""} restante${daysLeft!==1?"s":""}`} />
      </div>
      {drillDown && <DrillDownModal {...drillDown} onClose={()=>setDrillDown(null)} />}
      {portfolioDrillOpen && (
        <PortfolioDrillModal periodLabel={periodLabelD} groups={carteiraGroupsD}
          onClose={()=>setPortfolioDrillOpen(false)}
          thresholds={portfolioThresholds||DEFAULT_PORTFOLIO_THRESHOLDS} onSaveThresholds={onSavePortfolioThresholds} canEditThresholds={!isConsultant && !!onSavePortfolioThresholds} />
      )}
      {drillSelected && <ClientModal client={drillSelected} storeId={drillSelected.storeId} onClose={()=>setDrillSelected(null)}
        onUpdate={onUpdateClient ? (u=>onUpdateClient(u)) : undefined}
        onDelete={onDeleteClient ? (id=>{ onDeleteClient(id); setDrillSelected(null); }) : undefined}
        onAddReminder={onAddReminder} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} whatsappMsgs={whatsappMsgs} onReturnToAurora={onReturnToAurora} onConversationActive={onConversationActive} />}

      {!nuDash && <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
        <div style={{ fontWeight:700, fontSize:15, color:T.text, marginBottom:16 }}>{goalLabel}{fmt(activeGoal)}</div>
        <ProgressBar value={totalClosed} max={activeGoal} color={pctGoal>=75?T.positive:T.accent} label={`${fmt(totalClosed)} de ${fmt(activeGoal)}`} motivational={motivational} />
        <div style={{ marginTop:12, padding:"10px 14px", background:`linear-gradient(135deg,${T.navyLight}22,${T.gold}22)`, borderRadius:10, border:`1px solid ${T.gold}44` }}>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
            <span style={{ fontSize:12, fontWeight:700, color:T.gold }}>🚀 Super Meta — {fmt(superGoal)}</span>
            <span style={{ fontSize:12, fontWeight:700, color:T.gold }}>{pctSuper}%</span>
          </div>
          <div style={{ background:T.sandDark, borderRadius:99, height:8, overflow:"hidden" }}>
            <div style={{ width:`${Math.min(pctSuper,100)}%`, height:"100%", background:`linear-gradient(90deg,${T.gold},${T.accentLight})`, borderRadius:99, transition:"width 0.6s ease" }} />
          </div>
          <div style={{ fontSize:11, color:T.gold, fontWeight:600, marginTop:4 }}>
            {totalClosed>=superGoal?"🚀🚀 SUPER META BATIDA!":`Faltam ${fmt(superGoal-totalClosed)} pra super meta!`}
          </div>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginTop:16 }}>
          <div style={{ background:"#fff", borderRadius:10, padding:12, textAlign:"center", border:"1px solid #E2E8F0" }}>
            <div style={{ fontSize:18, fontWeight:800, color:T.positive }}>{fmt(totalClosed)}</div>
            <div style={{ fontSize:11, color:T.muted }}>Já vendido</div>
          </div>
          <div style={{ background:"#fff", borderRadius:10, padding:12, textAlign:"center", border:"1px solid #E2E8F0" }}>
            <div style={{ fontSize:18, fontWeight:800, color:T.gold }}>{fmt(totalOpen)}</div>
            <div style={{ fontSize:11, color:T.muted }}>Potencial em aberto</div>
          </div>
        </div>
      </div>}

      {!nuDash && isConsultant && totalOpen > 0 && (() => {
        const potentialTotal = totalClosed + totalOpen;
        const frases = [
          "\"Tudo que a mente humana pode acreditar, ela pode conceber.\" Bora pra cima! 🚀",
          "\"O sucesso é a soma de pequenos esforços repetidos dia após dia.\" Você é capaz! 💪",
          "\"Acredite em si mesmo e chegará um dia em que os outros não terão outra escolha senão acreditar com você.\" 🌟",
          "\"A diferença entre o possível e o impossível está na determinação.\" Vai buscar! 🔥",
          "\"Grandes conquistas exigem grandes atitudes. Você tem tudo isso!\" ✨",
          "\"Cada cliente é uma oportunidade. Cada sim é uma vitória. Continue!\" 🏆",
        ];
        const frase = frases[new Date().getDate() % frases.length];
        return (
          <div style={{ background:`linear-gradient(135deg,${T.accent},${T.accentLight})`, borderRadius:16, padding:20, marginBottom:20, boxShadow:`0 4px 20px ${T.accent}44` }}>
            <div style={{ fontSize:11, fontWeight:700, color:"rgba(255,255,255,0.75)", letterSpacing:1, marginBottom:6, textTransform:"uppercase" }}>💡 Você poderia estar com</div>
            <div style={{ fontSize:32, fontWeight:900, color:"#fff", marginBottom:4, lineHeight:1 }}>{fmt(potentialTotal)}</div>
            <div style={{ fontSize:12, color:"rgba(255,255,255,0.8)", marginBottom:14 }}>
              {fmt(totalClosed)} já vendidos + {fmt(totalOpen)} em potencial nos seus orçamentos abertos
            </div>
            <div style={{ background:"rgba(255,255,255,0.15)", borderRadius:10, padding:"10px 14px" }}>
              <div style={{ fontSize:13, color:"#fff", fontStyle:"italic", lineHeight:1.5 }}>{frase}</div>
            </div>
          </div>
        );
      })()}

      {/* ── Origem das Vendas: Lead / Prospecção / Atendimento Presencial ── */}
      <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
        <div style={{ fontWeight:700, fontSize:14, color:"#1E293B", marginBottom:14 }}>Vínculos operacionais das vendas — {periodLabelD}</div>
        <DashboardOriginCards Card={OriginBreakdownCard} storeId={currentUser.storeId} periodRange={periodRangeD}
          consultantId={isConsultant?currentUser.id:null} sales={originBreakdownD.sales} legacyBreakdown={originBreakdownD}
          onOpen={(label,rows)=>openDrillItems(`Vendas de ${label} — ${periodLabelD}`,rows.map(saleToItemD))}/>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", background:"#F8FAFC", borderRadius:10, padding:"12px 16px", flexWrap:"wrap", gap:10 }}>
          <div style={{ fontWeight:700, fontSize:13, color:"#1E293B" }}>Total Geral</div>
          <div style={{ display:"flex", gap:18, flexWrap:"wrap" }}>
            <div style={{ textAlign:"center" }}>
              <div style={{ fontSize:15, fontWeight:800, color:T.positive }}>{fmt(originBreakdownD.totalValue)}</div>
              <div style={{ fontSize:10, color:"#64748B" }}>Vendido</div>
            </div>
            <div style={{ textAlign:"center" }}>
              <div style={{ fontSize:15, fontWeight:800, color:"#1E293B" }}>{originBreakdownD.totalQtd}</div>
              <div style={{ fontSize:10, color:"#64748B" }}>Vendas</div>
            </div>
            <div style={{ textAlign:"center" }}>
              <div style={{ fontSize:15, fontWeight:800, color:T.navyLight }}>{originBreakdownD.ticketMedio>0?fmt(originBreakdownD.ticketMedio):"—"}</div>
              <div style={{ fontSize:10, color:"#64748B" }}>Ticket Médio</div>
            </div>
            <div style={{ textAlign:"center" }}>
              <div style={{ fontSize:15, fontWeight:800, color:totalPending>0?"#D97706":"#64748B" }}>{fmt(totalPending)}</div>
              <div style={{ fontSize:10, color:"#64748B" }}>A Receber</div>
            </div>
          </div>
        </div>

        {!isConsultant && consultantOriginSummary.length>0 && (
          <>
            <div style={{ fontSize:11, fontWeight:700, color:"#64748B", margin:"16px 0 8px" }}>Resumo por consultor</div>
            <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
              {consultantOriginSummary.map(r => (
                <div key={r.id} style={{ background:"#F8FAFC", border:"1px solid #E2E8F0", borderRadius:10, padding:"10px 12px" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:6, marginBottom:6 }}>
                    <div style={{ fontWeight:700, fontSize:12.5, color:"#1E293B" }}>{r.name.split(" ")[0]}</div>
                    <div style={{ fontSize:13, fontWeight:800, color:T.positive }}>{fmt(r.breakdown.totalValue)} · {r.breakdown.totalQtd} venda{r.breakdown.totalQtd!==1?"s":""} · 🎫 {r.breakdown.ticketMedio>0?fmt(r.breakdown.ticketMedio):"—"}</div>
                  </div>
                  <div style={{ display:"flex", gap:14, flexWrap:"wrap", fontSize:11.5, color:"#475569" }}>
                    <span>📥 Lead: <strong>{fmt(r.breakdown.lead.value)}</strong> ({r.breakdown.lead.qtd} de {r.breakdown.lead.arrived}, {r.breakdown.lead.conv}%)</span>
                    <span>🔎 Prospecção: <strong>{fmt(r.breakdown.prospeccao.value)}</strong> ({r.breakdown.prospeccao.qtd} de {r.breakdown.prospeccao.arrived}, {r.breakdown.prospeccao.conv}%)</span>
                    <span>🏪 Atendimento: <strong>{fmt(r.breakdown.porta.value)}</strong> ({r.breakdown.porta.qtd} de {r.breakdown.porta.arrived}, {r.breakdown.porta.conv}%)</span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {byProduct.length>0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
          <div style={{ fontWeight:700, fontSize:14, color:T.text, marginBottom:14 }}>🏆 Produtos Mais Vendidos</div>
          <div style={{ display:"flex", flexWrap:"wrap", gap:10 }}>
            {byProduct.map((p,i) => (
              <div key={p.product} style={{ background:T.sand, borderRadius:10, padding:"10px 14px", minWidth:140, flex:"1 1 140px" }}>
                <div style={{ fontSize:11, color:T.muted }}>#{i+1}</div>
                <div style={{ fontWeight:700, fontSize:13, color:T.text }}>{p.product}</div>
                <div style={{ fontSize:12, color:T.accent, fontWeight:600 }}>{fmt(p.value)}</div>
                <div style={{ fontSize:11, color:T.muted }}>{p.count} cliente{p.count>1?"s":""}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export function LembretesView({ reminders, currentUser, clients, leads = [], prospeccao = [], onOpenLinkedCard, onOpenReminderCard, onToggle, onAdd, onDelete, onUpdateClient, onDeleteClient, onAddReminder, onSendZapi, onSendZapiMedia, whatsappMsgs, onReturnToAurora, onConversationActive }) {
  const { sales:liftSales, error:liftError, onSaved:onLiftSaved,
    onRefresh:onRefreshLiftSales, postSales, postError, onPostSaved, onLinksUpdated, authenticatedUser } = useContext(LiftPendingContext);
  const [form, setForm] = useState({ text:"", clientName:"", dueDate:"" });
  const setF = (k,v) => setForm(f=>({...f,[k]:v}));
  const [expandedId, setExpandedId] = useState(null);
  const [openClient, setOpenClient] = useState(null);
  const resolveCard = r => resolveReminderCard(r, {
    clients, leads, prospeccao, currentUser, leadConsultantId:resolveLeadConsultantId,
    consultantStoreId:id => USERS.find(user => Number(user.id) === Number(id))?.storeId,
  });
  const localOpenReminder = (r) => {
    const linked = resolveCard(r);
    if (!linked) { alert("O cartão vinculado não está disponível nesta visão."); return; }
    if (linked.moduleId === "kanban") setOpenClient(linked.record);
    else onOpenLinkedCard?.(linked.target);
  };
  const { navigate:handleOpenReminder, noticeView } = useReminderCardNavigation(onOpenReminderCard || localOpenReminder, onDelete);

  const mine = currentUser.role==="consultant"
    ? reminders.filter(r=>r.consultantId===currentUser.id)
    : reminders.filter(r=>{ const sid=r.storeId||USERS.find(u=>u.id===r.consultantId)?.storeId||1; return sid===currentUser.storeId; });

  const myClients = currentUser.role==="consultant" ? clients.filter(c=>c.consultantId===currentUser.id) : clients;
  const REMINDER_TERMINAL = new Set(["closed","posVenda","nextSale","semInteresse"]);
  const isClientDone = (r) => {
    const linked = resolveCard(r);
    return linked?.moduleId === "kanban" && REMINDER_TERMINAL.has(linked.record.stage);
  };
  const allPending   = mine.filter(r=>r.status==="pending" && !isClientDone(r)).sort((a,b)=>(a.dueDate||"9999")<(b.dueDate||"9999")?-1:1);
  const pending      = allPending.filter(r => isThisMonthOrEarlier(r.dueDate));
  const pendingFuture= allPending.filter(r => !isThisMonthOrEarlier(r.dueDate));
  const done         = mine.filter(r=>r.status==="done" && feitoHojeSP(r.doneAt)).sort((a,b)=>(b.doneAt||"")>(a.doneAt||"")?1:-1);
  const overdue      = pending.filter(isOverdue);
  const overdueCount = overdue.length;
  const missedAccounting=mine.filter(r=>r.accountingOnly);
  const consultantName = (id) => USERS.find(u=>u.id===id)?.name.split(" ")[0]||"";

  const [drillDown, setDrillDown] = useState(null);
  const reminderToItem = (r) => {
    const linked = resolveCard(r);
    const c = linked?.record;
    return {
      id:r.id, name:r.text, phone:c?.phone, consultant:consultantName(r.consultantId),
      store:STORES.find(s=>s.id===(c?.storeId||currentUser.storeId))?.name, origin:r.clientName?`Cliente: ${r.clientName}`:"",
      status:r.status==="done"?"Concluído":(isOverdue(r)?"Atrasado":"Pendente"), createdAt:r.createdAt, lastInteraction:r.dueDate,
      actionLabel:c?"Ver card":undefined, onAction:c?()=>{ setDrillDown(null); handleOpenReminder(r); }:undefined,
    };
  };

  return (
    <div>
      <div style={{ fontWeight:800, fontSize:20, color:T.text, marginBottom:4 }}>Lembretes — A Fazer</div>
      {noticeView}
      <div style={{ fontSize:13, color:T.muted, marginBottom:20 }}>Adeus, caderninho! 📝</div>
      <LiftPendingSales sales={liftSales} error={liftError} onSaved={onLiftSaved} onIndicationSaved={onRefreshLiftSales} currentUser={currentUser} authenticatedUser={authenticatedUser} users={consultantUsers(getActiveUsers())} />
      <LiftPostSale sales={postSales} error={postError} onSaved={onPostSaved}
        onLinksUpdated={onLinksUpdated} currentUser={currentUser} />
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))", gap:12, marginBottom:20 }}>
        <MetricCard icon="📌" label="Este mês"      value={pending.length}       accent={T.gold} onClick={()=>setDrillDown({ title:"Lembretes deste mês", items:pending.map(reminderToItem), period:"Este mês" })} />
        <MetricCard icon="⚠️" label="Atrasados"     value={overdueCount}         accent={T.accent} sub={overdueCount>0?"resolve hoje!":"tudo em dia 👏"} onClick={()=>setDrillDown({ title:"Lembretes atrasados", items:overdue.map(reminderToItem), period:"Até hoje" })} />
        <MetricCard icon="🗓" label="Próx. meses"   value={pendingFuture.length} accent={T.muted} onClick={()=>setDrillDown({ title:"Lembretes dos próximos meses", items:pendingFuture.map(reminderToItem), period:"Próximos meses" })} />
        <MetricCard icon="✅" label="Feitos"         value={done.length}          accent={T.positive} onClick={()=>setDrillDown({ title:"Lembretes concluídos", items:done.map(reminderToItem), period:"Todo o período" })} />
      </div>

      {currentUser.role==="consultant" && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
          <div style={{ fontWeight:700, fontSize:14, marginBottom:14 }}>+ Novo Lembrete</div>
          <div style={{ marginBottom:10 }}>
            <div style={{ fontSize:11, color:T.muted, marginBottom:4 }}>O que você precisa fazer?</div>
            <input value={form.text} onChange={e=>setF("text",e.target.value)} placeholder="Ex: Mandar fotos de sofá pra cliente..." style={{ width:"100%", padding:"10px 12px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:14, boxSizing:"border-box" }} />
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:14 }}>
            <div>
              <div style={{ fontSize:11, color:T.muted, marginBottom:4 }}>Cliente (opcional)</div>
              <input list="lembrete-clientes" value={form.clientName} onChange={e=>setF("clientName",e.target.value)} placeholder="Nome do cliente" style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box" }} />
              <datalist id="lembrete-clientes">{myClients.map(c=><option key={c.id} value={c.name}/>)}</datalist>
            </div>
            <div>
              <div style={{ fontSize:11, color:T.muted, marginBottom:4 }}>Fazer até (opcional)</div>
              <input type="date" value={form.dueDate} onChange={e=>setF("dueDate",e.target.value)} style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box" }} />
            </div>
          </div>
          <button onClick={() => { if(!form.text.trim()) return; onAdd({id:Date.now(), consultantId:currentUser.id, storeId:currentUser.storeId, text:form.text.trim(), clientName:form.clientName.trim(), dueDate:form.dueDate||null, status:"pending", createdAt:new Date().toISOString().split("T")[0], doneAt:null}); setForm({text:"",clientName:"",dueDate:""}); }} style={{ width:"100%", background:`linear-gradient(135deg,${T.accent},${T.accentLight})`, color:"#fff", border:"none", borderRadius:8, padding:"10px", fontWeight:700, cursor:"pointer", fontSize:14 }}>
            Adicionar Lembrete
          </button>
        </div>
      )}

      {currentUser.role==="consultant" ? (
        <>
          <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:16, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
            <div style={{ fontWeight:700, fontSize:14, marginBottom:14 }}>📌 Este mês / Atrasados ({pending.length})</div>
            {missedAccounting.length>0 && <div style={{fontSize:12,color:"#9A3412",marginBottom:12}}>
              Não feitos na data prevista neste mês: {missedAccounting.length}. Reagendar não conta como concluir.
              {missedAccounting.map(r=><div key={r.id}>Não feito em {r.dueDate} — reagendado pelo sistema.</div>)}
            </div>}
            {pending.length===0 && <div style={{ color:T.muted, fontSize:13 }}>Nenhum lembrete pendente para este mês! 🎉</div>}
            {pending.map(r => (
              <div key={r.id} style={{ display:"flex", alignItems:"center", gap:8 }}>
                <div style={{ flex:1 }}><ReminderItem reminder={r} onToggle={onToggle} onOpenClient={handleOpenReminder} allowIdLink /></div>
                <button onClick={()=>onDelete(r.id)} style={{ background:"none", border:"none", color:T.muted, cursor:"pointer", fontSize:14, padding:4, marginBottom:8 }}>🗑</button>
              </div>
            ))}
          </div>
          {pendingFuture.length>0 && (
            <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:16, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderLeft:`4px solid ${T.muted}` }}>
              <div style={{ fontWeight:700, fontSize:14, marginBottom:4, color:T.muted }}>🗓 Próximos meses ({pendingFuture.length})</div>
              <div style={{ fontSize:12, color:T.muted, marginBottom:12 }}>Aparecerão na lista principal quando chegar o mês certo.</div>
              {pendingFuture.map(r => (
                <div key={r.id} style={{ display:"flex", alignItems:"center", gap:8 }}>
                  <div style={{ flex:1, opacity:0.7 }}><ReminderItem reminder={r} onToggle={onToggle} onOpenClient={handleOpenReminder} allowIdLink /></div>
                  <button onClick={()=>onDelete(r.id)} style={{ background:"none", border:"none", color:T.muted, cursor:"pointer", fontSize:14, padding:4, marginBottom:8 }}>🗑</button>
                </div>
              ))}
            </div>
          )}
          <div style={{ background:"#fff", borderRadius:14, padding:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
            <div style={{ fontWeight:700, fontSize:14, marginBottom:14 }}>✅ Feitos hoje ({done.length})</div>
            {done.length===0 && <div style={{ color:T.muted, fontSize:13 }}>Nada concluído hoje ainda.</div>}
            {done.map(r => (
              <div key={r.id} style={{ display:"flex", alignItems:"center", gap:8 }}>
                <div style={{ flex:1 }}><ReminderItem reminder={r} onToggle={onToggle} onOpenClient={handleOpenReminder} allowIdLink /></div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
          <div style={{ fontWeight:700, fontSize:15, color:T.text, marginBottom:4 }}>👥 Visão da Equipe</div>
          <div style={{ fontSize:12, color:T.muted, marginBottom:16 }}>Clique em um consultor para ver os lembretes dele</div>
          {(currentUser.role==="admin"
            ? USERS.filter(u=>u.role==="consultant")
            : USERS.filter(u=>u.storeId===currentUser.storeId&&u.role==="consultant")
          ).map(u => {
            const uRems = reminders.filter(r=>r.consultantId===u.id);
            const uPend = uRems.filter(r=>r.status==="pending"&&isThisMonthOrEarlier(r.dueDate));
            const uMissed=uRems.filter(r=>r.accountingOnly);
            const uOver = [...uPend.filter(isOverdue),...uMissed];
            const uDone = uRems.filter(r=>r.status==="done");
            const uTotal = uPend.length+uDone.length+uMissed.length;
            const uPct = uTotal>0?Math.round(uDone.length/uTotal*100):0;
            const isExp = expandedId===u.id;
            const th2 = THEMES[u.storeId||1];
            return (
              <div key={u.id} style={{ borderBottom:"1px solid #F1F5F9" }}>
                <button onClick={()=>setExpandedId(isExp?null:u.id)} style={{ width:"100%", display:"flex", alignItems:"center", gap:12, padding:"12px 0", background:"none", border:"none", cursor:"pointer", textAlign:"left" }}>
                  <div style={{ width:36, height:36, borderRadius:"50%", background:th2.accent, display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontWeight:800, fontSize:15, flexShrink:0 }}>{u.name.charAt(0)}</div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontWeight:700, fontSize:13, color:T.text }}>{u.name.split(" ")[0]}</div>
                    <div style={{ fontSize:10, color:T.muted }}>{STORES.find(s=>s.id===u.storeId)?.name||""}</div>
                  </div>
                  <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap", justifyContent:"flex-end" }}>
                    {uOver.length>0&&<span style={{ background:"#FEE2E2", color:"#EF4444", borderRadius:99, padding:"2px 8px", fontSize:11, fontWeight:700 }}>⚠️ {uOver.length} atrasado{uOver.length>1?"s":""}</span>}
                    <span style={{ background:"#FEF3C7", color:"#D97706", borderRadius:99, padding:"2px 8px", fontSize:11, fontWeight:700 }}>{uPend.length} pendente{uPend.length!==1?"s":""}</span>
                    <span style={{ background:"#F0FFF4", color:"#16A34A", borderRadius:99, padding:"2px 8px", fontSize:11, fontWeight:700 }}>✅ {uDone.length}</span>
                    <div style={{ textAlign:"right", minWidth:38 }}>
                      <div style={{ fontSize:13, fontWeight:800, color:uPct>=80?T.positive:uPct>=50?"#D97706":"#EF4444" }}>{uPct}%</div>
                      <div style={{ fontSize:9, color:T.muted }}>execução</div>
                    </div>
                  </div>
                  <span style={{ fontSize:11, color:T.muted, marginLeft:4 }}>{isExp?"▲":"▼"}</span>
                </button>
                {isExp&&(
                  <div style={{ paddingLeft:48, paddingBottom:12 }}>
                    {uPend.length===0&&uDone.length===0&&<div style={{ fontSize:12, color:T.muted, paddingTop:4 }}>Nenhum lembrete registrado.</div>}
                    {uPend.map(r=><ReminderItem key={r.id} reminder={r} onToggle={onToggle} onOpenClient={handleOpenReminder} allowIdLink />)}
                    {uDone.slice(0,5).map(r=><ReminderItem key={r.id} reminder={r} onToggle={onToggle} onOpenClient={handleOpenReminder} allowIdLink />)}
                    {uDone.length>5&&<div style={{ fontSize:11, color:T.muted, marginTop:4 }}>+ {uDone.length-5} feito{uDone.length-5>1?"s":""}</div>}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      {drillDown && <DrillDownModal {...drillDown} onClose={()=>setDrillDown(null)} />}
      {openClient && <ClientModal client={openClient} storeId={openClient.storeId} onClose={()=>setOpenClient(null)}
        onUpdate={onUpdateClient ? (u=>onUpdateClient(u)) : undefined}
        onDelete={onDeleteClient ? (id=>{ onDeleteClient(id); setOpenClient(null); }) : undefined}
        onAddReminder={onAddReminder} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} whatsappMsgs={whatsappMsgs} onReturnToAurora={onReturnToAurora} onConversationActive={onConversationActive} />}
    </div>
  );
}

// ── ENTREGAS ──────────────────────────────────────────────────
function AddEntregaModal({ currentUser, onAdd, onClose }) {
  const today = new Date().toISOString().split("T")[0];
  const storeConsultants = USERS.filter(u => u.role === "consultant" && (
    currentUser.role === "admin" || currentUser.role === "manager" ? true : u.storeId === currentUser.storeId
  ));
  const [name,         setName]         = useState("");
  const [product,      setProduct]      = useState("");
  const [value,        setValue]        = useState("");
  const [consultantId, setConsultantId] = useState(
    currentUser.role === "consultant" ? currentUser.id : (storeConsultants[0]?.id || "")
  );
  const [followUp,     setFollowUp]     = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [posVendaDate, setPosVendaDate] = useState("");
  const [note,         setNote]         = useState("");
  const [saving,       setSaving]       = useState(false);
  const submittedRef = useRef(false);

  const storeId = USERS.find(u => u.id === Number(consultantId))?.storeId || currentUser.storeId || 1;

  const hasDate = followUp || deliveryDate || posVendaDate;

  const handleSave = () => {
    if (!name.trim() || !hasDate || submittedRef.current) return;
    submittedRef.current = true;
    setSaving(true);
    const newClient = {
      name: name.trim(),
      product: product.trim(),
      value: Number(String(value).replace(/\D/g,"")) || 0,
      consultantId: Number(consultantId),
      storeId,
      stage: "nextSale",
      origin: "Porta",
      note: note.trim(),
      followUp: followUp || null,
      deliveryDate: deliveryDate || null,
      deliveryStatus: deliveryDate ? "aguardando" : null,
      posVendaDate: posVendaDate || null,
      createdAt: today,
      stageDates: { closed: today, nextSale: today },
      manualEntrega: true,
    };
    Promise.resolve(onAdd(newClient)).then(() => onClose()).catch(() => {
      submittedRef.current = false;
      setSaving(false);
    });
  };

  const inputStyle = { width:"100%", padding:"9px 12px", borderRadius:8, border:`1.5px solid ${T.sandDark}`, fontSize:14, boxSizing:"border-box", fontFamily:"inherit" };
  const labelStyle = { fontSize:12, fontWeight:700, color:T.text, display:"block", marginBottom:5 };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.45)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div style={{ background:"#fff", borderRadius:18, padding:28, width:"100%", maxWidth:480, maxHeight:"90vh", overflowY:"auto", boxShadow:"0 8px 40px rgba(0,0,0,0.18)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <div style={{ fontWeight:800, fontSize:17, color:T.text }}>➕ Adicionar Entrega</div>
          <button onClick={onClose} disabled={saving} style={{ background:"none", border:"none", fontSize:20, cursor:saving?"default":"pointer", color:T.muted }}>✕</button>
        </div>

        <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
          <div>
            <label style={labelStyle}>Nome do cliente *</label>
            <input style={inputStyle} value={name} onChange={e=>setName(e.target.value)} placeholder="Ex: João Silva" />
          </div>

          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
            <div>
              <label style={labelStyle}>Produto</label>
              <input style={inputStyle} value={product} onChange={e=>setProduct(e.target.value)} placeholder="Ex: Sofá 3 lugares" />
            </div>
            <div>
              <label style={labelStyle}>Valor (R$)</label>
              <input style={inputStyle} value={value} onChange={e=>setValue(e.target.value)} placeholder="Ex: 5900" type="number" min="0" />
            </div>
          </div>

          {currentUser.role !== "consultant" && (
            <div>
              <label style={labelStyle}>Consultor</label>
              <select style={{ ...inputStyle, background:"#fff" }} value={consultantId} onChange={e=>setConsultantId(e.target.value)}>
                {storeConsultants.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
              </select>
            </div>
          )}

          <div style={{ borderTop:`1px solid ${T.sandDark}`, paddingTop:14 }}>
            <div style={{ fontSize:12, fontWeight:700, color:T.muted, marginBottom:12, textTransform:"uppercase", letterSpacing:1 }}>Datas</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <div>
                <label style={labelStyle}>📅 Follow-up</label>
                <input type="date" style={inputStyle} value={followUp} onChange={e=>setFollowUp(e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>📦 Data de Entrega</label>
                <input type="date" style={inputStyle} value={deliveryDate} onChange={e=>setDeliveryDate(e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>⭐ Data de Pós-venda</label>
                <input type="date" style={inputStyle} value={posVendaDate} onChange={e=>setPosVendaDate(e.target.value)} />
              </div>
            </div>
          </div>

          <div>
            <label style={labelStyle}>Observação</label>
            <textarea style={{ ...inputStyle, resize:"vertical", minHeight:60 }} value={note} onChange={e=>setNote(e.target.value)} placeholder="Anotações sobre a venda ou entrega..." />
          </div>

          {!hasDate && name.trim() && (
            <div style={{ fontSize:12, color:"#D97706", background:"#FFF8E6", border:"1px solid #D97706", borderRadius:8, padding:"7px 12px", fontWeight:600 }}>
              ⚠️ Preencha ao menos uma data (Follow-up, Entrega ou Pós-venda) para salvar.
            </div>
          )}
          <div style={{ display:"flex", gap:10, justifyContent:"flex-end", marginTop:4 }}>
            <button onClick={onClose} disabled={saving} style={{ background:T.sandDark, color:T.text, border:"none", borderRadius:10, padding:"9px 20px", fontSize:14, fontWeight:700, cursor:saving?"default":"pointer", opacity:saving?0.7:1 }}>Cancelar</button>
            <button onClick={handleSave} disabled={!name.trim()||!hasDate||saving} style={{ background:(name.trim()&&hasDate&&!saving)?T.accent:"#ccc", color:"#fff", border:"none", borderRadius:10, padding:"9px 22px", fontSize:14, fontWeight:700, cursor:(name.trim()&&hasDate&&!saving)?"pointer":"default" }}>{saving?"Salvando…":"Salvar"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Nova interface: Entregas a partir do LIFT. A lista antiga (entregas
// registradas à mão no CRM) continua a um clique, sem mudança.
function EntregasTela({ onAbrirPedido, ...props }) {
  const { commercialSales, commercialLoaded, commercialError } = useContext(LiftPendingContext);
  const [antiga, setAntiga] = useState(false);
  const hoje = new Date().toLocaleDateString("en-CA", { timeZone:"America/Sao_Paulo" });
  if (antiga) return (
    <div>
      <button type="button" onClick={() => setAntiga(false)} style={{ background:"none", border:"none", color:T.accent, fontWeight:700, fontSize:14, cursor:"pointer", marginBottom:10, padding:0 }}>← Entregas do LIFT</button>
      <EntregasView {...props} />
    </div>
  );
  return <Entregas theme={T} pedidos={commercialSales || []} hoje={hoje} carregado={commercialLoaded} erro={commercialError} usuario={props.currentUser}
    mostrarConsultor={props.currentUser.role !== "consultant"}
    nomeConsultor={id => USERS.find(u => u.id === Number(id))?.name?.split(" ")[0] || ""}
    onAbrir={onAbrirPedido} onListaAntiga={() => setAntiga(true)} />;
}

function EntregasView({ clients, currentUser, onUpdate, onAdd, onAddReminder, onSendZapi, onSendZapiMedia, whatsappMsgs, onReturnToAurora, onConversationActive }) {
  const today = new Date().toISOString().split("T")[0];
  const [filterStatus,   setFilterStatus]   = useState("todos");
  const [showAdd,        setShowAdd]        = useState(false);
  const [drillDown,      setDrillDown]      = useState(null);
  const [openClient,     setOpenClient]     = useState(null);
  const [rescheduleId,   setRescheduleId]   = useState(null);
  const [rescheduleDate, setRescheduleDate] = useState("");

  const visibleClients = currentUser.role==="admin" ? clients
    : currentUser.role==="manager" ? clients.filter(c => Number(c.storeId)===Number(currentUser.storeId))
    : clients.filter(c => Number(c.consultantId)===Number(currentUser.id));

  // Qualquer cliente com deliveryDate ou posVendaDate aparece (independente do estágio);
  // manualEntrega e vendas realizadas também aparecem se tiverem followUp
  const withDelivery = visibleClients
    .filter(c => c.deliveryDate || c.posVendaDate || ((c.manualEntrega || wasSold(c)) && c.followUp))
    .sort((a,b) => {
      const da = c => c.deliveryDate || c.followUp || c.posVendaDate || "9999";
      return da(a) > da(b) ? 1 : -1;
    });

  const getDeliveryInfo = (c) => {
    if (!c.deliveryDate) return { label:"📅 Sem entrega", color:T.navyLight, bg:"#F5F5FF", tag:"ok" };
    const diff = Math.ceil((new Date(c.deliveryDate) - new Date(today)) / 86400000);
    if (c.deliveryStatus === "entregue") return { label:"🎉 Entregue", color:"#6B8F3E", bg:"#F0FFF4", tag:"entregue" };
    if (diff < 0) return { label:"🚨 Atrasada", color:"#EF4444", bg:"#FFF1F1", tag:"atrasada", diff };
    if (diff === 0) return { label:"⚠️ HOJE", color:"#D97706", bg:"#FFF8E6", tag:"hoje", diff:0 };
    if (diff <= 3) return { label:`⚠️ Em ${diff} dia${diff>1?"s":""}`, color:"#D97706", bg:"#FFF8E6", tag:"urgente", diff };
    return { label:`📅 Em ${diff} dia${diff>1?"s":""}`, color:"#6B8F3E", bg:"#F0FFF4", tag:"ok", diff };
  };

  const filtered = filterStatus==="todos" ? withDelivery
    : withDelivery.filter(c => {
        const info = getDeliveryInfo(c);
        if (filterStatus==="atrasada") return info.tag==="atrasada";
        if (filterStatus==="urgente")  return info.tag==="urgente" || info.tag==="hoje";
        if (filterStatus==="ok")       return info.tag==="ok";
        if (filterStatus==="entregue") return info.tag==="entregue";
        return true;
      });

  const counts = {
    atrasadas: withDelivery.filter(c => getDeliveryInfo(c).tag==="atrasada").length,
    urgentes:  withDelivery.filter(c => ["urgente","hoje"].includes(getDeliveryInfo(c).tag)).length,
    ok:        withDelivery.filter(c => getDeliveryInfo(c).tag==="ok").length,
    entregues: withDelivery.filter(c => getDeliveryInfo(c).tag==="entregue").length,
  };

  const consultantName = id => USERS.find(u=>u.id===id)?.name.split(" ")[0]||"";

  const deliveryToItem = (c) => {
    const info = getDeliveryInfo(c);
    return {
      id:c.id, name:c.name, phone:c.phone, consultant:consultantName(c.consultantId),
      store:STORES.find(s=>s.id===c.storeId)?.name, origin:c.product, status:info.label,
      createdAt:c.createdAt, lastInteraction:c.deliveryDate||c.followUp||c.posVendaDate, value:c.value,
      actionLabel:"Ver card", onAction:()=>{ setDrillDown(null); setOpenClient(c); },
    };
  };

  return (
    <div>
      {showAdd && <AddEntregaModal currentUser={currentUser} onAdd={onAdd} onClose={()=>setShowAdd(false)} />}

      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:12, marginBottom:4 }}>
        <div>
          <div style={{ fontWeight:800, fontSize:20, color:T.text }}>📦 Entregas</div>
          <div style={{ fontSize:13, color:T.muted }}>Agendamentos de entrega, follow-up e pós-venda</div>
        </div>
        <button onClick={()=>setShowAdd(true)} style={{ background:T.accent, color:"#fff", border:"none", borderRadius:10, padding:"9px 18px", fontSize:13, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}>
          ➕ Adicionar cliente
        </button>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))", gap:12, margin:"20px 0" }}>
        <MetricCard icon="🚨" label="Atrasadas"  value={counts.atrasadas} accent="#EF4444" onClick={()=>setDrillDown({ title:"Entregas atrasadas", items:withDelivery.filter(c=>getDeliveryInfo(c).tag==="atrasada").map(deliveryToItem), period:"Atrasadas" })} />
        <MetricCard icon="⚠️" label="Urgentes"   value={counts.urgentes}  accent="#D97706" onClick={()=>setDrillDown({ title:"Entregas urgentes", items:withDelivery.filter(c=>["urgente","hoje"].includes(getDeliveryInfo(c).tag)).map(deliveryToItem), period:"Próximos 3 dias" })} />
        <MetricCard icon="✅" label="No prazo"   value={counts.ok}        accent="#6B8F3E" onClick={()=>setDrillDown({ title:"Entregas no prazo", items:withDelivery.filter(c=>getDeliveryInfo(c).tag==="ok").map(deliveryToItem), period:"No prazo" })} />
        <MetricCard icon="🎉" label="Entregues"  value={counts.entregues} accent={T.navyLight} onClick={()=>setDrillDown({ title:"Entregas concluídas", items:withDelivery.filter(c=>getDeliveryInfo(c).tag==="entregue").map(deliveryToItem), period:"Todo o período" })} />
      </div>

      <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:20 }}>
        {[["todos","Todas"],["atrasada","🚨 Atrasadas"],["urgente","⚠️ Urgentes"],["ok","✅ No prazo"],["entregue","🎉 Entregues"]].map(([val,lbl]) => (
          <button key={val} onClick={()=>setFilterStatus(val)} style={{ background:filterStatus===val?T.accent:"#fff", color:filterStatus===val?"#fff":T.text, border:`2px solid ${T.accent}`, borderRadius:99, padding:"5px 14px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
            {lbl}
          </button>
        ))}
      </div>

      {filtered.length===0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:40, textAlign:"center", color:T.muted, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
          <div style={{ fontSize:36, marginBottom:10 }}>📦</div>
          <div style={{ fontWeight:700, fontSize:15 }}>{withDelivery.length===0 ? "Nenhuma entrega agendada ainda." : "Nenhuma entrega neste filtro."}</div>
          <div style={{ fontSize:13, marginTop:6 }}>Clique em "➕ Adicionar cliente" para programar uma entrega.</div>
        </div>
      )}

      <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
        {filtered.map(c => {
          const info = getDeliveryInfo(c);
          const phoneClean = normalizePhone(c.phone);
          const clientWaMsgs = (whatsappMsgs && phoneClean) ? getWaMsgsForPhone(whatsappMsgs, phoneClean, c.storeId) : {};
          const msgCount = Object.keys(clientWaMsgs).length;
          const isRescheduling = rescheduleId === c.id;
          const canReschedule = !!c.deliveryDate && c.deliveryStatus !== "entregue";
          return (
            <div key={c.id} style={{ background:info.bg, borderRadius:14, padding:"16px 20px", boxShadow:"0 2px 10px rgba(0,0,0,0.06)", border:`2px solid ${info.color}44` }}>
              <div onClick={()=>{ if(!isRescheduling) setOpenClient(c); }} style={{ cursor:"pointer" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:8 }}>
                  <div style={{ flex:1, minWidth:200 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:4, flexWrap:"wrap" }}>
                      <div style={{ fontWeight:800, fontSize:15, color:T.text }}>{c.name}</div>
                      <span style={{ background:info.color+"22", color:info.color, border:`1px solid ${info.color}44`, borderRadius:20, padding:"2px 10px", fontSize:11, fontWeight:700 }}>{info.label}</span>
                    </div>
                    <div style={{ fontSize:12, color:T.muted, marginBottom:6 }}>
                      {c.product && <>🛋 {c.product} · </>}💰 {fmt(c.value||0)}
                      {currentUser.role !== "consultant" && <span> · 👤 {consultantName(c.consultantId)}</span>}
                    </div>
                    <div style={{ display:"flex", flexWrap:"wrap", gap:10 }}>
                      {c.followUp    && <div style={{ fontSize:11, background:"#EFF6FF", color:"#1D4ED8", border:"1px solid #BFDBFE", borderRadius:6, padding:"3px 8px", fontWeight:600 }}>📅 Follow-up: {fmtDate(c.followUp)}</div>}
                      {c.deliveryDate && <div style={{ fontSize:11, background:info.bg, color:info.color, border:`1px solid ${info.color}44`, borderRadius:6, padding:"3px 8px", fontWeight:600 }}>📦 Entrega: {fmtDate(c.deliveryDate)}</div>}
                      {c.posVendaDate && <div style={{ fontSize:11, background:"#F5F3FF", color:"#7C3AED", border:"1px solid #DDD6FE", borderRadius:6, padding:"3px 8px", fontWeight:600 }}>⭐ Pós-venda: {fmtDate(c.posVendaDate)}</div>}
                      {c.stage === "closed" && c.nextSaleDate && <div style={{ fontSize:11, background:"#EFF6FF", color:"#2563EB", border:"1px solid #BFDBFE", borderRadius:6, padding:"3px 8px", fontWeight:600 }} title={c.nextSaleNote||""}>🔄 Próxima Venda: {fmtDate(c.nextSaleDate)}</div>}
                    </div>
                  </div>
                  <div style={{ display:"flex", gap:8, flexWrap:"wrap", alignItems:"center" }}>
                    {canReschedule && (
                      <button onClick={e=>{ e.stopPropagation(); setRescheduleId(c.id); setRescheduleDate(c.deliveryDate||""); }}
                        style={{ background:"#FFF8E6", color:"#D97706", border:"2px solid #FCD34D", borderRadius:8, padding:"6px 12px", fontSize:12, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}>
                        📅 Reagendar
                      </button>
                    )}
                    <div style={{ background:T.accent, color:"#fff", borderRadius:8, padding:"6px 14px", fontSize:12, fontWeight:700, whiteSpace:"nowrap", display:"flex", alignItems:"center", gap:6 }}>
                      ✏️ Abrir{phoneClean?` · 💬 ${msgCount>0?msgCount:""}`:""}
                    </div>
                  </div>
                </div>
                {c.note && <div style={{ fontSize:11, color:T.muted, marginTop:8, fontStyle:"italic" }}>💬 {c.note}</div>}
              </div>

              {isRescheduling && (
                <div onClick={e=>e.stopPropagation()} style={{ marginTop:14, padding:"14px 16px", background:"#FFFBEB", border:"2px solid #FCD34D", borderRadius:10 }}>
                  <div style={{ fontWeight:700, fontSize:13, color:"#92400E", marginBottom:10 }}>📅 Reagendar entrega — {c.name}</div>
                  <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
                    <div>
                      <label style={{ fontSize:11, fontWeight:700, color:"#92400E", display:"block", marginBottom:4 }}>Nova data de entrega</label>
                      <input type="date" value={rescheduleDate} onChange={e=>setRescheduleDate(e.target.value)}
                        style={{ padding:"8px 10px", borderRadius:8, border:"2px solid #FCD34D", fontSize:13, background:"#fff" }} />
                    </div>
                    <div style={{ display:"flex", gap:8, marginTop:16 }}>
                      <button onClick={()=>{
                        if (!rescheduleDate) return;
                        const updated = { ...c, deliveryDate: rescheduleDate, deliveryStatus: "aguardando" };
                        onUpdate(updated);
                        if (onAddReminder) onAddReminder({
                          id: String(Date.now()),
                          text: `📦 Entrega hoje (reagendada) — ${c.name} · ${c.product||""}`,
                          dueDate: rescheduleDate,
                          consultantId: c.consultantId,
                          storeId: c.storeId,
                          clientId: c.id,
                          type: "entrega",
                        });
                        setRescheduleId(null);
                        setRescheduleDate("");
                      }} style={{ background:"#D97706", color:"#fff", border:"none", borderRadius:8, padding:"8px 18px", fontSize:13, fontWeight:700, cursor:"pointer" }}>
                        ✅ Confirmar
                      </button>
                      <button onClick={()=>{ setRescheduleId(null); setRescheduleDate(""); }}
                        style={{ background:"#fff", color:T.muted, border:`1px solid #E2E8F0`, borderRadius:8, padding:"8px 14px", fontSize:13, fontWeight:600, cursor:"pointer" }}>
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {drillDown && <DrillDownModal {...drillDown} onClose={()=>setDrillDown(null)} />}
      {openClient && <ClientModal client={openClient} storeId={openClient.storeId} onClose={()=>setOpenClient(null)}
        onUpdate={u=>onUpdate(u)}
        onAddReminder={onAddReminder} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} whatsappMsgs={whatsappMsgs} onReturnToAurora={onReturnToAurora} onConversationActive={onConversationActive} />}
    </div>
  );
}

// ── WHATSAPP INBOX ─────────────────────────────────────────────
export function CentralConversas({ whatsappMsgs, leads, prospeccao, clients, currentUser, onSend, onSendZapiMedia, onDeleteWhatsAppMessage, waReadAt, onMarkRead, prospMensagens, autoOpenTarget, onAutoOpenConsumed, onRegistrarVenda, onUpdateClient, onUpdateProsp, onTransferProsp, onAddReminder, onConversationActive, unreadPushLookup, onOpenLead }) {
  useTextSendAttempts();
  const {
    selectedPhone,
    selectedStoreId,
    activeCentralRecord,
    centralExitGuard,
    selectConversation,
    runNavigation,
  } = useCentralConversationSelection({
    records:[...(clients || []), ...(prospeccao || []), ...(leads || [])],
    normalizePhone,
    onMarkRead,
    exitOptions:{
      screen:"central",
      getDate:() => showCcFollowUp ? ccFollowUpDate : (ccFollowUpDate || selectedEntity?.followUp || selectedEntity?.proxima_data_contato || ""),
      onSave:(date, context) => saveNextContactOnExit(selectedEntity, date, {
        kind:selectedIsClient ? "client" : "prosp",
        update:(_record, changes) => ccUpdateEntry(changes),
        addReminder:onAddReminder, ...context,
      }),
    },
  });
  const [replyTo, setReplyTo] = useState(null);
  const [roteiroModalCC, setRoteiroModalCC] = useState(null);
  const [showCcFollowUp, setShowCcFollowUp] = useState(false);
  const [showCcTransfer, setShowCcTransfer] = useState(false);
  const [ccFollowUpDate, setCcFollowUpDate] = useState("");
  const ccSavingFollowUpRef = useRef(false);
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    setShowCcFollowUp(false);
    setShowCcTransfer(false);
    setCcFollowUpDate("");
    setReplyTo(null);
  }, [selectedPhone, selectedStoreId]);
  useConversationPresence({
    phone:normalizePhone(selectedPhone),
    storeId:selectedStoreId || currentUser?.storeId, module:"inbox", onConversationActive,
  });

  useEffect(() => {
    if (!autoOpenTarget) return;
    selectConversation(autoOpenTarget.phone, autoOpenTarget.storeId, { afterSelect:onAutoOpenConsumed });
  }, [autoOpenTarget]); // eslint-disable-line react-hooks/exhaustive-deps
  const [convOrigin, setConvOrigin] = useState("client"); // "client" = Atendimento Presencial, "prosp" = Prospecção
  const [ccSearch, setCcSearch] = useState("");
  // Central usa sortBy:"interacao" por padrão para que respostas de clientes
  // subam automaticamente ao topo em tempo real (sortBy:"recentes" usa createdAt e bloqueia esse comportamento)
  const [ccFilters, setCcFilters] = useScreenPeriodFilters("centralConversas", { ...DEFAULT_FILTERS, sortBy:"interacao" });
  const [onlyNoResponse, setOnlyNoResponse] = useState(false);
  const [onlyFollowupPending, setOnlyFollowupPending] = useState(false);
  const [ccEmConversa, setCcEmConversa] = useState(false);
  const [ccActiveIndicator, setCcActiveIndicator] = useState("total");
  const [fuUrgencyFilter, setFuUrgencyFilter] = useState(null);
  const ccListRef = useRef(null);
  const chatRef = useRef(null);
  useConversationDiagnosticView(selectedStoreId || currentUser?.storeId, normalizePhone(selectedPhone), chatRef);
  const leadsArr = Array.isArray(leads) ? leads : Object.values(leads||{});
  const isAdmin  = currentUser && currentUser.role === "admin";
  const isManager = currentUser && currentUser.role === "manager";
  // Compara dois telefones já normalizados, tolerando a diferença do 9º dígito
  // (Z-API envia 11 dígitos; número cadastrado no CRM pode ter 10 dígitos sem o 9)
  const phonesMatch = (a, b) => {
    if (!a || !b) return false;
    if (a === b) return true;
    // Reduz ambos a DDD + 8 dígitos finais para comparar
    const strip9 = (p) => p.length === 11 ? p.slice(0, 2) + p.slice(3) : p;
    return strip9(a) === strip9(b);
  };

  const recordBelongsToCurrentStore = record => conversationRecordIsInUserStore(record, currentUser, USERS);
  // A Central recebe arrays globais do App. O escopo precisa ser aplicado antes
  // de resolver contato, telefone, origem ou histórico; filtrar só a lista final
  // deixaria um contato de outra loja como dono aparente do mesmo telefone.
  const scopedProspecao = isAdmin ? (prospeccao || []) : (prospeccao || []).filter(recordBelongsToCurrentStore);
  const scopedClients = isAdmin ? (clients || []) : (clients || []).filter(recordBelongsToCurrentStore);

  const isMyConversation = (phone) => {
    if (isAdmin) return true;
    if (isManager) {
      return (
        leadsArr.some(l   => phonesMatch(normalizePhone(l.telefone), phone) && recordBelongsToCurrentStore(l)) ||
        scopedProspecao.some(p => phonesMatch(normalizePhone(p.phone), phone)) ||
        scopedClients.some(c    => phonesMatch(normalizePhone(c.phone), phone))
      );
    }
    // Consultor: vê SOMENTE conversas explicitamente atribuídas a ele
    // Leads sem consultantId (ainda com Aurora) não aparecem na inbox do consultor
    const myLead = leadsArr.find(l =>
      phonesMatch(normalizePhone(l.telefone), phone) &&
      Number(l.consultantId) === Number(currentUser.id)
    );
    if (myLead) return true;
    const myProsp = scopedProspecao.find(p =>
      phonesMatch(normalizePhone(p.phone), phone) &&
      Number(p.consultantId) === Number(currentUser.id)
    );
    if (myProsp) return true;
    const myClient = scopedClients.find(c =>
      phonesMatch(normalizePhone(c.phone), phone) &&
      Number(c.consultantId) === Number(currentUser.id)
    );
    return !!myClient;
  };

  const getContactRobust = (phone, conversationStoreId = null) => {
    // Prospecção/Atendimento Presencial têm prioridade sobre Lead: um cliente que já
    // nasceu em Prospecção ou virou Atendimento nunca deve "sumir"/mudar de origem
    // por causa de um nó de lead remanescente (ex: nó antigo em leads/{phone} que a
    // automação da Aurora ainda enxerga). Só tratamos como "lead" quando o telefone
    // NÃO pertence a nenhuma Prospecção/Atendimento ativo.
    const belongsToConversation = record => !conversationStoreId || Number(record.storeId) === Number(conversationStoreId);
    const prosp = scopedProspecao.find(p => belongsToConversation(p) && phonesMatch(normalizePhone(p.phone), phone));
    if (prosp) return { name:prosp.name, type:"prosp", prosp };
    const client = scopedClients.find(c => belongsToConversation(c) && phonesMatch(normalizePhone(c.phone), phone));
    if (client) return { name:client.name, type:"client", client };
    const lead = leadsArr.find(l => belongsToConversation(l) && phonesMatch(normalizePhone(l.telefone), phone));
    if (lead) return { name:lead.nome, type:"lead", lead };
    return { name:phone, type:"unknown" };
  };

  // Conversation contents come exclusively from the authenticated scoped cache.
  // Prospecção metadata still determines the contact card, but its legacy
  // message bucket is never merged into a store conversation.
  const getMergedMsgsForPhone = (phone, storeId = null) => {
    const waMap = getWaMsgsForPhone(whatsappMsgs, phone, storeId);
    return waMap;
  };

  // Union: all phones in whatsappMsgs PLUS phones of prospects that have messages in prospMensagens.
  // Deduplicate using phonesMatch so the same person doesn't appear twice when Z-API uses
  // a different digit count than the CRM (9th-digit Brazilian rule).
   const prospPhonesWithMsgs = [];

  // Merge and deduplicate: prefer whatsappMsgs key (already normalised by processWaData)
   const allPhones = [
     ...Object.keys(whatsappMsgs||{}).map(key => {
       const [storeId, ...phoneParts] = key.split(":");
       return { phone:phoneParts.join(":"), storeId:Number(storeId), key };
     }).filter(({ phone, storeId }) => phone && storeId),
     ...prospPhonesWithMsgs.map(phone => {
       const entity = scopedProspecao.find(p => phonesMatch(normalizePhone(p.phone), phone));
       return { phone, storeId:Number(entity?.storeId), key:conversationKey(entity?.storeId, phone) };
     }).filter(({ storeId, key }) => storeId && key),
   ];

  const conversations = allPhones
    .filter(({ phone }) => isMyConversation(phone))
    .map(({ phone, storeId, key }) => {
      // Resolve o contato primeiro para obter storeId e evitar chamada duplicada de getContactRobust
      const contact = getContactRobust(phone, storeId);
      const contactStoreId = contact.client?.storeId || contact.prosp?.storeId || storeId;
      const msgs = Object.entries(getMergedMsgsForPhone(phone, contactStoreId))
        .map(([id,m])=>({...m,id}))
        .sort((a,b)=>_conversationActionTs(a)-_conversationActionTs(b));
      const replyMsgs = Object.values(getReplyMsgsForPhone(whatsappMsgs, phone, contactStoreId));
      const lastMsg = _lastMsg(replyMsgs);
       const needsTeamReply = (contact.client
         ? getClientConversationState(contact.client, replyMsgs)
         : getProspectConversationState(contact.prosp || {}, replyMsgs)) === "needs_team_reply";
       // Mensagens antigas podem continuar marcadas como não lidas, mas não devem
       // manter o alerta operacional depois de uma resposta posterior da equipe.
       const unread = needsTeamReply
         ? replyMsgs.filter(m=>m.remetente==="cliente"&&m.timestamp>(waReadAt[key]||"0")).length
         : 0;
      return { phone, conversationKey:key, contact, lastMsg, unread, msgs, ts:lastMsg?.timestamp||"0" };
    }).filter(c => {
      // Central de Conversas é exclusiva para Prospecção e Cliente Presencial — leads (inclusive
      // prospecção futura) pertencem à seção "Leads" e nunca devem aparecer aqui.
      return c.contact.type === "prosp" || c.contact.type === "client";
    }).sort((a,b)=>b.ts>a.ts?1:-1)
    // Enriquece cada conversa com os dados de acompanhamento (consultor, primeiro contato,
    // status, follow-up, tempo sem resposta) usados pela nova Central de Conversas.
    .map(c => {
      const rec = c.contact.client || c.contact.prosp;
      const isClient = c.contact.type === "client";
      const stageDef = isClient ? STAGES.find(s=>s.id===rec?.stage) : PROSP_STAGES.find(s=>s.id===rec?.stage);
      return {
        ...c,
        consultantId: rec?.consultantId,
        storeId: rec?.storeId || null,
        storeName: rec?.storeId
          ? (STORES.find(s=>s.id===Number(rec.storeId))?.name || `Loja ${rec.storeId}`)
          : null,
        createdAt: rec?.createdAt || rec?.date || null,
        stageId: rec?.stage || null,
        stageLabel: stageDef?.label || rec?.stage || "—",
        stageColor: stageDef?.color || "#94A3B8",
        followupDate: rec?.followUp || null,
        // Fechou venda, sem interesse, pós-venda/próxima venda agendada, prospecção futura ou
        // follow-up marcado pra outro dia = não está mais aguardando resposta imediata.
        awaitingReply: (isClient
          ? getClientConversationState(rec, Object.values(getReplyMsgsForPhone(whatsappMsgs, c.phone, c.storeId)))
          : getProspectConversationState(rec, Object.values(getReplyMsgsForPhone(whatsappMsgs, c.phone, c.storeId)))) === "needs_team_reply",
      };
    });

  const totalUnread = conversations.reduce((acc,c)=>acc+c.unread,0);
  const isMobile = window.innerWidth < 768;
  const selected = conversations.find(c => (
    Number(c.storeId) === Number(selectedStoreId)
    && (c.phone === selectedPhone || phonesMatch(c.phone, selectedPhone))
  ));

  // ── Central de Conversas: separação estrita por origem (nunca mistura Presencial com Prospecção) ──
  const effFiltersCC = ccFilters;
  const periodRangeCC = getPeriodRange(effFiltersCC.period, effFiltersCC.customFrom, effFiltersCC.customTo);
  const inPeriodCC = (c) => effFiltersCC.period === "tudo" || inPeriod(c.lastMsg?.timestamp || c.createdAt, periodRangeCC);

  const byOrigin = (type) => conversations.filter(c => c.contact.type === type);
  const presencialAll = byOrigin("client").filter(inPeriodCC);
  const prospAll      = byOrigin("prosp").filter(inPeriodCC);

  const currentOriginAll = convOrigin === "client" ? presencialAll : prospAll;
   const isStaffCC = currentUser?.role === "admin" || currentUser?.role === "manager";
   const consultantsInScope = isStaffCC ? conversationConsultantsInScope(currentUser, USERS) : null;
  const statusOptionsCC = convOrigin === "client" ? STAGES : PROSP_STAGES;

  const selectedIsClient = selected?.contact.type === "client";
  const selectedEntity = selected ? (selected.contact.type==="client" ? selected.contact.client : selected.contact.type==="prosp" ? selected.contact.prosp : null) : null;
  const selectedSaleStages = selectedIsClient ? ["closed", "posVenda", "nextSale"] : ["venda"];
  const selectedStageOptions = (selectedIsClient ? STAGES : PROSP_STAGES).filter(stage =>
    canManuallyRegisterSale(currentUser)
    || !selectedSaleStages.includes(stage.id)
    || stage.id === selectedEntity?.stage
    || (selectedIsClient && stage.id === "nextSale" && ["closed", "posVenda"].includes(selectedEntity?.stage))
  );
  const ccUpdateEntry = (changes) => {
    if (!selectedEntity) return Promise.reject(new Error("Conversa não encontrada."));
    if (selectedIsClient) {
      return onUpdateClient
        ? Promise.resolve(onUpdateClient({ ...selectedEntity, ...changes }))
        : Promise.reject(new Error("Atualização indisponível."));
    } else {
      return onUpdateProsp
        ? Promise.resolve(onUpdateProsp(null, { patches:[{
            id:selectedEntity.id, storeId:selectedEntity.storeId, changes,
          }] }))
        : Promise.reject(new Error("Atualização indisponível."));
    }
  };
  const ccHandleStageChange = async (stageId) => {
    if (manualSaleWriteDenied({
      user:currentUser,
      previousStage:selectedEntity?.stage,
      nextStage:stageId,
      saleStages:selectedSaleStages,
    })) {
      alert(MANUAL_SALE_CUTOFF_NOTICE);
      return;
    }
    const changes = { stage: stageId };
    try {
      const writeResult = await ccUpdateEntry(changes);
      if (prospectWriteWasStale(writeResult)) return;
    } catch {
      return;
    }
    if (stageId === "semInteresse" || stageId === "sem_interesse" || stageId === "sem_resposta") {
      centralExitGuard.saved({ ...selectedEntity, ...changes });
    }
  };
  // Presencial usa "semInteresse" (STAGES); Prospecção usa "sem_interesse" (PROSP_STAGES).
  // "desqualificado" não existe em PROSP_STAGES — gravar isso fazia o card sumir de todas as colunas.
  const ccHandleDesqualificar = () => ccHandleStageChange(selectedIsClient ? "semInteresse" : "sem_interesse");
  const ccHandleAgendarFollowUp = async () => {
    if (!ccFollowUpDate || !selectedEntity || ccSavingFollowUpRef.current) return;
    const timing = createNextContactTiming("central");
    if (!hasValidFutureNextContactDate(ccFollowUpDate)) {
      timing.finish("failed");
      alert("Selecione uma data de hoje ou futura para o próximo contato.");
      return;
    }
    ccSavingFollowUpRef.current = true;
    try {
      if (!onAddReminder) throw new Error("Criação do afazer indisponível.");
      const changes = nextContactSaveChanges(selectedEntity, ccFollowUpDate, new Date().toISOString());
      const writeResult = await ccUpdateEntry(changes);
      if (prospectWriteWasStale(writeResult)) { timing.finish("stale"); return; }
      timing.cardConfirmed();
      const result = await Promise.resolve(onAddReminder({
        id:Date.now(),
        ...(selectedIsClient
          ? { clientId:String(selectedEntity.id), storeId:selectedEntity.storeId }
          : { prospId:String(selectedEntity.id), storeId:selectedEntity.storeId }),
        consultantId:selectedEntity.consultantId,
        text:`📅 Follow-up — ${selected.contact.name}`,
        clientName:selected.contact.name,
        dueDate:ccFollowUpDate,
        status:"pending",
        createdAt:today,
        doneAt:null,
        type:"followup",
      }));
      if (result?.stale === true) { timing.finish("stale"); return; }
      if (result?.ok !== true) {
        timing.finish("failed");
        if (!result?.sessionExpired) alert(result?.error || "Não foi possível salvar o follow-up.");
        return;
      }
      timing.reminderConfirmed();
      const confirmed = selectedIsClient ? writeResult : firstConfirmedProspectWrite(writeResult)?.record;
      centralExitGuard.saved(confirmedNextContactAfterSave(selectedEntity, confirmed, changes));
      timing.finish(activeConversationExitGuard.canExit() ? "released" : "blocked");
      setShowCcFollowUp(false);
    } catch (error) {
      timing.finish("failed");
      alert(error?.message || "Não foi possível salvar o follow-up.");
    } finally {
      ccSavingFollowUpRef.current = false;
    }
  };
  const ccHandleTransfer = async (consultantId) => {
    try {
      if (selectedIsClient) {
        await ccUpdateEntry({ consultantId });
      } else if (onTransferProsp) {
        await onTransferProsp(selectedEntity, consultantId);
      } else {
        throw new Error("Transferência indisponível.");
      }
      setShowCcTransfer(false);
    } catch (error) {
      alert(error.message || "Não foi possível transferir este cartão.");
    }
  };
  const lostStageIdCC = selectedIsClient ? "semInteresse" : "sem_interesse";

  const searchNorm = ccSearch.trim().toLowerCase();
  const searchDigits = ccSearch.replace(/\D/g,"");
  const lookupPhone = normalizePhone(ccSearch);
  const lookupPhoneMatches = rawPhone => {
    return matchesCrmPhoneSearch(rawPhone, ccSearch);
  };
  let ccList = currentOriginAll.filter(c => {
    if (!matchesResponsavelFiltro(c, ccFilters.consultantId)) return false;
    if (ccFilters.status && ccFilters.status !== "todos" && c.stageId !== ccFilters.status) return false;
    if (onlyNoResponse && !c.awaitingReply) return false;
    if (onlyFollowupPending) {
      if (convOrigin === "client" ? !c.followupDate : c.stageId !== "interesse") return false;
    }
    if (ccEmConversa) {
      const inConv = convOrigin === "client" ? ["waiting","msg_sent","final"].includes(c.stageId) : c.stageId === "interesse";
      if (!inConv) return false;
    }
    // Tolera diferença do 9º dígito (ex: buscar "42 9935-2609" deve achar "42999352609")
    const phoneMatchCC = searchDigits.length>=8 && lookupPhoneMatches(c.phone);
    if (searchNorm && !(c.contact.name||"").toLowerCase().includes(searchNorm) && !phoneMatchCC) return false;
    return true;
  });
  ccList = sortItems(ccList, ccFilters.sortBy, {
    createdAt: c => c.createdAt,
    interacao: c => c.lastMsg?.timestamp,
    followup: c => c.followupDate,
  });
  // Prioridade fixa: "aguardando resposta" sempre vai ao topo, independente do sort escolhido.
  // Dentro do grupo "aguardando" e dentro do grupo "não aguardando", mantém a ordem do sortItems.
  ccList = [...ccList.filter(c => c.awaitingReply), ...ccList.filter(c => !c.awaitingReply)];
  const ccGroups = groupByDay(ccList, c => c.lastMsg?.timestamp || c.createdAt);

  // Contadores por aba (respeitam o período, mas não a busca/filtros locais — visão geral fixa)
  const presencialCounters = [
    { id:"total",   label:"Total de conversas",     value:presencialAll.length,                                                          color:"#6366F1" },
    { id:"emconv",  label:"Em conversa",             value:presencialAll.filter(c=>["waiting","msg_sent","final"].includes(c.stageId)).length, color:"#0EA5E9" },
    { id:"aguard",  label:"Aguardando resposta",     value:presencialAll.filter(c=>c.awaitingReply).length,                               color:"#F59E0B" },
    { id:"followup",label:"Follow-up",               value:presencialAll.filter(c=>c.followupDate).length,                                color:"#A07830" },
    { id:"vendido", label:"Vendidos",                value:presencialAll.filter(c=>c.stageId==="closed").length,                          color:"#6B8F3E" },
    { id:"perdido", label:"Perdidos",                value:presencialAll.filter(c=>c.stageId==="semInteresse").length,                    color:"#C0392B" },
  ];
  const prospCounters = [
    { id:"total",   label:"Total prospectados",      value:prospAll.length,                                                               color:"#6366F1" },
    { id:"respond", label:"Responderam",              value:prospAll.filter(c=>["respondeu","interesse","venda","sem_interesse"].includes(c.stageId)).length, color:"#8B5CF6" },
    { id:"emconv",  label:"Em conversa",              value:prospAll.filter(c=>c.stageId==="interesse").length,                            color:"#0EA5E9" },
    { id:"followup",label:"Follow-up",                value:prospAll.filter(c=>c.stageId==="interesse").length,                            color:"#A07830" },
    { id:"vendido", label:"Vendidos",                 value:prospAll.filter(c=>c.stageId==="venda").length,                                 color:"#10B981" },
    { id:"perdido", label:"Perdidos",                 value:prospAll.filter(c=>c.stageId==="sem_interesse").length,                         color:"#EF4444" },
  ];
  const ccCounters = convOrigin === "client" ? presencialCounters : prospCounters;

  // ── Aba Follow-up: agenda unificada de afazeres do dia (mistura Presencial + Prospecção
  // de propósito — é uma lista de tarefas, não a conversa em si; clicar abre o chat direto). ──
  const todayKeyFU = new Date(); todayKeyFU.setHours(0,0,0,0);
  const followupAllRaw = conversations.filter(c => {
    if (c.contact.type === "client") return !!c.followupDate && !["closed","semInteresse"].includes(c.stageId);
    return c.stageId === "interesse";
  }).map(c => ({
    ...c,
    fuDate: c.followupDate ? toDateSafe(c.followupDate) : null,
    fuUrgency: (() => {
      if (!c.followupDate) return "sem_data";
      const d = toDateSafe(c.followupDate);
      if (!d) return "sem_data";
      const dd = new Date(d); dd.setHours(0,0,0,0);
      if (dd < todayKeyFU) return "atrasado";
      if (dd.getTime() === todayKeyFU.getTime()) return "hoje";
      return "futuro";
    })(),
  }));
  const followupAll = followupAllRaw.filter(c => matchesResponsavelFiltro(c, ccFilters.consultantId));
  let followupList = followupAll.filter(c => {
    if (fuUrgencyFilter && c.fuUrgency !== fuUrgencyFilter) return false;
    if (!searchNorm) return true;
    return (c.contact.name||"").toLowerCase().includes(searchNorm) || matchesPhoneSearch(c.phone, ccSearch);
  });
  const urgencyRank = { atrasado:0, hoje:1, futuro:2, sem_data:3 };
  followupList = [...followupList].sort((a,b) => {
    const r = urgencyRank[a.fuUrgency] - urgencyRank[b.fuUrgency];
    if (r !== 0) return r;
    if (a.fuDate && b.fuDate) return a.fuDate - b.fuDate;
    return (b.lastMsg?.timestamp||"") > (a.lastMsg?.timestamp||"") ? 1 : -1;
  });
  const URGENCY_LABELS = { atrasado:"🔴 Atrasados", hoje:"🟡 Para hoje", futuro:"🟢 Próximos dias", sem_data:"📋 Sem data (interesse em prospecção)" };
  const followupGroups = ["atrasado","hoje","futuro","sem_data"]
    .map(key => ({ key, label:URGENCY_LABELS[key], items: followupList.filter(c=>c.fuUrgency===key) }))
    .filter(g => g.items.length > 0);
  const followupCounters = [
    { id:"total",    label:"Total pendente",   value:followupAll.length,                                     color:"#6366F1" },
    { id:"atrasado", label:"Atrasados",        value:followupAll.filter(c=>c.fuUrgency==="atrasado").length, color:"#EF4444" },
    { id:"hoje",     label:"Para hoje",        value:followupAll.filter(c=>c.fuUrgency==="hoje").length,     color:"#F59E0B" },
    { id:"futuro",   label:"Próximos dias",    value:followupAll.filter(c=>c.fuUrgency==="futuro").length,   color:"#10B981" },
  ];

  useEffect(()=>{
    if(chatRef.current) chatRef.current.scrollTop=chatRef.current.scrollHeight;
  },[selected?.msgs?.length]);

  useEffect(()=>{ if(selected?.conversationKey) onMarkRead(selected.conversationKey); },[selected?.conversationKey,selected?.msgs?.length]); // eslint-disable-line

  const consultantName = id => USERS.find(u=>u.id===id)?.name.split(" ")[0]||"";

  // Busca por telefone também encontra registros fora da aba atualmente selecionada.
  // Admin/Gerente podem localizar qualquer registro; consultor só pode localizar o
  // próprio registro, mas todos podem clicar no resultado para abrir a origem correta.
  const phoneLookupResults = lookupPhone.replace(/\D/g,"").length >= 8
    ? [
        ...leadsArr
          .filter(l => lookupPhoneMatches(l.telefone))
          .map(l => ({
            key:`lead_${l.storeId || "unknown"}_${l.id}`, type:"Lead", name:l.nome, phone:l.telefone,
            storeId:l.storeId || resolveLeadConsultant(l)?.storeId || null,
            consultantId:resolveLeadConsultantId(l),
          })),
         ...scopedProspecao
          .filter(p => lookupPhoneMatches(p.phone))
          .map(p => ({
            key:`prosp_${p.storeId || "unknown"}_${p.id}`, type:"Prospecção", name:p.name, phone:p.phone,
            storeId:p.storeId || null, consultantId:p.consultantId,
          })),
         ...scopedClients
          .filter(c => lookupPhoneMatches(c.phone))
          .map(c => ({
            key:`client_${c.storeId || "unknown"}_${c.id}`, type:"Atendimento", name:c.name, phone:c.phone,
            storeId:c.storeId || null, consultantId:c.consultantId,
          })),
      ].filter(result => isStaffCC || Number(result.consultantId) === Number(currentUser?.id))
    : [];

  // Indicadores clicáveis (Atendimento Presencial / Prospecção): ao clicar, filtra a lista
  // abaixo para exatamente aquele recorte, sem tocar em período/consultor já aplicados.
  // Clicar de novo no mesmo indicador desliga o filtro rápido (volta a mostrar tudo).
  const selectIndicator = (id) => {
    if (ccActiveIndicator === id) {
      setCcActiveIndicator("total");
      setOnlyNoResponse(false);
      setOnlyFollowupPending(false);
      setCcEmConversa(false);
      setCcFilters(prev => ({ ...prev, status:"todos" }));
      return;
    }
    setCcActiveIndicator(id);
    setOnlyNoResponse(id === "aguard");
    setOnlyFollowupPending(id === "followup");
    setCcEmConversa(id === "emconv");
    setCcFilters(prev => ({
      ...prev,
      status: id === "vendido" ? (convOrigin === "client" ? "closed" : "venda")
            : id === "perdido" ? (convOrigin === "client" ? "semInteresse" : "sem_interesse")
            : "todos",
    }));
    if (ccListRef.current) ccListRef.current.scrollIntoView({ behavior:"smooth", block:"start" });
  };

  // Indicadores clicáveis da aba Follow-up: filtram por urgência (atrasado/hoje/futuro).
  const selectFollowupIndicator = (id) => {
    if (id === "total" || fuUrgencyFilter === id) {
      setFuUrgencyFilter(null);
      setCcActiveIndicator("total");
      return;
    }
    setFuUrgencyFilter(id);
    setCcActiveIndicator(id);
    if (ccListRef.current) ccListRef.current.scrollIntoView({ behavior:"smooth", block:"start" });
  };

  return (
    <div>
      <div style={{ fontWeight:800, fontSize:20, color:"#1E293B", marginBottom:2 }}>Central de Conversas</div>
      <div style={{ fontSize:13, color:"#64748B", marginBottom:14 }}>
        Atendimento Presencial e Prospecção, organizados por dia — nunca misturados.
        {totalUnread>0&&<span style={{ background:"#EF4444", color:"#fff", borderRadius:99, padding:"1px 8px", fontSize:11, fontWeight:800, marginLeft:8 }}>{totalUnread} nova{totalUnread!==1?"s":""}</span>}
      </div>

      {/* Abas por origem — nunca mistura Atendimento Presencial com Prospecção. O Follow-up é uma
          agenda de afazeres à parte, por isso pode reunir os dois. */}
      <div style={{ display:"flex", gap:8, marginBottom:14, flexWrap:"wrap" }}>
        {[["client","🏪 Atendimento Presencial",presencialAll.length],["prosp","📞 Prospecção",prospAll.length],["followup","📅 Follow-up",followupAll.length]].map(([id,label,count])=>(
          <button key={id} onClick={()=>{ setConvOrigin(id); setCcFilters({ ...DEFAULT_FILTERS, sortBy:"interacao" }); setCcSearch(""); setOnlyNoResponse(false); setOnlyFollowupPending(false); setCcEmConversa(false); setFuUrgencyFilter(null); setCcActiveIndicator("total"); }}
            style={{ flex:1, minWidth:150, background:convOrigin===id?T.accent:"#fff", color:convOrigin===id?"#fff":T.text, border:`1.5px solid ${convOrigin===id?T.accent:"#E2E8F0"}`, borderRadius:12, padding:"10px 14px", fontWeight:800, fontSize:13, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
            {label} <span style={{ background:convOrigin===id?"rgba(255,255,255,0.25)":(id==="followup"&&count>0?"#FEE2E2":"#F1F5F9"), color:convOrigin===id?"#fff":(id==="followup"&&count>0?"#DC2626":T.muted), borderRadius:99, padding:"1px 8px", fontSize:11, fontWeight:800 }}>{count}</span>
          </button>
        ))}
      </div>
      {convOrigin==="followup" && (
        <div style={{ fontSize:12, color:"#64748B", marginBottom:12, marginTop:-6 }}>
          Tudo que precisa de retorno hoje — de Atendimento Presencial e Prospecção juntos. Clique em um card para abrir a conversa e fazer o follow-up.
        </div>
      )}

      {/* Contadores da aba atual — clicáveis: abrem direto a lista filtrada correspondente */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(130px, 1fr))", gap:8, marginBottom:14 }}>
        {(convOrigin==="followup"?followupCounters:ccCounters).map(k => {
          const isActive = convOrigin==="followup" ? (k.id==="total" ? !fuUrgencyFilter : fuUrgencyFilter===k.id) : ccActiveIndicator===k.id;
          return (
          <div key={k.id}
            onClick={()=> convOrigin==="followup" ? selectFollowupIndicator(k.id) : selectIndicator(k.id)}
            title="Clique para abrir a lista filtrada"
            style={{ background:isActive?k.color+"14":"#fff", borderRadius:10, padding:"10px 12px", border:`1px solid ${isActive?k.color:"#E2E8F0"}`, borderLeft:`3px solid ${k.color}`, cursor:"pointer", transition:"all 0.12s", boxShadow:isActive?`0 0 0 1px ${k.color}33`:"none" }}>
            <div style={{ fontSize:18, fontWeight:800, color:"#1E293B" }}>{k.value}</div>
            <div style={{ fontSize:10.5, color:"#64748B", fontWeight:600 }}>{k.label}</div>
          </div>
          );
        })}
      </div>

      <FilterBar
        filters={ccFilters}
        setFilters={setCcFilters}
        hidePeriod={convOrigin==="followup"}
        showStatus={convOrigin!=="followup"}
        statusOptions={statusOptionsCC}
        consultants={consultantsInScope}
        showConsultant={isStaffCC}
        showSearch={true}
        searchValue={ccSearch}
        onSearchChange={setCcSearch}
      />
      {convOrigin!=="followup" && (
        <div style={{ display:"flex", gap:16, alignItems:"center", marginBottom:14, marginTop:-6, flexWrap:"wrap" }}>
          <label style={{ display:"flex", alignItems:"center", gap:6, fontSize:12, fontWeight:800, color:onlyNoResponse?"#EF4444":T.text, cursor:"pointer" }}>
            <input type="checkbox" checked={onlyNoResponse} onChange={e=>{ setOnlyNoResponse(e.target.checked); setCcActiveIndicator(e.target.checked?"aguard":"total"); }} /> 🔴 Aguardando resposta
          </label>
          <label style={{ display:"flex", alignItems:"center", gap:6, fontSize:12, fontWeight:700, color:T.text, cursor:"pointer" }}>
            <input type="checkbox" checked={onlyFollowupPending} onChange={e=>setOnlyFollowupPending(e.target.checked)} /> 📅 Follow-up pendente
          </label>
        </div>
      )}
      {phoneLookupResults.length > 0 && (
        <div style={{ background:"#EFF6FF", border:"1px solid #BFDBFE", borderRadius:12, padding:"10px 14px", marginBottom:14 }}>
          <div style={{ fontSize:11, fontWeight:800, color:"#1D4ED8", marginBottom:7 }}>
            🔎 Localização encontrada para {ccSearch}
          </div>
          <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
            {phoneLookupResults.map(result => {
              const store = result.storeId ? STORES.find(s=>s.id===Number(result.storeId)) : null;
              const consultant = result.consultantId ? USERS.find(u=>u.id===Number(result.consultantId)) : null;
              const openLookupResult = () => {
                if (result.type === "Lead") {
                  runNavigation(() => onOpenLead?.(conversationTarget("leads", result.storeId, result.phone)));
                  return;
                }
                selectConversation(result.phone, result.storeId, {
                  markReadKey:conversationKey(result.storeId, result.phone),
                  afterSelect:() => {
                    if (result.type === "Prospecção") setConvOrigin("prosp");
                    else if (result.type === "Atendimento") setConvOrigin("client");
                    setCcSearch("");
                  },
                });
              };
              return (
                <button key={result.key} type="button" onClick={openLookupResult}
                  title="Abrir esta conversa"
                  style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", width:"100%", textAlign:"left", fontSize:11, color:"#334155", background:"#fff", border:"1px solid #DBEAFE", borderRadius:8, padding:"5px 8px", cursor:"pointer" }}>
                  <strong style={{ color:"#1E293B" }}>{result.name || result.phone}</strong>
                  <span style={{ background:"#fff", borderRadius:99, padding:"2px 8px", color:"#475569", fontWeight:700 }}>{result.type}</span>
                  <span>🏬 {store?.name || "Loja não identificada"}</span>
                  <span>👤 {consultant?.name?.split(" ")[0] || "Sem consultor"}</span>
                  <span style={{ marginLeft:"auto", color:"#1D4ED8", fontWeight:800 }}>Abrir conversa →</span>
                </button>
              );
            })}
          </div>
        </div>
      )}

      <div style={{ display:"flex", height:isMobile?"calc(100vh - 172px)":"72vh", minHeight:isMobile?380:560, borderRadius:16, overflow:"hidden", boxShadow:"0 2px 20px rgba(0,0,0,0.12)", border:"1px solid #E2E8F0" }}>
        {/* Lista de conversas — agrupada por dia (Presencial/Prospecção) ou por urgência (Follow-up) */}
        <div ref={ccListRef} style={{ flex:1, overflowY:"auto", background:"#F1F5F9", padding:"12px", display:isMobile&&selectedPhone?"none":"block", minWidth:0 }}>
          {(convOrigin==="followup"?followupGroups:ccGroups).length===0 && (
            <div style={{ textAlign:"center", color:"#94A3B8", fontSize:12, paddingTop:60 }}>
              {convOrigin==="followup" ? "Nenhum follow-up pendente. 🎉" : "Nenhuma conversa encontrada com esses filtros."}
            </div>
          )}
          {prioritizeTextSendGroups(convOrigin==="followup"?followupGroups:ccGroups, getTextSendAttempts()).map(group => (
            <div key={group.key} style={{ marginBottom:16 }}>
              <div style={{ fontSize:11, fontWeight:800, color:"#64748B", textTransform:"uppercase", letterSpacing:0.3, marginBottom:8, padding:"0 4px" }}>{group.label}</div>
              <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                {prioritizeTextSendFailures(group.items, getTextSendAttempts()).map(c => {
                  const _ccTd = new Date().toISOString().split("T")[0];
                  const _ccAfazer = !c.awaitingReply && c.followupDate && c.followupDate <= _ccTd;
                  const eventCount = unreadPushLookup?.get(`inbox:${c.conversationKey}`) || 0;
                  const effectiveUnread = Math.max(c.unread || 0, eventCount);
                  return (
                  <div key={c.conversationKey} onClick={()=>selectConversation(c.phone, c.storeId, { markReadKey:c.conversationKey })}
                    aria-label={eventCount ? `${c.contact.name}, ${effectiveUnread} item${effectiveUnread>1?"s":""} não visualizado${effectiveUnread>1?"s":""}, incluindo ${eventCount} notificação${eventCount>1?"ões":""}` : undefined}
                    title={eventCount ? `${eventCount} notificação${eventCount>1?"ões":""} do CRM não visualizada${eventCount>1?"s":""}` : undefined}
                    style={{ background:c.awaitingReply?"#FEF2F2":_ccAfazer?"#FFF7ED":eventCount?"#FFFBEB":"#fff", borderRadius:12, padding:"12px 14px", cursor:"pointer", boxShadow:selected?.conversationKey===c.conversationKey?"0 2px 10px rgba(99,102,241,0.2)":"0 1px 3px rgba(0,0,0,0.07)", border:selected?.conversationKey===c.conversationKey?`1.5px solid ${T.accent}`:_ccAfazer?"1.5px solid #D97706":eventCount?"1.5px solid #F59E0B":"1.5px solid transparent", borderLeft:c.awaitingReply?"4px solid #EF4444":_ccAfazer?"4px solid #D97706":eventCount?"4px solid #F59E0B":(selected?.conversationKey===c.conversationKey?`1.5px solid ${T.accent}`:"4px solid transparent") }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:8, marginBottom:4 }}>
                      <div style={{ fontWeight:800, fontSize:13, color:"#1E293B", display:"flex", alignItems:"center", gap:6 }}>
                        {convOrigin==="followup" && (c.contact.type==="prosp"?<span title="Prospecção">📞</span>:<span title="Atendimento Presencial">🏪</span>)}
                        {c.contact.name}
                        <TextSendStatus storeId={c.storeId} phone={c.phone} />
                      </div>
                      <div style={{ display:"flex", alignItems:"center", gap:6, flexShrink:0 }}>
                        {effectiveUnread>0&&<span style={{ background:c.unread>0?"#EF4444":"#F59E0B", color:"#fff", borderRadius:99, fontSize:9, fontWeight:800, padding:"1px 6px" }}>{effectiveUnread}</span>}
                        <span style={{ fontSize:9, fontWeight:800, borderRadius:99, padding:"2px 8px", background:c.stageColor+"22", color:c.stageColor }}>{c.stageLabel}</span>
                      </div>
                    </div>
                    <div style={{ display:"flex", flexWrap:"wrap", gap:10, fontSize:10.5, color:"#64748B", marginBottom:6 }}>
                      <span>👤 {consultantName(c.consultantId)||"Sem consultor"}</span>
                      {isStaffCC && <span>🏬 {c.storeName || "Loja não identificada"}</span>}
                      {c.createdAt&&<span>🗓 1º contato: {fmtDate(c.createdAt)}</span>}
                      {c.followupDate&&<span style={{ color:T.accent, fontWeight:700 }}>📅 Follow-up: {fmtDate(c.followupDate)}</span>}
                    </div>
                    {c.lastMsg&&<div style={{ fontSize:11, color:"#475569", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", marginBottom:4 }}>{c.lastMsg.remetente==="consultor"?"✓ ":""}{c.lastMsg.texto||"📎 Mídia"}</div>}
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:10, color:"#94A3B8" }}>
                      <span>Última interação: {c.lastMsg?.timestamp?timeAgo(c.lastMsg.timestamp):"—"}</span>
                      {c.awaitingReply&&<span style={{ background:"#EF4444", color:"#fff", borderRadius:99, padding:"2px 8px", fontWeight:800, fontSize:9.5 }}>🔴 Aguardando resposta há {timeAgo(c.lastMsg.timestamp)}</span>}
                    </div>
                  </div>
                ); })}
              </div>
            </div>
          ))}
        </div>

        {selectedPhone&&selected&&(
          <div style={{ width:isMobile?"100%":355, flexShrink:0, display:"flex", flexDirection:"column", minWidth:0, borderLeft:isMobile?"none":"1px solid #E2E8F0" }}>
            {!activeCentralRecord && <div role="status" style={{ padding:"12px 16px", background:"#FFF7ED", color:"#9A3412", borderBottom:"1px solid #FED7AA", fontSize:12, fontWeight:700 }}>{CENTRAL_RECORD_NOT_FOUND_MESSAGE}</div>}
            <div style={{ padding:"12px 16px", borderBottom:"1px solid #F1F5F9", background:"#fff", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                {isMobile&&(
                  <button onClick={centralExitGuard.close} style={{ background:"#F1F5F9", border:"none", borderRadius:99, width:30, height:30, cursor:"pointer", fontSize:16, display:"flex", alignItems:"center", justifyContent:"center", color:"#64748B", flexShrink:0 }}>←</button>
                )}
                <div>
                  <div style={{ fontWeight:800, fontSize:14, color:"#1E293B" }}>{selected.contact.name}</div>
                  <div style={{ fontSize:11, color:"#64748B" }}>📱 {selectedPhone}</div>
                </div>
              </div>
              <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                {selected.contact.type==="lead"&&selected.contact.lead&&(
                  <span style={{ fontSize:10, fontWeight:700, borderRadius:99, padding:"2px 10px", background:selected.contact.lead.responsavel==="consultor"?"#DBEAFE":"#EDE9FE", color:selected.contact.lead.responsavel==="consultor"?"#1D4ED8":"#7C3AED" }}>
                    {selected.contact.lead.responsavel==="consultor"
                      ? `👤 ${(()=>{ const _l=selected.contact.lead; return USERS.find(u=>u.id===_l.consultantId)?.name?.split(" ")[0] || _l.responsavelNome?.split(" ")[0] || _l.consultorNome?.split(" ")[0] || (_l.responsavel!=="consultor"&&_l.responsavel!=="aurora"&&_l.responsavel ? _l.responsavel.split(" ")[0] : null) || "Consultor"; })()}`
                      : "🤖 Aurora"}
                  </span>
                )}
                {selected.contact.type==="prosp"&&<span style={{ fontSize:10, fontWeight:700, background:"#F0FDF4", color:"#15803D", borderRadius:99, padding:"2px 10px" }}>📱 Prospecção</span>}
                {selected.contact.type==="client"&&<span style={{ fontSize:10, fontWeight:700, background:"#EDE9FE", color:"#7C3AED", borderRadius:99, padding:"2px 10px" }}>🏪 Presencial</span>}
                {onRegistrarVenda && selected.contact.type!=="unknown" && (
                  <ManualSaleAction currentUser={currentUser}
                    onClick={()=>{
                      const c = selected.contact;
                      const entity = c.type==="lead" ? c.lead : c.type==="prosp" ? c.prosp : c.client;
                      onRegistrarVenda({ ...createSaleTarget("inbox", entity || c, currentUser?.storeId, c.type==="prosp" ? null : currentUser?.id), phone:selectedPhone, name:c.name, contactType:c.type });
                    }}
                    style={{ background:"#10B981", color:"#fff", border:"none", borderRadius:99, padding:"4px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}
                    noticeStyle={{ background:"#FEF9F0", border:"1px solid #D4C5A9", borderRadius:8, padding:"6px 8px", maxWidth:260 }} />
                )}
                <button onClick={centralExitGuard.close} style={{ background:"#F1F5F9", border:"none", borderRadius:99, width:28, height:28, cursor:"pointer", fontSize:13, display:"flex", alignItems:"center", justifyContent:"center", color:"#64748B" }}>✕</button>
              </div>
            </div>
            {selectedEntity && (
              <div style={{ padding:"8px 16px", borderBottom:"1px solid #F1F5F9", background:"#fff", display:"flex", flexDirection:"column", gap:6 }}>
                <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                  <LiftSaleStageSelect moduleId={selectedIsClient?"kanban":"prospeccao"} record={selectedEntity}
                    value={selectedEntity.stage} saleStage={selectedIsClient?"closed":"venda"}
                    options={selectedStageOptions} onChange={ccHandleStageChange}
                    onLinked={card=>centralExitGuard.saved(card)}
                    style={{padding:"6px 8px",borderRadius:8,border:"1px solid #E2E8F0",fontSize:11,fontWeight:700,background:"#fff"}}/>
                  {selectedEntity.stage!==lostStageIdCC && (
                    <button onClick={ccHandleDesqualificar} title="Desqualificar" style={{ background:"#FEE2E2", color:"#DC2626", border:"none", borderRadius:8, padding:"6px 10px", fontSize:11, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}>🚫</button>
                  )}
                </div>
                <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                  <button onClick={()=>setShowCcFollowUp(v=>!v)} style={{ background:showCcFollowUp?T.accent:"#F1F5F9", color:showCcFollowUp?"#fff":"#475569", border:"none", borderRadius:8, padding:"5px 10px", fontSize:10.5, fontWeight:700, cursor:"pointer" }}>📅 Follow-up</button>
                  {isStaffCC && selected.contact.type !== "prosp" && (
                    <button onClick={()=>setShowCcTransfer(v=>!v)} style={{ background:showCcTransfer?T.accent:"#F1F5F9", color:showCcTransfer?"#fff":"#475569", border:"none", borderRadius:8, padding:"5px 10px", fontSize:10.5, fontWeight:700, cursor:"pointer" }}>⇄ Transferir</button>
                  )}
                  <button onClick={centralExitGuard.close} style={{ background:"#F1F5F9", color:"#475569", border:"none", borderRadius:8, padding:"5px 10px", fontSize:10.5, fontWeight:700, cursor:"pointer" }}>✅ Concluir</button>
                </div>
                {showCcFollowUp && (
                  <div style={{ display:"flex", gap:6 }}>
                    <input type="date" value={ccFollowUpDate} onChange={e=>setCcFollowUpDate(e.target.value)} style={{ flex:1, padding:"6px 8px", borderRadius:8, border:"1px solid #E2E8F0", fontSize:11 }} />
                    <button onClick={ccHandleAgendarFollowUp} disabled={!ccFollowUpDate} style={{ background:ccFollowUpDate?T.accent:"#E2E8F0", color:"#fff", border:"none", borderRadius:8, padding:"6px 12px", fontSize:11, fontWeight:700, cursor:ccFollowUpDate?"pointer":"default" }}>Agendar</button>
                  </div>
                )}
                {isStaffCC && selected.contact.type === "prosp" && (
                  <div role="status" style={{ fontSize:11, color:"#64748B" }}>
                    Troca de consultor temporariamente indisponível nesta ficha.
                  </div>
                )}
                {showCcTransfer && selected.contact.type !== "prosp" && (
                  <select value="" onChange={e=>{ if(e.target.value) ccHandleTransfer(Number(e.target.value)); }} style={{ padding:"6px 8px", borderRadius:8, border:"1px solid #E2E8F0", fontSize:11, background:"#fff" }}>
                    <option value="">Selecionar consultor...</option>
                    {consultantsInScope?.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
                  </select>
                )}
                {selectedIsClient && ["closed","posVenda","nextSale"].includes(selectedEntity.stage) && <RegistrarIndicacao
                  sourceSale={{ type:"client", storeId:Number(selectedEntity.storeId || selected.storeId), id:selectedEntity.id }}
                  defaultIndicadoPor={selectedEntity.name || selected.contact.name}
                  showToggle
                />}
              </div>
            )}
            <div ref={chatRef} style={{ flex:1, overflowY:"auto", padding:"14px 16px", display:"flex", flexDirection:"column", gap:8, background:"#F8FAFC" }}>
              <HistoryPagination storeId={Number(selected?.conversationKey?.split(":")[0])||selected?.contact?.storeId} phone={selected?.phone} />
              <ChatMessageList
                storeId={selected.storeId || currentUser?.storeId} phone={selectedPhone}
                messages={selected.msgs}
                buildRetry={(m, msgTexto, isMine) => isMine ? (waMsgIsMedia(m)?(onSendZapiMedia?()=>onSendZapiMedia(selectedPhone,m,m.tipo):null):(onSend && msgTexto.trim())?()=>onSend(selectedPhone,msgTexto,currentUser,null,selected.storeId || currentUser?.storeId,null,m):null) : null}
                onReply={msg=>setReplyTo(msg)}
                onDelete={onDeleteWhatsAppMessage ? (msg)=>onDeleteWhatsAppMessage(selectedPhone, msg, msg.storeId || selected.storeId || currentUser?.storeId) : null}
              />
            </div>
            <div style={{ padding:"8px 16px 12px", background:"#fff", borderTop:"1px solid #F1F5F9" }}>
              <LiftCloseSaleAction moduleId={selectedIsClient?"kanban":"prospeccao"} record={selectedEntity}/>
              <ChatComposerBar
                noteTarget={selectedEntity?{moduleId:selectedIsClient?"kanban":"prospeccao",recordId:selectedEntity.id}:null}
                onSendText={(t,qId,quote,options)=>onSend(selectedPhone, t, currentUser, qId, selected.storeId || currentUser?.storeId, quote, null, options)}
                coachAlvo={selectedPhone ? { phone:selectedPhone, storeId:selected?.storeId || currentUser?.storeId } : null}
                onSendMedia={onSendZapiMedia ? (file,tipo,qId,quote)=>onSendZapiMedia(selectedPhone, file, tipo, selected.storeId || currentUser?.storeId, qId, quote) : null}
                replyTo={replyTo}
                onClearReply={()=>setReplyTo(null)}
                allowNote
                currentUser={currentUser}
                storeId={selected.storeId || currentUser?.storeId}
                reviewContext={{ phone:selectedPhone, nome:selected.contact.name,
                  produto:selectedEntity?.product || selected.contact.client?.product || selected.contact.prosp?.product || "" }}
                onSendQRMedia={onSendZapiMedia ? (m,qId,quote)=>onSendZapiMedia(selectedPhone,{_isQRMedia:true,url:m.url,tipo:m.tipo},m.tipo,undefined,qId,quote) : null}
                onSaveNote={t=>{
                  // Nota interna: fica registrada na linha do tempo da conversa (destacada em
                  // amarelo), visível só dentro do CRM — nunca é enviada ao cliente via Z-API.
                  const phoneClean = normalizePhone(selectedPhone);
                  const storeId = selected.storeId || currentUser?.storeId;
                  if (!phoneClean || !storeId) return;
                  const msgId = `${Date.now()}`;
                  set(dbRef(conversationMessagePath(storeId, phoneClean, msgId)), {
                    remetente: "nota_interna",
                    texto: t,
                    timestamp: new Date().toISOString(),
                    storeId,
                    autor: currentUser?.name || currentUser?.username || "",
                  }).catch(()=>{});
                }}
                placeholder="Digite sua mensagem…"
                disabled={!selectedPhone}
                onGerarRoteiro={() => setRoteiroModalCC({ chooser: true })}
              />
            </div>
          </div>
        )}
        {selectedPhone&&!selected&&(
          <div style={{ width:isMobile?"100%":355, flexShrink:0, display:"flex", flexDirection:"column", minWidth:0, borderLeft:isMobile?"none":"1px solid #E2E8F0", background:"#fff" }}>
            <div style={{ padding:"12px 16px", display:"flex", alignItems:"center", gap:10, borderBottom:"1px solid #F1F5F9" }}>
              <button onClick={centralExitGuard.close} style={{ background:"#F1F5F9", border:"none", borderRadius:99, width:30, height:30, cursor:"pointer", fontSize:16, color:"#475569" }}>←</button>
              <div style={{ fontSize:12, color:"#9A3412", fontWeight:700 }}>
                {selectedStoreId && !activeCentralRecord ? CENTRAL_RECORD_NOT_FOUND_MESSAGE : "Carregando conversa..."}
              </div>
            </div>
          </div>
        )}
      </div>
      <AiHelpModal
        roteiroModal={roteiroModalCC}
        setRoteiroModal={setRoteiroModalCC}
        clientName={selectedPhone && selected ? selected.contact.name : ""}
        phone={selectedPhone ? normalizePhone(selectedPhone) : ""}
        storeId={currentUser?.storeId}
      />
    </div>
  );
}

// ── PROSPECÇÃO ─────────────────────────────────────────────────
const PROSP_STAGES = [
  { id:"contatado",    label:"Contatado",     color:"#6366F1", icon:"📱" },
  { id:"respondeu",    label:"Respondeu",     color:"#8B5CF6", icon:"💬" },
  { id:"interesse",    label:"Tem Interesse", color:"#F59E0B", icon:"✨" },
  { id:"venda",        label:"Fechou Venda",  color:"#10B981", icon:"🏆" },
  { id:"sem_interesse",label:"Sem Interesse", color:"#EF4444", icon:"🚫" },
  { id:"sem_resposta", label:"Sem Resposta",  color:"#9CA3AF", icon:"🔇" },
];
// Etapas usadas nas setas de "avançar etapa" sequenciais do card — "sem_resposta" só é
// atingido pela ação manual após 3 tentativas de follow-up, nunca por avanço sequencial.
const PROSP_STAGES_SEQUENCE = PROSP_STAGES.filter(s => s.id !== "sem_resposta");
// Legacy stage sets are fallback guards only; a proven post-closure inbound
// takes precedence through the shared reply-state helper.
const PROSP_STAGES_NO_AWAITING = new Set(["venda","sem_interesse","sem_resposta"]);
// Etapas finais/agendadas de Cliente Presencial onde "Aguardando resposta" nunca deve aparecer —
// fechou venda, sem interesse, pós-venda/próxima venda já agendada, ou prospecção futura.
const CLIENT_STAGES_NO_AWAITING = new Set(["closed","semInteresse","posVenda","nextSale"]);

// ── Helpers compartilhados de "aguardando resposta" ─────────────────────────
// Reutilizados em CentralOperacionalView, badge count e (como referência) nos módulos individuais.

// Compara dois timestamps (string ISO ou number ms) de forma segura
const _tsNum = (ts) => typeof ts === "number" ? ts : ts ? new Date(ts).getTime() : 0;
const _conversationActionTs = conversationActionTimestamp;
const _lastMsg = (msgs) => msgs.reduce((a,m) => (
  _conversationActionTs(m) > _conversationActionTs(a) ? m : a
), null);

function clientAwaitingReply(c, whatsappMsgs) {
  const msgs = Object.values(getReplyMsgsForPhone(whatsappMsgs, c.phone, c.storeId));
  return getClientConversationState(c, msgs) === "needs_team_reply";
}

// O estágio do funil é escolhido manualmente e não muda com uma mensagem. Este
// estado, porém, deixa claro no card se existe uma ação da equipe ou se ela já
// respondeu e agora só aguarda o cliente, sem tratar acompanhamento como pendência.
function getClientConversationState(client, messages) {
  if(["closed","posVenda","nextSale","semInteresse","desqualificado"].includes(client.stage))return postSaleReplyState(client,messages);
  if (CLIENT_STAGES_NO_AWAITING.has(client.stage)) return "not_actionable";
  const state = conversationReplyState(messages, { isClosingMessage });
  return client.followUp && state === "no_messages" ? "followup_scheduled" : state;
}

function getProspectConversationState(prospect, messages) {
  if(["venda","sem_interesse","sem_resposta","desqualificado"].includes(prospect.stage))return postSaleReplyState(prospect,messages);
  if (PROSP_STAGES_NO_AWAITING.has(prospect.stage)) return "not_actionable";
  const state = conversationReplyState(messages, { isClosingMessage });
  return prospect.followUp && state === "no_messages" ? "followup_scheduled" : state;
}

function prospAwaitingReply(p, whatsappMsgs, prospMensagens) {
  const pMsgs = Object.values(getReplyMsgsForPhone(whatsappMsgs, p.phone, p.storeId || null));
  return getProspectConversationState(p, pMsgs) === "needs_team_reply";
}

function leadReplyMessages(lead, leadMessages, whatsappMsgs) {
  return replyMessagesForLeadCard(whatsappMsgs, leadMessages, lead.id,
    leadStoreIds(lead), normalizePhone(lead.telefone));
}

function leadAwaitingReply(lead, leadMessages, whatsappMsgs) {
  return leadConversationReplyState(lead, leadReplyMessages(lead, leadMessages, whatsappMsgs), {
    hasHumanOwnership:leadHasHumanOwnership(lead),
    isClosingMessage,
  }) === "needs_team_reply";
}

// ── Nova interface (Etapa 5b): conversa da Indicação dentro da própria aba ──
// Regra da Ana: indicação recebe uma mensagem só; se não responder, ninguém
// insiste. Por isso esta conversa NÃO tem trava de próximo contato: fecha livre.
export function IndicacaoConversa({ item, storeId, currentUser, whatsappMsgs, onSend, onSendMedia, onMarkRead, onConversationActive, onStatus, onClose, busy }) {
  const telefone = item.whatsapp || item.telefone || item.indicado?.whatsapp || item.contato?.whatsapp || "";
  const phone = normalizePhone(telefone);
  const nome = item.nome || item.indicado?.nome || item.contato?.nome || "Pessoa indicada";
  const msgs = phone ? (getWaMsgsForPhone(whatsappMsgs || {}, phone, Number(storeId)) || {}) : {};
  const status = item.status || "a_contatar";
  const conversationActiveCallback = useRef(onConversationActive);
  conversationActiveCallback.current = onConversationActive;
  useEffect(() => {
    const active = phone && Number(storeId) > 0
      ? { phone, storeId:Number(storeId), module:"indicacoes" }
      : null;
    if (!active) return undefined;
    conversationActiveCallback.current?.(active);
    return () => conversationActiveCallback.current?.(null);
  }, [phone, storeId]);
  return (
    <div className="nu-indic-full" style={{ position:"fixed", top:0, right:0, bottom:0, zIndex:200, background:"#fff", display:"flex", flexDirection:"column", boxShadow:"-12px 0 32px rgba(0,0,0,0.10)" }}>
      <style>{`
.nu-indic-full { left: 248px; }
@media (max-width: 899px) { .nu-indic-full { left: 0; } }`}</style>
      <div style={{ padding:"12px 18px", borderBottom:`1px solid ${T.nuLine || T.sandDark}`, display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
        <button type="button" onClick={onClose} aria-label="Voltar para as indicações" style={{ background:T.sandDark, border:"none", borderRadius:6, padding:"6px 12px", cursor:"pointer", fontSize:13, fontWeight:700, color:T.text }}>← Indicações</button>
        <div style={{ flex:1, minWidth:180 }}>
          <div style={{ fontWeight:800, fontSize:17, color:T.text }}>{nome}</div>
          <div style={{ fontSize:12, color:T.muted }}>Indicada por {item.indicadoPor || item.referringPerson || "—"}{phone ? ` · ${phone}` : ""}</div>
        </div>
        {["virou_venda","sem_interesse"].map(s => (
          <button key={s} type="button" disabled={busy || status === s} onClick={() => onStatus(s)} style={{ border:`1px solid ${T.nuLine || T.sandDark}`, background:status === s ? T.accent : "#fff", color:status === s ? "#fff" : T.text, borderRadius:4, padding:"7px 12px", fontSize:13, fontWeight:600, cursor:busy ? "wait" : "pointer" }}>
            {s === "virou_venda" ? "Virou venda" : "Sem interesse"}
          </button>
        ))}
      </div>
      <div style={{ flex:1, overflowY:"auto", padding:"8px 18px 18px" }}>
        {phone
          ? <ProspChatPanel tall contact={{ name:nome, phone, storeId:Number(storeId), product:item.produto || item.product || "" }} messages={msgs} currentUser={currentUser} onSend={onSend} onSendMedia={onSendMedia} onMarkRead={onMarkRead} />
          : <div style={{ color:T.muted, fontSize:14, padding:"24px 0" }}>Esta indicação não tem WhatsApp válido.</div>}
      </div>
    </div>
  );
}

export function ProspChatPanel({ contact, messages, currentUser, onSend, onSendMedia, onMarkRead, tall = false }) {
  const [roteiroModalProsp, setRoteiroModalProsp] = useState(null);
  const chatRef = useRef(null);
  useConversationDiagnosticView(contact.storeId, normalizePhone(contact.phone || contact.telefone), chatRef);
  const sortedMsgs = useTextSendMessages(Object.entries(messages||{}).map(([id,m]) => ({ ...m, id:m.id || id })), contact.storeId, contact.phone || contact.telefone);
  const readIdentity = conversationKey(contact.storeId, contact.phone || contact.telefone);
  const readCallbackRef = useRef(onMarkRead);
  readCallbackRef.current = onMarkRead;
  const progressBoundaryRef = useRef({ identity:readIdentity, since:Date.now(), seen:new Set() });
  if (progressBoundaryRef.current.identity !== readIdentity) {
    progressBoundaryRef.current = { identity:readIdentity, since:Date.now(), seen:new Set() };
  }
  useEffect(() => {
    const boundary = progressBoundaryRef.current;
    let changed = false;
    Object.entries(messages || {}).forEach(([id, message]) => {
      const realInteraction = message?.remetente === "cliente"
        || (message?.remetente === "consultor" && ["sent","delivered","read"].includes(message.status));
      if (!realInteraction || boundary.seen.has(id)) return;
      boundary.seen.add(id);
      if (Date.parse(message.timestamp) >= boundary.since) changed = true;
    });
    if (changed && readIdentity) notifyProspRefresh();
  }, [messages, readIdentity]);
  useEffect(() => {
    if (readIdentity) readCallbackRef.current?.(readIdentity);
    if (chatRef.current) chatRef.current.scrollTop = chatRef.current.scrollHeight;
  }, [readIdentity, sortedMsgs.length]);
  return (
    <div style={{ marginTop:10, background:"#F8FAFC", borderRadius:10, border:"1px solid #E2E8F0", padding:"10px 12px" }}>
      <div style={{ fontSize:11, fontWeight:700, color:"#64748B", marginBottom:8, display:"flex", alignItems:"center", gap:6 }}>
        <span style={{ background:"#25D366", color:"#fff", borderRadius:6, padding:"2px 8px", fontSize:9, fontWeight:800, letterSpacing:"0.3px" }}>📱 WhatsApp</span>
        {contact.name||contact.phone}
      </div>
      <div ref={chatRef} style={{ minHeight:tall ? 280 : 110, maxHeight:tall ? "calc(100vh - 260px)" : 200, overflowY:"auto", display:"flex", flexDirection:"column", gap:6, marginBottom:8 }}>
        <HistoryPagination storeId={contact.storeId} phone={contact.phone||contact.telefone} />
        {isNewUiEnabled() ? (
          <ChatMessageList messages={Object.entries(messages || {}).map(([id, m]) => ({ ...m, id:m.id || id }))}
            storeId={contact.storeId || currentUser?.storeId} phone={contact.phone || contact.telefone}
            buildRetry={(m, text, isMine) => {
              if (!isMine || m._localTextAttempt) return null;
              const type = String(m.tipo || m.type || (m.document ? "documento" : "")).toLowerCase();
              if (["documento", "document"].includes(type) && onSendMedia) {
                return () => onSendMedia(normalizePhone(contact.phone || contact.telefone), m, type, contact.storeId || currentUser?.storeId);
              }
              return onSend && text.trim()
                ? () => onSend(contact.phone || contact.telefone, text, currentUser, null, contact.storeId, null, m)
                : null;
            }} />
        ) : (<>
        {sortedMsgs.length===0&&<div style={{ textAlign:"center", color:"#94A3B8", fontSize:11, paddingTop:20 }}>Nenhuma mensagem ainda</div>}
        {sortedMsgs.map((m,i)=>{
          const isMine   = m.remetente==="consultor";
          const isAurora = m.remetente==="aurora";
          const isRight  = isMine || isAurora;
          const texto    = m.texto || m.content || m.body || m.text || m.message || "";
          const tipo = String(m.tipo || m.type || (m.document ? "documento" : "")).toLowerCase();
          const isDocument = isDocumentMessage(m);
          const documentUrl = m.url || m.base64Data || (typeof m.document === "string" ? m.document : m.document?.url) || null;
          const documentSrc = resolveMediaSrc(documentUrl, m.storagePath);
          const imageUrl = m.storageUrl || m.base64Data || m.url || (typeof m.image === "string" ? m.image : m.image?.url);
          const imageSrc = resolveMediaSrc(imageUrl, m.storagePath);
          const isImage = isNewUiEnabled() && (tipo.includes("imag") || ["foto","photo","picture"].includes(tipo) || Boolean(m.image)) && Boolean(imageSrc);
           const st       = isMine ? (m.status || "sent") : (isAurora ? (m.status || null) : null);
           const statusEl = isRight
             ? <WaSendStatus attempt={m._textAttempt} status={st} ack={m.waAck} motivo={m.motivo} timestamp={m.timestamp}
                 onRetry={isMine && !m._localTextAttempt && onSend && texto.trim()
                   ? () => onSend(contact.phone || contact.telefone, texto, currentUser, null, contact.storeId, null, m) : null} />
             : null;
          return (
            <div key={i} style={{ display:"flex", flexDirection:"column", alignItems:isRight?"flex-end":"flex-start" }}>
              <div style={{ background: st==="failed" ? "#FEE2E2" : st==="blocked" ? "#FEF3C7" : isMine?T.accent:isAurora?"#6366F1":"#E8EDF8", color: st==="failed" ? "#991B1B" : st==="blocked" ? "#92400E" : isRight?"#fff":"#1E293B", borderRadius:isRight?"12px 12px 4px 12px":"12px 12px 12px 4px", padding:"7px 11px", maxWidth:"82%", fontSize:12, lineHeight:1.4, border: st==="failed" ? "1px solid #FECACA" : st==="blocked" ? "1px solid #FDE68A" : isRight?"none":"1px solid #DDE4F0" }}>
                {isImage ? (
                  <div>
                    <LazyChatImage src={imageSrc} alt="imagem" onClick={()=>openMediaSrc({...m, url:imageUrl})} style={{maxWidth:"100%",maxHeight:260,borderRadius:6,cursor:"pointer",display:"block"}} />
                    {texto && <div><MessageTextLinks text={texto} /></div>}
                    {!isRight && isNewUiEnabled() && <button type="button" onClick={()=>pedirParecidos(imageSrc)} style={{ marginTop:5, border:"1px solid #CBD5E1", borderRadius:6, cursor:"pointer", background:"#fff", padding:"3px 8px" }}>🔎 Parecidos</button>}
                  </div>
                ) : isDocument ? (
                  <DocumentAttachment message={m} src={documentSrc || documentUrl} resolveSrc={resolveMediaSrc} />
                ) : <MessageTextLinks text={texto||"📎 Mídia"} />}
              </div>
              <div style={{ fontSize:9, color:"#94A3B8", marginTop:2, display:"flex", alignItems:"center", gap:4 }}>
                {messageSenderLabel(m, USERS)}{m.timestamp?` · ${new Date(m.timestamp).toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"})}`:""} {statusEl}
                {st==="failed" && texto && !isDocument && (
                  <button onClick={()=>onSend(normalizePhone(contact.phone), texto, null, null, contact.storeId || currentUser?.storeId, null, m)} title="Reenviar mensagem" style={{ background:"#EF4444", color:"#fff", border:"none", borderRadius:5, padding:"1px 7px", fontSize:9, fontWeight:700, cursor:"pointer", marginLeft:2 }}>↺ Reenviar</button>
                )}
                {st==="failed" && isDocument && onSendMedia && (
                  <button onClick={()=>onSendMedia(normalizePhone(contact.phone), m, tipo, contact.storeId || currentUser?.storeId)} title="Reenviar documento" style={{ background:"#EF4444", color:"#fff", border:"none", borderRadius:5, padding:"1px 7px", fontSize:9, fontWeight:700, cursor:"pointer", marginLeft:2 }}>↺ Reenviar</button>
                )}
              </div>
              {st==="failed" && m.motivo && (
                <div style={{ fontSize:9, color:"#EF4444", fontWeight:600, marginTop:1 }}>⚠️ Não enviada: {m.motivo}</div>
              )}
              {st==="blocked" && (
                <div style={{ fontSize:9, color:"#B45309", fontWeight:700, marginTop:1 }}>⚠️ {m.motivo || "Envio não confirmado; não reenviado para evitar duplicidade."}</div>
              )}
            </div>
          );
        })}
        </>)}
      </div>
      {/* Compositor unificado: Prospecção usa a mesma fila/armazenamento de anexos. */}
      <LiftCloseSaleAction moduleId="prospeccao" record={contact}/>
      <ChatComposerBar
        allowNote
        noteTarget={{moduleId:"prospeccao",recordId:contact.id}}
        onSendText={(text, quotedId, quotedMsg, options) => onSend(normalizePhone(contact.phone), text, currentUser, quotedId, contact.storeId || currentUser?.storeId, quotedMsg, null, options)}
        coachAlvo={contact?.phone ? { phone:normalizePhone(contact.phone), storeId:contact.storeId || currentUser?.storeId } : null}
        onSendMedia={onSendMedia ? (file, tipo, quotedMsgId, quotedMsg) =>
          onSendMedia(normalizePhone(contact.phone), file, tipo, contact.storeId || currentUser?.storeId, quotedMsgId, quotedMsg) : null}
        placeholder="Digite sua mensagem…"
        disabled={false}
        currentUser={currentUser}
        storeId={contact.storeId || currentUser?.storeId}
        reviewContext={{ phone:contact.phone, nome:contact.name, produto:contact.product }}
        onGerarRoteiro={() => setRoteiroModalProsp({ chooser: true })}
      />
      <AiHelpModal
        roteiroModal={roteiroModalProsp}
        setRoteiroModal={setRoteiroModalProsp}
        clientName={contact.name || contact.phone}
        phone={normalizePhone(contact.phone)}
        storeId={currentUser?.storeId}
      />
    </div>
  );
}

export function ProspConversationModal({ p, messages, currentUser, sendProspMsg, sendZapiMedia, onMarkRead, updateEntry, onAddReminder, isManagerOrAdmin, storeConsultants, onRegistrarVenda, onClose }) {
  const exitGuard = useFutureFollowUpExit(p, `prosp:${p.storeId}:${normalizePhone(p.phone)}:${p.id}`, onClose, {
    isExempt:record => record.stage === "contatado",
    getDate:() => followUpDate,
    onSave:(date, context) => saveNextContactOnExit(p, date, {
      kind:"prosp", update:(_record, changes) => updateEntry(p.id, changes),
      addReminder:onAddReminder, ...context,
    }),
    screen:"prospeccao",
  });
  const [followUpDate, setFollowUpDate] = useState(p.followUp || "");
  const [savingFollowUp, setSavingFollowUp] = useState(false);
  const savingFollowUpRef = useRef(false);
  const today = new Date().toISOString().split("T")[0];

  const handleFollowUp = async () => {
    if (savingFollowUpRef.current) return;
    const timing = createNextContactTiming("prosp");
    const diagnostic = createSaveDiagnostic("prosp");
    if (!hasValidFutureNextContactDate(followUpDate)) {
      timing.finish("failed");
      alert("Selecione uma data de hoje ou futura para o próximo contato.");
      return;
    }
    savingFollowUpRef.current = true;
    setSavingFollowUp(true);
    let operation = "card";
    try {
      // Keep existing date aliases and completion flags in sync with the new
      // appointment. A stale earlier alias must not hide a confirmed follow-up.
      if (!onAddReminder) throw new Error("Criação do afazer indisponível.");
      const changes = nextContactSaveChanges(p, followUpDate, new Date().toISOString());
      // updateEntry must resolve only after the Firebase write is confirmed.
      const writeResult = await Promise.resolve(updateEntry(p.id, changes));
      if (prospectWriteWasStale(writeResult)) { timing.finish("stale"); return; }
      const confirmedCard = firstConfirmedProspectWrite(writeResult)?.record;
      if (!confirmedCard) throw new Error("O servidor não confirmou o cartão/próxima data salvo.");
      timing.cardConfirmed();
      diagnosticMark(diagnostic, "card_confirmed");
      operation = "reminder";
      if (onAddReminder) {
        const result = await Promise.resolve(onAddReminder(associateReminderDiagnostic({
          id:Date.now(),
          prospId:String(p.id),
          storeId:p.storeId,
          consultantId:p.consultantId,
          text:`📅 Follow-up (Prosp.) — ${p.name}`,
          clientName:p.name,
          dueDate:followUpDate,
          status:"pending",
          createdAt:today,
          doneAt:null,
          type:"followup",
        }, diagnostic)));
        if (result?.stale === true) { timing.finish("stale"); return; }
        if (result?.ok !== true) {
          timing.finish("failed");
          if (!result?.sessionExpired) alert(operationFailureMessage("reminder", result?.error));
          return;
        }
      }
      timing.reminderConfirmed();
      diagnosticMark(diagnostic, "reminder_confirmed");
      if (!exitGuard.saved(confirmedNextContactAfterSave(p, confirmedCard, changes))) {
        timing.finish("stale");
        return;
      }
      timing.finish(exitGuard.canExit() ? "released" : "blocked");
      observeDiagnosticClose(diagnostic, () => exitGuard.close());
    } catch (error) {
      timing.finish("failed");
      if (!["prosp_scope_changed", "prosp_stale_response", "crm_session_expired"].includes(error?.code)) {
        alert(operationFailureMessage(operation, error));
      }
    } finally {
      savingFollowUpRef.current = false;
      setSavingFollowUp(false);
    }
  };
  const handleClose = () => {
    exitGuard.close();
  };
  const handleStageChange = async (stage) => {
    if (savingFollowUpRef.current) return;
    if (manualSaleWriteDenied({
      user:currentUser,
      previousStage:p.stage,
      nextStage:stage,
      saleStages:["venda"],
    })) {
      alert(MANUAL_SALE_CUTOFF_NOTICE);
      return;
    }
    savingFollowUpRef.current = true;
    setSavingFollowUp(true);
    try {
      const writeResult = await Promise.resolve(updateEntry(p.id, { stage }));
      if (prospectWriteWasStale(writeResult)) return;
      const confirmed = firstConfirmedProspectWrite(writeResult)?.record;
      if (!confirmed || confirmed.stage !== stage) {
        throw new Error("O servidor não confirmou a alteração do estágio.");
      }
      const applied = exitGuard.saved({ ...p, ...confirmed });
      if (applied && (stage === "sem_interesse" || stage === "sem_resposta")) exitGuard.close();
    } catch (error) {
      if (!["prosp_scope_changed", "prosp_stale_response", "crm_session_expired"].includes(error?.code)) {
        alert(operationFailureMessage("stage", error));
      }
    } finally {
      savingFollowUpRef.current = false;
      setSavingFollowUp(false);
    }
  };

  const nuProspFull = isNewUiEnabled();
  return (
    <div data-save-diagnostic-conversation="" className={nuProspFull ? "nu-prosp-full" : undefined} style={nuProspFull ? { position:"fixed", top:0, right:0, bottom:0, zIndex:200, background:"#fff", display:"flex", boxShadow:"-12px 0 32px rgba(0,0,0,0.10)" } : { position:"fixed", inset:0, background:"rgba(15,31,61,0.65)", zIndex:200, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }} onClick={nuProspFull ? undefined : handleClose}>
      {nuProspFull && <style>{`
.nu-prosp-full { left: 248px; }
@media (max-width: 899px) { .nu-prosp-full { left: 0; } }`}</style>}
      <div style={nuProspFull ? { background:"#fff", width:"100%", height:"100%", display:"flex", flexDirection:"column" } : { background:"#fff", borderRadius:18, width:"100%", maxWidth:520, maxHeight:"92vh", display:"flex", flexDirection:"column", boxShadow:"0 20px 60px rgba(0,0,0,0.35)" }} onClick={e=>e.stopPropagation()}>
        <div style={{ padding:"18px 22px 14px", borderBottom:`1px solid ${T.sandDark}`, flexShrink:0 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10 }}>
            <div>
              <div style={{ fontWeight:800, fontSize:16, color:T.text }}>{p.name}</div>
              <div style={{ fontSize:12, color:T.muted, marginTop:2 }}>{p.phone?`📱 ${p.phone}`:""}{p.product?` · 🛋 ${p.product}`:""}</div>
            </div>
            <button onClick={handleClose} title="Fechar" disabled={savingFollowUp} style={{ background:T.sandDark, border:"none", borderRadius:99, width:32, height:32, cursor:"pointer", fontSize:16, flexShrink:0 }}>✕</button>
          </div>
        </div>
        <div style={{ overflowY:"auto", padding:"16px 22px", flex:1 }}>
          <div style={{ marginBottom:14 }}>
            <div style={{ fontSize:11, fontWeight:700, color:T.muted, marginBottom:4 }}>Etapa</div>
            <div style={{ display:"flex", gap:8, alignItems:"center" }}>
              <LiftSaleStageSelect moduleId="prospeccao" record={p} value={p.stage} saleStage="venda"
                disabled={savingFollowUp} options={PROSP_STAGES}
                onChange={next=>{handleStageChange(next).catch(()=>{});}}
                onBegin={()=>{if(savingFollowUpRef.current)return false;savingFollowUpRef.current=true;setSavingFollowUp(true);return true;}}
                onSettled={()=>{savingFollowUpRef.current=false;setSavingFollowUp(false);}}
                onLinked={card=>{setFollowUpDate("");exitGuard.saved(card);}}
                style={{padding:"7px 10px",borderRadius:8,border:`1px solid ${T.sandDark}`,fontSize:13,background:"#fff"}}/>
              {p.stage!=="sem_interesse" && (
                <button disabled={savingFollowUp} onClick={()=>{ handleStageChange("sem_interesse").catch(()=>{}); }} title="Desqualificar" style={{ background:"#FEE2E2", color:"#DC2626", border:"none", borderRadius:8, padding:"7px 12px", fontSize:11, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}>🚫 Desqualificar</button>
              )}
            </div>
          </div>

          {p.stage !== "contatado" && <div style={{ marginBottom:14 }}>
            <div style={{ fontSize:11, fontWeight:700, color:T.muted, marginBottom:4 }}>📅 Agendar follow-up</div>
            <div style={{ display:"flex", gap:8 }}>
              <input type="date" value={followUpDate} onChange={e=>setFollowUpDate(e.target.value)} style={{ flex:1, padding:"7px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box" }} />
              <button onClick={handleFollowUp} disabled={!followUpDate || savingFollowUp} style={{ background:followUpDate?T.accent:T.sandDark, color:followUpDate?"#fff":T.muted, border:"none", borderRadius:8, padding:"7px 14px", fontSize:12, fontWeight:700, cursor:followUpDate?"pointer":"default", whiteSpace:"nowrap" }}>{savingFollowUp ? "Salvando…" : "Agendar"}</button>
            </div>
          </div>}

          {isManagerOrAdmin && storeConsultants && storeConsultants.length>0 && (
            <div style={{ marginBottom:14 }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.muted, marginBottom:4 }}>⇄ Transferir consultor</div>
              <select value={p.consultantId||""} disabled aria-label="Consultor responsável (transferência temporariamente indisponível)" style={{ width:"100%", padding:"7px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, background:"#F3F4F6" }}>
                {!p.consultantId && <option value="">Sem consultor atribuído</option>}
                {p.consultantId && !storeConsultants.some(u=>Number(u.id)===Number(p.consultantId)) && (
                  <option value={p.consultantId}>Consultor {p.consultantId}</option>
                )}
                {storeConsultants.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
              </select>
              <div role="status" style={{ marginTop:6, fontSize:11, color:T.muted }}>
                Troca de consultor temporariamente indisponível nesta ficha.
              </div>
            </div>
          )}

          <div style={{ marginBottom:14 }}>
            {p.stage === "venda" ? (
              <div style={{ background:"#F0FFF4", border:"1.5px solid #86EFAC", color:"#166534", borderRadius:8, padding:"8px 12px", fontSize:12, fontWeight:700 }}>
                ✅ Venda registrada {p.value>0 ? `· ${fmt(p.value)}` : ""}
              </div>
            ) : onRegistrarVenda && (
              <ManualSaleAction currentUser={currentUser}
                onClick={()=>onRegistrarVenda(createSaleTarget("prospeccao", p, currentUser?.storeId, null))}
                style={{ background:"#10B981", color:"#fff", border:"none", borderRadius:8, padding:"8px 14px", fontSize:12, fontWeight:700, cursor:"pointer", width:"100%" }}
                noticeStyle={{ background:"#FEF9F0", border:"1px solid #D4C5A9", borderRadius:8, padding:"8px 12px" }} />
            )}
          </div>

          {sendProspMsg && (
            <ProspChatPanel contact={p} messages={messages} currentUser={currentUser} onSend={sendProspMsg} onSendMedia={sendZapiMedia} onMarkRead={id=>onMarkRead&&onMarkRead(String(id))} />
          )}
        </div>
        <div style={{ padding:"12px 22px", borderTop:`1px solid ${T.sandDark}`, flexShrink:0 }}>
          <button onClick={handleClose} disabled={savingFollowUp} style={{ width:"100%", background:T.accent, color:"#fff", border:"none", borderRadius:10, padding:"10px", fontWeight:800, fontSize:13, cursor:"pointer" }}>{savingFollowUp ? "Salvando agendamento…" : "✅ Concluir e voltar à lista"}</button>
        </div>
      </div>
    </div>
  );
}

export function ProspeccaoView({ currentUser, loggedInUser, prospeccao, onUpdateProsp, getProspectWriteScope, whatsappMsgs={}, prospMensagens={}, sendProspMsg, sendZapiMedia, lastReadAt={}, onMarkRead, onAddReminder, onCancelReminder, autoOpenTarget, onAutoOpenConsumed, onRegistrarVenda, onConversationActive, unreadPushLookup }) {
  useTextSendAttempts();
  const DAILY_GOAL = 25;
  const today = currentDateKeySaoPaulo();
  const nowDateP = new Date();
  const monthKeyP = `${nowDateP.getFullYear()}-${String(nowDateP.getMonth()+1).padStart(2,"0")}`;
  const workingDaysInMonthP = (year, month) => { // month 0-indexed; conta seg-sex
    const daysInMonth = new Date(year, month+1, 0).getDate();
    let count = 0;
    for (let d=1; d<=daysInMonth; d++) { const dow = new Date(year, month, d).getDay(); if (dow!==0 && dow!==6) count++; }
    return count;
  };
  const workingDaysUpTo = (year, month, day) => {
    let count = 0;
    for (let d=1; d<=day; d++) { const dow = new Date(year, month, d).getDay(); if (dow!==0 && dow!==6) count++; }
    return count;
  };
  const workingDaysTotalP   = workingDaysInMonthP(nowDateP.getFullYear(), nowDateP.getMonth());
  const workingDaysSoFarP   = workingDaysUpTo(nowDateP.getFullYear(), nowDateP.getMonth(), nowDateP.getDate());
  const MONTHLY_GOAL = DAILY_GOAL * workingDaysTotalP;

  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [chatOpenId, setChatOpenIdRaw] = useState(null);
  const setChatOpenId = useCallback((next) => {
    const nextId = next == null ? null : String(next);
    if (nextId != null && chatOpenId != null && nextId !== String(chatOpenId)) {
      return activeConversationExitGuard.requestAction(() => setChatOpenIdRaw(nextId));
    }
    setChatOpenIdRaw(nextId);
  }, [chatOpenId]);
  const presenceProspect = findProspectSelection(prospeccao, chatOpenId);
  useConversationPresence({
    phone:normalizePhone(presenceProspect?.phone || presenceProspect?.telefone),
    storeId:presenceProspect?.storeId || currentUser?.storeId,
    module:"prospeccao", onConversationActive,
  });

  useEffect(() => {
    if (!autoOpenTarget) return;
    const match = autoOpenTarget.reminderCard
      ? resolveReminderCard({ prospId:autoOpenTarget.recordId, storeId:autoOpenTarget.storeId }, {
        prospeccao, currentUser,
        consultantStoreId:id => USERS.find(user => Number(user.id) === Number(id))?.storeId,
      })?.record
      : prospeccao.find(p => recordMatchesConversationTarget(p, autoOpenTarget, ["phone","telefone"]));
    if (!match) return;
    setChatOpenId(match.id);
    if (onAutoOpenConsumed) onAutoOpenConsumed();
  }, [autoOpenTarget, prospeccao]); // eslint-disable-line react-hooks/exhaustive-deps
  const isManagerOrAdminP = currentUser.role !== "consultant";
  const storeConsultantsP = USERS.filter(u => u.role === "consultant" && (currentUser.role === "admin" || currentUser.role === "manager" ? true : u.storeId === currentUser.storeId));
  // Consultor Responsável nasce sempre atribuído: pro consultor, é ele mesmo
  // (não editável — reforça a regra "quem iniciou o relacionamento continua
  // responsável"); pro gerente/admin, é editável pois eles podem estar
  // cadastrando em nome de um consultor da equipe.
  const [newP, setNewP] = useState({ name:"", phone:"", product:"", value:"", observation:"", stage:"contatado", visitDate: today, consultantId: currentUser.role==="consultant" ? currentUser.id : (storeConsultantsP[0]?.id ?? "") });
  const setF = (k,v) => setNewP(p=>({...p,[k]:v}));
  const [saving, setSaving] = useState(false);

  const [filterDate, setFilterDate] = useState("");
  const nuProsp = isNewUiEnabled();
  const [nuShowList, setNuShowList] = useState(false);
  const contextoFila = filaOperatorContext({ loggedInUser, currentUser });
  const { operator:operadorFila, role:papelFila, management:gerenciaFila, active:ativaFila, readOnly:filaReadOnly, viewingConsultant:visualizandoConsultorFila, consultantId:consultantIdFila, scopeKey:escopoFilaKey } = contextoFila;
  const nuFila = useProspFila(nuProsp && !_demoMode && ativaFila, consultantIdFila, { scopeKey:escopoFilaKey });
  const nuPlacar = useProspPlacar(nuProsp && !_demoMode && gerenciaFila && !visualizandoConsultorFila);
  const nuAbrindoFila = useRef(false);
  const [nuAbrindoFilaId, setNuAbrindoFilaId] = useState(null);
  const [filters, setFilters] = useScreenPeriodFilters("prospeccao", DEFAULT_FILTERS);
  const [drillDown, setDrillDown] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  // Mudar visão reutiliza a mesma tela. Não herdar busca/consultor/data de outra
  // pessoa, pois isso pode deixar o quadro vazio apesar do painel mensal cheio.
  const viewerKey = `${currentUser.role}:${currentUser.id}:${currentUser.storeId}`;
  const previousViewerKey = useRef(viewerKey);
  useEffect(() => {
    if (previousViewerKey.current === viewerKey) return;
    previousViewerKey.current = viewerKey;
    setFilters(prev => ({ ...prev, consultantId:"todos", period:"tudo", customFrom:"", customTo:"" }));
    setFilterDate("");
    setSearchQuery("");
  }, [viewerKey, setFilters]);

  const effPeriodP = filters.period;
  const effCustomFromP = filters.customFrom;
  const effCustomToP = filters.customTo;
  const effFiltersP = { period:effPeriodP, customFrom:effCustomFromP, customTo:effCustomToP };

  const mineAll = prospectsForViewer(prospeccao, currentUser,
    id => USERS.find(user => Number(user.id) === Number(id))?.storeId);

  const periodRangeP = getPeriodRange(effPeriodP, effCustomFromP, effCustomToP);
  // Resumo por consultor: sempre considera TODOS os consultores do período filtrado,
  // ignorando o filtro de consultor específico (senão o painel mostraria só 1 pessoa).
  const minePeriodOnly = mineAll.filter(p => effPeriodP === "tudo" || inPeriod(p.date || p.createdAt, periodRangeP));
  const prospRanking = storeConsultantsP.map(u => {
    const list  = minePeriodOnly.filter(p => Number(p.consultantId) === u.id);
    const vendas = list.filter(p => p.stage === "venda");
    return {
      id:u.id, name:u.name,
      contatados:list.length, contatadosList:list,
      vendas:vendas.length, vendasList:vendas,
      conv:pct(vendas.length, list.length),
    };
  }).sort((a,b)=>b.vendas-a.vendas);

  const dayListRaw = prospectBoardItems(mineAll, {
    matchesOwner:p => matchesResponsavelFiltro(p, filters.consultantId),
    matchesDate:p => (effPeriodP === "tudo" || inPeriod(p.date || p.createdAt, periodRangeP))
      && (!filterDate || p.date === filterDate),
    query:searchQuery,
    matchesSearch:p => {
    const q = searchQuery.trim().toLowerCase();
    const nameMatch  = (p.name || p.nome || "").toLowerCase().includes(q);
    const digits = q.replace(/\D/g,"");
    // Tolera diferença do 9º dígito (ex: buscar "42 9935-2609" deve achar "42999352609")
    const phoneMatch = digits.length>=8 && matchesPhoneSearch(p.phone || p.telefone, digits);
    return nameMatch || phoneMatch;
    },
  });
  const returnsDue = prospectReturnsDue(mineAll.filter(p => matchesResponsavelFiltro(p, filters.consultantId)), today);
  const dayListPreSort = filters.sortBy === "recentes" ? dayListRaw : sortItems(dayListRaw, filters.sortBy, {
    createdAt: (p)=> p.date || p.createdAt,
    interacao: (p)=> p.date || p.createdAt,
    valor:     (p)=> p.value || 0,
  });
  // "Aguardando resposta" (última mensagem é do cliente, sem resposta ainda) — usado pro
  // badge vermelho no card e pra fazer esses contatos subirem ao topo do dia, sem checar um a um.
  const isUnansweredProsp = (p) => {
    const phoneKey = normalizePhone(p.phone);
    const msgs = Object.values(getWaMsgsForPhone(whatsappMsgs, phoneKey, p.storeId)||{});
    return getProspectConversationState(p,msgs) === "needs_team_reply";
  };
  const dateOrderProsp = [...new Set(dayListPreSort.map(p=>p.date||p.createdAt))];
  const dayListBase = dateOrderProsp.flatMap(d => dayListPreSort
    .filter(p=>(p.date||p.createdAt)===d)
    .sort((a,b)=>(isUnansweredProsp(b)?1:0)-(isUnansweredProsp(a)?1:0)));
  // Painel principal: acumulado do mês (independe do filtro de dia, respeita só o filtro de consultor).
  // O filtro de dia continua existindo mais abaixo como "conferência" pontual, não define mais a meta principal.
  const mesFiltered = mineAll.filter(p => matchesResponsavelFiltro(p, filters.consultantId) && String(p.date||p.createdAt||"").startsWith(monthKeyP));
  const monthStageCount = (sid) => mesFiltered.filter(p=>p.stage===sid).length;
  const monthSemResposta = monthStageCount("sem_resposta");
  const monthSemInteresse= monthStageCount("sem_interesse");
  const monthContatados  = monthStageCount("contatado") + monthStageCount("respondeu") + monthStageCount("interesse") + monthStageCount("venda") + monthSemInteresse + monthSemResposta;
  const monthRespondeu   = monthStageCount("respondeu") + monthStageCount("interesse") + monthStageCount("venda") + monthSemInteresse;
  const monthInteresse   = monthStageCount("interesse") + monthStageCount("venda");
  const monthVenda       = monthStageCount("venda");
  const monthPctSemInter = monthRespondeu>0 ? Math.round((monthSemInteresse/monthRespondeu)*100) : 0;
  const monthPctResp   = monthContatados>0 ? Math.round((monthRespondeu/monthContatados)*100) : 0;
  const monthPctInter  = monthRespondeu>0  ? Math.round((monthInteresse/monthRespondeu)*100)  : 0;
  const monthPctVenda  = monthInteresse>0  ? Math.round((monthVenda/monthInteresse)*100)       : 0;
  const monthPctFinal  = monthContatados>0 ? Math.round((monthVenda/monthContatados)*100)      : 0;
  const monthGoalExpectedToday = DAILY_GOAL * workingDaysSoFarP;
  const monthPace = monthContatados >= monthGoalExpectedToday ? "no-ritmo" : "atrasado";
  const monthPctGoal = MONTHLY_GOAL>0 ? Math.round((monthContatados/MONTHLY_GOAL)*100) : 0;

  const addProsp = () => {
    if (!newP.name.trim() || saving) return;
    const visitDate = newP.visitDate && newP.visitDate <= today ? newP.visitDate : today;
    // Consultor sempre vira o dono do cadastro que ele mesmo criou (não confia
    // em nada vindo do form pra esse papel). Gerente/admin escolhem no form,
    // com fallback pro próprio usuário se por algum motivo não tiver consultor
    // selecionado (ex: loja sem consultores cadastrados).
    const assignedConsultantId = currentUser.role==="consultant"
      ? currentUser.id
      : (newP.consultantId || currentUser.id);
    const assignedConsultant = storeConsultantsP.find(u => u.id === assignedConsultantId);
    const entry = {
      ...newP,
      id: createProspectId(),
      value: parseFloat(newP.value)||0,
      consultantId: assignedConsultantId,
      storeId: currentUser.role==="consultant" ? currentUser.storeId : (assignedConsultant?.storeId ?? currentUser.storeId),
      date: visitDate,
      createdAt: visitDate,
    };
    setSaving(true);
    Promise.resolve(onUpdateProsp([entry]))
      .then(results => {
        if (prospectWriteWasStale(results) || !firstConfirmedProspectWrite(results)?.record) return;
        setNewP({ name:"", phone:"", product:"", value:"", observation:"", stage:"contatado", visitDate: today, consultantId: currentUser.role==="consultant" ? currentUser.id : (storeConsultantsP[0]?.id ?? "") });
        setShowForm(false);
      })
      .catch(error => {
        if (!["prosp_scope_changed", "prosp_stale_response", "crm_session_expired"].includes(error?.code)) {
          window.alert("Não foi possível salvar o contato — parece que houve uma falha de conexão. Confira sua internet e tente salvar novamente. Os dados preenchidos não foram perdidos.");
        }
      })
      .finally(() => setSaving(false));
  };

  const updateEntry = (id, changes) => {
    const item = (prospeccao||[]).find(p => String(p.id) === String(id));
    if (!item) return Promise.reject(new Error("O cartão de prospecção não está disponível neste escopo."));
    return onUpdateProsp(null, { patches:[{ id:item.id, storeId:item.storeId, changes }] });
  };

  const deleteEntry = (id) => {
    if (!window.confirm("Remover este contato da prospecção?")) return;
    return onUpdateProsp(null, { deleteIds:[id] });
  };

  // Confirmed sends reset the server's 48h response window. No browser-side
  // second/third attempt and no attempt counter.
  const handleSendProspMsg = (phone, text, user, quotedMsgId=null, storeContext=null, quotedMsg=null, retryMessage=null, transportOptions=null) => {
    const requestScope = getProspectWriteScope?.() ?? null;
    const requestIsCurrent = () => !getProspectWriteScope || requestScope === getProspectWriteScope();
    const result = sendProspMsg && sendProspMsg(phone, text, user, quotedMsgId, storeContext, quotedMsg, retryMessage, transportOptions);
    void Promise.resolve(result).then(sendResult => {
      if (!isConfirmedTextSend(sendResult) || !requestIsCurrent()) return;
      const sid = typeof storeContext === "object" ? storeContext?.responsibleStoreId || storeContext?.storeId : storeContext;
      const identity = conversationKey(sid || currentUser.storeId, phone);
      if (identity) onMarkRead?.(identity);
      notifyProspRefresh();
    }).catch(() => {});
    return result;
  };

  // Unique dates for navigation
  const dayList = prioritizeTextSendFailures(dayListBase, getTextSendAttempts());
  const allDates = [...new Set(minePeriodOnly.filter(p => matchesResponsavelFiltro(p, filters.consultantId)).map(p=>p.date))].sort((a,b)=>b>a?1:-1);

  const consultantName = id => USERS.find(u=>u.id===id)?.name.split(" ")[0]||"";

  return (
    <div>
      <div style={{ fontWeight:800, fontSize:20, color:T.text, marginBottom:4 }}>Prospecção Ativa</div>
      <div style={{ fontSize:13, color:T.muted, marginBottom:20 }}>
        Meta do mês: {MONTHLY_GOAL} contatos ({DAILY_GOAL}/dia × {workingDaysTotalP} dias úteis) · Acompanhe cada etapa
      </div>

      {/* Métricas do funil — acumulado do mês corrente */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(130px, 1fr))", gap:10, marginBottom:20 }}>
        {[
          { label:"Contatados",     value:monthContatados,   color:"#6366F1", icon:"📱", sub:`meta: ${MONTHLY_GOAL}`,                  filterFn:p=>true },
          { label:"Responderam",    value:monthRespondeu,    color:"#8B5CF6", icon:"💬", sub:`${monthPctResp}% dos contatados`,            filterFn:p=>["respondeu","interesse","venda","sem_interesse"].includes(p.stage) },
          { label:"Com Interesse",  value:monthInteresse,    color:"#F59E0B", icon:"✨", sub:`${monthPctInter}% dos que responderam`,      filterFn:p=>["interesse","venda"].includes(p.stage) },
          { label:"Fecharam Venda", value:monthVenda,        color:"#10B981", icon:"🏆", sub:`${monthPctVenda}% dos interessados`,         filterFn:p=>p.stage==="venda" },
          { label:"Sem Interesse",  value:monthSemInteresse, color:"#EF4444", icon:"🚫", sub:`${monthPctSemInter}% dos que responderam`,   filterFn:p=>p.stage==="sem_interesse" },
          { label:"Sem Resposta",   value:monthSemResposta,  color:"#9CA3AF", icon:"🔇", sub:`48h após o último envio confirmado`,        filterFn:p=>p.stage==="sem_resposta" },
        ].map(item => (
          <div key={item.label} onClick={()=>{
              const list = mesFiltered.filter(item.filterFn).map(p=>({
                id:p.id, name:p.name, phone:p.phone, consultant:consultantName(p.consultantId),
                store:STORES.find(s=>s.id===currentUser.storeId)?.name, origin:p.product, status:PROSP_STAGES.find(s=>s.id===p.stage)?.label||p.stage,
                createdAt:p.date||p.createdAt, lastInteraction:p.date||p.createdAt, value:p.value,
                actionLabel:"Abrir conversa", onAction:()=>{ noteConversationSelection(p.storeId || currentUser.storeId, normalizePhone(p.phone || p.telefone)); setChatOpenId(p.id); },
              }));
              setDrillDown({ title:item.label, items:list, period:"Este mês" });
            }}
            style={{ background:"#fff", borderRadius:14, padding:"14px 16px", boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderLeft:`4px solid ${item.color}`, cursor:"pointer" }}
            onMouseEnter={e=>e.currentTarget.style.transform="translateY(-2px)"}
            onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}
          >
            <div style={{ fontSize:20, marginBottom:2 }}>{item.icon}</div>
            <div style={{ fontSize:22, fontWeight:800, color:item.color }}>{item.value}</div>
            <div style={{ fontSize:11, color:T.muted, marginTop:2 }}>{item.label}</div>
            <div style={{ fontSize:10, color:item.color, fontWeight:700, marginTop:3 }}>{item.sub}</div>
          </div>
        ))}
      </div>
      {drillDown && <DrillDownModal {...drillDown} onClose={()=>setDrillDown(null)} />}

      {/* Funil visual — mês corrente */}
      {monthContatados > 0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
          <div style={{ fontWeight:700, fontSize:14, color:T.text, marginBottom:16 }}>📊 Funil de Conversão — {monthKeyP}</div>
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {[
              { label:"Contatados",     value:monthContatados,   total:monthContatados, color:"#6366F1", icon:"📱", pctLabel:`100% (base)` },
              { label:"Responderam",    value:monthRespondeu,    total:monthContatados, color:"#8B5CF6", icon:"💬", pctLabel:`${monthPctResp}% dos contatados` },
              { label:"Tiveram Interesse", value:monthInteresse, total:monthRespondeu||1, color:"#F59E0B", icon:"✨", pctLabel:`${monthPctInter}% dos que responderam` },
              { label:"Fecharam Venda", value:monthVenda,        total:monthInteresse||1, color:"#10B981", icon:"🏆", pctLabel:`${monthPctVenda}% dos interessados · ${monthPctFinal}% do total` },
              { label:"Sem Interesse",  value:monthSemInteresse, total:monthRespondeu||1, color:"#EF4444", icon:"🚫", pctLabel:`${monthPctSemInter}% dos que responderam` },
            ].map((item,i) => {
              const barW = monthContatados>0 ? Math.round((item.value/monthContatados)*100) : 0;
              return (
                <div key={item.label}>
                  <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                    <span style={{ fontSize:12, fontWeight:700, color:item.color }}>{item.icon} {item.label}</span>
                    <span style={{ fontSize:12, color:T.muted }}><strong style={{ color:item.color }}>{item.value}</strong> · {item.pctLabel}</span>
                  </div>
                  <div style={{ background:T.sandDark, borderRadius:99, height:14, overflow:"hidden" }}>
                    <div style={{ width:`${barW}%`, height:"100%", background:`linear-gradient(90deg,${item.color},${item.color}bb)`, borderRadius:99, transition:"width 0.5s", display:"flex", alignItems:"center", paddingLeft:6, minWidth:barW>0?24:0 }}>
                      {barW>8 && <span style={{ fontSize:9, color:"#fff", fontWeight:700 }}>{barW}%</span>}
                    </div>
                  </div>
                  {i < 3 && <div style={{ fontSize:10, color:T.muted, textAlign:"right", marginTop:2 }}>↓</div>}
                </div>
              );
            })}
          </div>

          {/* Barra meta mensal acumulada */}
          <div style={{ marginTop:16, paddingTop:16, borderTop:`1px solid ${T.sandDark}` }}>
            <ProgressBar
              value={monthContatados} max={MONTHLY_GOAL}
              color={monthContatados>=MONTHLY_GOAL?T.positive:T.accent}
              label={`${monthContatados} de ${MONTHLY_GOAL} contatos no mês (${monthPctGoal}%)`}
              motivational={monthContatados>=MONTHLY_GOAL?"🎉 Meta mensal de prospecção batida!":`💬 Faltam ${MONTHLY_GOAL-monthContatados} contatos pra bater a meta do mês`}
            />
            <div style={{ fontSize:11, marginTop:6, fontWeight:700, color: monthPace==="no-ritmo" ? T.positive : "#F59E0B" }}>
              {monthPace==="no-ritmo"
                ? `✅ No ritmo — esperado até hoje: ${monthGoalExpectedToday} (${workingDaysSoFarP} dias úteis)`
                : `⚠️ Abaixo do ritmo — esperado até hoje: ${monthGoalExpectedToday} (${workingDaysSoFarP} dias úteis)`}
            </div>
          </div>
        </div>
      )}

      {/* Resumo por consultor: contatados, vendas e conversão originada da prospecção — sempre do mesmo grupo filtrado */}
      {isManagerOrAdminP && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
          <div style={{ fontWeight:700, fontSize:14, color:T.text, marginBottom:12 }}>🧑‍💼 Resumo por Consultor — {periodLabelText(effFiltersP, "")}</div>
          <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
            {prospRanking.map(r => (
              <div key={r.id} style={{ display:"flex", alignItems:"center", gap:10, background:"#F8FAFC", border:`1px solid ${T.sandDark}`, borderRadius:10, padding:"8px 12px", flexWrap:"wrap" }}>
                <div style={{ flex:"1 1 120px", fontWeight:700, fontSize:12.5, color:T.text }}>{r.name.split(" ")[0]}</div>
                <div onClick={()=>r.contatados>0 && setDrillDown({ title:`Contatados — ${r.name.split(" ")[0]}`, period:periodLabelText(effFiltersP, ""), items:r.contatadosList.map(p=>({
                    id:p.id, name:p.name, phone:p.phone, consultant:r.name.split(" ")[0], origin:p.product, status:PROSP_STAGES.find(s=>s.id===p.stage)?.label||p.stage,
                    createdAt:p.date||p.createdAt, lastInteraction:p.date||p.createdAt, value:p.value,
                    actionLabel:"Abrir conversa", onAction:()=>{ noteConversationSelection(p.storeId || currentUser.storeId, normalizePhone(p.phone || p.telefone)); setChatOpenId(p.id); },
                  })) })} style={{ cursor:r.contatados>0?"pointer":"default", fontSize:12, color:"#6366F1" }}>📱 {r.contatados} contatado{r.contatados!==1?"s":""}</div>
                <div onClick={()=>r.vendas>0 && setDrillDown({ title:`Vendas — ${r.name.split(" ")[0]}`, period:periodLabelText(effFiltersP, ""), items:r.vendasList.map(p=>({
                    id:p.id, name:p.name, phone:p.phone, consultant:r.name.split(" ")[0], origin:p.product, status:PROSP_STAGES.find(s=>s.id===p.stage)?.label||p.stage,
                    createdAt:p.date||p.createdAt, lastInteraction:p.date||p.createdAt, value:p.value,
                    actionLabel:"Abrir conversa", onAction:()=>{ noteConversationSelection(p.storeId || currentUser.storeId, normalizePhone(p.phone || p.telefone)); setChatOpenId(p.id); },
                  })) })} style={{ cursor:r.vendas>0?"pointer":"default", fontSize:12, color:"#10B981" }}>🏆 {r.vendas} venda{r.vendas!==1?"s":""}</div>
                <div style={{ fontSize:12, fontWeight:700, color:"#F59E0B" }}>📊 {r.conv}%</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <FilterBar
        filters={filters}
        setFilters={setFilters}
        consultants={isManagerOrAdminP ? storeConsultantsP : null}
        showConsultant={isManagerOrAdminP}
        showStatus={false}
        hidePeriod={false}
        showSearch
        searchValue={searchQuery}
        onSearchChange={setSearchQuery}
      />

      {/* Seletor de data + botão novo */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, flexWrap:"wrap", gap:10 }}>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <div style={{ fontWeight:700, fontSize:15, color:T.text }}>
            {filterDate ? `Contatos de ${filterDate}` : "Todos os contatos"} <span style={{ fontWeight:400, fontSize:13, color:T.muted }}>({dayList.length})</span>
          </div>
          <input type="date" value={filterDate} onChange={e=>setFilterDate(e.target.value)} style={{ padding:"6px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13 }} />
          {filterDate && (
            <button onClick={()=>setFilterDate("")} title="Mostrar todos" style={{ background:"#EF4444", color:"#fff", border:"none", borderRadius:8, padding:"5px 10px", fontSize:11, fontWeight:700, cursor:"pointer" }}>✕ Todos</button>
          )}
        </div>
        <button onClick={()=>setShowForm(v=>!v)} style={{ background:`linear-gradient(135deg,${T.accent},${T.accentLight})`, color:"#fff", border:"none", borderRadius:10, padding:"8px 18px", fontWeight:700, cursor:"pointer", fontSize:13 }}>
          {showForm ? "✕ Cancelar" : "+ Novo Contato"}
        </button>
      </div>

      {/* Formulário de novo contato */}
      {showForm && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", border:`2px solid ${T.accent}44` }}>
          <div style={{ fontWeight:700, fontSize:14, marginBottom:14 }}>Novo Contato de Prospecção</div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
            {[["Nome completo","name","text"],["Telefone","phone","tel"]].map(([label,key,type]) => (
              <div key={key}>
                <div style={{ fontSize:11, color:T.muted, marginBottom:4 }}>{label}</div>
                <input type={type} value={newP[key]} onChange={e=>setF(key,e.target.value)} style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box" }} />
              </div>
            ))}
          </div>
          <div style={{ marginBottom:10 }}>
            <div style={{ fontSize:11, color:T.muted, marginBottom:4 }}>Consultor Responsável</div>
            {currentUser.role==="consultant" ? (
              <div style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box", background:"#F3EFE6", color:T.muted }}>
                {currentUser.name} <span style={{ fontSize:11 }}>(você — quem inicia o contato é o responsável)</span>
              </div>
            ) : (
              <select value={newP.consultantId} onChange={e=>setF("consultantId", Number(e.target.value))} style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, background:"#fff" }}>
                {storeConsultantsP.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
              </select>
            )}
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:10 }}>
            <div>
              <div style={{ fontSize:11, color:T.muted, marginBottom:4 }}>Produto de interesse</div>
              <input value={newP.product} onChange={e=>setF("product",e.target.value)} placeholder="Ex: sofá king" style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box" }} />
            </div>
            <div>
              <div style={{ fontSize:11, color:T.muted, marginBottom:4 }}>Valor orçado (R$)</div>
              <input type="number" value={newP.value} onChange={e=>setF("value",e.target.value)} placeholder="0" style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box" }} />
            </div>
            <div>
              <div style={{ fontSize:11, color:T.muted, marginBottom:4 }}>Etapa inicial</div>
              <select value={newP.stage} onChange={e=>setF("stage",e.target.value)} style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, background:"#fff" }}>
                {PROSP_STAGES.filter(s => canManuallyRegisterSale(currentUser)
                  || s.id !== "venda")
                  .map(s=><option key={s.id} value={s.id}>{s.icon} {s.label}</option>)}
              </select>
            </div>
          </div>
          <div style={{ marginBottom:14 }}>
            <div style={{ fontSize:11, color:T.muted, marginBottom:4 }}>📅 Data do atendimento</div>
            <input type="date" value={newP.visitDate||today} max={today} onChange={e=>setF("visitDate", e.target.value > today ? today : e.target.value)} style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box" }} />
          </div>
          <div style={{ marginBottom:14 }}>
            <div style={{ fontSize:11, color:T.muted, marginBottom:4 }}>💬 O que o cliente disse? (observação)</div>
            <textarea value={newP.observation} onChange={e=>setF("observation",e.target.value)} rows={2} placeholder="Ex: Vai ver com o marido, vai pensar, ligou perguntando sobre promoção..." style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.sandDark}`, fontSize:13, resize:"vertical", boxSizing:"border-box" }} />
          </div>
          <button onClick={addProsp} disabled={saving} style={{ width:"100%", background:saving?"#ccc":`linear-gradient(135deg,${T.accent},${T.accentLight})`, color:"#fff", border:"none", borderRadius:8, padding:"10px", fontWeight:700, cursor:saving?"default":"pointer", fontSize:14 }}>
            {saving ? "Salvando..." : "Adicionar Contato"}
          </button>
        </div>
      )}

      {nuProsp && gerenciaFila && <PlacarTombamento theme={T} placar={nuPlacar.placar} erro={nuPlacar.erro} />}
      {nuProsp && ativaFila && nuFila.fila?.deferredCount > 0 && (
        <div role="status" style={{ color:T.muted, fontSize:13, marginBottom:10 }}>
          {nuFila.fila.deferredCount} contato(s) preservado(s) para os próximos dias.
          A fila de hoje respeita sua cota total; concluir contatos não adiciona novos no mesmo dia.
        </div>
      )}
      {nuProsp && ativaFila && !filaReadOnly && papelFila === "consultant" && (
        <JustificativaTombamento theme={T} justificarDe={nuFila.fila?.justificarDe} motivos={nuFila.fila?.motivos} onSalvo={nuFila.recarregar} />
      )}
      {nuProsp && (
        <div style={{ color:T.muted, fontSize:12, marginBottom:10 }}>
          Contatos em andamento e retornos permanecem no quadro, independentemente da data de entrada ou da busca. A busca também consulta o histórico desta visão.
        </div>
      )}
      {nuProsp && (
        <ProspKanban theme={T} stages={PROSP_STAGES} items={dayList} returnsDue={returnsDue} today={today}
          isAwaiting={p => isUnansweredProsp(p)}
          unreadCount={p => {
            const phoneKey = normalizePhone(p.phone);
            const identity = conversationKey(p.storeId, phoneKey);
            const pMsgs = getWaMsgsForPhone(whatsappMsgs, phoneKey, p.storeId) || {};
            const eventCount = unreadPushLookup?.get(`prospeccao:${identity}`) || 0;
            return prospectUnreadCount(pMsgs, lastReadAt[identity], eventCount);
          }}
          consultantName={consultantName} showConsultant={currentUser.role!=="consultant"}
          onOpen={p => { noteConversationSelection(p.storeId || currentUser.storeId, normalizePhone(p.phone || p.telefone)); setChatOpenId(p.id); if(onMarkRead) onMarkRead(conversationKey(p.storeId, p.phone)); }}
          listOpen={nuShowList} onToggleList={() => setNuShowList(v => !v)}
          fila={ativaFila ? nuFila : null}
          filaReadOnly={filaReadOnly}
          openingFilaItemId={nuAbrindoFilaId}
          onOpenFilaItem={!filaReadOnly && papelFila === "consultant" ? async (it) => {
            if (nuAbrindoFila.current) return;
            let existente;
            try {
              existente = resolveDailyQueueProspect(prospeccao, it, {
                storeId:operadorFila.storeId, consultantId:operadorFila.id, normalizePhone,
              });
            } catch (error) {
              window.alert(error.message);
              return;
            }
            if (existente) { setChatOpenId(existente.id); return; }
            nuAbrindoFila.current = true;
            setNuAbrindoFilaId(String(it.id));
            try {
              // ID generation can fail on an unsupported browser. It must be
              // inside finally's boundary or every later queue click stays locked.
              const entry = { name:it.nome || "Cliente", phone:it.telefone, product:it.produto || "", value:0, observation:it.motivo || "",
                stage:"contatado", visitDate:today, consultantId:operadorFila.id, storeId:operadorFila.storeId,
                id:createProspectId(), date:today, createdAt:today, origemTombamento:{ data:nuFila.fila?.data || today, itemId:it.id, fonte:it.fonte } };
              const results = await Promise.resolve(onUpdateProsp([entry]));
              const confirmed = firstConfirmedProspectWrite(results);
              if (!confirmed || confirmed.stale || !confirmed.record) return;
              setChatOpenId(confirmed.record.id);
            } catch (error) {
              if (!["prosp_scope_changed", "prosp_stale_response", "crm_session_expired"].includes(error?.code)) {
                window.alert(error.message || "Não foi possível abrir este cliente. Confira a internet e tente de novo.");
              }
            } finally {
              nuAbrindoFila.current = false;
              setNuAbrindoFilaId(null);
            }
          } : null}
          onMarcarLiguei={!filaReadOnly && papelFila === "consultant" ? async (idx) => {
            if (!window.confirm("Marcar este cliente como feito por ligação?")) return;
            try {
              const r = await fetch("/api/prospeccao/fila/feito", { method:"POST", credentials:"same-origin", headers:{ "Content-Type":"application/json" }, body:JSON.stringify({ idx, como:"ligacao" }) });
              const proof = await r.json();
              if (!r.ok) throw new Error(proof.error || "Não foi possível gravar.");
              nuFila.confirmarFeito(proof);
              notifyProspRefresh();
            } catch { window.alert("Não foi possível marcar. Tente de novo."); }
          } : null} />
      )}
      {/* Lista de contatos do dia */}
      <div style={{ background:"#fff", borderRadius:14, padding:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", display: nuProsp && !nuShowList ? "none" : undefined }}>
        <div style={{ fontWeight:700, fontSize:14, marginBottom:14, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <span>Contatos de {filterDate} ({dayList.length})</span>
          {allDates.length > 1 && (
            <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
              {allDates.slice(0,5).map(d => (
                <button key={d} onClick={()=>setFilterDate(d)} style={{ background:filterDate===d?T.accent:"#fff", color:filterDate===d?"#fff":T.text, border:`1px solid ${T.accent}`, borderRadius:8, padding:"3px 10px", fontSize:11, cursor:"pointer", fontWeight:600 }}>{d}</button>
              ))}
            </div>
          )}
        </div>

        {dayList.length===0 && (
          <div style={{ color:T.muted, fontSize:13, textAlign:"center", padding:"20px 0" }}>
            {filterDate===today ? "Nenhuma prospecção registrada hoje. Comece adicionando contatos!" : "Nenhuma prospecção nesta data."}
          </div>
        )}

        {dayList.map((p, idx) => {
          const stage = PROSP_STAGES.find(s=>s.id===p.stage)||PROSP_STAGES[0];
          const isEditing = editingId===p.id;
          const phoneKey = normalizePhone(p.phone);
          const identity = conversationKey(p.storeId, phoneKey);
          const pMsgs = getWaMsgsForPhone(whatsappMsgs, phoneKey, p.storeId) || {};
          const unread = prospectUnreadCount(pMsgs, lastReadAt[identity]);
          const eventCount = unreadPushLookup?.get(`prospeccao:${identity}`) || 0;
          const effectiveUnread = Math.max(unread, eventCount);
          const showDayHeader = !filterDate && (idx===0 || (p.date||p.createdAt) !== (dayList[idx-1].date||dayList[idx-1].createdAt));
          return (
            <Fragment key={p.id}>
            {showDayHeader && (
              <div style={{ fontSize:11, fontWeight:800, color:T.muted, textTransform:"uppercase", letterSpacing:0.5, margin:"10px 0 2px" }}>
                {dayGroupLabel(p.date||p.createdAt)}
              </div>
            )}
            <div aria-label={eventCount ? `${p.name}, ${effectiveUnread} item${effectiveUnread>1?"s":""} não visualizado${effectiveUnread>1?"s":""}, incluindo ${eventCount} notificação${eventCount>1?"ões":""}` : undefined} title={eventCount ? `${eventCount} notificação${eventCount>1?"ões":""} do CRM não visualizada${eventCount>1?"s":""}` : undefined} style={{ padding:"14px 14px 14px 12px", borderBottom:`1px solid ${T.sandDark}`, borderLeft:isUnansweredProsp(p)?"4px solid #EF4444":eventCount?"4px solid #F59E0B":"4px solid transparent", background:isUnansweredProsp(p)?"#FEF2F2":eventCount?"#FFFBEB":"transparent" }}>
              {!isEditing ? (
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:8, flexWrap:"wrap" }}>
                  <div style={{ flex:1, minWidth:160 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4, flexWrap:"wrap" }}>
                      <div style={{ fontWeight:700, fontSize:14, color:T.text }}>{p.name}</div>
                      <TextSendStatus storeId={p.storeId} phone={p.phone} />
                      <span style={{ background:stage.color+"22", color:stage.color, border:`1px solid ${stage.color}44`, borderRadius:20, padding:"2px 10px", fontSize:11, fontWeight:700 }}>
                        {stage.icon} {stage.label}
                      </span>
                      {isUnansweredProsp(p) && (
                        <span style={{ background:"#EF4444", color:"#fff", borderRadius:99, padding:"2px 9px", fontSize:10, fontWeight:800 }}>🔴 Aguardando resposta</span>
                      )}
                      {currentUser.role!=="consultant" && <span style={{ fontSize:10, color:T.muted }}>👤 {consultantName(p.consultantId)}</span>}
                    </div>
                    <div style={{ fontSize:11, color:T.muted }}>
                      {p.phone&&<span>📱 {p.phone} · </span>}
                      <span>🛋 {p.product}</span>
                      {p.value>0&&<span> · 💰 {fmt(p.value)}</span>}
                    </div>
                    {p.observation && (
                      <div style={{ fontSize:11, color:T.text, marginTop:6, background:T.sand, borderRadius:8, padding:"6px 10px", fontStyle:"italic" }}>
                        💬 "{p.observation}"
                      </div>
                    )}
                  </div>
                  <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                    {/* Avançar etapa */}
                    {currentUser.role==="consultant" && (
                      <>
                        {PROSP_STAGES_SEQUENCE.map((s,i) => {
                          const currIdx = PROSP_STAGES_SEQUENCE.findIndex(ss=>ss.id===p.stage);
                          const isNext = i === currIdx+1;
                          if (!isNext) return null;
                          if (s.id === "venda") {
                            return (
                              <ManualSaleAction key={s.id} currentUser={currentUser}
                                onClick={()=>onRegistrarVenda && onRegistrarVenda(createSaleTarget("prospeccao", p, currentUser?.storeId, null))}
                                style={{ background:s.color, color:"#fff", border:"none", borderRadius:8, padding:"5px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}
                                noticeStyle={{ background:"#FEF9F0", border:"1px solid #D4C5A9", borderRadius:8, padding:"5px 8px", maxWidth:250 }} >
                                → {s.icon} {s.label}
                              </ManualSaleAction>
                            );
                          }
                          return (
                            <button key={s.id} onClick={()=>updateEntry(p.id,{stage:s.id})} style={{ background:s.color, color:"#fff", border:"none", borderRadius:8, padding:"5px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>
                              → {s.icon} {s.label}
                            </button>
                          );
                        })}
                        <button onClick={()=>{ setEditingId(p.id); }} style={{ background:T.sandDark, color:T.text, border:"none", borderRadius:8, padding:"5px 10px", fontSize:11, cursor:"pointer" }}>✏️</button>
                        <button onClick={()=>deleteEntry(p.id)} style={{ background:"none", border:"none", color:"#EF4444", cursor:"pointer", fontSize:14, padding:"0 4px" }}>🗑</button>
                      </>
                    )}
                    {currentUser.role!=="consultant" && (
                      <div style={{ display:"flex", gap:4 }}>
                        {PROSP_STAGES.filter(s => canManuallyRegisterSale(currentUser)
                          || s.id !== "venda" || p.stage === "venda").map(s => (
                          <span key={s.id} style={{ background:p.stage===s.id?s.color:T.sandDark, color:p.stage===s.id?"#fff":T.muted, borderRadius:99, padding:"3px 8px", fontSize:10, fontWeight:700 }}>
                            {s.icon}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                /* Modo edição */
                <div style={{ background:T.sand, borderRadius:10, padding:14 }}>
                  <div style={{ fontWeight:700, fontSize:13, marginBottom:10, color:T.text }}>Editando: {p.name}</div>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
                    <div>
                      <div style={{ fontSize:10, color:T.muted, marginBottom:3 }}>Nome</div>
                      <input defaultValue={p.name} id={`edit-name-${p.id}`} style={{ width:"100%", padding:"6px 10px", borderRadius:6, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box" }} />
                    </div>
                    <div>
                      <div style={{ fontSize:10, color:T.muted, marginBottom:3 }}>Telefone</div>
                      <input defaultValue={p.phone} id={`edit-phone-${p.id}`} style={{ width:"100%", padding:"6px 10px", borderRadius:6, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box" }} />
                    </div>
                    <div>
                      <div style={{ fontSize:10, color:T.muted, marginBottom:3 }}>Produto</div>
                      <input defaultValue={p.product} id={`edit-product-${p.id}`} placeholder="Ex: sofá king" style={{ width:"100%", padding:"6px 10px", borderRadius:6, border:`1px solid ${T.sandDark}`, fontSize:13, boxSizing:"border-box" }} />
                    </div>
                    <div>
                      <div style={{ fontSize:10, color:T.muted, marginBottom:3 }}>Etapa</div>
                      <LiftSaleStageSelect moduleId="prospeccao" record={p} saleStage="venda"
                        defaultValue={p.stage} options={PROSP_STAGES} id={`edit-stage-${p.id}`}
                        style={{width:"100%",padding:"6px 10px",borderRadius:6,border:`1px solid ${T.sandDark}`,fontSize:13,background:"#fff"}}/>
                    </div>
                  </div>
                  <div style={{ marginBottom:10 }}>
                    <div style={{ fontSize:10, color:T.muted, marginBottom:3 }}>💬 Observação</div>
                    <textarea defaultValue={p.observation} id={`edit-obs-${p.id}`} rows={2} style={{ width:"100%", padding:"6px 10px", borderRadius:6, border:`1px solid ${T.sandDark}`, fontSize:13, resize:"vertical", boxSizing:"border-box" }} />
                  </div>
                  <div style={{ display:"flex", gap:8 }}>
                    <button onClick={() => {
                      updateEntry(p.id, {
                        name:    document.getElementById(`edit-name-${p.id}`).value,
                        phone:   document.getElementById(`edit-phone-${p.id}`).value,
                        product: document.getElementById(`edit-product-${p.id}`).value,
                        stage:   document.getElementById(`edit-stage-${p.id}`).value,
                        observation: document.getElementById(`edit-obs-${p.id}`).value,
                      });
                      setEditingId(null);
                    }} style={{ background:T.positive, color:"#fff", border:"none", borderRadius:8, padding:"7px 16px", fontWeight:700, fontSize:13, cursor:"pointer" }}>Salvar</button>
                    <button onClick={()=>setEditingId(null)} style={{ background:T.sandDark, color:T.text, border:"none", borderRadius:8, padding:"7px 12px", fontSize:13, cursor:"pointer" }}>Cancelar</button>
                  </div>
                </div>
              )}
              {p.stage === "contatado" && p.responseWindow?.status === "active" && (
                <div style={{ marginTop:8, background:"#F9FAFB", border:"1px solid #E5E7EB", borderRadius:8, padding:"8px 10px" }}>
                  <span style={{ fontSize:11, color:"#6B7280", fontWeight:600 }}>
                    Aguardando resposta até {new Date(p.responseWindow.lastOutboundAt ? Date.parse(p.responseWindow.lastOutboundAt) + 48 * 60 * 60 * 1000 : p.responseWindow.deadlineAt).toLocaleString("pt-BR", { timeZone:"America/Sao_Paulo" })}. Sem segunda tentativa automática.
                  </span>
                </div>
              )}
              {/* Abrir conversa completa */}
              <div style={{ marginTop:8, display:"flex", justifyContent:"flex-end", gap:8 }}>
                <button
                  onClick={()=>{ noteConversationSelection(p.storeId || currentUser.storeId, normalizePhone(p.phone || p.telefone)); setChatOpenId(p.id); if(onMarkRead) onMarkRead(conversationKey(p.storeId, p.phone)); }}
                  style={{ background:T.navy, color:"#fff", border:"none", borderRadius:8, padding:"5px 12px", fontSize:11, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", gap:5 }}
                >
                  💬 Abrir conversa
                  {effectiveUnread>0&&<span style={{ background:unread>0?"#EF4444":"#F59E0B", color:"#fff", borderRadius:99, padding:"1px 6px", fontSize:9, fontWeight:800 }}>{effectiveUnread}</span>}
                </button>
              </div>
            </div>
            </Fragment>
          );
        })}
      </div>
      {chatOpenId!=null && (() => {
        const activeP = findProspectSelection(prospeccao, chatOpenId);
        if (!activeP) return null;
        const phoneKey = normalizePhone(activeP.phone);
        const activeMsgs = getWaMsgsForPhone(whatsappMsgs, phoneKey, activeP.storeId)||{};
        return (
          <ProspConversationModal
            p={activeP}
            messages={activeMsgs}
            currentUser={currentUser}
            sendProspMsg={handleSendProspMsg}
            sendZapiMedia={sendZapiMedia}
            onMarkRead={onMarkRead}
            updateEntry={updateEntry}
            onAddReminder={onAddReminder}
            isManagerOrAdmin={isManagerOrAdminP}
            storeConsultants={storeConsultantsP}
            onRegistrarVenda={onRegistrarVenda}
            onClose={()=>{
              const diagnostic = closingDiagnostic();
              diagnosticMark(diagnostic, "close_callback");
              setChatOpenId(null); setNuShowList(true);
              if (nuProsp && currentUser.role === "consultant") nuFila.recarregar();
              observeListFrame(diagnostic, "list_visible");
            }}
          />
        );
      })()}
    </div>
  );
}

// Ranking de consultores — SEMPRE calculado a partir do Período Global (nunca de lógica de data própria).
function computeConsultantRanking({ storeConsultants, storeClients, leads = [], prospeccao = [], liftSales=[], storeId, periodRange, realSales = {} }) {
  return storeConsultants
    .map(c => {
      const attendedList = storeClients.filter(cl => Number(cl.consultantId)===Number(c.id) && inPeriod(cl.createdAt, periodRange));
      // A mesma fonte canônica de faturamento alimenta Dashboard, ranking e relatórios.
      const breakdown = redactConsultantCrossStoreSales(computeDashboardRevenueBreakdown({
        clients:storeClients, periodRange, storeId:null, consultantId:c.id, consultantAcrossStores:true, liftSales,
      }), storeId);
      return {
        ...c,
        attendedList,
        clientCount: attendedList.length,
        sold: breakdown.totalValue,
        salesList: breakdown.sales,
      };
    })
    .sort((a,b)=>b.sold-a.sold);
}

function ConsultantRankingCard({ store, ranking, periodLabel, onDrillSold, onViewAs }) {
  const th = THEMES[store.id] || T_DEMO;
  return (
    <div>
      <div style={{ fontSize:13, fontWeight:700, color:th.muted, marginBottom:10 }}>🏆 Ranking de Consultores {periodLabel ? `— ${periodLabel}` : ""}</div>
      <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}>
        {ranking.map((c,i) => {
          const medal = i===0?"🥇":i===1?"🥈":i===2?"🥉":"👤";
          const p = pct(c.sold, store.consultantGoal);
          return (
            <div key={c.id} style={{ background:th.sand, borderRadius:12, padding:"12px 16px", minWidth:160, flex:"1 1 160px" }}>
              <div style={{ fontWeight:700, fontSize:14 }}>{medal} {c.name}</div>
              <div onClick={()=>onDrillSold && onDrillSold(c)} style={{ fontSize:18, fontWeight:800, color:th.accent, marginTop:4, cursor:onDrillSold?"pointer":"default" }}>{fmt(c.sold)}</div>
              <div style={{ fontSize:11, color:th.muted }}>{c.clientCount} cliente{c.clientCount!==1?"s":""} atendido{c.clientCount!==1?"s":""} · meta {p}%</div>
              <div style={{ background:th.sandDark, borderRadius:99, height:6, marginTop:6, overflow:"hidden" }}>
                <div style={{ width:`${Math.min(p,100)}%`, height:"100%", background:p>=75?th.positive:th.accent, borderRadius:99 }} />
              </div>
              {onViewAs && (
                <button onClick={() => onViewAs(c.id)} style={{ marginTop:10, width:"100%", background:th.accent, color:"#fff", border:"none", borderRadius:8, padding:"6px", fontSize:11, fontWeight:700, cursor:"pointer" }}>
                  👁 Ver como {c.name.split(" ")[0]}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}


export function AdminView({ clients, leads = [], prospeccao = [], users, onViewAs, onCloseMonth, realSales = {}, selectedMonth, onSelectMonth, loggedInUser, onUpdateClient, onDeleteClient, onAddReminder, onSendZapi, onSendZapiMedia, whatsappMsgs, onReturnToAurora, onRegistrarVenda, onOpenLead, onOpenProsp, onConversationActive }) {
  const goalStores=useMonthlyGoalStores(getActiveStores(),selectedMonth||currentDateKeySaoPaulo().slice(0,7));
  const monthlyGoals=useMonthlyGoals();
  const { commercialSales:liftSales, commercialError, commercialLoaded } = useContext(LiftPendingContext);
  const [cleaning, setCleaning] = useState(false);
  const [cleanResult, setCleanResult] = useState(null);
  const [passwordResetOpen, setPasswordResetOpen] = useState(false);
  const [dailySettingsOpen,setDailySettingsOpen]=useState(false);
  const [drillDown, setDrillDown] = useState(null);
  const [selected, setSelected] = useState(null);
  const [expandedStoreId, setExpandedStoreId] = useState(null);
  const [filters, setFilters] = useScreenPeriodFilters("admin", DEFAULT_FILTERS);
  const periodRangeAdm = getPeriodRange(filters.period, filters.customFrom, filters.customTo);
  const periodLabelAdm = periodLabelText(filters);
  const canResetPasswords = loggedInUser?.role === 'admin';
  const adminClientToItem = (c) => ({
    id:c.id, name:c.name, phone:c.phone, consultant:users.find(u=>u.id===c.consultantId)?.name.split(" ")[0],
    store:STORES.find(s=>s.id===(c.storeId||1))?.name, origin:c.origin, status:STAGES.find(s=>s.id===c.stage)?.label||c.stage,
    createdAt:c.createdAt, lastInteraction:(c.stageDates||{})[c.stage]||c.createdAt, value:c.value, followUp:c.followUp,
    actionLabel:"Ver ficha", onAction:()=>{ setDrillDown(null); setSelected(c); },
  });
  const saleToItemAdmin = sale => saleToDrillItem(sale, {
    onOpenClient:client => { setDrillDown(null); setSelected(client); },
    onOpenLead:lead => { setDrillDown(null); onOpenLead?.(lead); },
    onOpenProsp:prospect => { setDrillDown(null); onOpenProsp?.(prospect); },
  });

  const clientsInPeriod = clients.filter(c => inPeriod(c.createdAt, periodRangeAdm));
  const SPECIAL_STAGES_ADM = ["closed","posVenda","nextSale","semInteresse"];
  // Indicadores comerciais sempre vêm do livro compartilhado: Lead, Prospecção
  // e fichas de Atendimento contam uma única vez, na data real do fechamento.
  const commercialSalesAdm = computeDashboardRevenueBreakdown({ clients, periodRange:periodRangeAdm, liftSales });
  const totalAtendidosAdm  = clientsInPeriod.length;
  const totalOrcamentosAdm = clientsInPeriod.filter(c=>c.stage==="msg_sent").length;
  const totalNegociacaoAdm = clientsInPeriod.filter(c=>c.stage==="final").length;
  const totalFollowupAdm   = clientsInPeriod.filter(c=>c.followUp && !SPECIAL_STAGES_ADM.includes(c.stage)).length;
  const totalFechadosAdm   = commercialSalesAdm.totalQtd;
  const totalPerdidosAdm   = clientsInPeriod.filter(c=>c.stage==="semInteresse").length;
  const totalValorAdm      = commercialSalesAdm.totalValue;
  const conversaoAdm       = totalAtendidosAdm>0 ? Math.round(totalFechadosAdm/totalAtendidosAdm*100) : 0;

  const kvMetricsAdm = [
    { label:"Atendidos",           value:totalAtendidosAdm,  color:"#6366F1", icon:"👥", list:clientsInPeriod },
    { label:"Orçamentos enviados", value:totalOrcamentosAdm, color:"#0EA5E9", icon:"📄", list:clientsInPeriod.filter(c=>c.stage==="msg_sent") },
    { label:"Em Negociação",       value:totalNegociacaoAdm, color:"#A07830", icon:"🔔", list:clientsInPeriod.filter(c=>c.stage==="final") },
    { label:"Follow-up",           value:totalFollowupAdm,   color:"#F59E0B", icon:"📅", list:clientsInPeriod.filter(c=>c.followUp && !SPECIAL_STAGES_ADM.includes(c.stage)) },
    { label:"Vendas comerciais",  value:totalFechadosAdm,   color:"#22C55E", icon:"✅", list:commercialSalesAdm.sales, saleItems:true },
    { label:"Perdidos",            value:totalPerdidosAdm,   color:"#EF4444", icon:"🚫", list:clientsInPeriod.filter(c=>c.stage==="semInteresse") },
    { label:"Conversão",           value:`${conversaoAdm}%`, color:"#14B8A6", icon:"📊", list:commercialSalesAdm.sales, saleItems:true },
    { label:"Vendido (comercial)", value:fmt(totalValorAdm), color:"#D97706", icon:"💰", list:commercialSalesAdm.sales, saleItems:true },
  ];

  const handleCleanup = async () => {
    if (!window.confirm("Limpar histórico de mensagens antigas? Mantém apenas as últimas 150 mensagens por contato. Use caso o sistema esteja lento ou travando.")) return;
    setCleaning(true); setCleanResult(null);
    try {
      const r = await fetch('/api/cleanup-wa-messages', { method:'POST' });
      const data = await r.json();
      setCleanResult(data.ok
        ? `✅ Limpeza concluída: ${data.deleted} msgs removidas em ${data.phones} telefones`
        : `❌ Erro: ${data.error}`);
    } catch(e) { setCleanResult('❌ Erro de conexão'); }
    setCleaning(false);
  };

  return (
    <div>
      <MonthlyGoalsEditor defaultMonth={selectedMonth||currentDateKeySaoPaulo().slice(0,7)}
        stores={getActiveStores()} canEdit={!_demoMode&&["admin","superadmin"].includes(loggedInUser?.role)}
        onSaved={monthlyGoals.saved}/>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20, flexWrap:"wrap", gap:12 }}>
        <div>
          <div style={{ fontWeight:800, fontSize:20, color:T.text, marginBottom:4 }}>Visão Administrativa</div>
          <div style={{ fontSize:13, color:T.muted }}>Todas as lojas · dados em tempo real</div>
        </div>
        <div style={{ display:"flex", gap:8, flexWrap:"wrap", alignItems:"flex-start" }}>
           {canResetPasswords && <button onClick={()=>setPasswordResetOpen(true)} style={{ background:"linear-gradient(135deg,#4F46E5,#3730A3)", color:"#fff", border:"none", borderRadius:10, padding:"10px 16px", fontWeight:700, fontSize:13, cursor:"pointer", whiteSpace:"nowrap" }}>
             Gerenciar usuários / Redefinir senha
           </button>}
          <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:4 }}>
            <button onClick={handleCleanup} disabled={cleaning} style={{ background:cleaning?"#94A3B8":"linear-gradient(135deg,#DC2626,#991B1B)", color:"#fff", border:"none", borderRadius:10, padding:"10px 16px", fontWeight:700, fontSize:13, cursor:cleaning?"not-allowed":"pointer", whiteSpace:"nowrap" }}>
              {cleaning ? "🧹 Limpando..." : "🧹 Limpar Mensagens Antigas"}
            </button>
            {cleanResult && <div style={{ fontSize:11, color:"#475569", maxWidth:220, textAlign:"right" }}>{cleanResult}</div>}
          </div>
        </div>
      </div>
      <FilterBar filters={filters} setFilters={setFilters} showConsultant={false} showStatus={false} />
      <CommercialSalesNotice breakdown={commercialSalesAdm} periodRange={periodRangeAdm} error={commercialError} loaded={commercialLoaded} liftSales={liftSales} />

      <div style={{ marginBottom:12 }}>
        <div style={{ fontWeight:800, fontSize:14, color:T.text, marginBottom:10 }}>📊 Indicadores Gerais — {periodLabelAdm}</div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))", gap:10, marginBottom:20 }}>
          {kvMetricsAdm.map(m => (
            <div key={m.label} onClick={()=>setDrillDown({ title:m.label, items:m.list.map(m.saleItems ? saleToItemAdmin : adminClientToItem), period:periodLabelAdm })}
              style={{ background:"#fff", borderRadius:14, padding:"14px 16px", boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderLeft:`4px solid ${m.color}`, cursor:"pointer" }}
            >
              <div style={{ fontSize:18, marginBottom:2 }}>{m.icon}</div>
              <div style={{ fontSize:20, fontWeight:800, color:m.color }}>{m.value}</div>
              <div style={{ fontSize:11, color:T.muted, marginTop:2 }}>{m.label}</div>
            </div>
          ))}
        </div>
      </div>

      {expandedStoreId==null ? (
        <div>
          <div style={{ fontWeight:800, fontSize:14, color:T.text, marginBottom:10 }}>🏬 Resumo por Loja</div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))", gap:14, marginBottom:20 }}>
            {goalStores.map(store => {
              const storeConsultants = users.filter(u=>u.storeId===store.id&&u.role==="consultant");
              const storeSold = computeDashboardRevenueBreakdown({ clients, periodRange:periodRangeAdm, storeId:store.id, consultantId:null, liftSales }).totalValue;
              const th = THEMES[store.id] || T_DEMO;
              return (
                <div key={store.id} onClick={()=>setExpandedStoreId(store.id)} style={{ background:"#fff", borderRadius:16, padding:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderTop:`4px solid ${th.accent}`, cursor:"pointer" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:12 }}>
                    <div style={{ width:36, height:36, borderRadius:"50%", background:th.headerGrad, display:"flex", alignItems:"center", justifyContent:"center", fontSize:17 }}>👑</div>
                    <div>
                      <div style={{ fontWeight:800, fontSize:15, color:th.text }}>{store.name}</div>
                      <div style={{ fontSize:11, color:th.muted }}>{storeConsultants.length} consultores</div>
                    </div>
                  </div>
                  <div style={{ fontSize:20, fontWeight:800, color:th.positive }}>{fmt(storeSold)}</div>
                  <div style={{ fontSize:11, color:th.muted, marginBottom:8 }}>{pct(storeSold,store.goal)}% da meta ({fmt(store.goal)})</div>
                  <div style={{ background:th.sandDark, borderRadius:99, height:8, overflow:"hidden" }}>
                    <div style={{ width:`${Math.min(pct(storeSold,store.goal),100)}%`, height:"100%", background:`linear-gradient(90deg,${th.positive},${th.accentLight})`, borderRadius:99, transition:"width 0.6s" }} />
                  </div>
                  <div style={{ fontSize:11, color:th.accent, fontWeight:700, marginTop:10 }}>Ver consultores →</div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (() => {
        const store = goalStores.find(s=>s.id===expandedStoreId);
        const th = THEMES[store.id] || T_DEMO;
        const storeClients     = clients.filter(c=>Number(c.storeId)===Number(store.id));
        const storeConsultants = users.filter(u=>u.storeId===store.id&&u.role==="consultant");
        const ranking = computeConsultantRanking({ storeConsultants, storeClients, leads, prospeccao, liftSales, storeId:store.id, periodRange:periodRangeAdm, realSales });
        const storeSold = computeDashboardRevenueBreakdown({ clients, periodRange:periodRangeAdm, storeId:store.id, consultantId:null, liftSales }).totalValue;
        return (
          <div style={{ background:"#fff", borderRadius:16, padding:24, marginBottom:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderTop:`4px solid ${th.accent}` }}>
            <button onClick={()=>setExpandedStoreId(null)} style={{ background:"none", border:"none", color:th.accent, fontWeight:700, fontSize:13, cursor:"pointer", padding:0, marginBottom:14 }}>← Voltar para todas as lojas</button>
            <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:16, paddingBottom:12, borderBottom:`2px solid ${th.sand}` }}>
              <div style={{ width:40, height:40, borderRadius:"50%", background:th.headerGrad, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20 }}>👑</div>
              <div>
                <div style={{ fontWeight:800, fontSize:16, color:th.text }}>{store.name}</div>
                <div style={{ fontSize:12, color:th.muted }}>Meta: {fmt(store.goal)} · {storeConsultants.length} consultores</div>
              </div>
              <div onClick={()=>setDrillDown({ title:`${store.name} — Vendido no período`, items:ranking.flatMap(c=>c.salesList).map(saleToItemAdmin), period:periodLabelAdm })} style={{ marginLeft:"auto", textAlign:"right", cursor:"pointer" }}>
                <div style={{ fontSize:20, fontWeight:800, color:th.positive }}>{fmt(storeSold)}</div>
                <div style={{ fontSize:11, color:th.muted }}>{pct(storeSold,store.goal)}% da meta</div>
              </div>
            </div>
            <div style={{ background:th.sandDark, borderRadius:99, height:8, overflow:"hidden", marginBottom:16 }}>
              <div style={{ width:`${Math.min(pct(storeSold,store.goal),100)}%`, height:"100%", background:`linear-gradient(90deg,${th.positive},${th.accentLight})`, borderRadius:99, transition:"width 0.6s" }} />
            </div>
            <ConsultantRankingCard
              store={store}
              ranking={ranking}
              periodLabel={periodLabelAdm}
              onDrillSold={(c)=>setDrillDown({ title:`${c.name} — Vendido no período`, items:c.salesList.map(saleToItemAdmin), period:periodLabelAdm })}
              onViewAs={(id)=>onViewAs(users.find(u=>u.id===id))}
            />
            <div style={{ display:"flex", flexDirection:"column", gap:6, marginTop:14 }}>
              {ranking.map(c => (
                <div key={c.id} onClick={()=>setDrillDown({ title:`${c.name} — Atendimentos`, items:c.attendedList.map(adminClientToItem), period:periodLabelAdm })} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"8px 12px", background:th.sand, borderRadius:10, cursor:"pointer" }}>
                  <span style={{ fontSize:12, fontWeight:700, color:th.text }}>{c.name}</span>
                  <span style={{ fontSize:12, color:th.muted }}><b style={{ color:th.accent }}>{c.clientCount}</b> atendimento{c.clientCount!==1?"s":""} — ver clientes →</span>
                </div>
              ))}
            </div>
          </div>
        );
      })()}

      <ZapiSafetyPanel />
      <PhoneConfigPanel users={users} loggedInUser={loggedInUser} />
      {canResetPasswords && <div style={{margin:"16px 0"}}>
        <button type="button" onClick={()=>setDailySettingsOpen(v=>!v)} style={{padding:"10px 16px",border:"1px solid #CBD5E1",borderRadius:8,cursor:"pointer"}}>
          {dailySettingsOpen ? "Fechar configuração da fila" : "Configurar contatos novos por dia"}
        </button>
      </div>}
      {canResetPasswords && dailySettingsOpen && <ProspDailySettings users={users} stores={STORES} />}

      {drillDown && (
        <DrillDownModal
          title={drillDown.title}
          period={drillDown.period}
          items={drillDown.items}
          emptyMessage={drillDown.emptyMessage}
          onClose={()=>setDrillDown(null)}
        />
      )}

      {selected && (
        <ClientModal
          client={selected}
          storeId={selected.storeId}
          onClose={()=>setSelected(null)}
          onUpdate={updated => onUpdateClient && onUpdateClient(updated)}
          onDelete={id => { onDeleteClient && onDeleteClient(id); setSelected(null); }}
          onAddReminder={onAddReminder}
          onSendZapi={onSendZapi}
          onSendZapiMedia={onSendZapiMedia}
          whatsappMsgs={whatsappMsgs}
          onReturnToAurora={onReturnToAurora}
          currentUser={loggedInUser}
          onRegistrarVenda={onRegistrarVenda ? () => onRegistrarVenda(createSaleTarget("admin", selected, loggedInUser?.storeId, loggedInUser?.id)) : null}
          onConversationActive={onConversationActive}
        />
      )}
      {passwordResetOpen && <div style={{position:'fixed',inset:0,zIndex:30,background:'rgba(15,23,42,.62)',display:'grid',placeItems:'center',padding:16}}><CrmPasswordResetPanel apiBase="/api/crm/admin" exactConfirmation onClose={()=>setPasswordResetOpen(false)} /></div>}
    </div>
  );
}

function ZapiSafetyPanel() {
  const [settings, setSettings] = useState(null);
  const [phoneInput, setPhoneInput] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [logs, setLogs] = useState([]);
  const [showLogs, setShowLogs] = useState(false);
  const [loadingLogs, setLoadingLogs] = useState(false);

  const loadSettings = async () => {
    try {
      const r = await fetch('/api/zapi-safety');
      const data = await r.json();
      if (data.ok) { setSettings(data.settings); setPhoneInput(data.settings.authorizedPhone || ''); }
    } catch (e) { /* silencioso */ }
  };

  useEffect(() => { loadSettings(); }, []);

  const toggleEnabled = async () => {
    if (!settings) return;
    setSaving(true); setMsg(null);
    try {
      const r = await fetch('/api/zapi-safety', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ enabled: !settings.enabled, authorizedPhone: settings.authorizedPhone }),
      });
      const data = await r.json();
      if (data.ok) { setSettings(data.settings); setMsg('✅ Configuração salva'); }
      else setMsg(`❌ Erro: ${data.error}`);
    } catch (e) { setMsg('❌ Erro de conexão'); }
    setSaving(false);
  };

  const savePhone = async () => {
    setSaving(true); setMsg(null);
    try {
      const r = await fetch('/api/zapi-safety', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ enabled: settings?.enabled ?? true, authorizedPhone: phoneInput }),
      });
      const data = await r.json();
      if (data.ok) { setSettings(data.settings); setMsg('✅ Telefone autorizado salvo'); }
      else setMsg(`❌ Erro: ${data.error}`);
    } catch (e) { setMsg('❌ Erro de conexão'); }
    setSaving(false);
  };

  const loadLogs = async () => {
    setLoadingLogs(true);
    try {
      const r = await fetch('/api/webhook-log?limit=50');
      const data = await r.json();
      if (data.ok) setLogs(data.logs);
    } catch (e) { /* silencioso */ }
    setLoadingLogs(false);
  };

  return (
    <div style={{ background:"#fff", borderRadius:16, padding:24, marginBottom:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderTop:"4px solid #DC2626" }}>
      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
        <div style={{ fontSize:20 }}>🔒</div>
        <div>
          <div style={{ fontWeight:800, fontSize:16, color:T.text }}>Segurança Z-API — Colchões</div>
          <div style={{ fontSize:12, color:T.muted }}>Controle de processamento automático; o cadastro protegido não depende dele. Não é uma pausa geral de envios.</div>
        </div>
      </div>

      {settings ? (
        <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
          <div style={{ display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" }}>
            <button
              onClick={toggleEnabled}
              disabled={saving}
              style={{
                background: settings.enabled ? "linear-gradient(135deg,#DC2626,#991B1B)" : "linear-gradient(135deg,#16A34A,#15803D)",
                color:"#fff", border:"none", borderRadius:10, padding:"10px 16px", fontWeight:700, fontSize:13,
                cursor: saving ? "not-allowed" : "pointer",
              }}
            >
              {settings.enabled ? "🧪 Modo Teste: ATIVADO" : "✅ Modo Teste: DESATIVADO (produção normal)"}
            </button>
            <div style={{ fontSize:12, color:T.muted }}>
              {settings.enabled
                ? "Processamento automático restrito ao telefone autorizado. Novos contatos continuam com cadastro protegido."
                : "Processamento de entrada liberado. A pausa do Follow-up é um controle separado."}
            </div>
          </div>

          <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
            <label style={{ fontSize:12, color:T.muted, fontWeight:700 }}>Telefone autorizado (modo teste):</label>
            <input
              value={phoneInput}
              onChange={e => setPhoneInput(e.target.value)}
              placeholder="5542999720519"
              style={{ border:`1px solid ${T.border||'#CBD5E1'}`, borderRadius:8, padding:"8px 10px", fontSize:13, width:180 }}
            />
            <button onClick={savePhone} disabled={saving} style={{ background:T.accent||"#2563EB", color:"#fff", border:"none", borderRadius:8, padding:"8px 14px", fontWeight:700, fontSize:12, cursor:saving?"not-allowed":"pointer" }}>
              Salvar
            </button>
          </div>

          {msg && <div style={{ fontSize:12, color:"#475569" }}>{msg}</div>}

          <div>
            <button
              onClick={() => { setShowLogs(v => !v); if (!showLogs) loadLogs(); }}
              style={{ background:"#F1F5F9", color:"#334155", border:"none", borderRadius:8, padding:"8px 14px", fontWeight:700, fontSize:12, cursor:"pointer" }}
            >
              {showLogs ? "▲ Ocultar log de auditoria" : "▼ Ver log de auditoria"}
            </button>
            {showLogs && (
              <div style={{ marginTop:12, maxHeight:320, overflowY:"auto", border:"1px solid #E2E8F0", borderRadius:10 }}>
                {loadingLogs ? (
                  <div style={{ padding:16, fontSize:12, color:T.muted }}>Carregando...</div>
                ) : logs.length === 0 ? (
                  <div style={{ padding:16, fontSize:12, color:T.muted }}>Nenhum evento registrado ainda.</div>
                ) : (
                  <table style={{ width:"100%", borderCollapse:"collapse", fontSize:11 }}>
                    <thead>
                      <tr style={{ background:"#F8FAFC", textAlign:"left" }}>
                        <th style={{ padding:"6px 10px" }}>Quando</th>
                        <th style={{ padding:"6px 10px" }}>Loja</th>
                        <th style={{ padding:"6px 10px" }}>Telefone</th>
                        <th style={{ padding:"6px 10px" }}>Decisão</th>
                        <th style={{ padding:"6px 10px" }}>Motivo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {logs.map(l => (
                        <tr key={l.key} style={{ borderTop:"1px solid #F1F5F9" }}>
                          <td style={{ padding:"6px 10px", whiteSpace:"nowrap" }}>{l.at ? new Date(l.at).toLocaleString('pt-BR') : '—'}</td>
                          <td style={{ padding:"6px 10px" }}>{l.loja || '—'}</td>
                          <td style={{ padding:"6px 10px" }}>{l.phone || '—'}</td>
                          <td style={{ padding:"6px 10px", fontWeight:700 }}>{l.decisao || '—'}</td>
                          <td style={{ padding:"6px 10px" }}>{l.motivo || '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div style={{ fontSize:12, color:T.muted }}>Carregando configuração...</div>
      )}
    </div>
  );
}

// Antes esses telefones ficavam hardcoded no server.js — qualquer troca de
// número (novo gerente, novo consultor, mudança de celular) exigia editar
// código e fazer deploy. Esse painel deixa a Ana Paula (ou outro admin)
// editar direto pelo CRM, salvo no Firebase (arflow_settings/phone_config).
function PhoneConfigPanel({ users, loggedInUser }) {
  const [config, setConfig] = useState(null);
  const [storeLabels, setStoreLabels] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [logs, setLogs] = useState([]);
  const [showLogs, setShowLogs] = useState(false);
  const [loadingLogs, setLoadingLogs] = useState(false);
  const [reverting, setReverting] = useState(null);

  const consultantsForNotify = (users || []).filter(
    u => u.role === "consultant" && [2, 4].includes(u.storeId)
  );
  // Lista de lojas vem do backend (STORE_LABELS é a fonte única de verdade) —
  // uma nova loja adicionada lá aparece aqui automaticamente, sem editar dois lugares.
  const storeIds = Object.keys(storeLabels).map(Number).sort((a, b) => a - b);
  const storesWithAlerts = storeIds;

  const loadConfig = async () => {
    try {
      const r = await fetch('/api/phone-config');
      const data = await r.json();
      if (data.ok) { setConfig(data.config); setStoreLabels(data.storeLabels || {}); }
    } catch (e) { /* silencioso */ }
  };

  useEffect(() => { loadConfig(); }, []);

  const setOwnerPhone = (v) => setConfig(c => ({ ...c, ownerPhone: v }));
  const setConsultantPhone = (id, v) => setConfig(c => ({ ...c, consultantPhones: { ...c.consultantPhones, [id]: v } }));
  const setStoreManagerPhone = (storeId, v) => setConfig(c => ({ ...c, storeManagerPhones: { ...c.storeManagerPhones, [storeId]: v } }));
  const setAlertPhones = (storeId, v) => setConfig(c => ({
    ...c,
    storeManagementAlertPhones: { ...c.storeManagementAlertPhones, [storeId]: v.split(',').map(s => s.trim()).filter(Boolean) },
  }));

  const handleSave = async () => {
    setSaving(true); setMsg(null);
    try {
      const r = await fetch('/api/phone-config', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...config, actorName: loggedInUser?.name || null, actorId: loggedInUser?.id ?? null }),
      });
      const data = await r.json();
      if (data.ok) {
        setConfig(data.config);
        setMsg('✅ Telefones salvos — já valem pra próximos alertas/notificações, sem precisar de deploy');
        if (showLogs) loadLogs();
      }
      else setMsg(`❌ Erro: ${data.error}`);
    } catch (e) { setMsg('❌ Erro de conexão'); }
    setSaving(false);
  };

  const loadLogs = async () => {
    setLoadingLogs(true);
    try {
      const r = await fetch('/api/phone-config-log?limit=50');
      const data = await r.json();
      if (data.ok) setLogs(data.logs);
    } catch (e) { /* silencioso */ }
    setLoadingLogs(false);
  };

  const handleRevert = async (log, change, changeIndex) => {
    const previousValue = change.de || '(vazio)';
    if (!window.confirm(`Reverter "${change.campo || 'este telefone'}" para ${previousValue}?`)) return;

    const revertKey = `${log.key}:${changeIndex}`;
    setReverting(revertKey);
    setMsg(null);
    try {
      const r = await fetch('/api/phone-config/revert', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ logKey: log.key, changeIndex }),
      });
      const data = await r.json();
      if (data.ok) {
        setConfig(data.config);
        setMsg(`✅ ${change.campo || 'Alteração'} revertido para ${previousValue}`);
        await loadLogs();
      } else {
        setMsg(`❌ Erro: ${data.error || 'não foi possível reverter'}`);
      }
    } catch (e) {
      setMsg('❌ Erro de conexão ao reverter');
    } finally {
      setReverting(null);
    }
  };

  const inputStyle = { border:`1px solid ${T.border||'#CBD5E1'}`, borderRadius:8, padding:"7px 10px", fontSize:13, width:180 };
  const rowStyle = { display:"flex", alignItems:"center", gap:10, flexWrap:"wrap", marginBottom:8 };
  const labelStyle = { fontSize:12, color:T.muted, fontWeight:700, minWidth:170 };

  return (
    <div style={{ background:"#fff", borderRadius:16, padding:24, marginBottom:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderTop:"4px solid #2563EB" }}>
      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
        <div style={{ fontSize:20 }}>📞</div>
        <div>
          <div style={{ fontWeight:800, fontSize:16, color:T.text }}>Telefones de Alerta e Notificação</div>
          <div style={{ fontSize:12, color:T.muted }}>Quem recebe aviso de novo lead e de fila travada, por loja — edite sem precisar chamar o dev</div>
        </div>
      </div>

      {!config ? (
        <div style={{ fontSize:12, color:T.muted }}>Carregando configuração...</div>
      ) : (
        <div style={{ display:"flex", flexDirection:"column", gap:18 }}>
          <div>
            <div style={rowStyle}>
              <label style={labelStyle}>Dona (recebe alerta de todas as lojas):</label>
              <input value={config.ownerPhone || ''} onChange={e => setOwnerPhone(e.target.value)} placeholder="5542999999999" style={inputStyle} />
            </div>
          </div>

          <div>
            <div style={{ fontSize:13, fontWeight:700, color:T.text, marginBottom:8 }}>Alerta de fila travada, por loja</div>
            <div style={{ fontSize:11, color:T.muted, marginBottom:8 }}>Telefones separados por vírgula. A dona (número acima) é sempre incluída automaticamente se a lista ficar vazia.</div>
            {storesWithAlerts.map(storeId => (
              <div key={storeId} style={rowStyle}>
                <label style={labelStyle}>{storeLabels[storeId] || `Loja ${storeId}`}:</label>
                <input
                  value={(config.storeManagementAlertPhones?.[storeId] || []).join(', ')}
                  onChange={e => setAlertPhones(storeId, e.target.value)}
                  placeholder="5542999999999, 5542988888888"
                  style={{ ...inputStyle, width:280 }}
                />
              </div>
            ))}
          </div>

          <div>
            <div style={{ fontSize:13, fontWeight:700, color:T.text, marginBottom:8 }}>Gerente que recebe cópia de todo lead novo, por loja</div>
            {storeIds.map(storeId => (
              <div key={storeId} style={rowStyle}>
                <label style={labelStyle}>{storeLabels[storeId] || `Loja ${storeId}`}:</label>
                <input
                  value={config.storeManagerPhones?.[storeId] || ''}
                  onChange={e => setStoreManagerPhone(storeId, e.target.value)}
                  placeholder="(opcional)"
                  style={inputStyle}
                />
              </div>
            ))}
          </div>

          <div>
            <div style={{ fontSize:13, fontWeight:700, color:T.text, marginBottom:8 }}>Consultores que recebem aviso de lead novo (WhatsApp direto)</div>
            {consultantsForNotify.map(u => (
              <div key={u.id} style={rowStyle}>
                <label style={labelStyle}>{u.name}:</label>
                <input
                  value={config.consultantPhones?.[u.id] || ''}
                  onChange={e => setConsultantPhone(u.id, e.target.value)}
                  placeholder="(sem aviso configurado)"
                  style={inputStyle}
                />
              </div>
            ))}
          </div>

          <div style={{ display:"flex", alignItems:"center", gap:12 }}>
            <button onClick={handleSave} disabled={saving} style={{ background:T.accent||"#2563EB", color:"#fff", border:"none", borderRadius:8, padding:"10px 18px", fontWeight:700, fontSize:13, cursor:saving?"not-allowed":"pointer" }}>
              {saving ? "Salvando..." : "💾 Salvar telefones"}
            </button>
            {msg && <div style={{ fontSize:12, color:"#475569" }}>{msg}</div>}
          </div>

          <div>
            <button
              onClick={() => { setShowLogs(v => !v); if (!showLogs) loadLogs(); }}
              style={{ background:"#F1F5F9", color:"#334155", border:"none", borderRadius:8, padding:"8px 14px", fontWeight:700, fontSize:12, cursor:"pointer" }}
            >
              {showLogs ? "▲ Ocultar histórico de alterações" : "▼ Ver histórico de alterações"}
            </button>
            {showLogs && (
              <div style={{ marginTop:12, maxHeight:320, overflowY:"auto", border:"1px solid #E2E8F0", borderRadius:10 }}>
                {loadingLogs ? (
                  <div style={{ padding:16, fontSize:12, color:T.muted }}>Carregando...</div>
                ) : logs.length === 0 ? (
                  <div style={{ padding:16, fontSize:12, color:T.muted }}>Nenhuma alteração registrada ainda.</div>
                ) : (
                  <table style={{ width:"100%", borderCollapse:"collapse", fontSize:11 }}>
                    <thead>
                      <tr style={{ background:"#F8FAFC", textAlign:"left" }}>
                        <th style={{ padding:"6px 10px" }}>Quando</th>
                        <th style={{ padding:"6px 10px" }}>Quem</th>
                        <th style={{ padding:"6px 10px" }}>O que mudou</th>
                      </tr>
                    </thead>
                    <tbody>
                      {logs.map(l => (
                        <tr key={l.key} style={{ borderTop:"1px solid #F1F5F9" }}>
                          <td style={{ padding:"6px 10px", whiteSpace:"nowrap" }}>{l.timestamp ? new Date(l.timestamp).toLocaleString('pt-BR') : '—'}</td>
                          <td style={{ padding:"6px 10px", fontWeight:700 }}>{l.actorName || '—'}</td>
                          <td style={{ padding:"6px 10px" }}>
                            {(l.changes || []).map((c, i) => (
                              <div key={i} style={{ marginBottom: i < (l.changes.length - 1) ? 4 : 0 }}>
                                <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                                  <span>
                                    <strong>{c.campo}:</strong> {c.de || '(vazio)'} → {c.para || '(vazio)'}
                                  </span>
                                  {loggedInUser?.role === 'admin' && (
                                    <button
                                      type="button"
                                      onClick={() => handleRevert(l, c, i)}
                                      disabled={reverting !== null}
                                      aria-label={`Reverter ${c.campo || 'alteração'}`}
                                      style={{
                                        background:"#FFF7ED",
                                        color:"#C2410C",
                                        border:"1px solid #FDBA74",
                                        borderRadius:6,
                                        padding:"3px 8px",
                                        fontWeight:700,
                                        fontSize:10,
                                        cursor:reverting !== null ? "not-allowed" : "pointer",
                                        opacity:reverting !== null && reverting !== `${l.key}:${i}` ? 0.55 : 1,
                                      }}
                                    >
                                      {reverting === `${l.key}:${i}` ? "Revertendo..." : "↩ Reverter"}
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))}
                            {l.action === 'revert' && (
                              <div style={{ marginTop:4, color:"#C2410C", fontSize:10, fontWeight:700 }}>↩ Reversão registrada</div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function HistoricoView({ months, clients, selectedMonth, onSelectMonth, currentUser, leads=[], prospeccao=[] }) {
  const goalStores=useMonthlyGoalStores(getActiveStores(),selectedMonth||currentDateKeySaoPaulo().slice(0,7));
  const { commercialSales:liftSales, commercialError, commercialLoaded } = useContext(LiftPendingContext);
  const [drillDown, setDrillDown] = useState(null);
  const SOLD_STAGES = ["closed","posVenda","nextSale"];
  const [localFilters, setLocalFilters] = useScreenPeriodFilters("historico", DEFAULT_FILTERS);
  const effFiltersHist = localFilters;
  const periodRangeHist = getPeriodRange(effFiltersHist.period, effFiltersHist.customFrom, effFiltersHist.customTo);
  const periodLabelHist = periodLabelText(effFiltersHist);
  const filterHeaderHist = (
    <div style={{ marginBottom:16 }}>
      <FilterBar filters={localFilters} setFilters={setLocalFilters} showConsultant={false} showStatus={false} />
    </div>
  );

  // Cards do Funil fechados no período selecionado (fonte: dados ao vivo)
  const scopedClients = currentUser?.storeId
    ? clients.filter(c => c.storeId === currentUser.storeId)
    : clients;
  const closedInMonth = scopedClients.filter(c => {
    if (!SOLD_STAGES.includes(c.stage) && c.stage !== 'semInteresse') return false;
    return inPeriod(getClosingDate(c), periodRangeHist);
  });
  const lostCards = closedInMonth.filter(c => c.stage==='semInteresse');
  const histClientToItem = (c) => ({
    id:c.id, name:c.name, phone:c.phone, consultant:USERS.find(u=>u.id===c.consultantId)?.name.split(" ")[0],
    store:STORES.find(s=>s.id===(c.storeId||1))?.name, origin:c.origin, status:STAGES.find(s=>s.id===c.stage)?.label||c.stage,
    createdAt:c.createdAt, lastInteraction:(c.stageDates||{})[c.stage]||c.createdAt, value:c.value, followUp:c.followUp,
  });

  // Uma única base comercial alimenta total, quantidade, ticket e drilldowns.
  // A lista de fichas fechadas abaixo permanece apenas para o indicador de perda.
  const commercialSalesHist = computeOriginBreakdown({
    clients, leads, prospeccao, periodRange: periodRangeHist,
    storeId: currentUser?.role === "consultant" ? null : (currentUser?.storeId ?? null),
    consultantId:currentUser?.role === "consultant" ? currentUser.id : null,
    consultantAcrossStores:currentUser?.role === "consultant",
    liftSales,
  });
  const sold = commercialSalesHist.sales;
  const histSaleToItem = saleToDrillItem;

  // Ranking de consultores — usa computeOriginBreakdown para incluir leads (kanban) e prospecção,
  // igual ao Dashboard principal e à visão Admin, evitando divergência entre as telas.
  const stagesRanking = goalStores.map(store => {
    const th = THEMES[store.id] || T_DEMO;
    const storeConsultants = getActiveUsers().filter(u=>u.storeId===store.id&&u.role==="consultant");
    if (currentUser?.storeId && currentUser.storeId !== store.id) return null;
    const ranking = storeConsultants
      .map(u => {
        const bd = computeOriginBreakdown({ clients, leads, prospeccao, periodRange: periodRangeHist, storeId:null, consultantId:u.id, consultantAcrossStores:true, liftSales });
        return { ...u, total: bd.totalValue, sales: redactConsultantCrossStoreSales(bd, store.id).sales };
      })
      .sort((a,b)=>b.total-a.total);
    const storeTotal = computeOriginBreakdown({ clients, leads, prospeccao, periodRange:periodRangeHist, storeId:store.id, consultantId:null, liftSales }).totalValue;
    return { store, th, ranking, storeTotal };
  }).filter(Boolean);

  const totalVendido = commercialSalesHist.totalValue;

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12, marginBottom:20 }}>
        <div>
          <div style={{ fontWeight:800, fontSize:20, color:T.text }}>Histórico do Funil</div>
          <div style={{ fontSize:13, color:T.muted }}>Vendas fechadas por período · dados ao vivo</div>
        </div>
      </div>
      {filterHeaderHist}
      <CommercialSalesNotice breakdown={commercialSalesHist} periodRange={periodRangeHist} error={commercialError} loaded={commercialLoaded}
        storeId={currentUser?.role === "consultant" ? null : (currentUser?.storeId ?? null)}
        consultantId={currentUser?.role === "consultant" ? currentUser.id : null} liftSales={liftSales} />

      {/* Métricas do período */}
      <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:16, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, flexWrap:"wrap", gap:8 }}>
          <div style={{ fontWeight:800, fontSize:18, color:T.text }}>{periodLabelHist}</div>
          <div style={{ textAlign:"right" }}>
            <div style={{ fontSize:24, fontWeight:800, color:T.positive }}>{fmt(totalVendido)}</div>
            <div style={{ fontSize:11, color:T.muted }}>{sold.length} venda{sold.length!==1?"s":""} comercial{sold.length!==1?"is":""} no funil</div>
          </div>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(110px,1fr))", gap:10 }}>
          <MetricCard icon="✅" label="Vendas comerciais" value={sold.length}    accent={T.positive} onClick={()=>setDrillDown({ title:"Vendas comerciais", items:sold.map(histSaleToItem), period:periodLabelHist })} />
          <MetricCard icon="🚫" label="Sem Interesse" value={lostCards.length}   accent={T.muted} onClick={()=>setDrillDown({ title:"Sem Interesse", items:lostCards.map(histClientToItem), period:periodLabelHist })} />
          <MetricCard icon="🎫" label="Ticket Médio" value={sold.length>0?fmt(commercialSalesHist.ticketMedio):"—"} accent={T.navyLight} onClick={()=>setDrillDown({ title:"Ticket Médio — vendas comerciais", items:sold.map(histSaleToItem), period:periodLabelHist })} />
          <MetricCard icon="📊" label="Conv. mês"  value={`${pct(sold.length,(sold.length+lostCards.length)||1)}%`} accent={T.accent} onClick={()=>setDrillDown({ title:"Conversão do mês — vendas comerciais + sem interesse", items:[...sold.map(histSaleToItem), ...lostCards.map(histClientToItem)], period:periodLabelHist })} />
        </div>
      </div>

      {/* Ranking por loja */}
      {stagesRanking.map(({ store, th, ranking, storeTotal }) => (
        <div key={store.id} style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:12, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderLeft:`4px solid ${th.accent}` }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
            <div style={{ fontWeight:700, fontSize:15, color:th.text }}>🏆 {store.name}</div>
            <div style={{ fontWeight:800, fontSize:16, color:th.positive }}>{fmt(storeTotal)}</div>
          </div>
          {ranking.map((u,i) => {
            const medal = i===0?"🥇":i===1?"🥈":i===2?"🥉":"👤";
            const p = pct(u.total, store.consultantGoal);
            return (
              <div key={u.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 0", borderBottom:`1px solid ${th.sand}` }}>
                <div>
                  <div style={{ fontWeight:700, fontSize:13, color:th.text }}>{medal} {u.name}</div>
                  <div style={{ fontSize:11, color:th.muted }}>meta: {p}%</div>
                </div>
                <div style={{ fontWeight:800, fontSize:16, color:th.accent }}>{fmt(u.total)}</div>
              </div>
            );
          })}
          {ranking.every(u=>u.total===0) && (
            <div style={{ fontSize:13, color:T.muted, textAlign:'center', padding:'12px 0' }}>Nenhuma venda fechada neste mês</div>
          )}
        </div>
      ))}

      {/* Lista de cards fechados no mês */}
      {closedInMonth.length > 0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:12, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
          <div style={{ fontWeight:700, fontSize:14, color:T.text, marginBottom:12 }}>📋 Cards fechados — {periodLabelHist}</div>
          {closedInMonth.sort((a,b)=>(getClosingDate(b)>getClosingDate(a)?1:-1)).map(c => {
            const th = THEMES[c.storeId||1];
            const stageInfo = STAGES.find(s=>s.id===c.stage);
            const consultor = USERS.find(u=>u.id===c.consultantId);
            return (
              <div key={c.id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 0', borderBottom:`1px solid ${th.sand}`, flexWrap:'wrap', gap:6 }}>
                <div>
                  <div style={{ fontWeight:600, fontSize:13, color:T.text }}>{c.name}</div>
                  <div style={{ fontSize:11, color:T.muted }}>{c.product} · {consultor?.name||'—'} · {getClosingDate(c).slice(0,10)}</div>
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                  <span style={{ fontSize:11, background:`${stageInfo?.color||T.accent}22`, color:stageInfo?.color||T.accent, borderRadius:6, padding:'2px 8px', fontWeight:700 }}>{stageInfo?.label||c.stage}</span>
                  {c.value>0 && <span style={{ fontSize:13, fontWeight:800, color:th.positive }}>{fmt(c.value)}</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {closedInMonth.length===0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:40, textAlign:"center", color:T.muted, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
          <div style={{ fontSize:36, marginBottom:10 }}>📅</div>
          <div style={{ fontWeight:700, fontSize:15 }}>Nenhum card fechado — {periodLabelHist}</div>
          <div style={{ fontSize:13, marginTop:6 }}>Cards são registrados aqui quando movidos para Fechado, Pós-venda ou Perdido.</div>
        </div>
      )}

      {drillDown && (
        <DrillDownModal
          title={drillDown.title}
          period={drillDown.period}
          items={drillDown.items}
          emptyMessage={drillDown.emptyMessage}
          onClose={()=>setDrillDown(null)}
        />
      )}
    </div>
  );
}

function StoreRecebimentos({ store, clients, rs, showConsultant, periodRange, onOpenClient }) {
  const th = THEMES[store.id] || T_DEMO;
  const consultants = getActiveUsers().filter(u=>u.storeId===store.id&&u.role==="consultant");
  const closed = clients.filter(c=>Number(c.storeId)===Number(store.id)&&wasSold(c)&&inPeriod(getClosingDate(c), periodRange));
  const legacyUnverified = consultants.reduce((s,u)=>s+(rs[u.id]||0),0);
  const getReceived = c => c.paidValue !== undefined ? c.paidValue : (c.value||0);
  const getPending  = c => Math.max(0, (c.value||0) - getReceived(c));
  const totalReceived  = closed.reduce((s,c)=>s+getReceived(c),0);
  const totalPending   = closed.reduce((s,c)=>s+getPending(c),0);
  const withPending    = closed.filter(c=>getPending(c)>0).sort((a,b)=>getPending(b)-getPending(a));
  const consultantName = id => USERS.find(u=>Number(u.id)===Number(id))?.name||"";

  const [drillDown, setDrillDown] = useState(null);
  const recebToItem = (c) => ({
    id:c.id, name:c.name, phone:c.phone, consultant:consultantName(c.consultantId),
    store:store.name, origin:c.product, status:getPending(c)>0?"Pendente":"Quitado",
    createdAt:c.createdAt, lastInteraction:(c.stageDates||{}).closed||c.createdAt, value:c.value,
    actionLabel:onOpenClient ? "Ver ficha" : undefined,
    onAction:onOpenClient ? ()=>onOpenClient(c) : undefined,
  });

  return (
    <div style={{ background:"#fff", borderRadius:16, padding:24, marginBottom:20, boxShadow:"0 2px 16px rgba(0,0,0,0.08)", borderTop:`4px solid ${th.accent}` }}>
      {/* Cabeçalho */}
      <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:16, paddingBottom:14, borderBottom:`2px solid ${th.sand}` }}>
        <div style={{ width:40, height:40, borderRadius:"50%", background:th.headerGrad, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20 }}>💰</div>
        <div style={{ flex:1 }}>
          <div style={{ fontWeight:800, fontSize:16, color:th.text }}>{store.name}</div>
          <div style={{ fontSize:12, color:th.muted }}>{consultants.length} consultores</div>
        </div>
        <div style={{ textAlign:"right" }}>
          <div style={{ fontSize:11, color:th.muted }}>Fichas a receber</div>
          <div style={{ fontSize:22, fontWeight:800, color:totalPending>0?"#D97706":th.positive }}>{fmt(totalPending)}</div>
        </div>
      </div>

      {/* Métricas */}
      <LegacySalesNotice value={legacyUnverified} />
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10, marginBottom:16 }}>
        <div onClick={()=>setDrillDown({ title:`${store.name} — Total recebido`, items:closed.map(recebToItem), period:"Vendas fechadas" })} style={{ background:th.sand, borderRadius:10, padding:"10px 12px", textAlign:"center", cursor:"pointer" }}>
          <div style={{ fontSize:15, fontWeight:800, color:th.positive }}>{fmt(totalReceived)}</div>
          <div style={{ fontSize:10, color:th.muted }}>Total recebido</div>
        </div>
        <div onClick={()=>setDrillDown({ title:`${store.name} — Aguardando recebimento`, items:withPending.map(recebToItem), period:"Pendentes" })} style={{ background:th.sand, borderRadius:10, padding:"10px 12px", textAlign:"center", cursor:"pointer" }}>
          <div style={{ fontSize:15, fontWeight:800, color:totalPending>0?"#D97706":th.muted }}>{fmt(totalPending)}</div>
          <div style={{ fontSize:10, color:th.muted }}>A receber</div>
        </div>
        <div onClick={()=>setDrillDown({ title:`${store.name} — Fichas fechadas`, items:closed.map(recebToItem), period:"Fichas com financeiro" })} style={{ background:th.sand, borderRadius:10, padding:"10px 12px", textAlign:"center", cursor:"pointer" }}>
          <div style={{ fontSize:15, fontWeight:800, color:th.accent }}>{closed.length}</div>
          <div style={{ fontSize:10, color:th.muted }}>Fichas fechadas</div>
        </div>
      </div>

      {/* Aguardando recebimento */}
      {withPending.length>0 ? (
        <div>
          <div style={{ fontWeight:700, fontSize:13, color:"#92400E", marginBottom:10 }}>⏳ Aguardando Recebimento ({withPending.length})</div>
          {withPending.map(c => {
            const received = getReceived(c);
            const pending  = getPending(c);
            const paidPct  = pct(received, c.value||1);
            return (
              <div key={c.id} style={{ padding:"12px 0", borderBottom:`1px solid ${th.sandDark}` }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:8 }}>
                  <div style={{ flex:1, minWidth:140 }}>
                    <div style={{ fontWeight:700, fontSize:13, color:th.text }}>{c.name}</div>
                    <div style={{ fontSize:11, color:th.muted, marginTop:2 }}>
                      {c.product}
                      {showConsultant && <span> · 👤 {consultantName(c.consultantId).split(" ")[0]}</span>}
                    </div>
                  </div>
                  <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                    <div style={{ textAlign:"right" }}>
                      <div style={{ fontSize:10, color:th.muted }}>Recebido</div>
                      <div style={{ fontSize:13, fontWeight:700, color:th.positive }}>{fmt(received)}</div>
                    </div>
                    <div style={{ textAlign:"right" }}>
                      <div style={{ fontSize:10, color:th.muted }}>A Receber</div>
                      <div style={{ fontSize:15, fontWeight:800, color:"#D97706" }}>{fmt(pending)}</div>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop:6 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", marginBottom:2 }}>
                    <span style={{ fontSize:10, color:th.muted }}>Total: {fmt(c.value||0)}</span>
                    <span style={{ fontSize:10, fontWeight:700, color:paidPct===100?th.positive:"#D97706" }}>{paidPct}% recebido</span>
                  </div>
                  <div style={{ background:th.sandDark, borderRadius:99, height:6, overflow:"hidden" }}>
                    <div style={{ width:`${paidPct}%`, height:"100%", background:th.positive, borderRadius:99, transition:"width 0.5s" }} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ textAlign:"center", padding:"16px 0", color:th.positive, fontWeight:600, fontSize:13 }}>
          ✅ Nenhum valor pendente nesta loja
        </div>
      )}
      {drillDown && <DrillDownModal {...drillDown} onClose={()=>setDrillDown(null)} />}
    </div>
  );
}

function RecebimentosView({ clients, currentUser, realSales, onOpenClient }) {
  const rs = realSales || REAL_SALES;
  const [drillDown, setDrillDown] = useState(null);
  const [localFilters, setLocalFilters] = useScreenPeriodFilters("recebimentos", DEFAULT_FILTERS);
  const effFiltersReceb = localFilters;
  const periodRangeReceb = getPeriodRange(effFiltersReceb.period, effFiltersReceb.customFrom, effFiltersReceb.customTo);
  const filterHeaderReceb = (
    <div style={{ marginBottom:16 }}>
      <FilterBar filters={localFilters} setFilters={setLocalFilters} />
    </div>
  );

  const getReceived = c => c.paidValue !== undefined ? c.paidValue : (c.value||0);
  const getPending  = c => Math.max(0, (c.value||0) - getReceived(c));
  const consultantName = id => USERS.find(u=>Number(u.id)===Number(id))?.name||"";

  // ── ADMIN: uma seção por loja, sem quitados ──────────────────
  if (currentUser.role === "admin") {
    return (
      <div>
        <div style={{ fontWeight:800, fontSize:20, color:T.text, marginBottom:4 }}>Valores a Receber</div>
        <div style={{ fontSize:13, color:T.muted, marginBottom:20 }}>Financeiro das fichas fechadas — não inclui vendas comerciais sem ficha</div>
        {filterHeaderReceb}
        {getActiveStores().map(store => (
          <StoreRecebimentos key={store.id} store={store} clients={clients} rs={rs} showConsultant={true} periodRange={periodRangeReceb} onOpenClient={onOpenClient} />
        ))}
      </div>
    );
  }

  // ── GERENTE / CONSULTOR ──────────────────────────────────────
  const relevantConsultants = currentUser.role==="manager"
    ? getActiveUsers().filter(u=>u.storeId===currentUser.storeId&&u.role==="consultant")
    : getActiveUsers().filter(u=>u.id===currentUser.id);

  const mine = currentUser.role==="manager"
    ? clients.filter(c=>Number(c.storeId)===Number(currentUser.storeId))
    : clients.filter(c=>Number(c.consultantId)===Number(currentUser.id));

  const closed = mine.filter(c=>wasSold(c)&&inPeriod(getClosingDate(c), periodRangeReceb));
  const baseSalesTotal  = relevantConsultants.reduce((s,u)=>s+(rs[u.id]||0), 0);
  const funilReceived   = closed.reduce((s,c)=>s+getReceived(c),0);
  const totalReceived   = funilReceived;
  const totalPending    = closed.reduce((s,c)=>s+getPending(c),0);
  const withPending     = closed.filter(c=>getPending(c)>0).sort((a,b)=>getPending(b)-getPending(a));
  const fullyPaid       = closed.filter(c=>getPending(c)===0);
  const consultantsWithBase = relevantConsultants.filter(u=>(rs[u.id]||0)>0);

  const recebToItemRC = (c) => ({
    id:c.id, name:c.name, phone:c.phone, consultant:consultantName(c.consultantId).split(" ")[0],
    store:STORES.find(s=>s.id===c.storeId)?.name, origin:c.product, status:getPending(c)>0?"Pendente":"Quitado",
    createdAt:c.createdAt, lastInteraction:(c.stageDates||{}).closed||c.createdAt, value:c.value,
    actionLabel:onOpenClient ? "Ver ficha" : undefined,
    onAction:onOpenClient ? ()=>onOpenClient(c) : undefined,
  });

  return (
    <div>
      <div style={{ fontWeight:800, fontSize:20, color:T.text, marginBottom:4 }}>Valores a Receber</div>
      <div style={{ fontSize:13, color:T.muted, marginBottom:20 }}>Financeiro das fichas fechadas — não inclui vendas comerciais sem ficha</div>
      {filterHeaderReceb}

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))", gap:12, marginBottom:24 }}>
        <MetricCard icon="💵" label="Total Recebido"  value={fmt(totalReceived)} accent={T.positive} sub={`${fullyPaid.length} quitados`} onClick={()=>setDrillDown({ title:"Total recebido", items:fullyPaid.map(recebToItemRC), period:"Vendas quitadas" })} />
        <MetricCard icon="⏳" label="Total a Receber" value={fmt(totalPending)}  accent={totalPending>0?"#D97706":T.muted} sub={`${withPending.length} cliente${withPending.length!==1?"s":""} pendente${withPending.length!==1?"s":""}`} onClick={()=>setDrillDown({ title:"Aguardando recebimento", items:withPending.map(recebToItemRC), period:"Pendentes" })} />
        <MetricCard icon="📦" label="Fichas Fechadas" value={closed.length} accent={T.navyLight} sub={`${fmt(funilReceived+totalPending)} em fichas`} onClick={()=>setDrillDown({ title:"Fichas fechadas", items:closed.map(recebToItemRC), period:"Fichas com financeiro" })} />
      </div>

      {consultantsWithBase.length>0 && (
        <div style={{ background:"#FFF8E6", borderRadius:14, padding:20, marginBottom:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderLeft:"4px solid #D97706" }}>
          <div style={{ fontWeight:700, fontSize:14, color:"#92400E", marginBottom:6 }}>⚠️ Registros manuais legados sem conciliação</div>
          <div style={{ fontSize:12, color:"#92400E", marginBottom:14 }}>Não entram em recebido, a receber ou vendas até terem cliente, data e comprovante individual.</div>
          <div style={{ display:"flex", flexWrap:"wrap", gap:10 }}>
            {consultantsWithBase.map(u => (
              <div key={u.id} style={{ background:T.sand, borderRadius:10, padding:"12px 16px", minWidth:150, flex:"1 1 150px" }}>
                <div style={{ fontWeight:700, fontSize:13, color:T.text }}>👤 {u.name.split(" ")[0]}</div>
                <div style={{ fontSize:18, fontWeight:800, color:T.positive, marginTop:4 }}>{fmt(rs[u.id]||0)}</div>
                <div style={{ fontSize:11, color:T.muted, marginTop:2 }}>sem comprovante individual</div>
              </div>
            ))}
          </div>
          {consultantsWithBase.length>1 && (
            <div style={{ marginTop:12, paddingTop:12, borderTop:`1px solid ${T.sandDark}`, display:"flex", justifyContent:"space-between" }}>
              <span style={{ fontSize:13, color:T.muted, fontWeight:600 }}>Subtotal legado sem conciliação</span>
              <span style={{ fontSize:15, fontWeight:800, color:"#D97706" }}>{fmt(baseSalesTotal)}</span>
            </div>
          )}
        </div>
      )}

      {withPending.length>0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderLeft:"4px solid #D97706" }}>
          <div style={{ fontWeight:700, fontSize:14, color:"#92400E", marginBottom:14 }}>⏳ Aguardando Recebimento ({withPending.length})</div>
          {withPending.map(c => {
            const received = getReceived(c);
            const pending  = getPending(c);
            const paidPct  = pct(received, c.value||1);
            return (
              <div key={c.id} style={{ padding:"14px 0", borderBottom:`1px solid ${T.sandDark}` }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:8 }}>
                  <div style={{ flex:1, minWidth:160 }}>
                    <div style={{ fontWeight:700, fontSize:14, color:T.text }}>{c.name}</div>
                    <div style={{ fontSize:11, color:T.muted, marginTop:2 }}>
                      {c.product}
                      {currentUser.role!=="consultant" && <span> · 👤 {consultantName(c.consultantId).split(" ")[0]}</span>}
                    </div>
                  </div>
                  <div style={{ display:"flex", gap:10, alignItems:"center", flexWrap:"wrap" }}>
                    <div style={{ textAlign:"right" }}>
                      <div style={{ fontSize:11, color:T.muted }}>Recebido</div>
                      <div style={{ fontSize:14, fontWeight:700, color:T.positive }}>{fmt(received)}</div>
                    </div>
                    <div style={{ textAlign:"right" }}>
                      <div style={{ fontSize:11, color:T.muted }}>A Receber</div>
                      <div style={{ fontSize:16, fontWeight:800, color:"#D97706" }}>{fmt(pending)}</div>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop:8 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", marginBottom:3 }}>
                    <span style={{ fontSize:10, color:T.muted }}>Total: {fmt(c.value||0)}</span>
                    <span style={{ fontSize:10, fontWeight:700, color:paidPct===100?T.positive:"#D97706" }}>{paidPct}% recebido</span>
                  </div>
                  <div style={{ background:T.sandDark, borderRadius:99, height:6, overflow:"hidden" }}>
                    <div style={{ width:`${paidPct}%`, height:"100%", background:`linear-gradient(90deg,${T.positive},${T.positive}99)`, borderRadius:99, transition:"width 0.5s" }} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {fullyPaid.length>0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
          <div style={{ fontWeight:700, fontSize:14, color:T.positive, marginBottom:14 }}>✅ Quitados ({fullyPaid.length})</div>
          <div style={{ display:"flex", flexWrap:"wrap", gap:10 }}>
            {fullyPaid.map(c => (
              <div key={c.id} style={{ background:T.sand, borderRadius:10, padding:"10px 14px", minWidth:150, flex:"1 1 150px" }}>
                <div style={{ fontWeight:700, fontSize:13, color:T.text }}>{c.name}</div>
                <div style={{ fontSize:11, color:T.muted }}>{c.product}</div>
                <div style={{ fontSize:14, fontWeight:700, color:T.positive, marginTop:4 }}>{fmt(c.value||0)} ✅</div>
                {currentUser.role!=="consultant" && <div style={{ fontSize:10, color:T.muted, marginTop:2 }}>👤 {consultantName(c.consultantId).split(" ")[0]}</div>}
              </div>
            ))}
          </div>
        </div>
      )}

      {closed.length===0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:40, textAlign:"center", color:T.muted, boxShadow:"0 2px 12px rgba(15,31,61,0.08)" }}>
          <div style={{ fontSize:32, marginBottom:8 }}>💼</div>
          <div style={{ fontWeight:600 }}>Nenhuma venda fechada ainda.</div>
          <div style={{ fontSize:13, marginTop:4 }}>Os valores aparecerão aqui quando houver vendas fechadas no funil.</div>
        </div>
      )}
      {drillDown && <DrillDownModal {...drillDown} onClose={()=>setDrillDown(null)} />}
    </div>
  );
}

// ── LEADS ──────────────────────────────────────────────────────

function LeadSeloResponsavel({ lead }) {
  const isAurora = leadIsAuroraActive(lead);
  const consultor = resolveLeadConsultant(lead);
  const label = isAurora ? "Aurora" : (consultor?.name?.split(" ")[0] || "Sem consultor");
  return (
    <span style={{
      display:"inline-flex", alignItems:"center", gap:4,
      background: isAurora ? "#F3EDE2" : "#EAF3EC",
      border: `1px solid ${isAurora ? "#C8A04D" : "#4A7A5C"}`,
      color: isAurora ? "#8B6F47" : "#2F5B40",
      borderRadius:99, padding:"2px 9px", fontSize:11, fontWeight:600, whiteSpace:"nowrap"
    }}>
      <span style={{ width:6, height:6, borderRadius:"50%", background: isAurora?"#C8A04D":"#4A7A5C", display:"inline-block" }} />
      {isAurora ? "🤖 Aurora" : `👤 ${label}`}
    </span>
  );
}

function LeadCard({ lead, msgs, waMsgs, replyMsgs, onClick, selected, currentUser }) {
  const today = currentDateKeySaoPaulo();
  const hasAuroraHandoff = lead.aurora_handoff === true
    || lead.aurora_handoff === 1
    || String(lead.aurora_handoff).toLowerCase() === "true";
  const isLeadReengaged = lead.lead_reengaged === true || !!lead.lead_reengagement_event_id;
  // O destaque só aparece depois que a Aurora realmente entregou o lead a um
  // responsável humano; enquanto ainda está com a Aurora, o card mantém a
  // aparência normal de automação em andamento.
  const isAuroraTransferred = hasAuroraHandoff && leadHasHumanOwnership(lead);
  const allActivity = [...Object.values(msgs||{}), ...Object.values(waMsgs||{})];
  const sortedWa    = Object.values(waMsgs||{}).sort((a,b)=>(a.timestamp>b.timestamp?1:-1));
  const sortedMsgs  = Object.values(msgs||{}).sort((a,b)=>(a.timestamp>b.timestamp?1:-1));
  const lastMsgAll  = allActivity.length > 0 ? _lastMsg(allActivity) : null;
  // "Sem resposta" só dispara quando a última mensagem é do CLIENTE (quem enviou a última)
  // Lead desqualificado, vendido ou agendado (prospecção futura/follow-up) não está mais
  // "aguardando resposta imediata" — o vermelho tem que sumir automaticamente nessas etapas.
  // Leads sob responsabilidade da Aurora também nunca acendem o badge — ela já está atendendo.
  const lastClientMsg = allActivity.filter(m=>m.remetente==='cliente').reduce((l,m)=>(_tsNum(m.timestamp)>_tsNum(l?.timestamp))?m:l, null);
  // Flag manual "aguardando retorno": consultor já respondeu (inclusive por tel/outros meios)
  // e quer suprimir o badge vermelho sem precisar enviar WhatsApp. Some ao chegar nova msg do cliente.
  const replyState = leadConversationReplyState(lead, replyMsgs || allActivity, {
    hasHumanOwnership:leadHasHumanOwnership(lead),
    isClosingMessage,
  });
  const manualWaiting = replyState === "awaiting_customer_manual";
  const isUnanswered = replyState === "needs_team_reply";
  const awaitingConsultantAfterAurora = isAuroraTransferred
    && isUnanswered && auroraHandoffAwaitsConsultant(lead, replyMsgs || allActivity);
  const hoursStale    = isUnanswered && lastClientMsg ? (Date.now()-_tsNum(lastClientMsg.timestamp))/3600000 : null;
  // Selo manual (azul, discreto): consultor já respondeu tudo e só falta o cliente decidir.
  // Some sozinho assim que chegar QUALQUER mensagem nova depois de marcado (não precisa desmarcar na mão).
  const awaitingClientReturn = manualWaiting;
  const isOverdue   = lead.proxima_data_contato && lead.proxima_data_contato < today;
  const isToday     = lead.proxima_data_contato === today;
  const hasWa       = Object.keys(waMsgs||{}).length > 0;
  const showMsg     = sortedWa[sortedWa.length-1] || sortedMsgs[sortedMsgs.length-1];
  const showTime    = lastMsgAll?.timestamp ? (() => {
    const diff = (Date.now() - new Date(lastMsgAll.timestamp).getTime()) / 60000;
    if (diff < 60) return `${Math.round(diff)}min`;
    if (diff < 1440) return `${Math.round(diff/60)}h`;
    return `${Math.round(diff/1440)}d`;
  })() : null;
  const entryDate = lead.data_criacao || lead.createdAt;
  const entryLabel = entryDate ? (() => {
    const d = toDateSafe(entryDate);
    if (!d) return "";
    const hh = String(d.getHours()).padStart(2,"0");
    const mm2 = String(d.getMinutes()).padStart(2,"0");
    return `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")} às ${hh}:${mm2}`;
  })() : "";
  const stalledDays = entryDate ? daysStalled(lastMsgAll?.timestamp || entryDate) : 0;
  return (
    <div
      onClick={onClick}
      onMouseEnter={e=>{ if(!selected) e.currentTarget.style.boxShadow="0 4px 16px rgba(200,160,77,0.18)"; }}
      onMouseLeave={e=>{ if(!selected) e.currentTarget.style.boxShadow="0 1px 4px rgba(43,27,18,0.07)"; }}
      style={{
        background: isAuroraTransferred ? "#F5F0FF" : ((isOverdue || isToday) ? "#FFF7ED" : "#fff"),
        borderRadius:12, padding:"11px 13px", marginBottom:8, cursor:"pointer",
        border: selected ? "2px solid #C8A04D" : isUnanswered ? "1.5px solid #EF4444" : isAuroraTransferred ? "1.5px solid #8B5CF6" : (isOverdue || isToday) ? "1.5px solid #D97706" : "1.5px solid #E8E1D3",
        boxShadow: selected ? "0 0 0 3px #C8A04D22" : isAuroraTransferred ? "0 0 0 2px #8B5CF622" : (isOverdue || isToday) ? "0 0 0 2px #D9770622" : "0 1px 4px rgba(43,27,18,0.07)",
        transition:"box-shadow 0.15s",
      }}
    >
      <TextSendStatus storeId={lead.lojaAtual || lead.storeId} phone={lead.telefone || lead.phone} />
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:5 }}>
        <div style={{ display:"flex", alignItems:"center", gap:5, flex:1, marginRight:6 }}>
          <span style={{ fontWeight:700, fontSize:13.5, color:"#2B1B12", letterSpacing:"-0.01em" }}>{lead.nome}</span>
          {hasWa && <span style={{ width:8, height:8, background:"#3FA76B", borderRadius:"50%", display:"inline-block", flexShrink:0 }} title="WhatsApp ativo" />}
          {lead.origem_manual && <span style={{ fontSize:9, fontWeight:800, color:"#8B6F47", background:"#F3EDE2", borderRadius:6, padding:"1px 5px", flexShrink:0 }} title="Cadastrado manualmente">✋ Manual</span>}
          {isLeadReengaged && <span style={{ fontSize:9, fontWeight:800, color:"#92400E", background:"#FEF3C7", border:"1px solid #FDE68A", borderRadius:6, padding:"1px 5px", flexShrink:0 }} title="Lead anteriormente desqualificado; retorno registrado no histórico">↩ Retorno</span>}
           {lead.aurora_handoff && (
             <span
               style={{ fontSize:9, fontWeight:800, color:"#6D28D9", background:"#F4F0FF", border:"1px solid #DDD6FE", borderRadius:6, padding:"1px 5px", flexShrink:0 }}
               title={lead.aurora_handoff_consultant_name ? `Primeiro consultor: ${lead.aurora_handoff_consultant_name}` : "Transferência automática registrada"}
             >🤖 Transferido pela Aurora</span>
           )}
        </div>
        {showTime && <span style={{ fontSize:10, color:"#9C8F7E", fontFamily:"monospace", whiteSpace:"nowrap" }}>{showTime}</span>}
      </div>
      {lead.manualSaleBinding?.status==="confirmed" && <div role="status" style={{fontSize:11,fontWeight:700,color:"#15803D",marginBottom:5}}>
        Venda #{lead.manualSaleBinding.pedidoId} vinculada
      </div>}
      {lead.produto_anuncio && (
        <div style={{ fontSize:11, color:"#8B6F47", marginBottom:5, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
          🛋️ {lead.produto_anuncio}{lead.tamanho_desejado?` · ${lead.tamanho_desejado}`:""}
          {lead.orcamento_estimado ? <span style={{ color:"#4A7A5C", marginLeft:6 }}>{lead.orcamento_estimado}</span> : ""}
        </div>
      )}
      {(lead.nome_produto_anuncio || lead.ad_id_reported || lead.aurora_status) && (
        <div style={{ fontSize:10, marginBottom:4, background:"#F4F0FF", borderRadius:5, padding:"4px 7px", border:"1px solid #DDD6FE" }}>
          <div style={{ color:"#6D28D9", fontWeight:700, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
            🤖 {lead.nome_produto_anuncio || "Qualificação Aurora"}{lead.campaign_id_reported ? ` · ${lead.campaign_id_reported}` : ""}
          </div>
          {lead.aurora_status && <div style={{ color:"#7C3AED", fontSize:9.5, marginTop:1 }}>Status: {String(lead.aurora_status).replaceAll("_"," ")}</div>}
          {lead.ad_id_reported && lead.ad_origin_confirmation!=="confirmed_real_zapi_payload" && <div style={{ color:"#8B5CF6", fontSize:9, marginTop:1 }}>Origem do anúncio aguardando confirmação Z-API</div>}
        </div>
      )}
      {(lead.link_anuncio || lead.id_anuncio_meta) && (
        <div style={{ fontSize:10, marginBottom:4, background:"#EFF6FF", borderRadius:5, padding:"3px 7px", border:"1px solid #BFDBFE" }}>
          <div style={{ display:"flex", alignItems:"center", gap:4, overflow:"hidden" }}>
            <span style={{ color:"#1D4ED8", fontWeight:700, flexShrink:0 }}>📣</span>
            {lead.link_anuncio
              ? <a href={lead.link_anuncio} target="_blank" rel="noopener noreferrer" className="ad-link"
                   style={{ color:"#2563EB", textDecoration:"none", fontWeight:700, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                  {lead.titulo_anuncio || "Ver anúncio"}
                </a>
              : <span style={{ color:"#1D4ED8", fontWeight:700 }}>{lead.titulo_anuncio || `Anúncio #${lead.id_anuncio_meta}`}</span>
            }
          </div>
          {lead.body_anuncio && (
            <div style={{ color:"#3B5EA6", fontSize:9.5, marginTop:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
              {lead.body_anuncio}
            </div>
          )}
        </div>
      )}
      {lead.origem_canal === "instagram_bio" && !lead.link_anuncio && !lead.id_anuncio_meta && (
        <div style={{ fontSize:10, marginBottom:4, background:"#FFF7ED", borderRadius:5, padding:"4px 7px", border:"1px solid #FED7AA" }}>
          <span style={{ color:"#C2410C", fontWeight:700 }}>📸 {lead.origem_descricao || "Instagram — link da bio"}</span>
        </div>
      )}
      {isUnanswered && (
        <div style={{ display:"inline-block", fontSize:10, fontWeight:800, color:"#fff", background:"#EF4444", borderRadius:99, padding:"2px 8px", marginBottom:4 }}>
          🔴 {awaitingConsultantAfterAurora
            ? "Aguardando consultor responder"
            : `Aguardando resposta${hoursStale!==null ? ` há ${hoursStale<1?`${Math.round(hoursStale*60)}min`:`${Math.round(hoursStale)}h`}` : ""}`}
        </div>
      )}
      {awaitingClientReturn && (
        <div style={{ display:"inline-block", fontSize:9.5, fontWeight:700, color:"#3B82C4", background:"#EAF3FB", borderRadius:99, padding:"2px 8px", marginBottom:4 }}>
          🔵 Aguardando retorno do cliente
        </div>
      )}
      {lead.proxima_data_contato && <div style={{ fontSize:10, fontWeight:700, color:isOverdue?"#C0392B":isToday?"#B8763E":"#9C8F7E", marginBottom:4 }}>{isOverdue?"⚠️ Atrasado":isToday?"⏰ Hoje":"📅"} {fmtDate(lead.proxima_data_contato)}</div>}
      {entryLabel && (
        <div style={{ fontSize:9.5, color:"#B0A491", marginBottom:4, display:"flex", gap:6, flexWrap:"wrap" }}>
          <span>🕐 Entrada: {entryLabel}</span>
          {stalledDays > 0 && <span>· Parado há {stalledDays}d</span>}
        </div>
      )}
      {showMsg && (
        <div style={{ fontSize:11, color:"#9C8F7E", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", borderTop:"1px solid #F3EDE2", paddingTop:5, marginTop:5 }}>
          {showMsg.remetente==="aurora"?"🤖":showMsg.remetente==="consultor"?"👤":"👥"} {showMsg.texto||showMsg.content||"📎 Mídia"}
        </div>
      )}
      <div style={{ marginTop:6, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        {(!currentUser || currentUser.role !== "consultant") && <LeadSeloResponsavel lead={lead} />}
        {lead.tentativas_followup>0 && <span style={{ fontSize:10, color:"#B8763E", fontWeight:600 }}>🔄 {lead.tentativas_followup}x</span>}
      </div>
    </div>
  );
}

export function LeadPanel({ lead, msgs, waMsgs, events={}, onClose, onUpdate, onDelete, onDeleteWhatsAppMessage=null, onSendMessage, onSendZapi, onSendZapiMedia, onLogTransfer, onAddReminder, currentUser, onRegistrarVenda, onSendQRMedia=null, onConversationActive, onCreateProspItem=null }) {
  const exitGuard = useFutureFollowUpExit(lead, `lead:${lead.lojaAtual || lead.storeId}:${normalizePhone(lead.telefone || lead.phone)}:${lead.id}`, onClose, {
    automaticExit:true,
    getDate:() => proximaData,
    onSave:async(date,context)=>{
      if([101,102,103].includes(Number(lead.storeId))) {
        const schedule=STAGES_SEM_DATA_OBRIGATORIA.has(lead._crm_estagio || lead.estagio)
          ? {...nextContactSaveChanges(lead,null,new Date().toISOString()),proxima_data_contato:null}
          : transferScheduleChanges({...lead,proxima_data_contato:date});
        return onUpdate({...lead,...schedule},{keepOpen:true});
      }
      const saved=await persistLeadAutomaticExit(lead,date,{operationId:context.reminderId});
      window.dispatchEvent(new CustomEvent("arflow:lead-automatic-exit",{detail:{lead:saved}}));
      return saved;
    },
    screen:"lead",
  });
  const explicitResponsibleStoreId = Number(lead.lojaAtual);
  const conversationResponsibleStoreId = Number(
    Number.isFinite(explicitResponsibleStoreId) && explicitResponsibleStoreId > 0
      ? explicitResponsibleStoreId
      : lead.storeId || currentUser?.storeId
  );
  useConversationPresence({
    phone:normalizePhone(lead.telefone || lead.phone),
    storeId:conversationResponsibleStoreId, module:"leads", onConversationActive,
  });
  const [estagio,             setEstagio]             = useState(lead.estagio||"chegou");
  const [responsavel,         setResponsavel]         = useState(() => leadResponsibleMode(lead));
  // Normaliza para número desde a inicialização — evita string "5" vs number 5 no Firebase
  const [selectedConsultantId,setSelectedConsultantId]= useState(() => resolveLeadConsultantId(lead));
  const [proximaData,         setProximaData]         = useState(lead.proxima_data_contato||"");
  const [tentativas,          setTentativas]          = useState(lead.tentativas_followup||0);
  const [motivo,              setMotivo]              = useState(lead.motivo_desqualificacao||lead.motivo_prospeccao_futura||"");
  const [motivoTipo,          setMotivoTipo]          = useState(lead.motivo_desqualificacao_tipo||guessMotivoTipo(lead.motivo_desqualificacao));
  const [erroDataContato, setErroDataContato] = useState(false);
  const [replyTo,     setReplyTo]     = useState(null);
  const [showTransfer,setShowTransfer]= useState(false);
  const [mobileTab, setMobileTab] = useState("chat");
  const [chatExpanded, setChatExpanded] = useState(true);
  const [roteiroModal, setRoteiroModal] = useState(null); // null | {loading:true} | {text:"..."}
  const outboundStores = leadOutboundStoreContext(lead);
  const qrStoreId  = outboundStores.channelStoreId ?? currentUser?.storeId;
  const chatRef        = useRef(null);
  useConversationDiagnosticView(conversationResponsibleStoreId, normalizePhone(lead.telefone || lead.phone), chatRef);
  const phoneClean = normalizePhone(lead.telefone);
  const conversationStoreId = conversationResponsibleStoreId;
  const conversationChannelStoreId = Number(
    lead.whatsappStoreId ?? lead.lojaOrigem ?? conversationStoreId
  );
  const leadConversationKey = conversationKey(conversationChannelStoreId, phoneClean);
  const [directConversation, setDirectConversation] = useState(null);
  const [conversationLoadState, setConversationLoadState] = useState("loading");
  const [conversationLoadError, setConversationLoadError] = useState("");
  const [conversationReloadToken, setConversationReloadToken] = useState(0);
  const [olderCursor,setOlderCursor]=useState(false);
  const activeLeadKeyRef=useRef(leadConversationKey);activeLeadKeyRef.current=leadConversationKey;
  const loadEarlierLeadMessages=async()=>{
    if(!olderCursor)return true;
    const response=await fetch(`/api/crm/leads/${conversationStoreId}/${encodeURIComponent(phoneClean)}/conversation?cursor=${encodeURIComponent(olderCursor)}`,
      {credentials:"same-origin",cache:"no-store"});
    if(!response.ok)return false;
    const payload=await response.json();
    if(activeLeadKeyRef.current!==leadConversationKey)return false;
    if(Number(payload.storeId)!==conversationChannelStoreId||payload.phone!==phoneClean)return false;
    setDirectConversation(previous=>({key:leadConversationKey,
      messages:mergeConversationMessages(previous?.messages,payload.messages)}));
    setOlderCursor(payload.older||false);
    return true;
  };
  // O lead aberto pode ser transferido pela Aurora enquanto o painel permanece
  // montado. Sincroniza somente os campos de atribuição quando o snapshot muda,
  // sem fechar a conversa nem depender de um refresh.
  useEffect(() => {
    setResponsavel(leadResponsibleMode(lead));
    setSelectedConsultantId(resolveLeadConsultantId(lead));
  }, [lead]);
  useEffect(() => {
    let cancelled = false;
    if (!leadConversationKey) {
      setConversationLoadState("error");
      setConversationLoadError("Loja ou telefone da conversa não foram identificados.");
      return () => { cancelled = true; };
    }
    setConversationLoadState("loading");
    setOlderCursor(false);
    setConversationLoadError("");
    fetch(`/api/crm/leads/${conversationStoreId}/${encodeURIComponent(phoneClean)}/conversation`, {
      credentials:"same-origin",
      cache:"no-store",
      headers:{ Accept:"application/json" },
    })
      .then(async response => {
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          const error = new Error(payload.error || "Não foi possível carregar a conversa.");
          error.status = response.status;
          throw error;
        }
        const scoped = scopedConversationCache({ conversations:[payload] }, [conversationChannelStoreId]);
        if (!cancelled) {
          setDirectConversation({
            key:leadConversationKey,
            messages:messagesForConversation(scoped, conversationChannelStoreId, phoneClean),
          });
          setConversationLoadState("loaded");
          setOlderCursor(payload.older||false);
        }
      })
      .catch(error => {
        if (cancelled) return;
        setConversationLoadState("error");
        setConversationLoadError(
          error.status === 401
            ? "Sua sessão expirou. Entre novamente para carregar a conversa."
            : error.status === 403
              ? "Você não tem permissão para visualizar este lead."
            : error.message || "Não foi possível carregar a conversa."
        );
      });
    return () => { cancelled = true; };
  }, [leadConversationKey, conversationStoreId, conversationChannelStoreId, phoneClean, conversationReloadToken]);
  const activeWaMsgs = mergeConversationMessages(
    waMsgs,
    directConversation?.key === leadConversationKey ? directConversation.messages : null,
  );
  const hasWa      = Object.keys(activeWaMsgs).length > 0;

  const _seenMsgKeys = new Set();
  const _seenTextSender = new Map(); // dedup extra: mesmo texto+remetente PERTO no tempo → remove re-entregas do n8n (não esconde mensagens novas repetidas horas/dias depois)

  // Prioriza o registro canônico do WhatsApp quando a mesma mensagem também
  // existe em arflow_lead_messages. O registro interno pode não ter
  // waMessageId, e seria escolhido pelo deduplicador antes da mensagem real,
  // deixando a exclusão para todos bloqueada mesmo após a confirmação da Z-API.
  const inheritCanonicalSendStatus = (message) => {
    if (!message || message.status || message.remetente !== "consultor") return message;
    const messageText = String(message.texto || message.message || message.text || "").trim();
    const messageTime = new Date(message.timestamp || message.createdAt || "").getTime();
    if (!messageText || Number.isNaN(messageTime)) return message;

    const canonical = Object.values(activeWaMsgs).find((candidate) => {
      if (!candidate || candidate.remetente !== "consultor" || !candidate.status) return false;
      const candidateText = String(candidate.texto || candidate.message || candidate.text || "").trim();
      const candidateTime = new Date(candidate.timestamp || candidate.createdAt || "").getTime();
      return candidateText === messageText
        && !Number.isNaN(candidateTime)
        && Math.abs(candidateTime - messageTime) <= 5000;
    });

    return canonical
      ? {
          ...message,
          status: canonical.status,
          motivo: canonical.motivo || null,
          waAck: canonical.waAck || null,
          waAckAt: canonical.waAckAt || null,
          storeId: canonical.storeId ?? message.storeId,
           providerMessageId: canonical.providerMessageId || canonical.waMessageId || null,
           providerMessageIdVerified: canonical.providerMessageIdVerified === true || canonical.waMessageIdVerified === true,
           providerSendId: canonical.providerSendId || canonical.zaapId || null,
           waMessageId: canonical.providerMessageId || canonical.waMessageId || null,
           zaapId: canonical.providerSendId || canonical.zaapId || null,
           storagePath: canonical.storagePath || message.storagePath,
           mediaPermanent: canonical.mediaPermanent === true || message.mediaPermanent === true,
        }
      : message;
  };
  void inheritCanonicalSendStatus;

  const timelineTransferEvents = transferEventsForLead(lead, events, USERS);
  const timelineTransferCycles = transferResponseCycles(timelineTransferEvents, activeWaMsgs);
  const allMsgs = useTextSendMessages([
    ...Object.entries(activeWaMsgs).map(([id,m])=>({...m,id,_src:"wa"})),
    ...Object.values(lead.systemRescheduleHistory || {}).map(event=>({
      id:`system-reschedule-${event.id}`,remetente:"sistema",timestamp:event.at,_src:"system_reschedule",
      texto:`reagendado pelo sistema — ${event.fromDate || "sem data"} → ${event.toDate || "sem data"}${event.notDoneDate?" • Afazer não feito na data original":""}`,
    })),
    ...timelineTransferCycles.flatMap(cycle=>{
      const event = cycle.event;
      const transferMessage = {
        id:event.id,
        remetente:"sistema",
        texto:`${formatTransferClock(event.timestamp)} — ${event.fromLabel} transferiu para ${event.toLabel}${event.actorLabel && event.actorLabel!==event.fromLabel?` • por ${event.actorLabel}`:""}${event.reason?` • Motivo: ${event.reason}`:""}${cycle.status==="awaiting"?"\nAguardando resposta do consultor":cycle.status==="unconfirmed"?"\nTempo de resposta não confirmado":""}`,
        timestamp:event.timestamp,
        _src:"transfer_event",
      };
      if (cycle.status !== "confirmed") return [transferMessage];
      const responseTimestamp = cycle.response.timestamp || cycle.response.createdAt;
      return [transferMessage, {
        id:`${event.id}_response`,
        remetente:"sistema",
        texto:`${formatTransferClock(responseTimestamp)} — ${event.toLabel} respondeu · Tempo após transferência: ${cycle.elapsedMinutes} min`,
        timestamp:responseTimestamp,
        _src:"transfer_response",
      }];
    }),
  ].sort((a,b)=>{
    const ta = a.timestamp||""; const tb = b.timestamp||"";
    if (!ta && !tb) return 0;
    if (!ta) return 1;
    if (!tb) return -1;
    const normalize = t => /^\d{10,}$/.test(t) ? new Date(Number(t)).toISOString() : t;
    const na = normalize(ta); const nb = normalize(tb);
    return na > nb ? 1 : na < nb ? -1 : 0;
  }).filter(m => {
    if (m.remetente === "sistema") return true;
    const hasContent = (m.texto||"").length > 0 || m.url || m.image || m.audio || m.video || m.tipo;
    if (!hasContent) return false;
    const fullTs = m.timestamp || "";
    const tsKey = /^\d{10,}$/.test(fullTs) ? new Date(Number(fullTs)).toISOString() : fullTs;
    // Dedup primário: remetente + url + texto + segundo
    const dk = m.remetente === "consultor" && m.id ? `consultor|${m.id}` : `${m.remetente}|${m.url||m.image||m.audio||m.video||""}|${(m.texto||"").slice(0,120)}|${tsKey.slice(0,19)}`;
    if (_seenMsgKeys.has(dk)) return false;
    _seenMsgKeys.add(dk);
    // Dedup secundário: para mensagens de texto puro (sem mídia), mesmo remetente+texto já visto
    // → remove re-entregas do n8n/Z-API que repetem a última mensagem do cliente horas depois
    const hasMedia = !!(m.url || m.image || m.audio || m.video || m.tipo);
    if (!hasMedia && m.remetente !== "consultor") {
      const textKey = `${m.remetente}|${(m.texto||"").trim()}`;
      const msgTime = /^\d{10,}$/.test(fullTs) ? Number(fullTs) : Date.parse(fullTs);
      const DEDUP_WINDOW_MS = 3 * 60 * 1000; // só considera re-entrega se for a mesma mensagem em até 3 min
      const prevTime = _seenTextSender.get(textKey);
      const validTimes = !isNaN(msgTime) && prevTime !== undefined && !isNaN(prevTime);
      if (validTimes && Math.abs(msgTime - prevTime) <= DEDUP_WINDOW_MS) return false;
      _seenTextSender.set(textKey, isNaN(msgTime) ? prevTime : msgTime);
    }
    return true;
  }), conversationChannelStoreId, phoneClean);
  useEffect(() => { if (chatRef.current) chatRef.current.scrollTop = chatRef.current.scrollHeight; }, [allMsgs.length]);
  const isStaff = currentUser && (currentUser.role === "admin" || currentUser.role === "manager");
  const transferDestinations = leadTransferDestinations(USERS, currentUser || {}, lead);
  const inp = { padding:"6px 8px", borderRadius:8, border:"1.5px solid #E8E1D3", fontSize:12, width:"100%", boxSizing:"border-box", background:"#fff", color:"#2B1B12" };

  // Estágios terminais que não precisam de data de próximo contato
  const STAGES_SEM_DATA_OBRIGATORIA = new Set(["desqualificado","fechou_venda"]);
  // Lead novo só fica vermelho enquanto aguarda a primeira resposta humana.
  // A obrigatoriedade de follow-up começa depois que o consultor enviou algo.
  const hasConsultantReply = allMsgs.some(m => m.remetente === "consultor" || m.fromMe === true);
  const currentLeadConsultantId = resolveLeadConsultantId(lead);
  const selectedTransferId = responsavel === "consultor" ? Number(selectedConsultantId) || null : null;
  const isTransferPending = (responsavel === "aurora" && lead.responsavel !== "aurora")
    || (responsavel === "consultor" && (
      lead.responsavel === "aurora"
      || (selectedTransferId != null && selectedTransferId !== currentLeadConsultantId)
    ));
  const mustScheduleFollowUp = !isTransferPending
    && currentUser?.role === "consultant"
    && hasConsultantReply
    && !STAGES_SEM_DATA_OBRIGATORIA.has(estagio)
    && !persistedRecordIsReferral(lead);
  const saveLeadInFlight = useRef(false);
  const [savingLead, setSavingLead] = useState(false);
  const handleSave = async () => {
    if (saveLeadInFlight.current) return;
    saveLeadInFlight.current = true;
    setSavingLead(true);
    try {
    const timing = proximaData && estagio !== "desqualificado"
      && (proximaData !== lead.proxima_data_contato || !hasValidFutureNextContactDate(lead))
      ? createNextContactTiming("lead") : null;
    if (manualSaleWriteDenied({
      user:currentUser,
      previousStage:lead?._crm_estagio ?? lead?.estagio,
      nextStage:estagio,
      saleStages:["fechou_venda"],
    })) {
      timing?.finish("failed");
      alert(MANUAL_SALE_CUTOFF_NOTICE);
      return;
    }
    // Não bloqueia a simples visualização de um lead novo. Só exige a data após
    // uma resposta humana ter sido enviada na conversa.
    // Leads no longer require typing a date to save/close. The exit command
    // confirms tomorrow/the retained date and reconciles the same reminder.
    setErroDataContato(false);
    // Resolve o consultantId correto para salvar:
    // 1. Preferência: seleção explícita pelo UI (selectedConsultantId)
    // 2. Fallback: consultor logado (auto-atribuição quando nenhum foi selecionado e o lead ainda não tem dono)
    // 3. Fallback: consultantId já gravado no lead (mudança de estágio sem mexer no responsável)
    // Sempre salva como number (Firebase RTDB pode devolver string; === falharia no lookup depois)
    const consultantId = responsavel === "consultor"
      ? (Number(selectedConsultantId) || (currentUser?.role === "consultant" ? currentUser.id : null) || Number(lead.consultantId) || null)
      : null;
    const oldName = lead.responsavel === "aurora" ? "Aurora" : (USERS.find(u=>u.id===lead.consultantId)?.name?.split(" ")[0] || "Consultor");
    const newConsultant = USERS.find(u=>u.id===consultantId);
    const newName = responsavel === "aurora" ? "Aurora" : (newConsultant?.name?.split(" ")[0] || currentUser?.name?.split(" ")[0] || "Consultor");
    if (lead.responsavel !== responsavel && onLogTransfer) onLogTransfer(lead.id, oldName, newName);
    // Consultor assumiu o lead (não Aurora) — avisa o n8n pra travar a Aurora nesse telefone.
    if (responsavel === "consultor" && consultantId && (lead.responsavel !== "consultor" || lead.consultantId !== consultantId)) {
      // lead._rawPhone pode ser "storeId_phone" (chave composta) — usar telefone real para notificação
      const phoneForNotify = (lead.telefone||"").replace(/\D/g,"") || lead._rawPhone;
      if (phoneForNotify) {
        fetch('/api/notify-consultant-assumed', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone: phoneForNotify, consultor: newName, consultantId }),
        }).catch(()=>{});
      }
    }
    // Transferência nunca altera o estágio comercial do lead — só muda o responsável.
    // (Antes havia um auto-avanço para "Vai na Loja" que foi removido pois causava
    //  regressão de estágio em transferências consultor→consultor.)
    const autoEstagio = estagio;
    // The exit command updates the same pending reminder; never replace an
    // overdue reminder here or pretend that rescheduling completed it.
    // Transferência cross-store: gerente OU admin move lead para consultor de outra loja
    const newConsultantStoreId = newConsultant?.storeId;
    const currentResponsibleStoreId = leadResponsibleStoreId(lead) || Number(lead.storeId);
    const needsStoreRepair = !!(
      newConsultantStoreId
      && Number(newConsultantStoreId) !== Number(lead.storeId)
    );
    // Registro de auditoria para qualquer transferência consultor→consultor (mesma loja ou cross-store)
    const isConsultantTransfer = responsavel === "consultor" && consultantId &&
      (lead.consultantId !== consultantId || lead.responsavel !== "consultor");
    let crossStoreExtra = {};
    if (isConsultantTransfer) {
      const lojaAnteriorNome = STORES.find(s=>s.id===Number(currentResponsibleStoreId))?.name || `Loja ${currentResponsibleStoreId}`;
      const lojaDestinoId    = Number(newConsultantStoreId || currentResponsibleStoreId);
      const lojaDestinoNome  = STORES.find(s=>s.id===lojaDestinoId)?.name || `Loja ${lojaDestinoId}`;
      const novaEntrada = {
        de:                oldName,
        para:              newName,
        lojaAnterior:      Number(currentResponsibleStoreId),
        lojaAnteriorNome,
        lojaDestino:       lojaDestinoId,
        lojaDestinoNome,
        consultorAnterior: lead.consultantId || null,
        consultorDestino:  consultantId,
        transferidoPor:    currentUser?.name || currentUser?.username || "Sistema",
        data:              new Date().toISOString(),
      };
      // Converte array normalizado → objeto keyed (previne array-coercion no Firebase RTDB)
      const historicoObj = {};
      const existingHist = lead.historicoTransferencias || {};
      const histArr = Array.isArray(existingHist) ? existingHist : Object.values(existingHist);
      histArr.forEach((h, i) => { historicoObj[`t_${i}`] = h; });
      historicoObj[`t_${Date.now()}`] = novaEntrada;
      crossStoreExtra = {
        ...(needsStoreRepair ? {
          storeId:    Number(newConsultantStoreId),
          lojaAtual:  Number(newConsultantStoreId),
          lojaOrigem: lead.lojaOrigem ?? Number(lead.storeId),
          whatsappStoreId: lead.whatsappStoreId ?? lead.lojaOrigem ?? Number(lead.storeId),
        } : {}),
        consultorAtual:          consultantId,
        historicoTransferencias: historicoObj,
      };
    }
    const savedLead = {
      ...lead, estagio:autoEstagio, responsavel, proxima_data_contato:proximaData, tentativas_followup:tentativas,
      ...(proximaData && autoEstagio !== "desqualificado"
        ? nextContactSaveChanges(lead, proximaData, new Date().toISOString()) : {}),
      consultantId,
      desqualificado: autoEstagio === "desqualificado",
      ...crossStoreExtra,
      ...(autoEstagio==="desqualificado"    ? {motivo_desqualificacao:motivo, motivo_desqualificacao_tipo:motivoTipo} : {}),
      ...(autoEstagio==="desqualificado" ? {
        desqualificado_em: (
          lead.desqualificado === true
          || [lead.estagio, lead._crm_estagio, lead.status, lead.stage]
            .some(stage => ["desqualificado","sem_interesse","seminteresse"].includes(String(stage || "").toLowerCase()))
        )
          ? (lead.desqualificado_em || lead.desqualificadoEm || lead.disqualifiedAt || lead.disqualified_at || new Date().toISOString())
          : new Date().toISOString(),
      } : {}),
      ...(autoEstagio==="prospeccao_futura" ? {motivo_prospeccao_futura:motivo} : {}),
    };
    try {
      if (timing && autoEstagio !== "desqualificado" && !onAddReminder) {
        throw new Error("Criação do afazer indisponível.");
      }
      const persisted = await Promise.resolve(onUpdate(savedLead));
      timing?.cardConfirmed();
      exitGuard.saved(confirmedLeadForExit(savedLead, persisted));
      timing?.finish(activeConversationExitGuard.canExit() ? "released" : "blocked");
      exitGuard.close();
    } catch (error) {
      timing?.finish("failed");
      alert(error?.message || "Não foi possível salvar o lead. Tente novamente.");
    }
    } finally {
      saveLeadInFlight.current = false;
      setSavingLead(false);
    }
  };

  // Todas as lojas usam a mesma confirmação persistida; não registrar história
  // otimista nem deixar uma segunda gravação do formulário repetir a transferência.
  const transferToConsultant = async target => {
    if (!target?.id || saveLeadInFlight.current
      || !transferDestinations.some(user => Number(user.id) === Number(target.id))) return;
    if (Number(resolveLeadConsultantId(lead)) === Number(target.id)) return;
    saveLeadInFlight.current = true;
    setSavingLead(true);
    try {
      const updated = { ...lead, responsavel:"consultor", consultantId:Number(target.id),
        consultorAtual:Number(target.id), assignedConsultantId:Number(target.id),
        storeId:Number(target.storeId), _transferOnly:true };
      const confirmed = await onUpdate(updated, {keepOpen:true});
      if (!confirmed || Number(confirmed.consultantId) !== Number(target.id)
        || Number(confirmed.storeId) !== Number(target.storeId)) {
        throw new Error("A transferência ainda não foi confirmada. Atualize a lista antes de tentar novamente.");
      }
      exitGuard.saved(confirmedLeadForExit(transferBusinessPatch(updated), confirmed));
      setShowTransfer(false);
      // O remetente já não é responsável: a data confirmada pertence ao
      // destinatário. Não reaplicar o rascunho antigo na trava de saída.
      exitGuard.dismiss();
    } catch (error) {
      alert(error?.message || "Não foi possível confirmar a transferência. Tente novamente.");
    } finally {
      saveLeadInFlight.current = false;
      setSavingLead(false);
    }
  };

  // Callback de envio de texto — recebe (text, quotedId) do ChatComposerBar
  const handleLeadSend = async (text, quotedId, quotedMsg, transportOptions) => {
    if (!text?.trim() || !phoneClean || !onSendZapi) {
      return { ok:false, error:"Não foi possível identificar o WhatsApp deste lead." };
    }
    const cName = currentUser?.name?.split(" ")[0] || "Consultor";
    const result = await onSendZapi(phoneClean, text, { name:cName }, quotedId, outboundStores, quotedMsg, null, transportOptions);
    if (!isConfirmedTextSend(result)) return result;
    // Only an accepted send may advance/assign a lead. The queue-backed
    // canonical conversation supplies the message; never fabricate a second
    // human message in the legacy lead history.
    try {
    // Ao enviar a primeira mensagem humana, avança automaticamente de "Chegou" → "Em conversa".
    // Só dispara se o lead ainda está em "chegou" — outros estágios não são alterados.
    const currentEstagio = lead.estagio || "chegou";
    if (currentEstagio === "chegou" && onUpdate) {
      const updates = { ...lead, estagio: "qualificacao" };
      // Se ainda não tem consultor atribuído, aproveita e atribui agora
      if (currentUser?.role === "consultant" && !lead.consultantId) {
        updates.consultantId = currentUser.id;
        updates.responsavel  = "consultor";
      }
      // A mudança automática de etapa não é um salvamento/fechamento do lead.
      // O consultor precisa continuar na mesma conversa depois de enviar a 1ª msg.
      await onUpdate(updates, { keepOpen:true });
      setEstagio("qualificacao");
    } else if (currentUser?.role === "consultant" && !lead.consultantId && onUpdate) {
      // Auto-atribui consultantId ao lead na primeira mensagem do consultor (qualquer estágio)
      await onUpdate({ ...lead, consultantId: currentUser.id, responsavel: "consultor" }, { keepOpen:true });
    }
    } catch (error) {
      // Queue acceptance cannot be undone by a secondary UI update failure.
      console.error("[lead] mensagem aceita, mas atualização do lead falhou", error);
    }
    return result;
  };

  // Callback de nota interna — recebe (text) do ChatComposerBar
  const handleLeadNote = (text) => {
    const timestamp = new Date().toISOString();
    const note = {
      remetente: "nota_interna", texto: text,
      timestamp,
      autor: currentUser?.name || currentUser?.username || "",
      storeId: conversationChannelStoreId,
    };
    // Keep the legacy lead timeline for compatibility, but make the
    // store-scoped conversation the durable source shared by every screen.
    onSendMessage(lead.id, note);
    const noteId = `note_${Date.now()}`;
    const notePath = conversationMessagePath(conversationChannelStoreId, phoneClean, noteId);
    if (notePath) set(dbRef(notePath), note).catch(error => {
      console.error("[CRM] não foi possível salvar nota no histórico canônico:", error);
    });
  };

  // T005 — Ferramenta de correção de origem (Gestor Geral): corrige cadastros
  // antigos que entraram como Lead antes da automação parar de mudar a origem de quem
  // nasceu em Prospecção/Atendimento. Cria o registro no módulo correto preservando
  // telefone/consultor e remove o Lead — nunca mistura os dois cadastros.
  const returnLeadToModule = async (targetModule) => {
    if (!phoneClean) { alert("Lead sem telefone válido — não é possível corrigir a origem."); return; }
    const label = targetModule === "prospeccao" ? "Prospecção" : "Atendimento Presencial";
    if (!window.confirm(`Corrigir origem: mover "${lead.nome||lead.telefone}" para ${label}?\n\nUm novo cadastro será criado em ${label} (mesmo telefone e consultor) e este Lead será removido.`)) return;
    // Authorize and close before starting any read/write in the move flow.
    // React state updates do not interrupt the current callback; the captured
    // lead data remains available to the asynchronous persistence chain.
    return exitGuard.close(async () => {
    if (targetModule === "prospeccao") {
      if (!onCreateProspItem) {
        alert("Não foi possível criar o cartão de prospecção nesta tela. Abra a Central de Conversas e tente novamente.");
        return;
      }
      const now = new Date().toISOString();
      const today = now.split("T")[0];
      const entry = {
        id:createProspectId(),
        name:lead.nome || lead.name || lead.telefone,
        phone:phoneClean,
        consultantId:lead.consultantId || null,
        storeId:lead.storeId || currentUser?.storeId || 1,
        createdAt:lead.createdAt || now,
        product:lead.produto_anuncio || "",
        value:0,
        note:`Origem corrigida de Lead para Prospecção por ${currentUser?.name||"Administrador"} em ${today}.`,
        correctedFromLead:true,
        stage:"respondeu",
      };
      try {
        const results = await onCreateProspItem([entry]);
        const savedResult = firstConfirmedProspectWrite(results);
        if (!savedResult || savedResult.stale || !savedResult.record) {
          throw new Error("O servidor não confirmou o novo cartão.");
        }
        if (onDelete) await onDelete(lead.id);
      } catch (error) {
        if (!["prosp_scope_changed", "prosp_stale_response", "crm_session_expired"].includes(error?.code)) {
          alert(error.message || "Não foi possível criar o cartão de prospecção.");
        }
      }
      return;
    }
    fetch('/api/crm/leads/correct-to-physical',{
      method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({leadKey:lead._rawPhone||String(lead.id).replace(/^aurora_/,''),
        expectedConsultantId:resolveLeadConsultantId(lead)}),
    }).then(async response=>{
      const result=await response.json();
      if(!response.ok||!result.ok)throw Error(result.error||'Correção não confirmada');
      if(onDelete)await onDelete(lead.id);
    }).catch(error=>alert(error.message||'Não foi possível corrigir a origem.'));
    });
  };

  const stageObj = LEAD_STAGES.find(s=>s.id===estagio) || LEAD_STAGES[0];
  const isMobile = window.innerWidth < 768;
  const nuFull = !isMobile && isNewUiEnabled();
  const hasRegisteredSale = lead.estagio === "fechou_venda" && Number(lead.valor_venda) > 0;
  const registeredSaleSummary = hasRegisteredSale && (
    <div style={{ background:"#ECFDF5", border:"1.5px solid #86EFAC", borderRadius:10, padding:"10px 11px", color:"#166534" }}>
      <div style={{ fontSize:12, fontWeight:800, marginBottom:5 }}>✅ Venda registrada</div>
      <div style={{ fontSize:16, fontWeight:900 }}>{fmt(lead.valor_venda)}</div>
      <div style={{ fontSize:11, marginTop:3 }}>{lead.produto_venda || lead.produto_anuncio || "Produto não informado"}</div>
      {lead.data_fechamento && <div style={{ fontSize:10, marginTop:3 }}>🗓 Venda: {fmtDate(lead.data_fechamento)}</div>}
      {lead.forma_pagamento && <div style={{ fontSize:10, marginTop:2 }}>💳 {lead.forma_pagamento}</div>}
      {lead.observacoes_venda && <div style={{ fontSize:10, marginTop:4, color:"#2F6E50" }}>💬 {lead.observacoes_venda}</div>}
      {(lead.deliveryDate || lead.followUp || lead.posVendaDate || lead.nextSaleDate) && (
        <div style={{ marginTop:6, paddingTop:6, borderTop:"1px solid #BBF7D0", fontSize:10, display:"flex", flexDirection:"column", gap:2 }}>
          {lead.deliveryDate && <span>📦 Entrega: {fmtDate(lead.deliveryDate)}</span>}
          {lead.followUp && <span>📅 Follow-up: {fmtDate(lead.followUp)}</span>}
          {lead.posVendaDate && <span>⭐ Pós-venda: {fmtDate(lead.posVendaDate)}</span>}
          {lead.nextSaleDate && <span>🔄 Próxima venda: {fmtDate(lead.nextSaleDate)}{lead.nextSaleNote ? ` · ${lead.nextSaleNote}` : ""}</span>}
        </div>
      )}
    </div>
  );

  // ── Gerar Roteiro via Aurora Helper ──────────────────────────────────────
  const handleGerarRoteiro = () => setRoteiroModal({ chooser: true });

  // ── painel de detalhes à direita (desktop) ─────────────────────────────
  const detailsPanel = !isMobile && (
    <div style={{ width:nuFull ? 360 : 260, flexShrink:0, borderLeft:"1.5px solid #E8E1D3", background:"#FAF6EF", display:"flex", flexDirection:"column", overflowY:"auto" }}>
      <div style={{ padding:"14px 14px 18px", display:"flex", flexDirection:"column", gap:10 }}>
        <div style={{ fontSize:11, fontWeight:800, color:"#8B6F47", letterSpacing:0.3, marginBottom:2 }}>📋 Detalhes do Lead</div>
        {hasRegisteredSale ? registeredSaleSummary : onRegistrarVenda && (
          <ManualSaleAction currentUser={currentUser} onClick={onRegistrarVenda}
            style={{ background:"#10B981", color:"#fff", border:"none", borderRadius:10, padding:"9px 12px", fontSize:12, fontWeight:800, cursor:"pointer", width:"100%" }}
            noticeStyle={{ background:"#FEF9F0", border:"1px solid #D4C5A9", borderRadius:8, padding:"9px 12px" }} />
        )}
        <button onClick={handleGerarRoteiro}
          style={{ background:"#F3EDE2", color:"#8B6F47", border:"1px solid #D4C5A9", borderRadius:10, padding:"8px 12px", fontSize:12, fontWeight:700, cursor:"pointer", width:"100%", textAlign:"left" }}
        >🎯 Gerar Roteiro</button>
        {/* Responsável + Loja + Transferir */}
        <div style={{ display:"flex", flexWrap:"wrap", alignItems:"center", gap:6 }}>
          <LeadSeloResponsavel lead={{ ...lead, responsavel, consultantId: responsavel==="consultor"?(selectedConsultantId||lead.consultantId):null }} />
          {(lead.lojaOrigem ?? lead.storeId) && (() => { const lojaId = lead.lojaOrigem ?? lead.storeId; const sn = STORES.find(s=>s.id===Number(lojaId))?.name; return sn ? <span style={{ display:"inline-flex", alignItems:"center", gap:4, background:"#EEF2FF", border:"1px solid #A5B4FC", color:"#4338CA", borderRadius:99, padding:"2px 9px", fontSize:11, fontWeight:600, whiteSpace:"nowrap" }}>🏪 {sn}</span> : null; })()}
          <button
            onClick={()=>setShowTransfer(t=>!t)}
            style={{ display:"inline-flex", alignItems:"center", gap:4, background:"#fff", border:"1px solid #C8A04D", color:"#8B6F47", borderRadius:99, padding:"3px 10px", fontSize:10, fontWeight:700, cursor:"pointer" }}
          >⇄ Transferir</button>
          {lead.responsavel==="consultor" && (isStaff||lead.consultantId===currentUser?.id) && (
            <button
              onClick={()=>exitGuard.close(()=>{ const fn=USERS.find(u=>u.id===lead.consultantId)?.name?.split(" ")[0]||"Consultor"; if(onLogTransfer)onLogTransfer(lead.id,fn,"Aurora"); onUpdate({...lead,...nextContactSaveChanges(lead,proximaData,new Date().toISOString()),proxima_data_contato:proximaData,responsavel:"aurora",consultantId:null}); })}
              style={{ background:"#F3EDE2", color:"#8B6F47", border:"none", borderRadius:8, padding:"3px 9px", fontSize:10, fontWeight:700, cursor:"pointer" }}
            >🤖 → Aurora</button>
          )}
        </div>
         {lead.aurora_handoff && (
           <div style={{ background:"#F4F0FF", border:"1px solid #DDD6FE", borderRadius:9, padding:"8px 9px", color:"#6D28D9" }}>
             <div style={{ fontSize:11, fontWeight:800 }}>🤖 Transferido pela Aurora</div>
             <div style={{ fontSize:10, marginTop:3 }}>
               Primeiro consultor: <strong>{lead.aurora_handoff_consultant_name || "não identificado"}</strong>
             </div>
             {lead.aurora_handoff_at && (
               <div style={{ fontSize:9.5, marginTop:2, color:"#7C3AED" }}>
                 {new Date(lead.aurora_handoff_at).toLocaleString("pt-BR")}
               </div>
             )}
           </div>
         )}
        {showTransfer && (
          <div style={{ background:"#fff", borderRadius:10, border:"1px solid #E8E1D3", padding:"8px 6px" }}>
            <div style={{ fontSize:10, color:"#8B6F47", fontWeight:700, padding:"0 6px 6px" }}>Transferir para:</div>
            <div onClick={()=>{ setResponsavel("aurora"); setSelectedConsultantId(null); setShowTransfer(false); }} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"6px 10px", borderRadius:8, cursor:"pointer", color:"#2B1B12", fontSize:13 }} onMouseEnter={e=>e.currentTarget.style.background="#FAF6EF"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              🤖 Aurora <span style={{ color:"#C8A04D" }}>›</span>
            </div>
            {transferDestinations.map(u=>(
              <div key={u.id} onClick={()=>transferToConsultant(u)} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"6px 10px", borderRadius:8, cursor:"pointer", color:"#2B1B12", fontSize:13 }} onMouseEnter={e=>e.currentTarget.style.background="#FAF6EF"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                👤 {u.name.split(" ")[0]} · {STORES.find(store=>store.id===u.storeId)?.name} <span style={{ color:"#C8A04D" }}>›</span>
              </div>
            ))}
          </div>
        )}
        {/* Etapa */}
        <div>
          <label style={{ fontSize:10, fontWeight:700, color:"#8B6F47", display:"block", marginBottom:3 }}>Etapa</label>
          <LiftSaleStageSelect moduleId="leads" record={lead} value={estagio} saleStage="fechou_venda"
            options={LEAD_STAGES} onChange={setEstagio} style={inp}
            onLinked={card=>{setEstagio(card._crm_estagio||card.estagio);setProximaData("");exitGuard.saved(card);}}/>
        </div>
        {/* Próx. Contato */}
        <div id="lead-proxima-data">
          <label style={{ fontSize:10, fontWeight:700, color:"#8B6F47", display:"block", marginBottom:3 }}>Próx. Contato (opcional)</label>
          <input
            type="date"
            value={proximaData}
            onChange={e=>{ setProximaData(e.target.value); if(e.target.value) setErroDataContato(false); }}
            style={{ ...inp, border: erroDataContato ? "2px solid #EF4444" : inp.border, background: erroDataContato ? "#FEF2F2" : inp.background }}
          />
          {erroDataContato && mustScheduleFollowUp && (
            <div style={{ fontSize:11, color:"#EF4444", marginTop:4, fontWeight:600 }}>
              {!proximaData
                ? "Agende o próximo contato antes de fechar esta conversa."
                : "Clique em Salvar para registrar a data antes de fechar."}
            </div>
          )}
          <div style={{fontSize:11,color:"#8B6F47",marginTop:4}}>
            Ao fechar: sem data ou vencida, amanhã; data válida, mantém. Venda fechada e desqualificado ficam sem data.
          </div>
        </div>
        {/* Motivo */}
        {(estagio==="desqualificado"||estagio==="prospeccao_futura") && (
          <div>
            <label style={{ fontSize:10, fontWeight:700, color:"#8B6F47", display:"block", marginBottom:3 }}>{estagio==="desqualificado"?"Motivo desqualificação":"Motivo prosp. futura"}</label>
            {estagio==="desqualificado" && (
              <select value={motivoTipo} onChange={e=>setMotivoTipo(e.target.value)} style={{ ...inp, marginBottom:6, background:"#fff" }}>
                <option value="">Selecione o motivo…</option>
                {DESQUALIFICACAO_REASONS.map(r=><option key={r.id} value={r.id}>{r.label}</option>)}
              </select>
            )}
            <textarea value={motivo} onChange={e=>setMotivo(e.target.value)} rows={3} placeholder={estagio==="desqualificado"?"Detalhes (opcional)":""} style={{ ...inp, resize:"vertical" }} />
          </div>
        )}
        {/* Follow-ups */}
        <div>
          <label style={{ fontSize:10, fontWeight:700, color:"#8B6F47", display:"block", marginBottom:3 }}>Follow-ups</label>
          <input type="number" min="0" value={tentativas} onChange={e=>setTentativas(parseInt(e.target.value)||0)} style={inp} />
        </div>
        {/* Resumo Aurora + Anúncio */}
        {(lead.produto_anuncio||lead.orcamento_estimado||lead.link_anuncio||lead.id_anuncio_meta||lead.origem_canal==="instagram_bio") && (
          <div style={{ background:"#fff", borderRadius:8, padding:"8px 10px", border:"1px solid #E8E1D3" }}>
            <div style={{ fontSize:10, fontWeight:700, color:"#8B6F47", marginBottom:4 }}>🏷 Aurora capturou</div>
            {lead.produto_anuncio && <div style={{ fontSize:11, color:"#2B1B12" }}><span style={{ color:"#9C8F7E" }}>Produto: </span>{lead.produto_anuncio}{lead.tamanho_desejado?` · ${lead.tamanho_desejado}`:""}</div>}
            {lead.orcamento_estimado && <div style={{ fontSize:11, color:"#2B1B12", marginTop:2 }}><span style={{ color:"#9C8F7E" }}>Orçamento: </span>{lead.orcamento_estimado}</div>}
            {lead.origem_canal === "instagram_bio" && !lead.link_anuncio && !lead.id_anuncio_meta && (
              <div style={{ marginTop:6, background:"#FFF7ED", borderRadius:6, padding:"5px 8px", border:"1px solid #FED7AA", color:"#C2410C", fontSize:10, fontWeight:700 }}>
                📸 {lead.origem_descricao || "Instagram — link da bio"}
              </div>
            )}
            {(lead.link_anuncio||lead.id_anuncio_meta) && (
              <div style={{ marginTop:6, background:"#EFF6FF", borderRadius:6, padding:"5px 8px", border:"1px solid #BFDBFE" }}>
                <div style={{ fontSize:10, fontWeight:700, color:"#1D4ED8", marginBottom:2 }}>📣 Origem do anúncio</div>
                {lead.titulo_anuncio && <div style={{ fontSize:11, color:"#1E40AF" }}>{lead.titulo_anuncio}</div>}
                {lead.body_anuncio   && <div style={{ fontSize:10.5, color:"#3B5EA6", marginTop:1 }}>{lead.body_anuncio}</div>}
                {lead.tipo_anuncio   && <div style={{ fontSize:10, color:"#6B7280", marginTop:1 }}>Tipo: {lead.tipo_anuncio}</div>}
                {lead.id_anuncio_meta&& <div style={{ fontSize:10, color:"#6B7280" }}>ID Meta: {lead.id_anuncio_meta}</div>}
                {lead.link_anuncio && (
                  <a href={lead.link_anuncio} target="_blank" rel="noopener noreferrer" className="ad-link"
                     style={{ display:"inline-block", marginTop:4, fontSize:11, fontWeight:700, color:"#2563EB", textDecoration:"none", background:"#DBEAFE", borderRadius:5, padding:"2px 8px" }}>
                    🔗 Ver anúncio
                  </a>
                )}
              </div>
            )}
          </div>
        )}
        {/* Salvar */}
        <button onClick={handleSave} disabled={savingLead} style={{ background:"linear-gradient(135deg,#C8A04D,#8B6F47)", color:"#fff", border:"none", borderRadius:10, padding:"10px 0", fontWeight:700, fontSize:13, cursor:"pointer", width:"100%", marginTop:4 }}>
          {savingLead ? "Salvando…" : "Salvar ✓"}
        </button>
        {currentUser?.role==="admin" && (
          <div style={{ display:"flex", flexDirection:"column", gap:4, marginTop:8, paddingTop:8, borderTop:"1px dashed #E8E1D3" }}>
            <div style={{ fontSize:9.5, fontWeight:700, color:"#9C8F7E", textTransform:"uppercase", letterSpacing:0.4 }}>Correção de origem (cadastro antigo)</div>
            <button onClick={()=>returnLeadToModule("prospeccao")} style={{ background:"#FAF6EF", color:"#8B6F47", border:"1px solid #C8A04D", borderRadius:10, padding:"7px 0", fontWeight:700, fontSize:11.5, cursor:"pointer", width:"100%" }}>
              ↩️ Retornar para Prospecção
            </button>
            <button onClick={()=>returnLeadToModule("atendimento")} style={{ background:"#FAF6EF", color:"#8B6F47", border:"1px solid #C8A04D", borderRadius:10, padding:"7px 0", fontWeight:700, fontSize:11.5, cursor:"pointer", width:"100%" }}>
              ↩️ Retornar para Atendimento Presencial
            </button>
          </div>
        )}
        {currentUser?.role==="admin" && onDelete && (
          <button onClick={() => { if(window.confirm("Tem certeza que deseja excluir este Lead? Essa ação não poderá ser desfeita.")) exitGuard.close(()=>onDelete(lead.id)); }} style={{ background:"#fff", color:"#C0392B", border:"2px solid #C0392B", borderRadius:"10px", padding:"9px 0", fontWeight:700, fontSize:13, cursor:"pointer", width:"100%", marginTop:4 }}>
            🗑 Excluir Lead
          </button>
        )}
      </div>
    </div>
  );

  return (
    <div className={nuFull ? "nu-lead-full" : undefined} style={isMobile
      ? { position:"fixed", inset:0, zIndex:500, background:"#FFFFFF", display:"flex", flexDirection:"column", overflowY:"hidden" }
      : nuFull
        ? { position:"fixed", top:0, right:0, bottom:0, zIndex:60, background:"#FFFFFF", display:"flex", flexDirection:"row", boxShadow:"-12px 0 32px rgba(0,0,0,0.10)" }
        : { width: chatExpanded ? (460+260) : 460, flexShrink:0, borderLeft:"1.5px solid #E8E1D3", background:"#FFFFFF", display:"flex", flexDirection:"row", height:"100%", transition:"width 0.2s ease" }
    }>
      {nuFull && <style>{`
.nu-lead-full { left: 248px; }
@media (max-width: 899px) { .nu-lead-full { left: 0; } }`}</style>}

      {/* ── COLUNA DE CHAT (esquerda / centro) ──────────────────────── */}
      <div style={{ flex:1, display:"flex", flexDirection:"column", minWidth:0, height:"100%", overflow:"hidden" }}>

      {/* Header fino */}
      <div style={{ padding:"8px 12px", borderBottom:"1.5px solid #E8E1D3", flexShrink:0, background:"#fff" }}>
        <div style={{ display:"flex", alignItems:"center", gap:6 }}>
          {isMobile && (
            <button onClick={exitGuard.close} style={{ background:"#F3EDE2", border:"none", borderRadius:99, width:32, height:32, cursor:"pointer", fontSize:18, display:"flex", alignItems:"center", justifyContent:"center", color:"#8B6F47", flexShrink:0 }}>←</button>
          )}
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ display:"flex", alignItems:"center", gap:6 }}>
              <span style={{ fontWeight:800, fontSize:15, color:"#2B1B12", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{lead.nome}</span>
              {hasWa && <span style={{ width:8, height:8, background:"#3FA76B", borderRadius:"50%", display:"inline-block", flexShrink:0 }} title="WhatsApp ativo" />}
              {lead.origem_manual && <span style={{ fontSize:9, fontWeight:800, color:"#8B6F47", background:"#F3EDE2", borderRadius:6, padding:"1px 6px", flexShrink:0 }} title="Cadastrado manualmente">✋ Lead manual</span>}
            </div>
            {lead.telefone && <div style={{ fontSize:10, color:"#9C8F7E", fontFamily:"monospace" }}>📱 {lead.telefone}</div>}
            {(lead.lojaOrigem ?? lead.storeId) && (() => { const lojaId = lead.lojaOrigem ?? lead.storeId; const sn = STORES.find(s=>s.id===Number(lojaId))?.name; return sn ? <div style={{ fontSize:10, color:"#8B6F47", fontWeight:700 }}>🏪 {sn}</div> : null; })()}
          </div>
          {/* Badge responsável (desktop inline) */}
          {!isMobile && <LeadSeloResponsavel lead={{ ...lead, responsavel, consultantId: responsavel==="consultor"?(selectedConsultantId||lead.consultantId):null }} />}
          {/* Transferir */}
          {!isMobile && (
            <button
              onClick={()=>setShowTransfer(t=>!t)}
              style={{ display:"inline-flex", alignItems:"center", gap:4, background:"#FAF6EF", border:"1px solid #C8A04D", color:"#8B6F47", borderRadius:99, padding:"3px 10px", fontSize:10, fontWeight:700, cursor:"pointer", flexShrink:0 }}
            >⇄ Transferir</button>
          )}
          {/* → Aurora (desktop) */}
          {!isMobile && lead.responsavel==="consultor" && (isStaff||lead.consultantId===currentUser?.id) && (
            <button
              onClick={()=>exitGuard.close(()=>{ const fn=USERS.find(u=>u.id===lead.consultantId)?.name?.split(" ")[0]||"Consultor"; if(onLogTransfer)onLogTransfer(lead.id,fn,"Aurora"); onUpdate({...lead,...nextContactSaveChanges(lead,proximaData,new Date().toISOString()),proxima_data_contato:proximaData,responsavel:"aurora",consultantId:null}); })}
              style={{ background:"#F3EDE2", color:"#8B6F47", border:"none", borderRadius:8, padding:"3px 9px", fontSize:10, fontWeight:700, cursor:"pointer", flexShrink:0 }}
            >🤖 Aurora</button>
          )}
          {/* Toggle painel detalhes (desktop) */}
          {!isMobile && (
            <button onClick={()=>setChatExpanded(e=>!e)} title={chatExpanded?"Ocultar detalhes":"Ver detalhes do lead"} style={{ background: chatExpanded?"#E8E1D3":"#F3EDE2", border:"none", borderRadius:8, width:30, height:30, cursor:"pointer", fontSize:13, display:"flex", alignItems:"center", justifyContent:"center", color:"#8B6F47", flexShrink:0 }}>
              {chatExpanded ? "◀" : "▶"}
            </button>
          )}
          {/* Fechar */}
          {!isMobile && !nuFull && (
            <button onClick={exitGuard.close} style={{ background:"#F3EDE2", border:"none", borderRadius:99, width:30, height:30, cursor:"pointer", fontSize:14, display:"flex", alignItems:"center", justifyContent:"center", color:"#8B6F47", flexShrink:0 }}>✕</button>
          )}
          {nuFull && (
            <button onClick={exitGuard.close} aria-label="Voltar para a lista de leads" style={{ background:"#F3EDE2", border:"none", borderRadius:6, padding:"6px 12px", cursor:"pointer", fontSize:13, fontWeight:700, color:"#8B6F47", flexShrink:0, order:-1, marginRight:6 }}>← Leads</button>
          )}
        </div>
        {/* Mobile: abas Conversa / Detalhes */}
        {isMobile && (
          <div style={{ display:"flex", gap:0, marginTop:8, borderRadius:10, overflow:"hidden", border:"1.5px solid #E8E1D3" }}>
            {[["chat","💬 Conversa"],["details","📋 Detalhes"]].map(([id,label])=>(
              <button key={id} onClick={()=>setMobileTab(id)}
                style={{ flex:1, padding:"9px 0", border:"none", cursor:"pointer", fontWeight:700, fontSize:13,
                  background: mobileTab===id ? "#2B1B12" : "#F3EDE2",
                  color:      mobileTab===id ? "#F3EDE2" : "#8B6F47",
                }}>
                {label}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Transfer dropdown (desktop inline, abaixo do header) */}
      {!isMobile && showTransfer && (
        <div style={{ background:"#FAF6EF", borderBottom:"1px solid #E8E1D3", padding:"8px 12px" }}>
          <div style={{ fontSize:10, color:"#8B6F47", fontWeight:700, marginBottom:6 }}>Transferir para:</div>
          <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
            <div onClick={()=>{ setResponsavel("aurora"); setSelectedConsultantId(null); setShowTransfer(false); }} style={{ display:"inline-flex", alignItems:"center", gap:5, padding:"5px 12px", borderRadius:20, cursor:"pointer", color:"#2B1B12", fontSize:12, background:"#fff", border:"1px solid #E8E1D3" }}>
              🤖 Aurora
            </div>
            {(()=>{
              const consultants = transferDestinations;
              const isStaffMultiStore = true;
              if (!isStaffMultiStore) return consultants.map(u=>(
                <div key={u.id} onClick={()=>transferToConsultant(u)} style={{ display:"inline-flex", alignItems:"center", gap:5, padding:"5px 12px", borderRadius:20, cursor:"pointer", color:"#2B1B12", fontSize:12, background:"#fff", border:"1px solid #E8E1D3" }}>
                  👤 {u.name.split(" ")[0]}
                </div>
              ));
              return STORES.flatMap(s=>{
                const sc = consultants.filter(u=>u.storeId===s.id);
                if (!sc.length) return [];
                const isSameStore = s.id === Number(lead.storeId);
                return [
                  <div key={`store_${s.id}`} style={{ width:"100%", fontSize:9.5, fontWeight:800, color:"#8B6F47", marginTop:4, marginBottom:1, letterSpacing:0.3, textTransform:"uppercase" }}>
                    🏪 {s.name}{isSameStore ? " (atual)" : ""}
                  </div>,
                  ...sc.map(u=>(
                    <div key={u.id} onClick={()=>transferToConsultant(u)} style={{ display:"inline-flex", alignItems:"center", gap:5, padding:"5px 12px", borderRadius:20, cursor:"pointer", color:"#2B1B12", fontSize:12, background:"#fff", border:`1px solid ${isSameStore?"#E8E1D3":"#A5B4FC"}` }}>
                      👤 {u.name.split(" ")[0]}
                    </div>
                  ))
                ];
              });
            })()}
          </div>
        </div>
      )}

      {/* ── Banner de transferência cross-store ───────────────────────────── */}
      {lead.historicoTransferencias?.length > 0 && (() => {
        const last = lead.historicoTransferencias[lead.historicoTransferencias.length - 1];
        const fmtD = iso => { try { return new Date(iso).toLocaleDateString('pt-BR',{day:'2-digit',month:'2-digit',year:'2-digit'}); } catch { return iso||""; } };
        return (
          <div style={{ background:"#FFFBEB", borderBottom:"1.5px solid #FCD34D", padding:"5px 12px", flexShrink:0, display:"flex", alignItems:"center", gap:7, fontSize:10.5 }}>
            <span style={{ fontSize:15 }}>🔄</span>
            <span style={{ color:"#92400E", lineHeight:1.4 }}>
              <strong>Transferido de {last.lojaAnteriorNome || `Loja ${last.lojaAnterior}`}</strong>
              {` em ${fmtD(last.data)} por ${last.transferidoPor||"Gestor"}`}
              {lead.historicoTransferencias.length>1 && <em style={{ color:"#B45309" }}>{` (+${lead.historicoTransferencias.length-1} anterior${lead.historicoTransferencias.length>2?"es":""})`}</em>}
            </span>
          </div>
        );
      })()}

      {/* Mobile: aba Detalhes */}
      {isMobile && mobileTab === "details" && (
        <div style={{ flex:1, overflowY:"auto", padding:"14px", display:"flex", flexDirection:"column", gap:10 }}>
          {hasRegisteredSale ? registeredSaleSummary : onRegistrarVenda && (
            <ManualSaleAction currentUser={currentUser} onClick={onRegistrarVenda}
              style={{ background:"#10B981", color:"#fff", border:"none", borderRadius:10, padding:"10px 12px", fontSize:13, fontWeight:800, cursor:"pointer", width:"100%" }}
              noticeStyle={{ background:"#FEF9F0", border:"1px solid #D4C5A9", borderRadius:8, padding:"10px 12px" }} />
          )}
          <button onClick={handleGerarRoteiro}
            style={{ background:"#F3EDE2", color:"#8B6F47", border:"1px solid #D4C5A9", borderRadius:10, padding:"9px 12px", fontSize:13, fontWeight:700, cursor:"pointer", width:"100%" }}
          >🎯 Gerar Roteiro</button>
          <div style={{ display:"flex", flexWrap:"wrap", alignItems:"center", gap:8, marginBottom:2 }}>
            <LeadSeloResponsavel lead={{ ...lead, responsavel, consultantId: responsavel==="consultor"?(selectedConsultantId||lead.consultantId):null }} />
            {(lead.lojaOrigem ?? lead.storeId) && (() => { const lojaId = lead.lojaOrigem ?? lead.storeId; const sn = STORES.find(s=>s.id===Number(lojaId))?.name; return sn ? <span style={{ display:"inline-flex", alignItems:"center", gap:4, background:"#EEF2FF", border:"1px solid #A5B4FC", color:"#4338CA", borderRadius:99, padding:"2px 9px", fontSize:11, fontWeight:600, whiteSpace:"nowrap" }}>🏪 {sn}</span> : null; })()}
            <button onClick={()=>setShowTransfer(t=>!t)} style={{ marginLeft:"auto", display:"inline-flex", alignItems:"center", gap:4, background:"#FAF6EF", border:"1px solid #C8A04D", color:"#8B6F47", borderRadius:99, padding:"4px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>⇄ Transferir</button>
            {lead.responsavel==="consultor" && (isStaff||lead.consultantId===currentUser?.id) && (
            <button onClick={()=>exitGuard.close(()=>{ const fn=USERS.find(u=>u.id===lead.consultantId)?.name?.split(" ")[0]||"Consultor"; if(onLogTransfer)onLogTransfer(lead.id,fn,"Aurora"); onUpdate({...lead,...nextContactSaveChanges(lead,proximaData,new Date().toISOString()),proxima_data_contato:proximaData,responsavel:"aurora",consultantId:null}); })} style={{ background:"#F3EDE2", color:"#8B6F47", border:"none", borderRadius:8, padding:"4px 10px", fontSize:10, fontWeight:700, cursor:"pointer" }}>🤖 → Aurora</button>
            )}
          </div>
          {showTransfer && (
            <div style={{ background:"#FAF6EF", borderRadius:10, border:"1px solid #E8E1D3", padding:"8px 6px" }}>
              <div style={{ fontSize:10, color:"#8B6F47", fontWeight:700, padding:"0 6px 6px" }}>Transferir para:</div>
              <div onClick={()=>{ setResponsavel("aurora"); setSelectedConsultantId(null); setShowTransfer(false); }} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"6px 10px", borderRadius:8, cursor:"pointer", color:"#2B1B12", fontSize:13 }} onMouseEnter={e=>e.currentTarget.style.background="#fff"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                🤖 Aurora <span style={{ color:"#C8A04D" }}>›</span>
              </div>
              {(()=>{
                const consultants = transferDestinations;
                const isStaffMultiStore = true;
                if (!isStaffMultiStore) return consultants.map(u=>(
                  <div key={u.id} onClick={()=>transferToConsultant(u)} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"6px 10px", borderRadius:8, cursor:"pointer", color:"#2B1B12", fontSize:13 }} onMouseEnter={e=>e.currentTarget.style.background="#fff"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                    👤 {u.name.split(" ")[0]} <span style={{ color:"#C8A04D" }}>›</span>
                  </div>
                ));
                return STORES.flatMap(s=>{
                  const sc = consultants.filter(u=>u.storeId===s.id);
                  if (!sc.length) return [];
                  const isSameStore = s.id === Number(lead.storeId);
                  return [
                    <div key={`store_${s.id}`} style={{ padding:"4px 10px 2px", fontSize:9, fontWeight:800, color:"#8B6F47", textTransform:"uppercase", letterSpacing:0.3 }}>🏪 {s.name}{isSameStore?" (atual)":""}</div>,
                    ...sc.map(u=>(
                      <div key={u.id} onClick={()=>transferToConsultant(u)} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"6px 10px", borderRadius:8, cursor:"pointer", color:"#2B1B12", fontSize:13, borderLeft: isSameStore?"none":"3px solid #A5B4FC" }} onMouseEnter={e=>e.currentTarget.style.background="#fff"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                        👤 {u.name.split(" ")[0]} <span style={{ color:"#C8A04D" }}>›</span>
                      </div>
                    ))
                  ];
                });
              })()}
            </div>
          )}
          {(lead.produto_anuncio||lead.orcamento_estimado||lead.link_anuncio||lead.id_anuncio_meta||lead.origem_canal==="instagram_bio") && (
            <div style={{ background:"#FAF6EF", borderRadius:10, padding:"8px 12px", border:"1px solid #E8E1D3" }}>
              <div style={{ fontSize:10, fontWeight:700, color:"#8B6F47", marginBottom:4 }}>🏷 Resumo capturado pela Aurora</div>
              {lead.produto_anuncio && <div style={{ fontSize:12, color:"#2B1B12" }}><span style={{ color:"#9C8F7E" }}>Produto: </span>{lead.produto_anuncio}{lead.tamanho_desejado?` · ${lead.tamanho_desejado}`:""}</div>}
              {lead.orcamento_estimado && <div style={{ fontSize:12, color:"#2B1B12" }}><span style={{ color:"#9C8F7E" }}>Orçamento: </span>{lead.orcamento_estimado}</div>}
              {lead.origem_canal === "instagram_bio" && !lead.link_anuncio && !lead.id_anuncio_meta && (
                <div style={{ marginTop:6, background:"#FFF7ED", borderRadius:7, padding:"5px 9px", border:"1px solid #FED7AA", color:"#C2410C", fontSize:10.5, fontWeight:700 }}>
                  📸 {lead.origem_descricao || "Instagram — link da bio"}
                </div>
              )}
              {(lead.link_anuncio||lead.id_anuncio_meta) && (
                <div style={{ marginTop:6, background:"#EFF6FF", borderRadius:7, padding:"5px 9px", border:"1px solid #BFDBFE" }}>
                  <div style={{ fontSize:10, fontWeight:700, color:"#1D4ED8", marginBottom:2 }}>📣 Origem do anúncio</div>
                  {lead.titulo_anuncio && <div style={{ fontSize:11.5, color:"#1E40AF" }}>{lead.titulo_anuncio}</div>}
                  {lead.body_anuncio   && <div style={{ fontSize:11, color:"#3B5EA6", marginTop:1 }}>{lead.body_anuncio}</div>}
                  {lead.tipo_anuncio   && <div style={{ fontSize:10.5, color:"#6B7280", marginTop:1 }}>Tipo: {lead.tipo_anuncio}</div>}
                  {lead.id_anuncio_meta&& <div style={{ fontSize:10.5, color:"#6B7280" }}>ID Meta: {lead.id_anuncio_meta}</div>}
                  {lead.link_anuncio && (
                    <a href={lead.link_anuncio} target="_blank" rel="noopener noreferrer" className="ad-link"
                       style={{ display:"inline-block", marginTop:4, fontSize:12, fontWeight:700, color:"#2563EB", textDecoration:"none", background:"#DBEAFE", borderRadius:6, padding:"3px 10px" }}>
                      🔗 Ver anúncio
                    </a>
                  )}
                </div>
              )}
            </div>
          )}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:6 }}>
            <div>
              <label style={{ fontSize:10, fontWeight:700, color:"#8B6F47", display:"block", marginBottom:3 }}>Etapa</label>
              <LiftSaleStageSelect moduleId="leads" record={lead} value={estagio} saleStage="fechou_venda"
                options={LEAD_STAGES} onChange={setEstagio} style={inp}
                onLinked={card=>{setEstagio(card._crm_estagio||card.estagio);setProximaData("");exitGuard.saved(card);}}/>
            </div>
            <div>
              <label style={{ fontSize:10, fontWeight:700, color:"#8B6F47", display:"block", marginBottom:3 }}>Próx. Contato</label>
              <input type="date" value={proximaData} onChange={e=>setProximaData(e.target.value)} style={inp} />
            </div>
          </div>
          {(estagio==="desqualificado"||estagio==="prospeccao_futura") && (
            <div>
              <label style={{ fontSize:10, fontWeight:700, color:"#8B6F47", display:"block", marginBottom:3 }}>{estagio==="desqualificado"?"Motivo desqualificação":"Motivo prosp. futura"}</label>
              {estagio==="desqualificado" && (
                <select value={motivoTipo} onChange={e=>setMotivoTipo(e.target.value)} style={{ ...inp, marginBottom:6, background:"#fff" }}>
                  <option value="">Selecione o motivo…</option>
                  {DESQUALIFICACAO_REASONS.map(r=><option key={r.id} value={r.id}>{r.label}</option>)}
                </select>
              )}
              <textarea value={motivo} onChange={e=>setMotivo(e.target.value)} rows={2} placeholder={estagio==="desqualificado"?"Detalhes (opcional)":""} style={{ ...inp, resize:"vertical" }} />
            </div>
          )}
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            <div style={{ flex:1 }}>
              <label style={{ fontSize:10, fontWeight:700, color:"#8B6F47", display:"block", marginBottom:3 }}>Follow-ups</label>
              <input type="number" min="0" value={tentativas} onChange={e=>setTentativas(parseInt(e.target.value)||0)} style={inp} />
            </div>
            <div style={{ display:"flex", alignItems:"flex-end" }}>
              <button onClick={handleSave} disabled={savingLead} style={{ background:"linear-gradient(135deg,#C8A04D,#8B6F47)", color:"#fff", border:"none", borderRadius:10, padding:"9px 18px", fontWeight:700, fontSize:13, cursor:"pointer", whiteSpace:"nowrap" }}>{savingLead ? "Salvando…" : "Salvar ✓"}</button>
            </div>
          </div>
          {currentUser?.role==="admin" && (
            <div style={{ display:"flex", flexDirection:"column", gap:4, marginTop:4, paddingTop:8, borderTop:"1px dashed #E8E1D3" }}>
              <div style={{ fontSize:9.5, fontWeight:700, color:"#9C8F7E", textTransform:"uppercase", letterSpacing:0.4 }}>Correção de origem (cadastro antigo)</div>
              <button onClick={()=>returnLeadToModule("prospeccao")} style={{ background:"#FAF6EF", color:"#8B6F47", border:"1px solid #C8A04D", borderRadius:10, padding:"7px 0", fontWeight:700, fontSize:11.5, cursor:"pointer", width:"100%" }}>
                ↩️ Retornar para Prospecção
              </button>
              <button onClick={()=>returnLeadToModule("atendimento")} style={{ background:"#FAF6EF", color:"#8B6F47", border:"1px solid #C8A04D", borderRadius:10, padding:"7px 0", fontWeight:700, fontSize:11.5, cursor:"pointer", width:"100%" }}>
                ↩️ Retornar para Atendimento Presencial
              </button>
            </div>
          )}
          {currentUser?.role==="admin" && onDelete && (
          <button onClick={() => { if(window.confirm("Tem certeza que deseja excluir este Lead? Essa ação não poderá ser desfeita.")) exitGuard.close(()=>onDelete(lead.id)); }} style={{ background:"#fff", color:"#C0392B", border:"2px solid #C0392B", borderRadius:10, padding:"9px 0", fontWeight:700, fontSize:13, cursor:"pointer", width:"100%", marginTop:4 }}>
              🗑 Excluir Lead
            </button>
          )}
        </div>
      )}

      {/* Chat — oculto no mobile quando na aba Detalhes */}
      {(!isMobile || mobileTab === "chat") && (<>
      {lead.responsavel==="consultor" && (
        <div style={{ display:"flex", alignItems:"flex-start", gap:6, padding:"7px 14px", background:"#FFF4E5", borderBottom:"1px solid #F0D9A8", flexShrink:0 }}>
          <span style={{ fontSize:13, lineHeight:1 }}>⚠️</span>
          <span style={{ fontSize:11, color:"#8B6F47", lineHeight:1.35 }}>
            Este lead já está com atendimento humano. <b>Responda por aqui, pelo CRM</b> — mensagens digitadas direto no WhatsApp do celular da loja não são gravadas aqui em tempo real.
          </span>
        </div>
      )}
      <div style={{ display:"flex", alignItems:"center", gap:6, padding:"6px 14px", borderBottom:"1px solid #F3EDE2", flexShrink:0 }}>
        <span style={{ fontSize:11, fontWeight:700, color:"#8B6F47" }}>💬 Conversa</span>
        {conversationLoadState==="loading" && (
          <span title="Carregando conversa" style={{ display:"inline-flex", alignItems:"center", gap:4, color:"#15803D", fontSize:9, fontWeight:800 }}>
            <span style={{ width:10, height:10, border:"2px solid #BBF7D0", borderTopColor:"#16A34A", borderRadius:"50%", animation:"leadConversationSpin 0.7s linear infinite" }} />
            Carregando
          </span>
        )}
        {hasWa && <span style={{ background:"#3FA76B", color:"#fff", borderRadius:6, padding:"1px 7px", fontSize:9, fontWeight:800 }}>WhatsApp</span>}
        <span style={{ fontSize:10, color:"#9C8F7E", marginLeft:2 }}>{allMsgs.filter(m=>m.remetente!=="sistema").length} msgs</span>
        <span style={{ marginLeft:"auto", fontSize:10, borderRadius:6, background:`${stageObj.color}22`, color:stageObj.color, padding:"2px 8px", fontWeight:700 }}>{stageObj.label}</span>
        <style>{`@keyframes leadConversationSpin{to{transform:rotate(360deg)}}`}</style>
      </div>
      <div ref={chatRef} style={{ flex:1, overflowY:"auto", padding:"12px 14px", display:"flex", flexDirection:"column", gap:7, background:"#FDFBF7" }}>
        <HistoryPagination storeId={conversationChannelStoreId} phone={phoneClean}
          hasMore={!!olderCursor} loadMore={loadEarlierLeadMessages} />
        {conversationLoadState==="loading" && allMsgs.length===0 && (
          <div style={{ textAlign:"center", color:"#15803D", fontSize:12, paddingTop:30, fontWeight:700 }}>
            <span style={{ display:"inline-block", width:18, height:18, border:"3px solid #BBF7D0", borderTopColor:"#16A34A", borderRadius:"50%", animation:"leadConversationSpin 0.7s linear infinite", marginBottom:7 }} />
            <div>Carregando conversa…</div>
          </div>
        )}
        {conversationLoadState==="error" && allMsgs.length===0 && (
          <div style={{ textAlign:"center", color:"#B45309", fontSize:12, padding:"28px 12px" }}>
            <div style={{ fontWeight:800, marginBottom:5 }}>A conversa não pôde ser carregada.</div>
            <div style={{ marginBottom:10 }}>{conversationLoadError}</div>
            <button type="button" onClick={()=>setConversationReloadToken(value=>value+1)}
              style={{ background:"#15803D", color:"#fff", border:"none", borderRadius:8, padding:"7px 12px", fontSize:11, fontWeight:800, cursor:"pointer" }}>
              Tentar novamente
            </button>
          </div>
        )}
        {conversationLoadState==="loaded" && allMsgs.length===0 && <div style={{ textAlign:"center", color:"#9C8F7E", fontSize:12, paddingTop:30 }}>Nenhuma mensagem registrada nesta loja</div>}
        {allMsgs.map((m,i)=>{
          if(m.messageSource==="firebase_outage_gap_note")return <RecoveryGapNote key={m.id||i} message={m}/>;
          if (m.remetente==="sistema") return (
            <div key={i} style={{ display:"flex", alignItems:"center", gap:6 }}>
              <div style={{ flex:1, height:1, background:"#E8E1D3" }} />
              <div style={{ fontSize:10, color:"#9C8F7E", padding:"2px 8px", background:"#F3EDE2", borderRadius:99, whiteSpace:"nowrap" }}><MessageTextLinks text={m.texto} /></div>
              <div style={{ flex:1, height:1, background:"#E8E1D3" }} />
            </div>
          );
          if (m.remetente==="nota_interna") {
            const showDaySepNote = i===0||dayKey(allMsgs[i-1]?.timestamp)!==dayKey(m.timestamp);
            return (
              <div key={i} style={{ display:"flex", flexDirection:"column" }}>
                {showDaySepNote&&m.timestamp&&(
                  <div style={{ display:"flex", justifyContent:"center", margin:"10px 0 6px" }}>
                    <span style={{ background:"#F1EDE4", color:"#9C8F7E", fontSize:10, fontWeight:700, borderRadius:99, padding:"3px 12px" }}>{formatDayLabel(m.timestamp)}</span>
                  </div>
                )}
                <div style={{ background:"#FEF9C3", border:"1px solid #FDE68A", borderRadius:10, padding:"8px 12px", margin:"2px 0" }}>
                  <div style={{ fontSize:10, fontWeight:800, color:"#92400E", marginBottom:2 }}>📝 Nota interna (só a equipe vê){m.autor?` — ${m.autor}`:""}</div>
                  <div style={{ fontSize:12, color:"#78350F", lineHeight:1.5, whiteSpace:"pre-wrap" }}><MessageTextLinks text={m.texto} /></div>
                  <div style={{ fontSize:9, color:"#B45309", marginTop:4 }}>{m.timestamp?new Date(m.timestamp).toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"}):""}</div>
                </div>
              </div>
            );
          }
          const isAurora = m.remetente==="aurora";
          const isConsultor = m.remetente==="consultor";
          const isRight = isAurora||isConsultor;
          const failed = isRight && waMsgIsFailed(m);
          const msgTxt = m.texto||(typeof m.content==="string"?m.content:"")||(typeof m.body==="string"?m.body:"")||(typeof m.text==="string"?m.text:m.text?.message||"")||m.caption||m.mensagem||"";
          const showDaySep = i===0||dayKey(allMsgs[i-1]?.timestamp)!==dayKey(m.timestamp);
          return (
            <div key={i} style={{ display:"flex", flexDirection:"column" }}>
              {showDaySep&&m.timestamp&&(
                <div style={{ display:"flex", justifyContent:"center", margin:"10px 0 6px" }}>
                  <span style={{ background:"#F1EDE4", color:"#9C8F7E", fontSize:10, fontWeight:700, borderRadius:99, padding:"3px 12px" }}>{formatDayLabel(m.timestamp)}</span>
                </div>
              )}
              <div style={{ display:"flex", flexDirection:"column", alignItems:isRight?"flex-end":"flex-start" }}>
              <div style={{ display:"flex", alignItems:"flex-end", gap:4, flexDirection:isRight?"row-reverse":"row" }}>
              {isConsultor && <ChatMessageActions
                message={m}
                onDelete={onDeleteWhatsAppMessage ? (msg) => onDeleteWhatsAppMessage(
                  phoneClean,
                  msg,
                  msg.storeId || lead.lojaOrigem || lead.storeId || currentUser?.storeId
                ) : null}
              />}
              <button onClick={()=>setReplyTo(m)} title="Responder" style={{ background:"none", border:"none", cursor:"pointer", fontSize:14, color:"#94A3B8", padding:"2px 5px", flexShrink:0, borderRadius:6, lineHeight:1, alignSelf:"center", opacity:0.55 }}>↩</button>
              {(()=>{
                // Resolve src: suporta formato flat (m.url) e aninhado Z-API (m.image.url)
                const rawMediaUrl =
                  m.storageUrl ||
                  m.base64Data ||
                  m.url ||
                  (m.image && (typeof m.image === "string" ? m.image : m.image?.url)) ||
                  (m.audio && (typeof m.audio === "string" ? m.audio : m.audio?.url)) ||
                  (m.video && (typeof m.video === "string" ? m.video : m.video?.url)) ||
                  (m.document && (typeof m.document === "string" ? m.document : m.document?.url)) ||
                  null;
                const mediaSrc = resolveMediaSrc(rawMediaUrl, m.storagePath);
                // Resolve tipo: usa campo explícito ou infere pelo campo presente ou pelo MIME do base64
                const _tRaw = (m.tipo || m.type ||
                  (m.image?.url || (typeof m.image === "string" && m.image) ? "imagem" :
                   m.audio?.url || (typeof m.audio === "string" && m.audio) ? "audio" :
                    m.video?.url || (typeof m.video === "string" && m.video) ? "video" :
                    m.document?.url || (typeof m.document === "string" && m.document) ? "documento" : "") || "").toLowerCase();
                const _tMime = rawMediaUrl?.startsWith("data:image/") ? "imagem" : rawMediaUrl?.startsWith("data:audio/") ? "audio" : rawMediaUrl?.startsWith("data:video/") ? "video" : "";
                const tipo = _tMime || (_tRaw.includes("imag")||_tRaw==="foto"||_tRaw==="photo"||_tRaw==="picture" ? "imagem" : _tRaw.includes("audio")||_tRaw==="voz" ? "audio" : _tRaw.includes("video")||_tRaw==="vídeo" ? "video" : _tRaw);
                const isImg = tipo==="imagem"||tipo==="image";
                const isAud = tipo==="audio";
                const isVid = tipo==="video";
                const isDoc = isDocumentMessage(m);
                // Resolve texto
                const txt = m.texto||(typeof m.content==="string"?m.content:"")||(typeof m.body==="string"?m.body:"")||(typeof m.text==="string"?m.text:m.text?.message||"")||m.caption||m.mensagem||"";
                const bubbleStyle = {
                  background: failed?"#FEE2E2":isAurora?"#2B1B12":isConsultor?"#C8A04D":"#F1EDE4",
                  color: failed?"#991B1B":isRight?"#F3EDE2":"#3A2E22",
                  border: failed?"1px solid #FECACA":"none",
                  borderRadius: isRight?"14px 14px 4px 14px":"14px 14px 14px 4px",
                  padding: isImg&&mediaSrc?"4px":"9px 13px",
                  maxWidth:"92%", fontSize:13, lineHeight:1.5,
                  whiteSpace:"pre-wrap", wordBreak:"break-word", overflow:"hidden"
                };
                const _quotedBar = m.quotedMsg ? <QuotedPreview quotedMsg={m.quotedMsg} isMine={isRight||isAurora} /> : null;
                const fallbackBtn = (label) => (
                  <button onClick={()=>openMediaSrc(m)}
                    style={{display:"none",alignItems:"center",gap:6,background:"rgba(255,255,255,0.18)",
                      border:"1px solid rgba(255,255,255,0.45)",borderRadius:8,padding:"6px 12px",
                      cursor:"pointer",color:"inherit",fontSize:12,fontWeight:700,width:"100%",justifyContent:"center"}}>
                    {label}
                  </button>
                );
                const refreshOnError = async (e) => {
                  const el = e.target;
                  if (el.dataset.retried) {
                    el.style.display="none";
                    if (el.nextSibling) {
                      el.nextSibling.style.display="flex";
                      el.nextSibling.textContent = "⚠ Imagem histórica indisponível";
                    }
                    return;
                  }
                  el.dataset.retried = "1";
                  if (rawMediaUrl && rawMediaUrl.includes("firebasestorage")) {
                    try {
                      const { getDownloadURL: gd, ref: sr } = await import("firebase/storage");
                      const { getStorage: gs } = await import("firebase/storage");
                      const pm = new URL(rawMediaUrl).pathname.match(/\/o\/(.+)$/);
                      if (pm) { el.src = await gd(sr(gs(), decodeURIComponent(pm[1]))); return; }
                    } catch {}
                  }
                  if (rawMediaUrl && !rawMediaUrl.startsWith("data:") && !rawMediaUrl.includes("firebasestorage")) {
                    el.src = `/api/media?url=${encodeURIComponent(rawMediaUrl)}`;
                    return;
                  }
                  el.style.display="none"; if(el.nextSibling) el.nextSibling.style.display="flex";
                };
                if (isImg && mediaSrc) return (
                  <div style={bubbleStyle}>
                    {_quotedBar}
                    <LazyChatImage src={mediaSrc} alt="imagem" style={{maxWidth:"100%",borderRadius:10,display:"block",cursor:"pointer"}}
                      onClick={()=>openMediaSrc({...m, url: rawMediaUrl})}
                      onError={refreshOnError} />
                    {fallbackBtn(m.mediaRetentionPending ? "⚠ Imagem sem cópia permanente — tentar abrir" : "🖼 Abrir imagem ↗")}
                    {txt?<div style={{padding:"4px 6px 0",fontSize:12,lineHeight:1.4}}><MessageTextLinks text={txt} /></div>:null}
                    {!isRight && isNewUiEnabled() && <button type="button" onClick={()=>pedirParecidos(mediaSrc)} style={{marginTop:5,border:"1px solid #CBD5E1",borderRadius:6,cursor:"pointer",background:"#fff",padding:"3px 8px"}}>🔎 Parecidos</button>}
                    <FotoIdsGallery fotoIds={m.fotoIds} dark={isRight} />
                  </div>
                );
                if (isAud && mediaSrc) return (
                  <div style={bubbleStyle}>
                    {_quotedBar}
                    <audio preload="none" controls src={mediaSrc} style={{maxWidth:"100%",display:"block"}}
                      onError={e=>{ e.target.style.display="none"; if(e.target.nextSibling) e.target.nextSibling.style.display="flex"; }} />
                    {fallbackBtn("🎵 Baixar áudio ↗")}
                  </div>
                );
                if (isVid && mediaSrc) return (
                  <div style={bubbleStyle}>
                    {_quotedBar}
                    <video preload="none" controls src={mediaSrc} style={{maxWidth:"100%",borderRadius:10,display:"block"}}
                      onError={e=>{ e.target.style.display="none"; if(e.target.nextSibling) e.target.nextSibling.style.display="flex"; }} />
                    {fallbackBtn("🎥 Abrir vídeo ↗")}
                  </div>
                );
                if (isDoc) return (
                  <div style={bubbleStyle}>
                    {_quotedBar}
                    <DocumentAttachment message={m} src={mediaSrc || rawMediaUrl} resolveSrc={resolveMediaSrc} />
                    {txt ? <div style={{marginTop:4,fontSize:12}}><MessageTextLinks text={txt} /></div> : null}
                  </div>
                );
                // Fallback: se tem tipo mas não tem src ainda (mensagem antiga sem base64)
                if ((isImg||isAud||isVid) && (m.storagePath||m.url||m.image||m.audio||m.video)) {
                  const rawUrl = m.url||m.image||m.audio||m.video;
                  return (
                    <div style={bubbleStyle}>
                      {_quotedBar}
                      <a href={resolveMediaSrc(rawUrl, m.storagePath)} target="_blank" rel="noopener noreferrer"
                         style={{color:"inherit",fontWeight:700,textDecoration:"underline"}}>
                        {isImg?"🖼 Ver imagem":isAud?"🎵 Abrir áudio":"🎥 Abrir vídeo"} ↗
                      </a>
                    </div>
                  );
                }
                // Placeholder do n8n sem URL real: "[Imagem enviada]", "[Audio recebido]", "chegou imagem"…
                const _N8N_RE2 = /^\[(imagem|foto|audio|áudio|vídeo|video|arquivo)[^\]]*\]$/i;
                const _isPlaceholder2 = _N8N_RE2.test((txt||"").trim()) || /^chegou (imagem|áudio|audio|vídeo|video)/i.test((txt||"").trim());
                if (_isPlaceholder2) {
                  const _pAud2 = /audio|áudio/i.test(txt); const _pVid2 = /video|vídeo/i.test(txt);
                  return <div style={{...bubbleStyle,opacity:0.75}}><span style={{fontStyle:"italic"}}>{_pAud2?"🎵":_pVid2?"🎥":"📷"} {_pAud2?"Áudio":_pVid2?"Vídeo":"Imagem"} (ver no WhatsApp)</span></div>;
                }
                // Texto puro (pode ter fotoIds anexados mesmo sem tipo de mídia)
                return (
                  <div style={bubbleStyle}>
                    {_quotedBar}
                    <MessageTextLinks text={txt||"📎 Mídia"} />
                    <FotoIdsGallery fotoIds={m.fotoIds} dark={isRight} />
                  </div>
                );
              })()}
              </div>{/* fim flex wrapper ↩ */}
              <div style={{ fontSize:9, color:"#9C8F7E", marginTop:2, display:"flex", alignItems:"center", gap:3 }}>
                {messageSenderLabel(m, USERS)}
                {m.timestamp?` · ${new Date(m.timestamp).toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"})}` : ""}
                {isRight && <WaSendStatus attempt={m._textAttempt} status={m.status} ack={m.waAck} motivo={m.motivo} timestamp={m.timestamp} onRetry={isConsultor ? (waMsgIsMedia(m)?((onSendZapiMedia && m.id)?()=>onSendZapiMedia(phoneClean,m,m.tipo,outboundStores):null):(onSendZapi && msgTxt.trim())?()=>onSendZapi(phoneClean,msgTxt,{name:"Consultor"},null,outboundStores,null,m):null) : null} />}
              </div>
              {failed && m.motivo && (
                <div style={{ fontSize:9, color:"#EF4444", fontWeight:600, marginTop:1 }}>⚠️ Não enviada: {m.motivo}</div>
              )}
              </div>
            </div>
          );
        })}
      </div>
      {/* Input — compositor unificado do AR Flow */}
      <LiftCloseSaleAction moduleId="leads" record={lead}/>
      <ChatComposerBar
        onSendText={handleLeadSend}
        noteTarget={{moduleId:"leads",recordId:lead.id}}
        coachAlvo={phoneClean ? { phone:phoneClean, storeId:leadStoreIds(lead) || lead.storeId } : null}
        onSendMedia={onSendZapiMedia && phoneClean ? (file, tipo, quotedId, quotedMsg) => onSendZapiMedia(phoneClean, file, tipo, outboundStores, quotedId, quotedMsg) : null}
        allowNote
        onSaveNote={handleLeadNote}
        placeholder={phoneClean ? "Enviar pelo WhatsApp…" : "Registrar mensagem…"}
        replyTo={replyTo}
        onClearReply={() => setReplyTo(null)}
        currentUser={currentUser}
        storeId={qrStoreId}
        reviewContext={{ phone:phoneClean, nome:lead.nome || lead.name,
          produto:lead.produto || lead.product || lead.produto_interesse || lead.produto_anuncio || "" }}
        onSendQRMedia={onSendQRMedia ? (m, quotedId, quotedMsg) => onSendQRMedia(phoneClean, m, outboundStores, quotedId, quotedMsg) : null}
        onGerarRoteiro={handleGerarRoteiro}
        onToggleAguardandoRetorno={() => onUpdate(
          { ...lead, aguardandoRetornoCliente: lead.aguardandoRetornoCliente?.value ? { value:false, setAt:new Date().toISOString() } : { value:true, setAt:new Date().toISOString() } },
          { keepOpen:true }
        )}
        aguardandoRetorno={!!lead.aguardandoRetornoCliente?.value}
      />
      </>)}
    </div>{/* fim coluna chat */}
      {chatExpanded && detailsPanel}
      <AiHelpModal
        roteiroModal={roteiroModal}
        setRoteiroModal={setRoteiroModal}
        clientName={lead.nome}
        phone={phoneClean}
        storeId={lead.lojaOrigem ?? lead.storeId ?? currentUser?.storeId ?? 1}
        produto={lead.produto_anuncio || lead.produto || ""}
        estagio={lead.estagio || "chegou"}
      />
    </div>
  );
}

const LEAD_DATE_FIELDS = [
  { id:"createdAt",  label:"Data de entrada" },
  { id:"followup",   label:"Data de follow-up" },
  { id:"fechamento", label:"Data de fechamento" },
];
export function LeadKanban({ leads, leadMessages, leadEvents={}, currentUser, onUpdate, onDelete, onSendMessage, whatsappMsgs={}, onSendZapi, onSendZapiMedia, onDeleteWhatsAppMessage=null, onLogTransfer, onAddReminder, autoOpenTarget, onAutoOpenConsumed, onRegistrarVenda, showStoreFilter=false, storeFilter="todas", onStoreFilterChange, onConversationActive, onCreateProspItem }) {
  useTextSendAttempts();
  const [selected, setSelected] = useState(null);
  const [dragLeadId, setDragLeadId] = useState(null);

  useEffect(() => {
    if (!autoOpenTarget) return;
    const match = leads.find(l => autoOpenTarget.recordId != null
      ? (String(l?.id || "") === String(autoOpenTarget.recordId)
        && (l?.lojaAtual != null && l?.lojaAtual !== ""
          ? Number(l.lojaAtual) === Number(autoOpenTarget.storeId)
          : leadBelongsToStore(l, autoOpenTarget.storeId)))
      : recordMatchesConversationTarget(l, autoOpenTarget, ["telefone","phone"]));
    if (!match) return;
    setSelected(match);
    if (onAutoOpenConsumed) onAutoOpenConsumed();
  }, [autoOpenTarget, leads]); // eslint-disable-line react-hooks/exhaustive-deps
  const [filters, setFilters] = useScreenPeriodFilters("leadsKanban", DEFAULT_FILTERS);
  const [searchQuery, setSearchQuery] = useState("");
  const [onlyTransfers, setOnlyTransfers] = useState(false);
  const [transferType, setTransferType] = useState("all");
  const [transferSourceId, setTransferSourceId] = useState("");
  const [transferDestinationId, setTransferDestinationId] = useState("");
  const [transferFrom, setTransferFrom] = useState("");
  const [transferTo, setTransferTo] = useState("");
  const [transferAurora, setTransferAurora] = useState("all");
  const panelHeight = "calc(100vh - 185px)";
  const isManagerOrAdmin = currentUser?.role !== "consultant";
  const storeConsultantsFB = USERS.filter(u => u.role === "consultant" && (currentUser?.role === "admin" ? true : u.storeId === currentUser?.storeId));
  const effPeriodK = filters.period;
  const effCustomFromK = filters.customFrom;
  const effCustomToK = filters.customTo;
  const leadDateValue = (l) => {
    if (filters.dateField === "followup")   return l.proxima_data_contato;
    if (filters.dateField === "fechamento") return l.fechou_venda_em;
    return l.data_criacao || l.createdAt;
  };
  const periodRange = getPeriodRange(effPeriodK, effCustomFromK, effCustomToK);
  const transferFilters = {
    type:transferType,
    sourceConsultantId:transferSourceId,
    destinationConsultantId:transferDestinationId,
    from:transferFrom,
    to:transferTo,
    aurora:transferAurora,
  };
  const filteredLeads = leads.filter(l => {
    if (!matchesResponsavelFiltro(l, filters.consultantId)) return false;
    if (effPeriodK !== "tudo") {
      const noDateFieldChosen = !filters.dateField || filters.dateField === "createdAt";
      const inCreated = inPeriod(leadDateValue(l), periodRange);
      // Lead transferido recentemente (ultima_atualizacao dentro do período) continua visível
      // mesmo se a data de criação for antiga — senão o lead "desaparece" para quem acabou de recebê-lo.
      const inUpdated = noDateFieldChosen && inPeriod(l.ultima_atualizacao, periodRange);
      if (!inCreated && !inUpdated) return false;
    }
    if (searchQuery.trim()) {
      const q = searchQuery.trim().toLowerCase();
      const nameMatch  = (l.nome||"").toLowerCase().includes(q);
      const digits = q.replace(/\D/g,"");
      const phoneMatch = digits.length>0 && matchesPhoneSearch(l.telefone, digits);
      if (!nameMatch && !phoneMatch) return false;
    }
    if (onlyTransfers && !leadMatchesTransferFilters(transferEventsForLead(l, leadEvents[l.id] || {}, USERS), transferFilters)) return false;
    return true;
  });
  useEffect(() => {
    if (!selected) return;
    const latest = leads.find(lead => lead.id === selected.id
      || (lead._rawPhone && lead._rawPhone === selected._rawPhone));
    if (!latest) setSelected(null);
  }, [leads, selected]);

  const handleDrop = (stageId) => {
    if (!dragLeadId) return;
    const lead = leads.find(l => l.id === dragLeadId);
    if (lead && lead.estagio !== stageId) {
      if (manualSaleWriteDenied({
        user:currentUser,
        previousStage:lead?._crm_estagio ?? lead?.estagio,
        nextStage:stageId,
        saleStages:["fechou_venda"],
      })) {
        alert(MANUAL_SALE_CUTOFF_NOTICE);
        setDragLeadId(null);
        return;
      }
      Promise.resolve(onUpdate({ ...lead, estagio: stageId })).catch(error =>
        alert(error?.message || "Não foi possível atualizar o estágio do lead."));
    }
    setDragLeadId(null);
  };

  // Mesma regra do LeadCard: "aguardando resposta" quando a última mensagem é do cliente
  // e ainda não teve resposta da Aurora/consultor — usado só pra ordenar (não duplica o badge).
  const leadIsUnanswered = (l) => {
    return leadConversationReplyState(l, leadReplyMessages(l, leadMessages, whatsappMsgs), {
      hasHumanOwnership:leadHasHumanOwnership(l),
      isClosingMessage,
    }) === "needs_team_reply";
  };

  return (
    <div style={{ display:"flex", flexDirection:"column" }}>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        dateFieldOptions={LEAD_DATE_FIELDS}
        consultants={isManagerOrAdmin ? storeConsultantsFB : null}
        showConsultant={isManagerOrAdmin}
        showStatus={false}
        showSearch
        searchValue={searchQuery}
        onSearchChange={setSearchQuery}
        showStore={showStoreFilter}
        storeValue={storeFilter}
        onStoreChange={onStoreFilterChange}
      />
      <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", padding:"7px 10px", background:"#FAF5FF", border:"1px solid #E9D5FF", borderRadius:10, marginBottom:8 }}>
        <label style={{ display:"flex", alignItems:"center", gap:6, color:"#6D28D9", fontSize:12, fontWeight:800, cursor:"pointer" }}>
          <input type="checkbox" checked={onlyTransfers} onChange={e=>setOnlyTransfers(e.target.checked)} />
          ↔️ Transferências
        </label>
        {onlyTransfers && <>
          <select aria-label="Tipo de transferência" value={transferType} onChange={e=>setTransferType(e.target.value)} style={{ fontSize:11, padding:5, borderRadius:7, border:"1px solid #D8B4FE" }}>
            <option value="all">Todos os tipos</option><option value="aurora_to_consultant">Aurora → Consultor</option><option value="consultant_to_aurora">Consultor → Aurora</option><option value="consultant_to_consultant">Consultor → Consultor</option><option value="manager_to_consultant">Gestor/Gerente → Consultor</option><option value="cross_store">Entre lojas</option>
          </select>
          {isManagerOrAdmin && <select aria-label="Consultor de origem" value={transferSourceId} onChange={e=>setTransferSourceId(e.target.value)} style={{ fontSize:11, padding:5, borderRadius:7, border:"1px solid #D8B4FE" }}>
            <option value="">Toda origem</option>{storeConsultantsFB.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
          </select>}
          {isManagerOrAdmin && <select aria-label="Consultor de destino" value={transferDestinationId} onChange={e=>setTransferDestinationId(e.target.value)} style={{ fontSize:11, padding:5, borderRadius:7, border:"1px solid #D8B4FE" }}>
            <option value="">Todo destino</option>{storeConsultantsFB.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
          </select>}
          <input type="date" aria-label="Transferências desde" value={transferFrom} onChange={e=>setTransferFrom(e.target.value)} style={{ fontSize:11, padding:4, borderRadius:7, border:"1px solid #D8B4FE" }} />
          <input type="date" aria-label="Transferências até" value={transferTo} onChange={e=>setTransferTo(e.target.value)} style={{ fontSize:11, padding:4, borderRadius:7, border:"1px solid #D8B4FE" }} />
          <select aria-label="Participação da Aurora" value={transferAurora} onChange={e=>setTransferAurora(e.target.value)} style={{ fontSize:11, padding:5, borderRadius:7, border:"1px solid #D8B4FE" }}>
            <option value="all">Todas</option><option value="yes">Com Aurora</option><option value="no">Entre consultores</option>
          </select>
        </>}
      </div>
      <div style={{ display:"flex", gap:0, height:panelHeight, background:"#F1F5F9", borderRadius:14, overflow:"hidden", border:"1.5px solid #E2E8F0" }}>
        {/* Kanban columns */}
        <div style={{ flex:1, overflowX:"auto", overflowY:"hidden", WebkitOverflowScrolling:"touch", padding:"12px 12px 12px 14px" }}>
          <div style={{ display:"flex", gap:10, alignItems:"flex-start", height:"100%", minWidth:"min-content" }}>
            {LEAD_STAGES.map(stage=>{
            const isConsultant = currentUser?.role === "consultant";
            const currentYM = `${new Date().getFullYear()}-${String(new Date().getMonth()+1).padStart(2,"0")}`;
            const stageLeads = filteredLeads.filter(l => {
              if (l.manualFechamento) return false; // entradas manuais só aparecem no dashboard
              // Desqualificação é estado canônico (inclui legados "sem_interesse"/flag desqualificado):
              // o card sai da etapa anterior e aparece SEMPRE na coluna Desqualificado.
              const leadStageId = isDisqualifiedLead(l) ? "desqualificado" : l.estagio;
              if (leadStageId !== stage.id) return false;
              // Coluna "Fechou Venda" é mensal — só mostra fechamentos do mês atual
              if (stage.id === "fechou_venda") {
                if (!l.fechou_venda_em) return false;
                if (!l.fechou_venda_em.startsWith(currentYM)) return false;
              }
              if (isConsultant) {
                return leadOwnedByConsultant(l, currentUser);
              }
              // Gerente/admin: mostra TODOS os leads da loja (já filtrados por storeId no LeadsView)
              // Colchões cria leads com responsavel = nome do consultor (turno), não "aurora"
              return true;
            });

            // ── Ordenação por 3 níveis de prioridade ──────────────────────────────
            // P1: Cliente respondeu (aguardando consultor) → seção fixada no TOPO de cada coluna
            // P2: Afazer vencido ou para hoje (proxima_data_contato <= hoje) → seção laranja logo abaixo
            // P3: Demais leads → agrupamento normal por data de entrada
            const today = new Date().toISOString().split("T")[0];
            const _getLastClientTs = (l) => {
              const allMsgs = [
                ...Object.values(leadMessages[l.id]||{}),
                ...Object.values(getWaMsgsForPhone(whatsappMsgs, normalizePhone(l.telefone), leadStoreIds(l))||{}),
              ];
              const cli = allMsgs.filter(m=>m.remetente==="cliente");
              if (!cli.length) return 0;
              return Math.max(...cli.map(m=>_tsNum(m.timestamp)));
            };

            const unansweredLeads = stageLeads
              .filter(leadIsUnanswered)
              .sort((a,b) => _getLastClientTs(b) - _getLastClientTs(a)); // mais recente primeiro
            const unansweredIds = new Set(unansweredLeads.map(l=>l.id));

            const overdueOrTodayLeads = stageLeads
              .filter(l => !unansweredIds.has(l.id) && l.proxima_data_contato && l.proxima_data_contato <= today)
              .sort((a,b) => (a.proxima_data_contato||"").localeCompare(b.proxima_data_contato||"")); // mais atrasado primeiro
            const overdueOrTodayIds = new Set(overdueOrTodayLeads.map(l=>l.id));

            const normalLeads = stageLeads.filter(l => !unansweredIds.has(l.id) && !overdueOrTodayIds.has(l.id));
            const arrivalGroupsRaw = groupLeadsByArrivalDay(normalLeads, l => l.data_criacao || l.createdAt);
            const arrivalGroups = arrivalGroupsRaw; // sem re-sort interno — prioridade já separada acima

            const isDragTarget = !!dragLeadId && leads.find(l=>l.id===dragLeadId)?.estagio !== stage.id;

            const renderCard = (l) => (
              <div key={l.id}
                draggable={true}
                onDragStart={e=>{ e.stopPropagation(); setDragLeadId(l.id); }}
                onDragEnd={()=>setDragLeadId(null)}
                style={{ opacity:dragLeadId===l.id?0.45:1, cursor:"grab", position:"relative", borderRadius:10 }}
              >
                <LeadCard
                  lead={l}
                  msgs={leadMessages[l.id]||{}}
                  replyMsgs={leadReplyMessages(l, leadMessages, whatsappMsgs)}
                  waMsgs={getWaMsgsForPhone(whatsappMsgs, normalizePhone(l.telefone), leadStoreIds(l))}
                  onClick={() => { noteConversationSelection(Number(l.responsibleStoreId) > 0 ? Number(l.responsibleStoreId) : l.storeId || currentUser?.storeId, normalizePhone(l.telefone || l.phone)); setSelected(l); }}
                  selected={selected?.id===l.id}
                  currentUser={currentUser}
                />
              </div>
            );

            return (
              <div key={stage.id} style={{ width:230, flexShrink:0, display:"flex", flexDirection:"column", maxHeight:"100%" }}>
                <div style={{ display:"flex", alignItems:"center", gap:7, marginBottom:8, paddingLeft:2 }}>
                  <span style={{ width:9, height:9, borderRadius:"50%", background:stage.color, display:"inline-block", flexShrink:0 }} />
                  <span style={{ fontWeight:700, fontSize:13, color:"#2B1B12" }}>{stage.label}</span>
                  <span style={{ marginLeft:"auto", background:"#E2E8F0", color:"#64748B", borderRadius:99, padding:"1px 9px", fontSize:11, fontWeight:700, fontFamily:"monospace" }}>{stageLeads.length}</span>
                </div>
                <div
                  onDragOver={e=>e.preventDefault()}
                  onDrop={e=>{ e.preventDefault(); handleDrop(stage.id); }}
                  style={{ background:isDragTarget?"#EDE9FE":"#fff", borderRadius:12, padding:"8px 8px 4px", overflowY:"auto", flex:1, minHeight:80, border:isDragTarget?`2px dashed ${stage.color}`:`1px solid #E2E8F0`, transition:"background 0.15s" }}>
                  {stageLeads.length===0 && <div style={{ textAlign:"center", color:isDragTarget?stage.color:"#9C8F7E", fontSize:11, padding:"24px 0", fontWeight:isDragTarget?700:400 }}>{isDragTarget?"⬇ Soltar aqui":<ScopedLeadEmptyLabel fallback="Nenhum lead" />}</div>}

                  {/* P1 — Aguardando resposta do consultor (mais recente primeiro) */}
                  {unansweredLeads.length>0 && (
                    <div style={{ marginBottom:4 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:5, margin:"4px 0 4px", padding:"0 2px" }}>
                        <span style={{ fontSize:9.5, fontWeight:800, color:"#EF4444", letterSpacing:0.4, whiteSpace:"nowrap", textTransform:"uppercase" }}>🔴 Aguardando resposta</span>
                        <span style={{ background:"#FEE2E2", color:"#EF4444", borderRadius:99, padding:"0 6px", fontSize:9.5, fontWeight:700, fontFamily:"monospace" }}>{unansweredLeads.length}</span>
                        <div style={{ flex:1, height:1, background:"#FECACA" }} />
                      </div>
                      {unansweredLeads.map(renderCard)}
                    </div>
                  )}

                  {/* P2 — Afazer para hoje ou atrasado */}
                  {overdueOrTodayLeads.length>0 && (
                    <div style={{ marginBottom:4 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:5, margin:"4px 0 4px", padding:"0 2px" }}>
                        <span style={{ fontSize:9.5, fontWeight:800, color:"#D97706", letterSpacing:0.4, whiteSpace:"nowrap", textTransform:"uppercase" }}>🟠 Para hoje / Atrasados</span>
                        <span style={{ background:"#FEF3C7", color:"#D97706", borderRadius:99, padding:"0 6px", fontSize:9.5, fontWeight:700, fontFamily:"monospace" }}>{overdueOrTodayLeads.length}</span>
                        <div style={{ flex:1, height:1, background:"#FDE68A" }} />
                      </div>
                      {prioritizeTextSendFailures(overdueOrTodayLeads, getTextSendAttempts()).map(renderCard)}
                    </div>
                  )}

                  {/* P3 — Demais leads agrupados por data de entrada */}
                  {prioritizeTextSendGroups(arrivalGroups, getTextSendAttempts()).map(g => (
                    <div key={g.key}>
                      <div style={{ display:"flex", alignItems:"center", gap:5, margin:"6px 0 4px", padding:"0 2px" }}>
                        <span style={{ fontSize:9.5, fontWeight:800, color:"#8B6F47", letterSpacing:0.4, whiteSpace:"nowrap", textTransform:"uppercase" }}>{g.label}</span>
                        <span style={{ background:"#F3EDE2", color:"#9C8F7E", borderRadius:99, padding:"0 6px", fontSize:9.5, fontWeight:700, fontFamily:"monospace" }}>{g.items.length}</span>
                        <div style={{ flex:1, height:1, background:"#E8E1D3" }} />
                      </div>
                      {prioritizeTextSendFailures(g.items, getTextSendAttempts()).map(renderCard)}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
          </div>
        </div>
        {/* Side panel */}
        {selected && (
          <LeadPanel
            lead={leads.find(l=>l.id===selected.id) || selected}
            msgs={leadMessages[selected.id]||{}}
            waMsgs={getWaMsgsForPhone(whatsappMsgs, normalizePhone(selected.telefone), leadStoreIds(selected))}
            events={leadEvents[selected.id]||{}}
            onClose={()=>setSelected(null)}
            onUpdate={(updated)=>Promise.resolve(onUpdate(updated)).then(result=>{ setSelected(prev=>prev?.id===updated.id ? { ...prev, ...updated } : prev); return result; })}
            onDelete={onDelete ? (id=>{ onDelete(id); setSelected(null); }) : undefined}
            onDeleteWhatsAppMessage={onDeleteWhatsAppMessage}
            onSendMessage={onSendMessage}
            onSendZapi={onSendZapi}
            onSendZapiMedia={onSendZapiMedia}
            onLogTransfer={onLogTransfer}
            onAddReminder={onAddReminder}
            currentUser={currentUser}
            onCreateProspItem={onCreateProspItem}
            onConversationActive={onConversationActive}
            onRegistrarVenda={onRegistrarVenda ? () => onRegistrarVenda(createSaleTarget("leads", selected, currentUser?.storeId, currentUser?.id)) : null}
          />
        )}
      </div>
    </div>
  );
}

function AddLeadFechamentoModal({ currentUser, onAdd, onUpdate, onClose, editLead=null }) {
  const isEdit = !!editLead;
  const today = new Date().toISOString().split("T")[0];
  const storeConsultants = USERS.filter(u => u.role === "consultant" && ![22, 31].includes(Number(u.id)) && (
    ["admin", "superadmin"].includes(currentUser.role) ? true : u.storeId === currentUser.storeId
  ));
  const [nome,           setNome]           = useState(editLead?.nome || "");
  const [produto,        setProduto]        = useState(editLead?.produto_anuncio || "");
  const [valor,          setValor]          = useState(editLead?.valor_venda != null ? String(editLead.valor_venda) : "");
  const [consultantId,   setConsultantId]   = useState(
    editLead?.consultantId || (currentUser.role === "consultant" ? currentUser.id : (storeConsultants[0]?.id || ""))
  );
  const [dataFechamento, setDataFechamento] = useState(editLead?.fechou_venda_em || today);
  const [saving,         setSaving]         = useState(false);
  const [saveError,      setSaveError]      = useState("");

  const handleSave = async () => {
    if (!nome.trim() || saving) return;
    if (manualSaleWriteDenied({
      user:currentUser,
      previousStage:editLead?._crm_estagio ?? editLead?.estagio
        ?? (isEdit && editLead?.manualFechamento ? "fechou_venda" : undefined),
      nextStage:"fechou_venda",
      saleStages:["fechou_venda"],
      creatingSale:!isEdit,
    })) {
      setSaveError(MANUAL_SALE_CUTOFF_NOTICE);
      return;
    }
    setSaving(true);
    setSaveError("");
    const storeId = USERS.find(u => u.id === Number(consultantId))?.storeId || currentUser.storeId || 1;
    const entry = {
      ...(isEdit ? editLead : {}),
      id: isEdit ? editLead.id : `_vm_${Date.now()}`,
      nome: nome.trim(),
      produto_anuncio: produto.trim(),
      valor_venda: parseValorBR(valor),
      consultantId: Number(consultantId),
      storeId,
      estagio: "fechou_venda",
      fechou_venda_em: dataFechamento,
      data_fechamento: dataFechamento,
      data_criacao: isEdit ? (editLead.data_criacao || today) : today,
      manualFechamento: true,
    };
    try {
      if (isEdit && onUpdate) await onUpdate(entry);
      else if (onAdd) await onAdd(entry);
      onClose();
    } catch (error) {
      console.error("[AddLeadFechamento] erro ao salvar:", error);
      setSaveError(error?.message || "Não foi possível salvar a venda. Tente novamente.");
    } finally {
      setSaving(false);
    }
  };

  const inp = { width:"100%", padding:"9px 12px", borderRadius:8, border:"1.5px solid #D4C5A9", fontSize:14, boxSizing:"border-box", fontFamily:"inherit" };
  const lbl = { fontSize:12, fontWeight:700, color:"#2B1B12", display:"block", marginBottom:5 };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.45)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div style={{ background:"#fff", borderRadius:18, padding:28, width:"100%", maxWidth:460, maxHeight:"90vh", overflowY:"auto", boxShadow:"0 8px 40px rgba(0,0,0,0.18)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <div style={{ fontWeight:800, fontSize:17, color:"#2B1B12" }}>{isEdit ? "✏️ Editar Venda" : "🎉 Registrar Venda de Lead"}</div>
          <button onClick={onClose} style={{ background:"none", border:"none", fontSize:20, cursor:"pointer", color:"#8B6F47" }}>✕</button>
        </div>
        {!isEdit && (
          <div style={{ fontSize:12, color:"#8B6F47", background:"#FEF9F0", border:"1px solid #D4C5A9", borderRadius:8, padding:"8px 12px", marginBottom:16 }}>
            Use para registrar vendas de leads que fecharam fora do kanban (presencial, ligação, etc.).
          </div>
        )}
        <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
          <div>
            <label style={lbl}>Nome do cliente *</label>
            <input style={inp} value={nome} onChange={e=>setNome(e.target.value)} placeholder="Ex: Maria Silva" />
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
            <div>
              <label style={lbl}>Produto</label>
              <input style={inp} value={produto} onChange={e=>setProduto(e.target.value)} placeholder="Ex: Sofá 3 lug." />
            </div>
            <div>
              <label style={lbl}>Valor da venda (R$)</label>
              <input style={inp} type="text" value={valor} onChange={e=>setValor(e.target.value)} placeholder="Ex: 40.410,00 ou 40410" />
            </div>
          </div>
          {currentUser.role !== "consultant" && (
            <div>
              <label style={lbl}>Consultor</label>
              <select style={{ ...inp, background:"#fff" }} value={consultantId} onChange={e=>setConsultantId(e.target.value)}>
                {storeConsultants.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
              </select>
            </div>
          )}
          <div>
            <label style={lbl}>📅 Data do fechamento</label>
            <input type="date" style={inp} value={dataFechamento} onChange={e=>setDataFechamento(e.target.value)} />
          </div>
          <div style={{ display:"flex", gap:10, justifyContent:"flex-end", marginTop:4 }}>
            <button onClick={onClose} style={{ background:"#F3EDE2", color:"#2B1B12", border:"none", borderRadius:10, padding:"9px 20px", fontSize:14, fontWeight:700, cursor:"pointer" }}>Cancelar</button>
            <button onClick={handleSave} disabled={!nome.trim()||saving} style={{ background:(nome.trim()&&!saving)?"#2563EB":"#ccc", color:"#fff", border:"none", borderRadius:10, padding:"9px 22px", fontSize:14, fontWeight:700, cursor:(nome.trim()&&!saving)?"pointer":"default" }}>{saving ? "Salvando…" : isEdit ? "Salvar alterações" : "Salvar"}</button>
          </div>
          {saveError && <div role="alert" style={{ fontSize:12, fontWeight:700, color:"#B91C1C", background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:8, padding:"9px 12px" }}>⚠️ {saveError}</div>}
        </div>
      </div>
    </div>
  );
}

// Cadastro manual de lead — usado quando um cliente chega pelo WhatsApp mas,
// por algum problema (bug de telefone, falha no webhook, etc.), não aparece
// automaticamente no Kanban de Leads. Permite ao consultor/gerente registrar
// o contato como lead para continuar a conversa dentro do CRM.
function AddManualLeadModal({ currentUser, onAdd, onClose }) {
  const today = new Date().toISOString().split("T")[0];
  const storeConsultants = USERS.filter(u => u.role === "consultant" && ![22, 31].includes(Number(u.id)) && (
    currentUser.role === "admin" ? true : u.storeId === currentUser.storeId
  ));
  const [nome,         setNome]         = useState("");
  const [telefone,     setTelefone]     = useState("");
  const [produto,      setProduto]      = useState("");
  const [consultantId, setConsultantId] = useState(
    currentUser.role === "consultant" ? currentUser.id : (storeConsultants[0]?.id || "")
  );
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  const telDigits = telefone.replace(/\D/g,"");
  const isValid = nome.trim().length>0 && telDigits.length>=10;

  const handleSave = async () => {
    if (!isValid || saving) return;
    setSaving(true);
    setSaveError("");
    const consultant = USERS.find(u => u.id === Number(consultantId));
    const storeId = consultant?.storeId || currentUser.storeId || 1;
    const responsavelNome = currentUser.role === "consultant"
      ? currentUser.name.split(" ")[0]
      : (consultant?.name?.split(" ")[0] || "aurora");
    const entry = {
      id: `manual_${Date.now()}`,
      nome: nome.trim(),
      telefone: normalizePhone(telDigits) || telDigits,
      produto_anuncio: produto.trim(),
      estagio: "chegou",
      responsavel: responsavelNome,
      consultantId: Number(consultantId) || null,
      storeId,
      tentativas_followup: 0,
      createdAt: today,
      data_criacao: today,
      origem_manual: true,
    };
    try {
      await onAdd(entry);
      onClose();
    } catch (error) {
      setSaveError(error?.message || "Não foi possível cadastrar o lead. Tente novamente.");
    } finally {
      setSaving(false);
    }
  };

  const inp = { width:"100%", padding:"9px 12px", borderRadius:8, border:"1.5px solid #D4C5A9", fontSize:14, boxSizing:"border-box", fontFamily:"inherit" };
  const lbl = { fontSize:12, fontWeight:700, color:"#2B1B12", display:"block", marginBottom:5 };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.45)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div style={{ background:"#fff", borderRadius:18, padding:28, width:"100%", maxWidth:460, maxHeight:"90vh", overflowY:"auto", boxShadow:"0 8px 40px rgba(0,0,0,0.18)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <div style={{ fontWeight:800, fontSize:17, color:"#2B1B12" }}>✋ Cadastrar Lead Manual</div>
          <button onClick={onClose} style={{ background:"none", border:"none", fontSize:20, cursor:"pointer", color:"#8B6F47" }}>✕</button>
        </div>
        <div style={{ fontSize:12, color:"#8B6F47", background:"#FEF9F0", border:"1px solid #D4C5A9", borderRadius:8, padding:"8px 12px", marginBottom:16 }}>
          Use quando um cliente escrever no WhatsApp mas não aparecer sozinho no Kanban de Leads. Ele entra direto na coluna "Chegou" e você já pode continuar a conversa por aqui.
        </div>
        <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
          <div>
            <label style={lbl}>Nome do cliente *</label>
            <input style={inp} value={nome} onChange={e=>setNome(e.target.value)} placeholder="Ex: Maria Silva" />
          </div>
          <div>
            <label style={lbl}>Telefone (WhatsApp) *</label>
            <input style={inp} value={telefone} onChange={e=>setTelefone(e.target.value)} placeholder="Ex: 41 99981-3231" />
          </div>
          <div>
            <label style={lbl}>Produto de interesse</label>
            <input style={inp} value={produto} onChange={e=>setProduto(e.target.value)} placeholder="Ex: Sofá 3 lug." />
          </div>
          {currentUser.role !== "consultant" && (
            <div>
              <label style={lbl}>Consultor</label>
              <select style={{ ...inp, background:"#fff" }} value={consultantId} onChange={e=>setConsultantId(e.target.value)}>
                {storeConsultants.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
              </select>
            </div>
          )}
          <div style={{ display:"flex", gap:10, justifyContent:"flex-end", marginTop:4 }}>
            <button onClick={onClose} style={{ background:"#F3EDE2", color:"#2B1B12", border:"none", borderRadius:10, padding:"9px 20px", fontSize:14, fontWeight:700, cursor:"pointer" }}>Cancelar</button>
            <button onClick={handleSave} disabled={!isValid||saving} style={{ background:isValid&&!saving?"#2563EB":"#ccc", color:"#fff", border:"none", borderRadius:10, padding:"9px 22px", fontSize:14, fontWeight:700, cursor:isValid&&!saving?"pointer":"default" }}>{saving ? "Salvando…" : "Salvar"}</button>
          </div>
          {saveError && <div role="alert" style={{ fontSize:12, fontWeight:700, color:"#B91C1C", background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:8, padding:"9px 12px" }}>{saveError}</div>}
        </div>
      </div>
    </div>
  );
}

// Converte uma data (ISO com hora ou já no formato YYYY-MM-DD) para a chave de dia
// no fuso de Brasília. Necessário porque os timestamps são salvos em UTC
// (new Date().toISOString()) e comparar apenas o prefixo UTC zera contagens
// "de hoje" à noite no horário de Brasília (UTC vira o dia seguinte 3h antes).
function toBRDateKey(value) {
  if (!value) return "";
  if (typeof value === "string" && value.length === 10 && !value.includes("T")) return value;
  const d = new Date(value);
  if (isNaN(d)) return "";
  return d.toLocaleDateString("en-CA", { timeZone: "America/Sao_Paulo" });
}

function DuplicateLeadGroup({ group, onMerge }) {
  const smartDefault = (() => {
    // Prioriza: lead com mais avanço no funil (não desqualificado) > criado há mais tempo > primeiro da lista
    const naoDesq = group.filter(l=>l.estagio!=="desqualificado");
    if (naoDesq.length===1) return naoDesq[0].id;
    const ordered = [...group].sort((a,b)=>{
      const da = a.createdAt || a.data_criacao || "";
      const db_ = b.createdAt || b.data_criacao || "";
      return da.localeCompare(db_);
    });
    return ordered[0].id;
  })();
  const [primaryId, setPrimaryId] = useState(smartDefault);
  const [merging, setMerging] = useState(false);

  const handleMerge = () => {
    if (merging) return;
    setMerging(true);
    onMerge(group, primaryId);
  };

  return (
    <div style={{ border:"1px solid #FDE68A", background:"#FFFBEB", borderRadius:10, padding:"12px 14px" }}>
      <div style={{ display:"flex", flexWrap:"wrap", gap:8, marginBottom:10 }}>
        {group.map(l=>{
          const s = LEAD_STAGES.find(st=>st.id===l.estagio) || LEAD_STAGES[0];
          return (
            <label key={l.id} style={{
              display:"flex", alignItems:"flex-start", gap:6, cursor:"pointer",
              background:"#fff", border:primaryId===l.id?"2px solid #C0392B":"1px solid #E2E8F0",
              borderRadius:8, padding:"8px 10px", flex:"1 1 200px", minWidth:180,
            }}>
              <input type="radio" checked={primaryId===l.id} onChange={()=>setPrimaryId(l.id)} style={{ marginTop:3 }} />
              <div style={{ minWidth:0 }}>
                <div style={{ fontWeight:700, fontSize:12.5, color:"#1E293B", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{l.nome || "(sem nome)"}</div>
                <div style={{ fontSize:10.5, color:"#64748B", fontFamily:"monospace" }}>{l.telefone}</div>
                <div style={{ fontSize:10, fontWeight:700, color:s.color, marginTop:2 }}>{s.label}</div>
              </div>
            </label>
          );
        })}
      </div>
      <button onClick={handleMerge} disabled={merging} style={{
        background:merging?"#FCA5A5":"#C0392B", color:"#fff", border:"none", borderRadius:8,
        padding:"7px 14px", fontSize:12, fontWeight:700, cursor:merging?"default":"pointer",
      }}>{merging ? "Mesclando..." : "🔗 Mesclar em 1 lead"}</button>
    </div>
  );
}

// ── Chat com IA Gerencial (manager/admin) ─────────────────────────────────────
function AiChatView({ currentUser }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  // Período — storeId vem SEMPRE do usuário logado, nunca digitado manualmente
  const [period, setPeriod] = useState("este_mes");
  const chatEndRef = useRef(null);
  useEffect(() => { chatEndRef.current?.scrollIntoView({ behavior:'smooth' }); }, [messages]);

  const storeId = currentUser?.storeId ?? null;

  const send = async () => {
    const text = input.trim();
    if (!text || loading) return;
    setMessages(prev => [...prev, { role:'user', text }]);
    setInput("");
    setLoading(true);
    try {
      const r = await fetch('/api/ah-gerencial', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ message: text, storeId, period, history: messages }),
      });
      const d = await r.json();
      setMessages(prev => [...prev, { role:'model', text: d.reply || d.error || 'Erro desconhecido' }]);
    } catch(e) {
      setMessages(prev => [...prev, { role:'model', text:'⚠️ Erro de rede ao conectar à IA.' }]);
    }
    setLoading(false);
  };

  const PERIOD_OPTIONS = [
    { value:"hoje",        label:"Hoje" },
    { value:"esta_semana", label:"Esta semana" },
    { value:"este_mes",    label:"Este mês" },
    { value:"tudo",        label:"Todos os tempos" },
  ];

  const suggestions = [
    "Quantos leads recebi e quantos fechei?",
    "Qual a taxa de conversão da loja?",
    "Estratégias para reativar leads frios",
    "Como melhorar o funil de atendimento?",
  ];

  return (
    <div style={{ maxWidth:720, margin:"0 auto", padding:"24px 16px", display:"flex", flexDirection:"column", height:"calc(100vh - 160px)" }}>
      {/* Cabeçalho */}
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:10, marginBottom:14 }}>
        <div>
          <div style={{ fontWeight:800, fontSize:20, color:T.text }}>💡 IA Gerencial</div>
          <div style={{ fontSize:12, color:T.muted, marginTop:2 }}>
            Análise com dados reais da loja · storeId {storeId}
          </div>
        </div>
        {/* Seletor de período — filtra os dados que a IA recebe */}
        <div style={{ display:"flex", alignItems:"center", gap:6 }}>
          <span style={{ fontSize:11, color:T.muted, fontWeight:600 }}>📅 Período:</span>
          <select value={period} onChange={e=>{ setPeriod(e.target.value); setMessages([]); }}
            style={{ padding:"5px 10px", borderRadius:8, border:"1.5px solid #D4C5A9", fontSize:12, background:"#FEF9F0", color:T.text, cursor:"pointer" }}>
            {PERIOD_OPTIONS.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>
      </div>

      {/* Mensagens */}
      <div style={{ flex:1, overflowY:"auto", display:"flex", flexDirection:"column", gap:12, marginBottom:16, padding:"4px 0" }}>
        {messages.length === 0 && (
          <div style={{ textAlign:"center", color:T.muted, fontSize:13, marginTop:32 }}>
            <div style={{ fontSize:36, marginBottom:10 }}>🤖</div>
            <div style={{ marginBottom:4, fontWeight:600 }}>Olá, {currentUser?.name?.split(" ")[0]}!</div>
            <div style={{ fontSize:12, marginBottom:14 }}>Pergunte sobre os dados reais da loja. Mudei o período acima para ajustar o contexto.</div>
            <div style={{ display:"flex", flexWrap:"wrap", gap:8, justifyContent:"center" }}>
              {suggestions.map(s => (
                <button key={s} onClick={()=>setInput(s)}
                  style={{ background:"#F3EDE2", border:"1px solid #D4C5A9", borderRadius:20, padding:"6px 14px", fontSize:12, cursor:"pointer", color:T.text }}>
                  {s}
                </button>
              ))}
            </div>
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} style={{ display:"flex", justifyContent:m.role==="user"?"flex-end":"flex-start" }}>
            <div style={{ maxWidth:"82%", padding:"10px 14px",
              borderRadius: m.role==="user"?"14px 14px 4px 14px":"14px 14px 14px 4px",
              background: m.role==="user"?"#8B6F47":"#fff", color: m.role==="user"?"#fff":"#2B1B12",
              fontSize:13, lineHeight:1.65, boxShadow:"0 1px 4px rgba(0,0,0,0.08)",
              border: m.role==="model"?"1px solid #E8E1D3":"none", whiteSpace:"pre-wrap" }}>
              {m.text}
            </div>
          </div>
        ))}
        {loading && (
          <div style={{ display:"flex", justifyContent:"flex-start" }}>
            <div style={{ background:"#fff", border:"1px solid #E8E1D3", borderRadius:"14px 14px 14px 4px", padding:"10px 14px", fontSize:13, color:T.muted }}>⏳ Consultando dados e pensando…</div>
          </div>
        )}
        <div ref={chatEndRef} />
      </div>

      {/* Compositor */}
      <div style={{ display:"flex", gap:8 }}>
        <input value={input} onChange={e=>setInput(e.target.value)}
          onKeyDown={e=>{ if(e.key==="Enter"&&!e.shiftKey){ e.preventDefault(); send(); } }}
          placeholder="Pergunte sobre leads, vendas, conversão…"
          style={{ flex:1, padding:"10px 14px", borderRadius:12, border:"1.5px solid #D4C5A9", fontSize:13, outline:"none", background:"#FEF9F0", color:T.text }} />
        <button onClick={send} disabled={loading||!input.trim()}
          style={{ background:loading||!input.trim()?"#D4C5A9":"#8B6F47", color:"#fff", border:"none", borderRadius:12, padding:"10px 20px", fontSize:13, fontWeight:700, cursor:loading||!input.trim()?"default":"pointer" }}>
          Enviar
        </button>
      </div>
    </div>
  );
}

function LeadsDashboard({ leads, clients=[], currentUser, onAdd, onUpdate, onDelete, onMerge, leadMessages={}, leadEvents={}, onSendMessage, whatsappMsgs={}, onSendZapi, onSendZapiMedia, onDeleteWhatsAppMessage=null, onLogTransfer, onAddReminder, onRegistrarVenda, onCreateProspItem, showStoreFilter=false, storeFilter="todas", onStoreFilterChange }) {
  const today      = toBRDateKey(new Date());
  const currentYM  = today.slice(0,7);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editLead,     setEditLead]     = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(currentYM);
  const [drillDown, setDrillDown] = useState(null);
  const [openLead, setOpenLeadRaw] = useState(null);
  const setOpenLead = useCallback((next) => {
    if (next && openLead && next.id !== openLead.id) {
      return activeConversationExitGuard.requestAction(() => setOpenLeadRaw(next));
    }
    setOpenLeadRaw(next);
  }, [openLead]);
  const [leadFilters, setLeadFilters] = useScreenPeriodFilters("leadsDashboard", DEFAULT_FILTERS);
  const isStaffUser = currentUser?.role==="admin" || currentUser?.role==="manager";
  const storeConsultantsLD = USERS.filter(u => u.role==="consultant" && (["admin", "superadmin"].includes(currentUser?.role) ? true : u.storeId===currentUser?.storeId));
  const effLeadFilters = leadFilters;
  const leadPeriodRange = getPeriodRange(effLeadFilters.period, effLeadFilters.customFrom, effLeadFilters.customTo);
  const leadEntryDate = canonicalLeadEntryDate;
  // Leads reais (não fechamentos manuais), escopados pela loja do usuário
  // (admin vê todas). O vínculo de loja não pode depender de consultantId:
  // leads ainda sob a Aurora não têm consultor e também precisam ser contados.
  const leadsScoped = leads.filter(l => !l.manualFechamento && (currentUser?.role==="admin" ? true : leadBelongsToStore(l, currentUser?.storeId)));
  // Consultor vê somente seus próprios leads — sem depender do filtro manual
  const consultantScopeId = currentUser?.role === 'consultant' ? currentUser.id : null;
  const leadsForStats = consultantScopeId
    ? leadsScoped.filter(l => resolveLeadConsultantId(l) === consultantScopeId)
    : leadsScoped;
  // Coorte por data de entrada do lead, ignorando o filtro de consultor específico (usada no ranking, pra mostrar todo mundo)
  const leadsPeriodAll = leadsScoped.filter(l => effLeadFilters.period === "tudo" || inPeriod(leadEntryDate(l), leadPeriodRange));
  // Mesma coorte, já aplicando o filtro de consultor específico (usada nos cards de topo).
  // Se o usuário é consultor, sempre escopa ao próprio id, independente do filtro manual.
  const leadsPeriod = leadsPeriodAll.filter(l => {
    if (consultantScopeId && resolveLeadConsultantId(l) !== consultantScopeId) return false;
    return matchesResponsavelFiltro(l, leadFilters.consultantId);
  });
  const cRecebidos    = leadsPeriod.length;
  const cQualificados = leadsPeriod.filter(l=>l.estagio==="qualificado").length;
  // Transferido = qualquer lead que já saiu das mãos da Aurora para um humano
  // (responsavel com nome real ou consultantId atribuído), indiferente do estágio
  // em que está agora (qualificado, negociando, vai na loja, vendido etc).
  const isTransferido = (l) => (l.responsavel && l.responsavel!=="aurora") || l.consultantId!=null;
  const cTransferidos = leadsPeriod.filter(isTransferido).length;
  const cNegociacao   = leadsPeriod.filter(l=>["qualificacao","followup_programado"].includes(l.estagio)).length;
  const cVendidos     = leadsPeriod.filter(l=>l.estagio==="fechou_venda").length;
  const cPerdidos     = leadsPeriod.filter(l=>l.estagio==="desqualificado").length;
  // "Em conversa" = respondeu e segue em atendimento, mas ainda não foi vendido, perdido
  // ou transferido para um consultor humano — ainda dentro do fluxo automático/ativo.
  const cEmConversa = leadsPeriod.filter(l=>!["fechou_venda","desqualificado"].includes(l.estagio) && !isTransferido(l)).length;
  const convGeralPeriodo = pct(cVendidos, cRecebidos);
  const vendidosPeriodoList = leadsPeriod.filter(l=>l.estagio==="fechou_venda");
  const valorVendidoPeriodo = vendidosPeriodoList.reduce((s,l)=>s+(Number(l.valor_venda)||0),0);
  const leadRanking = storeConsultantsLD.map(u => {
    const list = leadsPeriodAll.filter(l=>leadOwnedByConsultant(l,u));
    const vendidos = list.filter(l=>l.estagio==="fechou_venda");
    return {
      id:u.id, name:u.name,
      recebidos:list.length, recebidosList:list,
      vendidos:vendidos.length, vendidosList:vendidos,
      conv:pct(vendidos.length, list.length),
    };
  }).sort((a,b)=>b.vendidos-a.vendidos);

  // Agrupa leads pelo mesmo telefone (tolerando 9º dígito e prefixo 55) para achar duplicados
  const strip9 = (p) => p.length===11 ? p.slice(0,2)+p.slice(3) : p;
  const duplicateGroups = (() => {
    if (!isStaffUser) return [];
    const groups = {};
    leads.forEach(l => {
      if (l.manualFechamento) return;
      const norm = strip9(normalizePhone(l.telefone || ""));
      if (!norm || norm.length < 8) return;
      groups[norm] = groups[norm] || [];
      groups[norm].push(l);
    });
    return Object.values(groups).filter(g => g.length > 1);
  })();

  // Enquanto o backfill histórico não for executado, campos antigos de criação
  // continuam válidos. `ultima_atualizacao` não entra como chegada: ela moveria
  // artificialmente um lead antigo para o período atual.
  // leadsForStats já é escopado por loja + consultor (se consultor logado); substitui "leads" bruto em todos os indicadores
  const todayLeads = leadsForStats.filter(l => toBRDateKey(leadEntryDate(l))===today);
  const total      = leadsForStats.length;
  const qualif     = leadsForStats.filter(l=>l.estagio==="qualificado").length;
  const perdidosGeralCount = leadsForStats.filter(l=>l.estagio==="desqualificado").length;
  const taxaQualificacaoGeral   = pct(qualif, total);
  const taxaDesqualificacaoGeral = pct(perdidosGeralCount, total);
  // Fechamentos via kanban de leads (manual ou lead real) no mês selecionado
  const fechamentosLeads = leadsForStats.filter(l=>l.estagio==="fechou_venda"&&(l.fechou_venda_em||"").startsWith(selectedMonth));
  // Fechamentos automáticos: clientes do Atendimento Presencial com origem "Lead" fechados no mês selecionado
  const closedLeadClients = clients.filter(c => {
    if (c.origin !== "Lead") return false;
    if (!wasSold(c)) return false;
    if (consultantScopeId && c.consultantId !== consultantScopeId) return false;
    const cd = c.data_fechamento||c.stageDates?.closed||c.stageDates?.posVenda||c.stageDates?.nextSale||"";
    return cd.startsWith(selectedMonth);
  });
  // Une os dois, sem duplicar — exclui closedLeadClients cujo telefone já está em fechamentosLeads
  const fechamentosLeadsPhones = new Set(fechamentosLeads.map(l => normalizePhone(l.telefone || l.phone || "")));
  const fechamentos = [
    ...fechamentosLeads,
    ...closedLeadClients
      .filter(c => !fechamentosLeadsPhones.has(normalizePhone(c.phone || "")))
      .map(c=>({ id:`_ac_${c.id}`, nome:c.name, produto_anuncio:c.product, valor_venda:c.value||0, consultantId:c.consultantId, fechou_venda_em: c.data_fechamento||c.stageDates?.closed||today, fromAtendimento:true })),
  ];
  const totalValorFechamentos = fechamentos.reduce((s,l)=>s+(Number(l.valor_venda)||0),0);
  const leadsThisMonth = leadsForStats.filter(l => toBRDateKey(leadEntryDate(l)).startsWith(selectedMonth)).length;
  const leadConvMonth  = leadsThisMonth > 0 ? Math.round(fechamentos.length / leadsThisMonth * 100) : 0;

  // Opções de mês: últimos 6 meses
  const monthOptions = Array.from({length:6},(_,i)=>{
    const d = new Date(); d.setDate(1); d.setMonth(d.getMonth()-i);
    const ym = d.toISOString().slice(0,7);
    const label = d.toLocaleDateString("pt-BR",{month:"long",year:"numeric"});
    return { ym, label };
  });
  const days = [];
  for (let i=6;i>=0;i--) {
    const d=new Date(); d.setDate(d.getDate()-i);
    const key=toBRDateKey(d);
    const label=d.toLocaleDateString("pt-BR",{weekday:"short"}).replace(".","");
    days.push({key,label,count:leadsForStats.filter(l=>toBRDateKey(leadEntryDate(l))===key).length});
  }
  const maxCount=Math.max(...days.map(d=>d.count),1);
  const CW=300,CH=110,BW=30,gap=(CW-days.length*BW)/(days.length+1);
  const byStage=LEAD_STAGES.map(s=>({...s,count:leadsForStats.filter(l=>l.estagio===s.id).length}));
  const desqualificados = leadsForStats.filter(l=>l.estagio==="desqualificado");
  const efetivoMotivoTipo = (l) => l.motivo_desqualificacao_tipo || guessMotivoTipo(l.motivo_desqualificacao);
  const byReason = DESQUALIFICACAO_REASONS.map(r=>({...r,count:desqualificados.filter(l=>efetivoMotivoTipo(l)===r.id).length}));
  const semMotivoCount = desqualificados.filter(l=>!efetivoMotivoTipo(l)).length;
  const leadToItem = (l, opts={}) => ({
    id:l.id, name:l.nome, phone:l.telefone, storeId:l.lojaAtual || l.storeId, consultant:USERS.find(u=>u.id===Number(l.consultantId))?.name.split(" ")[0],
    store:STORES.find(s=>s.id===Number(l.storeId||1))?.name, origin:l.produto_anuncio, status:LEAD_STAGES.find(s=>s.id===l.estagio)?.label||l.estagio,
    createdAt:leadEntryDate(l), lastInteraction:leadEntryDate(l),
    actionLabel:"Ver ficha completa", onAction:()=>{ setDrillDown(null); setOpenLead(l); },
    onDelete: (opts.allowDelete && onDelete && currentUser?.role==="admin") ? ()=>{ if(window.confirm(`Excluir o lead "${l.nome||l.telefone}"? Essa ação não pode ser desfeita.`)) onDelete(l.id); } : undefined,
  });
  return (
    <div>
      {/* Filtro por data de entrada + conversão por consultor — números sempre da mesma coorte filtrada */}
      <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:20, boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
        <div style={{ fontWeight:700, fontSize:14, color:"#1E293B", marginBottom:12 }}>📅 Leads por Data de Entrada — {periodLabelText(effLeadFilters, "")}</div>
        <FilterBar
          filters={leadFilters}
          setFilters={setLeadFilters}
          consultants={isStaffUser ? storeConsultantsLD : null}
          showConsultant={isStaffUser}
          showStatus={false}
          showStore={showStoreFilter}
          storeValue={storeFilter}
          onStoreChange={onStoreFilterChange}
        />
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(110px,1fr))", gap:10, marginBottom:14 }}>
          {[
            { icon:"📥", label:"Recebidos",     value:cRecebidos,               color:"#6366F1", list:leadsPeriod },
            { icon:"✅", label:"Qualificados",  value:cQualificados,            color:"#22C55E", list:leadsPeriod.filter(l=>l.estagio==="qualificado") },
            { icon:"🗨️", label:"Em conversa",   value:cEmConversa,              color:"#0EA5E9", list:leadsPeriod.filter(l=>!["fechou_venda","desqualificado"].includes(l.estagio) && !isTransferido(l)) },
            { icon:"🏪", label:"Transferidos",  value:cTransferidos,            color:"#7C3AED", list:leadsPeriod.filter(isTransferido) },
            { icon:"💬", label:"Em negociação", value:cNegociacao,              color:"#F59E0B", list:leadsPeriod.filter(l=>["qualificacao","followup_programado"].includes(l.estagio)) },
            { icon:"🏆", label:"Vendidos",      value:cVendidos,                color:"#2563EB", list:leadsPeriod.filter(l=>l.estagio==="fechou_venda") },
            { icon:"🚫", label:"Desqualificados", value:cPerdidos,              color:"#C0392B", list:leadsPeriod.filter(l=>l.estagio==="desqualificado") },
            { icon:"📊", label:"Conversão",     value:`${convGeralPeriodo}%`,   color:"#D97706", list:leadsPeriod.filter(l=>l.estagio==="fechou_venda") },
          ].map(m=>(
            <div key={m.label} onClick={()=>setDrillDown({ title:m.label, items:m.list.map(leadToItem), period:periodLabelText(effLeadFilters, ""), groupByDay:true })}
              style={{ background:"#F8FAFC", borderRadius:10, padding:"10px 12px", textAlign:"center", cursor:"pointer" }}>
              <div style={{ fontSize:16 }}>{m.icon}</div>
              <div style={{ fontSize:16, fontWeight:800, color:m.color }}>{m.value}</div>
              <div style={{ fontSize:10, color:"#64748B", marginTop:2 }}>{m.label}</div>
            </div>
          ))}
        </div>
        {isStaffUser && (
          <>
            <div style={{ fontSize:11, fontWeight:700, color:"#64748B", marginBottom:6 }}>Resumo por consultor</div>
            <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
              {leadRanking.map(r => (
                <div key={r.id} style={{ display:"flex", alignItems:"center", gap:10, background:"#F8FAFC", border:"1px solid #E2E8F0", borderRadius:10, padding:"8px 12px", flexWrap:"wrap" }}>
                  <div style={{ flex:"1 1 120px", fontWeight:700, fontSize:12.5, color:"#1E293B" }}>{r.name.split(" ")[0]}</div>
                  <div onClick={()=>r.recebidos>0 && setDrillDown({ title:`Leads — ${r.name.split(" ")[0]}`, period:periodLabelText(effLeadFilters, ""), items:r.recebidosList.map(leadToItem), groupByDay:true })}
                    style={{ cursor:r.recebidos>0?"pointer":"default", fontSize:12, color:"#6366F1" }}>📥 {r.recebidos} lead{r.recebidos!==1?"s":""}</div>
                  <div onClick={()=>r.vendidos>0 && setDrillDown({ title:`Vendas — ${r.name.split(" ")[0]}`, period:periodLabelText(effLeadFilters, ""), items:r.vendidosList.map(leadToItem), groupByDay:true })}
                    style={{ cursor:r.vendidos>0?"pointer":"default", fontSize:12, color:"#10B981" }}>🏆 {r.vendidos} venda{r.vendidos!==1?"s":""}</div>
                  <div style={{ fontSize:12, fontWeight:700, color:"#D97706" }}>📊 {r.conv}%</div>
                </div>
              ))}
            </div>
            {currentUser?.role === "admin" && STORES.length > 1 && (
              <>
                <div style={{ fontSize:11, fontWeight:700, color:"#64748B", margin:"14px 0 6px" }}>Totais por loja</div>
                <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                  {STORES.map((s,si) => {
                    const sl = leadsPeriodAll.filter(l => leadBelongsToStore(l, s.id));
                    const sv = sl.filter(l => l.estagio==="fechou_venda").length;
                    const sp = sl.filter(l => l.estagio==="desqualificado").length;
                    const sa = sl.filter(l => !["fechou_venda","desqualificado"].includes(l.estagio)).length;
                    const sc = ["#6366F1","#F59E0B","#10B981","#EC4899"][si%4];
                    return (
                      <div key={s.id} style={{ display:"flex", alignItems:"center", gap:10, background:"#fff", border:`2px solid ${sc}33`, borderRadius:10, padding:"8px 12px", flexWrap:"wrap" }}>
                        <span style={{ flex:"1 1 100px", fontWeight:700, fontSize:12, color:sc }}>🏪 {s.name}</span>
                        <span style={{ fontSize:11, color:"#6366F1" }} title="Recebidos">📥 {sl.length}</span>
                        <span style={{ fontSize:11, color:"#10B981" }} title="Vendidos">🏆 {sv}</span>
                        <span style={{ fontSize:11, color:"#EF4444" }} title="Desqualificados">🚫 {sp}</span>
                        <span style={{ fontSize:11, color:"#6B7280" }} title="Ativos">{sa} ativo{sa!==1?"s":""}</span>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </>
        )}
      </div>

      <div style={{ fontWeight:700, fontSize:13, color:"#8B6F47", marginBottom:8 }}>📈 Indicadores de Desempenho</div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))", gap:12, marginBottom:22 }}>
        {[
          {icon:"📥",label:"Leads hoje",   value:todayLeads.length,color:"#6366F1", list:todayLeads},
          {icon:"📋",label:"Total ativo",  value:total,            color:"#0EA5E9", list:leadsForStats},
          {icon:"✅",label:"Taxa de Qualificação",   value:`${taxaQualificacaoGeral}%`, color:"#22C55E", list:leadsForStats.filter(l=>l.estagio==="qualificado")},
          {icon:"🚫",label:"Taxa de Desqualificação",value:`${taxaDesqualificacaoGeral}%`, color:"#C0392B", list:leadsForStats.filter(l=>l.estagio==="desqualificado")},
          {icon:"💰",label:"Valor Vendido",value:valorVendidoPeriodo>0?fmt(valorVendidoPeriodo):"—", color:"#22C55E", list:vendidosPeriodoList, small:valorVendidoPeriodo>0},
        ].map(m=>(
          <div key={m.label} onClick={()=>setDrillDown({ title:m.label, items:m.list.map(leadToItem), period:"Todo o período", groupByDay:true })}
            style={{ background:"#fff", borderRadius:14, padding:18, boxShadow:"0 2px 8px rgba(0,0,0,0.06)", textAlign:"center", cursor:"pointer" }}>
            <div style={{ fontSize:22 }}>{m.icon}</div>
            <div style={{ fontSize:m.small?16:26, fontWeight:800, color:m.color, lineHeight:1.1, marginTop:4 }}>{m.value}</div>
            <div style={{ fontSize:11, color:"#64748B", marginTop:2 }}>{m.label}</div>
          </div>
        ))}
      </div>
      {/* ── Vendas de Leads do mês ── */}
      <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:20, boxShadow:"0 2px 8px rgba(0,0,0,0.06)", border:"2px solid #2563EB22" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12, flexWrap:"wrap", gap:8 }}>
          <div style={{ fontWeight:700, fontSize:13, color:"#1E293B" }}>🏆 Vendas de Leads</div>
          <select value={selectedMonth} onChange={e=>setSelectedMonth(e.target.value)}
            style={{ fontSize:12, fontWeight:700, borderRadius:8, border:"1.5px solid #D4C5A9", padding:"4px 10px", background:"#FEF9F0", color:"#2B1B12", cursor:"pointer" }}>
            {monthOptions.map(o=><option key={o.ym} value={o.ym}>{o.label}</option>)}
          </select>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10 }}>
          <div onClick={()=>setDrillDown({ title:"Vendas fechadas", period:`Mês ${selectedMonth}`, items:fechamentos.map(l=>({
              id:l.id, name:l.nome, consultant:USERS.find(u=>u.id===Number(l.consultantId))?.name.split(" ")[0],
              origin:l.produto_anuncio, value:Number(l.valor_venda)||0, createdAt:l.fechou_venda_em, lastInteraction:l.fechou_venda_em, status:"Fechou Venda 🎉",
              ...(!l.fromAtendimento ? { actionLabel:"Ver ficha completa", onAction:()=>{ setDrillDown(null); setOpenLead(l); } } : {}),
            })), groupByDay:true })}
            style={{ background:"#EFF6FF", borderRadius:10, padding:"14px 12px", textAlign:"center", cursor:"pointer" }}>
            <div style={{ fontSize:24, fontWeight:800, color:"#2563EB" }}>{fechamentos.length}</div>
            <div style={{ fontSize:11, color:"#64748B", marginTop:2 }}>Vendas fechadas</div>
          </div>
          <div onClick={()=>setDrillDown({ title:"Valor total em vendas", period:`Mês ${selectedMonth}`, items:fechamentos.map(l=>({
              id:l.id, name:l.nome, consultant:USERS.find(u=>u.id===Number(l.consultantId))?.name.split(" ")[0],
              origin:l.produto_anuncio, value:Number(l.valor_venda)||0, createdAt:l.fechou_venda_em, lastInteraction:l.fechou_venda_em, status:"Fechou Venda 🎉",
              ...(!l.fromAtendimento ? { actionLabel:"Ver ficha completa", onAction:()=>{ setDrillDown(null); setOpenLead(l); } } : {}),
            })), groupByDay:true })}
            style={{ background:"#F0FDF4", borderRadius:10, padding:"14px 12px", textAlign:"center", cursor:"pointer" }}>
            <div style={{ fontSize:totalValorFechamentos>0?15:24, fontWeight:800, color:"#22C55E", lineHeight:1.2 }}>{totalValorFechamentos>0?fmt(totalValorFechamentos):"—"}</div>
            <div style={{ fontSize:11, color:"#64748B", marginTop:2 }}>Valor total</div>
          </div>
          <div onClick={()=>setDrillDown({ title:"Leads do mês (base da conversão)", period:`Mês ${selectedMonth}`, items:leadsForStats.filter(l => toBRDateKey(leadEntryDate(l)).startsWith(selectedMonth)).map(leadToItem), groupByDay:true })}
            style={{ background:"#FEF3C7", borderRadius:10, padding:"14px 12px", textAlign:"center", cursor:"pointer" }}>
            <div style={{ fontSize:24, fontWeight:800, color:"#D97706" }}>{leadsThisMonth>0?`${leadConvMonth}%`:"—"}</div>
            <div style={{ fontSize:11, color:"#64748B", marginTop:2 }}>Conversão{leadsThisMonth>0?` (${leadsThisMonth} leads)`:""}</div>
          </div>
        </div>
      </div>

      {desqualificados.length>0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, boxShadow:"0 2px 8px rgba(0,0,0,0.06)", marginBottom:20 }}>
          <div style={{ fontWeight:700, fontSize:14, color:"#1E293B", marginBottom:14 }}>🚫 Motivos de Desqualificação ({desqualificados.length})</div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:10 }}>
            {byReason.map(r=>(
              <div key={r.id} onClick={()=>r.count>0 && setDrillDown({ title:r.label, items:desqualificados.filter(l=>efetivoMotivoTipo(l)===r.id).map(l=>leadToItem(l,{allowDelete:true})), period:"Todo o período", groupByDay:true })}
                style={{ background:"#FEF2F2", borderRadius:10, padding:"12px 14px", cursor:r.count>0?"pointer":"default" }}>
                <div style={{ fontSize:20, fontWeight:800, color:"#C0392B" }}>{r.count}</div>
                <div style={{ fontSize:11, color:"#64748B", marginTop:2 }}>{r.label}</div>
              </div>
            ))}
            {semMotivoCount>0 && (
              <div onClick={()=>setDrillDown({ title:"Sem motivo informado", items:desqualificados.filter(l=>!efetivoMotivoTipo(l)).map(l=>leadToItem(l,{allowDelete:true})), period:"Todo o período", groupByDay:true })}
                style={{ background:"#F1F5F9", borderRadius:10, padding:"12px 14px", cursor:"pointer" }}>
                <div style={{ fontSize:20, fontWeight:800, color:"#64748B" }}>{semMotivoCount}</div>
                <div style={{ fontSize:11, color:"#64748B", marginTop:2 }}>Sem motivo informado</div>
              </div>
            )}
          </div>
        </div>
      )}
      {isStaffUser && duplicateGroups.length>0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, boxShadow:"0 2px 8px rgba(0,0,0,0.06)", marginBottom:20 }}>
          <div style={{ fontWeight:700, fontSize:14, color:"#1E293B", marginBottom:4 }}>🔗 Possíveis Duplicados ({duplicateGroups.length})</div>
          <div style={{ fontSize:11.5, color:"#94A3B8", marginBottom:14 }}>Mesmo telefone cadastrado em mais de um lead. Escolha qual registro manter — os demais serão apagados e seus dados úteis (histórico, motivo, etc) copiados para o escolhido.</div>
          <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
            {duplicateGroups.map((group,gi)=>(
              <DuplicateLeadGroup key={gi} group={group} onMerge={onMerge} />
            ))}
          </div>
        </div>
      )}
      {todayLeads.length>0&&(
        <div style={{ background:"#fff", borderRadius:14, padding:20, boxShadow:"0 2px 8px rgba(0,0,0,0.06)", marginBottom:20 }}>
          <div style={{ fontWeight:700, fontSize:14, color:"#1E293B", marginBottom:14 }}>📥 Leads de hoje ({todayLeads.length})</div>
          <div style={{ display:"flex", flexWrap:"wrap", gap:10 }}>
            {todayLeads.map(l=>{
              const s=LEAD_STAGES.find(st=>st.id===l.estagio)||LEAD_STAGES[0];
              return (
                <div key={l.id} style={{ background:"#F8FAFC", borderRadius:10, padding:"10px 14px", flex:"1 1 180px", borderLeft:`3px solid ${s.color}` }}>
                  <div style={{ fontWeight:700, fontSize:13, color:"#1E293B" }}>{l.nome}</div>
                  <div style={{ fontSize:11, color:"#64748B", marginTop:2 }}>{l.produto_anuncio||"—"}</div>
                  <div style={{ fontSize:10, color:s.color, fontWeight:700, marginTop:4 }}>{s.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── Fechamentos do mês ── */}
      {showAddModal && onAdd && canManuallyRegisterSale(currentUser)
        && <AddLeadFechamentoModal currentUser={currentUser} onAdd={onAdd} onClose={()=>setShowAddModal(false)} />}
      {editLead && onUpdate
        && <AddLeadFechamentoModal currentUser={currentUser} onUpdate={onUpdate} editLead={editLead} onClose={()=>setEditLead(null)} />}
      <div style={{ background:"#fff", borderRadius:14, padding:20, boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, flexWrap:"wrap", gap:8 }}>
          <div>
            <div style={{ fontWeight:700, fontSize:14, color:"#1E293B" }}>🎉 Fechamentos — {selectedMonth.slice(5,7)}/{selectedMonth.slice(0,4)}</div>
            <div style={{ fontSize:12, color:"#64748B", marginTop:2 }}>
              {fechamentos.length} venda{fechamentos.length!==1?"s":""} · Total:{" "}
              <strong style={{ color:"#22C55E" }}>{totalValorFechamentos>0?fmt(totalValorFechamentos):"sem valor registrado"}</strong>
            </div>
          </div>
          {onAdd && <ManualSaleAction currentUser={currentUser}
            onClick={()=>setShowAddModal(true)}
            style={{ background:"#2563EB", color:"#fff", border:"none", borderRadius:10, padding:"8px 16px", fontSize:12, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}
            noticeStyle={{ background:"#FEF9F0", border:"1px solid #D4C5A9", borderRadius:8, padding:"8px 12px", maxWidth:360 }} />}
        </div>
        {fechamentos.length===0 ? (
          <div style={{ textAlign:"center", color:"#94A3B8", fontSize:13, padding:"20px 0" }}>Nenhum fechamento registrado este mês ainda.</div>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {fechamentos.sort((a,b)=>(b.fechou_venda_em||"")>(a.fechou_venda_em||"")?1:-1).map(l=>{
              const consultant = USERS.find(u=>u.id===Number(l.consultantId));
              return (
                <div key={l.id} onClick={()=>{ if(!l.fromAtendimento) setOpenLead(l); }} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", background:"#F0FDF4", borderRadius:10, padding:"10px 14px", borderLeft:"3px solid #22C55E", flexWrap:"wrap", gap:6, cursor:l.fromAtendimento?"default":"pointer" }}>
                  <div style={{ flex:1, minWidth:160 }}>
                    <div style={{ fontWeight:700, fontSize:13, color:"#1E293B" }}>
                      {l.nome}
                      {l.manualFechamento&&<span style={{ fontSize:10, color:"#8B6F47", background:"#FEF9F0", border:"1px solid #D4C5A9", borderRadius:99, padding:"1px 7px", marginLeft:6, fontWeight:600 }}>Manual</span>}
                      {l.fromAtendimento&&<span style={{ fontSize:10, color:"#0369A1", background:"#E0F2FE", border:"1px solid #7DD3FC", borderRadius:99, padding:"1px 7px", marginLeft:6, fontWeight:600 }}>Atendimento</span>}
                    </div>
                    {l.produto_anuncio&&<div style={{ fontSize:11, color:"#64748B", marginTop:1 }}>{l.produto_anuncio}</div>}
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:8, flexShrink:0 }}>
                    {Number(l.valor_venda)>0&&<span style={{ fontWeight:800, fontSize:14, color:"#22C55E" }}>{fmt(Number(l.valor_venda))}</span>}
                    {consultant&&<span style={{ fontSize:11, color:"#64748B" }}>{consultant.name.split(" ")[0]}</span>}
                    <span style={{ fontSize:11, color:"#94A3B8" }}>{(l.fechou_venda_em||"").slice(8,10)}/{(l.fechou_venda_em||"").slice(5,7)}</span>
                    {l.manualFechamento && onUpdate && (
                      <button onClick={e=>{ e.stopPropagation(); setEditLead(l); }} title="Editar venda" style={{ background:"#EFF6FF", border:"1px solid #BFDBFE", color:"#2563EB", borderRadius:6, padding:"3px 8px", fontSize:11, fontWeight:700, cursor:"pointer" }}>✏️</button>
                    )}
                    {l.manualFechamento && onDelete && currentUser?.role==="admin" && (
                      <button onClick={e=>{ e.stopPropagation(); if(window.confirm(`Excluir venda de "${l.nome}"?`)) onDelete(l.id); }} title="Excluir venda" style={{ background:"#FEF2F2", border:"1px solid #FECACA", color:"#DC2626", borderRadius:6, padding:"3px 8px", fontSize:11, fontWeight:700, cursor:"pointer" }}>🗑️</button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:20 }}>
        <div style={{ background:"#fff", borderRadius:14, padding:20, boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ fontWeight:700, fontSize:14, color:"#1E293B", marginBottom:16 }}>📈 Tendência — 7 dias</div>
          <svg width="100%" viewBox={`0 0 ${CW} ${CH+28}`} style={{ overflow:"visible" }}>
            {days.map((d,i)=>{
              const x=gap+i*(BW+gap);
              const bH=Math.max(d.count===0?0:4,(d.count/maxCount)*CH);
              const y=CH-bH;
              const isT=d.key===today;
              return (
                <g key={d.key}>
                  <rect x={x} y={y} width={BW} height={bH} rx={5} fill={isT?"#6366F1":"#C7D2FE"} />
                  {d.count>0&&<text x={x+BW/2} y={y-5} textAnchor="middle" fontSize="10" fill="#6366F1" fontWeight="700">{d.count}</text>}
                  <text x={x+BW/2} y={CH+18} textAnchor="middle" fontSize="10" fill={isT?"#6366F1":"#94A3B8"} fontWeight={isT?"700":"400"}>{d.label}</text>
                </g>
              );
            })}
          </svg>
        </div>
        <div style={{ background:"#fff", borderRadius:14, padding:20, boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ fontWeight:700, fontSize:14, color:"#1E293B", marginBottom:14 }}>🗂️ Por Etapa</div>
          {byStage.map(s=>(
            <div key={s.id} style={{ marginBottom:10 }}>
              <div style={{ display:"flex", justifyContent:"space-between", marginBottom:3 }}>
                <span style={{ fontSize:12, color:"#334155" }}>{s.label}</span>
                <span style={{ fontSize:12, fontWeight:700, color:s.color }}>{s.count}</span>
              </div>
              <div style={{ background:"#F1F5F9", borderRadius:99, height:6, overflow:"hidden" }}>
                <div style={{ width:`${total>0?(s.count/total)*100:0}%`, height:"100%", background:s.color, borderRadius:99, transition:"width 0.5s" }} />
              </div>
            </div>
          ))}
        </div>
      </div>

      {drillDown && <DrillDownModal {...drillDown} onClose={()=>setDrillDown(null)} />}
      {openLead && (
        <LeadPanel
          lead={resolveProjectedRecord(leads, openLead)}
          msgs={leadMessages[openLead.id]||{}}
          waMsgs={getWaMsgsForPhone(whatsappMsgs, normalizePhone(openLead.telefone), leadStoreIds(openLead))}
          events={leadEvents[openLead.id]||{}}
          currentUser={currentUser}
          onClose={()=>setOpenLead(null)}
          onUpdate={(updated)=>Promise.resolve(onUpdate ? onUpdate(updated) : undefined).then(result=>{ setOpenLead(prev=>prev?.id===updated.id ? { ...prev, ...updated, ...(result && typeof result === "object" ? result : {}) } : prev); return result; })}
          onDelete={onDelete ? (id=>{ onDelete(id); setOpenLead(null); }) : undefined}
          onDeleteWhatsAppMessage={onDeleteWhatsAppMessage}
          onSendMessage={onSendMessage}
          onSendZapi={onSendZapi}
          onSendZapiMedia={onSendZapiMedia}
          onLogTransfer={onLogTransfer}
          onAddReminder={onAddReminder}
          onCreateProspItem={onCreateProspItem}
          onRegistrarVenda={onRegistrarVenda ? () => onRegistrarVenda(createSaleTarget("leads", openLead, currentUser?.storeId, currentUser?.id)) : null}
        />
      )}
    </div>
  );
}

function LeadsByConsultant({ leads, leadMessages, leadEvents, currentUser, onUpdate, onDelete, onSendMessage, whatsappMsgs, onSendZapi, onSendZapiMedia, onDeleteWhatsAppMessage=null, onLogTransfer, onAddReminder, onRegistrarVenda, onCreateProspItem, storeIdOverride=null, showStoreFilter=false, storeFilter="todas", onStoreFilterChange }) {
  useTextSendAttempts();
  const effectiveStoreId = storeIdOverride ?? currentUser.storeId ?? 1;
  const storeConsultants = USERS.filter(u =>
    (u.role === "consultant" || (u.role === "manager" && leads.some(l =>
      l.distribuicao_pendente && Number(l.consultantId) === Number(u.id))))
      && u.storeId === effectiveStoreId
  );
  const [selConsId, setSelConsId] = useState(storeConsultants[0]?.id ?? null);
  const [selected, setSelected]   = useState(null);
  const chooseConsultant = useCallback((id) => {
    const change = () => { setSelConsId(id); setSelected(null); };
    if (selected) return activeConversationExitGuard.requestAction(change);
    change();
  }, [selected]);
  const [localFilters, setLocalFilters] = useScreenPeriodFilters("leadsConsultores", DEFAULT_FILTERS);
  const [searchQueryBC, setSearchQueryBC] = useState("");
  const [silentDays, setSilentDays]         = useState(0);
  const [selectedLeads, setSelectedLeads]   = useState(new Set());
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [templateMsg, setTemplateMsg]       = useState("");
  const [bulkSending, setBulkSending]       = useState(false);
  const bulkSendLock = useRef(false);
  const [bulkSendError, setBulkSendError] = useState("");
  const effFiltersBC = localFilters;
  const periodRangeBC = getPeriodRange(effFiltersBC.period, effFiltersBC.customFrom, effFiltersBC.customTo);
  // Filtra apenas pela data de ENTRADA do lead (data_criacao), não pela última atualização.
  // Isso evita que leads transferidos recentemente apareçam em períodos passados.
  const inPeriodBC = (l) => effFiltersBC.period === "tudo" || inPeriod(l.data_criacao, periodRangeBC);

  const searchNormBC = searchQueryBC.trim().toLowerCase();
  const searchDigitsBC = searchQueryBC.replace(/\D/g,"");
  const matchesSearchBC = (l) => {
    if (!searchNormBC) return true;
    const nameMatch = (l.nome||"").toLowerCase().includes(searchNormBC);
    const phoneMatch = searchDigitsBC ? matchesPhoneSearch(l.telefone, searchDigitsBC) : false;
    return nameMatch || phoneMatch;
  };

  const auroraLeadsBC = leads.filter(l => leadIsAuroraActive(l) && inPeriodBC(l));
  const transferredLeads = (selConsId === "aurora"
    ? auroraLeadsBC
    : leads.filter(l => (l.distribuicao_pendente ? Number(l.consultantId) : resolveLeadConsultantId(l)) === Number(selConsId)
      && (l.distribuicao_pendente || leadHasHumanOwnership(l)) && inPeriodBC(l))
  ).filter(matchesSearchBC);

  // Helper: timestamp da última mensagem do CLIENTE (para filtro de silêncio)
  const lastClientMsgTs = (l) => {
    const all = [...Object.values(leadMessages[l.id]||{}), ...Object.values(getWaMsgsForPhone(whatsappMsgs, normalizePhone(l.telefone), leadStoreIds(l))||{})];
    const cm = all.filter(m => m.remetente === "cliente");
    return cm.length ? (_lastMsg(cm)?.timestamp || null) : null;
  };
  const silentMs = silentDays > 0 ? silentDays * 86400000 : 0;
  const displayedLeads = silentMs > 0
    ? transferredLeads.filter(l => { const ts = lastClientMsgTs(l); return !ts || (Date.now() - _tsNum(ts)) >= silentMs; })
    : transferredLeads;
  const toggleSelect = (id) => setSelectedLeads(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });

  // Mesma regra do LeadCard: "aguardando resposta" quando a última mensagem é do cliente e
  // ainda não teve resposta da Aurora/consultor — usado só pra ordenar (não duplica o badge).
  const leadIsUnansweredBC = (l) => {
    return leadConversationReplyState(l, leadReplyMessages(l, leadMessages, whatsappMsgs), {
      hasHumanOwnership:leadHasHumanOwnership(l),
      isClosingMessage,
    }) === "needs_team_reply";
  };

  return (
    <div>
      <div style={{ marginBottom:10 }}>
        <FilterBar filters={localFilters} setFilters={setLocalFilters} showConsultant={false} showStatus={false} showSearch searchValue={searchQueryBC} onSearchChange={setSearchQueryBC} showStore={showStoreFilter} storeValue={storeFilter} onStoreChange={onStoreFilterChange} />
        {/* ── Filtro: sem resposta há X dias ── */}
        <div style={{ display:"flex", alignItems:"center", gap:8, marginTop:6, flexWrap:"wrap" }}>
          <span style={{ fontSize:12, fontWeight:700, color:"#8B6F47" }}>🔇 Sem resposta há</span>
          <input type="number" min="0" max="365" value={silentDays||""} onChange={e=>{ setSilentDays(Number(e.target.value)||0); setSelectedLeads(new Set()); }}
            placeholder="X" style={{ width:50, padding:"4px 8px", borderRadius:8, border:"1.5px solid #D4C5A9", fontSize:12, textAlign:"center" }} />
          <span style={{ fontSize:12, color:"#8B6F47" }}>dias</span>
          {silentDays > 0 && <span style={{ fontSize:11, color:"#6366F1", fontWeight:700 }}>{displayedLeads.length} lead{displayedLeads.length!==1?"s":""}</span>}
          {silentDays > 0 && displayedLeads.length > 0 && (
            <button onClick={()=>{ const all=new Set(displayedLeads.map(l=>l.id)); setSelectedLeads(prev => prev.size===displayedLeads.length ? new Set() : all); }}
              style={{ background:"#F3EDE2", color:"#8B6F47", border:"1px solid #D4C5A9", borderRadius:8, padding:"3px 10px", fontSize:11, fontWeight:700, cursor:"pointer" }}>
              {selectedLeads.size===displayedLeads.length&&displayedLeads.length>0?"✓ Todos":"Selecionar todos"}
            </button>
          )}
          {silentDays > 0 && selectedLeads.size > 0 && (
            <button onClick={()=>setShowTemplateModal(true)}
              style={{ background:"#6366F1", color:"#fff", border:"none", borderRadius:8, padding:"5px 12px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
              📨 Enviar mensagem ({selectedLeads.size})
            </button>
          )}
          {silentDays > 0 && (
            <button onClick={()=>{ setSilentDays(0); setSelectedLeads(new Set()); }}
              style={{ background:"transparent", color:"#9C8F7E", border:"none", fontSize:11, cursor:"pointer", padding:0 }}>✕ limpar</button>
          )}
        </div>
      </div>
      {/* Tabs de responsável pelo atendimento (Aurora + consultores) */}
      <div style={{ display:"flex", gap:6, marginBottom:14, flexWrap:"wrap" }}>
        {(() => {
          const activeAurora = selConsId === "aurora";
          return (
            <button onClick={()=>chooseConsultant("aurora")}
              style={{ background:activeAurora?T.accent:"#F3EDE2", color:activeAurora?"#fff":"#8B6F47",
                border:"none", borderRadius:20, padding:"6px 16px", fontSize:12, fontWeight:700,
                cursor:"pointer", display:"flex", alignItems:"center", gap:6,
                boxShadow:activeAurora?"0 2px 8px rgba(139,111,71,0.25)":"none" }}
            >
              🤖 Aurora
              {auroraLeadsBC.length > 0 && <span style={{ background:activeAurora?"rgba(255,255,255,0.3)":"#E8DFD0", borderRadius:99, padding:"0px 7px", fontSize:11 }}>{auroraLeadsBC.length}</span>}
            </button>
          );
        })()}
        {storeConsultants.map(u => {
           const cnt = leads.filter(l => resolveLeadConsultantId(l) === u.id && leadHasHumanOwnership(l) && inPeriodBC(l)).length;
          const active = selConsId === u.id;
          return (
            <button key={u.id} onClick={()=>chooseConsultant(u.id)}
              style={{ background:active?T.accent:"#F3EDE2", color:active?"#fff":"#8B6F47",
                border:"none", borderRadius:20, padding:"6px 16px", fontSize:12, fontWeight:700,
                cursor:"pointer", display:"flex", alignItems:"center", gap:6,
                boxShadow:active?"0 2px 8px rgba(139,111,71,0.25)":"none" }}
            >
              👤 {u.name.split(" ")[0]}
              {cnt > 0 && <span style={{ background:active?"rgba(255,255,255,0.3)":"#E8DFD0", borderRadius:99, padding:"0px 7px", fontSize:11 }}>{cnt}</span>}
            </button>
          );
        })}
      </div>

      {/* Lista + painel */}
      <div style={{ display:"flex", gap:0, height:"calc(100vh - 250px)", minHeight:420, borderRadius:14, overflow:"hidden", border:"1.5px solid #E8E1D3" }}>
        <div style={{ width:250, flexShrink:0, background:"#FAF6EF", borderRight:"1.5px solid #E8E1D3", overflowY:"auto", padding:"8px" }}>
          {transferredLeads.length === 0 && (
            <div style={{ textAlign:"center", color:"#9C8F7E", fontSize:12, padding:"40px 12px", lineHeight:1.8 }}>
              <ScopedLeadEmptyLabel fallback={<>Nenhum lead transferido<br/>para este consultor</>} />
            </div>
          )}
          {groupLeadsByArrivalDay(displayedLeads, l => l.data_criacao || l.createdAt).map(g => ({
              ...g,
              items: [...g.items].sort((a,b) => (leadIsUnansweredBC(b)?1:0) - (leadIsUnansweredBC(a)?1:0)),
            })).map(g => (
            <div key={g.key}>
              <div style={{ display:"flex", alignItems:"center", gap:5, margin:"6px 0 4px", padding:"0 2px" }}>
                <span style={{ fontSize:9.5, fontWeight:800, color:"#8B6F47", letterSpacing:0.4, whiteSpace:"nowrap", textTransform:"uppercase" }}>{g.label}</span>
                <span style={{ background:"#F3EDE2", color:"#9C8F7E", borderRadius:99, padding:"0 6px", fontSize:9.5, fontWeight:700, fontFamily:"monospace" }}>{g.items.length}</span>
                <div style={{ flex:1, height:1, background:"#E8E1D3" }} />
              </div>
              {prioritizeTextSendFailures(g.items, getTextSendAttempts()).map(l=>(
                <div key={l.id} style={{ position:"relative" }}>
                  {silentDays > 0 && (
                    <input type="checkbox" checked={selectedLeads.has(l.id)} onChange={()=>toggleSelect(l.id)}
                      onClick={e=>e.stopPropagation()}
                      style={{ position:"absolute", top:8, right:8, zIndex:10, width:16, height:16, cursor:"pointer", accentColor:"#6366F1" }} />
                  )}
                  <LeadCard lead={l}
                    msgs={leadMessages[l.id]||{}}
                    replyMsgs={leadReplyMessages(l, leadMessages, whatsappMsgs)}
                    waMsgs={getWaMsgsForPhone(whatsappMsgs, normalizePhone(l.telefone), leadStoreIds(l))}
                    onClick={() => { noteConversationSelection(Number(l.responsibleStoreId) > 0 ? Number(l.responsibleStoreId) : l.storeId || currentUser?.storeId, normalizePhone(l.telefone || l.phone)); setSelected(l); }}
                    selected={selected?.id===l.id}
                    currentUser={currentUser}
                  />
                  <div style={{ padding:"0 4px 8px", marginTop:-4 }}>
                    <LiftSaleStageSelect moduleId="leads" record={l} saleStage="fechou_venda" options={LEAD_STAGES}
                      value={l.estagio||"chegou"}
                      onChange={next=>{ onUpdate({...l, estagio:next}); }}
                      onClick={e=>e.stopPropagation()}
                      style={{ width:"100%", fontSize:10, padding:"3px 6px", borderRadius:6, border:"1px solid #E8E1D3", background:"#F9F5EE", color:"#8B6F47", cursor:"pointer" }}
                    />
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
        {selected
          ? <LeadPanel lead={leads.find(l=>l.id===selected.id) || selected}
              msgs={leadMessages[selected.id]||{}}
              waMsgs={getWaMsgsForPhone(whatsappMsgs, normalizePhone(selected.telefone), leadStoreIds(selected))}
              events={leadEvents[selected.id]||{}}
              onClose={()=>setSelected(null)}
              onUpdate={(updated)=>Promise.resolve(onUpdate(updated)).then(result=>{ setSelected(prev=>prev?.id===updated.id ? { ...prev, ...updated } : prev); return result; })}
              onDelete={onDelete ? (id=>{ onDelete(id); setSelected(null); }) : undefined}
              onDeleteWhatsAppMessage={onDeleteWhatsAppMessage}
              onSendMessage={onSendMessage}
              onSendZapi={onSendZapi}
              onSendQRMedia={(phone,m,sid,quotedId,quotedMsg)=>onSendZapiMedia&&onSendZapiMedia(phone,{_isQRMedia:true,url:m.url,tipo:m.tipo},m.tipo,sid,quotedId,quotedMsg)}
              onSendZapiMedia={onSendZapiMedia}
              onLogTransfer={onLogTransfer}
              onAddReminder={onAddReminder}
              currentUser={currentUser}
               onCreateProspItem={onCreateProspItem}
              onRegistrarVenda={onRegistrarVenda ? () => onRegistrarVenda(createSaleTarget("leads", selected, currentUser?.storeId, currentUser?.id)) : null}
            />
          : <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", background:"#F8FAFC" }}>
              <div style={{ textAlign:"center", color:"#94A3B8" }}>
                <div style={{ fontSize:36, marginBottom:8 }}>👤</div>
                <div style={{ fontSize:13 }}>Selecione um lead para ver o histórico</div>
              </div>
            </div>
        }
      </div>

      {/* Modal de envio em massa */}
      {showTemplateModal && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.52)", zIndex:900, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
          <div style={{ background:"#fff", borderRadius:16, padding:24, maxWidth:480, width:"100%", boxShadow:"0 8px 40px rgba(0,0,0,0.22)" }}>
            <div style={{ fontWeight:800, fontSize:16, color:"#2B1B12", marginBottom:4 }}>📨 Enviar mensagem em massa</div>
            <div style={{ fontSize:12, color:"#9C8F7E", marginBottom:14, lineHeight:1.5 }}>
              Será enviada para <b>{selectedLeads.size}</b> lead{selectedLeads.size!==1?"s":""} com 3s de intervalo entre cada envio.<br/>
              Use <code style={{ background:"#F3EDE2", padding:"1px 5px", borderRadius:4 }}>{"{nome}"}</code> e <code style={{ background:"#F3EDE2", padding:"1px 5px", borderRadius:4 }}>{"{produto}"}</code> como variáveis.
            </div>
            <textarea value={templateMsg} onChange={e=>setTemplateMsg(e.target.value)} disabled={bulkSending}
              rows={5} placeholder={"Olá {nome}, tudo bem? Você demonstrou interesse em {produto}..."}
              style={{ width:"100%", borderRadius:10, border:"1.5px solid #D4C5A9", padding:"10px 12px", fontSize:13, resize:"vertical", boxSizing:"border-box", fontFamily:"inherit" }} />
            {bulkSendError && <div role="alert" style={{ color:"#B91C1C", marginTop:8, fontSize:12 }}>{bulkSendError}</div>}
            <div style={{ display:"flex", gap:8, marginTop:14, justifyContent:"flex-end" }}>
              <button onClick={()=>setShowTemplateModal(false)} disabled={bulkSending}
                style={{ background:"#F3EDE2", color:"#8B6F47", border:"none", borderRadius:8, padding:"8px 16px", fontSize:13, fontWeight:700, cursor:"pointer" }}>
                Cancelar
              </button>
              <button disabled={!templateMsg.trim()||bulkSending}
                onClick={async ()=>{
                  if (!templateMsg.trim()||selectedLeads.size===0||bulkSendLock.current) return;
                  bulkSendLock.current = true;
                  setBulkSending(true);
                  setBulkSendError("");
                  try {
                    const toSend = displayedLeads.filter(l => selectedLeads.has(l.id));
                    const result = await sendConfirmedTextBatch(toSend, {
                      send:l => onSendZapi(
                        normalizePhone(l.telefone),
                        templateMsg.replace(/\{nome\}/gi, l.nome||"").replace(/\{produto\}/gi, l.produto_anuncio||l.produto||""),
                        { name:currentUser?.name || "Consultor" },
                        null,
                        leadOutboundStoreContext(l),
                      ),
                      onAccepted:id => setSelectedLeads(previous => {
                        const remaining = new Set(previous);
                        remaining.delete(id);
                        return remaining;
                      }),
                      pause:() => new Promise(r => setTimeout(r, 3000)),
                    });
                    if (!result.ok) {
                      setBulkSendError(result.error);
                      return;
                    }
                    setShowTemplateModal(false); setSelectedLeads(new Set()); setTemplateMsg("");
                  } catch (_) {
                    setBulkSendError(textSendFailureMessage(null));
                  } finally {
                    bulkSendLock.current = false;
                    setBulkSending(false);
                  }
                }}
                style={{ background:bulkSending||!templateMsg.trim()?"#C0A882":"#8B6F47", color:"#fff", border:"none", borderRadius:8, padding:"8px 18px", fontSize:13, fontWeight:700, cursor:"pointer" }}>
                {bulkSending?"Enviando…":"✉️ Enviar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── LEADS CONVERSAS — lista tipo WhatsApp com painel lateral ──────────────────
function LeadsConversas({ leads, leadMessages, leadEvents={}, currentUser, onUpdate, onDelete, onSendMessage, whatsappMsgs={}, onSendZapi, onSendZapiMedia, onDeleteWhatsAppMessage=null, onLogTransfer, onAddReminder, onRegistrarVenda, onConversationActive, onCreateProspItem }) {
  const isMobile = window.innerWidth < 768;
  const [selected, setSelectedRaw] = useState(null);
  const setSelected = useCallback((next) => {
    if (next && selected && next.id !== selected.id) {
      return activeConversationExitGuard.requestAction(() => setSelectedRaw(next));
    }
    setSelectedRaw(next);
    return true;
  }, [selected]);
  const [searchQuery, setSearchQuery] = useState("");
  const [onlyUnanswered, setOnlyUnanswered] = useState(false);
  const [onlyTransfers, setOnlyTransfers] = useState(false);
  const [transferType, setTransferType] = useState("all");
  const [transferConsultantId, setTransferConsultantId] = useState("");
  const [transferFrom, setTransferFrom] = useState("");
  const [transferTo, setTransferTo] = useState("");
  const [transferAurora, setTransferAurora] = useState("all");
  const canManageTransferFilters = currentUser?.role === "admin" || currentUser?.role === "manager";
  const transferFilters = {
    type:transferType,
    consultantId:canManageTransferFilters ? transferConsultantId : currentUser?.id,
    from:transferFrom,
    to:transferTo,
    aurora:transferAurora,
  };
  const transferEvents = l => transferEventsForLead(l, leadEvents[l.id] || {}, USERS);
  useConversationPresence({
    phone:normalizePhone(selected?.telefone),
    storeId:selected?.storeId || currentUser?.storeId, module:"leads", onConversationActive,
  });

  // Última actividade de um lead (para ordenação)
  const getLastTs = (l) => {
    const allMsgs = [
      ...Object.values(leadMessages[l.id]||{}),
      ...Object.values(getWaMsgsForPhone(whatsappMsgs, normalizePhone(l.telefone), leadStoreIds(l))||{}),
    ];
    if (allMsgs.length === 0) return l.data_criacao || l.createdAt || "";
    return _lastMsg(allMsgs)?.timestamp || l.data_criacao || l.createdAt || "";
  };

  // "Aguardando resposta" — mesma lógica do LeadCard
  const isUnanswered = (l) => {
    return leadAwaitingReply(l, leadMessages, whatsappMsgs);
  };

  const searchNorm   = searchQuery.trim().toLowerCase();
  const searchDigits = searchQuery.replace(/\D/g,"");

  const filteredLeads = leads
    .filter(l => {
      if (onlyUnanswered && !isUnanswered(l)) return false;
      if (onlyTransfers && !leadMatchesTransferFilters(transferEvents(l), transferFilters)) return false;
      if (!searchNorm) return true;
      const nameMatch  = (l.nome||"").toLowerCase().includes(searchNorm);
      const phoneMatch = searchDigits ? matchesPhoneSearch(l.telefone, searchDigits) : false;
      return nameMatch || phoneMatch;
    })
    .sort((a, b) => _tsNum(getLastTs(b)) - _tsNum(getLastTs(a)));

  const unansweredCount = leads.filter(isUnanswered).length;
  const transfersCount = leads.filter(l => leadMatchesTransferFilters(transferEvents(l), transferFilters)).length;
  const listHeight = isMobile ? "calc(100vh - 200px)" : "72vh";

  return (
    <div style={{ display:"flex", height:listHeight, minHeight:isMobile?380:520, borderRadius:16, overflow:"hidden", boxShadow:"0 2px 20px rgba(0,0,0,0.10)", border:"1px solid #E8E1D3" }}>

      {/* ── Lista de conversas ─────────────────────────── */}
      <div style={{ width:isMobile?"100%":300, flexShrink:0, display: isMobile && selected ? "none" : "flex", flexDirection:"column", background:"#FAF6EF", borderRight: isMobile ? "none" : "1.5px solid #E8E1D3", minWidth:0 }}>

        {/* Barra de busca + filtro */}
        <div style={{ padding:"10px 10px 6px", borderBottom:"1px solid #E8E1D3", flexShrink:0 }}>
          <input
            type="text"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            placeholder="🔍 Buscar lead..."
            style={{ width:"100%", padding:"8px 10px", borderRadius:10, border:"1.5px solid #E8E1D3", fontSize:12, boxSizing:"border-box", background:"#fff" }}
          />
          <label style={{ display:"flex", alignItems:"center", gap:6, fontSize:11, fontWeight:700, color:onlyUnanswered?"#EF4444":"#8B6F47", cursor:"pointer", marginTop:6 }}>
            <input type="checkbox" checked={onlyUnanswered} onChange={e=>setOnlyUnanswered(e.target.checked)} />
            🔴 Aguardando resposta {unansweredCount > 0 && <span style={{ background:"#EF4444", color:"#fff", borderRadius:99, fontSize:9, fontWeight:800, padding:"1px 6px" }}>{unansweredCount}</span>}
          </label>
          <label style={{ display:"flex", alignItems:"center", gap:6, fontSize:11, fontWeight:700, color:onlyTransfers?"#7C3AED":"#8B6F47", cursor:"pointer", marginTop:6 }}>
            <input type="checkbox" checked={onlyTransfers} onChange={e=>setOnlyTransfers(e.target.checked)} />
            ↔️ Transferências <span style={{ background:onlyTransfers?"#7C3AED":"#E8E1D3", color:onlyTransfers?"#fff":"#8B6F47", borderRadius:99, fontSize:9, fontWeight:800, padding:"1px 6px" }}>{transfersCount}</span>
          </label>
          {onlyTransfers && (
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:5, marginTop:7 }}>
              <select value={transferType} onChange={e=>setTransferType(e.target.value)} style={{ gridColumn:"1 / -1", fontSize:10.5, padding:"5px 6px", borderRadius:7, border:"1px solid #D8CBB8", background:"#fff" }}>
                <option value="all">Todos os tipos</option>
                <option value="aurora_to_consultant">Aurora → Consultor</option>
                <option value="consultant_to_aurora">Consultor → Aurora</option>
                <option value="consultant_to_consultant">Consultor → Consultor</option>
                <option value="manager_to_consultant">Gestor/Gerente → Consultor</option>
                <option value="cross_store">Entre lojas</option>
              </select>
              {canManageTransferFilters && (
                <select value={transferConsultantId} onChange={e=>setTransferConsultantId(e.target.value)} style={{ gridColumn:"1 / -1", fontSize:10.5, padding:"5px 6px", borderRadius:7, border:"1px solid #D8CBB8", background:"#fff" }}>
                  <option value="">Todos os consultores</option>
                  {USERS.filter(u=>u.role==="consultant" && (!currentUser?.storeId || u.storeId===currentUser.storeId)).map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
                </select>
              )}
              <input type="date" aria-label="Transferências desde" value={transferFrom} onChange={e=>setTransferFrom(e.target.value)} style={{ fontSize:10, padding:"4px", borderRadius:7, border:"1px solid #D8CBB8" }} />
              <input type="date" aria-label="Transferências até" value={transferTo} onChange={e=>setTransferTo(e.target.value)} style={{ fontSize:10, padding:"4px", borderRadius:7, border:"1px solid #D8CBB8" }} />
              <select value={transferAurora} onChange={e=>setTransferAurora(e.target.value)} style={{ gridColumn:"1 / -1", fontSize:10.5, padding:"5px 6px", borderRadius:7, border:"1px solid #D8CBB8", background:"#fff" }}>
                <option value="all">Com ou sem Aurora</option>
                <option value="yes">Somente com Aurora</option>
                <option value="no">Sem Aurora</option>
              </select>
            </div>
          )}
        </div>

        {/* Items */}
        <div style={{ flex:1, overflowY:"auto" }}>
          {filteredLeads.length === 0 && (
            <div style={{ textAlign:"center", color:"#9C8F7E", fontSize:12, padding:"48px 16px", lineHeight:1.8 }}>
              <ScopedLeadEmptyLabel fallback={onlyUnanswered ? "Nenhum lead aguardando resposta. 🎉" : "Nenhum lead encontrado."} />
            </div>
          )}
          {filteredLeads.map(l => {
            const unans  = isUnanswered(l);
            const isSel  = selected?.id === l.id;
            const allMsgs = [
              ...Object.values(leadMessages[l.id]||{}),
              ...Object.values(getWaMsgsForPhone(whatsappMsgs, normalizePhone(l.telefone), leadStoreIds(l))||{}),
            ];
            const lastMsg = allMsgs.length > 0 ? _lastMsg(allMsgs) : null;
            const hasWa   = Object.keys(getWaMsgsForPhone(whatsappMsgs, normalizePhone(l.telefone), leadStoreIds(l))||{}).length > 0;
            const timeAgoStr = lastMsg?.timestamp ? (() => {
              const diff = (Date.now() - new Date(lastMsg.timestamp).getTime()) / 60000;
              if (diff < 60)   return `${Math.round(diff)}min`;
              if (diff < 1440) return `${Math.round(diff/60)}h`;
              return `${Math.round(diff/1440)}d`;
            })() : null;
            const stage = LEAD_STAGES.find(s => s.id === (l.estagio||"chegou"));
            const consultantName = USERS.find(u => u.id === l.consultantId)?.name?.split(" ")[0] || null;
            const lastTransfer = latestTransferEvent(transferEvents(l).filter(event => !onlyTransfers || transferEventMatches(event, transferFilters)));
            return (
              <div key={l.id}
                onClick={() => { noteConversationSelection(Number(l.responsibleStoreId) > 0 ? Number(l.responsibleStoreId) : l.storeId || currentUser?.storeId, normalizePhone(l.telefone || l.phone)); setSelected(l); }}
                style={{
                  padding:"11px 13px", cursor:"pointer", borderBottom:"1px solid #F0E8DC",
                  background: isSel ? "#FDF4E3" : unans ? "#FEF2F2" : "#FAF6EF",
                  borderLeft: unans ? "4px solid #EF4444" : isSel ? `4px solid ${T.accent||"#C8A04D"}` : "4px solid transparent",
                  boxShadow: isSel ? "inset 0 0 0 1px #C8A04D44" : "none",
                  transition:"background 0.12s",
                }}
              >
                {/* Linha 1: nome + tempo */}
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:3 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:5, flex:1, minWidth:0 }}>
                    <span style={{ fontWeight:800, fontSize:13, color:"#2B1B12", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{l.nome}</span>
                    {hasWa && <span style={{ width:7, height:7, background:"#3FA76B", borderRadius:"50%", display:"inline-block", flexShrink:0 }} title="WhatsApp ativo" />}
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:5, flexShrink:0 }}>
                    {timeAgoStr && <span style={{ fontSize:10, color:"#9C8F7E", fontFamily:"monospace" }}>{timeAgoStr}</span>}
                    {stage && <span style={{ fontSize:9, fontWeight:800, borderRadius:99, padding:"2px 7px", background:stage.color+"22", color:stage.color, whiteSpace:"nowrap" }}>{stage.label}</span>}
                  </div>
                </div>

                {/* Linha 2: prévia da última mensagem */}
                {lastMsg ? (
                  <div style={{ fontSize:11, color:"#6B7280", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", marginBottom:2 }}>
                    {lastMsg.remetente==="aurora"?"🤖 ":lastMsg.remetente==="consultor"?"✓ ":""}
                    {lastMsg.texto||lastMsg.content||"📎 Mídia"}
                  </div>
                ) : (
                  <div style={{ fontSize:11, color:"#C8B89A", fontStyle:"italic", marginBottom:2 }}>Sem mensagens ainda</div>
                )}

                {/* Linha 3: badges e consultor */}
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:3 }}>
                  <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
                    {unans && <span style={{ fontSize:9.5, fontWeight:800, color:"#fff", background:"#EF4444", borderRadius:99, padding:"2px 7px" }}>🔴 Aguardando</span>}
                    {l.aguardandoRetornoCliente?.value && !unans && <span style={{ fontSize:9.5, fontWeight:700, color:"#3B82C4", background:"#EAF3FB", borderRadius:99, padding:"2px 7px" }}>🔵 Ret. cliente</span>}
                    {l.proxima_data_contato && <span style={{ fontSize:9.5, color:"#B8763E", fontWeight:600 }}>📅 {fmtDate(l.proxima_data_contato)}</span>}
                    {lastTransfer && <span title={transferEventText(lastTransfer)} style={{ fontSize:9.5, color:"#6D28D9", background:"#F3E8FF", borderRadius:99, padding:"2px 7px", fontWeight:700 }}>{lastTransfer.type==="aurora_to_consultant"?"🤖":"↔"} {lastTransfer.fromLabel} → {lastTransfer.toLabel}</span>}
                  </div>
                  {consultantName && currentUser?.role !== "consultant" && (
                    <span style={{ fontSize:9.5, color:"#9C8F7E" }}>👤 {consultantName}</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* ── Painel direito ─────────────────────────────── */}
      {selected ? (
        <LeadPanel
          lead={leads.find(l=>l.id===selected.id) || selected}
          msgs={leadMessages[selected.id]||{}}
          waMsgs={getWaMsgsForPhone(whatsappMsgs, normalizePhone(selected.telefone), leadStoreIds(selected))}
          events={leadEvents[selected.id]||{}}
          onClose={()=>setSelected(null)}
          onUpdate={updated=>Promise.resolve(onUpdate(updated)).then(result=>{ setSelected(updated); return result; })}
          onDelete={onDelete ? (id=>{ onDelete(id); setSelected(null); }) : undefined}
          onDeleteWhatsAppMessage={onDeleteWhatsAppMessage}
          onSendMessage={onSendMessage}
          onSendZapi={onSendZapi}
          onSendZapiMedia={onSendZapiMedia}
          onLogTransfer={onLogTransfer}
          onAddReminder={onAddReminder}
          currentUser={currentUser}
          onCreateProspItem={onCreateProspItem}
          onConversationActive={onConversationActive}
          onRegistrarVenda={onRegistrarVenda ? () => onRegistrarVenda(createSaleTarget("leads", selected, currentUser?.storeId, currentUser?.id)) : null}
        />
      ) : (
        <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", background:"#F8FAFC" }}>
          <div style={{ textAlign:"center", color:"#9C8F7E" }}>
            <div style={{ fontSize:40, marginBottom:10 }}>💬</div>
            <div style={{ fontSize:14, fontWeight:700, marginBottom:4 }}>Selecione um lead</div>
            <div style={{ fontSize:12 }}>para ver a conversa</div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────

function LeadsView({ leads, clients=[], leadMessages, leadEvents={}, currentUser, onUpdate, onAdd, onDelete, onMerge, onSendMessage, whatsappMsgs={}, onSendZapi, onSendZapiMedia, onDeleteWhatsAppMessage=null, onLogTransfer, onAddReminder, autoOpenTarget, onAutoOpenConsumed, onRegistrarVenda, onConversationActive, unreadPushLookup, onCreateProspItem }) {
  const scopedLoadState = useScopedDataLoadState();
  const [view, setViewRaw] = useState("kanban");
  const setView = useCallback((next) => {
    if (next !== view) return activeConversationExitGuard.requestAction(() => setViewRaw(next));
    setViewRaw(next);
  }, [view]);
  const [showAddManual, setShowAddManual] = useState(false);
  const [storeFilter, setStoreFilter] = useState("todas");
  useEffect(() => {
    if (autoOpenTarget?.reminderCard || autoOpenTarget?.exactCard) {
      setStoreFilter("todas");
      setViewRaw("kanban");
    }
  }, [autoOpenTarget]);
  const isStaff = currentUser?.role === "admin" || currentUser?.role === "manager";
  // O filtro de loja só faz sentido pra quem enxerga leads de mais de uma loja
  // (o admin geral); gerente/consultor já recebem `leads` pré-filtrados por storeId.
  const showStoreFilter = currentUser?.storeId == null;
  const scopedLeads = (showStoreFilter && storeFilter !== "todas")
    ? leads.filter(l => leadBelongsToStore(l, Number(storeFilter)))
    : leads;
  const transferredCount = isStaff ? scopedLeads.filter(leadHasHumanOwnership).length : 0;
  // A failed/unfinished snapshot is not proof of an empty pipeline. Keep any
  // existing cards; only replace the unconfirmed empty screen, for every role.
  if (scopedLeads.length === 0 && scopedLoadState && scopedLoadState.status !== "ready") {
    return <ScopedLeadsUnavailable />;
  }
  const tabs = [
    ["conversas","💬 Conversas"],
    ["kanban","🗂️ Kanban"],
    ["dashboard","📊 Dashboard"],
    ...(isStaff ? [["consultores","👤 Consultores"]] : []),
  ];
  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, flexWrap:"wrap", gap:10 }}>
        <div>
          <div style={{ fontWeight:800, fontSize:20, color:"#2B1B12", letterSpacing:"-0.02em" }}>📋 Leads</div>
          <div style={{ fontSize:13, color:"#8B6F47", marginTop:2 }}>{scopedLeads.length} lead{scopedLeads.length!==1?"s":""} no sistema</div>
        </div>
        <div style={{ display:"flex", gap:10, alignItems:"center", flexWrap:"wrap" }}>
          {onAdd && (
            <button onClick={()=>setShowAddManual(true)} style={{ background:"linear-gradient(135deg,#C8A04D,#8B6F47)", color:"#fff", border:"none", borderRadius:10, padding:"9px 16px", fontWeight:700, fontSize:12.5, cursor:"pointer", whiteSpace:"nowrap" }}>
              ✋ Novo Lead Manual
            </button>
          )}
          <div style={{ display:"flex", gap:4, background:"#F3EDE2", borderRadius:10, padding:4 }}>
            {tabs.map(([id,label])=>(
              <button key={id} onClick={()=>setView(id)} style={{
                background:view===id?"#fff":"transparent", border:"none", borderRadius:8,
                padding:"7px 14px", fontSize:12, fontWeight:700,
                color:view===id?"#8B6F47":"#9C8F7E", cursor:"pointer",
                boxShadow:view===id?"0 1px 4px rgba(43,27,18,0.12)":"none", transition:"all 0.15s",
                position:"relative",
              }}>
                {label}
                {id==="consultores" && transferredCount>0 && (
                  <span style={{ background:"#EF4444", color:"#fff", borderRadius:99, fontSize:9, fontWeight:800, padding:"1px 5px", position:"absolute", top:2, right:2 }}>{transferredCount}</span>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
      {showAddManual && <AddManualLeadModal currentUser={currentUser} onAdd={onAdd} onClose={()=>setShowAddManual(false)} />}
      {view==="conversas"
         ? <LeadsConversas leads={scopedLeads} leadMessages={leadMessages} leadEvents={leadEvents} currentUser={currentUser} onUpdate={onUpdate} onDelete={onDelete} onSendMessage={onSendMessage} whatsappMsgs={whatsappMsgs} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} onDeleteWhatsAppMessage={onDeleteWhatsAppMessage} onLogTransfer={onLogTransfer} onAddReminder={onAddReminder} onRegistrarVenda={onRegistrarVenda} onConversationActive={onConversationActive} onCreateProspItem={onCreateProspItem} unreadPushLookup={unreadPushLookup} />
        : view==="kanban"
             ? <LeadKanban leads={scopedLeads} leadMessages={leadMessages} leadEvents={leadEvents} currentUser={currentUser} onUpdate={onUpdate} onDelete={onDelete} onSendMessage={onSendMessage} whatsappMsgs={whatsappMsgs} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} onDeleteWhatsAppMessage={onDeleteWhatsAppMessage} onLogTransfer={onLogTransfer} onAddReminder={onAddReminder} autoOpenTarget={autoOpenTarget} onAutoOpenConsumed={onAutoOpenConsumed} onRegistrarVenda={onRegistrarVenda} onConversationActive={onConversationActive} onCreateProspItem={onCreateProspItem} unreadPushLookup={unreadPushLookup}
              showStoreFilter={showStoreFilter} storeFilter={storeFilter} onStoreFilterChange={setStoreFilter}/>
          : view==="dashboard"
             ? <LeadsDashboard leads={scopedLeads} clients={clients} currentUser={currentUser} onAdd={onAdd} onUpdate={onUpdate} onDelete={onDelete} onMerge={onMerge}
                  leadMessages={leadMessages} leadEvents={leadEvents} onSendMessage={onSendMessage} whatsappMsgs={whatsappMsgs} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} onDeleteWhatsAppMessage={onDeleteWhatsAppMessage} onLogTransfer={onLogTransfer} onAddReminder={onAddReminder} onRegistrarVenda={onRegistrarVenda} onCreateProspItem={onCreateProspItem}
                showStoreFilter={showStoreFilter} storeFilter={storeFilter} onStoreFilterChange={setStoreFilter}/>
            : <LeadsByConsultant leads={scopedLeads} leadMessages={leadMessages} leadEvents={leadEvents} currentUser={currentUser} onUpdate={onUpdate} onDelete={onDelete} onSendMessage={onSendMessage} whatsappMsgs={whatsappMsgs} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} onLogTransfer={onLogTransfer} onAddReminder={onAddReminder} onRegistrarVenda={onRegistrarVenda}
                 onDeleteWhatsAppMessage={onDeleteWhatsAppMessage}
                 onCreateProspItem={onCreateProspItem}
                storeIdOverride={showStoreFilter && storeFilter!=="todas" ? Number(storeFilter) : null}
                showStoreFilter={showStoreFilter} storeFilter={storeFilter} onStoreFilterChange={setStoreFilter}/>
      }
    </div>
  );
}

// ── CENTRAL OPERACIONAL ────────────────────────────────────────
export function CentralOperacionalView({ onOpenReminderCard, onDeleteReminder, onAbrirConversaNaAba = null, onAbrirPedidoDeposito = null, clients, reminders, currentUser, loggedInUser, realSales, onToggleReminder, onNavigate, onUpdateClient, onDeleteClient, onAddReminder, onSendZapi, onSendZapiMedia, onDeleteWhatsAppMessage=null, whatsappMsgs, leads=[], allLeads=[], leadMessages={}, leadEvents={}, onUpdateLead, onDeleteLead, onSendMessage, onLogTransfer, onReturnToAurora, prospeccao=[], prospMensagens={}, onOpenProsp, onConversationActive, onCreateProspItem }) {
  const { sales:liftSales, error:liftError, postSales:allPostSales, postError, commercialSales, commercialError, commercialLoaded } = useContext(LiftPendingContext);
  const goalStores=useMonthlyGoalStores(getActiveStores(),currentDateKeySaoPaulo().slice(0,7));
  const entregaAvisoIdentity = currentUser?.role === "consultant"
    && Number.isInteger(Number(currentUser.id)) && Number(currentUser.id) > 0
    && Number.isInteger(Number(currentUser.storeId)) && Number(currentUser.storeId) > 0
    ? `${currentUser.id}:${currentUser.storeId}` : "";
  const [entregaAvisosState, setEntregaAvisosState] = useState({ identity:"", entregues:[], erro:"" });
  useEffect(() => {
    if (!entregaAvisoIdentity || loggedInUser?.isDemo || currentUser?.isDemo) {
      setEntregaAvisosState({ identity:entregaAvisoIdentity, entregues:[], erro:"" });
      return undefined;
    }
    const controller = new AbortController();
    const query = new URLSearchParams({
      viewAsUserId:String(currentUser.id),
      storeId:String(currentUser.storeId),
    });
    let carregando = false;
    const carregarEntregas = () => {
      if (carregando || controller.signal.aborted) return;
      carregando = true;
      fetch(`/api/deposito/entregas-do-vendedor?${query}`, { credentials:"same-origin", cache:"no-store", signal:controller.signal })
      .then(async response => {
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || `HTTP ${response.status}`);
        if (!Array.isArray(payload.entregues)) throw new Error("O servidor ainda não confirmou os avisos de entrega.");
        if (!controller.signal.aborted) setEntregaAvisosState({
          identity:entregaAvisoIdentity, entregues:payload.entregues, erro:"",
        });
      })
      .catch(error => {
        if (!controller.signal.aborted) setEntregaAvisosState({ identity:entregaAvisoIdentity, entregues:[], erro:error.message });
      })
      .finally(() => { carregando = false; });
    };
    const stopPolling = watchVisiblePolling(carregarEntregas);
    return () => { stopPolling(); controller.abort(); };
  }, [entregaAvisoIdentity, currentUser?.id, currentUser?.storeId, loggedInUser?.isDemo, currentUser?.isDemo]);
  const entregaAvisos = entregaAvisosState.identity === entregaAvisoIdentity
    ? entregaAvisosState : { entregues:[], erro:"" };
  const postSales = currentUser.role === "consultant"
    ? allPostSales.filter(s => Number(s.responsavelId) === Number(currentUser.id))
    : currentUser.role === "manager"
      ? allPostSales.filter(s => Number(s.storeId) === Number(currentUser.storeId)) : allPostSales;
  const today = currentDateKeySaoPaulo();
  const now   = new Date();
  const currentMonth = now.getMonth();
  const currentYear  = now.getFullYear();

  const [openClient, setOpenClient] = useState(null);
  const [openLead, setOpenLead] = useState(null);
  const dismissOpenLead = useCallback(() => {
    return activeConversationExitGuard.requestAction(() => setOpenLead(null));
  }, []);
  const resolveOperationalReminder = reminder => resolveReminderCard(reminder, {
    clients, leads:allLeads.length ? allLeads : leads, prospeccao, currentUser,
    leadConsultantId:resolveLeadConsultantId,
    consultantStoreId:id => USERS.find(user => Number(user.id) === Number(id))?.storeId,
  });
  const localOpenReminder = (r) => {
    const linked = resolveOperationalReminder(r);
    if (!linked) { alert("O cartão vinculado não está disponível nesta visão."); return; }
    if (onAbrirConversaNaAba) return onAbrirConversaNaAba(
      linked.moduleId, linked.target.storeId, linked.target.phone, linked.target,
    );
    if (linked.moduleId === "kanban") setOpenClient(linked.record);
    else if (linked.moduleId === "leads") setOpenLead(linked.record);
    else onOpenProsp?.(linked.target.phone, linked.target.storeId);
  };
  const { navigate:handleOpenReminder, noticeView } = useReminderCardNavigation(onOpenReminderCard || localOpenReminder, onDeleteReminder);

  const myClients = currentUser.role==="admin"
    ? clients
    : currentUser.role==="manager"
      ? clients.filter(c=>c.storeId===currentUser.storeId)
      : clients.filter(c=>c.consultantId===currentUser.id);

  // ── Clientes aguardando resposta (agrega Lead + Prospecção + Atendimento Presencial) ──
  const awaitingClients = myClients
    .filter(c => clientAwaitingReply(c, whatsappMsgs))
    .map(c => ({ key:`c_${c.id}`, name:c.name, origin:"Atendimento", originColor:"#6366F1", phone:c.phone, _raw:c, _type:"client" }));

  const myProsp = prospectsForViewer(prospeccao, currentUser,
    id => USERS.find(user => Number(user.id) === Number(id))?.storeId);

  const awaitingProsp = myProsp
    .filter(p => prospAwaitingReply(p, whatsappMsgs, prospMensagens))
    .map(p => ({ key:`p_${p.id}`, name:p.name||p.phone, origin:"Prospecção", originColor:"#D97706", phone:p.phone, _raw:p, _type:"prosp" }));

  const myLeads = currentUser.role==="admin"
    ? leads
    : currentUser.role==="manager"
      ? leads.filter(l => { const u=USERS.find(u=>u.id===l.consultantId); return u?.storeId===currentUser.storeId; })
      : leads.filter(l => l.consultantId===currentUser.id);

  const awaitingLeads = myLeads
    .filter(l => leadAwaitingReply(l, leadMessages, whatsappMsgs))
    .map(l => ({ key:`l_${l.id}`, name:l.nome||l.name||l.telefone, origin:"Lead", originColor:"#0EA5E9", phone:l.telefone, _raw:l, _type:"lead" }));

  const awaitingAll = [...awaitingClients, ...awaitingLeads, ...awaitingProsp];

  const myReminders = currentUser.role==="consultant"
    ? reminders.filter(r=>r.consultantId===currentUser.id)
    : reminders.filter(r=>{ const sid=r.storeId||USERS.find(u=>u.id===r.consultantId)?.storeId||1; return sid===currentUser.storeId; });

  const consultantName = id => USERS.find(u=>u.id===id)?.name.split(" ")[0]||"";

  // Clientes urgentes (proposta final)
  const urgentes = myClients.filter(c=>c.stage==="final");

  // Entregas com atenção (próximos 3 dias ou atrasadas)
  const entregasAlerta = myClients
    .filter(c=>c.deliveryDate && c.deliveryStatus!=="entregue")
    .map(c=>({ ...c, diff: Math.ceil((new Date(c.deliveryDate)-new Date(today))/86400000) }))
    .filter(c=>c.diff<=3)
    .sort((a,b)=>a.diff-b.diff);

  // Lembretes atrasados e de hoje (exclui reminders de clientes já fechados/vendidos)
  const CO_TERMINAL = new Set(["closed","posVenda","nextSale","semInteresse"]);
  const lembretesUrgentes = myReminders
    .filter(r => {
      if (r.status !== "pending" || !r.dueDate || r.dueDate > today) return false;
      const linked = resolveOperationalReminder(r);
      if (linked?.moduleId === "kanban" && CO_TERMINAL.has(linked.record.stage)) return false;
      return true;
    })
    .sort((a,b)=>a.dueDate>b.dueDate?1:-1);

  // A receber (clientes fechados com saldo pendente)
  const myClosed = myClients.filter(wasSold);
  const comPendente = myClosed
    .filter(c=>Math.max(0,(c.value||0)-(c.paidValue!==undefined?c.paidValue:(c.value||0)))>0)
    .map(c=>({ ...c, pendente: Math.max(0,(c.value||0)-(c.paidValue!==undefined?c.paidValue:(c.value||0))) }))
    .sort((a,b)=>b.pendente-a.pendente)
    .slice(0,5);
  const totalPendente = myClosed.reduce((s,c)=>s+Math.max(0,(c.value||0)-(c.paidValue!==undefined?c.paidValue:(c.value||0))),0);

  // Pulso da meta — usa computeOriginBreakdown para incluir leads (kanban) e prospecção,
  // igual ao Dashboard principal. realSales (sistema antigo de incremento manual) NÃO é somado
  // pois computeOriginBreakdown já conta todas as vendas de arflow_clients/leads/prospeccao,
  // evitando duplicar valores que existem nos dois sistemas ao mesmo tempo.
  const store = goalStores.find(s=>s.id===currentUser.storeId)||goalStores[0];
  const activeGoal = currentUser.role==="consultant" ? store.consultantGoal : store.goal;
  const pulsoRange = { from: new Date(currentYear, currentMonth, 1), to: new Date(currentYear, currentMonth + 1, 0, 23, 59, 59, 999) };
  const pulsoBD = computeOriginBreakdown({
    clients,
    leads,
    prospeccao,
    periodRange: pulsoRange,
    storeId:currentUser.role === "consultant" ? null : (currentUser.storeId || null),
    consultantId: currentUser.role === "consultant" ? currentUser.id : null,
    consultantAcrossStores:currentUser.role === "consultant",
    liftSales:commercialSales,
  });
  const totalVendido = pulsoBD.totalValue;
  const daysInMonth  = new Date(currentYear,currentMonth+1,0).getDate();
  const daysLeft     = Math.max(1, daysInMonth - now.getDate());
  const remaining    = Math.max(0, activeGoal - totalVendido);
  const dailyNeeded  = remaining>0 ? Math.ceil(remaining/daysLeft) : 0;
  const pctGoal      = pct(totalVendido, activeGoal);
  const showMeta     = currentUser.role!=="admin";

  const nothingUrgent = urgentes.length===0 && entregasAlerta.length===0 && lembretesUrgentes.length===0;

  const msgTimeAgo = (ts) => {
    if (!ts) return null;
    const diff = (Date.now() - new Date(ts).getTime()) / 60000;
    if (diff < 60) return `${Math.round(diff)}min`;
    if (diff < 1440) return `${Math.round(diff/60)}h`;
    return `${Math.round(diff/1440)}d`;
  };

  const handleAwaitingClick = (item) => {
    if (item._type === "client") { setOpenClient(item._raw); return; }
    if (item._type === "lead")   { setOpenLead(item._raw); return; }
    if (item._type === "prosp" && onOpenProsp) onOpenProsp(item.phone);
  };

  // ── Nova interface (Etapa 7): Meu Dia — só as prioridades do dia ──
  const nuMeuDia = isNewUiEnabled();
  const contextoFilaMeuDia = filaOperatorContext({ loggedInUser, currentUser });
  const filaMeuDiaAtiva = contextoFilaMeuDia.active;
  const nuFilaMeuDia = useProspFilaMeuDia(nuMeuDia && !_demoMode && filaMeuDiaAtiva, contextoFilaMeuDia.consultantId, { scopeKey: contextoFilaMeuDia.scopeKey });
  const nuDiaPreparado = useProspDiaPreparado(
    nuMeuDia && !_demoMode && !loggedInUser?.isDemo
      && ["consultant", "manager", "admin"].includes(loggedInUser?.role),
    { scopeKey: contextoFilaMeuDia.scopeKey },
  );
  if (nuMeuDia) {
    const abrirNaAba = (moduleId, storeId, phone, fallback) => {
      if (onAbrirConversaNaAba && phone) {
        onAbrirConversaNaAba(moduleId, storeId, phone);
        return;
      }
      fallback?.();
    };
    const responder = orderWaitingReplies(awaitingAll.map(item => {
      const raw = item._raw;
      const messages = item._type === "lead"
        ? Object.values(leadReplyMessages(raw, leadMessages, whatsappMsgs))
        : Object.values(getReplyMsgsForPhone(whatsappMsgs, item.phone, raw.storeId || null));
      const last = messages
        .filter(message => message.remetente === "cliente")
        .reduce((latest, message) => _tsNum(message.timestamp) > _tsNum(latest?.timestamp) ? message : latest, null);
      const rawTimestamp = last?.timestamp;
      const timestamp = _tsNum(rawTimestamp);
      const waitingAt = Number.isFinite(timestamp) && timestamp > 0 ? timestamp : null;
      const text = last?.texto || last?.text || last?.content || "";
      const ownerId = Number(raw.consultantId ?? raw.assignedConsultantId ?? raw.consultorAtual);
      return {
        ...item,
        waitingAt,
        ago:waitingAt ? msgTimeAgo(waitingAt) : null,
        passou15h:passou15h(waitingAt),
        preview:(item._type === "client" ? "Cliente respondeu — " : "")
          + (text.startsWith("data:") ? "📷 Imagem" : text.length > 70 ? `${text.slice(0, 70)}…` : text || "📎 Mídia"),
        consultor:Number.isFinite(ownerId) ? consultantName(ownerId) : "",
        moduleId:item._type === "client" ? "kanban" : item._type === "lead" ? "leads" : "prospeccao",
        storeId:item._type === "lead"
          ? (leadStoreIds(raw) || raw.storeId || currentUser.storeId)
          : (raw.storeId || currentUser.storeId),
      };
    }));
    const retornos = mergeProspectReturns(lembretesUrgentes, myProsp, today).map(reminder => ({
      ...reminder,
      atrasado:reminder.dueDate < today,
      consultor:consultantName(Number(reminder.consultantId)),
    }));
    const [, month, day] = String(today).split("-");
    return (
      <div>
      {noticeView}
      {nuDiaPreparado.erro && <div role="alert" style={{ color:"#B42318", fontSize:13, marginBottom:12 }}>
        Não foi possível preparar a prospecção de hoje: {nuDiaPreparado.erro}
      </div>}
      <ProspFilaDemoBoundary
        demo={_demoMode || loggedInUser?.isDemo === true}
        fallback={<div style={{ color:T.muted, fontSize:13, marginBottom:12 }}>
          Avisos e indicadores operacionais ficam disponíveis na sessão real.
        </div>}
      >
        {["consultant", "manager"].includes(currentUser.role) && <DepositoAvisos theme={T} currentUser={currentUser} onAbrirPedido={onAbrirPedidoDeposito} />}
        <PontosCard theme={T} currentUser={currentUser} />
        {currentUser.role !== "consultant" && <RotinaGerente theme={T} currentUser={currentUser} onIrPara={aba => onNavigate && onNavigate(aba)} />}
      </ProspFilaDemoBoundary>
      <MeuDia
        theme={T}
        hoje={`${day}/${month}`}
        currentUser={currentUser}
        nomeUsuario={(currentUser.name || "").split(" ")[0]}
        mostrarConsultor={currentUser.role !== "consultant"}
        responder={responder}
        alerta15h={currentUser.role !== "consultant" ? alertaSemResposta(responder) : []}
        retornos={retornos}
        fila={filaMeuDiaAtiva ? nuFilaMeuDia : null}
        entregues={entregaAvisos.entregues}
        entreguesErro={entregaAvisos.erro}
        bindingSales={liftSales}
        bindingError={liftError}
        onOpenBindingSale={() => {
          if (onNavigate && onNavigate("lembretes")) {
            setTimeout(() => document.getElementById("pendencias-venda")?.scrollIntoView({ behavior:"smooth" }), 100);
          }
        }}
        onAbrirPosVenda={() => onNavigate && onNavigate("lembretes")}
        onAbrirResponder={item => abrirNaAba(
          item.moduleId,
          item.storeId,
          item.phone,
          () => handleAwaitingClick(item),
        )}
        onAbrirRetorno={handleOpenReminder}
        onConcluirRetorno={id => onToggleReminder(id)}
        onIrProspeccao={() => onNavigate && onNavigate("prospeccao")}
      />
      </div>
    );
  }

  return (
    <div>
      <div style={{ fontWeight:800, fontSize:20, color:T.text, marginBottom:4 }}>⚡ Central Operacional</div>
      <div style={{ fontSize:13, color:T.muted, marginBottom:16 }}>Tudo que precisa de atenção agora · {today}</div>
      <CommercialSalesNotice breakdown={pulsoBD} periodRange={pulsoRange} error={commercialError} loaded={commercialLoaded}
        storeId={currentUser.role === "consultant" ? null : (currentUser.storeId || null)}
        consultantId={currentUser.role === "consultant" ? currentUser.id : null} liftSales={commercialSales} />
      <div style={{ background:"#FFF7F7", border:"1px solid #FCA5A5", borderRadius:14, padding:16, marginBottom:18 }}>
        <strong>Pendências de venda · LIFT</strong>
        <div style={{ margin:"8px 0", fontSize:13 }}>
          Abertas: {liftSales.filter(s => s.pendencia?.status === "aberta").length}
          {" · "}Há mais de 24h: {liftSales.filter(s => liftSaleIsLate(s)).length}
        </div>
        {liftError && <div role="alert" style={{ color:"#B91C1C" }}>{liftError}</div>}
        <button onClick={() => { if (onNavigate("lembretes")) setTimeout(() => document.getElementById("pendencias-venda")?.scrollIntoView({ behavior:"smooth" }), 100); }}
          style={{ border:"1px solid #DC2626", background:"#fff", borderRadius:8, color:"#B91C1C", padding:"7px 12px", cursor:"pointer" }}>
          Ver em Lembretes →
        </button>
      </div>
      <div style={{ background:"#F8FAFC", border:"1px solid #CBD5E1", borderRadius:14, padding:16, marginBottom:18 }}>
        <strong>Pós-venda LIFT</strong>
        <div style={{ margin:"8px 0", fontSize:13 }}>
          A fazer: {postSales.filter(s => !s.postSaleState.done).length}
          {" · "}Atrasados: {postSales.filter(s => !s.postSaleState.done && s.postSaleState.overdueDays > 0).length}
          {currentUser.role !== "consultant" && postSales.some(s => s.posVenda?.resultado === "problema") &&
            <div role="alert" style={{ color:"#B91C1C", fontWeight:700 }}>
              Atenção: {postSales.filter(s => s.posVenda?.resultado === "problema").length} cliente(s) com problema após a entrega.
            </div>}
        </div>
        {postError && <div role="alert" style={{ color:"#B91C1C" }}>{postError}</div>}
        {currentUser.role !== "consultant" && postSales.filter(s => !s.postSaleState.done && s.postSaleState.overdueDays > 0).map(s =>
          <div key={`${s.storeId}_${s.liftPedidoId}`} style={{ fontSize:12, color:"#B91C1C" }}>
            {s.vendidoPor?.nome || `Responsável #${s.responsavelId}`} não fez o pós-venda de {s.cliente?.nome || "cliente"} (pedido #{s.liftPedidoId}).
          </div>)}
        <button onClick={() => { if (onNavigate("lembretes")) setTimeout(() => document.getElementById("pos-venda-lift")?.scrollIntoView({ behavior:"smooth" }), 100); }}
          style={{ marginTop:8, border:"1px solid #334155", background:"#fff", borderRadius:8, padding:"7px 12px", cursor:"pointer" }}>
          Ver pós-venda em Lembretes →
        </button>
      </div>

      {/* ── Clientes aguardando sua resposta ── */}
      <div style={{ background:"#FEF2F2", border:"2px solid #EF4444", borderRadius:16, padding:"16px 20px", marginBottom:20 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom: awaitingAll.length > 0 ? 14 : 0 }}>
          <div style={{ fontWeight:800, fontSize:15, color:"#DC2626", display:"flex", alignItems:"center", gap:8 }}>
            🔴 Aguardando sua resposta
            <span style={{ background:"#EF4444", color:"#fff", borderRadius:99, padding:"2px 9px", fontSize:12, fontWeight:800 }}>
              {awaitingAll.length}
            </span>
          </div>
          {awaitingAll.length === 0 && (
            <span style={{ fontSize:12, color:"#16A34A", fontWeight:700 }}>✅ Nenhum cliente aguardando</span>
          )}
        </div>
        {awaitingAll.map(item => {
          const phone = item.phone;
          const allMsgs = item._type === "client"
            ? Object.values(getWaMsgsForPhone(whatsappMsgs, normalizePhone(phone), item._raw.storeId)||{})
            : item._type === "lead"
              ? [...Object.values(leadMessages[item._raw.id]||{}), ...Object.values(getWaMsgsForPhone(whatsappMsgs, normalizePhone(phone), leadStoreIds(item._raw))||{})]
              : Object.values(getWaMsgsForPhone(whatsappMsgs, normalizePhone(phone), item._raw.storeId)||{});
          const lastClientMsg = allMsgs.filter(m=>m.remetente==="cliente").reduce((a,m)=>(_tsNum(m.timestamp)>_tsNum(a?.timestamp))?m:a,null);
          const ago = msgTimeAgo(lastClientMsg?.timestamp);
          const lastText = lastClientMsg?.texto || lastClientMsg?.text || "";
          const preview = lastText.startsWith("data:") ? "📷 Imagem" : lastText.length > 48 ? lastText.slice(0,48)+"…" : lastText || "📎 Mídia";
          return (
            <div key={item.key} onClick={()=>handleAwaitingClick(item)}
              style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 0", borderBottom:"1px solid #FECACA", cursor:"pointer" }}>
              <div style={{ width:8, height:8, borderRadius:"50%", background:"#EF4444", flexShrink:0, animation:"pulse 1.5s infinite" }} />
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontWeight:700, fontSize:13, color:"#1E293B" }}>{item.name}</div>
                <div style={{ fontSize:11, color:"#64748B", marginTop:1, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{preview}</div>
              </div>
              <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:3, flexShrink:0 }}>
                <span style={{ background:item.originColor+"22", color:item.originColor, borderRadius:99, padding:"2px 7px", fontSize:10, fontWeight:700 }}>{item.origin}</span>
                {ago && <span style={{ fontSize:10, color:"#EF4444", fontWeight:700 }}>há {ago}</span>}
              </div>
            </div>
          );
        })}
        {awaitingAll.length === 0 && (
          <div style={{ fontSize:13, color:"#16A34A", textAlign:"center", paddingTop:4 }}>Tudo respondido! 🎉</div>
        )}
      </div>

      {/* Pulso da meta (gerente/consultor) */}
      {showMeta && (
        <div style={{ background:`linear-gradient(135deg,${T.accent},${T.accentLight})`, borderRadius:16, padding:20, marginBottom:20, boxShadow:`0 4px 20px ${T.accent}33` }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:12 }}>
            <div>
              <div style={{ fontSize:11, fontWeight:700, color:"rgba(255,255,255,0.75)", letterSpacing:1, textTransform:"uppercase", marginBottom:4 }}>🎯 Pulso da Meta</div>
              <div style={{ fontSize:28, fontWeight:900, color:"#fff", lineHeight:1 }}>{fmt(totalVendido)}</div>
              <div style={{ fontSize:12, color:"rgba(255,255,255,0.8)", marginTop:4 }}>de {fmt(activeGoal)} · {pctGoal}%</div>
            </div>
            <div style={{ textAlign:"right" }}>
              {dailyNeeded>0
                ? <>
                    <div style={{ fontSize:11, color:"rgba(255,255,255,0.75)", marginBottom:2 }}>Meta/dia restante</div>
                    <div style={{ fontSize:22, fontWeight:800, color:"#fff" }}>{fmt(dailyNeeded)}</div>
                    <div style={{ fontSize:11, color:"rgba(255,255,255,0.75)" }}>{daysLeft} dia{daysLeft!==1?"s":""} restante{daysLeft!==1?"s":""}</div>
                  </>
                : <div style={{ fontSize:18, fontWeight:800, color:"#fff" }}>🏆 Meta batida!</div>
              }
            </div>
          </div>
          <div style={{ background:"rgba(255,255,255,0.25)", borderRadius:99, height:8, overflow:"hidden", marginTop:14 }}>
            <div style={{ width:`${Math.min(pctGoal,100)}%`, height:"100%", background:"#fff", borderRadius:99, transition:"width 0.6s" }} />
          </div>
        </div>
      )}

      {/* Tudo em dia */}
      {nothingUrgent && (
        <div style={{ background:"#F0FFF4", border:"2px solid #86EFAC", borderRadius:16, padding:32, textAlign:"center", marginBottom:20 }}>
          <div style={{ fontSize:40, marginBottom:8 }}>🎉</div>
          <div style={{ fontWeight:800, fontSize:16, color:"#16A34A", marginBottom:4 }}>Tudo em dia!</div>
          <div style={{ fontSize:13, color:"#166534" }}>Nenhuma urgência no momento. Continue assim!</div>
        </div>
      )}

      {/* Clientes com proposta final */}
      {urgentes.length>0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:16, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderLeft:`4px solid ${T.accent}` }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
            <div style={{ fontWeight:700, fontSize:15, color:T.accent }}>⚠️ Proposta Final Pendente ({urgentes.length})</div>
            <button onClick={()=>onNavigate("kanban")} style={{ background:"none", border:`1px solid ${T.accent}`, borderRadius:8, padding:"4px 12px", fontSize:11, fontWeight:700, color:T.accent, cursor:"pointer" }}>Ver Kanban →</button>
          </div>
          {urgentes.map(c=>(
            <div key={c.id} onClick={()=>setOpenClient(c)} style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 0", borderBottom:"1px solid #F1F5F9", cursor:"pointer" }}>
              <div style={{ width:36, height:36, borderRadius:"50%", background:`${T.accent}18`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, flexShrink:0 }}>👤</div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontWeight:700, fontSize:13, color:T.text }}>{c.name}</div>
                <div style={{ fontSize:11, color:T.muted }}>{c.product}{currentUser.role!=="consultant"?` · ${consultantName(c.consultantId)}`:""}</div>
              </div>
              <div style={{ textAlign:"right" }}>
                <div style={{ fontSize:14, fontWeight:800, color:T.accent }}>{fmt(c.value||0)}</div>
                <div style={{ fontSize:10, color:T.muted }}>em negociação</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Entregas com atenção */}
      {entregasAlerta.length>0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:16, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderLeft:"4px solid #D97706" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
            <div style={{ fontWeight:700, fontSize:15, color:"#D97706" }}>📦 Entregas com Atenção ({entregasAlerta.length})</div>
            <button onClick={()=>onNavigate("entregas")} style={{ background:"none", border:"1px solid #D97706", borderRadius:8, padding:"4px 12px", fontSize:11, fontWeight:700, color:"#D97706", cursor:"pointer" }}>Ver Entregas →</button>
          </div>
          {entregasAlerta.map(c=>{
            const atrasada = c.diff<0;
            const hoje     = c.diff===0;
            const tag      = atrasada?"🚨 Atrasada":hoje?"⚠️ HOJE":`⚠️ Em ${c.diff}d`;
            const tagColor = atrasada?"#EF4444":"#D97706";
            return (
              <div key={c.id} onClick={()=>setOpenClient(c)} style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 0", borderBottom:"1px solid #F1F5F9", cursor:"pointer" }}>
                <div style={{ background:atrasada?"#FEE2E2":"#FEF3C7", borderRadius:8, padding:"4px 10px", fontSize:11, fontWeight:700, color:tagColor, whiteSpace:"nowrap" }}>{tag}</div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontWeight:700, fontSize:13, color:T.text }}>{c.name}</div>
                  <div style={{ fontSize:11, color:T.muted }}>{c.product}{currentUser.role!=="consultant"?` · ${consultantName(c.consultantId)}`:""}</div>
                </div>
                <div style={{ fontSize:11, color:T.muted, whiteSpace:"nowrap" }}>{c.deliveryDate}</div>
              </div>
            );
          })}
        </div>
      )}

      {/* Lembretes atrasados / hoje */}
      {lembretesUrgentes.length>0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, marginBottom:16, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderLeft:`4px solid ${T.gold}` }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
            <div style={{ fontWeight:700, fontSize:15, color:T.gold }}>📌 Lembretes Urgentes ({lembretesUrgentes.length})</div>
            <button onClick={()=>onNavigate("lembretes")} style={{ background:"none", border:`1px solid ${T.gold}`, borderRadius:8, padding:"4px 12px", fontSize:11, fontWeight:700, color:T.gold, cursor:"pointer" }}>Ver Todos →</button>
          </div>
          {lembretesUrgentes.map(r=>{
            const atrasado = r.dueDate<today;
            const canOpen = !!resolveOperationalReminder(r);
            return (
              <div key={r.id} onClick={canOpen?()=>handleOpenReminder(r):undefined} style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 0", borderBottom:"1px solid #F1F5F9", cursor:canOpen?"pointer":"default" }}>
                <ReminderCompletionButton reminder={r} onComplete={onToggleReminder} style={{ width:24, height:24, minWidth:24, borderRadius:7, border:`2px solid ${T.muted}`, background:"#fff", cursor:"pointer", fontSize:12, fontWeight:800, flexShrink:0 }} />
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:13, fontWeight:600, color:T.text }}>{r.text}</div>
                  {r.clientName && <div style={{ fontSize:11, color:T.muted }}>👤 {r.clientName}{currentUser.role!=="consultant"?` · ${consultantName(r.consultantId)}`:""}</div>}
                </div>
                <span style={{ background:atrasado?"#FEE2E2":"#FEF3C7", color:atrasado?"#EF4444":"#D97706", borderRadius:99, padding:"2px 8px", fontSize:10, fontWeight:700, whiteSpace:"nowrap" }}>
                  {atrasado?`Atrasado (${r.dueDate})`:"Hoje"}
                </span>
              </div>
            );
          })}
        </div>
      )}

      {/* A receber */}
      {comPendente.length>0 && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, boxShadow:"0 2px 12px rgba(15,31,61,0.08)", borderLeft:"4px solid #16A34A" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
            <div style={{ fontWeight:700, fontSize:15, color:"#16A34A" }}>💰 A Receber — {fmt(totalPendente)}</div>
            <button onClick={()=>onNavigate("recebimentos")} style={{ background:"none", border:"1px solid #16A34A", borderRadius:8, padding:"4px 12px", fontSize:11, fontWeight:700, color:"#16A34A", cursor:"pointer" }}>Ver Todos →</button>
          </div>
          {comPendente.map(c=>(
            <div key={c.id} onClick={()=>setOpenClient(c)} style={{ display:"flex", alignItems:"center", gap:12, padding:"8px 0", borderBottom:"1px solid #F1F5F9", cursor:"pointer" }}>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontWeight:700, fontSize:13, color:T.text }}>{c.name}</div>
                <div style={{ fontSize:11, color:T.muted }}>{c.product}{currentUser.role!=="consultant"?` · ${consultantName(c.consultantId)}`:""}</div>
              </div>
              <div style={{ fontSize:15, fontWeight:800, color:"#D97706" }}>{fmt(c.pendente)}</div>
            </div>
          ))}
          {myClosed.filter(c=>Math.max(0,(c.value||0)-(c.paidValue!==undefined?c.paidValue:(c.value||0)))>0).length>5 && (
            <div style={{ fontSize:11, color:T.muted, marginTop:8 }}>+ {myClosed.filter(c=>Math.max(0,(c.value||0)-(c.paidValue!==undefined?c.paidValue:(c.value||0)))>0).length-5} clientes — veja tudo em Recebimentos</div>
          )}
        </div>
      )}
      {openClient && <ClientModal client={openClient} storeId={openClient.storeId} onClose={()=>setOpenClient(null)}
        onUpdate={onUpdateClient ? (u=>onUpdateClient(u)) : undefined}
        onDelete={onDeleteClient ? (id=>{ onDeleteClient(id); setOpenClient(null); }) : undefined}
        onAddReminder={onAddReminder} onSendZapi={onSendZapi} onSendZapiMedia={onSendZapiMedia} whatsappMsgs={whatsappMsgs} onReturnToAurora={onReturnToAurora} onConversationActive={onConversationActive} />}
      {openLead && (
        <div style={{ position:"fixed", inset:0, background:"rgba(15,31,61,0.6)", zIndex:200, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={dismissOpenLead}>
          <div onClick={e=>e.stopPropagation()} style={{ background:"#fff", borderRadius:18, width:"100%", maxWidth:920, height:"85vh", maxHeight:760, overflow:"hidden", boxShadow:"0 20px 60px rgba(0,0,0,0.25)", display:"flex" }}>
            <LeadPanel
              lead={resolveProjectedRecord(leads, openLead)}
              msgs={leadMessages[openLead.id]||{}}
              waMsgs={getWaMsgsForPhone(whatsappMsgs, normalizePhone(openLead.telefone), leadStoreIds(openLead))}
              events={leadEvents[openLead.id]||{}}
              onClose={dismissOpenLead}
               onUpdate={onUpdateLead ? ((u, options)=>Promise.resolve(onUpdateLead(u)).then(result=>{ if (options?.keepOpen) setOpenLead(prev=>prev?.id===u.id ? { ...prev, ...u, ...(result && typeof result === "object" ? result : {}) } : prev); return result; })) : undefined}
              onDelete={onDeleteLead ? (id=>{ if (dismissOpenLead()) onDeleteLead(id); }) : undefined}
              onDeleteWhatsAppMessage={onDeleteWhatsAppMessage}
              onSendMessage={onSendMessage}
              onSendZapi={onSendZapi}
              onSendQRMedia={(phone,m,sid,quotedId,quotedMsg)=>onSendZapiMedia&&onSendZapiMedia(phone,{_isQRMedia:true,url:m.url,tipo:m.tipo},m.tipo,sid,quotedId,quotedMsg)}
              onSendZapiMedia={onSendZapiMedia}
              onLogTransfer={onLogTransfer}
              onAddReminder={onAddReminder}
              currentUser={currentUser}
               onCreateProspItem={onCreateProspItem}
              onConversationActive={onConversationActive}
            />
          </div>
        </div>
      )}
    </div>
  );
}

// ── Demo activation ─────────────────────────────────────────────────────────
// Três sinais possíveis (qualquer um basta):
//   1) Pathname /apresentacao  → CRA dev server serve index.html diretamente (sem proxy)
//   2) Hash #_demo             → server.js redireciona /#_demo; o hash sobrevive ao proxy
//                                do CRA mesmo que o proxy descarte o Set-Cookie
//   3) Cookie arflow_demo=1   → produção: server.js seta o cookie antes de redirecionar
//
// Em TODOS os casos, limpamos localStorage ANTES dos useState para garantir que qualquer
// sessão anterior (inclusive SuperAdmin/Studio) seja descartada antes que o React monte.
if (typeof window !== 'undefined') {
  const _onApresentacaoPath = window.location.pathname.startsWith('/apresentacao');
  const _hasDemoHash        = window.location.hash === '#_demo';
  const _hasDemoCookieNow   = document.cookie.split(';').some(c => c.trim() === 'arflow_demo=1');

  if (_onApresentacaoPath || _hasDemoHash || _hasDemoCookieNow) {
    // Força sessão limpa — descarta qualquer login real ou de SuperAdmin salvo
    try { localStorage.clear(); } catch {}

    // Garante que o cookie esteja presente para o useEffect de auto-login
    document.cookie = 'arflow_demo=1; max-age=14400; path=/; samesite=lax';

    // Limpa pathname e hash para a URL mostrar apenas "/"
    if (_onApresentacaoPath || _hasDemoHash) {
      window.history.replaceState({}, '', '/');
    }
  }
}
const _demoPendingLogin = false;

// Read-only operational view over the canonical commercial follow-up
// projection.  It deliberately has no write actions or local status model:
// refreshes always come from the server read model.
function CommercialFollowUpView({ currentUser, onOpenConversation }) {
  const isStaff = ["superadmin", "admin", "manager"].includes(currentUser?.role);
  const fixedStoreId = currentUser?.role === "manager" ? currentUser.storeId : "";
  const [storeFilter, setStoreFilter] = useState(fixedStoreId || "");
  const [stateFilter, setStateFilter] = useState("all");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setStoreFilter(fixedStoreId || "");
  }, [fixedStoreId]);

  useEffect(() => {
    if (!isStaff) return undefined;
    let cancelled = false;
    const params = new URLSearchParams();
    const requestedStore = fixedStoreId || storeFilter;
    if (requestedStore) params.set("storeId", requestedStore);
    if (stateFilter && stateFilter !== "all") params.set("state", stateFilter);
    setLoading(true);
    setError("");
    fetch(`/api/commercial-followup?${params.toString()}`, { credentials:"same-origin" })
      .then(async response => {
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || "Não foi possível carregar o Follow-up.");
        return payload;
      })
      .then(payload => {
        if (cancelled) return;
        setItems(Array.isArray(payload.items) ? payload.items : []);
      })
      .catch(loadError => {
        if (!cancelled) {
          setItems([]);
          setError(loadError.message || "Não foi possível carregar o Follow-up.");
        }
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [isStaff, fixedStoreId, storeFilter, stateFilter]);

  if (!isStaff) return null;
  const stateLabels = {
    awaiting_send:"Aguardando envio",
    awaiting_client:"Aguardando cliente",
    awaiting_consultant:"Respondeu / aguardando consultor",
    stopped:"Interrompido",
    completed:"Concluído",
    all:"Todos os estados",
  };
  const stateFor = item => item.state || "";
  const stateLabel = item => stateLabels[stateFor(item)] || stateFor(item) || "Sem estado";
  const dateLabel = value => value ? fmtDateTime(value) : "—";
  const visibleItems = items.filter(item => {
    if (fixedStoreId && Number(item.storeId) !== Number(fixedStoreId)) return false;
    if (storeFilter && Number(item.storeId) !== Number(storeFilter)) return false;
    return !stateFilter || stateFilter === "all" || stateFor(item) === stateFilter;
  });
  const storeName = item => item.storeName
    || STORES.find(store => Number(store.id) === Number(item.storeId))?.name
    || `Loja ${item.storeId || "—"}`;
  const ownerName = item => item.ownerName || item.responsibleName
    || item.owner?.name || (item.ownerId ? `ID ${item.ownerId}` : "Sem responsável");
  const openItem = item => {
    const phone = normalizePhone(item.phone || item.normalizedPhone || item.telefone);
    if (phone && onOpenConversation) onOpenConversation({ phone, storeId:item.storeId });
  };
  const card = { background:"#fff", border:"1px solid #E2E8F0", borderRadius:12, padding:16 };
  const label = { color:"#64748B", fontSize:10, fontWeight:800, textTransform:"uppercase", letterSpacing:.4 };
  const value = { color:"#1E293B", fontSize:13, fontWeight:600, marginTop:3 };
  return (
    <section aria-label="Follow-up Automático">
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12, marginBottom:18 }}>
        <div>
          <h1 style={{ margin:"0 0 5px", color:T.text, fontSize:24 }}>Follow-up Automático</h1>
          <div style={{ color:T.muted, fontSize:13 }}>Projeção operacional canônica — somente leitura.</div>
        </div>
        <button type="button" onClick={() => { setStoreFilter(fixedStoreId || ""); setStateFilter("all"); }} style={{ border:`1px solid ${T.sandDark}`, borderRadius:8, padding:"8px 12px", background:"#fff", color:T.text, cursor:"pointer", fontWeight:700 }}>Limpar filtros</button>
      </div>
      <div style={{ ...card, display:"flex", gap:12, flexWrap:"wrap", alignItems:"end", marginBottom:14 }}>
        {(currentUser.role === "admin" || currentUser.role === "superadmin") && (
          <label style={{ minWidth:210 }}>
            <span style={label}>Loja</span>
            <select value={storeFilter} onChange={event => setStoreFilter(event.target.value)} style={{ display:"block", width:"100%", marginTop:5, padding:"8px 10px", border:`1px solid ${T.sandDark}`, borderRadius:7, background:"#fff", color:T.text }}>
              <option value="">Todas as lojas</option>
              {STORES.map(store => <option key={store.id} value={store.id}>{store.name}</option>)}
            </select>
          </label>
        )}
        <label style={{ minWidth:240 }}>
          <span style={label}>Estado operacional</span>
          <select value={stateFilter} onChange={event => setStateFilter(event.target.value)} style={{ display:"block", width:"100%", marginTop:5, padding:"8px 10px", border:`1px solid ${T.sandDark}`, borderRadius:7, background:"#fff", color:T.text }}>
            <option value="all">Todos os estados</option>
            {Object.entries(stateLabels).filter(([id]) => id !== "all").map(([id, text]) => <option key={id} value={id}>{text}</option>)}
          </select>
        </label>
        <div style={{ color:T.muted, fontSize:12, paddingBottom:9 }}>{visibleItems.length} registro{visibleItems.length === 1 ? "" : "s"}</div>
      </div>
      {loading && <div style={{ ...card, color:T.muted }}>Carregando Follow-up…</div>}
      {!loading && error && <div role="alert" style={{ ...card, borderColor:"#FECACA", background:"#FFF7F7", color:"#B42318" }}>{error}</div>}
      {!loading && !error && !visibleItems.length && <div style={{ ...card, color:T.muted, textAlign:"center", padding:34 }}>Nenhum Follow-up encontrado para os filtros atuais.</div>}
      {!loading && !error && visibleItems.length > 0 && (
        <div style={{ display:"grid", gap:12 }}>
          {visibleItems.map((item, index) => (
            <article key={item.id || item.approvalRef || `${item.storeId}-${item.phone}-${index}`} style={card}>
              <div style={{ display:"flex", justifyContent:"space-between", gap:14, flexWrap:"wrap" }}>
                <div style={{ minWidth:220, flex:"1 1 260px" }}>
                  <div style={{ color:T.text, fontSize:16, fontWeight:800 }}>{item.contactName || item.name || item.phone || "Contato sem nome"}</div>
                  <div style={{ color:T.muted, fontSize:12, marginTop:3 }}>{item.phone || item.normalizedPhone || item.telefone || "Telefone não informado"}</div>
                </div>
                <div style={{ background:"#F8FAFC", borderRadius:8, padding:"7px 10px", color:T.text, fontSize:12, fontWeight:800 }}>{stateLabel(item)}</div>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))", gap:14, marginTop:16 }}>
                <div><div style={label}>Loja</div><div style={value}>{storeName(item)}</div></div>
                <div><div style={label}>Responsável canônico</div><div style={value}>{ownerName(item)}</div></div>
                <div><div style={label}>Policy</div><div style={value}>{item.policyId || item.policy || "—"}{item.policyVersion ? ` · v${item.policyVersion}` : ""}</div></div>
                <div><div style={label}>FU atual</div><div style={value}>{item.currentStep || item.fuCurrent || "—"}{item.nextStep ? ` · próximo ${item.nextStep}` : ""}</div></div>
                <div><div style={label}>Aguardando envio</div><div style={value}>{item.awaitingSend === true || stateFor(item) === "awaiting_send" ? "Sim" : "Não"}</div></div>
                <div><div style={label}>Aguardando cliente</div><div style={value}>{item.awaitingClient === true || stateFor(item) === "awaiting_client" ? "Sim" : "Não"}</div></div>
                <div><div style={label}>Próxima ação</div><div style={value}>{item.nextActionType || item.nextAction || "—"}</div></div>
                <div><div style={label}>Data da próxima ação</div><div style={value}>{dateLabel(item.nextActionAt || item.nextDueAt)}</div></div>
              </div>
              {item.stopReason && (
                <div style={{ marginTop:14, padding:"9px 11px", borderRadius:7, background:"#FFF7ED", color:"#9A3412", fontSize:12 }}>
                  <b>Motivo:</b> {item.stopReason}
                </div>
              )}
              {normalizePhone(item.phone || item.normalizedPhone || item.telefone) && (
                <button type="button" onClick={() => openItem(item)} style={{ marginTop:14, border:"none", borderRadius:7, padding:"8px 12px", background:T.accent, color:"#fff", cursor:"pointer", fontWeight:800, fontSize:12 }}>Abrir conversa</button>
              )}
            </article>
          ))}
        </div>
      )}
    </section>
  );
}

// ── APP ────────────────────────────────────────────────────────
export default function App() {
  const [loggedInUser, setLoggedInUser] = useState(() => {
    try {
      const u = localStorage.getItem('arflow_user');
      if (!u) return null;
      const parsed = JSON.parse(u);
      const canonical = USERS.find(usr => usr.id === parsed.id) || DEMO_USERS.find(usr => usr.id === parsed.id);
      const found = canonical ? { ...parsed, ...canonical, mustChangePassword:parsed.mustChangePassword===true, capabilities:parsed.capabilities||[] } : parsed;
      // Re-hidrata _demoMode no refresh de página para que Firebase use namespace correto
      if (found?.isDemo) _demoMode = true;
      return found;
    } catch { return null; }
  });
  const [currentUser, setCurrentUser] = useState(() => {
    try {
      const u = localStorage.getItem('arflow_user');
      if (!u) return null;
      const parsed = JSON.parse(u);
      const canonical = USERS.find(usr => usr.id === parsed.id) || DEMO_USERS.find(usr => usr.id === parsed.id);
      return canonical ? { ...parsed, ...canonical, mustChangePassword:parsed.mustChangePassword===true, capabilities:parsed.capabilities||[] } : parsed;
    } catch { return null; }
  });
  const [isDemoMode, setIsDemoMode] = useState(() => {
    try { const u = JSON.parse(localStorage.getItem('arflow_user') || 'null'); return !!u?.isDemo; } catch { return false; }
  });
  // Deliberately not persisted: every general-admin entry chooses its read
  // scope before the first heavy request. This never changes the login/role.
  const [adminReadSelection, setAdminReadSelection] = useState({ operatorId:null, value:null });
  const selectedAdminScope = adminReadSelection.operatorId === loggedInUser?.id
    ? adminReadSelection.value : null;
  const scopedReadStores = requestedReadStores(currentUser, selectedAdminScope, getActiveStores(), isDemoMode);
  const scopedReadKey = scopedReadStores.join(",");
  const awaitingAdminStore = isGeneralAdminView(currentUser, isDemoMode) && !scopedReadStores.length;
  const readScopeRef = useRef({ stores:scopedReadStores, awaiting:awaitingAdminStore, key:scopedReadKey });
  readScopeRef.current = { stores:scopedReadStores, awaiting:awaitingAdminStore, key:scopedReadKey };
  const chooseAdminReadScope = value => activeConversationExitGuard.requestAction(() => {
    if (readScopeRef.current.key === (value === "all" ? getActiveStores().map(store => store.id).join(",") : String(value))) return;
    invalidateProspectWrites();
    setClients([]); setAuroraLeads([]); setProspeccao([]); setCommercialTracking({});
    setScopedLiftSales([]); setWhatsappMsgs({}); setLeadMessages({}); setLeadEvents({});
    setReminders([]); setLoading(true);
    setLiftSales([]); setPostSales([]); setAutoOpenTarget(null); setTab("dashboard");
    setSearchOpenedCard(null);
    setAdminReadSelection({ operatorId:loggedInUser.id, value });
  });
  const prospectMutationGenerationRef = useRef(0);
  const ownActionSnapshots = useRef(createOwnActionSnapshots());
  const prospectScopeRevisionRef = useRef(new Map());
  const prospectScopePendingRef = useRef(new Map());
  const prospectLiveScopeRef = useRef("");
  const getProspectScope = () => prospectWriteScope({
    operator:loggedInUser,
    currentUser,
    demoMode:isDemoMode,
    generation:prospectMutationGenerationRef.current,
  });
  prospectLiveScopeRef.current = getProspectScope();
  const invalidateProspectWrites = () => {
    ownActionSnapshots.current.clear();
    prospectMutationGenerationRef.current += 1;
    prospectLiveScopeRef.current = getProspectScope();
  };
  const [accountOpen, setAccountOpen] = useState(false);
  const [userPasswordResetOpen, setUserPasswordResetOpen] = useState(false);
  const expiredCrmAlertShownRef = useRef(false);
  const loggedInUserId = loggedInUser?.id;
  const canViewOwnerSafety = !isDemoMode && Number(loggedInUserId) === 40
    && loggedInUser?.role === "superadmin" && loggedInUser?.authKind !== "studio";
  useEffect(() => {
    if (loggedInUserId == null) setAdminReadSelection({ operatorId:null, value:null });
  }, [loggedInUserId]);
  useEffect(() => { setTextSendAttemptOwner(loggedInUserId);clearHistoryPages(); }, [loggedInUserId,currentUser?.id]);
  const loggedInUserIsDemo = loggedInUser?.isDemo === true;
  const currentUserId = currentUser?.id;
  const currentUserStoreId = currentUser?.storeId;
  const currentUserRole = currentUser?.role;
  const [pushStatus, setPushStatus] = useState({
    supported:pushSupported(), permission:"default", subscription:null,
    serviceWorkerRegistered:false, serviceWorkerActive:false, serverSaved:false, environment:{},
  });
  const [pushError, setPushError] = useState("");
  const [pushMessage, setPushMessage] = useState("");
  const [pushBusy, setPushBusy] = useState(false);
  const [pushEvents, setPushEvents] = useState([]);
  const pushReadCutoffsRef = useRef({ userId:loggedInUserId, values:{} });
  if (pushReadCutoffsRef.current.userId !== loggedInUserId) {
    pushReadCutoffsRef.current = { userId:loggedInUserId, values:{} };
  }
  const unreadPushLookup = useMemo(() => {
    const lookup = new Map();
    pushEvents.filter(event => !event.firstViewedAt).forEach(event => {
      const phone = normalizePhone(event.phone);
      const identity = conversationKey(event.storeId, phone);
      if (!identity) return;
      const key = `${event.module || "inbox"}:${identity}`;
      lookup.set(key, (lookup.get(key) || 0) + 1);
    });
    return lookup;
  }, [pushEvents]);
  const pushUnreadCount = useMemo(() => pushEvents.filter(event => !event.firstViewedAt).length, [pushEvents]);
  useEffect(() => {
    if (loggedInUserId == null || loggedInUserIsDemo || currentUserRole === "deposito") return;
    getPushStatus({ storeId:currentUserStoreId, consultantId:currentUserId })
      .then(setPushStatus)
      .catch(error => setPushError(error.message));
  }, [loggedInUserId, loggedInUserIsDemo, currentUserId, currentUserStoreId, currentUserRole]);
  useEffect(() => {
    if (loggedInUserId == null || loggedInUserIsDemo || currentUserRole !== "consultant") return undefined;
    const load = () => getPushEvents().then(result => {
      if (pushReadCutoffsRef.current.userId === loggedInUserId) {
        setPushEvents(maskReadPushEvents(result.events, pushReadCutoffsRef.current.values));
      }
    }).catch(() => {});
    const onWorkerMessage = event => { if (event.data?.type === "ARFLOW_PUSH_REFRESH_EVENTS" && mayAutoRefresh()) load(); };
    navigator.serviceWorker?.addEventListener("message", onWorkerMessage);
    const stopPolling = watchVisiblePolling(load, 60000);
    return () => {
      stopPolling();
      navigator.serviceWorker?.removeEventListener("message", onWorkerMessage);
    };
  }, [loggedInUserId, loggedInUserIsDemo, currentUserRole]);
  useEffect(() => {
    if (loggedInUser?.mustChangePassword) setAccountOpen(true);
  }, [loggedInUser?.mustChangePassword]);
  useEffect(() => {
    if (!loggedInUser || loggedInUser.isDemo) return;
    let active = true;
    const expireLocally = () => {
      if (!active || expiredCrmAlertShownRef.current) return;
      expiredCrmAlertShownRef.current = true;
      invalidateProspectWrites();
      setLoggedInUser(null);
      setCurrentUser(null);
      try { localStorage.removeItem('arflow_user'); } catch {}
      window.alert("Sua sessão do CRM expirou por segurança. Entre novamente antes de enviar mensagens.");
    };
    const renewSession = async () => {
      try {
        const endpoint = loggedInUser.authKind === 'studio' ? '/api/studio/session' : '/api/crm/session';
        const response = await fetch(endpoint, { credentials:'same-origin' });
        if (response.status === 401) return expireLocally();
        if (response.ok) {
          const session = await response.json().catch(()=>null);
          if (session) {
            if (Number(session.userId) !== Number(loggedInUser.id)) return expireLocally();
            setLoggedInUser(previous => previous ? {
              ...previous,
              capabilities:session.capabilities||[],
              mustChangePassword:session.mustChangePassword===true,
            } : previous);
            if (session.mustChangePassword === true) setAccountOpen(true);
          }
        }
      } catch {
        // Falhas transitórias de rede não encerram uma sessão válida.
      }
    };
    renewSession();
    const timer = setInterval(renewSession, 15 * 60 * 1000);
    return () => { active = false; clearInterval(timer); };
  }, [loggedInUser?.id, loggedInUser?.role, loggedInUser?.isDemo]); // eslint-disable-line react-hooks/exhaustive-deps
  const [guidedOpen, setGuidedOpen] = useState(false);
  const [guidedStep, setGuidedStep] = useState(0);
  const [loading,   setLoading]    = useState(true);
  const [clients,   setClients]    = useState([]);
  const pendingClientWrites = useRef(new Map());
  const pendingFinancialSaleSheetWrites = useRef(new Map());
  const clientsLoadedRef = useRef(false);
  // Transferências usam um comando idempotente, CAS no cartão e CAS repetido
  // na coleção de lembretes para sobreviver a alterações concorrentes.
  const transferClientOwnership = async (client, consultantId, reason = "") => {
    const nextConsultantId = consultantId == null || consultantId === ""
      ? null : Number(consultantId);
    const expectedConsultantId = client?.consultantId
      ?? client?.assignedConsultantId
      ?? client?.consultorAtual
      ?? null;
    const expectedStoreId = Number(client?.storeId || client?.lojaAtual || currentUserRef.current?.storeId || 0) || null;
    const destinationStoreId = nextConsultantId == null
      ? Number(client.storeId || client.lojaAtual || currentUserRef.current?.storeId || 0)
      : Number(USERS.find(user => Number(user.id) === nextConsultantId)?.storeId || 0);
    if (!client?.id || (nextConsultantId != null && !destinationStoreId)) {
      throw new Error("Não foi possível identificar o cartão ou a loja do novo consultor.");
    }
    if (isDemoMode) {
      const moved = {
        ...client,
        consultantId:nextConsultantId,
        storeId:destinationStoreId,
        ownershipGeneration:(Number(client.ownershipGeneration) || 0) + 1,
        ...(nextConsultantId == null ? { returnedToAuroraAt:new Date().toISOString() } : { returnedToAuroraAt:null }),
      };
      await set(dbRef(`arflow_clients/${client.id}`), moved);
      setReminders(previous => previous.map(reminder =>
        reminder?.status === "pending" && String(reminder.clientId ?? "") === String(client.id)
          ? { ...reminder, consultantId:nextConsultantId, storeId:destinationStoreId }
          : reminder));
      return moved;
    }
    const transferId = window.crypto?.randomUUID?.()
      || `${Date.now()}_${Math.random().toString(36).slice(2)}`;
    const body = JSON.stringify({
        transferId,
        clientId:String(client.id),
        consultantId:nextConsultantId,
        expectedConsultantId,
        expectedStoreId,
        reason,
      });
    let response;
    let payload = {};
    for (let attempt = 0; attempt < 2; attempt += 1) {
      try {
        response = await fetch("/api/crm/clients/transfer", {
          method:"POST",
          credentials:"same-origin",
          headers:{ "Content-Type":"application/json", Accept:"application/json" },
          body,
        });
        payload = await response.json().catch(() => ({}));
      } catch (error) {
        if (attempt === 1) throw error;
        continue;
      }
      if (response.status !== 503 || attempt === 1) break;
    }
    if (!response.ok || payload.ok !== true || !payload.client) {
      if (response.status === 401) handleExpiredCrmSession();
      throw new Error(payload.error || `Não foi possível transferir o cartão (HTTP ${response.status}).`);
    }
    return payload.client;
  };
  const transferProspectOwnership = async (prospect, consultantId) => {
    const nextConsultantId = Number(consultantId);
    const destinationStoreId = Number(USERS.find(user => Number(user.id) === nextConsultantId)?.storeId || 0);
    const sourceStoreId = Number(prospect?.storeId || prospect?.lojaAtual || currentUser.storeId);
    const expectedConsultantId = prospect?.consultantId
      ?? prospect?.assignedConsultantId
      ?? prospect?.consultorAtual
      ?? null;
    if (!prospect?.id || !sourceStoreId || !destinationStoreId) {
      throw new Error("Não foi possível identificar a prospecção ou a loja do novo consultor.");
    }
    if (isDemoMode) {
      const transferId = window.crypto?.randomUUID?.()
        || `${Date.now()}_${Math.random().toString(36).slice(2)}`;
      const transferredAt = new Date().toISOString();
      const key = prospect._firebaseKey || String(prospect.id);
      const itemRef = dbRef(`arflow_prospeccao/${key}`);
      const transaction = await runTransaction(itemRef, existing => {
        if (!existing || String(existing.id ?? key) !== String(prospect.id)) return undefined;
        const event = {
          eventId:transferId,
          tipo:"ownership_change",
          responsavelAnterior:existing.consultantId ?? null,
          novoResponsavel:nextConsultantId,
          lojaAnterior:existing.storeId ?? existing.lojaAtual ?? sourceStoreId,
          novaLoja:destinationStoreId,
          timestamp:transferredAt,
        };
        return {
          ...existing,
          consultantId:nextConsultantId,
          ...(Object.hasOwn(existing, "assignedConsultantId") ? { assignedConsultantId:nextConsultantId } : {}),
          ...(Object.hasOwn(existing, "consultorAtual") ? { consultorAtual:nextConsultantId } : {}),
          storeId:destinationStoreId,
          ...(Object.hasOwn(existing, "lojaAtual") ? { lojaAtual:destinationStoreId } : {}),
          ownershipGeneration:(Number(existing.ownershipGeneration) || 0) + 1,
          ownershipHistory:{ ...(existing.ownershipHistory || {}), [transferId]:event },
          lastOwnershipTransferId:transferId,
        };
      });
      if (!transaction.committed) throw new Error("Não foi possível confirmar a transferência da prospecção.");
      const saved = { ...transaction.snapshot.val(), id:prospect.id, _firebaseKey:key };
      setReminders(previous => previous.map(reminder =>
        reminder?.status === "pending" && String(reminder.prospId ?? "") === String(prospect.id)
          ? {
            ...reminder,
            consultantId:nextConsultantId,
            storeId:destinationStoreId,
            ...(Object.hasOwn(reminder, "assignedConsultantId") ? { assignedConsultantId:nextConsultantId } : {}),
            ...(Object.hasOwn(reminder, "consultorAtual") ? { consultorAtual:nextConsultantId } : {}),
          }
          : reminder));
      setProspeccao(previous => previous.map(item => String(item.id) === String(saved.id) ? saved : item));
      return saved;
    }
    const transferId = window.crypto?.randomUUID?.()
      || `${Date.now()}_${Math.random().toString(36).slice(2)}`;
    const body = JSON.stringify({
      operation:"transfer",
      transferId,
      id:String(prospect.id),
      key:prospect._firebaseKey || undefined,
      storeId:sourceStoreId,
      expectedConsultantId,
      consultantId:nextConsultantId,
    });
    let response;
    let payload = {};
    for (let attempt = 0; attempt < 2; attempt += 1) {
      try {
        response = await fetch("/api/crm/prospects/item", {
          method:"POST",
          credentials:"same-origin",
          headers:{ "Content-Type":"application/json", Accept:"application/json" },
          body,
        });
        payload = await response.json().catch(() => ({}));
      } catch (error) {
        if (attempt === 1) throw error;
        continue;
      }
      if (response.status !== 503 || attempt === 1) break;
    }
    if (!response.ok || payload.ok !== true || !payload.record) {
      if (response.status === 401) handleExpiredCrmSession();
      throw new Error(payload.error || `Não foi possível transferir a prospecção (HTTP ${response.status}).`);
    }
    const saved = { ...payload.record, id:prospect.id, _firebaseKey:payload.key || prospect._firebaseKey };
    setProspeccao(previous => previous.map(item => String(item.id) === String(saved.id) ? saved : item));
    return saved;
  };
  const confirmCard = (moduleId, record, previous) => {
    const operationUserId = currentUserRef.current?.id;
    return confirmHumanCardUpdate(moduleId, record, previous, fetch, payload => {
      if (currentUserRef.current?.id !== operationUserId) return;
      if (payload.commercialState) setCommercialTracking(states => ({
        ...states, [payload.commercialState.conversationId]:payload.commercialState,
      }));
      const cancelled = new Set((payload.replacedIds || []).map(String));
      // Register confirmations synchronously, before enqueuing React updates.
      // A delayed poll can otherwise enqueue its old absolute list first.
      for (const item of reminders) {
        if (cancelled.has(String(item.id))) confirmedReminderCompletions.current.set(String(item.id),
          { ...item,status:"cancelled",cancelledAt:payload.card.updatedAt });
      }
      if (payload.reminder || cancelled.size) setReminders(items => [
        ...items.filter(item => String(item.id) !== String(payload.reminder?.id)).map(item => {
          return cancelled.has(String(item.id))
            ? { ...item,status:"cancelled",cancelledAt:payload.card.updatedAt } : item;
        }),
        ...(payload.reminder ? [payload.reminder] : []),
      ]);
      if (payload.motorSynced === false || payload.reminderSynced === false) {
        const id=Date.now();
        setToasts(items=>[...items,{id,type:"message",
          msg:"Agendamento salvo no cartão. A sincronização do Motor/afazer está pendente."}]);
        setTimeout(()=>setToasts(items=>items.filter(item=>item.id!==id)),7000);
      }
    }).then(saved => {
      if (currentUserRef.current?.id === operationUserId) {
        ownActionSnapshots.current.remember(moduleId === "kanban" ? "clients"
          : moduleId === "leads" ? "leads" : "prospects", saved, previous);
      }
      return saved;
    });
  };
  const updateClient = (u) => {
    const previous = clients.find(client => client.id === u?.id);
    u = sanitizeProjectedRecord(u, previous || {});
    if (manualSaleWriteDenied({
      user:currentUserRef.current || currentUser,
      previousStage:previous?.stage,
      nextStage:u?.stage,
      saleStages:["closed", "posVenda", "nextSale"],
      creatingSale:!previous && ["closed", "posVenda", "nextSale"].includes(u?.stage),
    })) {
      window.alert(MANUAL_SALE_CUTOFF_NOTICE);
      return Promise.reject(new Error(MANUAL_SALE_CUTOFF_NOTICE));
    }
    if (u.id == null) {
      console.error('[updateClient] cliente sem id — update abortado para evitar duplicata:', u.name, u.phone);
      return;
    }
    // Limpa a flag manual "aguardando retorno" ao mover para estágio terminal,
    // evitando que a badge reapareça se o stage for revertido ou a flag não for limpa.
    const TERMINAL_CLIENT_STAGES = new Set(["semInteresse","closed","posVenda","nextSale"]);
    const toSave = TERMINAL_CLIENT_STAGES.has(u.stage)
      ? { ...u, aguardandoRetornoCliente: null }
      : u;
    if (previous && (
      Number(previous.consultantId || 0) !== Number(toSave.consultantId || 0)
      || (toSave.consultantId != null && Number(previous.storeId || 0) !== Number(toSave.storeId || 0))
    )) {
      return transferClientOwnership(previous, toSave.consultantId)
        .then(async transferred => {
          const businessPatch = Object.fromEntries(Object.entries(toSave).filter(([field, value]) => (
            !["consultantId","assignedConsultantId","consultorAtual","responsibleId","ownerId","storeId","lojaAtual",
              "ownershipGeneration","lastOwnershipTransferId","returnedToAuroraAt","ownershipHistory"].includes(field)
            && JSON.stringify(previous[field]) !== JSON.stringify(value)
          )));
          if (Object.keys(businessPatch).length) {
            await update(dbRef(`arflow_clients/${toSave.id}`), businessPatch);
          }
          const saved = { ...transferred, ...businessPatch };
          setClients(cs => cs.map(client => client.id === saved.id ? saved : client));
          return saved;
        })
        .catch(error => {
          console.error("[updateClient] transferência de cartão falhou:", error.message);
          throw error;
        });
    }
    const nonOwnershipUpdate = Object.fromEntries(Object.entries(toSave).filter(([field]) => (
      !["consultantId","assignedConsultantId","consultorAtual","responsibleId","ownerId","storeId","lojaAtual",
        "ownershipGeneration","lastOwnershipTransferId","returnedToAuroraAt","ownershipHistory"].includes(field)
    )));
    const write = update(dbRef('arflow_clients/' + toSave.id), nonOwnershipUpdate);
    write.catch(e => {
      console.error('[updateClient] Firebase erro:', e.message);
      // Só desfaz a atualização otimista se ela ainda for a última versão local.
      // Um salvamento posterior do mesmo cliente não pode ser sobrescrito.
      if (previous) setClients(cs => cs.map(c => c.id === toSave.id && c === toSave ? previous : c));
    });
    setClients(cs => cs.map(c => c.id === toSave.id ? toSave : c));
    return write.then(async () => {
      const confirmed = isDemoMode ? toSave : await confirmCard("kanban", toSave, previous || {});
      setClients(cs => cs.map(client => client.id === confirmed.id ? confirmed : client));
      return confirmed;
    });
  };
  const deleteClient = (id) => {
    remove(dbRef('arflow_clients/' + id)).catch(e => {
      console.error('[deleteClient] Firebase erro:', e.message);
      const toastId = Date.now();
      setToasts(prev => [...prev, { id:toastId, msg:`⚠️ Erro ao excluir: ${e.message}`, type:"message" }]);
      setTimeout(() => setToasts(prev => prev.filter(t=>t.id!==toastId)), 8000);
    });
    setClients(cs => cs.filter(c => c.id !== id));
  };
  const addClient = async (c) => {
    if (manualSaleWriteDenied({
      user:currentUserRef.current || currentUser,
      nextStage:c?.stage,
      saleStages:["closed", "posVenda", "nextSale"],
      creatingSale:["closed", "posVenda", "nextSale"].includes(c?.stage),
    })) {
      window.alert(MANUAL_SALE_CUTOFF_NOTICE);
      throw new Error(MANUAL_SALE_CUTOFF_NOTICE);
    }
    const visitDate = c.createdAt || new Date().toISOString().split("T")[0];
    const candidate = {
      ...c,
      storeId:Number(c.storeId || currentUserRef.current?.storeId || 0),
      phone:canonicalPhone(c.phone) || String(c.phone || "").trim(),
      id:clientIdentityKey({ ...c, createdAt:visitDate }),
      createdAt:visitDate,
    };
    const identityKey = candidate.id;
    return runIdempotentWrite(pendingClientWrites.current, identityKey, async () => {
      const { client:saved, created } = await saveClientOnce({
        candidate,
        findExisting: async () => {
          let existing = (clientsRef.current || []).find(client => sameClientIdentity(client, candidate));
          return existing || null;
        },
        write: (client) => set(dbRef('arflow_clients/' + client.id), client),
      });
      if (!created) {
        setClients(cs => cs.some(client => client.id === saved.id) ? cs : [...cs, saved]);
        const tid = Date.now();
        setToasts(prev => [...prev, { id:tid, msg:`ℹ️ Cliente já cadastrado: ${saved.name || saved.id}`, type:'message' }]);
        setTimeout(() => setToasts(prev => prev.filter(t => t.id !== tid)), 5000);
        return saved;
      }

      // Upsert local: confirmação tardia e listener nunca acrescentam a mesma chave.
      setClients(cs => {
        const index = cs.findIndex(client => client.id === saved.id);
        if (index < 0) return [...cs, saved];
        const next = [...cs]; next[index] = saved; return next;
      });
      const tid = Date.now();
      setToasts(prev => [...prev, { id:tid, msg:`✅ Cliente salvo! (${saved.name || saved.id})`, type:'message' }]);
      setTimeout(() => setToasts(prev => prev.filter(t => t.id !== tid)), 4000);
      return saved;
    }).catch(e => {
      console.error('[addClient] Firebase erro:', e.message);
      const tid = Date.now();
      setToasts(prev => [...prev, { id:tid, msg:`⚠️ ${e.message || "Erro ao salvar cliente"}`, type:'message' }]);
      setTimeout(() => setToasts(prev => prev.filter(t => t.id !== tid)), 8000);
      throw e;
    });
  };
  const saveFinancialSaleSheet = async (sourceType, source, saleData = {}, { preserveExisting = false } = {}) => {
    const today = new Date().toISOString().split("T")[0];
    const candidate = buildFinancialSaleSheet({ sourceType, source, saleData, today });
    return runIdempotentWrite(pendingFinancialSaleSheetWrites.current, candidate.id, async () => {
      let existing = findFinancialSaleSheet(clientsRef.current, sourceType, source.id, source);
      const targetId = existing?.id || candidate.id;
      const transaction = await runTransaction(dbRef(`arflow_clients/${targetId}`), (current) => {
        const currentSheet = current ? { ...current, id: targetId } : existing;
        return mergeFinancialSaleSheet(currentSheet, candidate, { preserveExisting });
      });
      if (!transaction.committed) throw new Error("Não foi possível gravar a ficha financeira vinculada.");
      const saved = { ...transaction.snapshot.val(), id: targetId };
      setClients((current) => {
        const index = current.findIndex((client) => client.id === saved.id);
        if (index < 0) return [...current, saved];
        const next = [...current];
        next[index] = saved;
        return next;
      });
      return saved;
    });
  };
  const [reminders, setRemindersState] = useState([]);
  const confirmedReminderCompletions = useRef(new Map());
  const reminderCompletionRequests = useRef(new Map());
  const [confirmedCommercialReminders, setConfirmedCommercialReminders] = useState([]);
  const [completingReminderIds, setCompletingReminderIds] = useState(() => new Set());
  const setReminders = useCallback(update => setRemindersState(previous =>
    reconcileReminderCompletions(typeof update === "function" ? update(previous) : update,
      confirmedReminderCompletions.current)), []);
  const [realSales, setRealSales]  = useState({});
  const [historico, setHistorico]  = useState([]);
  const [prospeccao, setProspeccao] = useState([]);
  const [auroraLeads,   setAuroraLeads]   = useState([]);
  const [commercialTracking, setCommercialTracking] = useState({});
  const [leadMessages,  setLeadMessages]  = useState({});
  const [leadEvents,    setLeadEvents]    = useState({});
  const [prospMensagens,setProspMensagens]= useState({});
  const [whatsappMsgs,  setWhatsappMsgs]  = useState({});
  const ownTreatmentEvidence=useRef({});
  useEffect(()=>{
    const onTreatment=event=>{
      const {storeId,phone,messageId,message}=event.detail||{};
      const key=conversationKey(storeId,phone);
      if(!key||!messageId||!message)return;
      ownTreatmentEvidence.current[key]={messageId,message};
      setWhatsappMsgs(previous=>{
        const latest=previous.__latestEvidence?.[key]||previous[key]||{};
        const newer=Object.values(latest).some(item=>conversationActionTimestamp(item)>conversationActionTimestamp(message));
        return {...previous,[key]:{...(previous[key]||{}),[messageId]:message},
          __latestEvidence:{...previous.__latestEvidence,...(!newer?{[key]:{[messageId]:message}}:{})}};
      });
    };
    window.addEventListener("arflow:conversation-treatment",onTreatment);
    return ()=>window.removeEventListener("arflow:conversation-treatment",onTreatment);
  },[]);
  const [waReadAt,      setWaReadAt]      = useState({});
  const [toasts,        setToasts]        = useState([]);
  const [tab, setTabRaw]      = useState("dashboard");
  const [liftSales, setLiftSales] = useState([]);
  const [liftError, setLiftError] = useState("");
  const [scopedLiftSales, setScopedLiftSales] = useState([]);
  const [scopedLiftError, setScopedLiftError] = useState("");
  const [scopedLiftLoaded, setScopedLiftLoaded] = useState(false);
  const [scopedDataLoadState, setScopedDataLoadState] = useState(null);
  const scopedDataPollingRef = useRef(null);
  const [postSales, setPostSales] = useState([]);
  const [postError, setPostError] = useState("");
  const [postRefreshToken, setPostRefreshToken] = useState(0);
  const seenPostProblems = useRef(new Set());
  useEffect(() => {
    if (currentUser?.role !== "manager") return;
    postSales.filter(s => Number(s.storeId) === Number(currentUser.storeId)
      && s.posVenda?.resultado === "problema"
      && Date.now() - Date.parse(s.posVenda.feitoEm || "") < 3600000).forEach(s => {
      const id = `lift-problem-${s.storeId}-${s.liftPedidoId}-${s.posVenda.feitoEm}`;
      if (seenPostProblems.current.has(id)) return;
      seenPostProblems.current.add(id);
      setToasts(previous => [...previous, {
        id, type:"message",
        msg:`⚠️ Cliente com problema no pós-venda: ${s.cliente?.nome || "cliente"} (pedido #${s.liftPedidoId}). Veja a Central Operacional.`,
      }]);
      setTimeout(() => setToasts(previous => previous.filter(toast => toast.id !== id)), 12000);
    });
  }, [postSales, currentUser?.role, currentUser?.storeId]);
  useEffect(() => {
    if (loggedInUserId == null || loggedInUserIsDemo || awaitingAdminStore || currentUser?.role === "deposito") {
      setPostSales([]); setPostError("");
      return undefined;
    }
    let cancelled = false;
    const refresh = async () => {
      try {
        const suffix = isGeneralAdminView(currentUser, isDemoMode) ? `?storeIds=${scopedReadKey}` : "";
        const response = await fetch(`/api/lift/pos-venda${suffix}`, { credentials:"same-origin", cache:"no-store" });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || `HTTP ${response.status}`);
        if (!cancelled) { setPostSales(payload.sales || []); setPostError(""); }
      } catch (error) {
        if (!cancelled) { setPostSales([]); setPostError(error.message); }
      }
    };
    const stopPolling = watchVisiblePolling(refresh);
    return () => { cancelled = true; stopPolling(); };
  }, [loggedInUserId, loggedInUserIsDemo, currentUser?.role, tab, postRefreshToken, scopedReadKey, awaitingAdminStore]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (loggedInUserId == null || loggedInUserIsDemo || awaitingAdminStore || currentUser?.role === "deposito") {
      setLiftSales([]); setLiftError("");
      return undefined;
    }
    let cancelled = false;
    const refresh = async () => {
      try {
        const suffix = isGeneralAdminView(currentUser, isDemoMode) ? `?storeIds=${scopedReadKey}` : "";
        const response = await fetch(`/api/lift/pendencias${suffix}`, { credentials:"same-origin", cache:"no-store" });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || `HTTP ${response.status}`);
        if (!cancelled) { setLiftSales(payload.sales || []); setLiftError(""); }
      } catch (error) {
        if (!cancelled) { setLiftSales([]); setLiftError(error.message); }
      }
    };
    const stopPolling = watchVisiblePolling(refresh);
    return () => { cancelled = true; stopPolling(); };
  }, [loggedInUserId, loggedInUserIsDemo, currentUser?.role, scopedReadKey, awaitingAdminStore]); // eslint-disable-line react-hooks/exhaustive-deps
  const refreshLiftSales = useCallback(async () => {
    if (loggedInUserId == null || loggedInUserIsDemo || awaitingAdminStore || currentUser?.role === "deposito") {
      throw new Error("Atualização de vendas LIFT indisponível neste modo.");
    }
    const suffix = isGeneralAdminView(currentUser, isDemoMode) ? `?storeIds=${scopedReadKey}` : "";
    const response = await fetch(`/api/lift/pendencias${suffix}`, { credentials:"same-origin", cache:"no-store" });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || `HTTP ${response.status}`);
    setLiftSales(payload.sales || []);
    setLiftError("");
    return payload.sales || [];
  }, [loggedInUserId, loggedInUserIsDemo, currentUser, isDemoMode, scopedReadKey, awaitingAdminStore]);
  const onLiftSaved = useCallback(sale => {
    if (!sale?.storeId || !sale?.liftPedidoId) return;
    setLiftSales(previous => {
      const next = previous.filter(item => !(Number(item.storeId) === Number(sale.storeId)
        && String(item.liftPedidoId) === String(sale.liftPedidoId)));
      return [...next, sale];
    });
    setScopedLiftSales(previous => {
      const index = previous.findIndex(item => Number(item.storeId) === Number(sale.storeId)
        && String(item.liftPedidoId) === String(sale.liftPedidoId));
      // Preserve this feed's authorized membership and any redacted projection.
      if (index < 0 || previous[index].crossStore) return previous;
      return previous.map((item, itemIndex) => itemIndex === index ? sale : item);
    });
  }, []);
  const setTab = useCallback((nextTab) => {
    return activeConversationExitGuard.requestAction(() => {
      setTabRaw(current => current === nextTab ? current : nextTab);
    });
  }, []);
  const [nuConversaPendente, setNuConversaPendente] = useState(null);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (currentUserRole === "deposito") {
      if (params.get("module") === "deposito" && loggedInUser?.role === "deposito") {
        sendPushTelemetry("open", params.get("eventId"));
        window.history.replaceState({}, "", window.location.pathname);
      }
      return undefined;
    }
    if (params.get("module") === "central" && !isDemoMode) {
      if (setTab("central")) {
        sendPushTelemetry("open", params.get("eventId"));
        window.history.replaceState({}, "", window.location.pathname);
      }
      return undefined;
    }
    const phone = normalizePhone(params.get("phone") || "");
    const moduleId = ["inbox", "leads", "kanban", "prospeccao"].includes(params.get("module")) ? params.get("module") : "inbox";
    const storeId = Number(params.get("storeId") || currentUserStoreId);
    if (phone && storeId) {
      if (!isDemoMode && isNewUiEnabled()) {
        setNuConversaPendente({ storeId, phone });
      } else {
        setAutoOpenTarget(conversationTarget(moduleId, storeId, phone));
        setTab(moduleId);
      }
      sendPushTelemetry("open", params.get("eventId"));
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, [currentUserStoreId, currentUserRole, loggedInUser?.role, isDemoMode, setTab]);
  const canDiscardActiveConversation = useCallback(() => {
    if (activeConversationExitGuard.canExit()) return true;
    alert(FUTURE_FOLLOW_UP_REQUIRED_MESSAGE);
    return false;
  }, []);
  const setCurrentUserGuarded = useCallback((user) => {
    if (!canViewAsDeposito(loggedInUser, user)) return false;
    return activeConversationExitGuard.requestAction(() => {
      setCurrentUser(user);
      setTabRaw("dashboard");
      setMenuOpen(false);
    });
  }, [loggedInUser]);
  useEffect(() => {
    const onBeforeUnload = event => {
      if (activeConversationExitGuard.canExit()) return;
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, []);
  const [menuOpen, setMenuOpen]   = useState(false);
  const [expandedStore, setExpandedStore] = useState(null);
  const [autoOpenTarget, setAutoOpenTarget] = useState(null); // { moduleId, phone } — cliente pra abrir automaticamente ao navegar
  const [searchOpenedCard, setSearchOpenedCard] = useState(null);
  const openSearchResult = async result => {
    if (result.legacy) return;
    if (!canDiscardActiveConversation()) throw new Error(FUTURE_FOLLOW_UP_REQUIRED_MESSAGE);
    const identity = currentUserRef.current;
    const query = new URLSearchParams({
      moduleId:result.module, sourceId:result.sourceId, storeId:String(result.storeId),
    });
    const response = await fetch(`/api/crm/contact-search/card?${query}`, {
      credentials:"same-origin", cache:"no-store",
    });
    const payload = await response.json();
    if (!response.ok || !payload.ok) throw new Error(payload.error || "Não foi possível abrir este cartão.");
    if (currentUserRef.current !== identity) throw new Error("A visão mudou. Faça a busca novamente.");
    if (!activeConversationExitGuard.requestAction(() => {
      const setter = payload.moduleId === "leads" ? setAuroraLeads
        : payload.moduleId === "kanban" ? setClients : setProspeccao;
      if (readScopeRef.current.stores.includes(Number(payload.storeId))) {
        setter(previous => [...previous.filter(record => String(record.id) !== String(payload.record.id)
          && !(payload.moduleId === "leads" && record._rawPhone === payload.record._rawPhone)), payload.record]);
      }
      setSearchOpenedCard({ ...payload, identity });
      setAutoOpenTarget(payload.target);
      setTabRaw(payload.moduleId);
    })) throw new Error(FUTURE_FOLLOW_UP_REQUIRED_MESSAGE);
  };
  const openReminderCard = async reminder => {
    if (isDemoMode) {
      const linked = resolveReminderCard(reminder, { clients, leads:auroraLeads, prospeccao, currentUser });
      if (!linked) throw Object.assign(new Error("Cartão não encontrado: remover da lista"), { missingCard:true });
      setAutoOpenTarget(linked.target); setTab(linked.moduleId);
      return;
    }
    const query = new URLSearchParams();
    ["clientId","leadId","prospId"].forEach(key => { if (reminder[key]) query.set(key, reminder[key]); });
    const response = await fetch(`/api/crm/reminders/${encodeURIComponent(reminder.id)}/card?${query}`, {
      credentials:"same-origin", cache:"no-store",
    });
    const payload = await response.json();
    if (!response.ok || !payload.ok) throw Object.assign(
      new Error(payload.error || "Não foi possível abrir este cartão."), { missingCard:payload.missingCard === true });
    activeConversationExitGuard.requestAction(() => {
      const owner = operationalUserList.find(user => Number(user.id) === Number(payload.consultantId));
      if (owner && Number(currentUser.id) !== Number(owner.id)
        && ["admin","manager","superadmin"].includes(loggedInUser?.role) && !setCurrentUserGuarded(owner)) return;
      const setter = payload.moduleId === "leads" ? setAuroraLeads
        : payload.moduleId === "kanban" ? setClients : setProspeccao;
      setter(previous => [...previous.filter(record => String(record.id) !== String(payload.record.id)), payload.record]);
      setAutoOpenTarget(payload.target);
      setTabRaw(payload.moduleId);
    });
  };
  const [liftClientRegistrationRevision, setLiftClientRegistrationRevision] = useState(0);
  const { registration:liftClientRegistration, requestRegistration:requestLiftClientRegistration,
    cancelRegistration:cancelLiftClientRegistration, saveRegistration:saveLiftClientRegistration } = useLiftClientRegistration({
    identity:`${loggedInUserId}:${currentUserId}`,
    canOpen:() => !isDemoMode && !["deposito", "marketing"].includes(loggedInUser?.role)
      && currentUserRole !== "deposito" && canDiscardActiveConversation(),
    onCreated:(client, metadata = {}) => {
      if (metadata.sale) onLiftSaved(metadata.sale);
      setLiftClientRegistrationRevision(previous => previous + 1);
      if (!isLiftRegisteredClientCard(client)) return;
      setClients(previous => [...previous.filter(item => String(item.id) !== String(client.id)), client]);
      setTabRaw("kanban");
      setAutoOpenTarget({ ...conversationTarget("kanban", client.storeId, client.phone), recordId:client.id, storeId:client.storeId });
    },
  });
  const conversationHistoryLoaderRef = useRef(null);
  const {
    activeConversation:activePushConversation,
    reportConversation:handleConversationActive,
  } = useActiveConversationPresence({ tab, historyLoaderRef:conversationHistoryLoaderRef });
  const activeConversationRef = useRef(null);
  const inAppNotificationDedupeRef = useRef(new Map());
  const showInAppNotification = useCallback(({ key, phone, storeId, consultantId, message, type="message", duration=5000 }) => {
    const user = currentUserRef.current;
    const normalized = normalizePhone(phone);
    if (!user || !normalized) return false;
    if (user.role === "consultant" && Number(consultantId) !== Number(user.id)) return false;
    if (user.storeId && storeId != null && Number(storeId) !== Number(user.storeId)) return false;
    const now = Date.now();
    const cache = inAppNotificationDedupeRef.current;
    for (const [entryKey, expires] of cache) if (expires <= now) cache.delete(entryKey);
    const stableKey = String(key || `${storeId || "store"}:${consultantId || "consultant"}:${normalized}:${now}`);
    if (cache.has(stableKey)) return false;
    cache.set(stableKey, now + 5 * 60 * 1000);
    while (cache.size > 500) cache.delete(cache.keys().next().value);
    const active = activeConversationRef.current;
    if (active && conversationKey(active.storeId, active.phone) === conversationKey(storeId, normalized)) return false;
    playNotificationSound(type);
    const toastId = now + Math.random();
    setToasts(previous => [...previous, { id:toastId, msg:message, type }]);
    setTimeout(() => setToasts(previous => previous.filter(toast => toast.id !== toastId)), duration);
    return true;
  }, []);
  useEffect(() => {
    activeConversationRef.current = activePushConversation;
  }, [activePushConversation]);
  useEffect(() => {
    if (!activePushConversation?.storeId || !activePushConversation?.phone || isDemoMode) return undefined;
    return watchVisiblePolling(() =>
      conversationHistoryLoaderRef.current?.({ ...activePushConversation, tailOnly:true }), 5000);
  }, [activePushConversation, isDemoMode]);
  const [vendaModalTarget, setVendaModalTarget] = useState(null); // { moduleId, phone, name, storeId, consultantId, contactType? } — abre o modal Registrar Venda
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const n = new Date();
    // No dia 1º do mês, abre no mês anterior onde estão as vendas
    const d = n.getDate() === 1
      ? new Date(n.getFullYear(), n.getMonth() - 1, 1)
      : n;
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`;
  });
  const [portfolioThresholds, setPortfolioThresholds] = useState(DEFAULT_PORTFOLIO_THRESHOLDS);

  // Presence is deliberately per-tab (the helper keeps a session tab id), so a
  // closing CRM tab cannot erase a conversation being viewed in another tab.
  usePushPresenceHeartbeat({
    conversation:activePushConversation, userId:currentUserId,
    userStoreId:currentUserStoreId, userRole:currentUserRole,
    isDemoMode, sendPresence:setPushPresence,
  });

  const remoteSales     = useRef(false);
  const remoteHistorico = useRef(false);
  const auroraLeadsRef  = useRef([]);
  const prospeccaoRef   = useRef([]);
  const clientsRef      = useRef([]);
  const currentUserRef  = useRef(currentUser);
  prospeccaoRef.current = prospeccao;
  const conversationHistoryLoadsRef = useRef(new Map());
  const conversationHistoryReadStatesRef = useRef(new Map());
  const activeTabRef = useRef(tab);
  const refreshConversationSummariesRef = useRef(null);
  const migratingLeads  = useRef(new Set()); // guard: phones currently being migrated
  const updatingEstagio = useRef(new Set()); // guard: phones with estagio being updated to "chegou"
  useEffect(() => {
    activeTabRef.current = tab;
    if (tab !== "dashboard") refreshConversationSummariesRef.current?.();
  }, [tab]);

  // Leads transferidos entre lojas mantêm o histórico no canal canônico de
  // origem. Atualiza somente a última mensagem desses cards pelo endpoint
  // autenticado do lead; nunca copia ou regrava o histórico em outra loja.
  useEffect(() => {
    if (!currentUser || currentUser.role === "deposito" || isDemoMode) return undefined;
    let cancelled = false;
    let inFlight = false;
    const refreshTransferredLeadSummaries = async () => {
      if (inFlight) return;
      if (activeTabRef.current === "dashboard") return;
      const visibleTransferred = auroraLeads.filter(lead => {
        const responsibleStoreId = Number(lead.storeId || lead.lojaAtual);
        const channelStoreId = Number(lead.whatsappStoreId ?? lead.lojaOrigem ?? responsibleStoreId);
        if (!responsibleStoreId || !channelStoreId || responsibleStoreId === channelStoreId) return false;
        if (currentUser.role === "consultant") return resolveLeadConsultantId(lead) === Number(currentUser.id);
        return currentUser.storeId == null || leadBelongsToStore(lead, currentUser.storeId);
      });
      if (!visibleTransferred.length) return;
      inFlight = true;
      try {
        const response = await fetch(`/api/crm/lead-conversation-summaries?readMode=${["admin","superadmin","manager"].includes(currentUserRef.current?.role)?"activity-v1":"memory-v1"}`, {
          method:"POST",
          credentials:"same-origin",
          cache:"no-store",
          headers:{ "Content-Type":"application/json", Accept:"application/json" },
          body:JSON.stringify({ leads:visibleTransferred.map(lead => ({
            storeId:Number(lead.storeId || lead.lojaAtual),
            phone:normalizePhone(lead.telefone),
          })) }),
        });
        if (!response.ok) return;
        const payload = await response.json();
        const scoped = scopedConversationCache(payload, payload.conversations?.map(item => item.storeId) || []);
        if (!cancelled) {
          setWhatsappMsgs(previous => {
            const next = { ...(previous || {}) };
            Object.entries(scoped).forEach(([key, messages]) => {
              next[key] = mergeConversationMessages(previous?.[key], messages);
            });
            return next;
          });
        }
      } catch (error) {
        console.warn("[CRM] atualização dos cards transferidos falhou:", error.message);
      } finally {
        inFlight = false;
      }
    };
    const stopPolling = watchVisiblePolling(refreshTransferredLeadSummaries, 5000);
    return () => { cancelled = true; stopPolling(); };
  }, [auroraLeads, currentUser, isDemoMode]);

  useEffect(() => {
    if (!currentUser) return undefined;
    if (awaitingAdminStore) return undefined;
    if (currentUser.role === "deposito") {
      setScopedDataLoadState(null);
      setLoading(false);
      setClients([]);
      setReminders([]);
      setRealSales({});
      setHistorico([]);
      setProspeccao([]);
      setAuroraLeads([]);
      setCommercialTracking({});
      setLeadMessages({});
      setLeadEvents({});
      setProspMensagens({});
      setWhatsappMsgs({});
      setScopedLiftSales([]);
      setScopedLiftError("");
      setScopedLiftLoaded(false);
      setPostSales([]);
      setPostError("");
      setLiftSales([]);
      setLiftError("");
      return undefined;
    }
    const nowKey = `${new Date().getFullYear()}_${new Date().getMonth()}`;
    let loadedCount = 0;
    const tryFinish = () => { loadedCount++; if (loadedCount >= 5) setLoading(false); };
    // Segurança: se em 12s algum listener não respondeu, libera o loading mesmo assim
    const loadingTimeout = setTimeout(() => {
      if (loadedCount < 5) {
        console.warn('[CRM] timeout de loading — liberando tela após 12s (loadedCount=' + loadedCount + ')');
        setLoading(false);
      }
    }, 12000);
    const scopedReal = !isDemoMode;
    const requestedScopedStores = scopedReadStores;
    let scopedDataCancelled = false;
    const scopeForThisLoad = getProspectScope();
    if (scopedReal) {
      setScopedLiftSales([]);
      setScopedLiftError("");
      setScopedLiftLoaded(false);
      setScopedDataLoadState(null);
    }
    const loadScopedData = async signal => {
      const snapshotRead = ownActionSnapshots.current.startRead();
      const requestScope = scopeForThisLoad;
      const requestRevision = prospectScopeRevisionRef.current.get(requestScope) || 0;
      const requestPending = prospectScopePendingRef.current.get(requestScope) || 0;
      const payload = await fetchScopedData({ storeIds:requestedScopedStores,signal });
      if (scopedDataCancelled) return;
      const nextClients = (payload.clients || []).map(client => ({ ...client }));
      clientsLoadedRef.current = true;
      setClients(ownActionSnapshots.current.reconcile("clients",nextClients,snapshotRead));
      setAuroraLeads(ownActionSnapshots.current.reconcile("leads",
        (payload.leads || []).map(lead => ({ ...lead })),snapshotRead));
      const revisionNow = prospectScopeRevisionRef.current.get(requestScope) || 0;
      const pendingNow = prospectScopePendingRef.current.get(requestScope) || 0;
      if (prospectLiveScopeRef.current === requestScope
        && requestRevision === revisionNow
        && requestPending === 0
        && pendingNow === 0) {
        const scopedProspects = ownActionSnapshots.current.reconcile("prospects",
          (payload.prospects || []).map(prospect => ({ ...prospect })),snapshotRead);
        prospeccaoRef.current = scopedProspects;
        setProspeccao(scopedProspects);
      }
      setCommercialTracking(previous => reconcileCommercialTrackingSnapshot(previous,payload.commercialTracking || {}));
      setScopedLiftSales(payload.liftSales);
      setScopedLiftError("");
      setScopedLiftLoaded(true);
      tryFinish();
      tryFinish();
    };
    const scopedPolling = scopedReal ? watchScopedDataPolling(loadScopedData, {
      onState: state => {
        if (scopedDataCancelled) return;
        setScopedDataLoadState(state);
        if (state.error) {
          console.error("[CRM] atualização escopada falhou:", state.error);
          setScopedLiftLoaded(true);
          tryFinish();
        }
      },
    }) : null;
    scopedDataPollingRef.current = scopedPolling;
    if (!scopedReal) {
      setScopedDataLoadState(null);
      setScopedLiftSales([]);
      setScopedLiftError("");
      setScopedLiftLoaded(true);
    }

    const unsubClients = scopedReal ? () => {} : onValue(dbRef('arflow_clients'), snap => {
      if (!snap.exists()) { clientsLoadedRef.current = true; setClients([]); tryFinish(); return; }
      const data = snap.val();
      // Injeta o Firebase key como `id` quando o campo estiver ausente no valor armazenado.
      // Clientes antigos (criados antes da padronização de IDs) ficam sem `id` no objeto,
      // fazendo updateClient escrever em arflow_clients/undefined → cria duplicata.
      // Sempre usa a chave Firebase `k` como id canônico do cliente.
      // Clientes migrados de leads tinham `v.id` como número (≠ k string), causando
      // updateClient/deleteClient a escreverem no path ERRADO → duplicata + delete sem efeito.
      const arr = normalizeClientSnapshot(data);
      clientsLoadedRef.current = true;
      setClients(arr);
      tryFinish();
    }, (err) => { console.error('[CRM] arflow_clients erro:', err.message); tryFinish(); });

    const unsubSales = onValue(dbRef('arflow_data'), snap => {
      const data = snap.exists() ? snap.val() : {};
      const mData = data.month || {};
      const sData = data.sales || {};
      const monthChanged = mData.key && mData.key !== nowKey;
      if (monthChanged) {
        const zeros = Object.fromEntries(Object.keys(REAL_SALES).map(k => [k, 0]));
        remoteSales.current = true;
        setRealSales(zeros);
        fbSet('arflow_data/sales', zeros);
        fbSet('arflow_data/month', { key: nowKey });
      } else {
        const sales = (sData && Object.keys(sData).length > 0) ? sData : { ...REAL_SALES };
        remoteSales.current = true;
        setRealSales(sales);
        if (!mData.key) fbSet('arflow_data/month', { key: nowKey });
        if (!(sData && Object.keys(sData).length > 0)) fbSet('arflow_data/sales', REAL_SALES);
      }
      tryFinish();
    }, (err) => { console.error('[CRM] arflow_data erro:', err.message); tryFinish(); });

    const unsubHistorico = onValue(dbRef('arflow_historico'), snap => {
      remoteHistorico.current = true;
      setHistorico(snap.exists() ? snap.val() : []);
      tryFinish();
    }, (err) => { console.error('[CRM] arflow_historico erro:', err.message); tryFinish(); });

    const unsubPortfolioThresholds = onValue(dbRef('arflow_settings/portfolioThresholds'), snap => {
      if (snap.exists()) setPortfolioThresholds({ ...DEFAULT_PORTFOLIO_THRESHOLDS, ...snap.val() });
    }, (err) => { console.error('[CRM] arflow_settings erro:', err.message); });

    const unsubProsp = scopedReal ? () => {} : onValue(dbRef('arflow_prospeccao'), snap => {
      const data = snap.exists() ? snap.val() : [];
      const entries = Array.isArray(data) ? Object.entries(data) : Object.entries(data || {});
      const items = entries.filter(([, record]) => record && typeof record === "object")
        .map(([firebaseKey, record]) => ({ ...record, _firebaseKey:record._firebaseKey || firebaseKey }));
      prospeccaoRef.current = items;
      setProspeccao(items);
      tryFinish();
    }, (err) => { console.error('[CRM] arflow_prospeccao erro:', err.message); tryFinish(); });

    let remindersCancelled = false;
    const loadReminders = async () => {
      try {
        if (isDemoMode) {
          if (!remindersCancelled) setReminders([]);
        } else {
          const response = await fetch(`/api/crm/reminders?storeIds=${requestedScopedStores.join(",")}`, {
            credentials:'same-origin', cache:'no-store', headers:{ Accept:'application/json' },
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const payload = await response.json();
          if (!remindersCancelled) setReminders(remindersWithAccounting(payload));
        }
      } catch (err) {
        console.error('[CRM] afazeres erro:', err.message);
        if (!remindersCancelled) setReminders([]);
      } finally {
        if (!remindersCancelled) tryFinish();
      }
    };
    loadReminders();

    return () => {
      scopedDataCancelled = true;
      scopedPolling?.stop();
      if (scopedDataPollingRef.current === scopedPolling) scopedDataPollingRef.current = null;
      clearTimeout(loadingTimeout);
      remindersCancelled = true;
      unsubClients(); unsubSales(); unsubHistorico(); unsubProsp();
      unsubPortfolioThresholds();
    };
  }, [currentUser?.id, currentUser?.role, currentUser?.storeId, loggedInUser?.id, loggedInUser?.role, isDemoMode, scopedReadKey, awaitingAdminStore]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!isDemoMode) return undefined;
    const unsubCommercialTracking = onValue(dbRef('arflow_commercial_tracking'), snap => {
      // Keep the Firebase snapshot raw here; the memoized adapter below is the
      // single normalization boundary and therefore also handles demo swaps.
      setCommercialTracking(previous => reconcileCommercialTrackingSnapshot(previous,snap.exists() ? snap.val() : {}));
    }, (err) => { console.error('[CRM] arflow_commercial_tracking erro:', err.message); });
    return () => {
      unsubCommercialTracking();
      setCommercialTracking({});
    };
  }, [isDemoMode, currentUser?.role]); // eslint-disable-line react-hooks/exhaustive-deps

  const commercialTrackingIndex = useMemo(
    () => normalizeCommercialTrackingSnapshot(
      commercialTracking,
      (isDemoMode ? DEMO_STORES : STORES).map(store => store.id),
    ),
    [commercialTracking, isDemoMode],
  );
  const projectedClients = useMemo(
    () => projectClients(clients, commercialTrackingIndex).map(record=>projectConfirmedLiftCard("kanban",record,liftSales)),
    [clients, commercialTrackingIndex, liftSales],
  );
  const projectedLeads = useMemo(
    () => projectLeads(auroraLeads, commercialTrackingIndex)
      .map(record=>projectConfirmedFinancialLead(projectConfirmedLiftCard("leads",record,liftSales),clients)),
    [auroraLeads, commercialTrackingIndex, liftSales, clients],
  );
  const projectedProspeccao = useMemo(
    () => projectProspects(prospeccao, commercialTrackingIndex).map(record=>projectConfirmedLiftCard("prospeccao",record,liftSales)),
    [prospeccao, commercialTrackingIndex, liftSales],
  );
  // Keep only the explicitly opened card available in its view. Periodic scoped
  // refreshes must not close a searched card from another authorized store.
  // An out-of-scope search record never enters dashboards or metric totals.
  const searchCardRecords = useMemo(() => {
    const groups = { leads:projectedLeads, kanban:projectedClients, prospeccao:projectedProspeccao };
    if (!searchOpenedCard || searchOpenedCard.identity !== currentUser) return groups;
    const { moduleId, record } = searchOpenedCard;
    const sameCard = item => {
      if (moduleId === "leads" && item._rawPhone) return item._rawPhone === record._rawPhone;
      if (moduleId === "prospeccao" && item._firebaseKey) return item._firebaseKey === record._firebaseKey;
      return String(item.id) === String(record.id)
        && Number(item.lojaAtual ?? item.storeId) === Number(record.lojaAtual ?? record.storeId);
    };
    const existing = groups[moduleId].find(sameCard);
    return { ...groups, [moduleId]:[
      ...groups[moduleId].filter(item => !sameCard(item)),
      existing ? { ...record, ...existing, id:record.id } : record,
    ] };
  }, [searchOpenedCard, currentUser, projectedLeads, projectedClients, projectedProspeccao]);
  // Nova interface (Etapa 6): cada conversa abre na aba da sua origem mais antiga.
  // Sem um registro no CRM, a Central permanece como rede de segurança.
  const nuAbrirConversa = useCallback((phone, storeId, { fallbackTab } = {}) => {
    const sid = Number(storeId || currentUserStoreId);
    const origem = conversaDaOrigem({
      storeId:sid,
      phone,
      leads:projectedLeads,
      clients:projectedClients,
      prospeccao:projectedProspeccao,
      leadBelongsToStore,
    });
    const navigation = resolveConversationNavigation(origem, fallbackTab);
    if (!navigation.openConversationTarget) {
      if (!setTab(navigation.tab)) return false;
      setAutoOpenTarget(null);
      return true;
    }
    const aba = navigation.tab;
    if (!sid || !setTab(aba)) return false;
    const targetStoreId = origem?.storeId || sid;
    const targetPhone = origem?.phone || normalizePhone(phone);
    const target = conversationTarget(aba, targetStoreId, targetPhone);
    const resolvedLeadId = origem?.moduleId === "leads" && origem.recordId != null
      ? String(origem.recordId)
      : null;
    setAutoOpenTarget(target && resolvedLeadId
      ? { ...target, recordId:resolvedLeadId, channelStoreId:origem.channelStoreId }
      : target);
    return true;
  }, [projectedLeads, projectedClients, projectedProspeccao, currentUserStoreId, setTab]);
  const nuAbrirVendasConversa = useCallback((route) => {
    if (!route) return false;
    if (route.fallback === true && !route.moduleId) {
      if (["consultant", "manager"].includes(currentUser.role)
        && Number(route.storeId) !== Number(currentUser.storeId)) return false;
      return nuAbrirConversa(route.phone, route.storeId || currentUserStoreId);
    }
    const resolved = resolveVendasConversation(route, {
      clients:projectedClients,
      leads:projectedLeads,
      prospeccao:projectedProspeccao,
      currentUser,
      resolveLeadConsultantId,
    });
    if (!resolved) return false;
    const { route:routeToOpen, record } = resolved;
    if (!record) return false;
    const storeId = Number(routeToOpen.storeId);
    const phone = routeToOpen.moduleId === "leads"
      ? record.telefone || record.phone
      : record.phone || record.telefone;
    const target = conversationTarget(routeToOpen.moduleId, storeId, phone);
    if (!target || !setTab(routeToOpen.moduleId)) return false;
    setAutoOpenTarget({
      ...target,
      recordId:String(record.id),
      ...(routeToOpen.moduleId === "leads"
        ? { channelStoreId:Number(record.whatsappStoreId ?? record.lojaOrigem ?? record.storeId) || storeId }
        : {}),
    });
    return true;
  }, [projectedClients, projectedLeads, projectedProspeccao, currentUser, currentUserStoreId, nuAbrirConversa, setTab]);
  const abrirOrigemLift = useCallback((sourceLink) => {
    const route = liftCrmSourceRoute(sourceLink, {
      clients:projectedClients, leads:projectedLeads, prospeccao:projectedProspeccao,
      currentUser, resolveLeadConsultantId,
    });
    if (!route) {
      alert("Não foi possível abrir o cadastro vinculado. Atualize os dados ou confira sua permissão.");
      return false;
    }
    if (route.moduleId !== "indicacoes") return nuAbrirVendasConversa(route);
    const target = conversationTarget("indicacoes", route.storeId, route.phone);
    if (!target || !setTab("indicacoes")) return false;
    setAutoOpenTarget({ ...target, recordId:route.recordId, key:route.key });
    return true;
  }, [projectedClients, projectedLeads, projectedProspeccao, currentUser, nuAbrirVendasConversa, setTab]);
  useEffect(() => {
    if (!nuConversaPendente) return undefined;
    if (currentUserRole === "deposito") { setNuConversaPendente(null); return undefined; }
    if (!loading) {
      const { storeId, phone } = nuConversaPendente;
      setNuConversaPendente(null);
      nuAbrirConversa(phone, storeId);
      return undefined;
    }
    // Notificação recebida antes do carregamento: espera até 8s e usa a Central
    // se os registros ainda não estiverem disponíveis.
    const timer = setTimeout(() => {
      const { storeId, phone } = nuConversaPendente;
      setNuConversaPendente(null);
      setAutoOpenTarget(conversationTarget("inbox", storeId, phone));
      setTab("inbox");
    }, 8000);
    return () => clearTimeout(timer);
  }, [nuConversaPendente, loading, nuAbrirConversa, setTab, currentUserRole]);
  const displayReminders = useMemo(
    () => {
      const merged = mergeVirtualCommercialReminders(
      reminders,
      commercialTrackingIndex,
      [...clients.map(record => ({ ...record, _reminderField:"clientId" })),
        ...auroraLeads.map(record => ({ ...record, _reminderField:"leadId" })),
        ...prospeccao.map(record => ({ ...record, _reminderField:"prospId" }))],
      );
      const completedIds = new Set(confirmedCommercialReminders.map(reminder => String(reminder.id)));
      return reconcileReminderCompletions(
        [...merged.filter(reminder => !completedIds.has(String(reminder.id))), ...confirmedCommercialReminders],
        confirmedReminderCompletions.current)
        .filter(reminder => !completingReminderIds.has(String(reminder.id)));
    },
    [reminders, commercialTrackingIndex, clients, auroraLeads, prospeccao, confirmedCommercialReminders, completingReminderIds],
  );

  const prevLeadsRef     = useRef(null);

  useEffect(() => {
    if (!isDemoMode) return undefined;
    const applyLeadSnapshot = (raw) => {
      if (!raw || typeof raw !== "object") { setAuroraLeads([]); return; }

      // Mantém a mesma equivalência de telefone, mas evita percorrer todos os
      // clientes novamente para cada lead durante a carga inicial.
      const activeClientPhoneKeys = new Set();
      (clients || []).forEach(client => {
        if (client?.financeOnly) return;
        const phone = normalizePhone(client?.phone);
        if (!phone) return;
        activeClientPhoneKeys.add(phone);
        activeClientPhoneKeys.add(phone.length === 11 ? phone.slice(0, 2) + phone.slice(3) : phone);
      });

      // ── 0) Backfill idempotente da consultora em leads legados ──────────
      // O nome humano é a fonte mais recente da atribuição. Só preenche quando
      // não há consultantId gravado — nunca substitui uma atribuição explícita.
      // Nomes antigos sem consultantId são anomalias para auditoria. Nunca
      // normalizar ownership silenciosamente durante a leitura da tela.

      // ── 1) Auto-migração: em_atendimento_loja → arflow_clients ──────
      // Só acontece quando o cliente foi fisicamente à loja.
      Object.entries(raw).forEach(([phone, v]) => {
        if (typeof v !== 'object' || v === null) return;
        if (v._crm_migrated) return;
        const rawStatus = v._crm_estagio || v.estagio || v.status || v.stage || "";
        if (rawStatus !== "em_atendimento_loja") return;

        let storeId = v.storeId != null ? Number(v.storeId) : null;
        let consultantId = v.consultantId != null ? Number(v.consultantId) : null;
        if (!consultantId && v.responsavel && v.responsavel !== "aurora" && v.responsavel !== "consultor") {
          const resp = v.responsavel.toLowerCase();
          const found = USERS.find(u =>
            u.role === "consultant" &&
            (storeId ? u.storeId === storeId : true) &&
            u.name.split(" ")[0].toLowerCase() === resp
          ) || USERS.find(u => u.role === "consultant" && u.name.split(" ")[0].toLowerCase() === resp);
          consultantId = found?.id ?? null;
        }
        // Fallback: se o lead não trouxe storeId (comum quando o webhook não envia esse
        // campo), deriva a loja a partir do consultor já identificado, ou do nome da loja
        // (v.loja), antes de deixar o cliente "órfão" sem loja — o que o tornava invisível
        // em qualquer tela filtrada por loja (Atendimento Presencial, dashboards, etc).
        if (storeId == null && consultantId != null) {
          storeId = USERS.find(u => u.id === consultantId)?.storeId ?? null;
        }
        if (storeId == null && v.loja) {
          const lojaNorm = String(v.loja).toLowerCase();
          storeId = STORES.find(s => s.name.toLowerCase().includes(lojaNorm) || lojaNorm.includes(s.name.toLowerCase()))?.id ?? null;
        }
        if (storeId == null) storeId = 1; // último fallback — evita cliente sem loja

        const today = new Date().toISOString().split("T")[0];
        const sourcePhone = v.telefone || v.phone || phone;
        const migrationKey = `${storeId}:${canonicalPhone(sourcePhone) || phone}`;
        if (migratingLeads.current.has(migrationKey)) return;
        migratingLeads.current.add(migrationKey);
        const newClient = {
          id: clientIdentityKey({ storeId, phone:sourcePhone, name:v.nome || v.name || v.contato || phone, product:v.produto || v.produto_anuncio || v.product || "", createdAt:today }),
          name: v.nome || v.name || v.contato || phone,
          phone: canonicalPhone(sourcePhone) || sourcePhone,
          product: v.produto || v.produto_anuncio || v.product || "",
          origin: "WhatsApp",
          value: 0, note: "", followUp: "", birthday: "",
          stage: "waiting", consultantId, storeId, createdAt: today,
          stageDates: { waiting: today }, fromLead: true, leadPhone: phone,
        };

        // Usa a mesma escrita idempotente do cadastro presencial. Se outra aba já
        // criou a ficha, o lead é apenas marcado como migrado, sem abrir outro nó.
        addClient(newClient)
          .then(() => update(dbRef(`leads/${phone}`), { _crm_migrated: true }))
          .catch(e => console.error('[lead migration] erro ao criar cliente:', e.message))
          .finally(() => migratingLeads.current.delete(migrationKey));
      });

      // ── 2) Transferência para consultora → move para coluna "Chegou" ─
      // Quando responsavel muda para nome real de consultora (não "aurora",
      // não "consultor"), atualiza estagio para "chegou" no Firebase para
      // que o card apareça na coluna correta do Kanban de Leads da consultora.
      const AURORA_STAGES = new Set(["chegou","qualificado","ativo","em_atendimento_loja"]);
      const TERMINAL_STAGES_LEAD = new Set(["fechou_venda","desqualificado","prospeccao_futura"]);
      Object.entries(raw).forEach(([phone, v]) => {
        if (typeof v !== 'object' || v === null) return;
        if (v._crm_migrated) return;
        if (updatingEstagio.current.has(phone)) return;       // já sendo atualizado

        const respRaw = (v.responsavel || "").trim();
        const hasRealConsultant = respRaw &&
          respRaw !== "aurora" &&
          respRaw !== "consultor";
        if (!hasRealConsultant) return;

        const rawStatus = v._crm_estagio || v.estagio || v.status || v.stage || "chegou";
        if (rawStatus === "chegou") return;                   // já está na coluna certa
        if (TERMINAL_STAGES_LEAD.has(rawStatus)) return;     // não mexe em estágios finais

        // Só reseta se o estagio era gerenciado pela Aurora (não foi o consultor quem moveu)
        if (!AURORA_STAGES.has(rawStatus) && rawStatus !== "em_atendimento_loja") return;

        updatingEstagio.current.add(phone);
        update(dbRef(`leads/${phone}`), { estagio: "chegou" })
          .catch(() => {})
          .finally(() => updatingEstagio.current.delete(phone));
      });
      // ─────────────────────────────────────────────────────────────────

      const normalized = Object.entries(raw).map(([fbKey, v]) => {
        if (typeof v !== 'object' || v === null) return null;
        if (v._crm_migrated) return null;                     // oculta da aba Leads
        // Parseia chave Firebase: "{storeId}_{phone}" (nova, isolada por loja)
        // ou "{phone}" puro (legado). Regex garante que o prefixo seja 1-2 dígitos
        // seguidos de um número de telefone de 8-13 dígitos.
        const compositeMatch = fbKey.match(/^(\d{1,3})_(\d{8,13})$/);
        const phoneOnly  = compositeMatch ? compositeMatch[2] : fbKey;
        const keyStoreId = compositeMatch ? Number(compositeMatch[1]) : null;
        // Um cadastro presencial real substitui o Lead na fila. Já a ficha financeira
        // vinculada a uma venda de Lead é apenas o espelho para Recebimentos e não pode
        // ocultar a conversa/origem que o consultor precisa continuar consultando.
        const leadPhoneNorm = normalizePhone(v.telefone || v.phone || phoneOnly);
        const leadPhoneWithoutNinthDigit = leadPhoneNorm.length === 11
          ? leadPhoneNorm.slice(0, 2) + leadPhoneNorm.slice(3)
          : leadPhoneNorm;
        const jaEhCliente = activeClientPhoneKeys.has(leadPhoneNorm)
          || activeClientPhoneKeys.has(leadPhoneWithoutNinthDigit);
        const isLeadSaleClosed = (v._crm_estagio || v.estagio || v.status || v.stage) === "fechou_venda";
        // Um cliente antigo com o mesmo telefone não pode ocultar um fechamento
        // de Lead posterior. O livro comercial resolve a venda por origem/ID;
        // ocultá-la aqui faria o financeiro enxergar a ficha e o painel ignorar
        // a venda, gerando totais diferentes.
        if (jaEhCliente && !isLeadSaleClosed) return null;
        return {
          ...nextContactPersistenceFields(v),
          id: `aurora_${fbKey}`,             // usa fbKey completo → único entre lojas
          nome: v.nome || v.name || v.contato || phoneOnly,
          telefone: v.telefone || v.phone || phoneOnly,   // número WhatsApp real
          estagio: v.desqualificado===true ? "desqualificado" : (()=>{ const raw=v._crm_estagio||v.estagio||v.status||v.stage||"chegou"; const map={ativo:"chegou",em_atendimento_loja:"qualificado",qualificado:"qualificado",followup:"followup_programado",follow_up:"followup_programado",encaminhado_humano:"qualificado",em_atendimento_consultor:"qualificado"}; return map[raw]||(KNOWN_LEAD_STAGE_IDS.has(raw)?raw:"chegou"); })(),
          responsavel: v.responsavel || "aurora",
          // `consultorAtual`/nome do responsável podem ser mais novos que o
          // consultantId legado. A tela inteira usa o id canônico para nunca
          // mostrar um nome antigo no card e outro dentro da conversa.
          consultantId: resolveLeadConsultantId({ ...v, storeId: v.storeId != null ? Number(v.storeId) : keyStoreId }),
          produto_anuncio: v.produto || v.produto_anuncio || v.nome_produto_anuncio || v.product || "",
          produto_venda: v.produto_venda || "",
          tamanho_desejado: v.tamanho || v.tamanho_desejado || "",
          proxima_data_contato: v.proxima_data_contato || "",
          tentativas_followup: v.tentativas || v.tentativas_followup || 0,
          createdAt: v.createdAt || v.data || "",
          ultima_atualizacao: v.ultima_atualizacao || v.updatedAt || "",
          storeId: v.storeId != null ? Number(v.storeId) : keyStoreId,
          loja: v.loja || null,
          fechou_venda_em: v.fechou_venda_em || null,
          motivo_desqualificacao: v.motivo_desqualificacao || "",
          motivo_desqualificacao_tipo: v.motivo_desqualificacao_tipo || "",
           desqualificado_em: v.desqualificado_em || v.desqualificadoEm || v.disqualifiedAt || v.disqualified_at || null,
          motivo_prospeccao_futura: v.motivo_prospeccao_futura || "",
           ...projectLeadReengagementFields(v),
          // Campos preservados para fechamentos (manuais e do kanban)
          valor_venda: v.valor_venda != null ? Number(v.valor_venda) : 0,
          manualFechamento: v.manualFechamento || false,
          data_fechamento: v.data_fechamento || null,
          forma_pagamento: v.forma_pagamento || "",
          observacoes_venda: v.observacoes_venda || "",
          deliveryDate: v.deliveryDate || null,
          followUp: v.followUp || null,
          posVendaDate: v.posVendaDate || null,
          nextSaleDate: v.nextSaleDate || null,
          nextSaleValue: v.nextSaleValue != null ? Number(v.nextSaleValue) : null,
          nextSaleNote: v.nextSaleNote || "",
          financeSheetId: v.financeSheetId || null,
          data_criacao: v.data_criacao || v.createdAt || v.data || "",
          // Flag manual "já respondi, aguardando o cliente" — suprime badge vermelho
          aguardandoRetornoCliente: v.aguardandoRetornoCliente || null,
          // Anúncio de origem (click-to-WhatsApp Meta)
          ...observedAdFields(v),
          titulo_anuncio:  v.titulo_anuncio  || null,
          body_anuncio:    v.body_anuncio    || null,
          tipo_anuncio:    v.tipo_anuncio    || null,
          thumb_anuncio:   v.thumb_anuncio   || null,
           origem_canal:    v.origem_canal    || null,
           origem_descricao:v.origem_descricao || null,
          // Aurora Qualificação: mantidos separados dos campos antigos de
          // referral até a confirmação real do payload CTWA.
          conversationId: v.conversationId || null,
          ad_id: v.ad_id || null,
          ad_id_reported: v.ad_id_reported || null,
          campaign_id: v.campaign_id || null,
          campaign_id_reported: v.campaign_id_reported || null,
          nome_produto_anuncio: v.nome_produto_anuncio || null,
          aurora_status: v.aurora_status || null,
          resumo_qualificacao: v.resumo_qualificacao || null,
          ad_origin_confirmation: v.ad_origin_confirmation || null,
           aurora_handoff: v.aurora_handoff === true
             || v.aurora_handoff === 1
             || String(v.aurora_handoff).toLowerCase() === "true",
           aurora_handoff_event_id: v.aurora_handoff_event_id || null,
           manualSaleBinding: v.manualSaleBinding || null,
           saleConfirmedAt: v.saleConfirmedAt || null,
           terminalReplyRequired: v.terminalReplyRequired || null,
           liftPedidoId: v.liftPedidoId || null,
           liftStoreId: v.liftStoreId || null,
           aurora_handoff_at: v.aurora_handoff_at || null,
           aurora_handoff_consultant_id: v.aurora_handoff_consultant_id != null ? Number(v.aurora_handoff_consultant_id) : null,
           aurora_handoff_consultant_name: v.aurora_handoff_consultant_name || null,
           aurora_handoff_source: v.aurora_handoff_source || null,
          _source: "aurora",
          distribuicao_pendente: v.distribuicao_pendente === true
            && USERS.some(u => u.role === "manager" && Number(u.id) === Number(v.consultantId)),
          responsavel_tipo: v.responsavel_tipo || null,
          cadastro_rede_seguranca: v.cadastro_rede_seguranca === true,
          ...(v.distribuicao_pendente === true && USERS.some(u => u.role === "manager"
            && Number(u.id) === Number(v.consultantId)) ? {
              consultantId:Number(v.consultantId), assignedConsultantId:Number(v.consultantId),
              consultorAtual:Number(v.consultantId), responsavel:v.responsavel,
            } : {}),
          _rawPhone: fbKey,                  // chave Firebase real para CRUD (pode ser "storeId_phone")
          // Lojas anteriores (lead transferido cross-store) — exibe histórico de msgs de todas as lojas
          _prevStoreIds: Array.isArray(v._prev_store_ids) ? v._prev_store_ids.map(Number) : (v._prev_store_ids != null ? [Number(v._prev_store_ids)] : []),
          // ── Campos de transferência cross-store ────────────────────────────────
          // lojaOrigem: fixo, definido na entrada do lead. lojaAtual: atualizado a cada transfer.
          systemRescheduleHistory:v.systemRescheduleHistory || {},
          // historicoTransferencias: array de objetos {de,para,lojaAnterior,lojaDestino,transferidoPor,data}
          lojaOrigem: v.lojaOrigem != null ? Number(v.lojaOrigem) : (v.storeId != null ? Number(v.storeId) : keyStoreId),
          lojaAtual:  v.lojaAtual  != null ? Number(v.lojaAtual)  : (v.storeId != null ? Number(v.storeId) : keyStoreId),
          consultorAtual: resolveLeadConsultantId({ ...v, storeId: v.storeId != null ? Number(v.storeId) : keyStoreId }),
          historicoTransferencias: v.historicoTransferencias
            ? Object.values(v.historicoTransferencias).filter(Boolean).sort((a,b)=>new Date(a.data||0)-new Date(b.data||0))
            : [],
        };
      }).filter(Boolean);
      setAuroraLeads(dedupeLeadsForDisplay(normalized));
    };

    const unsubAuroraLeads = onValue(dbRef('leads'), snap => {
      if (!snap.exists()) { setAuroraLeads([]); return; }
      applyLeadSnapshot(snap.val());
    }, { onlyOnce: false });
    const knownWaMsgIds = new Set();
    const messageSourceSnapshots = {
      arflow_whatsapp: {},
      whatsapp: {},
      hist: {},
      prosp: {},
    };
    let waDebounceTimer = null;
    // Cada fonte (arflow_whatsapp, whatsapp, historico, prospeccao) tem seu próprio
    // listener onValue do Firebase, e cada um recebe seu snapshot inicial de forma
    // assíncrona e independente. Usar UMA flag global "primeira carga" compartilhada
    // era o bug: assim que a 1ª fonte a responder marcava a flag como false, as
    // demais fontes tratavam sua PRÓPRIA carga inicial (mensagens antigas) como se
    // fossem novas, disparando som/notificação falsa toda vez que o CRM abria.
    const waFirstLoadFlags = { arflow_whatsapp:true, whatsapp:true, hist:true, prosp:true };
    const MAX_MSGS_PER_PHONE = 150; // proteção contra volume alto (ex: bug zumbi)

    // Normalize n8n message format → CRM format
    const normalizeN8nMsg = (msg) => {
      // Z-API grava texto aninhado: msg.text = { message: "..." }
      // n8n/OpenAI pode usar content como array: [{ type:"text", text:"..." }]
      const extractText = (v) => {
        if (!v) return '';
        if (typeof v === 'string') return v;
        if (Array.isArray(v)) {
          const first = v.find(x => x && (x.text || x.content));
          return first ? String(first.text || first.content) : '';
        }
        if (typeof v === 'object') {
          if (v.message) return String(v.message);
          if (v.body)    return String(v.body);
          if (v.caption) return String(v.caption);
        }
        return '';
      };
      const texto =
        msg.texto ||
        (typeof msg.content === 'string' ? msg.content : '') ||
        (typeof msg.body    === 'string' ? msg.body    : '') ||
        extractText(msg.text) ||
        (typeof msg.message === 'string' ? msg.message : '') ||
        msg.caption || msg.mensagem || msg.descricao ||
        extractText(msg.content) ||
        '';
      // DEBUG: log raw msg when text could not be extracted — remove after diagnosis
      if (!texto) {
        console.warn('[CRM-DEBUG] normalizeN8nMsg: texto vazio. Campos brutos:', JSON.stringify(Object.keys(msg)), JSON.stringify(msg).slice(0,300));
      }
      const remetente = msg.remetente || (
        msg.fromMe === true                                                ? 'consultor'
        : (msg.responsavel === 'aurora' || msg.responsavel === 'bot')     ? 'aurora'
        : msg.responsavel === 'consultor'                                  ? 'consultor'
        : msg.responsavel === 'cliente'                                    ? 'cliente'
        : msg.role === 'user'                                              ? 'cliente'
        : (msg.role === 'aurora' || msg.role === 'assistant' || msg.role === 'bot') ? 'aurora'
        : (msg.role === 'consultant' || msg.role === 'agent')             ? 'consultor'
        : 'cliente'
      );
      const directionInferred = msg.directionInferred === true || !(
        msg.remetente || typeof msg.fromMe === "boolean"
        || ["cliente", "consultor", "aurora", "bot"].includes(msg.responsavel)
        || ["user", "aurora", "assistant", "bot", "consultant", "agent"].includes(msg.role)
      );
      // Aurora / n8n pode usar diferentes nomes para o timestamp
      const timestamp =
        msg.timestamp    || msg.ts          || msg.createdAt  || msg.created_at ||
        msg.created      || msg.date        || msg.datetime   || msg.sent_at    ||
        msg.time         || msg.hora        || msg.data       || '';
      return { ...msg, remetente, directionInferred, texto, timestamp };
    };

    // Show toast + sound for new incoming client message
    // Uses refs so the closure always sees the latest leads/prospects/clients (the effect runs once with [])
    const fireToast = (phone, msg, sourceKey) => {
      if ((msg.remetente || msg.role) !== 'cliente' && msg.role !== 'user') return;
      const contact = (prospeccaoRef.current||[]).find(p => normalizePhone(p.phone)===phone);
      const client  = (clientsRef.current||[]).find(c => normalizePhone(c.phone)===phone);
      const lead    = (auroraLeadsRef.current||[]).find(l => normalizePhone(l.telefone)===phone);
      const entity  = contact || client || lead;
      const name = contact?.name || client?.name || lead?.nome || phone;
      const consultantId = entity?.consultantId ?? null;
      const storeId = entity?.storeId ?? null;
      const user = currentUserRef.current;
      // Consultor só ouve/vê mensagens dos seus próprios contatos; gerente/admin vê tudo da(s) loja(s) dele
      const isMyLead = !user || user.role !== 'consultant' || (consultantId != null && consultantId === user.id);
      const isMyStore = !user || !user.storeId || (storeId != null ? storeId === user.storeId : true);
      if (entity && isMyLead && isMyStore) {
        const storeName = storeId != null ? STORES.find(s => s.id === storeId)?.name : null;
        const storeSuffix = storeName ? ` — ${storeName}` : '';
        showInAppNotification({ key:msg.waMessageId || msg.providerMessageId || sourceKey, phone, module:contact?"prospeccao":client?"kanban":"leads", storeId, consultantId,
          message:`💬 Nova mensagem de ${name}${storeSuffix}`, type:"message" });
      }
    };

    // Chaves de metadado que nunca são mensagens — usadas para filtrar node direto
    const META_KEYS = new Set([
      'nome','name','telefone','phone','email','estagio','stage','status',
      'responsavel','storeId','loja','criadoEm','updatedAt','createdAt',
      'consultantId','produto','tamanho','proxima_data_contato','tentativas',
      'desqualificado','_crm_estagio',
    ]);

    // Verifica se um objeto parece uma mensagem (tem pelo menos um campo de conteúdo)
    const looksLikeMessage = (obj) =>
      obj && typeof obj === 'object' &&
      (obj.texto || obj.content || obj.body || obj.message || obj.caption ||
       obj.mensagem || obj.text || obj.remetente || obj.role || obj.responsavel);

    const scheduleWhatsappRender = () => {
      if (waDebounceTimer) clearTimeout(waDebounceTimer);
      waDebounceTimer = setTimeout(() => {
        setWhatsappMsgs(previous => preserveLatestConversationEvidence(
          previous, mergeMessageSourceSnapshots(messageSourceSnapshots),
        ));
      }, 120);
    };

    // Process arflow_whatsapp/ and whatsapp/ (mensagens do CRM e webhook).
    // Cada callback substitui o snapshot da própria origem. Assim, uma mídia
    // removida/absorvida também sai do chat sem apagar mensagens das demais.
    const processWaData = (data, sourceName, { replaceAll = true } = {}) => {
      let totalPhones = 0; let totalMsgs = 0; let skipped = 0;
      const nextSourceSnapshot = {};
      Object.entries(data).forEach(([rawPhone, phoneMsgs]) => {
        const phone = normalizePhone(rawPhone);
        if (!phone) return;
        totalPhones++;
        if (!nextSourceSnapshot[phone]) nextSourceSnapshot[phone] = {};
        const allEntries = Object.entries(phoneMsgs||{});
        // Cap: só as últimas MAX_MSGS_PER_PHONE por telefone (keys são timestamps — ordem lexicográfica)
        const entries = allEntries.length > MAX_MSGS_PER_PHONE
          ? allEntries.slice(-MAX_MSGS_PER_PHONE)
          : allEntries;
        if (allEntries.length > MAX_MSGS_PER_PHONE) skipped += allEntries.length - MAX_MSGS_PER_PHONE;
        entries.forEach(([msgId, msg]) => {
          if (!msg || typeof msg !== 'object') return;
          const normalized = normalizeN8nMsg(msg);
          nextSourceSnapshot[phone][msgId] = normalized;
          totalMsgs++;
          const sourceMessageId = `${sourceName}:${msgId}`;
          if (!knownWaMsgIds.has(sourceMessageId)) {
            knownWaMsgIds.add(sourceMessageId);
            // Na 1ª carga semeia os IDs sem disparar toasts (evita flood ao abrir o CRM)
            if (!waFirstLoadFlags[sourceName] && normalized.remetente === 'cliente') fireToast(phone, normalized, sourceMessageId);
          }
        });
      });
      if (replaceAll) replaceMessageSourceSnapshot(messageSourceSnapshots, sourceName, nextSourceSnapshot);
      else replaceMessageSourcePhones(messageSourceSnapshots, sourceName, nextSourceSnapshot);
      if (waFirstLoadFlags[sourceName]) { waFirstLoadFlags[sourceName] = false; }
      if (skipped > 0) console.warn(`[CRM] ${sourceName}: ${skipped} msgs antigas ignoradas (cap ${MAX_MSGS_PER_PHONE}/tel)`);
      console.log(`[CRM] ${sourceName||'wa'}: ${totalPhones} telefones, ${totalMsgs} mensagens processadas`);
      // Debounce: agrupa updates rápidos em uma única re-renderização (evita freeze)
      scheduleWhatsappRender();
    };

    // Process /historico/{phone}/... e /prospeccao/{phone}/... (paths do n8n / Aurora)
    // Estruturas suportadas:
    //   A) node.mensagens.chatId = [ {content,role,ts}, ... ]  (Aurora array format)
    //   B) node.mensagens.msgId  = { content, role, ts }       (flat keyed messages)
    //   C) node.msgId            = { content, role, ts }       (sem sub-chave mensagens)
    //   D) node                  = { content, role, ts }       (o próprio node é a mensagem)
    const processN8nPath = (data, prefix) => {
      let totalPhones = 0; let totalMsgs = 0;
      const nextSourceSnapshot = {};
      Object.entries(data).forEach(([rawPhone, node]) => {
        if (!node || typeof node !== 'object') return;
        const phone = normalizePhone(rawPhone);
        if (!phone) return;
        totalPhones++;
        if (!nextSourceSnapshot[phone]) nextSourceSnapshot[phone] = {};

        // D) O próprio node é uma mensagem direta
        if (looksLikeMessage(node) && !node.mensagens) {
          const normalized = normalizeN8nMsg(node);
          const key = `${prefix}_${rawPhone}_0`;
          nextSourceSnapshot[phone][key] = normalized;
          totalMsgs++;
          const sourceMessageId = `${prefix}:${key}`;
          if (!knownWaMsgIds.has(sourceMessageId)) { knownWaMsgIds.add(sourceMessageId); if (!waFirstLoadFlags[prefix] && normalized.remetente==='cliente') fireToast(phone, normalized, sourceMessageId); }
          return;
        }

        // A/B) node.mensagens existe
        // C) sem mensagens → usa o próprio node como mapa (filtrando META_KEYS)
        const hasMensagens = node.mensagens && typeof node.mensagens === 'object';
        const rawMsgMap = hasMensagens
          ? node.mensagens
          : Object.fromEntries(Object.entries(node).filter(([k,v]) => !META_KEYS.has(k) && v && typeof v === 'object'));

        // Se mensagens é um array Firebase (chaves "0","1",...) expande para objeto
        const allNumeric = (obj) => Object.keys(obj).length > 0 && Object.keys(obj).every(k => /^\d+$/.test(k));
        const rawMsgObj = (typeof rawMsgMap === 'object' && allNumeric(rawMsgMap))
          ? Object.fromEntries(Object.values(rawMsgMap).map((v,i)=>[`item_${i}`,v]))
          : rawMsgMap;

        if (!rawMsgObj || typeof rawMsgObj !== 'object') return;

        // Cap por telefone: mantém só as últimas MAX_MSGS_PER_PHONE entradas
        const allMsgEntries = Object.entries(rawMsgObj).sort(([a],[b])=>a.localeCompare(b));
        const msgEntries = allMsgEntries.length > MAX_MSGS_PER_PHONE
          ? allMsgEntries.slice(-MAX_MSGS_PER_PHONE)
          : allMsgEntries;

        const msgMap = Object.fromEntries(msgEntries);

        Object.entries(msgMap).forEach(([msgId, msg]) => {
          if (!msg || typeof msg !== 'object') return;

          // Aurora array format: todas as chaves são numéricas → msg é array de itens
          const isArrayLike = allNumeric(msg);
          const items = isArrayLike ? Object.values(msg) : [msg];

          items.forEach((item, idx) => {
            if (!item || typeof item !== 'object') return;
            const normalized = normalizeN8nMsg(item);
            // Só descarta se não tiver nenhum conteúdo E não tiver remetente
            if (!normalized.texto && !normalized.url && !normalized.audio && !normalized.video && !normalized.remetente) return;
            const key = `${prefix}_${msgId}_${idx}`;
            nextSourceSnapshot[phone][key] = normalized;
            totalMsgs++;
            const sourceMessageId = `${prefix}:${key}`;
            if (!knownWaMsgIds.has(sourceMessageId)) {
              knownWaMsgIds.add(sourceMessageId);
              // Na 1ª carga apenas semeia — sem toasts
              if (!waFirstLoadFlags[prefix] && normalized.remetente === 'cliente') fireToast(phone, normalized, sourceMessageId);
            }
          });
        });
      });
      replaceMessageSourceSnapshot(messageSourceSnapshots, prefix, nextSourceSnapshot);
      if (waFirstLoadFlags[prefix]) { waFirstLoadFlags[prefix] = false; }
      console.log(`[CRM] ${prefix} (n8n): ${totalPhones} telefones, ${totalMsgs} mensagens`);
      scheduleWhatsappRender();
    };
    // Kept temporarily as inert migration parsers; no source invokes them.
    // Conversation loading below is exclusively the authenticated scoped API.
    void processWaData;
    void processN8nPath;
    return () => {
      unsubAuroraLeads();
      if (waDebounceTimer) clearTimeout(waDebounceTimer);
    };
  }, [isDemoMode, currentUser?.id, currentUser?.storeId, currentUser?.role]); // eslint-disable-line react-hooks/exhaustive-deps

  // Both production and demo use the authenticated, store-scoped latest
  // conversation snapshot. The Firebase lead listener above is demo-only.
  useEffect(() => {
    if (!currentUser) return undefined;
    if (currentUser.role === "deposito") return undefined;
    let conversationPollInFlight = false;
    let summaryScope = "";
    const seenLatestMessages = new Map();
    const loadScopedConversations = async () => {
      if (conversationPollInFlight || readScopeRef.current.awaiting) return;
      const user = currentUserRef.current;
      if (!user) return;
      const metadataOnly=["admin","superadmin","manager"].includes(user.role);
      if(!metadataOnly&&activeTabRef.current==="dashboard")return;
      const requestedStores = readScopeRef.current.stores;
      const requestScopeKey = readScopeRef.current.key;
      if (!requestedStores.length) { setWhatsappMsgs({}); return; }
      conversationPollInFlight = true;
      try {
        const response = await fetch(`/api/crm/conversations?storeIds=${encodeURIComponent(requestedStores.join(","))}&latestOnly=1&readMode=${metadataOnly?"activity-v1":"memory-v1"}`, {
          credentials:"same-origin", cache:"no-store", headers:{ Accept:"application/json" },
        });
        if (!response.ok) {
          if (response.status === 401) handleExpiredCrmSession();
          return;
        }
        const payload = await response.json();
        if (readScopeRef.current.key !== requestScopeKey || currentUserRef.current?.id !== user.id) return;
        const scoped = scopedConversationCache(payload, requestedStores);
        const scope = `${currentUserRef.current?.id}:${requestedStores.join(",")}`;
        const firstLoad = summaryScope !== scope;
        if(summaryScope&&firstLoad)ownTreatmentEvidence.current={};
        if (firstLoad) { seenLatestMessages.clear(); summaryScope = scope; }
        Object.entries(scoped).forEach(([key, messages]) => {
          const latest = Object.entries(messages || {}).reduce((last, [id, message]) =>
            !last || _tsNum(message.timestamp) > _tsNum(last.message.timestamp) ? { id, message } : last, null);
          if (!latest) return;
          const identity = `${latest.id}:${latest.message.timestamp || ""}`;
          if (!firstLoad && seenLatestMessages.get(key) !== identity && latest.message.remetente === "cliente") {
            const id = `${key}:${identity}`;
            setToasts(items => [...items, { id, type:"message",
              msg:"Cliente respondeu no WhatsApp. Abra a conversa pelo Meu Dia." }]);
            setTimeout(() => setToasts(items => items.filter(item => item.id !== id)), 7000);
          }
          seenLatestMessages.set(key, identity);
        });
        setWhatsappMsgs(previous => {
          Object.entries(ownTreatmentEvidence.current).forEach(([key,own])=>{
            const sameScope=requestedStores.includes(Number(key.split(":")[0]));
            const latest=Object.values(scoped[key]||{}).reduce((n,message)=>Math.max(n,conversationActionTimestamp(message)),0);
            if(!sameScope||latest>=conversationActionTimestamp(own.message))delete ownTreatmentEvidence.current[key];
            else scoped[key]={[own.messageId]:own.message};
          });
          const next = { ...(previous || {}), __latestEvidence:scoped };
          Object.entries(scoped).forEach(([key, messages]) => {
            next[key] = mergeConversationMessages(previous?.[key], messages);
          });
          return next;
        });
      } catch (error) {
        console.warn("[CRM] scoped conversation refresh failed:", error.message);
      } finally {
        conversationPollInFlight = false;
      }
    };
    refreshConversationSummariesRef.current = loadScopedConversations;
    const stopPolling = watchVisiblePolling(loadScopedConversations, 5000);
    return () => {
      stopPolling();
      if (refreshConversationSummariesRef.current === loadScopedConversations) {
        refreshConversationSummariesRef.current = null;
      }
    };
  }, [isDemoMode, currentUser?.id, currentUser?.role, scopedReadKey]); // eslint-disable-line react-hooks/exhaustive-deps

  // Cards recebem somente a última mensagem interna e eventos de transferência.
  // O histórico integral é carregado pelo endpoint individual ao abrir a conversa.
  useEffect(() => {
    const needsLeadSummaries = ["central", "leads"].includes(tab);
    if (!needsLeadSummaries || !currentUser || currentUser.role === "deposito" || isDemoMode
      || ["admin","superadmin","manager"].includes(currentUser.role)) return undefined;
    let cancelled = false;
    let inFlight = false;
    const requestedStores = scopedReadStores;
    const loadLeadSummaries = async () => {
      if (cancelled || inFlight || !requestedStores.length) return;
      inFlight = true;
      try {
        const response = await fetch(`/api/crm/lead-detail-summaries?storeIds=${encodeURIComponent(requestedStores.join(","))}`, {
          credentials:"same-origin",
          cache:"no-store",
          headers:{ Accept:"application/json" },
        });
        if (!response.ok) {
          if (response.status === 401) handleExpiredCrmSession();
          return;
        }
        const payload = await response.json();
        if (cancelled) return;
        setLeadMessages(previous => {
          const next = { ...(previous || {}) };
          Object.entries(payload.leadMessages || {}).forEach(([leadId, messages]) => {
            next[leadId] = mergeConversationMessages(previous?.[leadId], messages);
          });
          return next;
        });
        setLeadEvents(previous => {
          const next = { ...(previous || {}) };
          Object.entries(payload.leadEvents || {}).forEach(([leadId, events]) => {
            next[leadId] = { ...(previous?.[leadId] || {}), ...(events || {}) };
          });
          return next;
        });
      } catch (error) {
        console.warn("[CRM] resumos internos de leads indisponíveis:", error.message);
      } finally {
        inFlight = false;
      }
    };
    const stopPolling = watchVisiblePolling(loadLeadSummaries, 60000);
    return () => {
      cancelled = true;
      stopPolling();
    };
  }, [tab, currentUser, isDemoMode, scopedReadKey]); // eslint-disable-line react-hooks/exhaustive-deps

  // Mantém refs sempre atualizados — permitem que closures com [] vejam dados atuais
  useEffect(() => { auroraLeadsRef.current = auroraLeads; }, [auroraLeads]);
  useEffect(() => { prospeccaoRef.current = prospeccao; }, [prospeccao]);
  useEffect(() => { clientsRef.current = clients; }, [clients]);
  useEffect(() => {
    currentUserRef.current = currentUser;
    confirmedReminderCompletions.current.clear();
    reminderCompletionRequests.current.clear();
    setConfirmedCommercialReminders([]);
  }, [currentUserId, loggedInUserId]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { currentUserRef.current = currentUser; }, [currentUser]);

  // Fechamentos antigos de Lead/Prospecção foram gravados antes de existir uma
  // ficha financeira vinculada. Reconcilia somente vendas concluídas e só toca
  // o espelho financeiro quando ele ainda não foi associado à origem.
  useEffect(() => {
    if (currentUser?.role === "deposito" || !clientsLoadedRef.current) return;
    const pending = [
      ...(auroraLeads || []).map((source) => ({ sourceType:"lead", source })),
      ...(prospeccao || []).map((source) => ({ sourceType:"prospeccao", source })),
    ].filter(({ sourceType, source }) => {
      if (!isCompletedSaleSource(sourceType, source)) return false;
      const sheet = findFinancialSaleSheet(clients, sourceType, source.id, source);
      return !sheet
        || !sheet.financeOnly
        || sheet.financialSourceType !== sourceType
        || String(sheet.financialSourceId || "") !== String(source.id);
    });
    if (!pending.length) return;
    Promise.all(pending.map(({ sourceType, source }) => (
      saveFinancialSaleSheet(sourceType, source, {}, { preserveExisting:true })
    ))).catch((error) => console.error("[financial-sale-reconciliation]", error));
  }, [auroraLeads, clients, prospeccao, currentUser?.role]); // eslint-disable-line react-hooks/exhaustive-deps

  // Notificação de transferência e novo lead
  useEffect(() => {
    if (!currentUser || currentUser.role === "deposito" || !auroraLeads.length) return;
    if (prevLeadsRef.current === null) {
      prevLeadsRef.current = auroraLeads;
      return;
    }
    auroraLeads.forEach(lead => {
      const prev = prevLeadsRef.current.find(l => l.id === lead.id);
      if (!prev) {
        // Lead completamente novo — notifica admin/gerente/consultor dono
        const isMyLead = currentUser.role !== "consultant" || lead.consultantId === currentUser.id;
        const isMyStore = !currentUser.storeId || (lead.storeId || 1) === currentUser.storeId;
        if (isMyLead && isMyStore) {
          const name = lead.nome || lead.telefone || "lead";
          const storeName = STORES.find(s => s.id === (lead.storeId||1))?.name;
          const storeSuffix = storeName ? ` — ${storeName}` : '';
          showInAppNotification({ key:`lead:${lead.id}:${lead.createdAt || lead.data_criacao}`, phone:lead.telefone, module:"leads",
            storeId:lead.storeId || 1, consultantId:lead.consultantId, message:`🔔 Novo lead: ${name}${storeSuffix}`, duration:8000 });
        }
        return;
      }
      if (
        prev.responsavel !== lead.responsavel &&
        lead.responsavel !== "aurora" &&
        lead.consultantId === currentUser.id
      ) {
        const name = lead.nome || lead.telefone || "lead";
        showInAppNotification({ key:`transfer:${lead.id}:${lead.consultantId}:${lead.assignedAt || lead.ultima_atualizacao}`,
          phone:lead.telefone, module:"leads", storeId:lead.storeId || 1, consultantId:lead.consultantId,
          message:`🔥 Lead transferido para você: ${name}`, type:"transfer", duration:8000 });
      }
    });
    prevLeadsRef.current = auroraLeads;
  }, [auroraLeads, currentUser, showInAppNotification]);

  useEffect(() => {
    if (loading || currentUser?.role === "deposito") return;
    if (remoteSales.current) { remoteSales.current = false; return; }
    fbSet('arflow_data/sales', realSales);
  }, [realSales]); // eslint-disable-line react-hooks/exhaustive-deps

  // Só uma resposta real posterior ao envio humano confirmado deste ciclo cancela
  // o follow-up. Histórico antigo, telefone sem loja e bolhas ainda não confirmadas
  // não são evidência suficiente para avançar nem remover uma tarefa.
  // Precisa ficar ANTES dos early returns (loading/!loggedInUser) — hooks não podem ser condicionais.
  useEffect(() => {
    if (loading || currentUser?.role === "deposito") return;
    const pendingProsp = (prospeccao||[]).filter(p => p.followupReminderId);
    if (pendingProsp.length === 0) return;
    const toCancel = [];
    const idsToClear = new Set();
    pendingProsp.forEach(p => {
      const reminder = reminders.find(r => r.id === p.followupReminderId);
      if (!reminder) return;
      const target = confirmedReminderTarget(reminder, p);
      if (!target) return;
      const { phone, channelStoreId } = target;
      const channelKey = conversationKey(channelStoreId, phone);
      const trackingState = commercialTrackingIndex?.[channelKey];
      if (!hasCurrentProspectReply(trackingState)) return;
      const cycleStartedAt = trackingState.prospectCycle.firstOutboundAt;

      const scopedMessages = [];
      const appendHistory = (bucket, { allowMissingIdentity = false } = {}) => {
        if (!bucket || typeof bucket !== "object") return;
        Object.entries(bucket).forEach(([id, message]) => {
          if (!message || typeof message !== "object") return;
          const messageStoreId = message.storeId == null ? null : Number(message.storeId);
          const messagePhone = normalizedConversationPhone(message.phone || message.telefone);
          if (messageStoreId != null && messageStoreId !== channelStoreId) return;
          if (messagePhone && messagePhone !== phone) return;
          if (!allowMissingIdentity && (messageStoreId !== channelStoreId || messagePhone !== phone)) return;
          scopedMessages.push({
            id:message.id || message.crmMessageId || message.waMessageId
              || message.providerMessageId || id,
            storeId:channelStoreId,
            phone,
            message,
          });
        });
      };

      appendHistory(whatsappMsgs?.[channelKey], { allowMissingIdentity:true });
      // This bucket is populated only from the individually scoped history
      // endpoint after it verifies the returned store + normalized phone.
      if (channelStoreId === target.prospectStoreId) {
        appendHistory(prospMensagens?.[String(p.id)], { allowMissingIdentity:true });
      }
      // Legacy phone-only buckets have no tenant binding; use them only when
      // each individual message carries both identity fields.
      appendHistory(prospMensagens?.[phone]);
      appendHistory(whatsappMsgs?.[phone]);

      if (hasReplyToConfirmedProspectOutbound({
        messages:scopedMessages,
        storeId:channelStoreId,
        phone,
        outboundMessageId:target.outboundMessageId,
        cycleStartedAt,
      })) {
        toCancel.push(reminder.id);
        idsToClear.add(p.id);
      }
    });
    if (idsToClear.size === 0) return;
    const prospectsToClear = [...idsToClear].map(id =>
      (prospeccaoRef.current || []).find(item => String(item.id) === String(id))
    );
    if (prospectsToClear.some(prospect => !prospect)) return;
    const requestScope = prospectLiveScopeRef.current;
    void Promise.all(prospectsToClear.map(prospect =>
      persistProspecao(null, { patches:[{
        id:prospect.id,
        storeId:prospect.storeId,
        changes:{
          followupReminderId:null,
        },
      }] })
    )).then(results => {
      runProspectSideEffectIfCurrent(results.flat(), {
        requestScope,
        currentScope:prospectLiveScopeRef.current,
        sideEffect:() => toCancel.forEach(id => deleteReminder(id)),
      });
    }).catch(() => {});
  }, [prospMensagens, whatsappMsgs, reminders, prospeccao, commercialTrackingIndex]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Badge count (deve ficar antes dos early returns para respeitar Rules of Hooks) ──
  const awaitingBadgeCount = currentUser ? (() => {
    const sc = currentUser.role==="admin" ? clients : currentUser.role==="manager" ? clients.filter(c=>c.storeId===currentUser.storeId) : clients.filter(c=>c.consultantId===currentUser.id);
    const sp = currentUser.role==="admin" ? prospeccao : currentUser.role==="manager" ? prospeccao.filter(p=>{ const u=USERS.find(u=>u.id===p.consultantId); return u?.storeId===currentUser.storeId; }) : prospeccao.filter(p=>p.consultantId===currentUser.id);
    const sl = currentUser.role==="admin" ? auroraLeads.filter(l => leadBelongsToStore(l, currentUser.storeId)) : currentUser.role==="manager" ? auroraLeads.filter(l => leadBelongsToStore(l, currentUser.storeId)) : auroraLeads.filter(l=>l.consultantId===currentUser.id);
    return sc.filter(c=>clientAwaitingReply(c,whatsappMsgs)).length
      + sp.filter(p=>prospAwaitingReply(p,whatsappMsgs,prospMensagens)).length
      + sl.filter(l=>leadAwaitingReply(l,leadMessages,whatsappMsgs)).length;
  })() : 0;

  useEffect(() => {
    if (!navigator.setAppBadge) return;
    if (currentUserRole === "deposito") { navigator.clearAppBadge?.().catch(()=>{}); return; }
    if (pushUnreadCount > 0) navigator.setAppBadge(pushUnreadCount).catch(()=>{});
    else navigator.clearAppBadge?.().catch(()=>{});
  }, [pushUnreadCount, currentUserRole]);

  useEffect(()=>{
    if(!loggedInUser)return undefined;
    const refresh=async event=>{
      try {
        const saved=event.detail?.lead;
        if(saved) {
          ownActionSnapshots.current.remember("leads",saved,auroraLeads.find(item=>item.id===saved.id) || {});
          setAuroraLeads(items=>items.map(item=>item.id===saved.id?saved:item));
        }
        await reloadScopedReminders();
      } catch(error) {console.error("[lead-auto-exit] atualização pendente:",error.message);}
    };
    window.addEventListener("arflow:lead-automatic-exit",refresh);
    return ()=>window.removeEventListener("arflow:lead-automatic-exit",refresh);
  },[loggedInUser?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!loggedInUser) {
    const handleLogin = (user) => {
      invalidateProspectWrites();
      expiredCrmAlertShownRef.current = false;
      _demoMode = !!user?.isDemo;
      setIsDemoMode(!!user?.isDemo);
      setLoggedInUser(user); setCurrentUser(user);
      // Sessão demo é efêmera — não persiste em localStorage para não reidratar automaticamente
      if (!user?.isDemo) {
        try { localStorage.setItem('arflow_user', JSON.stringify(user)); } catch {}
      }
    };
    return <LoginScreen onLogin={handleLogin} />;
  }

  if (loggedInUser.role === "deposito") {
    const requiredPasswordChange = Boolean(loggedInUser.mustChangePassword);
    const passwordChanged = () => {
      const updated = { ...loggedInUser, mustChangePassword:false };
      setLoggedInUser(updated);
      setCurrentUser(previous => previous?.id === updated.id ? { ...previous, mustChangePassword:false } : previous);
      try { localStorage.setItem("arflow_user", JSON.stringify(updated)); } catch {}
      setAccountOpen(false);
    };
    const encerrarSessao = async () => {
      const response = await fetch("/api/crm/session", { method:"DELETE", credentials:"include" });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || result?.ok !== true) {
        throw new Error(result?.error || "Não foi possível encerrar a sessão. Tente novamente.");
      }
      _demoMode = false;
      invalidateProspectWrites();
      setIsDemoMode(false);
      setLoggedInUser(null);
      setCurrentUser(null);
      setAccountOpen(false);
      setTabRaw("dashboard");
      try { localStorage.removeItem("arflow_user"); } catch {}
      return true;
    };
    const sair = () => encerrarSessao().catch(error => {
      window.alert(error?.message || "Não foi possível encerrar a sessão. Tente novamente.");
      return false;
    });
    const depositoTheme = THEMES[Number(currentUser?.storeIds?.[0]) || currentUser?.storeId || 1] || THEMES[1];
    return (
      <div className="nu-root" style={{ minHeight:"100vh", background:depositoTheme.sand, fontFamily:NEW_UI_FONT }}>
        {!requiredPasswordChange && <DepositoApp theme={depositoTheme} currentUser={currentUser || loggedInUser} authenticatedUser={loggedInUser} onSair={sair} onMinhaConta={() => setAccountOpen(true)} />}
        {(accountOpen || requiredPasswordChange) && (
          <AccountPasswordModal
            user={loggedInUser}
            required={requiredPasswordChange}
            onClose={() => { if (!requiredPasswordChange) setAccountOpen(false); }}
            onChanged={passwordChanged}
            onLogout={requiredPasswordChange ? encerrarSessao : undefined}
          />
        )}
      </div>
    );
  }

  if (canViewOwnerSafety && tab === "whatsappAlerts") {
    return <InboundSafetyNotice operator={loggedInUser} onBack={() => setTabRaw("dashboard")} />;
  }

  if (awaitingAdminStore) {
    return <AdminStoreEntry stores={getActiveStores()} onSelect={chooseAdminReadScope}
      onOpenSafetyAlerts={canViewOwnerSafety ? () => setTabRaw("whatsappAlerts") : undefined}
      onLogout={() => {
        invalidateProspectWrites();
        setLoggedInUser(null); setCurrentUser(null);
        try { localStorage.removeItem("arflow_user"); } catch {}
      }} />;
  }

  if (loading) {
    return (
      <div style={{ minHeight:"100vh", background:"#3D2B00", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:16 }}>
        <div style={{ fontSize:40 }}>👑</div>
        <div style={{ color:"#C9A227", fontWeight:700, fontSize:16, fontFamily:"Georgia,serif" }}>AR Flow</div>
        <div style={{ color:"rgba(255,255,255,0.5)", fontSize:13 }}>Carregando dados...</div>
        {isGeneralAdminView(currentUser, isDemoMode) && <button type="button"
          onClick={() => chooseAdminReadScope(null)}
          style={{ marginTop:12, padding:"9px 14px", borderRadius:8, cursor:"pointer" }}>
          Escolher outra loja
        </button>}
      </div>
    );
  }

  if (currentUser?.role === "deposito" && loggedInUser.role === "admin") {
    const depositoTheme = THEMES[Number(currentUser?.storeIds?.[0]) || currentUser?.storeId || 1] || THEMES[1];
    return (
      <div className="nu-root" style={{ minHeight:"100vh", background:depositoTheme.sand, fontFamily:NEW_UI_FONT }}>
        <div style={{ background:depositoTheme.accent, padding:"7px 14px", display:"flex", justifyContent:"space-between", alignItems:"center", gap:10 }}>
          <span style={{ color:"#fff", fontSize:12, fontWeight:700 }}>👁 Visualizando como: {currentUser.name}</span>
          <button type="button" onClick={() => { if (setCurrentUserGuarded(loggedInUser)) setTab("dashboard"); }}
            style={{ background:"rgba(255,255,255,0.2)", border:"none", borderRadius:6, padding:"5px 10px", color:"#fff", fontSize:12, fontWeight:700, cursor:"pointer" }}>
            ← Voltar para Admin
          </button>
        </div>
        <DepositoApp theme={depositoTheme} currentUser={currentUser} authenticatedUser={loggedInUser} />
      </div>
    );
  }

  // Studio técnico e Superadministrador operacional são identidades separadas.
  if (currentUser?.role === "superadmin") {
    const superadminLogout = () => {
      const endpoint = currentUser.authKind === 'studio' ? '/api/studio/session' : '/api/crm/session';
      fetch(endpoint, { method:'DELETE', credentials:'include' }).catch(()=>{});
      invalidateProspectWrites();
      setLoggedInUser(null); setCurrentUser(null); try { localStorage.removeItem('arflow_user'); } catch {}
    };
    if (currentUser.authKind === 'studio') {
      return <ArFlowStudioView onLogout={superadminLogout} mustChangePassword={loggedInUser?.mustChangePassword===true} />;
    }
    return <MarketingIntelligenceView user={currentUser} onLogout={superadminLogout}
      onOpenSafetyAlerts={canViewOwnerSafety ? () => setTab("whatsappAlerts") : undefined} />;
  }

  const activeStoreId = currentUser.storeId || 1;
  const newUi = !isDemoMode && isNewUiEnabled();
  const isNewUi = newUi;
  T = isDemoMode ? T_DEMO : newUi ? (NEW_THEMES[activeStoreId] || NEW_THEMES[1]) : (THEMES[activeStoreId] || THEMES[1]);

  const isStaff = currentUser.role==="superadmin" || currentUser.role==="admin" || currentUser.role==="manager";
  const isAdminViewing = loggedInUser.role==="admin" && currentUser.id!==loggedInUser.id;
  const handleLogout = () => {
    activeConversationExitGuard.requestAction(() => {
      _demoMode = false; setIsDemoMode(false);
      invalidateProspectWrites();
      setLoggedInUser(null); setCurrentUser(null); setTab("dashboard"); setMenuOpen(false);
      try { localStorage.removeItem('arflow_user'); } catch {}
    });
  };
  const handleExpiredCrmSession = () => {
    if (expiredCrmAlertShownRef.current) return;
    expiredCrmAlertShownRef.current = true;
    invalidateProspectWrites();
    // Uma sessão inválida não pode exigir que o consultor salve um follow-up
    // antes de sair: a própria gravação requer uma sessão válida.
    setLoggedInUser(null);
    setCurrentUser(null);
    setTab("dashboard");
    setMenuOpen(false);
    try { localStorage.removeItem('arflow_user'); } catch {}
    window.alert("Sua sessão de login expirou. Entre novamente antes de enviar mensagens ou salvar afazeres. Mensagens recusadas pelo servidor NÃO foram enviadas.");
  };
  const loadConversationHistory = ({ storeId, phone, tailOnly = false,older=false }) => {
    const canonicalStoreId = Number(storeId);
    const canonicalPhone = normalizePhone(phone);
    const identity = conversationKey(canonicalStoreId, canonicalPhone);
    if (!identity) return Promise.resolve(false);
    const diagnostic = loadConversationDiagnostic(canonicalStoreId, canonicalPhone);
    const pending = conversationHistoryLoadsRef.current.get(identity);
    const tailDuringBackfill = Boolean(pending && tailOnly);
    const requestIdentity = tailDuringBackfill ? `${identity}:tail` : identity;
    const prior = conversationHistoryLoadsRef.current.get(requestIdentity);
    if (prior) { conversationMark(diagnostic, "load_history_pending"); return prior; }
    const endFetch = conversationPhase(diagnostic, "fetch");
    const readIdentity = `${currentUserRef.current?.id}:${identity}`;
    const request = readConversationHistory({
      storeId:canonicalStoreId, phone:canonicalPhone,
      tailOnly:tailDuringBackfill,
      older,
      state:conversationHistoryReadStatesRef.current.get(readIdentity),
      headers:conversationHeaders(diagnostic),
    }).then(({ payload, state }) => {
      endFetch();
      conversationMark(diagnostic, "fetch_status", { status:200 });
      if (!tailDuringBackfill) conversationHistoryReadStatesRef.current.set(readIdentity, state);
      publishHistoryState(canonicalStoreId,canonicalPhone,state);
      if (conversationKey(payload.storeId, payload.phone) !== identity) {
        conversationMark(diagnostic, "load_history_identity_rejected");
        throw new Error("histórico individual retornou uma identidade diferente");
      }
      prepareConversationMerges(diagnostic, [
        "merge_whatsapp",
        ...(payload.leadId ? ["merge_lead_messages", "merge_lead_events"] : []),
        ...(payload.prospId != null ? ["merge_prospect_messages"] : []),
      ]);
      const endSetState = conversationPhase(diagnostic, "set_state_schedule");
      setWhatsappMsgs(previous => observeConversationMerge(diagnostic, "merge_whatsapp", () =>
        mergeIndividualConversationPayload(previous, payload, canonicalStoreId, canonicalPhone)));
      if (payload.leadId) {
        setLeadMessages(previous => observeConversationMerge(diagnostic, "merge_lead_messages", () => ({
          ...(previous || {}),
          [payload.leadId]:mergeConversationMessages(previous?.[payload.leadId], payload.leadMessages),
        })));
        setLeadEvents(previous => observeConversationMerge(diagnostic, "merge_lead_events", () => ({
          ...(previous || {}),
          [payload.leadId]:{
            ...(previous?.[payload.leadId] || {}),
            ...(payload.leadEvents || {}),
          },
        })));
      }
      if (payload.prospId != null) {
        setProspMensagens(previous => observeConversationMerge(diagnostic, "merge_prospect_messages", () => ({
          ...(previous || {}),
          [payload.prospId]:mergeConversationMessages(previous?.[payload.prospId], payload.prospMessages),
        })));
      }
      endSetState();
      observeConversationFrame(diagnostic);
      return true;
    }).catch(error => {
      if (error.status === 401) handleExpiredCrmSession();
      endFetch();
      conversationMark(diagnostic, "load_history_failure");
      console.warn("[CRM] falha ao carregar histórico individual");
      return false;
    }).finally(() => {
      finishConversationDiagnostic(diagnostic);
      if (conversationHistoryLoadsRef.current.get(requestIdentity) === request) {
        conversationHistoryLoadsRef.current.delete(requestIdentity);
      }
    });
    conversationHistoryLoadsRef.current.set(requestIdentity, request);
    return request;
  };
  conversationHistoryLoaderRef.current = loadConversationHistory;
  setHistoryPageLoader(loadConversationHistory);

  const handleCloseMonth = () => {
    const now = new Date();
    const MN = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
    const monthLabel = `${MN[now.getMonth()]}/${now.getFullYear()}`;
    const yearMonth  = `${now.getFullYear()}_${String(now.getMonth()+1).padStart(2,"0")}`;
    if (!window.confirm(`Fechar o mês de ${monthLabel.toUpperCase()}?\n\nOs dados serão arquivados no Histórico. Os cartões e suas conversas serão preservados; os indicadores mensais passam para o próximo mês.`)) return;
    const monthRange = {
      from:new Date(now.getFullYear(), now.getMonth(), 1),
      to:new Date(now.getFullYear(), now.getMonth()+1, 0, 23, 59, 59, 999),
    };
    const cTotals = {};
    USERS.filter(u=>u.role==="consultant").forEach(u => {
      cTotals[u.id] = computeOriginBreakdown({
        clients, leads:auroraLeads, prospeccao, periodRange:monthRange,
        storeId:u.storeId, consultantId:u.id,
      }).totalValue;
    });
    const snapshot = {
      yearMonth, label:monthLabel, closedAt:now.toISOString().split("T")[0],
      clients:[...clients],
      // Mantido apenas para auditoria de importações antigas; não integra o total comercial.
      legacyManualSales:{...realSales},
      realSales:{...realSales},
      consultorTotals:cTotals,
    };
    const newHistorico = [snapshot, ...historico.filter(m=>m.yearMonth!==snapshot.yearMonth)];
    fbSet('arflow_historico', newHistorico);
    setHistorico(newHistorico);
    const cm=now.getMonth(), cy=now.getFullYear();
    // Month closing archives reporting, never deletes operational/financial
    // cards. Date filters, not removal of contacts, define the next month.
    const zeros = Object.fromEntries(Object.keys(REAL_SALES).map(k=>[k,0]));
    setRealSales(zeros);
    fbSet('arflow_data/sales', zeros);
    fbSet('arflow_data/month', {key:`${cy}_${cm+1}`});
    setTab("historico");
  };

  // Envia mensagem SEMPRE via /api/send-message (fila segura no servidor) —
  // nunca mais direto pro Z-API a partir do browser. Isso garante ritmo
  // controlado, dedup e retry mesmo com vários consultores no mesmo número.
  // storeContext separa a loja responsável (permissão) do canal original (Z-API).
  // Valores numéricos antigos continuam significando que as duas lojas são iguais.
  const sendZapiMessage = async (phone, text, user, quotedMsgId, storeContext, quotedMsg=null, retryMessage=null, transportOptions=null) => {
    let phoneClean;
    try {
      phoneClean = normalizePhone(phone);
    } catch (error) {
      return { ok:false, error:error.message || "Informe um WhatsApp válido.", uncertain:false };
    }
    if (!phoneClean || typeof text !== "string" || !text.trim()) {
      return { ok:false, error:"Informe um WhatsApp e uma mensagem válidos.", uncertain:false };
    }
    let responsibleStoreId;
    let effectiveStoreId;
    try {
      ({ responsibleStoreId, channelStoreId:effectiveStoreId } =
        normalizeOutboundStoreContext(storeContext, currentUser?.storeId));
    } catch (error) {
      return { ok:false, error:error.message || "Não foi possível identificar a loja do envio.", uncertain:false };
    }
    const msgId = retryMessage?.id ? String(retryMessage.id) : transportOptions?.clientMsgId || `${Date.now()}`;
    const effectiveQuotedMsgId = quotedMsgId
      || retryMessage?.quotedMsg?.providerMessageId
      || retryMessage?.quotedMsg?.waMessageId
      || null;
    const effectiveQuotedMsg = quotedMsg || retryMessage?.quotedMsg || null;
    const retryFields = retryMessage
      ? Object.fromEntries(Object.entries(retryMessage).filter(([key]) => key !== "id"))
      : {};
    const quotePreview = effectiveQuotedMsgId ? {
      id: effectiveQuotedMsgId,
      texto: effectiveQuotedMsg?.texto || effectiveQuotedMsg?.caption || "",
      tipo: effectiveQuotedMsg?.tipo || effectiveQuotedMsg?.type || "text",
      url: effectiveQuotedMsg?.storagePath ? null : (effectiveQuotedMsg?.url || effectiveQuotedMsg?.base64Data || null),
      ...(effectiveQuotedMsg?.storagePath ? { storagePath: effectiveQuotedMsg.storagePath } : {}),
      ...(effectiveQuotedMsg?.mediaPermanent === true ? { mediaPermanent:true, storageProvider:effectiveQuotedMsg.storageProvider || null } : {}),
      fromMe: effectiveQuotedMsg?.remetente === "consultor" || effectiveQuotedMsg?.fromMe === true,
    } : null;
    const msg = { ...retryFields, remetente:"consultor", texto:text, timestamp:new Date().toISOString(), status:"pending", motivo:null,
      storeId: effectiveStoreId,
      senderName: loggedInUser?.name ?? null,
      senderUserId: loggedInUser?.id ?? null,
      senderRole: loggedInUser?.role ?? null,
      ...(effectiveQuotedMsgId ? { quotedMsgId:effectiveQuotedMsgId, quotedMsg:quotePreview } : {}),
    };
    const conversationPath = conversationMessagePath(effectiveStoreId, phoneClean, msgId);
    if (!conversationPath) return { ok:false, error:"Não foi possível identificar a conversa do envio.", uncertain:false };
    const cacheKey = conversationKey(effectiveStoreId, phoneClean);
    const messageRef = dbRef(conversationPath);
    // Real history is created by the authenticated server from its durable
    // queue. A browser-only attempt must not survive reload as fake "pending".
    if (_demoMode) (retryMessage ? update(messageRef, msg) : set(messageRef, msg)).catch(()=>{});
    if (_demoMode) setWhatsappMsgs(prev=>({ ...prev, [cacheKey]:{ ...(prev[cacheKey]||{}), [msgId]:{ ...(prev[cacheKey]?.[msgId]||{}), ...msg } } }));
    // Modo demo: grava a mensagem no namespace demo_ mas não chama o Z-API
    if (_demoMode) {
      setTimeout(() => {
        const patch = { status:'sent', waAck: 1 };
        update(dbRef(conversationPath), patch).catch(()=>{});
        setWhatsappMsgs(prev=>({ ...prev, [cacheKey]:{ ...(prev[cacheKey]||{}), [msgId]:{ ...msg, ...patch } } }));
      }, 600);
      return { ok:false, error:"Envio real indisponível no modo de demonstração.", uncertain:false };
    }
    const _updateStatus = (s, motivo) => {
      if (!_demoMode && !retryMessage) return;
      const patch = motivo ? { status: s, motivo } : { status: s, motivo: null };
      if (_demoMode) update(dbRef(conversationPath), patch).catch(()=>{});
      setWhatsappMsgs(prev=>({
        ...prev,
        [cacheKey]:{ ...(prev[cacheKey]||{}), [msgId]:{ ...(prev[cacheKey]?.[msgId]||msg), status:s, motivo:motivo||null } }
      }));
    };
    const _markUnconfirmed = async () => {
      // A POST response may be lost AFTER the server has already reflected
      // "sent" in Firebase. Never overwrite that durable status with a local
      // network error. An unconfirmed warning is local until the server speaks.
      try {
        const stored = (await Promise.race([
          get(messageRef).then(snapshot => snapshot.val()),
          new Promise((_, reject) => setTimeout(() => reject(new Error("status lookup timed out")), 4000)),
        ])) || null;
        // A stored "failed" may belong to the PREVIOUS manual attempt on
        // this same bubble; only positive in-flight/sent evidence is safe.
        if (["sent", "sending", "retry"].includes(stored?.status)) {
          setWhatsappMsgs(prev=>({
            ...prev,
            [cacheKey]:{ ...(prev[cacheKey]||{}), [msgId]:{ ...(prev[cacheKey]?.[msgId]||msg), ...stored } }
          }));
          return;
        }
      } catch (_) { /* Network is still unavailable; status remains unknown. */ }
      if (!retryMessage) return;
      setWhatsappMsgs(prev=>({
        ...prev,
        [cacheKey]:{ ...(prev[cacheKey]||{}), [msgId]:{ ...(prev[cacheKey]?.[msgId]||msg), status:"blocked", motivo:WA_SEND_UNCONFIRMED_MOTIVO } }
      }));
    };
    if (!responsibleStoreId || !effectiveStoreId) {
      const error = "Loja não identificada neste contato — abra a conversa pela lista da loja correta";
      _updateStatus("failed", error);
      return { ok:false, error, uncertain:false };
    }
    try {
      const { response:r, data:d, uncertain } = await postQueuedText({
        storeId: responsibleStoreId, channelStoreId: effectiveStoreId, phone: phoneClean, message: text, type: "text",
        consultantId: currentUser?.id ?? user?.id ?? null,
        consultantName: currentUser?.name ?? user?.name ?? null,
        clientMsgId: msgId,
        quotedMsgId: effectiveQuotedMsgId,
      }, { shouldContinue:transportOptions?.shouldContinue || (() => true) });
      if (uncertain) {
        await _markUnconfirmed();
        if (isCrmSessionExpired(r, d)) handleExpiredCrmSession();
        return { ok:false, error:d?.error || WA_SEND_UNCONFIRMED_MOTIVO, uncertain:true };
      }
      if (!r?.ok || !d || !d.ok) {
        const sessionExpired = isCrmSessionExpired(r, d);
        const motivo = sessionExpired
          ? CRM_SESSION_EXPIRED_MOTIVO
          : (d?.duplicate ? "Mensagem duplicada — já enviada há poucos segundos" : (d?.error || `Falha ao enfileirar envio${r?.status ? ` (HTTP ${r.status})` : ""}`));
        console.error("[send-queue] falha ao enfileirar", d);
        _updateStatus("failed", motivo);
        if (sessionExpired) handleExpiredCrmSession();
        return { ok:false, error:motivo, uncertain:false };
      }
      if (d.duplicate === true && !isQueueTextAcceptance(r, d, msgId)) {
        // Uma nova bolha criada pelo compositor pode bater na deduplicação por
        // conteúdo. Ela nunca deve ficar no histórico como uma segunda mensagem
        // vermelha: o envio existente continua sendo a única fonte de verdade.
        if (!retryMessage) {
          return { ok:false, error:"Envio duplicado; a mensagem existente foi mantida.", uncertain:false };
        }
        const existingStatus = ['pending','sending','retry','sent','failed','blocked'].includes(d.duplicateStatus)
          ? d.duplicateStatus
          : 'pending';
        _updateStatus(existingStatus, d.duplicateMotivo || null);
        return { ok:false, error:d.duplicateMotivo || "Envio duplicado; a mensagem existente foi mantida.", uncertain:false };
      }
      if (!isQueueTextAcceptance(r, d, msgId)) {
        return { ok:false, error:"O servidor não confirmou a entrada da mensagem na fila. Tente novamente.", uncertain:true };
      }
      const acceptedStoreId = Number(d.routedStoreId || effectiveStoreId);
      const acceptedCacheKey = conversationKey(acceptedStoreId, phoneClean);
      // Publish only after durable queue acceptance. Preserve a newer status
      // already received from the server while awaiting the POST response.
      setWhatsappMsgs(prev => ({
        ...prev,
        [acceptedCacheKey]:{
          ...(prev[acceptedCacheKey] || {}),
          [msgId]:{ ...msg, status:d.duplicate === true ? d.duplicateStatus : d.status, storeId:acceptedStoreId, ...(prev[acceptedCacheKey]?.[msgId] || {}) },
        },
      }));
      // Mensagem entrou na fila do servidor — status "pending" fica até o
      // backend processar e refletir sent/failed em arflow_whatsapp/{msgId}.
      return { ok:true, messageId:msgId, queueItemId:d.id, channelStoreId:acceptedStoreId, responsibleStoreId };
    } catch (err) {
      console.error("[send-queue] erro de rede ao enfileirar", err);
      await _markUnconfirmed();
      return { ok:false, error:err.message || WA_SEND_UNCONFIRMED_MOTIVO, uncertain:true };
    }
  };

  // A remoção é confirmada no servidor antes de a mensagem ser marcada como
  // apagada no Firebase. Não há edição local porque a Z-API não oferece edição
  // de mensagens comuns — assim CRM e WhatsApp permanecem coerentes.
  const deleteWhatsAppMessage = async (phone, message, storeIdOverride) => {
    const phoneClean = normalizePhone(phone);
    const crmMessageId = message?.crmMessageId || message?.id;
    const storeId = storeIdOverride ?? message?.storeId ?? currentUser?.storeId;
    if (!phoneClean || !crmMessageId || !storeId) throw new Error("Não foi possível identificar a mensagem ou a loja.");
    const response = await fetch('/api/delete-message', {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      body: JSON.stringify({ phone:phoneClean, crmMessageId, providerMessageId:message?.providerMessageId || message?.waMessageId || null, storeId }),
    });
    const data = await response.json().catch(() => null);
    if (!response.ok || !data?.ok) throw new Error(data?.error || "Não foi possível confirmar a exclusão no WhatsApp.");
    return data;
  };

  const editWhatsAppMessage = async (phone, message, text, storeIdOverride) => {
    const phoneClean = normalizePhone(phone);
    const storeId = storeIdOverride ?? message?.storeId ?? currentUser?.storeId;
    const crmMessageId = message?.crmMessageId || message?.id;
    const providerMessageId = message?.providerMessageId || message?.waMessageId;
    if (!phoneClean || !storeId || !crmMessageId || !providerMessageId) throw new Error("Mensagem ainda não confirmada pelo WhatsApp.");
    const response = await fetch('/api/edit-message', {
      method:'POST', headers:{ 'Content-Type':'application/json' },
      body:JSON.stringify({ phone:phoneClean, storeId, crmMessageId, providerMessageId, message:text }),
    });
    const data = await response.json().catch(()=>null);
    if (!response.ok || !data?.ok) throw new Error(data?.error || "Não foi possível confirmar a edição no WhatsApp.");
    return data;
  };

  const markWaRead = (phone) => {
    const identity = String(phone || "");
    const separator = identity.indexOf(":");
    if (separator <= 0) return;
    const readStoreId = Number(identity.slice(0, separator));
    const readPhone = identity.slice(separator + 1);
    if (!conversationKey(readStoreId, readPhone)) return;
    const readAt = new Date().toISOString();
    pushReadCutoffsRef.current.values[identity] = readAt;
    setWaReadAt(prev=>({ ...prev, [identity]:readAt }));
    const eventId = new URLSearchParams(window.location.search).get("eventId");
    sendPushTelemetry("open", eventId);
    pushEvents.filter(event => Number(event.storeId) === readStoreId && normalizePhone(event.phone) === normalizePhone(readPhone) && !event.firstViewedAt)
      .forEach(event => sendPushTelemetry("view", event.eventId));
    setPushEvents(events => events.map(event => Number(event.storeId) === readStoreId && normalizePhone(event.phone) === normalizePhone(readPhone) && !event.firstViewedAt
      ? { ...event, firstViewedAt:new Date().toISOString() } : event));
  };

  const addLead = async (newLead) => {
    const response = await fetch('/api/leads/manual', {
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify(newLead),
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok || !result.ok || !result.lead) {
      throw new Error(result.error || `Não foi possível criar o lead (HTTP ${response.status})`);
    }
    const savedLead = { ...result.lead, id:result.leadKey || result.lead.id };
    setAuroraLeads(prev => prev.some(lead => lead.id === savedLead.id)
      ? prev.map(lead => lead.id === savedLead.id ? { ...lead, ...savedLead } : lead)
      : [...prev, savedLead]);
    return savedLead;
  };

  const updateLead = async (updated) => {
    const transferReason = updated?._transferReason;
    const transferOnly = updated?._transferOnly === true;
    updated = {...updated};
    delete updated._transferReason;
    delete updated._transferOnly;
    updated = sanitizeProjectedRecord(
      updated,
      auroraLeads.find(lead => lead.id === updated?.id || lead._rawPhone === updated?._rawPhone) || {},
    );
    const rawPhoneKey = updated._rawPhone || "";
    const phoneKey = rawPhoneKey.includes("_")
      ? rawPhoneKey
      : normalizePhone(rawPhoneKey || updated.telefone || "");
    const today = new Date().toISOString().split("T")[0];
    const TERMINAL_STAGES_L = ["fechou_venda","desqualificado"];
    const needsFechamento = TERMINAL_STAGES_L.includes(updated.estagio) && !updated.data_fechamento;
    // Grava fechou_venda_em (mês do fechamento) para filtro mensal da coluna
    const needsFechouVendaEm = updated.estagio === "fechou_venda" && !updated.fechou_venda_em;
    // Consolida os três campos de atribuição em toda edição. Isso repara
    // automaticamente registros antigos que ainda tinham Jaíne no id, mas Ana
    // já aparecia como responsável na conversa.
    const resolvedConsultantId = updated.responsavel === "aurora" ? null : resolveLeadConsultantId(updated);
    const finalUpdated = {
      ...updated,
      ...(needsFechamento   ? { data_fechamento: today } : {}),
      ...(needsFechouVendaEm ? { fechou_venda_em: today } : {}),
      ...(updated.responsavel === "aurora"
        ? { consultantId:null, consultorAtual:null, assignedConsultantId:null }
        : resolvedConsultantId != null
          ? { consultantId:resolvedConsultantId, consultorAtual:resolvedConsultantId, assignedConsultantId:resolvedConsultantId }
          : {}),
    };
    // ── Transferência cross-store: muda storeId ────────────────────────────
    // Quando admin move lead para consultor de outra loja, o lead precisa migrar
    // de leads/{oldStore}_{phone} para leads/{newStore}_{phone} para ser visível
    // e comunicável pela loja de destino (inclusive no webhook de entrada).
    // `id` é derivado do telefone e pode ser igual em registros compostos de
    // lojas diferentes. A chave Firebase é a identidade da edição.
    const existingLead = auroraLeads.find(l => l._rawPhone === updated._rawPhone)
      || auroraLeads.find(l => l.id === updated.id && Number(l.storeId) === Number(updated._previousStoreId))
      || (updated.manualFechamento === true
        ? auroraLeads.find(l => l.id === updated.id && l.manualFechamento === true
          && Number(l.storeId) === Number(updated.storeId))
        : null);
    if (manualSaleWriteDenied({
      user:currentUserRef.current || currentUser,
      previousStage:existingLead?._crm_estagio ?? existingLead?.estagio
        ?? (existingLead?.manualFechamento ? "fechou_venda" : undefined),
      nextStage:finalUpdated.estagio,
      saleStages:["fechou_venda"],
      creatingSale:!existingLead && finalUpdated.estagio === "fechou_venda",
    })) {
      throw new Error(MANUAL_SALE_CUTOFF_NOTICE);
    }
    const priorConsultantId = resolveLeadConsultantId(existingLead || {});
    const changesOwnership = resolvedConsultantId != null
      && Number(priorConsultantId) !== Number(resolvedConsultantId);
    if (!isDemoMode && changesOwnership && [22, 31].includes(Number(resolvedConsultantId))) {
      const message = "Este consultor está desativado e não pode receber novos leads.";
      window.alert(message);
      throw new Error(message);
    }
    if (finalUpdated.proxima_data_contato
      && finalUpdated.proxima_data_contato !== existingLead?.proxima_data_contato) {
      finalUpdated.ultima_atualizacao = new Date().toISOString();
    }
    const oldStoreId   = existingLead?.storeId;
    const newStoreId   = updated.storeId;
    const wasDisqualified = isDisqualifiedLead(existingLead || {});
    const isNowDisqualified = isDisqualifiedLead(finalUpdated);
    const stopDisqualifiedFollowUp = async () => {
      if (wasDisqualified || !isNowDisqualified || isDemoMode || !phoneKey) return;
      try {
        const response = await fetch('/api/crm/commercial-followup/stop-for-disqualification', {
          method:'POST',
          credentials:'same-origin',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({
            storeId:finalUpdated.storeId ?? finalUpdated.lojaAtual ?? finalUpdated.lojaOrigem,
            phone:normalizePhone(finalUpdated.telefone || phoneKey),
          }),
        });
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.error || `HTTP ${response.status}`);
        }
      } catch (error) {
        console.error('[commercial-followup] não foi possível interromper plano desqualificado:', error);
        throw new Error(`Lead salvo, mas o Motor de Follow-up não foi interrompido: ${error.message}`);
      }
    };
    const isCrossStore = oldStoreId && newStoreId && Number(oldStoreId) !== Number(newStoreId);
    const isConsultantTransfer = existingLead && resolvedConsultantId != null
      && (Number(priorConsultantId) !== Number(resolvedConsultantId) || isCrossStore);
    if (isConsultantTransfer && isDemoMode) Object.assign(finalUpdated, transferScheduleChanges(existingLead));

    if (isConsultantTransfer && !isDemoMode) {
      const response = await fetch('/api/leads/transfer', {
        method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          leadKey:existingLead._rawPhone || phoneKey,
          consultantId:Number(resolvedConsultantId),
          expectedConsultantId:priorConsultantId ?? null,
          expectedStoreId:Number(oldStoreId || existingLead.lojaAtual || existingLead.lojaOrigem || 0),
          expectedOwnershipGeneration:Number(existingLead.ownershipTransferGeneration) || 0,
          reason:transferReason,
        }),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.ok) {
        const message = result.error || 'Não foi possível concluir a transferência.';
        window.alert(message);
        throw new Error(message);
      }
      // Preserve edits made in the same form submission without letting the
      // browser rewrite any ownership, store, channel or transfer-history field.
      const businessPatch = transferOnly ? {} : transferBusinessPatch(finalUpdated);
      [
        'consultantId','assignedConsultantId','consultorAtual','responsavel','storeId',
        'lojaAtual','lojaOrigem','whatsappStoreId','historicoTransferencias',
        'ownershipHistory','ownershipTransferGeneration','ownershipTransferPendingId',
        'lastOwnershipTransferId','_ownershipTransferRecoveryConflicts',
        '_prev_store_ids','id','_source','_rawPhone','_prevStoreIds',
      ].forEach(field => delete businessPatch[field]);
      if (!transferOnly) await update(dbRef(`leads/${result.leadKey}`), Object.fromEntries(
        Object.entries({ ...businessPatch, _crm_estagio:businessPatch.estagio }).filter(([, value]) => value !== undefined)
      ));
      const confirmedLead = confirmedTransferredLead(
        existingLead, result.lead, businessPatch, result.leadKey
      );
      setAuroraLeads(previous => previous.map(lead => lead.id === existingLead.id
        ? confirmedLead : lead));
      await stopDisqualifiedFollowUp();
      return confirmedLead;
    }

    if (isCrossStore) {
      const phone      = normalizePhone(updated.telefone || existingLead?.telefone);
      const newPhoneKey = `${newStoreId}_${phone}`;
      const destinationLead = auroraLeads.find(l => l._rawPhone === newPhoneKey);
      if (destinationLead && destinationLead._rawPhone !== existingLead?._rawPhone) {
        const message = "Já existe um lead deste telefone na loja de destino. A transferência foi interrompida para não misturar duas conversas. Revise ou consolide os cadastros antes de transferir.";
        alert(message);
        throw new Error(message);
      }
      // Acumula histórico de lojas anteriores para continuar exibindo msgs antigas
      const prevIds = [...(existingLead._prevStoreIds||[]), Number(oldStoreId)].filter(Boolean);
      const {
        id:_id, _source:_src, _rawPhone:_rp, _prevStoreIds:_ps,
        consultantId:_consultantId, assignedConsultantId:_assignedConsultantId,
        consultorAtual:_consultorAtual, responsavel:_responsavel,
        storeId:_storeId, lojaAtual:_lojaAtual, lojaOrigem:_lojaOrigem,
        whatsappStoreId:_whatsappStoreId, _prev_store_ids:_previousStores,
        historicoTransferencias:_transferHistory,
        ownershipTransferGeneration:_ownershipGeneration,
        ownershipTransferPendingId:_pendingTransferId,
        lastOwnershipTransferId:_lastTransferId,
        ownershipHistory:_ownershipHistory,
        _ownershipTransferRecoveryConflicts:_recoveryConflicts,
        ...rest
      } = finalUpdated;
      const originalStoreId = Number(
        existingLead.whatsappStoreId
        ?? existingLead.lojaOrigem
        ?? finalUpdated.lojaOrigem
        ?? oldStoreId
      );
      const toWrite = Object.fromEntries(
        Object.entries({
          ...rest,
          _crm_estagio: rest.estagio,
          storeId: Number(newStoreId),
          _prev_store_ids: prevIds,
          // Canal imutável: responsabilidade e visibilidade podem trocar, mas
          // todas as respostas continuam no WhatsApp que iniciou a conversa.
          whatsappStoreId: originalStoreId,
          lojaOrigem: originalStoreId,
          lojaAtual:  Number(newStoreId),
          historicoTransferencias: rest.historicoTransferencias ?? existingLead.historicoTransferencias ?? {},
        }).filter(([, v]) => v !== undefined)
      );
      // Atualização atômica: só remove a origem quando o mesmo commit já tiver
      // gravado o destino. Isso evita que uma queda de rede deixe dois nós ativos.
      if (phoneKey && phoneKey !== newPhoneKey) {
        await update(dbRef("leads"), { [newPhoneKey]: toWrite, [phoneKey]: null });
      } else {
        await set(dbRef(`leads/${newPhoneKey}`), toWrite);
      }
      // Não faz update otimista do estado — o onValue('leads') vai reconstruir
      // com o novo fbKey e _rawPhone corretos assim que Firebase confirmar.
      await stopDisqualifiedFollowUp();
      return { ...finalUpdated, ...toWrite, _rawPhone:newPhoneKey };
    }

    if (phoneKey) {
      const {
        id:_id, _source:_src, _rawPhone:_rp, _prevStoreIds:_ps,
        consultantId:_consultantId, assignedConsultantId:_assignedConsultantId,
        consultorAtual:_consultorAtual, responsavel:_responsavel,
        storeId:_storeId, lojaAtual:_lojaAtual, lojaOrigem:_lojaOrigem,
        whatsappStoreId:_whatsappStoreId, _prev_store_ids:_previousStores,
        historicoTransferencias:_transferHistory,
        ownershipTransferGeneration:_ownershipGeneration,
        ownershipTransferPendingId:_pendingTransferId,
        lastOwnershipTransferId:_lastTransferId,
        ownershipHistory:_ownershipHistory,
        _ownershipTransferRecoveryConflicts:_recoveryConflicts,
        ...rest
      } = finalUpdated;
      // _crm_estagio é um campo protegido — a normalização dá prioridade a ele
      // sobre qualquer campo estagio/status que o N8N possa sobrescrever com set()
      // filter(v !== undefined): Firebase RTDB lança TypeError síncrono se receber `undefined`
      const toWrite = Object.fromEntries(
        Object.entries({ ...rest, _crm_estagio: rest.estagio }).filter(([, v]) => v !== undefined)
      );
      await update(dbRef(`leads/${phoneKey}`), protectLeadBindingPatch(toWrite,existingLead,
        confirmedBindingForCard("leads",existingLead,liftSales)||confirmedFinancialLeadBinding(existingLead,clients)));
    } else if (finalUpdated.id && String(finalUpdated.id).startsWith("_vm_")) {
      // Lead manual (fechamento avulso) — salva/atualiza pelo id composto
      await set(dbRef(`leads/${finalUpdated.id}`), finalUpdated);
    } else {
      throw new Error("Não foi possível identificar o registro do lead para salvar.");
    }
    setAuroraLeads(prev => prev.map(l => l.id===updated.id ? finalUpdated : l));
    await stopDisqualifiedFollowUp();
    const confirmed = isDemoMode ? finalUpdated
      : await confirmCard("leads", finalUpdated, existingLead || {});
    setAuroraLeads(previous => previous.map(record => record.id === confirmed.id ? confirmed : record));
    if (confirmed.proxima_data_contato && confirmed.followUpUpdatedAt !== existingLead?.followUpUpdatedAt) {
      const toastId = Date.now();
      setToasts(previous => [...previous, { id:toastId, type:"message", msg:`✅ Agendado para ${fmtDate(confirmed.proxima_data_contato)}` }]);
      setTimeout(() => setToasts(previous => previous.filter(toast => toast.id !== toastId)), 5000);
    }
    return confirmed;
  };

  // Leads da Aurora usam um id artificial `aurora_${telefone}` só pra chave do
  // React (ver normalização em auroraLeads) — mas no Firebase o nó real vive em
  // `leads/{telefone}` (ou `leads/{_rawPhone}` pra leads manuais). Usar o `id`
  // direto como caminho no Firebase (bug antigo) fazia delete/merge miraram um
  // caminho inexistente e nunca apagavam nada de verdade.
  const leadFbKey = (lead) => {
    if (!lead) return null;
    if (lead._rawPhone) return lead._rawPhone;
    const id = lead.id || "";
    return id.startsWith("aurora_") ? id.slice(7) : id;
  };

  const deleteLead = (leadId) => {
    // Só o Gestor Geral pode excluir leads (gerentes/consultores não podem).
    if (!currentUser || currentUser.role !== "admin") {
      alert("Apenas o Gestor Geral pode excluir leads.");
      return;
    }
    const lead = auroraLeads.find(l => l.id === leadId);
    const fbKey = leadFbKey(lead) || (leadId.startsWith("aurora_") ? leadId.slice(7) : leadId);
    setAuroraLeads(prev => prev.filter(l => l.id !== leadId));
    set(dbRef(`leads/${fbKey}`), null).catch(()=>{});
  };

  // Mescla um grupo de leads duplicados (mesmo telefone) em um único registro.
  // primaryId = id do lead que deve permanecer; os demais são apagados após
  // terem seus dados úteis (campos vazios no principal) copiados para ele.
  const mergeLeads = (groupLeads, primaryId) => {
    const sanitizedGroup = (groupLeads || []).map(lead => sanitizeProjectedRecord(
      lead,
      auroraLeads.find(rawLead => rawLead.id === lead?.id) || {},
    ));
    const primary = sanitizedGroup.find(l => l.id === primaryId);
    if (!primary) return;
    const others = sanitizedGroup.filter(l => l.id !== primaryId);
    const merged = { ...primary };
    const camposIgnorados = new Set(["id", "_source", "_rawPhone"]);
    let notasExtras = [];
    others.forEach(o => {
      Object.keys(o).forEach(k => {
        if (camposIgnorados.has(k)) return;
        const val = o[k];
        if (val === undefined || val === null || val === "") return;
        if (merged[k] === undefined || merged[k] === null || merged[k] === "") {
          merged[k] = val;
        } else if (k === "motivo_desqualificacao" && merged[k] !== val) {
          notasExtras.push(val);
        } else if (k === "tentativas_followup") {
          merged[k] = (Number(merged[k]) || 0) + (Number(val) || 0);
        }
      });
    });
    if (notasExtras.length) {
      merged.motivo_desqualificacao = [merged.motivo_desqualificacao, ...notasExtras].filter(Boolean).join(" | ");
    }
    merged.mesclado_de = [...(primary.mesclado_de || []), ...others.map(o => o.id)];
    setAuroraLeads(prev => {
      const otherIds = new Set(others.map(o => o.id));
      return prev.filter(l => !otherIds.has(l.id)).map(l => l.id === primaryId ? merged : l);
    });
    const { id:_id, _source:_src, _rawPhone:_rp, ...mergedForFirebase } = merged;
    set(dbRef(`leads/${leadFbKey(primary)}`), mergedForFirebase).catch(()=>{});
    others.forEach(o => { remove(dbRef(`leads/${leadFbKey(o)}`)).catch(()=>{}); });
  };

  const sendLeadMessage = (leadId, msg) => {
    const msgId = `${Date.now()}`;
    set(dbRef(`arflow_lead_messages/${leadId}/${msgId}`), msg).catch(()=>{});
    setLeadMessages(prev => ({
      ...prev,
      [leadId]: { ...(prev[leadId]||{}), [msgId]: msg },
    }));
  };

  const logLeadTransfer = (leadId, de, para) => {
    if (!leadId || de === para) return;
    const eventId = `ev_${Date.now()}`;
    const event = { tipo:"transferencia", de, para, timestamp: new Date().toISOString() };
    set(dbRef(`arflow_lead_events/${leadId}/${eventId}`), event).catch(()=>{});
    setLeadEvents(prev => ({ ...prev, [leadId]: { ...(prev[leadId]||{}), [eventId]: event } }));
  };

  // Devolve um cliente para a fila da Aurora: mantém todo o histórico, apenas
  // desvincula o consultor responsável. Registra um evento de auditoria.
  const returnClientToAurora = async (clientId, motivo) => {
    const client = (clientsRef.current || []).find(item => String(item.id) === String(clientId));
    if (!client || !client.consultantId) return;
    try {
      const updatedClient = await transferClientOwnership(client, null, motivo);
      setClients(current => current.map(item => item.id === updatedClient.id ? updatedClient : item));
      return updatedClient;
    } catch (error) {
      console.error("[client-transfer] devolução à Aurora falhou:", error.message);
      window.alert(error.message || "Não foi possível devolver o cartão à Aurora. Atualize a ficha e tente novamente.");
      throw error;
    }
  };

  // Registrar Venda a partir de qualquer conversa (Leads, Prospecção, Atendimento
  // Presencial, Central de Conversas) — mantém o histórico do chat e move o
  // contato para a etapa de venda concluída correspondente ao seu módulo.
  const openManualSaleModal = (target) => {
    if (!canManuallyRegisterSale(currentUserRef.current || currentUser)) {
      window.alert(MANUAL_SALE_CUTOFF_NOTICE);
      return;
    }
    setVendaModalTarget(target);
  };

  const handleRegistrarVenda = async (saleData) => {
    if (!canManuallyRegisterSale(currentUserRef.current || currentUser)) {
      throw new Error(MANUAL_SALE_CUTOFF_NOTICE);
    }
    const target = vendaModalTarget;
    if (!target) return;
    const saleRequestScope = prospectLiveScopeRef.current;
    const today = new Date().toISOString().split("T")[0];
    const noteExtra = [
      saleData.formaPagamento ? `Forma de pagamento: ${saleData.formaPagamento}` : null,
      saleData.observacoes || null,
    ].filter(Boolean).join(" — ");
    const { moduleId, phone, name, sourceId, sourceStoreId } = target;
    const resolvedModule = moduleId === "inbox"
      ? (target.contactType === "lead" ? "leads" : target.contactType === "prosp" ? "prospeccao" : "kanban")
      : moduleId === "admin" ? "kanban" : moduleId;
    const origin = resolvedModule === "leads" ? "Lead" : resolvedModule === "prospeccao" ? "Prospecção" : "Atendimento Presencial";
    const product = saleData.produtos || "";
    const prospectForSale = resolvedModule === "prospeccao"
      ? resolveSaleSource(prospeccao, { sourceId, sourceStoreId, phone, storeId:target.storeId }, ["phone", "telefone"])
      : null;
    if (resolvedModule === "prospeccao" && !prospectForSale) {
      throw new Error("Não foi possível encontrar a Prospecção. A venda não foi gravada.");
    }

    // ── Lembretes automáticos (entrega, follow-up, pós-venda, próxima venda) ──
    // Mesma lógica/textos usados no fechamento pelo ClientModal, agora disparados
    // independente do módulo de origem da venda.
    const scheduleReminders = (consultantId, storeId, exactLink = null) => {
      const link = exactLink || {};
      if (saleData.deliveryDate) {
        addReminder({ id: Date.now()+1, ...link, consultantId, storeId, text: `📦 Entrega hoje — ${name} · ${product}`, clientName: name, dueDate: saleData.deliveryDate, status:"pending", createdAt: today, doneAt:null, type:"entrega" });
      }
      if (saleData.followUp) {
        addReminder({ id: Date.now()+2, ...link, consultantId, storeId, text: `📅 Follow-up — ${name} · ${product}`, clientName: name, dueDate: saleData.followUp, status:"pending", createdAt: today, doneAt:null, type:"followup" });
      }
      if (saleData.posVendaDate) {
        addReminder({ id: Date.now()+3, ...link, consultantId, storeId, text: `⭐ Pós-venda — ligar para ${name} · ${product}`, clientName: name, dueDate: saleData.posVendaDate, status:"pending", createdAt: today, doneAt:null, type:"posvenda" });
      }
      if (saleData.nextSaleDate) {
        addReminder({ id: Date.now()+4, ...link, consultantId, storeId, text: `🔄 Próxima Venda — ofertar para ${name}${saleData.nextSaleNote ? " · " + saleData.nextSaleNote : ""}`, clientName: name, dueDate: saleData.nextSaleDate, status:"pending", createdAt: today, doneAt:null, type:"nextSale" });
      }
    };

    if (resolvedModule === "kanban") {
      // Lê clients diretamente do closure (event handler → state atual garantido pelo React)
      // Side effects (Firebase write + lembretes) FORA do state updater — evita double-fire
      // Resolve pelo id do card de origem (sourceId). Buscar só por telefone pegava o
      // primeiro registro com o mesmo número (ficha financeira, atendimento antigo,
      // outra loja) e o card "Em acompanhamento" nunca virava "Fechado".
      const client = resolveSaleSource(clients, { sourceId, sourceStoreId, phone, storeId:target.storeId }, ["phone", "telefone"])
        || (!sourceId ? clients.find(c => phonesMatchGlobal(normalizePhone(c.phone), normalizePhone(phone))) : null);
      if (client) {
        const finalConsultantId = saleData.consultantId || client.consultantId;
        const updatedClient = {
          ...client,
          stage: "closed",
          value: saleData.valor,
          paidValue: saleData.valor,
          product: product || client.product || "",
          consultantId: finalConsultantId,
          storeId: saleData.storeId || client.storeId,
          data_fechamento: saleData.data || today,
          note: [client.note, noteExtra].filter(Boolean).join(" | "),
          origin: client.origin || origin,
          deliveryDate: saleData.deliveryDate || client.deliveryDate,
          followUp: saleData.followUp || client.followUp,
          posVendaDate: saleData.posVendaDate || client.posVendaDate,
          nextSaleDate: saleData.nextSaleDate || client.nextSaleDate,
          nextSaleValue: saleData.nextSaleDate ? saleData.valor : client.nextSaleValue,
          nextSaleNote: saleData.nextSaleNote || client.nextSaleNote,
        };
        await updateClient(updatedClient);
        scheduleReminders(finalConsultantId, saleData.storeId || client.storeId,
          String(sourceId ?? "") === String(client.id) ? { clientId:String(client.id) } : null);
      } else {
        throw new Error("Não foi possível encontrar o Atendimento para registrar a venda.");
      }
    } else if (resolvedModule === "prospeccao") {
      // Lê prospeccao diretamente do closure — mesma razão acima
      const item = prospectForSale;
      if (item) {
        const finalConsultantId = saleData.consultantId || item.consultantId;
        const updatedItem = {
          ...item,
          stage: "venda",
          value: saleData.valor,
          product: product || item.product || "",
          saleDate: saleData.data || today,
          observation: [item.observation, noteExtra].filter(Boolean).join(" | "),
          origin: item.origin || origin,
          forma_pagamento: saleData.formaPagamento || item.forma_pagamento || "",
          observacoes_venda: saleData.observacoes || item.observacoes_venda || "",
          deliveryDate: saleData.deliveryDate || item.deliveryDate,
          followUp: saleData.followUp || item.followUp,
          posVendaDate: saleData.posVendaDate || item.posVendaDate,
          nextSaleDate: saleData.nextSaleDate || item.nextSaleDate,
          nextSaleValue: saleData.nextSaleDate ? saleData.valor : item.nextSaleValue,
          nextSaleNote: saleData.nextSaleNote || item.nextSaleNote,
        };
        const itemWrite = await persistProspecao(null, { patches:[{
          id:item.id,
          storeId:item.storeId,
          changes:{
            stage:updatedItem.stage,
            value:updatedItem.value,
            product:updatedItem.product,
            saleDate:updatedItem.saleDate,
            observation:updatedItem.observation,
            origin:updatedItem.origin,
            forma_pagamento:updatedItem.forma_pagamento,
            observacoes_venda:updatedItem.observacoes_venda,
            deliveryDate:updatedItem.deliveryDate,
            followUp:updatedItem.followUp,
            posVendaDate:updatedItem.posVendaDate,
            nextSaleDate:updatedItem.nextSaleDate,
            nextSaleValue:updatedItem.nextSaleValue,
            nextSaleNote:updatedItem.nextSaleNote,
          },
        }] });
        if (prospectWriteWasStale(itemWrite)
          || !prospectOperationIsCurrent({
            requestScope:saleRequestScope,
            currentScope:prospectLiveScopeRef.current,
          })) return;
        const savedProspItem = firstConfirmedProspectWrite(itemWrite)?.record;
        await saveFinancialSaleSheet("prospeccao", savedProspItem || item, saleData);
        if (!prospectOperationIsCurrent({
          requestScope:saleRequestScope,
          currentScope:prospectLiveScopeRef.current,
        })) return;
         scheduleReminders(finalConsultantId, saleData.storeId || item.storeId, { prospId:String(item.id) });
      } else {
        throw new Error("Não foi possível encontrar a Prospecção para registrar a venda.");
      }
    } else if (resolvedModule === "leads") {
      const lead = resolveSaleSource(auroraLeads, { sourceId, sourceStoreId, phone, storeId:target.storeId }, ["telefone", "phone"]);
      if (lead) {
        const finalConsultantId = saleData.consultantId || lead.consultantId;
        // Todos os campos opcionais recebem `|| null` para evitar `undefined`.
        // Firebase RTDB lança TypeError síncrono ao receber `undefined` em update(),
        // o que fazia o modal travar em "Salvando..." pois .finally() nunca era registrado.
        await updateLead({
          ...lead,
          estagio: "fechou_venda",
          saleConfirmedAt: new Date().toISOString(),
          fechou_venda_em: saleData.data || today,
          data_fechamento: saleData.data || today,
          valor_venda: saleData.valor,
          produto_anuncio: product || lead.produto_anuncio || "",
          produto_venda: product || lead.produto_venda || lead.produto_anuncio || "",
          consultantId: finalConsultantId,
          storeId: saleData.storeId || lead.storeId,
          motivo_desqualificacao: [lead.motivo_desqualificacao, noteExtra].filter(Boolean).join(" | ") || null,
          origin: lead.origin || origin,
          forma_pagamento: saleData.formaPagamento || lead.forma_pagamento || "",
          observacoes_venda: saleData.observacoes || lead.observacoes_venda || "",
          deliveryDate: saleData.deliveryDate || lead.deliveryDate || null,
          followUp: saleData.followUp || lead.followUp || null,
          posVendaDate: saleData.posVendaDate || lead.posVendaDate || null,
          nextSaleDate: saleData.nextSaleDate || lead.nextSaleDate || null,
          nextSaleValue: saleData.nextSaleDate ? saleData.valor : (lead.nextSaleValue || null),
          nextSaleNote: saleData.nextSaleNote || lead.nextSaleNote || null,
        });
        const savedFinancialSale = await saveFinancialSaleSheet("lead", {
          ...lead,
          estagio: "fechou_venda",
          valor_venda: saleData.valor,
          data_fechamento: saleData.data || today,
          produto_venda: product || lead.produto_venda || lead.produto_anuncio || "",
          consultantId: finalConsultantId,
          storeId: saleData.storeId || lead.storeId,
          forma_pagamento: saleData.formaPagamento || lead.forma_pagamento || "",
          observacoes_venda: saleData.observacoes || lead.observacoes_venda || "",
          deliveryDate: saleData.deliveryDate || lead.deliveryDate || null,
          followUp: saleData.followUp || lead.followUp || null,
          posVendaDate: saleData.posVendaDate || lead.posVendaDate || null,
          nextSaleDate: saleData.nextSaleDate || lead.nextSaleDate || null,
          nextSaleValue: saleData.nextSaleDate ? saleData.valor : (lead.nextSaleValue || null),
          nextSaleNote: saleData.nextSaleNote || lead.nextSaleNote || null,
        }, saleData);
        // Attribution is additive and must never affect a completed sale. The
        // server verifies explicit IDs and same-store ownership; a failed
        // attribution write is surfaced but does not roll back the sale.
        try {
          const attributionResponse = await fetch("/api/crm/marketing-intelligence/sale-link", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({
              storeId: savedFinancialSale.storeId,
              leadId: String(lead.id),
              saleId: `lead:${String(lead.id)}`,
              financialSaleId: String(savedFinancialSale.id),
            }),
          });
          if (!attributionResponse.ok) throw new Error(`HTTP ${attributionResponse.status}`);
        } catch (error) {
          console.error("[marketing-intelligence] sale attribution link failed after sale save:", error);
          const attributionToastId = Date.now();
          setToasts(previous => [...previous, {
            id: attributionToastId,
            msg: "⚠️ Venda salva, mas o vínculo de atribuição não foi registrado.",
            type: "message",
          }]);
          setTimeout(() => setToasts(previous => previous.filter(toast => toast.id !== attributionToastId)), 8000);
        }
         scheduleReminders(finalConsultantId, saleData.storeId || lead.storeId, {
           leadId:`aurora_${String(lead._rawPhone || lead.id).replace(/^aurora_/, "")}`,
         });
      } else {
        throw new Error("Não foi possível encontrar o Lead para registrar a venda.");
      }
    }

    const commercialStoreId = canonicalSaleChannelStore(
      target,
      saleData.storeId || sourceStoreId || currentUser?.storeId,
    ) || 0;
    const commercialSourceId = [
      "sale",
      resolvedModule,
      sourceId || normalizePhone(phone),
      saleData.data || today,
      saleData.valor == null ? "" : String(saleData.valor),
    ].join(":");
    if (commercialStoreId > 0 && normalizePhone(phone)) {
      try {
        const commercialResponse = await fetch("/api/commercial-events", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            type: "sale_registered",
            storeId: commercialStoreId,
            phone: normalizePhone(phone),
            sourceId: commercialSourceId,
            occurredAt: new Date().toISOString(),
          }),
        });
        if (!commercialResponse.ok) throw new Error(`HTTP ${commercialResponse.status}`);
      } catch (error) {
        console.error("[commercial-engine] sale_registered failed after sale confirmation:", error);
      }
    } else {
      console.error("[commercial-engine] sale_registered skipped: storeId/phone ausente após venda confirmada", {
        storeId: commercialStoreId,
        phone,
      });
    }

    const toastId = Date.now();
    setToasts(t => [...t, { id: toastId, msg: `🎉 Venda de ${name || phone} registrada com sucesso!`, type:"message" }]);
    setTimeout(() => setToasts(prev => prev.filter(t=>t.id!==toastId)), 5000);
    setVendaModalTarget(null);
  };

  // `fileOrExistingMsg` aceita dois formatos:
  // - um File/Blob novo (envio original, escolhido pelo consultor)
  // - o objeto de mensagem já salvo em Firebase (reenvio de uma mídia que
  //   falhou — usa o base64Data/url já gravado, sem exigir escolher o arquivo
  //   de novo, já que o File original não sobrevive além da memória da sessão)
  // storeContext: mesmo mecanismo de sendZapiMessage — autorização pela loja
  // responsável e envio pelo número original.
  const sendZapiMedia = async (phone, fileOrExistingMsg, tipo, storeContext, quotedMsgId=null, quotedMsg=null) => {
    const phoneClean = normalizePhone(phone);
    if (!phoneClean) throw new Error("Sem telefone");

    const isRetry = !(fileOrExistingMsg instanceof Blob);
    // effectiveStoreId declarado aqui para ser usado tanto no branch QR quanto no normal
    const { responsibleStoreId, channelStoreId:effectiveStoreId } =
      normalizeOutboundStoreContext(storeContext, currentUser?.storeId);
    // Quick Reply media — URL já no Firebase Storage, sem precisar converter base64
    if (fileOrExistingMsg?._isQRMedia) {
      if (!phoneClean || !effectiveStoreId) return;
      const qrMsgId = `${Date.now()}`;
      const qrMsg = { remetente:"consultor", tipo, timestamp:new Date().toISOString(), status:"pending", url:fileOrExistingMsg.url,
        storeId: effectiveStoreId,
        senderName: loggedInUser?.name ?? null,
        senderUserId: loggedInUser?.id ?? null,
        senderRole: loggedInUser?.role ?? null,
        ...(quotedMsgId ? { quotedMsgId, quotedMsg:{
          id:quotedMsgId, texto:quotedMsg?.texto || quotedMsg?.caption || "", tipo:quotedMsg?.tipo || quotedMsg?.type || "text",
          url:quotedMsg?.storagePath ? null : (quotedMsg?.url || quotedMsg?.base64Data || null),
          ...(quotedMsg?.storagePath ? { storagePath:quotedMsg.storagePath } : {}),
          fromMe:quotedMsg?.remetente === "consultor" || quotedMsg?.fromMe === true,
        } } : {}),
      };
      const qrConversationPath = conversationMessagePath(effectiveStoreId, phoneClean, qrMsgId);
      const qrCacheKey = conversationKey(effectiveStoreId, phoneClean);
      if (!qrConversationPath || !qrCacheKey) return;
      set(dbRef(qrConversationPath), qrMsg).catch(()=>{});
      setWhatsappMsgs(prev => ({ ...prev, [qrCacheKey]: {...(prev[qrCacheKey]||{}), [qrMsgId]:qrMsg} }));
      const qrMediaType = tipo==="video" ? "video" : "image";
      fetch('/api/send-message', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ storeId:responsibleStoreId, channelStoreId:effectiveStoreId, phone:phoneClean, type:qrMediaType, mediaUrl:fileOrExistingMsg.url, caption:"", clientMsgId:qrMsgId, consultantId:currentUser?.id??null, consultantName:currentUser?.name??null, quotedMsgId:quotedMsgId||null })
      }).then(r=>r.json().catch(()=>null)).then(d=>{
        if (!d?.ok) {
          update(dbRef(qrConversationPath), { status:"failed", motivo:d?.error||"Falha ao enviar mídia" }).catch(()=>{});
        } else if (d.routedStoreId && Number(d.routedStoreId) !== Number(effectiveStoreId)) {
          remove(dbRef(qrConversationPath)).catch(()=>{});
          setWhatsappMsgs(prev => relocateConversationMessage(prev, {
            fromStoreId:effectiveStoreId,
            toStoreId:Number(d.routedStoreId),
            phone:phoneClean,
            messageId:qrMsgId,
            message:qrMsg,
          }));
        }
      }).catch(()=>update(dbRef(qrConversationPath), { status:"failed" }).catch(()=>{}));
      return;
    }
    // Passa storeIdOverride para que o retry também use o Z-API correto (ex: loja de origem do lead)
    if (isRetry) return retryZapiMedia(phoneClean, fileOrExistingMsg, tipo, storeContext);
    const file = fileOrExistingMsg;

    // ── 1. Guarda foto/vídeo antes de gravar no histórico ─────────────────────
    // Mídia visual segue como binário para o App Storage. Isso evita base64 no
    // RTDB e elimina o antigo fallback para Firebase Storage, que não existe
    // neste projeto para arquivos maiores.
    const isPermanentMedia = tipo === "imagem" || tipo === "video" || tipo === "documento";
    const MAX_B64 = 16 * 1024 * 1024; // áudio (o único fluxo que ainda converte)
    let base64Data = null;
    let durableStorageUrl = null;
    let durableStoragePath = null;
    let durableTenantId = null;
    const documentContentType = tipo === "documento" ? documentMimeType(file) : null;
    const msgId = `${Date.now()}`;
    const timestamp = new Date().toISOString();
    if (!isPermanentMedia && file.size <= MAX_B64) {
      try {
        base64Data = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload  = e => resolve(e.target.result);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      } catch { base64Data = null; }
    }

    if (isPermanentMedia) {
      const fallbackMime = tipo === "imagem" ? "image/jpeg" : tipo === "video" ? "video/mp4" : documentContentType;
      const contentType = uploadMimeType(file, tipo) || fallbackMime;
      const uploadController = new AbortController();
      const uploadTimeout = setTimeout(() => uploadController.abort(), 60000);
      try {
        const persistent = await fetch('/api/permanent-media-upload', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': contentType,
            'X-Arflow-Store-Id': String(effectiveStoreId || ''),
            'X-Arflow-Responsible-Store-Id': String(responsibleStoreId || ''),
            'X-Arflow-Phone': phoneClean,
            'X-Arflow-Message-Id': msgId,
            ...(tipo === "documento" ? { 'X-Arflow-Document-Extension': documentExtension(file) } : {}),
          },
          body: file,
          signal: uploadController.signal,
        });
        const saved = await persistent.json().catch(() => null);
        if (!persistent.ok || !saved?.ok || !saved?.storagePath || !saved?.url) {
          if (isCrmSessionExpired(persistent, saved)) {
            handleExpiredCrmSession();
            throw new Error(CRM_SESSION_EXPIRED_MOTIVO);
          }
          throw new Error(saved?.error || 'upload recusado');
        }
        durableStorageUrl = saved.url;
        durableStoragePath = saved.storagePath;
        durableTenantId = saved.tenantId || null;
        base64Data = null; // Nunca persiste mídia visual no RTDB.
      } catch (storageErr) {
        console.warn("[sendZapiMedia] não foi possível criar cópia permanente de mídia:", storageErr.message);
        const uploadReason = storageErr?.name === 'AbortError'
          ? `O envio ${tipo === "imagem" ? "da foto" : tipo === "documento" ? "do documento" : "do vídeo"} demorou mais de 60 segundos e foi cancelado. Verifique sua conexão e tente novamente.`
          : (storageErr.message || `Não foi possível guardar ${tipo === "imagem" ? "a foto" : tipo === "documento" ? "o documento" : "o vídeo"} permanentemente. Tente novamente.`);
        throw new Error(uploadReason);
      } finally {
        clearTimeout(uploadTimeout);
      }
    }

    // ── 2. Grava no Firebase DB imediatamente (exibe no chat sem depender de Storage) ──
    const msg = { remetente:"consultor", tipo, timestamp, status:"pending",
      ...(base64Data ? { base64Data } : {}),
      ...(durableStorageUrl ? { url: durableStorageUrl, storagePath: durableStoragePath, mediaPermanent: true, storageProvider:"replit", ...(durableTenantId ? { tenantId:durableTenantId } : {}) } : {}),
      ...(tipo === "documento" ? { documentExtension:documentExtension(file), documentFileName:file.name, documentMime:documentContentType, documentSize:file.size } : {}),
      storeId: effectiveStoreId,
      senderName: loggedInUser?.name ?? null,
      senderUserId: loggedInUser?.id ?? null,
      senderRole: loggedInUser?.role ?? null,
      ...(quotedMsgId ? { quotedMsgId, quotedMsg:{
        id:quotedMsgId, texto:quotedMsg?.texto || quotedMsg?.caption || "", tipo:quotedMsg?.tipo || quotedMsg?.type || "text",
        url:quotedMsg?.storagePath ? null : (quotedMsg?.url || quotedMsg?.base64Data || null),
        ...(quotedMsg?.storagePath ? { storagePath:quotedMsg.storagePath } : {}),
        ...(quotedMsg?.mediaPermanent === true ? { mediaPermanent:true, storageProvider:quotedMsg.storageProvider || null } : {}),
        fromMe:quotedMsg?.remetente === "consultor" || quotedMsg?.fromMe === true,
      } } : {}),
    };
    const mediaConversationPath = conversationMessagePath(effectiveStoreId, phoneClean, msgId);
    const mediaCacheKey = conversationKey(effectiveStoreId, phoneClean);
    if (!mediaConversationPath || !mediaCacheKey) return msgId;
    set(dbRef(mediaConversationPath), msg).catch(()=>{});
    setWhatsappMsgs(prev => ({ ...prev, [mediaCacheKey]: { ...(prev[mediaCacheKey]||{}), [msgId]: msg } }));

    const _updateMediaStatus = (s, motivo, extra) => {
      const patch = { status:s, motivo: motivo || null, ...(extra||{}) };
      update(dbRef(mediaConversationPath), patch).catch(()=>{});
      setWhatsappMsgs(prev => ({
        ...prev,
        [mediaCacheKey]: { ...(prev[mediaCacheKey]||{}), [msgId]: { ...(prev[mediaCacheKey]?.[msgId]||msg), ...patch } }
      }));
    };

    // ── 3. Envia via /api/send-message (fila segura no servidor) ──
    // O servidor lê fotos/vídeos diretamente do App Storage e manda a data URL
    // para a Z-API. A URL privada de visualização nunca é passada ao provedor.
    if (!responsibleStoreId || !effectiveStoreId) { _updateMediaStatus("failed", "Loja não identificada nesta conversa"); return msgId; }

    let mediaValue = isPermanentMedia ? null : base64Data;

    // ── Áudio: converter webm→OGG Opus no servidor antes de enviar ao Z-API ──
    // O Chrome grava em audio/webm que o WhatsApp não suporta. O servidor usa ffmpeg
    // para converter e devolve o OGG como base64 diretamente — o Z-API recebe os bytes
    // sem precisar buscar uma URL externa (busca externa era a causa do "áudio mudo":
    // Z-API às vezes não conseguia acessar o servidor Replit para baixar o arquivo).
    if (tipo === "audio" && base64Data) {
      try {
        const uploadResp = await fetch('/api/audio-upload', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ base64: base64Data }),
        });
        const uploadJson = await uploadResp.json().catch(() => null);
        if (uploadResp.ok && (uploadJson?.url || uploadJson?.base64Ogg)) {
          // Usa a URL pública do servidor — o Z-API baixa o OGG diretamente.
          // base64 como PTT não é suportado pelo Z-API; a URL /api/audio/:id.ogg
          // fica disponível por 20 min no cache do servidor (tempo suficiente).
          mediaValue = uploadJson.url
            ? `${window.location.origin}${uploadJson.url}`
            : uploadJson.base64Ogg;
          // Guarda o OGG já convertido para reenvios — não depende do webm original.
          update(dbRef(mediaConversationPath), { convertedAudioUrl: mediaValue }).catch(()=>{});
          setWhatsappMsgs(prev => ({ ...prev, [mediaCacheKey]: { ...(prev[mediaCacheKey]||{}), [msgId]: { ...(prev[mediaCacheKey]?.[msgId]||msg), convertedAudioUrl: mediaValue } } }));
        } else {
          const reason = uploadJson?.error || `HTTP ${uploadResp.status}`;
          console.error('[sendZapiMedia] conversão de áudio falhou:', reason);
          _updateMediaStatus("failed", "Não foi possível converter o áudio para um formato que o WhatsApp suporta. Tente gravar novamente.");
          return msgId;
        }
      } catch (convErr) {
        console.error('[sendZapiMedia] erro de rede na conversão de áudio:', convErr.message);
        _updateMediaStatus("failed", "Erro de rede ao converter o áudio. Tente novamente.");
        return msgId;
      }
    }

    const mediaType = tipo==="imagem" ? "image" : tipo==="audio" ? "audio" : tipo === "documento" ? "documento" : "video";
    const isDataUrl = typeof mediaValue === "string" && mediaValue.startsWith("data:");
    fetch('/api/send-message', {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        storeId: responsibleStoreId, channelStoreId: effectiveStoreId, phone: phoneClean, type: mediaType,
        ...(durableStoragePath ? { mediaStoragePath: durableStoragePath } : (isDataUrl ? { mediaBase64: mediaValue } : { mediaUrl: mediaValue })),
        caption: "",
        ...(tipo === "documento" ? { documentExtension:documentExtension(file), documentFileName:file.name, documentMime:documentContentType, documentSize:file.size } : {}),
        consultantId: currentUser?.id ?? null,
        consultantName: currentUser?.name ?? null,
        clientMsgId: msgId,
          quotedMsgId: quotedMsgId || null,
      }),
    }).then(async r => {
      const d = await r.json().catch(() => null);
      if (!d || !d.ok) {
        console.error("[send-queue] falha ao enfileirar mídia", d);
        const sessionExpired = isCrmSessionExpired(r, d);
        _updateMediaStatus("failed", sessionExpired
          ? CRM_SESSION_EXPIRED_MOTIVO
          : (d?.duplicate ? "Mensagem duplicada — já enviada há poucos segundos" : (d?.error || "Falha ao enfileirar envio")));
        if (sessionExpired) handleExpiredCrmSession();
      } else if (d.routedStoreId && Number(d.routedStoreId) !== Number(effectiveStoreId)) {
        remove(dbRef(mediaConversationPath)).catch(()=>{});
        setWhatsappMsgs(prev => relocateConversationMessage(prev, {
          fromStoreId:effectiveStoreId,
          toStoreId:Number(d.routedStoreId),
          phone:phoneClean,
          messageId:msgId,
          message:msg,
        }));
      }
      // Sucesso: status "pending" fica até o backend refletir sent/failed via clientMsgId.
    }).catch((err) => {
      console.error("[send-queue] erro de rede ao enfileirar mídia", err);
      _updateMediaStatus("failed", "Erro de rede ao enviar");
    });
    return msgId;
  };

  // Reenvia uma mídia (foto/áudio/vídeo) que falhou, usando o base64/URL já
  // salvo em Firebase no momento do primeiro envio — não exige que o
  // consultor selecione o arquivo de novo (o File original não fica
  // guardado depois que a mensagem sai da memória).
  const retryZapiMedia = async (phone, m, _tipo, storeContext) => {
    const phoneClean = normalizePhone(phone);
    if (!phoneClean || !m?.id) return;
    const tipo = m.tipo || m.type;
    const msgId = m.id;
    const { responsibleStoreId, channelStoreId:effectiveStoreId } =
      normalizeOutboundStoreContext(storeContext, currentUser?.storeId);
    const retryConversationPath = conversationMessagePath(effectiveStoreId, phoneClean, msgId);
    const retryCacheKey = conversationKey(effectiveStoreId, phoneClean);
    if (!retryConversationPath || !retryCacheKey) return;
    const _updateMediaStatus = (s, motivo, extra) => {
      const patch = { status:s, motivo: motivo || null, ...(extra||{}) };
      update(dbRef(retryConversationPath), patch).catch(()=>{});
      setWhatsappMsgs(prev => ({
        ...prev,
        [retryCacheKey]: { ...(prev[retryCacheKey]||{}), [msgId]: { ...(prev[retryCacheKey]?.[msgId]||m), ...patch } }
      }));
    };
    // Áudio: o Z-API não aceita o webm que o Chrome grava — prefere a URL OGG já
    // convertida no primeiro envio (convertedAudioUrl); só reconverte o base64
    // bruto se essa URL não tiver sido salva (mensagens antigas).
    const hasPermanentCopy = (tipo === "imagem" || tipo === "video" || tipo === "documento") && m.storageProvider === "replit" && m.storagePath;
    let mediaValue = tipo === "audio" ? (m.convertedAudioUrl || m.url) : (m.base64Data || m.url);
    if (!mediaValue) mediaValue = m.base64Data || m.url;
    if ((!mediaValue && !hasPermanentCopy) || !tipo) {
      console.error("[retryZapiMedia] sem base64/URL salvos para reenviar", m);
      _updateMediaStatus("failed", MEDIA_UNAVAILABLE_MOTIVO);
      return;
    }
    // Limpa o ✓✓ de leitura antigo (se houver) na hora — a tentativa nova vai
    // gerar um zaapId próprio no backend (reflectStatusToChat já limpa lá
    // também); aqui é só pra UI não mostrar ticks "herdados" enquanto espera
    // a confirmação da fila.
    _updateMediaStatus("pending", null, { waAck: null, waAckAt: null });
    if (!responsibleStoreId || !effectiveStoreId) { _updateMediaStatus("failed", "Loja não identificada nesta conversa"); return; }
    // Se só temos o base64 bruto (webm) do gravador, converte pra OGG antes de reenviar —
    // mesma conversão feita no envio original (ver sendZapiMedia).
    if (tipo === "audio" && !m.convertedAudioUrl && typeof mediaValue === "string" && mediaValue.startsWith("data:")) {
      try {
        const uploadResp = await fetch('/api/audio-upload', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ base64: mediaValue }),
        });
        const uploadJson = await uploadResp.json().catch(() => null);
        if (!uploadResp.ok || (!uploadJson?.url && !uploadJson?.base64Ogg)) {
          const reason = uploadJson?.error || `HTTP ${uploadResp.status}`;
          console.error('[retryZapiMedia] conversão de áudio falhou:', reason);
          _updateMediaStatus("failed", "Falha ao converter áudio para reenvio — tente novamente em instantes");
          return;
        }
        mediaValue = uploadJson.url
          ? `${window.location.origin}${uploadJson.url}`
          : uploadJson.base64Ogg;
        update(dbRef(retryConversationPath), { convertedAudioUrl: mediaValue }).catch(()=>{});
        setWhatsappMsgs(prev => ({ ...prev, [retryCacheKey]: { ...(prev[retryCacheKey]||{}), [msgId]: { ...(prev[retryCacheKey]?.[msgId]||m), convertedAudioUrl: mediaValue } } }));
      } catch (convErr) {
        console.error('[retryZapiMedia] conversão de áudio falhou:', convErr.message);
        _updateMediaStatus("failed", "Falha ao converter áudio para reenvio — tente novamente em instantes");
        return;
      }
    }
    const mediaType = tipo==="imagem" ? "image" : tipo==="audio" ? "audio" : tipo === "documento" ? "documento" : "video";
    const isDataUrl = typeof mediaValue === "string" && mediaValue.startsWith("data:");
    try {
      const r = await fetch('/api/send-message', {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          storeId: responsibleStoreId, channelStoreId: effectiveStoreId, phone: phoneClean, type: mediaType,
          ...(hasPermanentCopy ? { mediaStoragePath: m.storagePath } : (isDataUrl ? { mediaBase64: mediaValue } : { mediaUrl: mediaValue })),
          caption: "",
          ...(tipo === "documento" ? { documentExtension:m.documentExtension, documentFileName:m.documentFileName, documentMime:m.documentMime, documentSize:m.documentSize } : {}),
          consultantId: currentUser?.id ?? null,
          consultantName: currentUser?.name ?? null,
          clientMsgId: msgId,
          quotedMsgId: m.quotedMsg?.providerMessageId || m.quotedMsg?.waMessageId || null,
        }),
      });
      const d = await r.json().catch(() => null);
      if (!d || !d.ok) {
        const sessionExpired = isCrmSessionExpired(r, d);
        const motivo = sessionExpired
          ? CRM_SESSION_EXPIRED_MOTIVO
          : (d?.duplicate ? "Mensagem duplicada — já enviada há poucos segundos" : (d?.error || "Falha ao enfileirar envio"));
        console.error("[send-queue] falha ao reenfileirar mídia", d);
        _updateMediaStatus("failed", motivo);
        if (sessionExpired) handleExpiredCrmSession();
      }
    } catch (err) {
      console.error("[send-queue] erro de rede ao reenviar mídia", err);
      _updateMediaStatus("failed", "Erro de rede ao enviar");
    }
  };

  const toggleReminder = (id) => {
    const key = String(id);
    if (reminderCompletionRequests.current.has(key)) return reminderCompletionRequests.current.get(key);
    const target = displayReminders.find(r => r && String(r.id) === key);
    if (!target) return Promise.reject(new Error("Lembrete não encontrado. Atualize a lista."));
    if (target.status === "done") return Promise.resolve({ reminder:target });
    const willBeDone = true;
    const operationUserId = currentUser.id;
    if (target.source === "commercial_tracking" && target.type === "consultant_reply_required") {
      return Promise.reject(new Error("Responda ao cliente para concluir esta pendência."));
    }
    setCompletingReminderIds(ids => new Set(ids).add(key));
    const request = (async () => {
      const result = isDemoMode
        ? { reminder:{ ...target, status:"done", doneAt:new Date().toISOString() } }
        : await persistReminderCompletion(target);
      if (currentUserRef.current?.id !== operationUserId) return result;
      if (result.commercialState) {
        setCommercialTracking(previous => ({ ...previous, [result.commercialState.conversationId]:result.commercialState }));
        setConfirmedCommercialReminders(previous =>
          [...previous.filter(reminder => String(reminder.id) !== key), result.reminder]);
      } else {
        confirmedReminderCompletions.current.set(key, result.reminder);
        setReminders(rs => rs.map(reminder => String(reminder.id) === key ? result.reminder : reminder));
      }
    if (willBeDone && target.clientName) {
      const norm = (s) => (s||"").trim().toLowerCase();
      const upcoming = reminders
        .filter(Boolean)
        .filter(r => r.id !== id && r.status === "pending" && r.clientName && norm(r.clientName) === norm(target.clientName))
        .sort((a,b)=>(a.dueDate||"9999")<(b.dueDate||"9999")?-1:1)[0];
      const toastId = Date.now();
      const msg = upcoming
        ? `✔ "${target.text}" concluído. Próxima ação: ${upcoming.text}${upcoming.dueDate?` em ${fmtDate(upcoming.dueDate)}`:""}`
        : `✔ "${target.text}" concluído.`;
      setToasts(prev => [...prev, { id:toastId, msg, type: upcoming ? "nextaction" : "message" }]);
      setTimeout(() => setToasts(prev => prev.filter(t=>t.id!==toastId)), 7000);
    }
      return result;
    })().catch(error => {
      const id = Date.now();
      setToasts(items => [...items, { id, type:"message",
        msg:`Não foi possível concluir: ${error.message}. O afazer voltou para a lista.` }]);
      setTimeout(() => setToasts(items => items.filter(item => item.id !== id)), 7000);
      throw error;
    }).finally(() => {
      setCompletingReminderIds(ids => { const next = new Set(ids); next.delete(key); return next; });
      if (reminderCompletionRequests.current.get(key) === request) reminderCompletionRequests.current.delete(key);
    });
    reminderCompletionRequests.current.set(key, request);
    return request;
  };
  const addReminder = (r) => {
    // Tipos que têm no máximo 1 lembrete ativo por cliente ao mesmo tempo.
    // Ao agendar o próximo, o anterior (pending) é cancelado automaticamente.
    const SINGLE_ACTIVE_TYPES = new Set(["followup","posvenda","nextSale","entrega"]);
    const normN = s => (s||"").trim().toLowerCase();
    const nowIso = new Date().toISOString();
    // filter(Boolean) elimina nulos que podem vir do Firebase RTDB em arrays esparsos
    let base = reminders.filter(Boolean);
    if (r.type && SINGLE_ACTIVE_TYPES.has(r.type)
      && (r.clientId || r.prospId || r.leadId || r.clientName)) {
      base = base.map(ex => {
        if (ex.status !== "pending" || ex.type !== r.type) return ex;
        const sameEntity = r.clientId
          ? String(ex.clientId ?? "") === String(r.clientId)
          : r.prospId
            ? String(ex.prospId ?? "").replace(/^aurora_/, "") === String(r.prospId).replace(/^aurora_/, "")
            : r.leadId
              ? String(ex.leadId ?? "").replace(/^aurora_/, "") === String(r.leadId).replace(/^aurora_/, "")
              : !ex.clientId && !ex.prospId && !ex.leadId
                && r.clientName && ex.clientName && normN(ex.clientName) === normN(r.clientName);
        return sameEntity ? { ...ex, status:"done", doneAt:nowIso } : ex;
      });
    }
    const next = [r, ...base];
    if (isDemoMode) {
      setReminders(next);
      return { ok:true, reminder:r };
    }
    return postScopedReminder(r, { diagnostic:reminderDiagnostic(r) }).then(({ response, payload, uncertain }) => {
      if (uncertain) {
        return { ok:false, uncertain:true, error:operationFailureMessage("reminder",
          "A conversa continua aberta; tente novamente mais tarde.", { uncertain:true }) };
      }
      if (!response.ok || payload.ok !== true) {
        if (response.status === 401) handleExpiredCrmSession();
        return {
          ok:false,
          sessionExpired:response.status === 401,
          error:operationFailureMessage("reminder", payload?.error || `Não foi possível criar o afazer (HTTP ${response.status}).`),
        };
      }
      const saved = payload.reminder || r;
      const replacedIds = new Set((payload.replacedIds || []).map(String));
      setReminders(previous => [
        saved,
        ...previous.filter(Boolean).filter(item => String(item.id) !== String(saved.id))
          .map(item => replacedIds.has(String(item.id))
            ? { ...item, status:"done", doneAt:new Date().toISOString() } : item),
      ]);
      void reloadScopedReminders().catch(error =>
        console.error("[CRM] não foi possível atualizar os afazeres:", error.message));
      return { ok:true, reminder:saved };
    }).catch(error => {
      console.error("[CRM] não foi possível criar o afazer:", error.message);
      return { ok:false, error:"Não foi possível confirmar o agendamento. Tente novamente." };
    });
  };
  const deleteReminder = (id) => {
    const target = reminders.find(reminder => reminder?.id === id);
    if (!target) return;
    if (isDemoMode) {
      setReminders(rs => rs.filter(Boolean).filter(r=>r.id!==id));
      return;
    }
    setReminders(rs => rs.filter(Boolean).filter(r=>r.id!==id));
    void fetch(`/api/crm/reminders/${encodeURIComponent(id)}`, {
      method:"DELETE", credentials:"same-origin", headers:{ Accept:"application/json" },
    }).then(response => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return reloadScopedReminders();
    }).catch(error => reloadScopedReminders().catch(() => {
      setReminders(rs => rs.some(reminder => reminder?.id === id) ? rs : [target, ...rs]);
      console.error("[CRM] não foi possível excluir o afazer:", error.message);
    }));
  };
  const persistProspecao = (value, { deleteIds = [], patches = [] } = {}) => {
    const current = (prospeccaoRef.current || []).filter(Boolean);
    const projected = Array.isArray(value)
      ? value
      : value instanceof Function ? value(current) : null;
    const next = projected == null ? current : sanitizeProjectedRecords(projected, current);
    let operations;
    try {
      operations = planProspectItemOperations(current, next, { deleteIds, patches });
    } catch (error) {
      return Promise.reject(error);
    }
    const previousById = new Map(current.map(item => [String(item.id), item]));
    const blockedSale = operations.map(operation => {
      const previous = previousById.get(String(operation.id));
      const candidate = operation.operation === "create"
        ? operation.record
        : { ...previous, ...(operation.changes || {}) };
      return manualSaleWriteDenied({
        user:currentUserRef.current || currentUser,
        previousStage:previous?.stage,
        nextStage:candidate?.stage,
        saleStages:["venda"],
        creatingSale:operation.operation === "create" && candidate?.stage === "venda",
      }) ? candidate : null;
    }).find(Boolean);
    if (blockedSale) {
      window.alert(MANUAL_SALE_CUTOFF_NOTICE);
      return Promise.reject(new Error(MANUAL_SALE_CUTOFF_NOTICE));
    }
    if (!operations.length) return Promise.resolve([]);

    const requestScope = getProspectScope();
    if (!prospectOperationIsCurrent({
      requestScope,
      currentScope:prospectLiveScopeRef.current,
    })) {
      const error = new Error("A sessão da prospecção mudou. Entre novamente antes de salvar.");
      error.code = "prosp_scope_changed";
      return Promise.reject(error);
    }
    const actorIsDemo = loggedInUser?.isDemo === true;
    const demoWrite = isDemoMode && actorIsDemo;
    if (!loggedInUser || !currentUser || demoWrite !== Boolean(_demoMode)
      || isDemoMode !== actorIsDemo) {
      return Promise.reject(new Error("A sessão da prospecção mudou. Entre novamente antes de salvar."));
    }
    const adjustScopeCount = (map, scope, delta) => {
      const count = Math.max(0, (map.get(scope) || 0) + delta);
      if (count) map.set(scope, count);
      else map.delete(scope);
    };
    const saveItem = async operation => {
      adjustScopeCount(prospectScopePendingRef.current, requestScope, 1);
      try {
        let result;
        if (demoWrite) {
          const firebaseKey = operation.operation === "create"
            ? `p_${operation.id}`
            : operation.key || String(operation.id);
          const itemRef = dbRef(`arflow_prospeccao/${firebaseKey}`);
          const transaction = await runTransaction(itemRef, existing => {
            if (operation.operation === "create") {
              return existing == null ? operation.record : undefined;
            }
            if (operation.operation === "delete") return null;
            if (existing == null) return undefined;
            const updated = { ...existing };
            Object.entries(operation.changes || {}).forEach(([key, fieldValue]) => {
              if (key === "id" || key === "_firebaseKey" || key === "__commercialProjection") return;
              if (fieldValue === null) delete updated[key];
              else updated[key] = fieldValue;
            });
            return updated;
          });
          if (operation.operation !== "delete" && !transaction.committed) {
            throw new Error("O cartão não foi gravado no espaço de demonstração.");
          }
          const record = transaction.snapshot?.exists()
            ? { ...transaction.snapshot.val(), id:operation.id, _firebaseKey:firebaseKey }
            : null;
          result = { record, key:firebaseKey, created:operation.operation === "create" };
        } else {
          const body = operation.operation === "create"
            ? { operation:"create", record:operation.record, storeId:operation.storeId }
            : {
                operation:operation.operation,
                id:operation.id,
                storeId:operation.storeId,
                ...(operation.key ? { key:operation.key } : {}),
                ...(operation.operation === "patch" ? { changes:operation.changes } : {}),
              };
          const response = await fetch("/api/crm/prospects/item", {
            method:"POST",
            credentials:"same-origin",
            cache:"no-store",
            headers:{ "Content-Type":"application/json", Accept:"application/json" },
            body:JSON.stringify(body),
          });
          const payload = await response.json().catch(() => ({}));
          const responseScope = fenceProspectHttpResponse({
            requestScope,
            currentScope:prospectLiveScopeRef.current,
            status:response.status,
            onUnauthorized:handleExpiredCrmSession,
          });
          if (responseScope.stale) return { ...payload, record:null, stale:true };
          if (responseScope.sessionExpired) {
            const error = new Error(payload?.error || "Sua sessão do CRM expirou. Entre novamente.");
            error.code = "crm_session_expired";
            throw error;
          }
          if (!response.ok) {
            throw new Error(payload?.error || `Não foi possível salvar o cartão (HTTP ${response.status}).`);
          }
          result = {
            ...payload,
            record:payload.record
              ? { ...payload.record, _firebaseKey:payload.record._firebaseKey || payload.key || undefined }
              : null,
          };
          if (operation.operation !== "delete" && !result.record) {
            throw new Error("O servidor não confirmou o cartão de prospecção salvo.");
          }
        }
        if (!prospectOperationIsCurrent({
          requestScope,
          currentScope:prospectLiveScopeRef.current,
        })) return { ...result, stale:true };
        if (!demoWrite && operation.operation !== "delete" && result.record) {
          result.record = await confirmCard("prospeccao", result.record,
            previousById.get(String(operation.id)) || {});
          if (!prospectOperationIsCurrent({ requestScope, currentScope:prospectLiveScopeRef.current })) {
            return { ...result, stale:true };
          }
        }

        const revisions = prospectScopeRevisionRef.current;
        revisions.set(requestScope, (revisions.get(requestScope) || 0) + 1);
        setProspeccao(previous => {
          if (!prospectOperationIsCurrent({
            requestScope,
            currentScope:prospectLiveScopeRef.current,
          })) return previous;
          const latest = (previous || []).filter(Boolean);
          if (operation.operation === "delete") {
            const remaining = latest.filter(item => String(item.id) !== String(operation.id));
            prospeccaoRef.current = remaining;
            return remaining;
          }
          const confirmed = result.record || { ...operation.record, _firebaseKey:result.key };
          const merged = mergeConfirmedProspectItem(latest, confirmed);
          prospeccaoRef.current = merged;
          return merged;
        });
        if (!demoWrite) notifyProspRefresh();
        return result;
      } catch (error) {
        console.error("[CRM] gravação do cartão de prospecção falhou:", error.message);
        throw contextualizeProspectWriteError(error,
          operation.changes?.stage && !operation.changes?.followUp ? "stage" : "prospect");
      } finally {
        adjustScopeCount(prospectScopePendingRef.current, requestScope, -1);
      }
    };
    return Promise.all(operations.map(saveItem)).catch(error => {
      if (error?.code !== "prosp_scope_changed" && error?.message && prospectOperationIsCurrent({
        requestScope,
        currentScope:prospectLiveScopeRef.current,
      })) {
        const toastId = Date.now();
        setToasts(previous => [...previous, {
          id:toastId,
          msg:`⚠️ ${error.message}`,
          type:"message",
        }]);
        setTimeout(() => setToasts(previous => previous.filter(toast => toast.id !== toastId)), 8000);
      }
      throw error;
    });
  };
  const reloadScopedReminders = async () => {
    if (isDemoMode) {
      setReminders([]);
      return;
    }
    const response = await fetch("/api/crm/reminders", {
      credentials:"same-origin", cache:"no-store", headers:{ Accept:"application/json" },
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const payload = await response.json();
    setReminders(remindersWithAccounting(payload));
  };
  const toggleDisplayReminder = (id) => {
    return toggleReminder(id);
  };
  const deleteDisplayReminder = (id) => {
    const target = displayReminders.find(reminder => reminder?.id === id);
    if (target?.source === "commercial_tracking" && target.type === "consultant_reply_required") {
      alert("Responda ao cliente para concluir esta pendência.");
      return;
    }
    if (target?.source === "commercial_tracking") {
      return toggleReminder(id);
    }
    deleteReminder(id);
  };

  const myPendingCount = reminders.filter(r => {
    if (!r || r.status !== "pending") return false;
    const sid = r.storeId || USERS.find(u=>u.id===r.consultantId)?.storeId || 1;
    if (sid !== currentUser.storeId) return false;
    return currentUser.role !== "consultant" || r.consultantId === currentUser.id;
  }).length;
  const liftPendingCount = liftSales.filter(s => s.pendencia?.status === "aberta").length;
  const lembretesLabel = `📌 Lembretes${myPendingCount>0?` (${myPendingCount})`:""}${liftPendingCount>0?` · Vendas (${liftPendingCount})`:""}`;

  const centralLabel = `${newUi ? "Meu Dia" : "⚡ Central"}${awaitingBadgeCount > 0 ? ` (${awaitingBadgeCount})` : ""}`;

  const tabs = ["superadmin","admin"].includes(currentUser.role)
    ? [
        { id:"central",      label:centralLabel },
        { id:"dashboard",    label:"📊 Dashboard" },
        ...(isDemoMode ? [
          { id:"kanban",      label:"🗂 Atendimento" },
          { id:"prospeccao",  label:"📱 Prospecção" },
        ] : []),
        { id:"lembretes",    label:lembretesLabel},
        { id:"indicacoes",   label:"🤝 Indicações" },
        { id:"recebimentos", label:"💵 Recebimentos" },
        { id:"leads",        label:"📋 Leads" },
        { id:"ia",           label:"💡 IA" },
        { id:"historico",    label:"📅 Histórico" },
         ...(!isDemoMode ? [{ id:"followup", label:"🔁 Follow-up" }] : []),
        ...(!isDemoMode ? [{ id:"reports", label:"Relatórios" }] : []),
        ...(!isDemoMode ? [{ id:"admin", label:"🏢 Lojas" }] : []),
      ]
    : currentUser.role==="manager"
    ? [
        { id:"central",      label:centralLabel },
        { id:"dashboard",    label:"📊 Dashboard" },
        { id:"kanban",       label:"🗂 Atendimento Presencial" },
        { id:"entregas",     label:"📦 Entregas" },
        { id:"recebimentos", label:"💵 Recebimentos" },
        { id:"lembretes",    label:lembretesLabel},
        { id:"indicacoes",   label:"🤝 Indicações" },
        { id:"leads",        label:"📋 Leads" },
        { id:"ia",           label:"💡 IA" },
        { id:"historico",    label:"📅 Histórico" },
         ...(!isDemoMode ? [{ id:"followup", label:"🔁 Follow-up" }] : []),
        ...(!isDemoMode ? [{ id:"reports", label:"Relatórios" }] : []),
        { id:"inbox",        label:"💬 Central de Conversas" },
      ]
    : [
        { id:"central",      label:centralLabel },
        { id:"dashboard",    label:"📊 Dashboard" },
        { id:"kanban",       label:"🗂 Atendimento Presencial" },
        { id:"entregas",     label:"📦 Entregas" },
        { id:"recebimentos", label:"💵 Recebimentos" },
        { id:"lembretes",    label:lembretesLabel},
        { id:"indicacoes",   label:"🤝 Indicações" },
        { id:"leads",        label:"📋 Leads" },
        { id:"prospeccao",   label:"📱 Prospecção" },
        { id:"inbox",        label:"💬 Central de Conversas" },
        ...(!isDemoMode ? [{ id:"reports", label:"Relatórios" }] : []),
      ];

  if (newUi && !isDemoMode && !tabs.some(tabItem => tabItem.id === "vendas")) {
    const dashboardIndex = tabs.findIndex(tabItem => tabItem.id === "dashboard");
    tabs.splice(dashboardIndex < 0 ? tabs.length : dashboardIndex + 1, 0, {
      id:"vendas", label:"💰 Vendas",
    });
  }

  if (newUi && !isDemoMode) {
    const nuExtras = [{ id:"produtos", label:"🔎 Produtos" }, { id:"biblioteca", label:"📷 Biblioteca" }];
    if (currentUser.role === "admin") nuExtras.push({ id:"marketing", label:"📊 Marketing" }, { id:"catalogo", label:"📚 Catálogo" });
    for (const t of nuExtras) if (!tabs.some(x => x.id === t.id)) tabs.push(t);
  }
  const roleBadge = { superadmin:["Superadmin",T.accent], admin:["Gestor Geral",T.accent], manager:["Gerente",T.navyLight], consultant:["Consultor",T.positive] };
  const [roleLabel, roleColor] = roleBadge[currentUser.role];

  const allStores = isDemoMode ? DEMO_STORES : STORES;
  const allUsers  = isDemoMode ? DEMO_USERS  : USERS;
  const { adminUsers, usersByStore, depositoUsers } = adminSwitcherUsers(allUsers, allStores);
  const operationalUserList = operationalUsers(allUsers);
  return (
    <div className={newUi ? "nu-root" : undefined} style={{ minHeight:"100vh", background: isDemoMode?'#F4F4F1':(newUi?T.nuPage:"#F8FAFC"), fontFamily: newUi?NEW_UI_FONT:"'Inter',system-ui,sans-serif", marginLeft: isDemoMode?240:(newUi?undefined:0) }}>
      {newUi && <NewUiStyles />}
      {newUi && <MobileNav theme={T} tabs={tabs.filter(t => t.id !== "inbox")} activeTab={tab} onSelect={setTab} />}
      {newUi && (
        <NewSidebar theme={T} tabs={tabs.filter(t => t.id !== "inbox")} activeTab={tab} onSelect={setTab}
          storeName={allStores.find(s=>s.id===currentUser.storeId)?.name}
          userName={currentUser.name} roleLabel={roleLabel} />
      )}
      {/* ── Sidebar fixa de demonstração ── */}
      {isDemoMode && (
        <div style={{ position:'fixed', left:0, top:0, bottom:0, width:240, background:'#1C1917', zIndex:100, display:'flex', flexDirection:'column', overflowY:'auto', boxShadow:'4px 0 20px rgba(0,0,0,0.25)' }}>
          {/* Logotipo */}
          <div style={{ padding:'22px 18px 14px', borderBottom:'1px solid rgba(255,255,255,0.08)', flexShrink:0 }}>
            <div style={{ color:'#B8960C', fontSize:10, fontWeight:700, letterSpacing:2.5, textTransform:'uppercase' }}>AR Flow</div>
            <div style={{ color:'#fff', fontSize:17, fontWeight:700, fontFamily:'Georgia,serif', marginTop:2 }}>OS</div>
            <div style={{ color:'rgba(255,255,255,0.35)', fontSize:9, marginTop:6, lineHeight:1.5 }}>Grupo Móvel &amp; Arte<br/>Demonstração</div>
          </div>
          {/* Usuário atual */}
          <div style={{ padding:'12px 14px', borderBottom:'1px solid rgba(255,255,255,0.08)', flexShrink:0 }}>
            <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom: loggedInUser?.role==='admin'?8:0 }}>
              <div style={{ width:30, height:30, background:'#B8960C', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:12, color:'#fff', flexShrink:0 }}>{currentUser.name.charAt(0)}</div>
              <div style={{ minWidth:0 }}>
                <div style={{ color:'#fff', fontSize:11, fontWeight:600, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{currentUser.name.split(' ')[0]}</div>
                <div style={{ color:'rgba(255,255,255,0.38)', fontSize:9 }}>{roleBadge[currentUser.role]?.[0]||'Consultor'}</div>
              </div>
            </div>
            {loggedInUser?.role==='admin' && (
              <button onClick={()=>setMenuOpen(m=>!m)} style={{ width:'100%', background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.10)', borderRadius:6, padding:'5px 8px', color:'rgba(255,255,255,0.50)', fontSize:10, cursor:'pointer', textAlign:'left', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <span>↕ Mudar visão</span><span style={{ fontSize:7 }}>▼</span>
              </button>
            )}
          </div>
          {/* Navegação */}
          <nav style={{ flex:1, padding:'6px 8px', overflowY:'auto' }}>
            {GUIDED_STEPS.map(item => (
              <button key={item.tab} onClick={()=>setTab(item.tab)} style={{ width:'100%', display:'flex', alignItems:'center', gap:9, padding:'8px 9px', borderRadius:7, border:'none', background:tab===item.tab?'rgba(184,150,12,0.20)':'transparent', cursor:'pointer', marginBottom:2, transition:'background 0.12s' }}>
                <span style={{ fontSize:14, width:18, textAlign:'center', flexShrink:0 }}>{item.icon}</span>
                <span style={{ fontSize:12, fontWeight:tab===item.tab?700:400, color:tab===item.tab?'#D4AF37':'rgba(255,255,255,0.62)', textAlign:'left', flex:1 }}>{item.label}</span>
                {tab===item.tab && <div style={{ width:3, height:12, background:'#B8960C', borderRadius:2, flexShrink:0 }} />}
              </button>
            ))}
            {myPendingCount>0 && (
              <button onClick={()=>setTab('lembretes')} style={{ width:'100%', display:'flex', alignItems:'center', gap:9, padding:'8px 9px', borderRadius:7, border:'none', background:'rgba(239,68,68,0.10)', cursor:'pointer', marginTop:6 }}>
                <span style={{ fontSize:14, width:18, textAlign:'center' }}>🔔</span>
                <span style={{ fontSize:11, fontWeight:700, color:'#F87171', flex:1, textAlign:'left' }}>{myPendingCount} pendente{myPendingCount>1?'s':''}</span>
              </button>
            )}
          </nav>
          {/* Controles demo */}
          <div style={{ padding:'8px', borderTop:'1px solid rgba(255,255,255,0.08)', flexShrink:0 }}>
            <button onClick={()=>{ if(!guidedOpen){ setGuidedStep(0); setTab(GUIDED_STEPS[0].tab); } setGuidedOpen(v=>!v); }} style={{ width:'100%', display:'flex', alignItems:'center', gap:7, padding:'7px 9px', borderRadius:7, border:`1px solid ${guidedOpen?'#B8960C':'rgba(184,150,12,0.30)'}`, background:guidedOpen?'rgba(184,150,12,0.14)':'transparent', color:'#B8960C', fontSize:11, fontWeight:600, cursor:'pointer', marginBottom:5 }}>
              🗺 {guidedOpen ? 'Fechar tour' : 'Tour Guiado'}
            </button>
            {loggedInUser?.role==='admin' && (
              <button onClick={async()=>{ if(!window.confirm('Restaurar os dados originais da demonstração?\n\nAs alterações feitas serão perdidas.')) return; try{ const r=await fetch('/api/demo/restore',{method:'POST',headers:{'Content-Type':'application/json'}}); const d=await r.json().catch(()=>({})); if(d.ok){ alert('✅ Demonstração restaurada!'); } else { alert('Erro: '+(d.error||'desconhecido')); } }catch(e){ alert('Erro: '+e.message); } }} style={{ width:'100%', display:'flex', alignItems:'center', gap:7, padding:'7px 9px', borderRadius:7, border:'1px solid rgba(255,255,255,0.08)', background:'transparent', color:'rgba(255,255,255,0.38)', fontSize:11, cursor:'pointer', marginBottom:5 }}>
                🔄 Restaurar
              </button>
            )}
            <button onClick={handleLogout} style={{ width:'100%', display:'flex', alignItems:'center', gap:7, padding:'7px 9px', borderRadius:7, border:'none', background:'transparent', color:'rgba(255,255,255,0.28)', fontSize:11, cursor:'pointer' }}>
              ← Sair
            </button>
          </div>
          <div style={{ padding:'6px 0 12px', textAlign:'center', flexShrink:0 }}>
            <span style={{ background:'rgba(184,150,12,0.10)', color:'#B8960C', fontSize:8, fontWeight:700, letterSpacing:1.5, textTransform:'uppercase', padding:'2px 8px', borderRadius:20, border:'1px solid rgba(184,150,12,0.2)' }}>MODO DEMO</span>
          </div>
        </div>
      )}
      {/* ── Banner demo (só no modo demo; no modo real o header escuro aparece abaixo) ── */}
      {isDemoMode && (
        <div style={{ background:"linear-gradient(90deg,#1E3A8A 0%,#1D4ED8 100%)", padding:"9px 20px", display:"flex", justifyContent:"space-between", alignItems:"center", position:"sticky", top:0, zIndex:200, boxShadow:"0 2px 12px rgba(30,58,138,0.35)" }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <span style={{ fontSize:18, lineHeight:1 }}>🎯</span>
            <div>
              <div style={{ color:"#fff", fontSize:12, fontWeight:800, letterSpacing:0.4 }}>MODO DEMONSTRAÇÃO — Grupo Móvel &amp; Arte</div>
              <div style={{ color:"rgba(255,255,255,0.7)", fontSize:10, marginTop:1 }}>Dados fictícios · Nenhuma mensagem real é enviada · Nenhum dado real é exibido</div>
            </div>
          </div>
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            <button onClick={()=>{ if (!guidedOpen){ setGuidedStep(0); setTab("dashboard"); } setGuidedOpen(v=>!v); }} style={{ background: guidedOpen ? "rgba(255,255,255,0.35)" : "rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.45)", borderRadius:7, padding:"5px 13px", color:"#fff", fontSize:11, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap", transition:"background 0.15s" }}>
              {guidedOpen ? "✕ Fechar guia" : "🗺 Tour Guiado"}
            </button>
            {loggedInUser?.role==="admin" && (
              <button onClick={async ()=>{
                if (!window.confirm("Restaurar os dados originais da demonstração?\n\nAs alterações feitas serão perdidas.")) return;
                try {
                  const r = await fetch('/api/demo/restore', { method:'POST', headers:{'Content-Type':'application/json'} });
                  const d = await r.json().catch(()=>({}));
                  if (d.ok) { alert('✅ Demonstração restaurada com sucesso!'); } else { alert('Erro ao restaurar: ' + (d.error||'desconhecido')); }
                } catch(e) { alert('Erro de rede: ' + e.message); }
              }} style={{ background:"rgba(255,255,255,0.12)", border:"1px solid rgba(255,255,255,0.35)", borderRadius:7, padding:"5px 13px", color:"#fff", fontSize:11, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}>
                🔄 Restaurar
              </button>
            )}
          </div>
        </div>
      )}
      {isAdminViewing && (
        <div style={{ background:T.accent, padding:"6px 20px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <span style={{ color:"#fff", fontSize:12, fontWeight:600 }}>👁 Visualizando como: {currentUser.name} — {allStores.find(s=>s.id===currentUser.storeId)?.name}</span>
          <button onClick={() => { if (setCurrentUserGuarded(loggedInUser)) setTab("dashboard"); }} style={{ background:"rgba(255,255,255,0.2)", border:"none", borderRadius:6, padding:"3px 10px", color:"#fff", fontSize:12, fontWeight:700, cursor:"pointer" }}>
            ← Voltar para Admin
          </button>
        </div>
      )}

      {/* ── Barra de conteúdo demo (substitui o header escuro) ── */}
      {isDemoMode && (
        <div style={{ background:'#fff', borderBottom:'1px solid #E8E2DA', padding:'0 24px', height:54, display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:50, boxShadow:'0 1px 8px rgba(0,0,0,0.06)' }}>
          <div>
            <div style={{ fontSize:15, fontWeight:700, color:'#1C1917' }}>{GUIDED_STEPS.find(s=>s.tab===tab)?.label || (tab==='central'?'Conversas':tab==='lembretes'?'Tarefas':tab==='entregas'?'Entregas':tab==='inbox'?'Inbox':'Dashboard')}</div>
            {isAdminViewing && <div style={{ fontSize:10, color:'#78716C' }}>👁 Visualizando como {currentUser.name}</div>}
          </div>
          {isAdminViewing && (
            <button onClick={()=>{if(setCurrentUserGuarded(loggedInUser))setTab('dashboard');}} style={{ background:'#FEF3C7', border:'1px solid #B8960C', borderRadius:6, padding:'4px 12px', color:'#92400E', fontSize:11, fontWeight:700, cursor:'pointer' }}>← Voltar para Admin</button>
          )}
        </div>
      )}
      {/* ── Header escuro original (oculto no demo mode) ── */}
      {!isDemoMode && (
      <div style={{ background:T.headerGrad, padding:"0 20px", position:"sticky", top:0, zIndex:50, boxShadow:T.headerShadow||"0 2px 20px rgba(0,0,0,0.3)" }}>
        <div style={{ maxWidth:1200, margin:"0 auto", display:"flex", alignItems:"center", gap:12, height:56 }}>
          <div style={{ flex:1 }}>
            <div className="nu-brand" style={{ display:"flex", flexDirection:"column", alignItems:"center", lineHeight:1 }}>
              <div style={{ color:T.gold, fontWeight:900, fontSize:13, letterSpacing:3, fontFamily:"Georgia,serif" }}>AR FLOW</div>
              <span style={{ fontSize:22, lineHeight:1 }}>{T.icon}</span>
              <div style={{ color:T.headerSubColor||"rgba(255,255,255,0.75)", fontSize:10, fontWeight:600, letterSpacing:0.5, marginTop:1, whiteSpace:"nowrap" }}>
                {currentUser.storeId
                  ? `OS — ${allStores.find(s=>s.id===currentUser.storeId)?.name}`
                  : "OS — Todas as Lojas"}
              </div>
            </div>
          </div>

          <div style={{ position:"relative" }}>
            {loggedInUser.role==="admin" ? (
              <>
                <button onClick={() => setMenuOpen(m=>!m)} style={{ background:T.headerBtnBg||"rgba(255,255,255,0.1)", border:"none", borderRadius:8, padding:"6px 12px", color:T.headerBtnColor||"#fff", cursor:"pointer", display:"flex", alignItems:"center", gap:8, fontSize:13 }}>
                  <div style={{ width:28, height:28, background:roleColor, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:700, fontSize:12, color:"#fff" }}>
                    {currentUser.name.charAt(0)}
                  </div>
                  <div style={{ textAlign:"left" }}>
                    <div style={{ fontWeight:600, fontSize:13 }}>{currentUser.name.split(" ")[0]}</div>
                    <div style={{ fontSize:10, color:T.headerSubColor||"rgba(255,255,255,0.6)" }}>{roleLabel}</div>
                  </div>
                  <span style={{ fontSize:10 }}>▼</span>
                </button>
                {menuOpen && (
                  <>
                    <div onClick={() => { setMenuOpen(false); setExpandedStore(null); }} style={{ position:"fixed", inset:0, zIndex:199 }} />
                    <div style={{ position:"absolute", right:0, top:"calc(100% + 8px)", background:"#fff", borderRadius:12, boxShadow:"0 8px 30px rgba(0,0,0,0.15)", overflow:"hidden", minWidth:240, zIndex:200, maxHeight:"80vh", overflowY:"auto" }}>
                      <div style={{ padding:"8px 14px", fontSize:10, color:T.muted, fontWeight:700, background:T.sand, letterSpacing:1 }}>ADMINISTRAÇÃO</div>
                      {adminUsers.map(u => {
                        const [rl,rc] = roleBadge[u.role]||["",T.muted];
                        return (
                          <button key={u.id} onClick={() => { if (!setCurrentUserGuarded(u)) return; setMenuOpen(false); setTab("dashboard"); }} style={{ width:"100%", background:u.id===currentUser.id?T.sandDark:"#fff", border:"none", padding:"10px 14px", cursor:"pointer", display:"flex", alignItems:"center", gap:10, textAlign:"left" }}>
                            <div style={{ width:28, height:28, background:rc, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:700, fontSize:12, color:"#fff", flexShrink:0 }}>{u.name.charAt(0)}</div>
                            <div>
                              <div style={{ fontSize:13, fontWeight:600, color:T.text }}>{u.name}</div>
                              <div style={{ fontSize:11, color:rc }}>{rl}</div>
                            </div>
                          </button>
                        );
                      })}
                      {usersByStore.map(({store, users:storeUsers}) => {
                        const th = THEMES[store.id] || T_DEMO;
                        const isOpen = expandedStore===store.id;
                        return (
                          <div key={store.id}>
                            <button onClick={() => setExpandedStore(isOpen?null:store.id)} style={{ width:"100%", background:th.storeButtonBg||th.accent, border:`1px solid ${th.storeButtonBg==="#FFFFFF"?"#E2E8F0":"transparent"}`, padding:"10px 14px", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                                <span style={{ fontSize:16 }}>{th.icon||"👑"}</span>
                                <span style={{ fontSize:12, color:th.storeButtonText||"#fff", fontWeight:700 }}>{store.name}</span>
                              </div>
                              <span style={{ color:th.storeButtonText||"rgba(255,255,255,0.8)", fontSize:11, display:"inline-block", transform:isOpen?"rotate(180deg)":"rotate(0deg)", transition:"transform 0.2s" }}>▼</span>
                            </button>
                            {isOpen && storeUsers.map(u => {
                              const uRole = u.role==="manager"?"Gerente":"Consultor";
                              const uColor = u.role==="manager"?th.navyLight:th.positive;
                              return (
                                <button key={u.id} onClick={() => { if (!setCurrentUserGuarded(u)) return; setMenuOpen(false); setExpandedStore(null); setTab("dashboard"); }} style={{ width:"100%", background:u.id===currentUser.id?th.sandDark:"#fff", border:"none", padding:"10px 14px", cursor:"pointer", display:"flex", alignItems:"center", gap:10, textAlign:"left" }}>
                                  <div style={{ width:28, height:28, background:uColor, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:700, fontSize:12, color:"#fff", flexShrink:0 }}>{u.name.charAt(0)}</div>
                                  <div>
                                    <div style={{ fontSize:13, fontWeight:600, color:T.text }}>{u.name}</div>
                                    <div style={{ fontSize:11, color:uColor }}>{uRole}</div>
                                  </div>
                                  {u.id===currentUser.id && <span style={{ marginLeft:"auto", fontSize:10, color:th.accent, fontWeight:700 }}>● atual</span>}
                                </button>
                              );
                            })}
                          </div>
                        );
                      })}
                      {depositoUsers.length > 0 && (
                        <>
                          <div style={{ padding:"8px 14px", fontSize:10, color:T.muted, fontWeight:700, background:"#F8FAFC", letterSpacing:1, borderTop:"1px solid #E2E8F0" }}>DEPÓSITO · VISÃO SEPARADA</div>
                          {depositoUsers.map(u => (
                            <button key={u.id} onClick={() => { if (!setCurrentUserGuarded(u)) return; setMenuOpen(false); setExpandedStore(null); setTab("dashboard"); }}
                              style={{ width:"100%", background:u.id===currentUser.id?"#FEF3C7":"#fff", border:"none", padding:"10px 14px", cursor:"pointer", display:"flex", alignItems:"center", gap:10, textAlign:"left" }}>
                              <div style={{ width:28, height:28, background:"#9A6700", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:700, fontSize:14, color:"#fff", flexShrink:0 }}>📦</div>
                              <div>
                                <div style={{ fontSize:13, fontWeight:600, color:T.text }}>{u.name}</div>
                                <div style={{ fontSize:11, color:"#9A6700" }}>Visão de depósito · todas as lojas</div>
                              </div>
                            </button>
                          ))}
                        </>
                      )}
                    </div>
                  </>
                )}
              </>
            ) : (
              <div style={{ display:"flex", alignItems:"center", gap:8, padding:"6px 12px" }}>
                <div style={{ width:28, height:28, background:roleColor, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:700, fontSize:12, color:"#fff" }}>
                  {currentUser.name.charAt(0)}
                </div>
                <div>
                  <div style={{ fontWeight:600, fontSize:13, color:T.headerBtnColor||"#fff" }}>{currentUser.name.split(" ")[0]}</div>
                  <div style={{ fontSize:10, color:T.headerSubColor||"rgba(255,255,255,0.6)" }}>{roleLabel}</div>
                </div>
              </div>
            )}
          </div>

          {loggedInUser.role==="admin" && (
            <button onClick={()=>setUserPasswordResetOpen(true)} style={{ background:T.headerBtnBg||"rgba(255,255,255,0.12)", border:`1px solid ${T.headerSubColor?"rgba(0,0,0,0.15)":"rgba(255,255,255,0.2)"}`, borderRadius:8, padding:"5px 12px", color:T.headerBtnColor||"rgba(255,255,255,0.8)", cursor:"pointer", fontSize:12, fontWeight:600 }}>
              Senhas de usuários
            </button>
          )}
          <button onClick={()=>setAccountOpen(true)} style={{ background:T.headerBtnBg||"rgba(255,255,255,0.12)", border:`1px solid ${T.headerSubColor?"rgba(0,0,0,0.15)":"rgba(255,255,255,0.2)"}`, borderRadius:8, padding:"5px 12px", color:T.headerBtnColor||"rgba(255,255,255,0.8)", cursor:"pointer", fontSize:12, fontWeight:600 }}>
            Minha conta
          </button>
          <button onClick={handleLogout} style={{ background:T.headerBtnBg||"rgba(255,255,255,0.12)", border:`1px solid ${T.headerSubColor?"rgba(0,0,0,0.15)":"rgba(255,255,255,0.2)"}`, borderRadius:8, padding:"5px 12px", color:T.headerBtnColor||"rgba(255,255,255,0.8)", cursor:"pointer", fontSize:12, fontWeight:600 }}>
            Sair
          </button>
        </div>

        <div style={{ maxWidth:1200, margin:"0 auto", padding:"0 0 9px", display:"flex", justifyContent:"flex-end" }}>
          <GlobalContactSearch currentUser={currentUser} onOpenResult={openSearchResult} />
        </div>
        <div className="nu-tabs-row" style={{ maxWidth:1200, margin:"0 auto", display:"flex", gap:4, overflowX:"auto" }}>
          {(newUi ? tabs.filter(t => t.id !== "inbox") : tabs).map(t => {
            return (
              <div key={t.id} style={{ position:"relative" }}>
                <button
                  onClick={() => setTab(t.id)}
                  style={{ background:"none", border:"none", color:tab===t.id?T.tabActive:(T.headerTabInactive||"rgba(255,255,255,0.6)"), cursor:"pointer", padding:"10px 14px", fontSize:12, fontWeight:tab===t.id?700:500, borderBottom:tab===t.id?`2px solid ${T.tabActive}`:"2px solid transparent", transition:"all 0.2s", whiteSpace:"nowrap" }}>
                  {t.label}
                </button>
              </div>
            );
          })}
        </div>

      </div>
      )}
      {!isDemoMode && currentUser?.role === "consultant" && (
        <section aria-label="Notificações no celular" style={{ background:"#FFF7E6", borderBottom:"1px solid #F0D79A" }}>
          <div style={{ maxWidth:1200, margin:"0 auto", padding:"10px 16px", display:"flex", flexWrap:"wrap", alignItems:"center", gap:10 }}>
            <div style={{ flex:"1 1 300px", minWidth:0 }}>
              <div style={{ color:"#5B3A00", fontSize:13, fontWeight:800 }}>
                🔔 Notificações no celular
              </div>
              <div role="status" aria-live="polite" style={{ color:"#72531B", fontSize:11, lineHeight:1.45, marginTop:2 }}>
                {pushStatus.permission === "granted" && pushStatus.subscription && pushStatus.serverSaved
                  ? "Notificações já estão ativas neste aparelho."
                  : pushMessage || "Ative para receber novos leads, respostas e transferências mesmo com o CRM em segundo plano."}
              </div>
              {pushStatus.permission === "denied" && (
                <div role="alert" style={{ color:"#B42318", fontSize:11, marginTop:4 }}>
                  Notificações bloqueadas. {pushStatus.environment?.isIOS
                    ? "Abra Ajustes › Notificações › AR Flow e permita alertas. Se o CRM não aparecer, adicione-o à Tela de Início pelo Safari e abra o ícone instalado."
                    : "No Chrome, abra o cadeado ao lado do endereço › Permissões › Notificações › Permitir. No Android, confira também Ajustes › Apps › Chrome › Notificações."}
                </div>
              )}
              {pushStatus.environment?.isIOS && !pushStatus.environment?.isStandalone && (
                <div role="alert" style={{ color:"#9A6700", fontSize:11, marginTop:4 }}>
                  No iPhone/iPad, abra no Safari, toque em Compartilhar › Adicionar à Tela de Início e use o ícone instalado para ativar notificações.
                </div>
              )}
              <details style={{ marginTop:4, color:"#7A5A20", fontSize:10 }}>
                <summary style={{ cursor:"pointer", fontWeight:700 }}>Ver diagnóstico deste aparelho</summary>
                <div style={{ marginTop:3, lineHeight:1.5 }}>
                  Permissão: <b>{pushStatus.permission}</b> · Service worker registrado: <b>{pushStatus.serviceWorkerRegistered?"sim":"não"}</b> ·
                  ativo: <b>{pushStatus.serviceWorkerActive?"sim":"não"}</b> · PushManager: <b>{pushStatus.subscription?"assinatura criada":"sem assinatura"}</b> ·
                  servidor: <b>{pushStatus.serverSaved?"vinculada ao usuário/loja":"não confirmada"}</b> ·
                  ambiente: <b>{pushStatus.environment?.isIOS ? (pushStatus.environment.isStandalone?"iOS PWA":"iOS fora da PWA") : pushStatus.environment?.isAndroid ? (pushStatus.environment.isChrome?"Android/Chrome":"Android") : "navegador desktop"}</b>
                </div>
              </details>
              {pushError && <div role="alert" style={{ color:"#B42318", fontSize:11, marginTop:4 }}>{pushError}</div>}
            </div>
            {!(pushStatus.permission === "granted" && pushStatus.subscription && pushStatus.serverSaved) && (
              <button
                type="button"
                disabled={pushBusy || !pushStatus.supported || (pushStatus.environment?.isIOS && !pushStatus.environment?.isStandalone)}
                onClick={async () => {
                  setPushBusy(true); setPushError(""); setPushMessage("");
                  try {
                    const status = await enablePush({ storeId:currentUser.storeId, consultantId:currentUser.id });
                    setPushStatus(status);
                    setPushMessage(status.serverSaved
                      ? "Notificações ativadas neste aparelho."
                      : "A permissão foi concedida, mas a assinatura ainda não foi confirmada no servidor.");
                  } catch (error) {
                    setPushError(error.message);
                    setPushStatus(await getPushStatus({ storeId:currentUser.storeId, consultantId:currentUser.id }).catch(() => pushStatus));
                  } finally { setPushBusy(false); }
                }}
                style={{ border:"none", borderRadius:9, padding:"10px 15px", background:pushBusy?"#A98A45":"#7A4F00", color:"#fff", fontWeight:800, fontSize:12, cursor:pushBusy?"wait":"pointer", boxShadow:"0 2px 8px rgba(91,58,0,.22)" }}>
                {pushBusy ? "Ativando…" : "Ativar notificações no celular"}
              </button>
            )}
          </div>
        </section>
      )}
      {accountOpen && !isDemoMode && (
        <AccountPasswordModal
          user={loggedInUser}
          required={loggedInUser?.mustChangePassword===true}
          onClose={()=>setAccountOpen(false)}
          onChanged={()=>{
            const updated = { ...loggedInUser, mustChangePassword:false };
            setLoggedInUser(updated);
            if (currentUser?.id === loggedInUser?.id) setCurrentUser(updated);
            try { localStorage.setItem('arflow_user', JSON.stringify(updated)); } catch {}
            setAccountOpen(false);
          }}
        />
      )}
      <NextContactExitDialog />
      {isStaff && tab === "admin" && !isDemoMode && <NextContactDiagnostics />}
      {userPasswordResetOpen && !isDemoMode && (
        <div style={{position:'fixed',inset:0,zIndex:300,background:'rgba(15,23,42,.62)',display:'grid',placeItems:'center',padding:16}}>
          <CrmPasswordResetPanel apiBase="/api/crm/admin" exactConfirmation onClose={()=>setUserPasswordResetOpen(false)} />
        </div>
      )}

      {vendaModalTarget && (
        <RegistrarVendaModal
          contactName={vendaModalTarget.name}
          phone={vendaModalTarget.phone}
          moduleId={vendaModalTarget.moduleId==="inbox" ? (vendaModalTarget.contactType==="lead"?"leads":vendaModalTarget.contactType==="prosp"?"prospeccao":"kanban") : vendaModalTarget.moduleId}
          currentUser={currentUser}
          defaultConsultantId={vendaModalTarget.consultantId}
          defaultStoreId={vendaModalTarget.storeId}
          onClose={()=>setVendaModalTarget(null)}
          onSave={handleRegistrarVenda}
        />
      )}

      {/* Toast notifications */}
      {toasts.length>0&&(
        <div style={{ position:"fixed", bottom:24, right:24, zIndex:500, display:"flex", flexDirection:"column", gap:8, pointerEvents:"none" }}>
          {toasts.map(t=>(
            <div key={t.id} style={{ background:"#1E293B", color:"#fff", borderRadius:12, padding:"12px 18px", fontSize:13, fontWeight:600, boxShadow:"0 4px 20px rgba(0,0,0,0.35)", maxWidth:320, borderLeft:`4px solid ${t.type==="transfer"?"#F59E0B":t.type==="nextaction"?"#7C3AED":t.type==="message"?"#22C55E":"#6366F1"}` }}>
              {t.msg}
            </div>
          ))}
        </div>
      )}

      {isGeneralAdminView(currentUser, isDemoMode) && <AdminStoreEntry compact
        stores={getActiveStores()} currentScope={selectedAdminScope} onSelect={chooseAdminReadScope} />}
      {!isDemoMode && currentUser?.role !== "deposito" && <ScopedDataLoadNotice
        state={scopedDataLoadState}
        allStores={isGeneralAdminView(currentUser, isDemoMode) && selectedAdminScope === "all"}
        onRetry={() => scopedDataPollingRef.current?.retry()}
      />}
      <ScopedDataLoadProvider value={isDemoMode ? null : scopedDataLoadState || INITIAL_SCOPED_LOADING}>
      <MonthlyGoalsProvider month={selectedMonth} identity={`${loggedInUserId}:${loggedInUser?.role}`}
        enabled={!isDemoMode&&["admin","superadmin","consultant","manager"].includes(loggedInUser?.role)}>
      <LiftCrmClientContext.Provider value={{ onCadastrarCliente:requestLiftClientRegistration, revision:liftClientRegistrationRevision,
        authenticatedUser:loggedInUser, sales:liftSales,
        onCardLinked:payload=>{
          const changedReminders=[...(payload.cancelledReminders||[]),...(payload.updatedReminders||[])];
          if(changedReminders.length)setReminders(previous=>previous.map(reminder=>
            changedReminders.find(item=>String(item.id)===String(reminder.id))||reminder));
          const collection=payload.moduleId==="leads"?"leads":payload.moduleId==="kanban"?"clients":"prospects";
          const setter=payload.moduleId==="leads"?setAuroraLeads:payload.moduleId==="kanban"?setClients:setProspeccao;
          setter(previous=>previous.map(record=>{
            if(String(record.id)!==String(payload.card.id))return record;
            const saved={...record,...payload.card};
            ownActionSnapshots.current.remember(collection,saved,record);
            return saved;
          }));
        },
        identity:`${loggedInUserId}:${currentUserId}:${currentUserStoreId}:${currentUserRole}`,
        canBindOrigin:!["deposito", "marketing"].includes(loggedInUser?.role),
        onOpenCrmSource:abrirOrigemLift, onOriginLinked:onLiftSaved }}>
      <LiftPendingContext.Provider value={{ sales:liftSales, error:liftError, onSaved:onLiftSaved, authenticatedUser:loggedInUser,
        onRefresh:refreshLiftSales,
        commercialSales:scopedLiftSales, commercialError:scopedLiftError, commercialLoaded:scopedLiftLoaded,
        postSales, postError, onLinksUpdated:() => setPostRefreshToken(n => n + 1),
        onPostSaved:(sale, completedIds) => {
          setPostSales(previous => previous.map(item =>
            Number(item.storeId) === Number(sale.storeId) && String(item.liftPedidoId) === String(sale.liftPedidoId)
              ? sale : item));
          if (completedIds.length) {
            void reloadScopedReminders();
          }
        } }}>
      <div style={{ maxWidth:1200, margin:"0 auto", padding:"24px 16px" }}>
        {tab==="vendas" && newUi && <VendasTela
          clients={projectedClients}
          leads={projectedLeads}
          prospeccao={projectedProspeccao}
          currentUser={currentUser}
          onAbrirConversa={nuAbrirVendasConversa}
          onUpdateClient={updateClient}
          onDeleteClient={deleteClient}
          onAddReminder={addReminder}
          onSendZapi={sendZapiMessage}
          onSendZapiMedia={sendZapiMedia}
          onDeleteWhatsAppMessage={deleteWhatsAppMessage}
          onEditWhatsAppMessage={editWhatsAppMessage}
          whatsappMsgs={whatsappMsgs}
          onReturnToAurora={returnClientToAurora}
          onMarkRead={markWaRead}
          onRegistrarVenda={openManualSaleModal}
          onConversationActive={handleConversationActive}
        />}
        {tab==="central"      && <CentralOperacionalView onOpenReminderCard={openReminderCard} onDeleteReminder={deleteDisplayReminder} onAbrirConversaNaAba={(moduleId, storeId, phone, reminderTarget) => {
          if (reminderTarget?.reminderCard) return activeConversationExitGuard.requestAction(() => {
            setAutoOpenTarget(reminderTarget); setTabRaw(reminderTarget.moduleId);
          });
          if (isNewUi) { nuAbrirConversa(phone, storeId || currentUser.storeId); return; }
          setAutoOpenTarget(conversationTarget(moduleId, storeId || currentUser.storeId, normalizePhone(phone))); setTab(moduleId);
        }} onAbrirPedidoDeposito={pedido => nuAbrirConversa(pedido?.cliente?.telefone, pedido?.storeId, { fallbackTab:"entregas" })} clients={projectedClients} reminders={displayReminders} currentUser={currentUser} loggedInUser={loggedInUser} realSales={realSales} onToggleReminder={toggleDisplayReminder} onNavigate={setTab} onUpdateClient={updateClient} onDeleteClient={deleteClient} onAddReminder={addReminder} onSendZapi={sendZapiMessage} onSendZapiMedia={sendZapiMedia} onDeleteWhatsAppMessage={deleteWhatsAppMessage} whatsappMsgs={whatsappMsgs} leads={projectedLeads.filter(l => leadBelongsToStore(l, currentUser.storeId))} allLeads={projectedLeads} leadMessages={leadMessages} leadEvents={leadEvents} onUpdateLead={updateLead} onDeleteLead={deleteLead} onSendMessage={sendLeadMessage} onLogTransfer={logLeadTransfer} onReturnToAurora={returnClientToAurora} prospeccao={projectedProspeccao} prospMensagens={prospMensagens} onOpenProsp={(phone, storeId)=>{ if (isNewUi) { nuAbrirConversa(phone, storeId || currentUser.storeId); return; } setAutoOpenTarget(conversationTarget("inbox", storeId || currentUser.storeId, phone));setTab("inbox");}} onConversationActive={handleConversationActive} onCreateProspItem={persistProspecao} />}
        {tab==="produtos" && newUi && <Produtos theme={T} />}
        {tab==="biblioteca" && newUi && <Biblioteca theme={T} stores={STORES} currentUser={currentUser} />}
        {tab==="marketing" && newUi && currentUser.role==="admin" && <MarketingNova theme={T} stores={STORES} />}
        {tab==="catalogo" && newUi && currentUser.role==="admin" && <CatalogoAdmin theme={T} />}
        {tab==="dashboard"    && <DashboardView    clients={projectedClients} leads={projectedLeads} prospeccao={projectedProspeccao} currentUser={currentUser} realSales={realSales} selectedMonth={selectedMonth} onSelectMonth={setSelectedMonth} portfolioThresholds={portfolioThresholds} onSavePortfolioThresholds={next=>{setPortfolioThresholds(next);fbSet('arflow_settings/portfolioThresholds',next);}} onUpdateClient={updateClient} onDeleteClient={deleteClient} onAddReminder={addReminder} onSendZapi={sendZapiMessage} onSendZapiMedia={sendZapiMedia} whatsappMsgs={whatsappMsgs} onReturnToAurora={returnClientToAurora} onOpenLead={lead=>{setAutoOpenTarget(conversationTarget("leads", lead.storeId, lead.telefone||lead.phone||""));setTab("leads");}} onOpenProsp={prospect=>{setAutoOpenTarget(conversationTarget("prospeccao", prospect.storeId, prospect.phone||prospect.telefone||""));setTab("prospeccao");}} onConversationActive={handleConversationActive} />}
        {tab==="kanban"       && <KanbanView       clients={searchCardRecords.kanban} leads={projectedLeads} prospeccao={projectedProspeccao} currentUser={currentUser} onUpdate={updateClient} onAdd={addClient} onDelete={deleteClient} onAddReminder={addReminder} reminders={displayReminders} onToggleReminder={toggleDisplayReminder} onGoToReminders={()=>setTab("lembretes")} whatsappMsgs={whatsappMsgs} onSendZapi={sendZapiMessage} onSendZapiMedia={sendZapiMedia} onDeleteWhatsAppMessage={deleteWhatsAppMessage} onEditWhatsAppMessage={(...args)=>editWhatsAppMessage(...args)} waReadAt={waReadAt} onMarkRead={markWaRead} onReturnToAurora={returnClientToAurora} autoOpenTarget={autoOpenTarget?.moduleId==="kanban"?autoOpenTarget:null} onAutoOpenConsumed={()=>setAutoOpenTarget(null)} onRegistrarVenda={openManualSaleModal} onConversationActive={handleConversationActive} unreadPushLookup={unreadPushLookup} onOpenProspect={target => activeConversationExitGuard.requestAction(() => { setAutoOpenTarget(target); setTabRaw("prospeccao"); })} />}
        {tab==="entregas"     && !newUi && <EntregasView     clients={projectedClients} currentUser={currentUser} onUpdate={updateClient} onAdd={addClient} onAddReminder={addReminder} onSendZapi={sendZapiMessage} onSendZapiMedia={sendZapiMedia} whatsappMsgs={whatsappMsgs} onReturnToAurora={returnClientToAurora} onConversationActive={handleConversationActive} />}
        {tab==="entregas" && newUi && <EntregasTela clients={projectedClients} currentUser={currentUser} onUpdate={updateClient} onAdd={addClient} onAddReminder={addReminder} onSendZapi={sendZapiMessage} onSendZapiMedia={sendZapiMedia} whatsappMsgs={whatsappMsgs} onReturnToAurora={returnClientToAurora} onConversationActive={handleConversationActive} onAbrirPedido={pedido => nuAbrirConversa(pedido.cliente?.telefone, pedido.storeId)} />}
        {tab==="recebimentos" && <RecebimentosView clients={projectedClients} currentUser={currentUser} realSales={realSales} onOpenClient={client=>{setAutoOpenTarget(conversationTarget("kanban", client.storeId, client.phone||""));setTab("kanban");}} />}
        {tab==="lembretes"    && <LembretesView onOpenReminderCard={openReminderCard} reminders={displayReminders} currentUser={currentUser} clients={projectedClients} leads={projectedLeads} prospeccao={projectedProspeccao} onOpenLinkedCard={target=>{setAutoOpenTarget(target);setTab(target.moduleId);}} onToggle={toggleDisplayReminder} onAdd={addReminder} onDelete={deleteDisplayReminder} onUpdateClient={updateClient} onDeleteClient={deleteClient} onAddReminder={addReminder} onSendZapi={sendZapiMessage} onSendZapiMedia={sendZapiMedia} whatsappMsgs={whatsappMsgs} onReturnToAurora={returnClientToAurora} onConversationActive={handleConversationActive} />}
        {tab==="indicacoes"   && <IndicacoesView currentUser={currentUser} stores={allStores} onSendZapi={sendZapiMessage}
           autoOpenTarget={autoOpenTarget?.moduleId === "indicacoes" ? autoOpenTarget : null}
           onAutoOpenConsumed={() => setAutoOpenTarget(null)}
           renderConversation={({ item, storeId:sid, busy, onClose, onStatus }) => <IndicacaoConversa item={item} storeId={sid} currentUser={currentUser} whatsappMsgs={whatsappMsgs} busy={busy} onClose={onClose} onStatus={onStatus} onConversationActive={handleConversationActive} onSend={(phone, text, sender, quotedId, _st, quoted, retry) => sendZapiMessage(phone, text, sender, quotedId ?? null, Number(sid), quoted ?? null, retry ?? null)} onSendMedia={sendZapiMedia} onMarkRead={id => markWaRead(String(id))} />}
          onOpenConversation={referral=>{
          const linkedType = String(referral.existingContactType || referral.contactType || referral.linkedContactType || (referral.alreadyContact ? referral.contact?.type : "lead") || "lead").toLowerCase();
          const moduleId = linkedType === "client" ? "kanban" : ["prospect","prosp","prospecto"].includes(linkedType) ? "prospeccao" : "leads";
          const targetStoreId = referral.storeId || currentUser.storeId;
          setAutoOpenTarget(conversationTarget(moduleId, targetStoreId, referral.phone));
          setTab(moduleId);
        }} />}
        {tab==="prospeccao"   && <ProspeccaoView   currentUser={currentUser} loggedInUser={loggedInUser} prospeccao={searchCardRecords.prospeccao} onUpdateProsp={persistProspecao} getProspectWriteScope={()=>prospectLiveScopeRef.current} whatsappMsgs={whatsappMsgs} prospMensagens={prospMensagens} sendProspMsg={sendZapiMessage} sendZapiMedia={sendZapiMedia} lastReadAt={waReadAt} onMarkRead={markWaRead} onAddReminder={addReminder} onCancelReminder={deleteReminder} autoOpenTarget={autoOpenTarget?.moduleId==="prospeccao"?autoOpenTarget:null} onAutoOpenConsumed={()=>setAutoOpenTarget(null)} onRegistrarVenda={openManualSaleModal} onConversationActive={handleConversationActive} unreadPushLookup={unreadPushLookup} />}
        {tab==="leads"        && <LeadsView leads={searchCardRecords.leads.filter(l => ["admin","superadmin"].includes(currentUser.role) ? true : currentUser.role === "consultant" ? resolveLeadConsultantId(l) === currentUser.id : leadBelongsToStore(l, currentUser.storeId))} clients={projectedClients.filter(c => !currentUser.storeId || c.storeId===currentUser.storeId)} leadMessages={leadMessages} leadEvents={leadEvents} currentUser={currentUser} onUpdate={updateLead} onAdd={addLead} onDelete={deleteLead} onMerge={mergeLeads} onSendMessage={sendLeadMessage} whatsappMsgs={whatsappMsgs} onSendZapi={sendZapiMessage} onSendZapiMedia={sendZapiMedia} onDeleteWhatsAppMessage={deleteWhatsAppMessage} onLogTransfer={logLeadTransfer} onAddReminder={addReminder} autoOpenTarget={autoOpenTarget?.moduleId==="leads"?autoOpenTarget:null} onAutoOpenConsumed={()=>setAutoOpenTarget(null)} onRegistrarVenda={openManualSaleModal} onConversationActive={handleConversationActive} unreadPushLookup={unreadPushLookup} onCreateProspItem={persistProspecao} />}
        {tab==="inbox"        && <CentralConversas whatsappMsgs={whatsappMsgs} leads={projectedLeads.filter(l => leadBelongsToStore(l, currentUser.storeId))} prospeccao={projectedProspeccao} clients={projectedClients} currentUser={currentUser} onSend={sendZapiMessage} onSendZapiMedia={sendZapiMedia} onDeleteWhatsAppMessage={deleteWhatsAppMessage} waReadAt={waReadAt} onMarkRead={markWaRead} prospMensagens={prospMensagens} autoOpenTarget={autoOpenTarget?.moduleId==="inbox"?autoOpenTarget:null} onAutoOpenConsumed={()=>setAutoOpenTarget(null)} onRegistrarVenda={openManualSaleModal} onUpdateClient={updateClient} onUpdateProsp={persistProspecao} onTransferProsp={transferProspectOwnership} onAddReminder={addReminder} onConversationActive={handleConversationActive} unreadPushLookup={unreadPushLookup} onOpenLead={target=>{setAutoOpenTarget(target);setTab("leads");}} />}
        {tab==="historico"    && isStaff && <HistoricoView months={historico} clients={clients} leads={auroraLeads} prospeccao={prospeccao} selectedMonth={selectedMonth} onSelectMonth={setSelectedMonth} currentUser={currentUser} />}
         {tab==="followup"     && isStaff && <CommercialFollowUpView currentUser={currentUser} onOpenConversation={({ phone, storeId }) => { if (isNewUi) { nuAbrirConversa(phone, storeId || currentUser.storeId); return; } setAutoOpenTarget(conversationTarget("inbox", storeId || currentUser.storeId, phone)); setTab("inbox"); }} />}
        {tab==="reports"      && <ReportsView currentUser={currentUser} stores={allStores} users={operationalUserList} />}
        {tab==="admin"        && isStaff && <AdminView clients={clients} leads={auroraLeads} prospeccao={prospeccao} users={operationalUserList} onViewAs={u=>{ if (setCurrentUserGuarded(u)) setTab("dashboard"); }} onCloseMonth={handleCloseMonth} realSales={realSales} selectedMonth={selectedMonth} onSelectMonth={setSelectedMonth} loggedInUser={loggedInUser} onUpdateClient={updateClient} onDeleteClient={deleteClient} onAddReminder={addReminder} onSendZapi={sendZapiMessage} onSendZapiMedia={sendZapiMedia} whatsappMsgs={whatsappMsgs} onReturnToAurora={returnClientToAurora} onRegistrarVenda={openManualSaleModal} onOpenLead={lead=>{setAutoOpenTarget(conversationTarget("leads", lead.storeId, lead.telefone||lead.phone||""));setTab("leads");}} onOpenProsp={prospect=>{setAutoOpenTarget(conversationTarget("prospeccao", prospect.storeId, prospect.phone||prospect.telefone||""));setTab("prospeccao");}} onConversationActive={handleConversationActive} />}
        {tab==="ia"           && isStaff && <AiChatView currentUser={currentUser} />}
      </div>
      </LiftPendingContext.Provider>
      </LiftCrmClientContext.Provider>
      </MonthlyGoalsProvider>
      </ScopedDataLoadProvider>
      {liftClientRegistration && <AddClientModal
        key={`${liftClientRegistration.storeId}:${liftClientRegistration.pedido}`}
        initialValues={liftClientRegistration.draft} liftOrderMode
        consultantId={liftClientRegistration.draft.consultantId}
        storeId={liftClientRegistration.storeId}
        currentUser={currentUser}
        storeConsultants={operationalUserList}
        onClose={cancelLiftClientRegistration} onAdd={saveLiftClientRegistration}
      />}

      {/* ── Tour de Apresentação Guiada ─────────────────────────────────── */}
      {isDemoMode && guidedOpen && (
        <div style={{ position:"fixed", right:16, top:"50%", transform:"translateY(-50%)", zIndex:500, background:"#fff", borderRadius:16, boxShadow:"0 8px 48px rgba(0,0,0,0.20)", width:248, overflow:"hidden", userSelect:"none" }}>
          {/* Cabeçalho */}
          <div style={{ background:"linear-gradient(135deg,#1E3A8A,#2563EB)", padding:"14px 16px 12px" }}>
            <div style={{ color:"#fff", fontSize:13, fontWeight:800, letterSpacing:0.3 }}>🗺 Tour de Apresentação</div>
            <div style={{ color:"rgba(255,255,255,0.75)", fontSize:10, marginTop:3 }}>
              Passo {guidedStep + 1} de {GUIDED_STEPS.length} — clique em qualquer etapa para navegar
            </div>
          </div>
          {/* Passos */}
          <div style={{ paddingTop:6, paddingBottom:6 }}>
            {GUIDED_STEPS.map((s, i) => {
              const active = i === guidedStep;
              const past   = i < guidedStep;
              return (
                <div key={s.id} onClick={()=>{ setGuidedStep(i); setTab(s.tab); }}
                  style={{ padding:"10px 16px", cursor:"pointer", background: active ? "#EFF6FF" : "transparent", borderLeft: active ? "3px solid #2563EB" : "3px solid transparent", display:"flex", gap:10, alignItems:"flex-start", transition:"background 0.12s" }}>
                  <span style={{ fontSize:15, lineHeight:1.2, minWidth:18, textAlign:"center", opacity: past && !active ? 0.45 : 1 }}>
                    {past && !active ? "✓" : s.icon}
                  </span>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:12, fontWeight: active ? 700 : 600, color: active ? "#1D4ED8" : past ? "#94A3B8" : "#374151", lineHeight:1.3 }}>{s.label}</div>
                    {active && <div style={{ fontSize:10, color:"#64748B", marginTop:3, lineHeight:1.5 }}>{s.desc}</div>}
                  </div>
                </div>
              );
            })}
          </div>
          {/* Navegação */}
          <div style={{ padding:"10px 12px 14px", borderTop:"1px solid #E2E8F0", display:"flex", gap:8 }}>
            <button
              disabled={guidedStep === 0}
              onClick={()=>{ const ns = guidedStep - 1; setGuidedStep(ns); setTab(GUIDED_STEPS[ns].tab); }}
              style={{ flex:1, padding:"7px 0", background: guidedStep === 0 ? "#F1F5F9" : "#F8FAFC", border:"1px solid #E2E8F0", borderRadius:8, fontSize:12, cursor: guidedStep === 0 ? "not-allowed" : "pointer", color: guidedStep === 0 ? "#CBD5E1" : "#374151", fontWeight:600 }}>
              ← Anterior
            </button>
            <button
              disabled={guidedStep === GUIDED_STEPS.length - 1}
              onClick={()=>{ const ns = guidedStep + 1; setGuidedStep(ns); setTab(GUIDED_STEPS[ns].tab); }}
              style={{ flex:1, padding:"7px 0", background: guidedStep === GUIDED_STEPS.length - 1 ? "#F1F5F9" : "#2563EB", border:"none", borderRadius:8, fontSize:12, cursor: guidedStep === GUIDED_STEPS.length - 1 ? "not-allowed" : "pointer", color: guidedStep === GUIDED_STEPS.length - 1 ? "#CBD5E1" : "#fff", fontWeight:700 }}>
              Próximo →
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
